/*! For license information please see dx-diagram.min.js.LICENSE.txt */
!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define([], e) : "object" == typeof exports ? exports.DevExpress = e() : (t.DevExpress = t.DevExpress || {}, t.DevExpress.diagram = e());
}(this, () => (() => {
  "use strict";

  var t = {
      4: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ImagePrimitive = void 0;
        var r = n(8509),
          s = function (t) {
            function e(e, n, o, i, r, s, a, c) {
              void 0 === s && (s = "none");
              var u = t.call(this, a, c) || this;
              return u.x = e, u.y = n, u.width = o, u.height = i, u.url = r, u.preserveAspectRatio = s, u;
            }
            return i(e, t), e.prototype.createMainElement = function () {
              return document.createElementNS(r.svgNS, "image");
            }, e.prototype.applyElementProperties = function (e, n) {
              this.setUnitAttribute(e, "x", this.x), this.setUnitAttribute(e, "y", this.y), this.setUnitAttribute(e, "width", this.width), this.setUnitAttribute(e, "height", this.height), this.setPositionCorrectionAttribute(e), e.setAttribute("href", this.url), e.setAttribute("preserveAspectRatio", this.preserveAspectRatio), t.prototype.applyElementProperties.call(this, e, n);
            }, e;
          }(n(8309).SvgPrimitive);
        e.ImagePrimitive = s;
      },
      18: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MouseHandlerToolboxDraggingState = e.MouseHandlerBeforeToolboxDraggingState = void 0;
        var r = n(5428),
          s = n(5327),
          a = n(8214),
          c = n(6512),
          u = n(2815),
          p = n(1785),
          h = n(1922),
          l = n(9589),
          d = n(5225),
          f = function (t) {
            function e(e, n, o, i, r, s) {
              var a = t.call(this, e) || this;
              return a.history = n, a.model = o, a.selection = i, a.visualizerManager = r, a.shapeDescriptionManager = s, a.isModelEmpty = 0 === o.items.length, a;
            }
            return i(e, t), e.prototype.cancelChanges = function () {
              this.tryRemoveTimer();
            }, e.prototype.onDragStart = function (t) {
              this.dragging = t;
            }, e.prototype.onDragEnd = function (t) {
              this.cancelChanges(), this.handler.switchToDefaultState();
            }, e.prototype.onMouseMove = function (t) {
              var e = this;
              t.source.type > r.MouseEventElementType.Background ? (this.tryRemoveTimer(), this.switchToDraggingState(t, !1)) : t.source.type !== r.MouseEventElementType.Background || this.isModelEmpty ? void 0 !== this.nonPageAreaTimer && this.tryRemoveTimer() : (this.savedEvt = t, void 0 === this.nonPageAreaTimer && (this.nonPageAreaTimer = setTimeout(function () {
                return e.switchToDraggingState(e.savedEvt, !0);
              }, 500)));
            }, e.prototype.switchToDraggingState = function (t, e) {
              this.handler.switchState(new y(this.handler, this.history, this.model, this.selection, this.visualizerManager, this.shapeDescriptionManager, e)), this.handler.state.onDragStart(this.dragging), this.handler.state.onMouseMove(t);
            }, e.prototype.tryRemoveTimer = function () {
              void 0 !== this.nonPageAreaTimer && (clearTimeout(this.nonPageAreaTimer), delete this.nonPageAreaTimer);
            }, e.prototype.finish = function () {
              this.tryRemoveTimer();
            }, e;
          }(l.MouseHandlerCancellableState);
        e.MouseHandlerBeforeToolboxDraggingState = f;
        var y = function (t) {
          function e(e, n, o, i, r, s, a) {
            var c = t.call(this, e, n) || this;
            return c.model = o, c.selection = i, c.visualizerManager = r, c.shapeDescriptionManager = s, a || (c.updatePageSizeTimer = setTimeout(function () {
              c.processAndRemoveUpdatePageSizeTimer();
            }, 300)), c;
          }
          return i(e, t), e.prototype.cancelChanges = function () {
            this.tryRemoveUpdatePageSizeTimer(), t.prototype.cancelChanges.call(this);
          }, e.prototype.tryRemoveUpdatePageSizeTimer = function () {
            void 0 !== this.updatePageSizeTimer && (clearTimeout(this.updatePageSizeTimer), delete this.updatePageSizeTimer);
          }, e.prototype.processAndRemoveUpdatePageSizeTimer = function () {
            void 0 !== this.updatePageSizeTimer && (this.handler.tryUpdateModelSize(), delete this.updatePageSizeTimer);
          }, e.prototype.onMouseMove = function (e) {
            t.prototype.onMouseMove.call(this, e);
            var n = this.model.findShape(this.shapeKey);
            if (n) {
              this.visualizerManager.setExtensionLines([n]);
              var o = h.ModelUtils.findContainerByEventKey(this.model, this.selection, e.source.key);
              o && this.allowInsertToContainer(e, n, o) ? this.visualizerManager.setContainerTarget(o, e.source.type) : this.visualizerManager.resetContainerTarget();
            }
          }, e.prototype.getDraggingElementKeys = function () {
            return void 0 === this.shapeKey ? [] : [this.shapeKey];
          }, e.prototype.onApplyChanges = function (t) {
            var e = this;
            if (t.source.type === r.MouseEventElementType.Undefined) {
              if (this.dragging.onCaptured(!1), void 0 !== this.shapeKey && !this.deleteHistoryItem) {
                var n = this.model.findShape(this.shapeKey);
                h.ModelUtils.detachConnectors(this.history, n), h.ModelUtils.removeFromContainer(this.history, this.model, n), this.deleteHistoryItem = new p.DeleteShapeHistoryItem(this.shapeKey, !0), this.history.addAndRedo(this.deleteHistoryItem);
              }
            } else {
              if (this.dragging.onCaptured(!0), void 0 === this.shapeKey) {
                this.startPoint = t.modelPoint, this.shapeKey = this.insertToolboxItem(t);
                var o = this.model.findShape(this.shapeKey);
                o && this.handler.addInteractingItem(o, d.DiagramModelOperation.AddShape);
              }
              this.deleteHistoryItem && (this.history.undoTransactionTo(this.deleteHistoryItem), delete this.deleteHistoryItem);
              var i = this.getPosition(t, this.startShapePosition);
              n = this.model.findShape(this.shapeKey);
              h.ModelUtils.setShapePosition(this.history, this.model, n, i), h.ModelUtils.updateMovingShapeConnections(this.history, n, this.connectorsWithoutBeginItemInfo, this.connectorsWithoutEndItemInfo, function () {
                e.visualizerManager.resetConnectionTarget(), e.visualizerManager.resetConnectionPoints();
              }, function (t, n) {
                e.visualizerManager.setConnectionTarget(t, r.MouseEventElementType.Shape), e.visualizerManager.setConnectionPoints(t, r.MouseEventElementType.Shape, n, !0);
              }, function (t) {
                return e.handler.addInteractingItem(t);
              }), h.ModelUtils.updateShapeAttachedConnectors(this.history, this.model, n);
              var s = h.ModelUtils.findContainerByEventKey(this.model, this.selection, t.source.key);
              n && s && this.allowInsertToContainer(t, n, s) ? h.ModelUtils.insertToContainer(this.history, this.model, n, s) : h.ModelUtils.removeFromContainer(this.history, this.model, n), void 0 === this.updatePageSizeTimer && this.handler.tryUpdateModelSize(function (t, n) {
                e.connectorsWithoutBeginItemInfo.forEach(function (e) {
                  e.point.x += t, e.point.y += n;
                }), e.connectorsWithoutEndItemInfo.forEach(function (e) {
                  e.point.x += t, e.point.y += n;
                });
              });
            }
          }, e.prototype.onFinishWithChanges = function () {
            this.deleteHistoryItem || this.history.addAndRedo(new c.SetSelectionHistoryItem(this.selection, [this.shapeKey]));
          }, e.prototype.onDragStart = function (t) {
            this.dragging = t, this.connectorsWithoutBeginItemInfo = h.ModelUtils.getConnectorsWithoutBeginItemInfo(this.model), this.connectorsWithoutEndItemInfo = h.ModelUtils.getConnectorsWithoutEndItemInfo(this.model);
          }, e.prototype.onDragEnd = function (t) {
            void 0 !== this.shapeKey && t.source.type === r.MouseEventElementType.Undefined && this.cancelChanges(), this.handler.switchToDefaultState();
          }, e.prototype.finish = function () {
            this.visualizerManager.resetExtensionLines(), this.visualizerManager.resetContainerTarget(), this.visualizerManager.resetConnectionTarget(), this.visualizerManager.resetConnectionPoints(), this.processAndRemoveUpdatePageSizeTimer(), this.dragging.onFinishDragging(), t.prototype.finish.call(this);
          }, e.prototype.insertToolboxItem = function (t) {
            var e = this.shapeDescriptionManager.get(this.dragging.data);
            this.startShapePosition = this.getSnappedPoint(t, new s.Point(t.modelPoint.x - e.defaultSize.width / 2, t.modelPoint.y - e.defaultSize.height / 2));
            var n = new a.AddShapeHistoryItem(e, this.startShapePosition);
            return this.history.addAndRedo(n), h.ModelUtils.updateNewShapeProperties(this.history, this.selection, n.shapeKey), n.shapeKey;
          }, e.prototype.allowInsertToContainer = function (t, e, n) {
            return !this.handler.canMultipleSelection(t) && n && n.expanded && h.ModelUtils.canInsertToContainer(this.model, e, n);
          }, e.prototype.getPosition = function (t, e) {
            return this.getSnappedPoint(t, new s.Point(e.x + t.modelPoint.x - this.startPoint.x, e.y + t.modelPoint.y - this.startPoint.y));
          }, e;
        }(u.MouseHandlerDraggingState);
        e.MouseHandlerToolboxDraggingState = y;
      },
      41: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.EventUtils = e.HtmlFocusUtils = e.ObjectUtils = e.GeometryUtils = e.Utils = e.EventDispatcher = e.Range = e.LineEquation = void 0, n(4092);
        var o = n(3844),
          i = n(5327),
          r = n(4412),
          s = n(124),
          a = n(4496),
          c = n(594),
          u = n(4166),
          p = n(476),
          h = n(5059),
          l = n(8424),
          d = n(8451),
          f = function () {
            function t(t, e, n) {
              this.aParam = t, this.bParam = e, this.cParam = n;
            }
            return t.fromPoints = function (e, n, o) {
              return void 0 === o && (o = 1e-5), v.areDuplicatedPoints(e, n, o) ? void 0 : new t(n.y - e.y, e.x - n.x, n.x * e.y - e.x * n.y);
            }, t.prototype.getPointIntersection = function (t, e) {
              void 0 === e && (e = 1e-5);
              var n = this.aParam,
                o = this.bParam,
                i = this.cParam,
                r = t.aParam,
                s = t.bParam,
                a = t.cParam,
                u = r * o - n * s;
              if (c.MathUtils.numberCloseTo(u, 0, e)) return null;
              if (0 === n) {
                var p = (s * i - a * o) / (o * r);
                return this.createPoint(p, -i / o);
              }
              var h = (a * n - i * r) / u;
              return this.createPoint((-o * h - i) / n, h);
            }, t.prototype.containsPoint = function (t, e) {
              return void 0 === e && (e = 1e-5), c.MathUtils.numberCloseTo(this.aParam * t.x + this.bParam * t.y + this.cParam, 0, e);
            }, t.prototype.createPoint = function (t, e, n) {
              return void 0 === n && (n = 1e-5), new i.Point(c.MathUtils.numberCloseTo(t, 0, n) ? 0 : t, c.MathUtils.numberCloseTo(e, 0, n) ? 0 : e);
            }, t;
          }();
        e.LineEquation = f;
        var y = function () {
          function t(t, e) {
            this.from = t, this.to = void 0 !== e ? e : t;
          }
          return Object.defineProperty(t.prototype, "length", {
            get: function () {
              return Math.abs(this.to - this.from);
            },
            enumerable: !1,
            configurable: !0
          }), t.prototype.extend = function (t) {
            this.from = Math.min(t.from, this.from), this.to = Math.max(t.to, this.to);
          }, t.prototype.includes = function (t) {
            return t >= this.from && t <= this.to;
          }, t.fromLength = function (e, n) {
            return new t(e, e + n);
          }, t;
        }();
        e.Range = y;
        var g = function () {
          function t() {
            this.listeners = [];
          }
          return t.prototype.add = function (t) {
            if (!t) throw new Error("Not Implemented");
            this.hasEventListener(t) || this.listeners.push(t);
          }, t.prototype.remove = function (t) {
            for (var e = 0, n = void 0; n = this.listeners[e]; e++) if (n === t) {
              this.listeners.splice(e, 1);
              break;
            }
          }, t.prototype.raise = function (t) {
            for (var e = [], n = 1; n < arguments.length; n++) e[n - 1] = arguments[n];
            for (var o = 0, i = void 0; i = this.listeners[o]; o++) {
              var r = i[t];
              r && r.apply(i, e);
            }
          }, t.prototype.raise1 = function (t) {
            for (var e = 0, n = void 0; n = this.listeners[e]; e++) t(n);
          }, t.prototype.hasEventListener = function (t) {
            for (var e = 0, n = this.listeners.length; e < n; e++) if (this.listeners[e] === t) return !0;
            return !1;
          }, t;
        }();
        e.EventDispatcher = g;
        var m = function () {
          function t() {}
          return t.flatten = function (t) {
            return [].concat.apply([], t);
          }, t;
        }();
        e.Utils = m;
        var v = function () {
          function t() {}
          return t.arePointsOfOrthogonalLine = function (t, e, n) {
            return n ? t.y === e.y : t.x === e.x;
          }, t.getCommonRectangle = function (t) {
            if (!t.length) return new r.Rectangle(0, 0, 0, 0);
            var e = Number.MAX_VALUE,
              n = -Number.MAX_VALUE,
              o = Number.MAX_VALUE,
              i = -Number.MAX_VALUE;
            return t.forEach(function (t) {
              e = Math.min(e, t.x), n = Math.max(n, t.right), o = Math.min(o, t.y), i = Math.max(i, t.bottom);
            }), new r.Rectangle(e, o, n - e, i - o);
          }, t.findFreeSpace = function (t, e, n, o) {
            var r = [o ? o.x : 0],
              a = [o ? o.y : 0];
            t.forEach(function (t) {
              r.push(t.x), r.push(t.right), a.push(t.y), a.push(t.bottom);
            }), r = r.sort(function (t, e) {
              return t - e;
            }).reduce(function (t, e, n) {
              return r[n - 1] !== e && t.push(e) && t || t;
            }, []);
            for (var c = (a = a.sort(function (t, e) {
                return t - e;
              }).reduce(function (t, e, n) {
                return a[n - 1] !== e && t.push(e) && t || t;
              }, [])).map(function (t) {
                return r.map(function (t, e) {
                  return r[e + 1] - t;
                });
              }), u = function (t, e) {
                for (var n = s.SearchUtils.binaryIndexOf(r, function (t) {
                    return t - e.x;
                  }), o = s.SearchUtils.binaryIndexOf(r, function (t) {
                    return t - e.right;
                  }), i = s.SearchUtils.binaryIndexOf(a, function (t) {
                    return t - e.y;
                  }), u = s.SearchUtils.binaryIndexOf(a, function (t) {
                    return t - e.bottom;
                  }), p = i; p < u; p++) for (var h = n; h < o; h++) c[p][h] *= -1;
              }, p = 0, h = void 0; h = t[p]; p++) u(0, h);
            for (var l = 0; l < a.length; l++) for (var d = 0; d < r.length - 1; d++) {
              var f = this.checkRect(c, a, r, l, d, e, n);
              if (f > 0) d = f;else if (0 === f) return new i.Point(r[d], a[l]);
            }
            return null;
          }, t.checkRect = function (t, e, n, o, i, r, s) {
            for (var a = 0, c = 0, u = n.length - 2, p = o; p < e.length; p++) {
              a = e[p + 1] - e[o];
              for (var h = i; h <= u; h++) {
                if (t[p][h] < 0) return 0 === h ? -1 : h;
                if (c = n[h + 1] - n[i], r.width <= c || !s && h === n.length - 2 && r.width / 2 <= c) {
                  if (r.height <= a || !s && p === e.length - 2 && r.height / 2 <= a) return 0;
                  u = h;
                }
              }
            }
          }, t.getArrowPoints = function (t, e, n, o) {
            if (t.x === e.x && t.y === e.y) return {
              point1: t.clone(),
              point2: t.clone(),
              point3: t.clone()
            };
            var r = e.x - t.x,
              s = e.y - t.y,
              a = Math.sqrt(Math.pow(r, 2) + Math.pow(s, 2)),
              c = r / a,
              u = s / a,
              p = t.x + n * c + o * u,
              h = t.y + n * u - o * c,
              l = t.x + n * c - o * u,
              d = t.y + n * u + o * c,
              f = t.x + n * c,
              y = t.y + n * u;
            return {
              point1: new i.Point(p, h),
              point2: new i.Point(l, d),
              point3: new i.Point(f, y)
            };
          }, t.createSegments = function (t) {
            for (var e = [], n = 1; n < t.length; n++) e.push(new p.Segment(t[n - 1], t[n]));
            return e;
          }, t.createRectagle = function (t) {
            var e = t.map(function (t) {
                return t.x;
              }),
              n = t.map(function (t) {
                return t.y;
              }),
              o = e.reduce(function (t, e) {
                return Math.min(t, e);
              }, Number.MAX_VALUE),
              i = e.reduce(function (t, e) {
                return Math.max(t, e);
              }, -Number.MAX_VALUE),
              s = n.reduce(function (t, e) {
                return Math.min(t, e);
              }, Number.MAX_VALUE),
              a = n.reduce(function (t, e) {
                return Math.max(t, e);
              }, -Number.MAX_VALUE);
            return new r.Rectangle(o, s, i - o, a - s);
          }, t.createSegmentsFromRectangle = function (t) {
            var e = [],
              n = new i.Point(t.x, t.y),
              o = new i.Point(t.right, t.y),
              r = new i.Point(t.right, t.bottom),
              s = new i.Point(t.x, t.bottom);
            return e.push(new p.Segment(n, o)), e.push(new p.Segment(o, r)), e.push(new p.Segment(r, s)), e.push(new p.Segment(s, n)), e;
          }, t.areSegmentsCutRectangle = function (e, n) {
            if (!n) return !1;
            for (var o = t.createSegmentsFromRectangle(n), i = !1, r = !1, s = function (t) {
                if (i && r) return {
                  value: !0
                };
                var s = e[t];
                if (s.isIntersectedByRect(n)) {
                  var a = s.startPoint,
                    c = s.endPoint,
                    u = n.containsPoint(a),
                    p = n.containsPoint(c);
                  if (!u && !p) return {
                    value: !0
                  };
                  if (u && !p) {
                    var h = o.filter(function (t) {
                      return t.containsPoint(a);
                    });
                    if (h.length > 0) o.filter(function (t) {
                      return 1 === h.length ? !t.containsPoint(h[0].startPoint) && !t.containsPoint(h[0].endPoint) : t !== h[0] && t !== h[1];
                    }).some(function (t) {
                      return s.isIntersected(t);
                    }) && !i && (i = !0);
                    return r || (r = !0), "continue";
                  }
                  if (!u && p) {
                    i || (i = !0, r && (r = !1));
                    var l = o.filter(function (t) {
                      return t.containsPoint(c);
                    });
                    if (l.length > 0) o.filter(function (t) {
                      return 1 === l.length ? !t.containsPoint(l[0].startPoint) && !t.containsPoint(l[0].endPoint) : t !== l[0] && t !== l[1];
                    }).some(function (t) {
                      return s.isIntersected(t);
                    }) && !r && (r = !0);
                    return "continue";
                  }
                  var d = o.filter(function (t) {
                      return t.containsPoint(a);
                    }),
                    f = o.filter(function (t) {
                      return t.containsPoint(c);
                    });
                  if (2 === d.length && 2 === f.length) return {
                    value: !0
                  };
                  if (1 === d.length && 1 === f.length && d[0] !== f[0]) return {
                    value: !0
                  };
                  r || 1 !== f.length || d.length || (r = !0), i || 1 !== d.length || f.length || (i = !0, r && (r = !1));
                }
              }, a = 0; a < e.length; a++) {
              var c = s(a);
              if ("object" == typeof c) return c.value;
            }
            return i && r;
          }, t.areIntersectedSegments = function (t, e) {
            if (!e) return !1;
            for (var n, o = 0; n = t[o];) {
              for (var i = 0, r = void 0; r = e[i];) {
                if (r.isIntersected(n)) return !0;
                i++;
              }
              o++;
            }
            return !1;
          }, t.isLineIntersected = function (e, n, o, i, r) {
            var s = f.fromPoints(e, n),
              a = o.startPoint,
              c = o.endPoint;
            if (s.containsPoint(a) && s.containsPoint(c)) return !i && !r;
            var u = f.fromPoints(a, c).getPointIntersection(s);
            return !(!u || !o.containsPoint(u)) && (i ? !t.areDuplicatedPoints(a, u) : !r || !t.areDuplicatedPoints(c, u));
          }, t.removeUnnecessaryPoints = function (t, e, n, o) {
            void 0 === n && (n = function (t) {
              return void 0 !== t;
            }), void 0 === o && (o = 1e-5), this.removeUnnecessaryPointsCore(t, e, n, o), this.removeBackwardPoints(t, e, n, o), this.removeUnnecessaryPointsCore(t, e, n, o);
          }, t.removeUnnecessaryRightAnglePoints = function (t, e, n, o) {
            void 0 === n && (n = function (t) {
              return void 0 !== t;
            }), void 0 === o && (o = 1e-5), this.removeUnnecessaryPointsCore(t, e, n, o), this.removeBackwardPoints(t, e, n, o), this.removeNotRightAnglePoints(t, e, n, o), this.removeUnnecessaryPointsCore(t, e, n, o);
          }, t.removeUnnecessaryPointsCore = function (t, e, n, o) {
            void 0 === n && (n = function (t) {
              return void 0 !== t;
            }), void 0 === o && (o = 1e-5), this.removeDuplicatedPoints(t, e, n, o), this.removeNotCornersPoints(t, e, n, o);
          }, t.removeNotRightAnglePoints = function (e, n, o, i) {
            void 0 === o && (o = function (t) {
              return void 0 !== t;
            }), void 0 === i && (i = 1e-5);
            for (var r, s = 0; (r = e[s]) && e.length > 2;) {
              var a = this.getNextPoint(e, s, 1, o),
                c = this.getNextPoint(e, s, -1, o);
              c && a && !t.isRightAngleCorner(c, r, a, i) && n(r, s) || s++;
            }
          }, t.removeDuplicatedPoints = function (e, n, o, i) {
            void 0 === o && (o = function (t) {
              return void 0 !== t;
            }), void 0 === i && (i = 1e-5);
            for (var r, s = 0; (r = e[s]) && e.length > 2;) {
              var a = this.getNextPoint(e, s, 1, o);
              if (a && t.areDuplicatedPoints(r, a, i)) {
                var c = s === e.length - 2 ? s : s + 1;
                if (n(e[c], c)) continue;
              }
              s++;
            }
          }, t.removeNotCornersPoints = function (e, n, o, i) {
            void 0 === o && (o = function (t) {
              return void 0 !== t;
            }), void 0 === i && (i = 1e-5);
            for (var r, s = 0; (r = e[s]) && e.length > 2;) {
              var a = this.getNextPoint(e, s, 1, o),
                c = this.getNextPoint(e, s, -1, o);
              c && a && !t.isCorner(c, r, a, i) && n(r, s) || s++;
            }
          }, t.removeBackwardPoints = function (e, n, o, i) {
            void 0 === o && (o = function (t) {
              return void 0 !== t;
            }), void 0 === i && (i = 1e-5);
            for (var r, s = 0; (r = e[s]) && e.length > 2;) {
              var a = this.getNextPoint(e, s, 1, o),
                c = this.getNextPoint(e, s, -1, o);
              c && a && t.isBackwardPoint(c, r, a, i) && n(r, s) || s++;
            }
          }, t.isRightAngleCorner = function (e, n, o, i) {
            return void 0 === i && (i = 1e-5), c.MathUtils.numberCloseTo(t.createAngle(e, n, o), Math.PI / 2, i) || c.MathUtils.numberCloseTo(t.createAngle(e, n, o), Math.PI, i) || c.MathUtils.numberCloseTo(t.createAngle(e, n, o), 3 * Math.PI / 2, i);
          }, t.isCorner = function (e, n, o, i) {
            return void 0 === i && (i = 1e-5), !c.MathUtils.numberCloseTo(t.createAngle(e, n, o), 0, i);
          }, t.areDuplicatedPoints = function (t, e, n) {
            return void 0 === n && (n = 1e-5), c.MathUtils.numberCloseTo(t.x, e.x, n) && c.MathUtils.numberCloseTo(t.y, e.y, n);
          }, t.isBackwardPoint = function (e, n, o, i) {
            return void 0 === i && (i = 1e-5), c.MathUtils.numberCloseTo(t.createAngle(e, n, o), Math.PI, i);
          }, t.createAngle = function (t, e, n) {
            var o = u.Vector.fromPoints(e, n),
              i = u.Vector.fromPoints(t, e),
              r = o.x,
              s = o.y,
              a = i.x,
              c = i.y,
              p = Math.atan2(r * c - a * s, r * a + s * c);
            return p < 0 ? 2 * Math.PI + p : p;
          }, t.getNextPoint = function (t, e, n, o) {
            for (var i, r = e + n; i = t[r];) {
              if (o(i)) return i;
              r += n;
            }
          }, t.addSelectedLinesTo = function (t, e, n, o, i, r, s, a, u, p, h, l, d, f) {
            void 0 === f && (f = 1e-5);
            var y = e.y - t.y,
              g = n.y - e.y,
              m = t.x - e.x,
              v = e.x - n.x,
              P = y * v - g * m;
            if (!c.MathUtils.numberCloseTo(P, 0, f)) {
              var C = y * (t.x + o) + m * (t.y + i),
                S = g * (e.x + a) + v * (e.y + u);
              l((v * C - m * S) / P, (y * S - g * C) / P);
              var x = y * (t.x + r) + m * (t.y + s),
                b = g * (e.x + p) + v * (e.y + h);
              d((v * x - m * b) / P, (y * b - g * x) / P);
            }
          }, t.getSelectionOffsetPoint = function (t, e, n) {
            return new i.Point((t.y - e.y) / n, (e.x - t.x) / n);
          }, t.getSelectionTextStartEndPoints = function (t, e, n, o, r, s) {
            var a = (e.x - t.x) / n,
              c = (e.y - t.y) / n,
              u = r.width * a + r.height * c;
            switch (s) {
              case h.TextAlignment.Left:
                return [o, new i.Point(o.x + a * u, o.y + c * u)];
              case h.TextAlignment.Right:
                return [new i.Point(o.x - a * u, o.y - c * u), o];
              default:
                return [new i.Point(o.x - .5 * a * u, o.y - .5 * c * u), new i.Point(o.x + .5 * a * u, o.y + .5 * c * u)];
            }
          }, t.getPathLength = function (t) {
            var e,
              n = 0;
            return t.forEach(function (t) {
              void 0 !== e && (n += a.Metrics.euclideanDistance(t, e)), e = t;
            }), n;
          }, t.getPathPointByPosition = function (t, e) {
            if (!t.length) throw new Error("Invalid points");
            if (0 > e || e > 1) throw new Error("Invalid relative position");
            var n = this.getPathLength(t);
            if (t.length <= 2 && 0 === n || 0 === e) return [t[0], 0];
            for (var o = n * e, r = 0, s = 1; s < t.length; s++) {
              var c = a.Metrics.euclideanDistance(t[s], t[s - 1]);
              if (r + c >= o) {
                var u = o - r,
                  p = (t[s].x - t[s - 1].x) / c,
                  h = (t[s].y - t[s - 1].y) / c;
                return [new i.Point(t[s - 1].x + p * u, t[s - 1].y + h * u), s];
              }
              r += c;
            }
            return [t[t.length - 1], t.length - 1];
          }, t.getLineAngle = function (t, e) {
            return Math.atan2(e.y - t.y, e.x - t.x);
          }, t.getTriangleBeginAngle = function (t, e, n) {
            var o = this.getLineAngle(t, e),
              i = this.getLineAngle(t, n);
            return Math.abs(i - o);
          }, t.getTriangleEndAngle = function (t, e, n) {
            var o = this.getLineAngle(t, e),
              i = this.getLineAngle(n, e);
            return Math.abs(o - i);
          }, t.getPathPointByPoint = function (t, e) {
            if (!t.length) throw new Error("Invalid points");
            if (1 === t.length) return t[0];
            for (var n, o = Number.MAX_VALUE, i = 1; i < t.length; i++) {
              var r = t[i - 1],
                s = t[i];
              if (e.equals(r)) {
                n = r.clone();
                break;
              }
              if (e.equals(s)) {
                n = s.clone();
                break;
              }
              var c = this.getTriangleBeginAngle(r, s, e),
                u = this.getTriangleEndAngle(r, s, e),
                p = a.Metrics.euclideanDistance(e, r),
                h = a.Metrics.euclideanDistance(e, s),
                l = p * Math.sin(c),
                d = void 0;
              if ((d = Math.PI / 2 <= c && c <= 3 * Math.PI / 2 ? p : Math.PI / 2 <= u && u <= 3 * Math.PI / 2 ? h : Math.abs(l)) < o) if (o = d, Math.PI / 2 <= c && c <= 3 * Math.PI / 2) n = r.clone();else if (Math.PI / 2 <= u && u <= 3 * Math.PI / 2) n = s.clone();else {
                var f = Math.fround || Math.round,
                  y = this.getLineAngle(r, s),
                  g = f(Math.abs(l * Math.sin(y))),
                  m = f(Math.abs(l * Math.cos(y))),
                  v = e.y - r.y < f((e.x - r.x) * Math.tan(y));
                0 <= y && y <= Math.PI / 2 ? (g *= v ? -1 : 1, m *= v ? 1 : -1) : Math.PI / 2 <= y && y <= Math.PI || 0 >= y && y >= -Math.PI / 2 ? (g *= v ? 1 : -1, m *= v ? 1 : -1) : -Math.PI / 2 >= y && y >= -Math.PI && (g *= v ? -1 : 1, m *= v ? 1 : -1), n = e.clone().offset(g, m);
              }
            }
            return n;
          }, t.getPathPositionByPoint = function (t, e, n) {
            void 0 === n && (n = 100), e = this.getPathPointByPoint(t, e);
            for (var o = this.getPathLength(t), i = 0, r = 1; r < t.length; r++) {
              var s = t[r - 1],
                c = t[r],
                u = a.Metrics.euclideanDistance(c, s),
                p = Math.atan((c.y - s.y) / (c.x - s.x)),
                h = Math.fround || Math.round;
              if (e.x === c.x && e.x === s.x || e.y === c.y && e.y === s.y || h(e.y - s.y) === h((e.x - s.x) * Math.tan(p))) return 0 !== Math.sin(p) ? i += Math.abs((e.y - s.y) / Math.sin(p)) : i += Math.abs(e.x - s.x), Math.round(i * n / o) / n;
              i += u;
            }
            return 1;
          }, t.arePointsEqual = function (t, e) {
            var n = t.length;
            if (n !== e.length) return !1;
            for (var o = 0; o < n; o++) if (!t[o].equals(e[o])) return !1;
            return !0;
          }, t.getMaxRectangleEnscribedInEllipse = function (t) {
            var e = t.width * Math.sqrt(2) / 2,
              n = t.height * Math.sqrt(2) / 2;
            return new o.Size(e, n);
          }, t.getEllipseByEnscribedRectangle = function (t) {
            return new o.Size(2 * t.width / Math.sqrt(2), 2 * t.height / Math.sqrt(2));
          }, t;
        }();
        e.GeometryUtils = v;
        var P = function () {
          function t() {}
          return t.cloneObject = function (t) {
            return t && Object.assign({}, t);
          }, t.compareObjects = function (t, e) {
            return t === e || "object" == typeof t && "object" == typeof e && this.isDeepEqual(t, e);
          }, t.isDeepEqual = function (t, e) {
            var n = t ? Object.getOwnPropertyNames(t) : [],
              o = e ? Object.getOwnPropertyNames(e) : [];
            if (n.length !== o.length) return !1;
            for (var i = 0; i < n.length; i++) {
              var r = n[i];
              switch (typeof t[r]) {
                case "object":
                  if (!this.isDeepEqual(t[r], e[r])) return !1;
                  break;
                case "number":
                  if (!(isNaN(t[r]) && isNaN(e[r]) || t[r] === e[r])) return !1;
                  break;
                default:
                  if (t[r] !== e[r]) return !1;
              }
            }
            return !0;
          }, t;
        }();
        e.ObjectUtils = P;
        var C = function () {
          function t() {}
          return t.focusWithPreventScroll = function (t) {
            try {
              var e = l.Browser.Safari,
                n = e && this.getHtmlScrollPosition();
              if (e) {
                var o = t.parentElement && t.parentElement.getBoundingClientRect();
                if (o) {
                  var i = o.left < 0 ? 1 - o.left : 0,
                    r = o.top < 0 ? 1 - o.top : 0,
                    s = window.frameElement && window.frameElement.getBoundingClientRect();
                  s && (s.top < 0 && -s.top > o.top && (r = -s.top - o.top + 1), s.left < 0 && -s.left > o.left && (i = -s.left - o.left + 1)), t.style.setProperty("left", i + "px", "important"), t.style.setProperty("top", r + "px", "important");
                }
              }
              if (t.focus({
                preventScroll: !0
              }), e) {
                var a = this.getHtmlScrollPosition();
                P.compareObjects(n, a) || this.setHtmlScrollPosition(n), t.style.setProperty("left", "-1000px", "important"), t.style.setProperty("top", "-1000px", "important");
              }
            } catch (t) {}
          }, t.getHtmlScrollPosition = function () {
            return {
              pos: this.getDocumentScrollPosition(window, document),
              iframePos: window.top !== window && this.getDocumentScrollPosition(window.top, window.top.document)
            };
          }, t.getDocumentScrollPosition = function (t, e) {
            return {
              left: t.pageXOffset || e.documentElement.scrollLeft || e.body.scrollLeft,
              top: t.pageYOffset || e.documentElement.scrollTop || e.body.scrollTop
            };
          }, t.setHtmlScrollPosition = function (t) {
            this.setDocumentScrollPosition(document, t.pos), window.top !== window && t.iframePos && this.setDocumentScrollPosition(window.top.document, t.iframePos);
          }, t.setDocumentScrollPosition = function (t, e) {
            t.documentElement.scrollTop = e.top, t.documentElement.scrollLeft = e.left, t.body.scrollTop = e.top, t.body.scrollLeft = e.left;
          }, t;
        }();
        e.HtmlFocusUtils = C;
        var S = function () {
          function t() {}
          return t.isLeftButtonPressed = function (t) {
            return d.EvtUtils.isLeftButtonPressed(t);
          }, t.isPointerEvents = function () {
            return window.PointerEvent;
          }, t.isMousePointer = function (t) {
            return this.isPointerEvents() && (t.pointerType && "mouse" === t.pointerType || l.Browser.Firefox && "click" === t.type);
          }, t.isTouchMode = function () {
            return l.Browser.TouchUI || window.navigator && window.navigator.maxTouchPoints > 0;
          }, t.isTouchEvent = function (e) {
            return l.Browser.TouchUI || !t.isMousePointer(e);
          }, t;
        }();
        e.EventUtils = S;
      },
      78: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MouseHandlerMoveShapeState = void 0;
        var r = function (t) {
          function e(e, n, o, i, r) {
            var s = t.call(this, e, n, o, i, r) || this;
            return s.model = o, s.selection = i, s.visualizerManager = r, s;
          }
          return i(e, t), Object.defineProperty(e.prototype, "areValidDraggingShapes", {
            get: function () {
              return this.shouldClone || this.dragHelper.draggingShapes.length > 0;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "areValidDraggingConnectors", {
            get: function () {
              return !0;
            },
            enumerable: !1,
            configurable: !0
          }), e;
        }(n(9993).MouseHandlerDragDiagramItemStateBase);
        e.MouseHandlerMoveShapeState = r;
      },
      94: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.RectanglePrimitive = void 0;
        var r = n(8509),
          s = function (t) {
            function e(e, n, o, i, r, s, a, c) {
              var u = t.call(this, r, s, a, c) || this;
              return u.x = e, u.y = n, u.width = o, u.height = i, u;
            }
            return i(e, t), e.prototype.createMainElement = function () {
              return document.createElementNS(r.svgNS, "rect");
            }, e.prototype.applyElementProperties = function (e, n) {
              this.setUnitAttribute(e, "x", this.x), this.setUnitAttribute(e, "y", this.y), this.setUnitAttribute(e, "width", this.width), this.setUnitAttribute(e, "height", this.height), this.setPositionCorrectionAttribute(e), t.prototype.applyElementProperties.call(this, e, n);
            }, e;
          }(n(8309).SvgPrimitive);
        e.RectanglePrimitive = s;
      },
      113: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.TextInputHandler = void 0;
        var o = n(6476),
          i = n(5428),
          r = n(6537),
          s = n(8408),
          a = n(6320),
          c = n(1914),
          u = function () {
            function t(t) {
              this.control = t;
            }
            return t.prototype.startTextInput = function (t, e) {
              if (!t.isLocked && t.enableText && t.allowEditText && !this.control.settings.readOnly && this.canFinishTextEditing()) {
                this.control.beginUpdate(), this.textInputItem = t;
                var n = !0;
                if (this.textInputItem instanceof s.Shape) {
                  var o = this.textInputItem.textEditRectangle;
                  (n = this.control.permissionsProvider.canChangeShapeText(this.textInputItem)) && this.control.eventManager.raiseTextInputStart(this.textInputItem, this.textInputItem.text, o.createPosition(), o.createSize());
                } else this.textInputItem instanceof a.Connector && (this.textInputPosition = e, (n = this.control.permissionsProvider.canChangeConnectorText(this.textInputItem, this.textInputPosition)) && this.control.eventManager.raiseTextInputStart(this.textInputItem, this.textInputItem.getText(this.textInputPosition), this.textInputItem.getTextPoint(this.textInputPosition)));
                n || (delete this.textInputItem, this.control.endUpdate());
              }
            }, t.prototype.endTextInput = function (t) {
              var e = this.textInputItem;
              delete this.textInputItem, this.control.eventManager.raiseTextInputEnd(e, t), this.control.endUpdate(), this.control.barManager.updateItemsState();
            }, t.prototype.raiseTextInputPermissionsCheck = function (t) {
              this.control.eventManager.raiseTextInputPermissionsCheck(this.textInputItem, t);
            }, t.prototype.applyTextInput = function (t, e) {
              if (this.canFinishTextEditing(t)) {
                var n = this.textInputItem,
                  i = this.textInputPosition;
                this.endTextInput(e), n instanceof s.Shape ? n.text !== t && this.control.history.addAndRedo(new o.ChangeShapeTextHistoryItem(n, t)) : n instanceof a.Connector && n.getText(i) !== t && this.control.history.addAndRedo(new c.ChangeConnectorTextHistoryItem(n, i, t));
              }
            }, t.prototype.canFinishTextEditing = function (t) {
              var e = !0;
              if (this.isTextInputActive()) {
                var n = t || this.getTextInputElementValue();
                this.textInputItem instanceof s.Shape ? e = this.control.permissionsProvider.canApplyShapeTextChange(this.textInputItem, n) : this.textInputItem instanceof a.Connector && (e = this.control.permissionsProvider.canApplyConnectorTextChange(this.textInputItem, this.textInputPosition, n)), this.raiseTextInputPermissionsCheck(e);
              }
              return e;
            }, t.prototype.getTextInputElementValue = function () {
              return this.control.render ? this.control.render.input.getTextInputElementValue() : "";
            }, t.prototype.cancelTextInput = function () {
              this.raiseTextInputPermissionsCheck(!0), this.endTextInput(!0);
            }, t.prototype.isTextInputActive = function () {
              return void 0 !== this.textInputItem;
            }, t.prototype.processDblClick = function (t) {
              if (t.source.type === i.MouseEventElementType.Shape) {
                var e = this.control.model.findShape(t.source.key);
                this.startTextInput(e);
              } else if (t.source.type === i.MouseEventElementType.Connector) {
                var n = (o = this.control.model.findConnector(t.source.key)).getTextPositionByPoint(t.modelPoint);
                this.startTextInput(o, n);
              } else if (t.source.type === i.MouseEventElementType.ConnectorText) {
                var o = this.control.model.findConnector(t.source.key);
                n = parseFloat(t.source.value);
                this.startTextInput(o, n);
              }
            }, t.prototype.onDblClick = function (t) {
              var e = this;
              setTimeout(function () {
                e.processDblClick(t);
              }, 10);
            }, t.prototype.onKeyDown = function (t) {
              this.isTextInputActive() && (13 === t.keyCode && this.hasCtrlModifier(t.modifiers) && (t.preventDefault = !0, this.applyTextInput(t.inputText, !0)), 27 === t.keyCode && this.cancelTextInput());
            }, t.prototype.onBlur = function (t) {
              this.isTextInputActive() && this.applyTextInput(t.inputText);
            }, t.prototype.onFocus = function (t) {}, t.prototype.reset = function () {
              delete this.textInputItem;
            }, t.prototype.hasCtrlModifier = function (t) {
              return (t & r.ModifierKey.Ctrl) > 0;
            }, t;
          }();
        e.TextInputHandler = u;
      },
      124: (t, e) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SearchUtils = void 0;
        var n = function () {
          function t() {}
          return t.binaryIndexOf = function (t, e, n, o) {
            void 0 === n && (n = 0), void 0 === o && (o = -2);
            var i = 0 === n;
            for (-2 === o && (o = t.length - 1); n <= o;) {
              var r = n + (o - n >> 1),
                s = e(t[r]);
              if (s < 0) n = r + 1;else {
                if (!(s > 0)) return r;
                o = r - 1;
              }
            }
            return i ? ~n : -1;
          }, t.normedBinaryIndexOf = function (e, n, o, i) {
            void 0 === o && (o = 0), void 0 === i && (i = -2);
            var r = t.binaryIndexOf(e, n, o, i);
            return t.binaryIndexNormalizator(r);
          }, t.binaryIndexNormalizator = function (t) {
            return t < 0 ? ~t - 1 : t;
          }, t.normedInterpolationIndexOf = function (t, e, n, o, i) {
            void 0 === o && (o = 0), void 0 === i && (i = -2), -2 === i && (i = t.length - 1);
            var r = t[Math.min(o, i)];
            if (void 0 === r || n < e(r)) return -1;
            for (var s = e(t[o]), a = e(t[i]);;) {
              if (!(n > s && n < a)) return n === s ? o : i;
              var c = o + Math.floor((n - s) * (i - o) / (a - s)),
                u = e(t[c]);
              if (n > u) {
                if (n < (s = e(t[o = c + 1]))) return c;
              } else {
                if (!(n < u)) return c;
                a = e(t[i = c - 1]);
              }
            }
          }, t;
        }();
        e.SearchUtils = n;
      },
      128: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.TextPrimitive270degRenderHelper = e.TextPrimitive180degRenderHelper = e.TextPrimitive90degRenderHelper = e.TextPrimitiveRenderHelper = e.TextPrimitive = e.TextAngle = void 0;
        var r,
          s = n(9500),
          a = n(8509),
          c = n(8309),
          u = n(2136),
          p = n(1842);
        !function (t) {
          t[t.Angle0deg = 0] = "Angle0deg", t[t.Angle90deg = 90] = "Angle90deg", t[t.Angle180deg = 180] = "Angle180deg", t[t.Angle270deg = 270] = "Angle270deg";
        }(r = e.TextAngle || (e.TextAngle = {}));
        var h = function (t) {
          function e(e, n, o, i, r, s, a, c, u, h, l, d, f) {
            var y = t.call(this, c, "", h, f) || this;
            return y.x = e, y.y = n, y.text = o, y.owner = i, y.textWidth = r, y.textHeight = s, y.textSpacing = a, y.reverseTextAhchor = u, y.angle = d, y.filterId = l, y.textSegmens = (0, p.textToParagraphs)(y.text), y.renderHelper = y.createRenderHelper(), void 0 !== y.textWidth && void 0 !== y.textWidth && (y.x = y.renderHelper.getTextX(y.x), y.y = y.renderHelper.getTextY(y.y)), y;
          }
          return i(e, t), e.prototype.createMainElement = function () {
            return document.createElementNS(a.svgNS, "text");
          }, e.prototype.applyElementProperties = function (e, n) {
            this.setUnitAttribute(e, "x", this.x), this.setUnitAttribute(e, "y", this.y), this.filterId && e.setAttribute("filter", u.RenderUtils.getUrlPathById(this.filterId)), t.prototype.applyElementProperties.call(this, e, n), e.getAttribute("appliedText") !== this.text || e.getAttribute("appliedSize") !== (this.fitToSize && this.fitToSize.toString()) ? (this.createTSpanElements(e, n), e.setAttribute("appliedText", this.text), e.setAttribute("appliedSize", this.fitToSize && this.fitToSize.toString())) : this.prepareTSpanElements(e), this.renderHelper.prepareMainElement(e, this.x, this.y);
          }, e.prototype.createTSpanElements = function (t, e) {
            var n = this;
            u.RenderUtils.removeContent(t), this.textSegmens.forEach(function (o, i) {
              if (!o && n.textSegmens.length > 1) n.createTSpanElement(t).textContent = " ";else if (n.fitToSize) {
                var r = (0, p.textToWords)(o),
                  a = (0, p.wordsByLines)(s.UnitConverter.twipsToPixels(n.fitToSize), r, function () {
                    return e.measureWords(r, n.style, n.owner);
                  });
                if (a.forEach(function (e) {
                  n.createTSpanElement(t).textContent = e;
                }), !a.length) n.createTSpanElement(t).textContent = " ";
              } else {
                n.createTSpanElement(t).textContent = o;
              }
            });
            var o = t.firstChild;
            o && this.prepareFirstTSpanElement(o, t.childNodes.length);
          }, e.prototype.createTSpanElement = function (t) {
            var e = document.createElementNS(a.svgNS, "tspan");
            return t.appendChild(e), this.prepareTSpanElement(e), e;
          }, e.prototype.prepareTSpanElements = function (t) {
            for (var e = 0; e < t.childNodes.length; e++) {
              var n = t.childNodes[e];
              this.prepareTSpanElement(n);
            }
            var o = t.firstChild;
            o && this.prepareFirstTSpanElement(o, t.childNodes.length);
          }, e.prototype.prepareTSpanElement = function (t) {
            this.renderHelper.prepareTSpanElement(t, this.x, this.y);
          }, e.prototype.prepareFirstTSpanElement = function (t, e) {
            this.renderHelper.prepareFirstTSpanElement(t, e);
          }, e.prototype.applyElementStyleProperties = function (t) {
            this.applyElementStylePropertiesCore(t, this.reverseTextAhchor);
          }, Object.defineProperty(e.prototype, "fitToSize", {
            get: function () {
              return this.renderHelper.fitToSize;
            },
            enumerable: !1,
            configurable: !0
          }), e.prototype.createRenderHelper = function () {
            switch (this.angle) {
              case r.Angle90deg:
                return new d(this);
              case r.Angle180deg:
                return new f(this);
              case r.Angle270deg:
                return new y(this);
              default:
                return new l(this);
            }
          }, e.baselineCorrection = .35, e;
        }(c.SvgPrimitive);
        e.TextPrimitive = h;
        var l = function () {
          function t(t) {
            this.primitive = t;
          }
          return Object.defineProperty(t.prototype, "textWidth", {
            get: function () {
              return this.primitive.textWidth;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "textHeight", {
            get: function () {
              return this.primitive.textHeight;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "fitToSize", {
            get: function () {
              return this.textWidth;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "textAnchor", {
            get: function () {
              return this.primitive.style["text-anchor"];
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "textSpacing", {
            get: function () {
              return this.primitive.textSpacing;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "angle", {
            get: function () {},
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "needRotation", {
            get: function () {
              return !1;
            },
            enumerable: !1,
            configurable: !0
          }), t.prototype.prepareMainElement = function (t, e, n) {
            this.needRotation && t.setAttribute("transform", "rotate(" + this.angle + ", " + s.UnitConverter.twipsToPixels(e) + ", " + s.UnitConverter.twipsToPixels(n) + ")");
          }, t.prototype.prepareTSpanElement = function (t, e, n) {
            this.primitive.setUnitAttribute(t, "x", e), t.setAttribute("dy", p.LINE_HEIGHT + "em");
          }, t.prototype.prepareFirstTSpanElement = function (t, e) {
            var n = -(e - 1) / 2 + h.baselineCorrection;
            t.setAttribute("dy", n.toFixed(2) + "em");
          }, t.prototype.getTextX = function (t) {
            return this.textAnchor && "middle" !== this.textAnchor ? "end" === this.textAnchor ? t + this.textWidth - this.textSpacing : "start" === this.textAnchor ? t + this.textSpacing : t : t + this.textWidth / 2;
          }, t.prototype.getTextY = function (t) {
            return t + this.textHeight / 2;
          }, t.prototype.setUnitAttribute = function (t, e, n) {
            this.primitive.setUnitAttribute(t, e, n);
          }, t;
        }();
        e.TextPrimitiveRenderHelper = l;
        var d = function (t) {
          function e(e) {
            return t.call(this, e) || this;
          }
          return i(e, t), Object.defineProperty(e.prototype, "fitToSize", {
            get: function () {
              return this.textHeight;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "angle", {
            get: function () {
              return 90;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "needRotation", {
            get: function () {
              return !0;
            },
            enumerable: !1,
            configurable: !0
          }), e.prototype.getTextX = function (t) {
            return t + this.textWidth / 2;
          }, e.prototype.getTextY = function (t) {
            return this.textAnchor && "middle" !== this.textAnchor ? "end" === this.textAnchor ? t + this.textHeight - this.textSpacing : "start" === this.textAnchor ? t + this.textSpacing : t : t + this.textHeight / 2;
          }, e;
        }(l);
        e.TextPrimitive90degRenderHelper = d;
        var f = function (t) {
          function e(e) {
            return t.call(this, e) || this;
          }
          return i(e, t), Object.defineProperty(e.prototype, "angle", {
            get: function () {
              return 180;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "needRotation", {
            get: function () {
              return !0;
            },
            enumerable: !1,
            configurable: !0
          }), e.prototype.getTextX = function (t) {
            return this.textAnchor && "middle" !== this.textAnchor ? "start" === this.textAnchor ? t + this.textWidth - this.textSpacing : "end" === this.textAnchor ? t + this.textSpacing : t : t + this.textWidth / 2;
          }, e;
        }(l);
        e.TextPrimitive180degRenderHelper = f;
        var y = function (t) {
          function e(e) {
            return t.call(this, e) || this;
          }
          return i(e, t), Object.defineProperty(e.prototype, "angle", {
            get: function () {
              return 270;
            },
            enumerable: !1,
            configurable: !0
          }), e.prototype.getTextY = function (t) {
            return this.textAnchor && "middle" !== this.textAnchor ? "start" === this.textAnchor ? t + this.textHeight - this.textSpacing : "end" === this.textAnchor ? t + this.textSpacing : t : t + this.textHeight / 2;
          }, e;
        }(d);
        e.TextPrimitive270degRenderHelper = y;
      },
      131: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MoveShapeEventArgs = e.MoveShapeRequestedEntity = void 0;
        var r = n(5225),
          s = n(5102),
          a = function (t) {
            function e(e, n, o, i) {
              var r = t.call(this, e) || this;
              return r.shape = n, r.oldPosition = o, r.position = i, r;
            }
            return i(e, t), Object.defineProperty(e.prototype, "operation", {
              get: function () {
                return r.DiagramModelOperation.MoveShape;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.createEventArgs = function () {
              return new c(this.apiController.createNativeShape(this.shape), this.apiController.convertPoint(this.oldPosition), this.apiController.convertPoint(this.position));
            }, Object.defineProperty(e.prototype, "settingsKey", {
              get: function () {
                return "moveShape";
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "storageKey", {
              get: function () {
                return this.settingsKey + "_" + (this.shape && this.shape.key);
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.equals = function (t) {
              return t instanceof e && this.shape === t.shape && this.oldPosition.equals(t.oldPosition) && this.position.equals(t.position);
            }, e;
          }(s.RequestedEntity);
        e.MoveShapeRequestedEntity = a;
        var c = function (t) {
          function e(e, n, o) {
            var i = t.call(this) || this;
            return i.shape = e, i.oldPosition = n, i.position = o, i;
          }
          return i(e, t), e;
        }(s.PermissionRequestEventArgs);
        e.MoveShapeEventArgs = c;
      },
      132: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ExportPngCommand = void 0;
        var r = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(e, t), e.prototype.getExtension = function () {
            return "png";
          }, e.prototype.getExportFunc = function () {
            return this.exporter.exportPng;
          }, e;
        }(n(6634).ExportImageCommand);
        e.ExportPngCommand = r;
      },
      149: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SparseObjectsIterator = void 0;
        var o = n(5215),
          i = function (t) {
            function e(e, n) {
              var o = t.call(this, e) || this;
              return o.objects = n, o;
            }
            return o.__extends(e, t), e.prototype.initObject = function () {
              this.obj = this.objects[this.index];
            }, e;
          }(n(1454).SparseIntervalsIterator);
        e.SparseObjectsIterator = i;
      },
      156: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.PredefinedProcessShapeDescription = e.PredefinedProcessEdgeParameterName = void 0;
        var r = n(3190),
          s = n(3255),
          a = n(4636),
          c = n(9763),
          u = n(5327),
          p = n(6208);
        e.PredefinedProcessEdgeParameterName = "e";
        var h = function (t) {
          function n() {
            return t.call(this, void 0, !0) || this;
          }
          return i(n, t), Object.defineProperty(n.prototype, "key", {
            get: function () {
              return s.ShapeTypes.PredefinedProcess;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(n.prototype, "keepRatioOnAutoSize", {
            get: function () {
              return !1;
            },
            enumerable: !1,
            configurable: !0
          }), n.prototype.createShapePrimitives = function (n) {
            var o = n.rectangle,
              i = o.x,
              r = o.y,
              s = o.right,
              a = o.bottom,
              c = i + n.parameters.get(e.PredefinedProcessEdgeParameterName).value,
              u = s - n.parameters.get(e.PredefinedProcessEdgeParameterName).value;
            return t.prototype.createShapePrimitives.call(this, n).concat([new p.PathPrimitive([new p.PathPrimitiveMoveToCommand(c, r), new p.PathPrimitiveLineToCommand(c, a), new p.PathPrimitiveMoveToCommand(u, r), new p.PathPrimitiveLineToCommand(u, a)], n.style)]);
          }, n.prototype.createParameters = function (t) {
            t.addIfNotExists(new a.ShapeParameter(e.PredefinedProcessEdgeParameterName, .1 * this.defaultSize.width));
          }, n.prototype.normalizeParameters = function (t, o) {
            this.changeParameterValue(o, e.PredefinedProcessEdgeParameterName, function (e) {
              return Math.max(n.minEdge, Math.min(.3 * t.size.width, e.value));
            });
          }, n.prototype.modifyParameters = function (t, n, o, i) {
            this.changeParameterValue(n, e.PredefinedProcessEdgeParameterName, function (t) {
              return t.value + o;
            }), this.normalizeParameters(t, n);
          }, n.prototype.getParameterPoints = function (t) {
            return [new c.ShapeParameterPoint("c", new u.Point(t.normalizeX(t.position.x + t.parameters.get(e.PredefinedProcessEdgeParameterName).value), t.position.y))];
          }, n.prototype.getTextRectangle = function (t) {
            var n = t.rectangle,
              o = t.parameters.get(e.PredefinedProcessEdgeParameterName).value;
            return n.clone().resize(-2 * o, 0).clone().moveRectangle(o, 0);
          }, n.minEdge = 72, n;
        }(r.RectangleShapeDescription);
        e.PredefinedProcessShapeDescription = h;
      },
      166: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ArrowDownShapeDescription = void 0;
        var r = n(6208),
          s = n(9763),
          a = n(5327),
          c = n(7436),
          u = n(3255),
          p = n(4824),
          h = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), Object.defineProperty(e.prototype, "key", {
              get: function () {
                return u.ShapeTypes.ArrowDown;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.createShapePrimitives = function (t) {
              var e = t.rectangle,
                n = e.x,
                o = e.y,
                i = e.right,
                s = e.bottom,
                a = e.width,
                u = e.height,
                p = e.center.x,
                h = (a - t.parameters.get(c.ArrowVerticalLineWidthParameterName).value) / 2,
                l = u - t.parameters.get(c.ArrowVerticalTriangleHeightParameterName).value,
                d = t.normalizeX(n + h),
                f = t.normalizeY(o + l),
                y = t.normalizeX(i - h);
              return [new r.PathPrimitive([new r.PathPrimitiveMoveToCommand(d, o), new r.PathPrimitiveLineToCommand(y, o), new r.PathPrimitiveLineToCommand(y, f), new r.PathPrimitiveLineToCommand(i, f), new r.PathPrimitiveLineToCommand(p, s), new r.PathPrimitiveLineToCommand(n, f), new r.PathPrimitiveLineToCommand(d, f), new r.PathPrimitiveClosePathCommand()], t.style)];
            }, e.prototype.modifyParameters = function (t, e, n, o) {
              this.changeParameterValue(e, c.ArrowVerticalTriangleHeightParameterName, function (t) {
                return t.value - o;
              }), this.changeParameterValue(e, c.ArrowVerticalLineWidthParameterName, function (t) {
                return t.value - 2 * n;
              }), this.normalizeParameters(t, e);
            }, e.prototype.getParameterPoints = function (t) {
              return [new s.ShapeParameterPoint("c", new a.Point(t.normalizeX(t.position.x + (t.size.width - t.parameters.get(c.ArrowVerticalLineWidthParameterName).value) / 2), t.normalizeY(t.position.y + t.size.height - t.parameters.get(c.ArrowVerticalTriangleHeightParameterName).value)))];
            }, e.prototype.processConnectionPoint = function (e, n) {
              var o = e.parameters.get(c.ArrowVerticalTriangleHeightParameterName).value;
              if (n.y > e.position.y + e.size.height - o) {
                var i = e.size.width / 2 / o,
                  r = (n.y - (e.position.y + e.size.height - o)) * i,
                  s = e.getConnectionPointSide(n);
                s === p.ConnectionPointSide.East ? n.x -= r : s === p.ConnectionPointSide.West && (n.x += r);
              } else t.prototype.processConnectionPoint.call(this, e, n);
            }, e;
          }(c.ArrowVerticalShapeDescription);
        e.ArrowDownShapeDescription = h;
      },
      195: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ExportCommand = void 0;
        var r = n(8762),
          s = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), e.prototype.executeCore = function (t, e) {
              return e(new r.Exporter().export(this.control.model)), !0;
            }, e;
          }(n(6089).ExportImportCommandBase);
        e.ExportCommand = s;
      },
      268: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.DocumentShapeDescription = void 0;
        var r = n(3190),
          s = n(3255),
          a = n(6208),
          c = n(4824),
          u = function (t) {
            function e() {
              return t.call(this, void 0, !0) || this;
            }
            return i(e, t), Object.defineProperty(e.prototype, "key", {
              get: function () {
                return s.ShapeTypes.Document;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "keepRatioOnAutoSize", {
              get: function () {
                return !1;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.createShapePrimitives = function (t) {
              return this.createDocumentPrimitives(t.rectangle, t.style);
            }, e.prototype.createDocumentPrimitives = function (t, n) {
              var o = t.x,
                i = t.y,
                r = t.right,
                s = t.bottom,
                c = t.width,
                u = t.height,
                p = t.center.x,
                h = u * e.curveOffsetRatio;
              return [].concat([new a.PathPrimitive([new a.PathPrimitiveMoveToCommand(o, i), new a.PathPrimitiveLineToCommand(r, i), new a.PathPrimitiveLineToCommand(r, s), new a.PathPrimitiveQuadraticCurveToCommand(r - .25 * c, s - 2 * h, p, s - h), new a.PathPrimitiveQuadraticCurveToCommand(o + .25 * c, s + h, o, s - h), new a.PathPrimitiveClosePathCommand()], n)]);
            }, e.prototype.processConnectionPoint = function (t, n) {
              t.getConnectionPointSide(n) === c.ConnectionPointSide.South && (n.y -= t.size.height * e.curveOffsetRatio);
            }, e.prototype.getTextRectangle = function (t) {
              var n = t.rectangle;
              return n.clone().resize(0, -n.height * e.curveOffsetRatio);
            }, e.curveOffsetRatio = .1, e;
          }(r.RectangleShapeDescription);
        e.DocumentShapeDescription = u;
      },
      281: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ShapeDescriptionManager = void 0;
        var o = n(5290),
          i = n(9415),
          r = n(5005),
          s = n(3489),
          a = n(7368),
          c = n(156),
          u = n(7443),
          p = n(2444),
          h = n(6855),
          l = n(3415),
          d = n(7763),
          f = n(9829),
          y = n(7727),
          g = n(3190),
          m = n(8278),
          v = n(3165),
          P = n(9543),
          C = n(9496),
          S = n(8005),
          x = n(166),
          b = n(3475),
          w = n(5455),
          I = n(1833),
          T = n(268),
          O = n(9901),
          _ = n(7450),
          E = n(2781),
          M = n(9968),
          D = n(9613),
          A = n(1381),
          R = n(2392),
          j = n(9904),
          L = n(9758),
          N = n(5803),
          z = n(8321),
          U = n(2092),
          k = n(1493),
          B = n(2567),
          H = n(6621),
          K = n(6283),
          V = n(7837),
          F = n(3255),
          W = n(5656),
          G = n(41),
          Z = n(321),
          q = function () {
            function t() {
              this.descriptions = {}, this.descriptionTypes = {}, this.descriptionCategories = {}, this.onShapeDecriptionChanged = new G.EventDispatcher(), this.register(new m.TextShapeDescription(), F.ShapeCategories.General), this.register(new g.RectangleShapeDescription(), F.ShapeCategories.General), this.register(new f.EllipseShapeDescription(), F.ShapeCategories.General), this.register(new l.CrossShapeDescription(), F.ShapeCategories.General), this.register(new I.TriangleShapeDescription(), F.ShapeCategories.General), this.register(new d.DiamondShapeDescription(), F.ShapeCategories.General), this.register(new y.HeartShapeDescription(), F.ShapeCategories.General), this.register(new v.PentagonShapeDescription(), F.ShapeCategories.General), this.register(new P.HexagonShapeDescription(), F.ShapeCategories.General), this.register(new C.OctagonShapeDescription(), F.ShapeCategories.General), this.register(new S.StarShapeDescription(), F.ShapeCategories.General), this.register(new h.ArrowUpShapeDescription(), F.ShapeCategories.General), this.register(new x.ArrowDownShapeDescription(), F.ShapeCategories.General), this.register(new w.ArrowLeftShapeDescription(), F.ShapeCategories.General), this.register(new p.ArrowRightShapeDescription(), F.ShapeCategories.General), this.register(new u.ArrowUpDownShapeDescription(), F.ShapeCategories.General), this.register(new b.ArrowLeftRightShapeDescription(), F.ShapeCategories.General), this.register(new o.ProcessShapeDescription(), F.ShapeCategories.Flowchart), this.register(new i.DecisionShapeDescription(), F.ShapeCategories.Flowchart), this.register(new a.TerminatorShapeDescription(), F.ShapeCategories.Flowchart), this.register(new c.PredefinedProcessShapeDescription(), F.ShapeCategories.Flowchart), this.register(new T.DocumentShapeDescription(), F.ShapeCategories.Flowchart), this.register(new O.MultipleDocumentsShapeDescription(), F.ShapeCategories.Flowchart), this.register(new r.ManualInputShapeDescription(), F.ShapeCategories.Flowchart), this.register(new _.PreparationShapeDescription(), F.ShapeCategories.Flowchart), this.register(new s.DataShapeDescription(), F.ShapeCategories.Flowchart), this.register(new M.DatabaseShapeDescription(), F.ShapeCategories.Flowchart), this.register(new E.HardDiskShapeDescription(), F.ShapeCategories.Flowchart), this.register(new D.InternalStorageShapeDescription(), F.ShapeCategories.Flowchart), this.register(new A.PaperTapeShapeDescription(), F.ShapeCategories.Flowchart), this.register(new R.ManualOperationShapeDescription(), F.ShapeCategories.Flowchart), this.register(new j.DelayShapeDescription(), F.ShapeCategories.Flowchart), this.register(new L.StoredDataShapeDescription(), F.ShapeCategories.Flowchart), this.register(new z.DisplayShapeDescription(), F.ShapeCategories.Flowchart), this.register(new N.MergeShapeDescription(), F.ShapeCategories.Flowchart), this.register(new W.ConnectorShapeDescription(), F.ShapeCategories.Flowchart), this.register(new U.OrShapeDescription(), F.ShapeCategories.Flowchart), this.register(new k.SummingJunctionShapeDescription(), F.ShapeCategories.Flowchart), this.register(new Z.CardWithImageOnLeftDescription(), F.ShapeCategories.OrgChart), this.register(new Z.CardWithImageOnRightDescription(), F.ShapeCategories.OrgChart), this.register(new V.CardWithImageOnTopDescription(), F.ShapeCategories.OrgChart), this.register(new H.VerticalContainerDescription(), F.ShapeCategories.Containers), this.register(new K.HorizontalContainerDescription(), F.ShapeCategories.Containers);
            }
            return Object.defineProperty(t, "default", {
              get: function () {
                return t.defaultInstance;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(t, "defaultContainer", {
              get: function () {
                return t.defaultContainerInstance;
              },
              enumerable: !1,
              configurable: !0
            }), t.prototype.get = function (t) {
              return this.descriptions[t];
            }, t.prototype.getTypesByCategory = function (t) {
              return this.descriptionTypes[t] || [];
            }, t.prototype.getCategoryByType = function (t) {
              return this.descriptionCategories[t];
            }, t.prototype.getCategoryByDescription = function (t) {
              return this.getCategoryByType(t.key);
            }, t.prototype.register = function (t, e, n) {
              if (void 0 === n && (n = t.key), void 0 !== this.descriptions[n]) throw Error("Description key is duplicated");
              this.descriptions[n] = t, this.descriptionTypes[e] || (this.descriptionTypes[e] = []), this.descriptionTypes[e].push(n), this.descriptionCategories[n] = e, t.onChanged.add(this);
            }, t.prototype.registerCustomShape = function (t) {
              if (void 0 === t.type) throw Error("Custom shape type is not defined");
              if (void 0 !== this.descriptions[t.type]) throw Error("Custom shape type is duplicated");
              var e = t.baseType && this.descriptions[t.baseType];
              t.minWidth > t.maxWidth && (t.maxWidth = t.minWidth), t.minHeight > t.maxHeight && (t.maxHeight = t.minHeight), this.register(new B.CustomShapeDescription(t, e), t.category || F.ShapeCategories.Custom);
            }, t.prototype.unregisterCustomShape = function (t) {
              var e = this.descriptions[t];
              if (e instanceof B.CustomShapeDescription) {
                e.onChanged.remove(this);
                var n = this.descriptionCategories[t];
                delete this.descriptions[t], delete this.descriptionCategories[t];
                var o = this.descriptionTypes[n].indexOf(t);
                this.descriptionTypes[n].splice(o, 1), 0 === this.descriptionTypes[n].length && delete this.descriptionTypes[n];
              }
            }, t.prototype.unregisterAllCustomShapes = function () {
              var t = this;
              Object.keys(this.descriptions).forEach(function (e) {
                t.unregisterCustomShape(e);
              });
            }, t.prototype.notifyShapeDescriptionChanged = function (t) {
              this.onShapeDecriptionChanged.raise1(function (e) {
                return e.notifyShapeDescriptionChanged(t);
              });
            }, t.defaultInstance = new g.RectangleShapeDescription(), t.defaultContainerInstance = new H.VerticalContainerDescription(), t;
          }();
        e.ShapeDescriptionManager = q;
      },
      321: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CardWithImageOnRightDescription = e.CardWithImageOnLeftDescription = void 0;
        var r = n(1280),
          s = n(3255),
          a = n(5311),
          c = n(3844),
          u = function (t) {
            function e() {
              var e = t.call(this, new c.Size(1.5 * r.ShapeDefaultDimension, .5 * r.ShapeDefaultDimension)) || this;
              return e.isHorizontal = !0, e;
            }
            return i(e, t), e.prototype.getToolboxHeightToWidthRatio = function (t, e) {
              return 26 / 46;
            }, e.prototype.getImageSize = function (t, e, n) {
              var o = Math.min(t.height, t.width);
              return e || (o = Math.max(0, o - 2 * this.getImageMargin(n))), new c.Size(o, o);
            }, e.prototype.getImageSizeByTextBlockSize = function (t) {
              return this.getImageSize(new c.Size(Number.MAX_VALUE, t.height), !0);
            }, e;
          }(a.CardBaseDescription),
          p = function (t) {
            function e() {
              var e = null !== t && t.apply(this, arguments) || this;
              return e.isTextAfterImage = !0, e;
            }
            return i(e, t), Object.defineProperty(e.prototype, "key", {
              get: function () {
                return s.ShapeTypes.CardWithImageOnLeft;
              },
              enumerable: !1,
              configurable: !0
            }), e;
          }(u);
        e.CardWithImageOnLeftDescription = p;
        var h = function (t) {
          function e() {
            var e = null !== t && t.apply(this, arguments) || this;
            return e.isTextAfterImage = !1, e;
          }
          return i(e, t), Object.defineProperty(e.prototype, "key", {
            get: function () {
              return s.ShapeTypes.CardWithImageOnRight;
            },
            enumerable: !1,
            configurable: !0
          }), e;
        }(u);
        e.CardWithImageOnRightDescription = h;
      },
      401: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MouseHandlerMoveConnectorSideState = void 0;
        var r = n(2815),
          s = n(1922),
          a = function (t) {
            function e(e, n, o) {
              var i = t.call(this, e, n) || this;
              return i.model = o, i;
            }
            return i(e, t), e.prototype.onMouseDown = function (e) {
              this.startPoint = e.modelPoint, this.connectorKey = e.source.key, this.pointIndex = parseInt(e.source.value) + 1, t.prototype.onMouseDown.call(this, e);
            }, e.prototype.onApplyChanges = function (t) {
              var e = this.getSnappedPoint(t, t.modelPoint),
                n = this.model.findConnector(this.connectorKey);
              this.pointCreated ? s.ModelUtils.moveConnectorPoint(this.history, n, this.pointIndex, e) : (this.handler.addInteractingItem(n), s.ModelUtils.addConnectorPoint(this.history, this.connectorKey, this.pointIndex, e.clone()), this.pointCreated = !0), this.handler.tryUpdateModelSize();
            }, e.prototype.onFinishWithChanges = function () {
              var t = this.model.findConnector(this.connectorKey);
              s.ModelUtils.deleteConnectorUnnecessaryPoints(this.history, t), s.ModelUtils.fixConnectorBeginEndConnectionIndex(this.history, t), this.handler.tryUpdateModelSize();
            }, e.prototype.getDraggingElementKeys = function () {
              return [this.connectorKey];
            }, e;
          }(r.MouseHandlerDraggingState);
        e.MouseHandlerMoveConnectorSideState = a;
      },
      455: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.DiagramModel = void 0;
        var o = n(8408),
          i = n(6320),
          r = n(41),
          s = n(4412),
          a = n(3844),
          c = n(5327),
          u = n(4062),
          p = n(9553),
          h = n(9254),
          l = n(1922),
          d = function () {
            function t(e) {
              void 0 === e && (e = new a.Size(8400, 11910)), this.items = [], this.itemIndexByKey = {}, this.keyCounter = 0, this.pageSize = new a.Size(8400, 11910), this.pageLandscape = !1, this.pageColor = t.defaultPageColor, this.units = h.DiagramUnit.In, this.snapStartPoint = new c.Point(0, 0), this.pageSize = e, this.size = this.pageSize.clone(), this.rectangle = s.Rectangle.fromGeometry(new c.Point(0, 0), new a.Size(0, 0)), this.initializeKeyCounter();
            }
            return Object.defineProperty(t.prototype, "pageWidth", {
              get: function () {
                return this.pageLandscape ? this.pageSize.height : this.pageSize.width;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(t.prototype, "pageHeight", {
              get: function () {
                return this.pageLandscape ? this.pageSize.width : this.pageSize.height;
              },
              enumerable: !1,
              configurable: !0
            }), t.prototype.getRectangle = function (t) {
              return t && (this.rectangle = l.ModelUtils.createRectangle(this.items)), this.rectangle;
            }, t.prototype.pushItem = function (t) {
              var e = this.items.push(t);
              this.itemIndexByKey[t.key] = e - 1, t instanceof o.Shape && !t.image.isEmpty && this.cacheShapeImage(t);
            }, t.prototype.removeItem = function (t) {
              var e = this.getItemIndex(t);
              delete this.itemIndexByKey[t.key], this.items.splice(e, 1), this.updateIndicesHash(e);
            }, t.prototype.updateIndicesHash = function (t) {
              for (var e = t; e < this.items.length; e++) this.itemIndexByKey[this.items[e].key] = e;
            }, t.prototype.getItemIndex = function (t) {
              return this.itemIndexByKey[t.key];
            }, t.prototype.findShape = function (t) {
              var e = this.findItem(t);
              return e instanceof o.Shape ? e : void 0;
            }, t.prototype.findShapesCore = function (t) {
              var e = [];
              return this.items.forEach(function (n) {
                n instanceof o.Shape && t(n) && e.push(n);
              }), e;
            }, t.prototype.findShapeCore = function (t) {
              for (var e = 0; e < this.items.length; e++) {
                var n = this.items[e];
                if (n instanceof o.Shape && t(n)) return n;
              }
            }, t.prototype.findShapeAtPosition = function (t) {
              return this.findShapeCore(function (e) {
                return e.position.equals(t);
              });
            }, t.prototype.findShapeByDataKey = function (t) {
              return this.findShapeCore(function (e) {
                return e.dataKey === t;
              });
            }, t.prototype.findShapesByImageUrl = function (t) {
              return this.findShapesCore(function (e) {
                return e.image.url === t;
              });
            }, t.prototype.findShapesByDescription = function (t) {
              return this.findShapesCore(function (e) {
                return e.description.key === t.key;
              });
            }, t.prototype.cacheShapeImage = function (t) {
              var e = u.ImageCache.instance.createUnloadedInfoByShapeImageInfo(t.image);
              e.isLoaded && t.image.loadBase64Content(e.base64);
            }, t.prototype.loadAllImages = function (t) {
              u.ImageCache.instance.loadAllImages(t);
            }, t.prototype.findContainer = function (t) {
              var e = this.findShape(t);
              return e && e.enableChildren ? e : void 0;
            }, t.prototype.findNearestContainer = function (t) {
              var e = this.findShape(t);
              return e ? e.enableChildren ? e : e.container : void 0;
            }, t.prototype.getChildren = function (t) {
              var e = this;
              return t.children.map(function (t) {
                return e.findItem(t.key);
              }).filter(function (t) {
                return t;
              });
            }, t.prototype.findChild = function (t, e, n) {
              var i,
                r = this;
              return void 0 === n && (n = !0), t.children.forEach(function (t) {
                i || (t.key !== e ? n && t instanceof o.Shape && (i = r.findChild(t, e, n)) : i = t);
              }), i;
            }, t.prototype.findItemContainerCore = function (t, e) {
              for (var n = t.container; n && e && !e(n);) n = n.container;
              return n;
            }, t.prototype.findItemContainer = function (t) {
              return this.findItemContainerCore(t);
            }, t.prototype.findItemCollapsedContainer = function (t) {
              return this.findItemContainerCore(t, function (t) {
                return !t.expanded;
              });
            }, t.prototype.findItemTopCollapsedContainer = function (t) {
              for (var e, n = t.container; n;) n.expanded || (e = n), n = n.container;
              return e;
            }, t.prototype.isContainerItem = function (t, e) {
              return void 0 !== this.findItemContainerCore(e, function (e) {
                return e.key === t.key;
              });
            }, t.prototype.findConnector = function (t) {
              var e = this.findItem(t);
              return e instanceof i.Connector ? e : void 0;
            }, t.prototype.findConnectorCore = function (t) {
              for (var e = 0; e < this.items.length; e++) {
                var n = this.items[e];
                if (n instanceof i.Connector && t(n)) return n;
              }
            }, t.prototype.findConnectorAtPoints = function (t) {
              return this.findConnectorCore(function (e) {
                return r.GeometryUtils.arePointsEqual(e.points, t);
              });
            }, t.prototype.findConnectorByDataKey = function (t) {
              return this.findConnectorCore(function (e) {
                return e.dataKey === t;
              });
            }, t.prototype.findConnectorByBeginEndDataKeys = function (t, e) {
              return this.findConnectorCore(function (n) {
                return n.beginItem && n.beginItem.dataKey === t && n.endItem && n.endItem.dataKey === e;
              });
            }, t.prototype.findConnectorsCore = function (t) {
              var e = [];
              return this.items.forEach(function (n) {
                n instanceof i.Connector && t(n) && e.push(n);
              }), e;
            }, t.prototype.findConnectorsWithoutBeginItem = function () {
              return this.findConnectorsCore(function (t) {
                return !t.beginItem;
              });
            }, t.prototype.findConnectorsWithoutEndItem = function () {
              return this.findConnectorsCore(function (t) {
                return !t.endItem;
              });
            }, t.prototype.findItem = function (t) {
              return this.items[this.itemIndexByKey[t]];
            }, t.prototype.findItemByDataKey = function (t) {
              return this.findItemCore(function (e) {
                return e.dataKey === t;
              });
            }, t.prototype.findItemCore = function (t) {
              for (var e = 0; e < this.items.length; e++) if (t(this.items[e])) return this.items[e];
            }, t.isIntersectedItems = function (t, e) {
              var n = !1;
              return t instanceof o.Shape ? n = e.intersectedByRect(t.rectangle) : t instanceof i.Connector && t.getSegments().forEach(function (t) {
                e instanceof o.Shape ? n = n || t.isIntersectedByRect(e.rectangle) : e instanceof i.Connector && e.getSegments().forEach(function (e) {
                  n = n || t.isIntersected(e);
                });
              }), n;
            }, t.prototype.getIntersectItems = function (e) {
              var n = [];
              return this.items.forEach(function (o) {
                o.container === e.container && (e === o || o instanceof i.Connector && -1 !== e.attachedConnectors.indexOf(o) || !t.isIntersectedItems(o, e) || n.push(o));
              }), n;
            }, t.prototype.getIntersectItemsMinZIndex = function (t) {
              return this.getIntersectItems(t).map(function (t) {
                return t.zIndex;
              }).reduce(function (t, e) {
                return Math.min(t, e);
              }, Number.MAX_VALUE);
            }, t.prototype.getIntersectItemsMaxZIndex = function (t) {
              return this.getIntersectItems(t).map(function (t) {
                return t.zIndex;
              }).reduce(function (t, e) {
                return Math.max(t, e);
              }, -Number.MAX_VALUE);
            }, t.prototype.iterateItems = function (t) {
              this.items.forEach(t);
            }, t.prototype.getNextKey = function () {
              return (this.keyCounter++).toString();
            }, t.prototype.initializeKeyCounter = function () {
              this.keyCounter = this.items.reduce(function (t, e) {
                var n = parseInt(e.key);
                return Math.max(t, isNaN(n) ? 0 : n + 1);
              }, this.items.length);
            }, t.defaultPageColor = p.ColorUtils.LIGHT_COLOR, t;
          }();
        e.DiagramModel = d;
      },
      459: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ChangeViewUnitsCommand = e.ChangeUnitsCommand = void 0;
        var r = n(1540),
          s = n(8437),
          a = n(3913),
          c = n(820),
          u = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), e.prototype.isEnabledInReadOnlyMode = function () {
              return !0;
            }, e.prototype.getValue = function () {
              return this.control.model.units;
            }, e.prototype.createHistoryItems = function (t) {
              return [new s.ChangeUnitsHistoryItem(t)];
            }, e.prototype.getItems = function () {
              return Object.keys(c.DiagramLocalizationService.unitItems).map(function (t) {
                return {
                  value: parseInt(t),
                  text: c.DiagramLocalizationService.unitItems[t]
                };
              });
            }, e;
          }(r.ChangePagePropertyCommand);
        e.ChangeUnitsCommand = u;
        var p = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(e, t), e.prototype.isEnabledInReadOnlyMode = function () {
            return !0;
          }, e.prototype.getValue = function () {
            return this.control.settings.viewUnits;
          }, e.prototype.executeCore = function (t, e) {
            return this.control.settings.viewUnits = e, !0;
          }, e.prototype.getItems = function () {
            return Object.keys(c.DiagramLocalizationService.unitItems).map(function (t) {
              return {
                value: parseInt(t),
                text: c.DiagramLocalizationService.unitItems[t]
              };
            });
          }, e;
        }(a.SimpleCommandBase);
        e.ChangeViewUnitsCommand = p;
      },
      472: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ChangeShapeImageHistoryItem = void 0;
        var r = n(2616),
          s = n(9406),
          a = function (t) {
            function e(e, n) {
              var o = t.call(this) || this;
              return o.shapeKey = e.key, o.imageUrl = n, o;
            }
            return i(e, t), e.prototype.redo = function (t) {
              var e = t.model.findShape(this.shapeKey);
              this.oldImage = e.image, t.changeShapeImage(e, new s.ImageInfo(this.imageUrl));
            }, e.prototype.undo = function (t) {
              var e = t.model.findShape(this.shapeKey);
              t.changeShapeImage(e, this.oldImage);
            }, e;
          }(r.HistoryItem);
        e.ChangeShapeImageHistoryItem = a;
      },
      476: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Segment = void 0;
        var o = n(594),
          i = n(4496),
          r = n(5327),
          s = n(4412),
          a = function () {
            function t(t, e) {
              this.startPoint = t, this.endPoint = e;
            }
            return Object.defineProperty(t.prototype, "length", {
              get: function () {
                return i.Metrics.euclideanDistance(this.startPoint, this.endPoint);
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(t.prototype, "xLength", {
              get: function () {
                return Math.abs(this.endPoint.x - this.startPoint.x);
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(t.prototype, "yLength", {
              get: function () {
                return Math.abs(this.endPoint.y - this.startPoint.y);
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(t.prototype, "center", {
              get: function () {
                return new r.Point(this.startPoint.x + (this.endPoint.x - this.startPoint.x) / 2, this.startPoint.y + (this.endPoint.y - this.startPoint.y) / 2);
              },
              enumerable: !1,
              configurable: !0
            }), t.prototype.isIntersected = function (t) {
              return this.startPoint.equals(t.startPoint) || this.endPoint.equals(t.startPoint) || this.startPoint.equals(t.endPoint) || this.endPoint.equals(t.endPoint) || this.intersectCore(t) && t.intersectCore(this);
            }, t.prototype.containsPoint = function (t, e) {
              return void 0 === e && (e = 1e-7), this.startPoint.equals(t) || this.endPoint.equals(t) || o.MathUtils.numberCloseTo(this.length, i.Metrics.euclideanDistance(this.startPoint, t) + i.Metrics.euclideanDistance(this.endPoint, t), e);
            }, t.prototype.isIntersectedByRect = function (e) {
              if (s.Rectangle.containsPoint(e, this.startPoint) || s.Rectangle.containsPoint(e, this.endPoint)) return !0;
              var n = e.x,
                o = e.x + e.width,
                i = e.y,
                a = e.y + e.height;
              return this.isIntersected(new t(new r.Point(n, i), new r.Point(n, a))) || this.isIntersected(new t(new r.Point(o, i), new r.Point(o, a))) || this.isIntersected(new t(new r.Point(n, i), new r.Point(o, i))) || this.isIntersected(new t(new r.Point(n, a), new r.Point(o, a)));
            }, t.prototype.intersectCore = function (t) {
              if (this.startPoint.x === this.endPoint.x) {
                if (this.startPoint.x - t.endPoint.x !== 0) return (this.startPoint.x - t.startPoint.x) / (this.startPoint.x - t.endPoint.x) <= 0;
                if (t.endPoint.y - this.endPoint.y !== 0) return (t.endPoint.y - this.startPoint.y) / (t.endPoint.y - this.endPoint.y) <= 0;
              }
              if (this.startPoint.y === this.endPoint.y) {
                if (this.startPoint.y - t.endPoint.y !== 0) return (this.startPoint.y - t.startPoint.y) / (this.startPoint.y - t.endPoint.y) <= 0;
                if (t.endPoint.x - this.endPoint.x !== 0) return (t.endPoint.x - this.startPoint.x) / (t.endPoint.x - this.endPoint.x) <= 0;
              }
              var e = (this.endPoint.y - this.startPoint.y) / (this.endPoint.x - this.startPoint.x),
                n = this.startPoint.y + (t.startPoint.x - this.startPoint.x) * e,
                o = this.startPoint.y + (t.endPoint.x - this.startPoint.x) * e,
                i = t.startPoint.y - n,
                r = t.endPoint.y - o;
              return 0 === i && 0 === r ? (this.startPoint.y - n) / (this.endPoint.y - n) <= 0 || (this.startPoint.y - o) / (this.endPoint.y - o) <= 0 : 0 === i || 0 === r || i / r < 0;
            }, t;
          }();
        e.Segment = a;
      },
      481: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.IconToolbox = void 0;
        var r = n(5037),
          s = n(8509),
          a = n(8408),
          c = n(9500),
          u = n(5327),
          p = n(8278),
          h = n(5059),
          l = n(2567),
          d = n(94),
          f = function (t) {
            function e(e, n, o, i, r, s, a, c, u) {
              var p = t.call(this, e, n, o, i, r, s) || this;
              return p.options = a, p.measurer = c, p.instanceId = u, p;
            }
            return i(e, t), e.prototype.createElements = function (t, e) {
              var n = document.createElementNS(s.svgNS, "svg");
              n.className.baseVal = "dxdi-canvas", t.appendChild(n), this.drawShapeIcons(n, e, this.options.toolboxWidth || n.getBoundingClientRect().width);
            }, e.prototype.drawShapeIcons = function (t, e, n) {
              var o = this,
                i = h.DEFAULT_STROKE_WIDTH,
                r = n - 2 * i,
                s = this.options.shapeIconSize;
              !s && this.options.shapeIconSpacing && this.options.shapeIconCountInRow && (s = Math.floor((r - (this.options.shapeIconCountInRow - 1) * this.options.shapeIconSpacing) / this.options.shapeIconCountInRow)), s || (s = 32);
              var a = s = Math.max(s, this.options.shapeIconSpacing / 2),
                u = this.options.shapeIconCountInRow;
              if (!u) for (u = 1; a < r;) (a += this.options.shapeIconSpacing + s) < r && u++;
              var p = u > 1 ? (r - s * u) / (u - 1) : 0,
                l = i,
                d = i,
                f = c.UnitConverter.pixelsToTwips(s);
              e.forEach(function (e, n) {
                n > 0 && n % u === 0 && (l = i, d += s + p);
                var r = o.shapeDescriptionManager.get(e),
                  a = o.createShape(r, l, d, s < 26);
                o.updateShapeIconBounds(a, s);
                var h = o.drawShape(t, a);
                o.drawSelector(h, c.UnitConverter.pixelsToTwips(l), c.UnitConverter.pixelsToTwips(d), f), l += s + p;
              }), t.style.height = d + s + i + "px", t.style.width = n + "px";
            }, e.prototype.drawShape = function (t, e) {
              var n = this,
                o = e.description.createPrimitives(e, this.instanceId, !0),
                i = document.createElementNS(s.svgNS, "g");
              if (i.setAttribute("data-tb-type", e.description.key.toString()), i.setAttribute("class", "toolbox-item"), i.setAttribute("title", e.description.getTitle()), this.options.shapeIconAttributes) for (var r in this.options.shapeIconAttributes) Object.prototype.hasOwnProperty.call(this.options.shapeIconAttributes, r) && i.setAttribute(r, this.options.shapeIconAttributes[r]);
              return t.appendChild(i), o.forEach(function (t) {
                var e = t.createElement(function (t) {
                  return i.appendChild(t);
                });
                t.applyElementProperties(e, n.measurer);
              }), i;
            }, e.prototype.drawSelector = function (t, e, n, o) {
              var i = this,
                r = new d.RectanglePrimitive(e, n, o, o, void 0, "selector");
              r.createElement(function (e) {
                r.applyElementProperties(e, i.measurer), t.appendChild(e);
              });
            }, e.prototype.createShape = function (t, e, n, o) {
              var i = c.UnitConverter.pixelsToTwips(e),
                r = c.UnitConverter.pixelsToTwips(n),
                s = new a.Shape(t, new u.Point(i, r), !0);
              return this.needResetShapeText(t) ? s.text = "" : o && (s.text = "T"), s;
            }, e.prototype.needResetShapeText = function (t) {
              return !(t instanceof p.TextShapeDescription) && !(t instanceof l.CustomShapeDescription && t.baseDescription instanceof p.TextShapeDescription);
            }, e.prototype.updateShapeIconBounds = function (t, e) {
              var n = c.UnitConverter.pixelsToTwips(e);
              if (t.size.height = t.size.width * t.getToolboxHeightToWidthRatio(), t.size.width > t.size.height) {
                var o = t.size.height / t.size.width;
                t.size.width = n, t.size.height = n * o, t.position.y = t.position.y + (n - t.size.height) / 2, t.parameters.forEach(function (e) {
                  e.value = e.value * n / t.description.defaultSize.width;
                });
              } else if (t.size.width < t.size.height) {
                o = t.size.width / t.size.height;
                t.size.height = n, t.size.width = n * o, t.position.x = t.position.x + (n - t.size.width) / 2, t.parameters.forEach(function (e) {
                  e.value = e.value * n / t.description.defaultSize.height;
                });
              } else t.size.width = n, t.size.height = n, t.parameters.forEach(function (e) {
                e.value = e.value * n / t.description.defaultSize.width;
              });
            }, e.prototype.createDraggingElement = function (t) {
              var e = document.createElement("DIV");
              e.setAttribute("class", "dxdi-toolbox-drag-item"), document.body.appendChild(e);
              var n = document.createElementNS(s.svgNS, "svg");
              n.className.baseVal = "dxdi-canvas", e.appendChild(n);
              var o = this.shapeDescriptionManager.get(t.evt.data),
                i = this.createShape(o, h.DEFAULT_STROKE_WIDTH, h.DEFAULT_STROKE_WIDTH);
              return this.drawShape(n, i), e.style.width = c.UnitConverter.twipsToPixels(i.size.width) + 2 * h.DEFAULT_STROKE_WIDTH + "px", e.style.height = c.UnitConverter.twipsToPixels(i.size.height) + 2 * h.DEFAULT_STROKE_WIDTH + "px", e;
            }, e;
          }(r.Toolbox);
        e.IconToolbox = f;
      },
      506: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ImportConnectorHistoryItem = void 0;
        var r = function (t) {
          function e(e) {
            var n = t.call(this) || this;
            return n.connector = e, n;
          }
          return i(e, t), e.prototype.redo = function (t) {
            this.connectorKey = this.connector.key, t.insertConnector(this.connector);
          }, e.prototype.undo = function (t) {
            var e = t.model.findConnector(this.connectorKey);
            t.removeConnector(e);
          }, e;
        }(n(2616).HistoryItem);
        e.ImportConnectorHistoryItem = r;
      },
      522: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ConnectorPointsOrthogonalWestSideCalculator = void 0;
        var r = n(4824),
          s = n(3976),
          a = n(9956),
          c = function (t) {
            function e(e) {
              return t.call(this, e) || this;
            }
            return i(e, t), e.prototype.getCorrectOriginPoint = function (t, e) {
              return t.x > e.x && (t = t.clone().offset(e.x - t.x, 0)), t;
            }, e.prototype.getSameShapeOffsetPoints = function (t, e, n, o) {
              switch (t) {
                case r.ConnectionPointSide.North:
                case r.ConnectionPointSide.South:
                case r.ConnectionPointSide.West:
                  return [e.clone().offset(-this.getMinOffset(), 0)];
                case r.ConnectionPointSide.East:
                  return this.getAsideOffsetPoints(e, n, o, this.getMinOffset(), this.getMinOffset());
              }
            }, e.prototype.getOverlappedPointsOffsetPoints = function (t, e, n, o) {
              switch (t) {
                case r.ConnectionPointSide.East:
                  return [e.clone().offset(this.getMinOffset(), 0)];
                case r.ConnectionPointSide.West:
                  return [e.clone().offset(-this.getMinOffset(), 0)];
              }
              return [];
            }, e.prototype.getBeginOverlappedShapeOffsetPoints = function (t, e, n, o) {
              switch (t) {
                case r.ConnectionPointSide.North:
                  return e.x > n.x ? e.y < n.y ? [] : [e.clone().offset(-this.getMinOffset(), 0)] : e.x < this.endRect.x ? this.getAsideOffsetPoints(e, n, o, this.getMinOffset(), this.getMinOffset(), !0) : [e.clone().offset(-this.getMinOffset(), 0)];
                case r.ConnectionPointSide.South:
                  return e.x > n.x ? e.y > n.y ? [] : [e.clone().offset(-this.getMinOffset(), 0)] : e.x < this.endRect.x ? this.getAsideOffsetPoints(e, n, o, this.getMinOffset(), this.getMinOffset(), !1) : [e.clone().offset(-this.getMinOffset(), 0)];
                case r.ConnectionPointSide.West:
                  return [e.clone().offset(-this.getMinOffset(), 0)];
                case r.ConnectionPointSide.East:
                  return this.getAsideOffsetPoints(e, n, o, this.getMinOffset(), this.getMinOffset(), e.y < n.y);
              }
            }, e.prototype.getEndOverlappedShapeOffsetPoints = function (t, e, n, o) {
              switch (t) {
                case r.ConnectionPointSide.East:
                  var i = -this.getMinOffset();
                  return this.beginRect.x < e.x && (i -= e.x - this.beginRect.x), [e.clone().offset(i, 0)];
                case r.ConnectionPointSide.West:
                  return [e.clone().offset(-this.getMinOffset(), 0)];
                case r.ConnectionPointSide.North:
                  return n.x > e.x ? this.getAsideOffsetPoints(e, n, o, this.getMinOffset(), this.getMinOffset(), !0) : e.y > n.y ? [e.clone().offset(-this.getMinOffset(), 0)] : [];
                case r.ConnectionPointSide.South:
                  return n.x > e.x ? this.getAsideOffsetPoints(e, n, o, this.getMinOffset(), this.getMinOffset(), !1) : e.y < n.y ? [e.clone().offset(-this.getMinOffset(), 0)] : [];
              }
            }, e.prototype.getBeginOnSideOffsetPoints = function (t, e, n, o) {
              return [e.clone().offset(-this.getScaleableOffsetX(e, !1), 0)];
            }, e.prototype.getEndOnSideOffsetPoints = function (t, e, n, o) {
              return [e.clone().offset(-this.getScaleableOffsetX(e, !0), 0)];
            }, e.prototype.getBeginOffSideOffsetPoints = function (t, e, n, o) {
              switch (t) {
                case r.ConnectionPointSide.South:
                  if (this.isBeginEndOverlappedY()) return this.getScaleableAsideOffsetPoints(e, n, o, !1, !1);
                  break;
                case r.ConnectionPointSide.North:
                  if (this.isBeginEndOverlappedY()) return this.getScaleableAsideOffsetPoints(e, n, o, !1, !0);
                  break;
                case r.ConnectionPointSide.West:
                  if (this.isBeginEndOverlappedY()) return this.getScaleableAsideOffsetPoints(e, n, o, !1);
                  break;
                case r.ConnectionPointSide.Undefined:
                case r.ConnectionPointSide.East:
                  return this.getScaleableAsideOffsetPoints(e, n, o, !1);
              }
              return [e.clone().offset(-this.getScaleableOffsetX(e, !1), 0)];
            }, e.prototype.getEndOffSideOffsetPoints = function (t, e, n, o) {
              if (t === r.ConnectionPointSide.Undefined) return this.getScaleableAsideOffsetPoints(e, n, o, !0);
              if (this.isBeginEndOverlappedY()) {
                var i = this.beginRect.center.y > this.endRect.center.y;
                return this.getScaleableAsideOffsetPoints(e, n, o, !0, i);
              }
              return [e.clone().offset(-this.getScaleableOffsetX(e, !0), 0)];
            }, e.prototype.getAsideOffsetPoints = function (t, e, n, o, i, r) {
              var s = [];
              return void 0 !== n && (void 0 === r && (r = e.y < t.y), r ? s.push(t.clone().offset(-o, -(t.y - n.y + i))) : s.push(t.clone().offset(-o, n.bottom - t.y + i))), s.push(t.clone().offset(-o, 0)), s;
            }, e.prototype.getScaleableAsideOffsetPoints = function (t, e, n, o, i) {
              var r = this.getScaleableOffsetX(t, o),
                s = this.getScaleableOffsetY(t, e, o);
              return this.getAsideOffsetPoints(t, e, n, r, s, i);
            }, e.prototype.getScaleableOffsetX = function (t, e) {
              if (this.beginRect && this.endRect) {
                var n = e ? t.x - this.beginRect.right : t.x - this.endRect.right;
                if (n > 0 && n < 2 * this.getMinOffset()) return n / 2;
              }
              return this.getMinOffset();
            }, e.prototype.getScaleableOffsetY = function (t, e, n) {
              if (this.beginRect && this.endRect && !n && !this.isBeginEndOverlappedY()) {
                var o = void 0;
                if ((o = e.y < t.y ? this.beginRect.y - this.endRect.bottom : this.endRect.y - this.beginRect.bottom) < 2 * this.getMinOffset()) return o / 2;
              }
              return this.getMinOffset();
            }, e.prototype.isOnSidePoint = function (t, e) {
              return e.x < t.x;
            }, e.prototype.isDirectConnectionAllowed = function (t, e, n) {
              return t === r.ConnectionPointSide.East || t === r.ConnectionPointSide.Undefined;
            }, e.prototype.getDirectConnectionPoints = function (t, e) {
              var n = e.x + (t.x - e.x) / 2;
              return [new a.ConnectorRenderPoint(n, t.y), new a.ConnectorRenderPoint(n, e.y)];
            }, e;
          }(s.ConnectorPointsOrthogonalSideCalculatorBase);
        e.ConnectorPointsOrthogonalWestSideCalculator = c;
      },
      531: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ChangeFontColorCommand = void 0;
        var r = n(6994),
          s = n(9553),
          a = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), e.prototype.processParameter = function (t) {
              return s.ColorUtils.stringToHash(t);
            }, e.prototype.getStyleProperty = function () {
              return "fill";
            }, e;
          }(r.ChangeStyleTextPropertyCommand);
        e.ChangeFontColorCommand = a;
      },
      540: (t, e, n) => {
        n.r(e);
      },
      564: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.BeforeChangeConnectorTextEventArgs = e.BeforeChangeConnectorTextRequestedEntity = void 0;
        var r = n(5225),
          s = n(5102),
          a = function (t) {
            function e(e, n, o) {
              var i = t.call(this, e) || this;
              return i.connector = n, i.position = o, i;
            }
            return i(e, t), Object.defineProperty(e.prototype, "operation", {
              get: function () {
                return r.DiagramModelOperation.BeforeChangeConnectorText;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.createEventArgs = function () {
              return new c(this.apiController.createNativeConnector(this.connector), this.position, this.connector.texts.map(function (t) {
                return t;
              }).sort(function (t, e) {
                return t.position - e.position;
              }).indexOf(this.connector.texts.get(this.position)));
            }, Object.defineProperty(e.prototype, "settingsKey", {
              get: function () {
                return "changeConnectorText";
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "storageKey", {
              get: function () {
                return "before" + this.settingsKey + "_" + (this.connector && this.connector.key);
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.equals = function (t) {
              return t instanceof e && this.connector === t.connector && this.position === t.position && this.connector.texts.get(this.position) === t.connector.texts.get(t.position);
            }, e;
          }(s.RequestedEntity);
        e.BeforeChangeConnectorTextRequestedEntity = a;
        var c = function (t) {
          function e(e, n, o) {
            var i = t.call(this) || this;
            return i.connector = e, i.position = n, i.index = o, i;
          }
          return i(e, t), e;
        }(s.PermissionRequestEventArgs);
        e.BeforeChangeConnectorTextEventArgs = c;
      },
      594: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MathUtils = void 0;
        var o = n(2892),
          i = function () {
            function t() {}
            return t.round = function (e, n) {
              void 0 === n && (n = 0);
              var o = t.powFactor[n];
              return Math.round(e * o) / o;
            }, t.numberCloseTo = function (t, e, n) {
              return void 0 === n && (n = 1e-5), Math.abs(t - e) < n;
            }, t.restrictValue = function (t, e, n) {
              return n < e && (n = e), t > n ? n : t < e ? e : t;
            }, t.getRandomInt = function (t, e) {
              return Math.floor(Math.random() * (e - t + 1)) + t;
            }, t.generateGuid = function () {
              return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (t) {
                var e = 16 * Math.random() | 0;
                return ("x" === t ? e : 3 & e | 8).toString(16);
              });
            }, t.powFactor = o.ListUtils.initByCallback(20, function (t) {
              return Math.pow(10, t);
            }), t.somePrimes = [1009, 1013, 1019, 1021, 1031, 1033, 1039, 1049, 1051, 1061, 1063, 1069, 1087, 1091, 1093, 1097, 1103, 1109, 1117, 1123, 1129, 1151, 1153, 1163, 1171, 1181, 1187, 1193, 1201, 1213, 1217, 1223, 1229, 1231, 1237, 1249, 1259, 1277, 1279, 1283, 1289, 1291, 1297, 1301, 1303, 1307, 1319, 1321, 1327, 1361, 1367, 1373, 1381, 1399, 1409, 1423, 1427, 1429, 1433, 1439, 1447, 1451, 1453, 1459, 1471, 1481, 1483, 1487, 1489, 1493, 1499, 1511, 1523, 1531, 1543, 1549, 1553, 1559, 1567, 1571, 1579, 1583, 1597, 1601, 1607, 1609, 1613, 1619, 1621, 1627, 1637, 1657, 1663, 1667, 1669, 1693, 1697, 1699, 1709, 1721, 1723, 1733, 1741, 1747, 1753, 1759, 1777, 1783, 1787, 1789, 1801, 1811, 1823, 1831, 1847, 1861, 1867, 1871, 1873, 1877, 1879, 1889, 1901, 1907, 1913, 1931, 1933, 1949, 1951, 1973, 1979, 1987, 1993, 1997, 1999, 2003], t;
          }();
        e.MathUtils = i;
      },
      618: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.RightAngleConnectorRoutingMathOperations = void 0;
        var o = n(476),
          i = n(594),
          r = n(8671),
          s = n(41),
          a = n(4824),
          c = function () {
            function t() {}
            return t.createUnionSegments = function (t, e) {
              for (var n = [], i = t[0].startPoint, r = t[0].endPoint, s = 1; s < t.length; s++) {
                var a = t[s];
                e(r, a.startPoint) && (n.push(new o.Segment(i.clone(), r.clone())), i = a.startPoint), r = a.endPoint;
              }
              return n.push(new o.Segment(i, r)), n;
            }, t.unionPoints = function (t) {
              for (var e = 0; e < t.length - 2;) s.GeometryUtils.isCorner(t[e], t[e + 1], t[e + 2]) ? e++ : (t.splice(e + 1, 1), e = Math.max(0, e - 1));
            }, t.getTurnDirection = function (t) {
              return i.MathUtils.numberCloseTo(t, 0) ? r.RightAngleTurnDirection.Straight : i.MathUtils.numberCloseTo(t, Math.PI) ? r.RightAngleTurnDirection.Backwards : t < Math.PI ? r.RightAngleTurnDirection.Left : r.RightAngleTurnDirection.Right;
            }, t.isSegmentNormal = function (t, e) {
              return e ? i.MathUtils.numberCloseTo(t.startPoint.y, t.endPoint.y) : i.MathUtils.numberCloseTo(t.startPoint.x, t.endPoint.x);
            }, t.isConnectionRectanleLineIntersected = function (t, e, n, o, i, r) {
              switch (n) {
                case a.ConnectionPointSide.North:
                  return s.GeometryUtils.isLineIntersected(r(t.x, t.y), r(t.right, t.y), e, o, i);
                case a.ConnectionPointSide.South:
                  return s.GeometryUtils.isLineIntersected(r(t.right, t.bottom), r(t.x, t.bottom), e, o, i);
                case a.ConnectionPointSide.West:
                  return s.GeometryUtils.isLineIntersected(r(t.x, t.y), r(t.x, t.bottom), e, o, i);
                case a.ConnectionPointSide.East:
                  return s.GeometryUtils.isLineIntersected(r(t.right, t.y), r(t.right, t.bottom), e, o, i);
                default:
                  return !1;
              }
            }, t.createBeginConnectionSegment = function (t, e, n, i) {
              switch (t) {
                case a.ConnectionPointSide.North:
                  return new o.Segment(e, i(e.x, e.y - n));
                case a.ConnectionPointSide.South:
                  return new o.Segment(e, i(e.x, e.y + n));
                case a.ConnectionPointSide.West:
                  return new o.Segment(e, i(e.x - n, e.y));
                case a.ConnectionPointSide.East:
                  return new o.Segment(e, i(e.x + n, e.y));
                default:
                  return e;
              }
            }, t.createEndConnectionSegment = function (t, e, n, i) {
              switch (t) {
                case a.ConnectionPointSide.North:
                  return new o.Segment(i(e.x, e.y - n), e);
                case a.ConnectionPointSide.South:
                  return new o.Segment(i(e.x, e.y + n), e);
                case a.ConnectionPointSide.West:
                  return new o.Segment(i(e.x - n, e.y), e);
                case a.ConnectionPointSide.East:
                  return new o.Segment(i(e.x + n, e.y), e);
                default:
                  return e;
              }
            }, t;
          }();
        e.RightAngleConnectorRoutingMathOperations = c;
      },
      672: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ChangeZindexHistoryItem = void 0;
        var r = function (t) {
          function e(e, n) {
            var o = t.call(this) || this;
            return o.itemKey = e.key, o.zIndex = n, o;
          }
          return i(e, t), e.prototype.redo = function (t) {
            var e = t.model.findItem(this.itemKey);
            this.oldZIndex = e.zIndex, t.changeZIndex(e, this.zIndex);
          }, e.prototype.undo = function (t) {
            var e = t.model.findItem(this.itemKey);
            t.changeZIndex(e, this.oldZIndex);
          }, e;
        }(n(2616).HistoryItem);
        e.ChangeZindexHistoryItem = r;
      },
      701: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.DiagramControl = void 0;
        var o = n(5327),
          i = n(2703),
          r = n(5031),
          s = n(6309),
          a = n(455),
          c = n(3099),
          u = n(7059),
          p = n(6695),
          h = n(4306),
          l = n(281),
          d = n(1581),
          f = n(9307),
          y = n(5225),
          g = n(3659),
          m = n(1922),
          v = n(1659),
          P = n(41),
          C = n(8315),
          S = n(4062),
          x = n(1040),
          b = n(5130),
          w = n(6727),
          I = n(6320),
          T = n(2175),
          O = n(5718),
          _ = n(2136),
          E = n(8156),
          M = n(594),
          D = function () {
            function t() {
              this.updateLockCount = 0, this.shouldUpdateItemsByModel = !1, this.reloadContentNeeded = !1, this.reloadContentParameters = new O.ReloadContentParameters(), this.reloadContentByExternalChangesParameters = new O.ReloadContentParameters(), this.instanceId = M.MathUtils.generateGuid(), this.settings = new f.DiagramSettings(), this.shapeDescriptionManager = new l.ShapeDescriptionManager(), this.shapeDescriptionManager.onShapeDecriptionChanged.add(this), this.model = new a.DiagramModel(), this.selection = new c.Selection(this.model), this.onNativeAction = new P.EventDispatcher(), this.apiController = new C.ApiController(this.onNativeAction, this.selection, this.model), this.permissionsProvider = new x.PermissionsProvider(this.apiController), this.permissionsProvider.onRequestOperation.add(this), this.routingModel = new b.ConnectorRoutingModel(), this.modelManipulator = new i.ModelManipulator(this.model, this.routingModel, this.permissionsProvider, this.shapeDescriptionManager), this.modelManipulator.onModelChanged.add(this.permissionsProvider), this.history = new u.History(this.modelManipulator, this), this.barManager = new p.BarManager(this), this.view = new g.ViewController(this.settings, this.barManager), this.commandManager = new r.CommandManager(this), this.eventManager = new s.EventManager(this), this.settings.onReadOnlyChanged.add(this.eventManager.mouseHandler), this.settings.onReadOnlyChanged.add(this.eventManager.visualizersManager), this.selection.onChanged.add(this.barManager), this.selection.onChanged.add(this.apiController), this.selection.onChanged.add(this.permissionsProvider), this.modelManipulator.commitItemsCreateChanges(), this.history.onChanged.add(this), this.toolboxManager = new v.ToolboxManager(this.shapeDescriptionManager), this.settings.onConnectorRoutingModeChanged.add(this.routingModel), S.ImageCache.instance.onReadyStateChanged.add(this);
            }
            return Object.defineProperty(t.prototype, "operationSettings", {
              get: function () {
                return this.permissionsProvider.operationSettings;
              },
              enumerable: !1,
              configurable: !0
            }), t.prototype.cleanMarkup = function (t) {
              t = t || function (t) {
                _.RenderUtils.removeElement(t);
              }, this.toolboxManager.clean(t), this.barManager.clean(), this.render && (this.settings.onZoomChanged.remove(this.render.view), this.settings.onViewChanged.remove(this.render.page), this.settings.onViewChanged.remove(this.render.view), this.settings.onReadOnlyChanged.remove(this.render), this.settings.onReadOnlyChanged.remove(this.render.selection), this.eventManager.cleanToolboxes(this.settings.onReadOnlyChanged), this.eventManager.onTextInputOperation.remove(this.render.input), this.eventManager.onTextInputOperation.remove(this.render.items), this.eventManager.onTextInputOperation.remove(this.render.selection), this.eventManager.onMouseOperation.remove(this.render.items), this.eventManager.onMouseOperation.remove(this.render.selection), this.eventManager.onMouseOperation.remove(this.render.view), this.eventManager.onMouseOperation.remove(this.render), this.eventManager.onVisualizersUpdate.remove(this.render.selection), this.modelManipulator.onModelSizeChanged.remove(this.render.view), this.modelManipulator.onModelSizeChanged.remove(this.render.page), this.modelManipulator.onModelChanged.remove(this.render.items), this.modelManipulator.onModelChanged.remove(this.render.page), this.modelManipulator.onModelChanged.remove(this.render.selection), this.selection.onChanged.remove(this.render.selection), this.selection.onChanged.remove(this.render.items), this.render.clean(t), this.render = void 0), this.measurer && this.measurer instanceof w.TextMeasurer && this.measurer.clean();
            }, t.prototype.dispose = function () {
              S.ImageCache.instance.onReadyStateChanged.remove(this);
            }, t.prototype.createDocument = function (t, e, n) {
              this.measurer || this.initMeasurer(t), this.render ? this.render.replaceParent(t, e) : (this.render = new h.RenderManager(t, this.eventManager, this.measurer, {
                pageColor: this.model.pageColor,
                modelSize: this.model.size,
                pageLandscape: this.model.pageLandscape,
                pageSize: this.model.pageSize,
                simpleView: this.settings.simpleView,
                readOnly: this.settings.readOnly,
                contextMenuEnabled: this.settings.contextMenuEnabled,
                gridSize: this.settings.gridSize,
                gridVisible: this.settings.showGrid,
                zoomLevel: this.settings.zoomLevel,
                autoZoom: this.settings.autoZoom,
                rectangle: this.model.getRectangle(!0)
              }, this.instanceId, e, n), this.settings.onZoomChanged.add(this.render.view), this.settings.onViewChanged.add(this.render.page), this.settings.onViewChanged.add(this.render.view), this.settings.onReadOnlyChanged.add(this.render), this.settings.onReadOnlyChanged.add(this.render.selection), this.eventManager.onTextInputOperation.add(this.render.input), this.eventManager.onTextInputOperation.add(this.render.items), this.eventManager.onTextInputOperation.add(this.render.selection), this.eventManager.onTextInputOperation.add(this), this.eventManager.onMouseOperation.add(this.render.items), this.eventManager.onMouseOperation.add(this.render.selection), this.eventManager.onMouseOperation.add(this.render.view), this.eventManager.onMouseOperation.add(this.render), this.eventManager.onVisualizersUpdate.add(this.render.selection), this.modelManipulator.onModelSizeChanged.add(this.render.view), this.modelManipulator.onModelSizeChanged.add(this.render.page), this.modelManipulator.onModelChanged.add(this.render.items), this.modelManipulator.onModelChanged.add(this.render.page), this.modelManipulator.onModelChanged.add(this.render.selection), this.selection.onChanged.add(this.render.selection), this.selection.onChanged.add(this.render.items), this.render.update(!1), this.render.onNewModel(this.model.items), this.modelManipulator.commitItemsCreateChanges(), this.view.initialize(this.render.view), this.settings.zoomLevelWasChanged && this.raiseCanvasViewActualZoomChanged(), this.selection.raiseSelectionChanged());
            }, t.prototype.createToolbox = function (t, e, n, o) {
              var i = this.toolboxManager.create(t, this.settings.readOnly, !0, e, n, this.getToolboxAllowedShapeTypes.bind(this), this.instanceId, o);
              this.settings.onReadOnlyChanged.add(i), i.onDragOperation.add(this), i.onDragOperation.add(this.apiController), this.eventManager.registerToolbox(i);
            }, t.prototype.createContextToolbox = function (t, e, n, o, i) {
              this.cleanContextToolbox(), this.contextToolbox = this.toolboxManager.create(t, this.settings.readOnly, !1, e, n, this.getToolboxAllowedShapeTypes.bind(this), this.instanceId, o), this.contextToolbox.onClickOperation.add(this), this.contextToolboxOnClick = i;
            }, t.prototype.getToolboxAllowedShapeTypes = function (t) {
              var e = this,
                n = [];
              return this.permissionsProvider.beginUpdateUI(), t.forEach(function (t) {
                e.permissionsProvider.canAddShapeFromToolbox(t) && n.push(t);
              }), this.permissionsProvider.endUpdateUI(), n;
            }, t.prototype.cleanContextToolbox = function () {
              this.contextToolbox && (this.toolboxManager.clean(void 0, this.contextToolbox), this.contextToolbox = void 0, this.contextToolboxOnClick = void 0);
            }, t.prototype.refreshToolbox = function (t) {
              this.permissionsProvider.clearCache(y.DiagramModelOperation.AddShapeFromToolbox), this.toolboxManager.refresh(t);
            }, t.prototype.applyToolboxFilter = function (t, e) {
              return this.toolboxManager.applyFilter(t, e);
            }, t.prototype.notifyToolboxClick = function (t) {
              this.contextToolboxOnClick && this.contextToolboxOnClick(t);
            }, t.prototype.initMeasurer = function (t) {
              this.measurer = new w.TextMeasurer(t);
            }, t.prototype.onDimensionChanged = function () {
              E.Browser.TouchUI || this.updateLayout(!0);
            }, t.prototype.updateLayout = function (t) {
              void 0 === t && (t = !1), this.render && this.render.update(!t);
            }, t.prototype.captureFocus = function () {
              this.render && this.render.input.captureFocus();
            }, t.prototype.isFocused = function () {
              return !this.render || this.render.input.isFocused();
            }, t.prototype.registerBar = function (t) {
              this.barManager.registerBar(t);
            }, t.prototype.updateBarItemsState = function (t, e) {
              this.barManager.updateBarItemsState(t, e);
            }, t.prototype.getCommand = function (t) {
              return this.commandManager.getCommand(t);
            }, t.prototype.getNativeItemByKey = function (t) {
              var e = this.model.findItem(t);
              return e && this.apiController.createNativeItem(e);
            }, t.prototype.getNativeItemByDataKey = function (t) {
              var e = this.model.findItemByDataKey(t);
              return e && this.apiController.createNativeItem(e);
            }, t.prototype.getNativeItems = function () {
              var t = this;
              return this.model.items.map(function (e) {
                return t.apiController.createNativeItem(e);
              });
            }, t.prototype.getNativeSelectedItems = function () {
              var t = this;
              return this.selection.getKeys().map(function (e) {
                return t.apiController.createNativeItem(t.model.findItem(e));
              });
            }, t.prototype.setSelectedItems = function (t) {
              this.selection.set(t);
            }, t.prototype.scrollToItems = function (t) {
              var e = this,
                n = P.GeometryUtils.getCommonRectangle(t.map(function (t) {
                  return e.model.findItem(t).rectangle;
                }));
              this.view.scrollIntoView(n);
            }, t.prototype.setInitialStyleProperties = function (t) {
              this.selection.inputPosition.setInitialStyleProperties(t);
            }, t.prototype.setInitialTextStyleProperties = function (t) {
              this.selection.inputPosition.setInitialTextStyleProperties(t);
            }, t.prototype.setInitialConnectorProperties = function (t) {
              this.selection.inputPosition.setInitialConnectorProperties(t);
            }, t.prototype.addCustomShapes = function (t) {
              var e = this;
              t.forEach(function (t) {
                t.apiController = e.apiController, t.defaultWidth && (t.defaultWidth = m.ModelUtils.getTwipsValue(e.model.units, t.defaultWidth)), t.defaultHeight && (t.defaultHeight = m.ModelUtils.getTwipsValue(e.model.units, t.defaultHeight)), t.minWidth && (t.minWidth = m.ModelUtils.getTwipsValue(e.model.units, t.minWidth)), t.minHeight && (t.minHeight = m.ModelUtils.getTwipsValue(e.model.units, t.minHeight)), t.maxWidth && (t.maxWidth = m.ModelUtils.getTwipsValue(e.model.units, t.maxWidth)), t.maxHeight && (t.maxHeight = m.ModelUtils.getTwipsValue(e.model.units, t.maxHeight)), e.shapeDescriptionManager.registerCustomShape(t);
              });
            }, t.prototype.removeCustomShapes = function (t) {
              var e = this;
              t.forEach(function (t) {
                e.shapeDescriptionManager.unregisterCustomShape(t);
              });
            }, t.prototype.removeAllCustomShapes = function () {
              this.shapeDescriptionManager.unregisterAllCustomShapes();
            }, t.prototype.importModel = function (t) {
              t.units = this.model.units, this.model = t, this.model.initializeKeyCounter(), this.apiController.model = t, this.onImportData();
            }, t.prototype.importItemsData = function () {
              this.onImportData();
            }, t.prototype.onImportData = function () {
              this.render && (this.render.clear(), this.render.onNewModel(this.model.items)), this.permissionsProvider.clearCache(), this.selection.initialize(this.model), this.modelManipulator.initialize(this.model, this.routingModel), this.history.clear(), this.eventManager.initialize(), this.modelManipulator.commitPageChanges(), this.modelManipulator.commitItemsCreateChanges(), this.notifyViewChanged(), this.notifyHistoryChanged();
            }, t.prototype.createDocumentDataSource = function (t, e, n, o, i) {
              return this.documentDataSource = new d.DocumentDataSource(this, t, e, n, o, i), this.apiController.setDataSource(this.documentDataSource), this.documentDataSource;
            }, t.prototype.deleteDocumentDataSource = function () {
              this.apiController.setDataSource(null), delete this.documentDataSource;
            }, t.prototype.applyShapeSizeSettings = function (t) {
              this.settings.applyShapeSizeSettings(t, this.model.units);
            }, t.prototype.applyOperationSettings = function (t) {
              this.permissionsProvider.operationSettings.applySettings(t);
            }, t.prototype.beginUpdateCanvas = function () {
              this.render && (this.render.items.beginUpdate(), this.render.selection.beginUpdate());
            }, t.prototype.endUpdateCanvas = function () {
              this.render && (this.render.items.endUpdate(), this.render.selection.endUpdate());
            }, t.prototype.beginUpdate = function () {
              this.barManager.beginUpdate(), this.apiController.beginUpdate(), this.eventManager.beginUpdate();
            }, t.prototype.endUpdate = function () {
              this.barManager.endUpdate(), this.apiController.endUpdate(), this.eventManager.endUpdate();
            }, t.prototype.notifyEdgeInserted = function (t, e, n) {
              this.onEdgeInserted ? this.onEdgeInserted(t, e, n) : e(t);
            }, t.prototype.notifyEdgeUpdated = function (t, e, n, o) {
              this.onEdgeUpdated ? this.onEdgeUpdated(t, e, n, o) : n(t, e);
            }, t.prototype.notifyEdgeRemoved = function (t, e, n, o) {
              this.onEdgeUpdated ? this.onEdgeRemoved(t, e, n, o) : n(t, e);
            }, t.prototype.notifyNodeInserted = function (t, e, n) {
              this.onNodeInserted ? this.onNodeInserted(t, e, n) : e(t);
            }, t.prototype.notifyNodeUpdated = function (t, e, n, o) {
              this.onNodeUpdated ? this.onNodeUpdated(t, e, n, o) : n(t, e);
            }, t.prototype.notifyNodeRemoved = function (t, e, n, o) {
              this.onNodeRemoved ? this.onNodeRemoved(t, e, n, o) : n(t, e);
            }, t.prototype.reloadInsertedItem = function (t) {
              this.settings.reloadInsertedItemRequired && this.reloadContent(t);
            }, t.prototype.reloadContent = function (t, e, n, o) {
              if (this.documentDataSource) {
                this.isChangesLocked() && (this.reloadContentNeeded = !0);
                var i = !0 === o || void 0 === o && !this.reloadContentNeeded,
                  r = i ? this.reloadContentByExternalChangesParameters : this.reloadContentParameters;
                r.add(t, e, n), this.isChangesLocked() || (this.reloadContentCore(r, i), this.barManager.updateItemsState());
              }
            }, t.prototype.reloadContentCore = function (t, e) {
              var n = this,
                o = t.getData && t.getData(),
                i = this.documentDataSource.refetchData(o && o.nodeDataSource, o && o.edgeDataSource);
              this.beginUpdateCanvas(), this.permissionsProvider.lockPermissions(), this.documentDataSource.updateModelItems(this.history, this.model, this.shapeDescriptionManager, this.selection, new T.DataLayoutParameters(this.settings, t.layoutParameters), e, t.dataKeys, function (t) {
                n.modelManipulator.commitItemUpdateChanges(t);
              }, i, this.settings.snapToGrid, this.settings.gridSize, this.measurer), this.permissionsProvider.unlockPermissions(), this.endUpdateCanvas(), t.clear();
            }, t.prototype.notifyHistoryChanged = function () {
              this.documentDataSource ? (this.shouldUpdateItemsByModel = !0, this.settings.readOnly || this.notifyDataChanges()) : this.raiseOnChanged();
            }, t.prototype.notifyViewChanged = function () {
              this.settings.notifyViewChanged();
            }, t.prototype.notifyToolboxDragStart = function (t) {
              this.render.notifyToolboxDragStart(t), this.onToolboxDragStart && this.onToolboxDragStart();
            }, t.prototype.notifyToolboxDragEnd = function (t) {
              this.render.notifyToolboxDragEnd(t), this.onToolboxDragEnd && this.onToolboxDragEnd();
            }, t.prototype.notifyToolboxDraggingMouseMove = function (t) {
              this.render && this.render.notifyToolboxDraggingMouseMove(t);
            }, t.prototype.notifyTextInputStart = function (t, e, n, o) {
              this.onTextInputStart && this.onTextInputStart();
            }, t.prototype.notifyTextInputEnd = function (t, e) {
              this.onTextInputEnd && this.onTextInputEnd();
            }, t.prototype.notifyTextInputPermissionsCheck = function (t, e) {}, t.prototype.notifyToggleFullscreen = function (t) {
              this.onToggleFullscreen && this.onToggleFullscreen(t);
            }, t.prototype.notifyShowContextMenu = function (t, e) {
              if (this.onShowContextMenu && this.render) {
                var n = void 0;
                if (this.selection.getSelectedItems(!0).length > 0) {
                  var i = m.ModelUtils.createRectangle(this.selection.getSelectedItems(!0)),
                    r = this.render.getEventPointByModelPoint(i.createPosition()),
                    s = this.render.view.getAbsoluteSize(i.createSize());
                  n = {
                    x: r.x,
                    y: r.y,
                    width: s.width,
                    height: s.height
                  };
                }
                if (t) this.contextMenuPosition = new o.Point(t.x, t.y), this.onShowContextMenu(t.x, t.y, n);else if (e) {
                  var a = this.render.getEventPointByModelPoint(e);
                  this.contextMenuPosition = a.clone(), this.onShowContextMenu(a.x, a.y, n);
                }
              }
            }, t.prototype.notifyHideContextMenu = function () {
              this.onHideContextMenu && this.render && this.onHideContextMenu();
            }, t.prototype.notifyShowContextToolbox = function (t, e, n, o, i) {
              if (this.onShowContextToolbox && this.render) {
                var r = this.render.getEventPointByModelPoint(t);
                this.onShowContextToolbox(r.x, r.y, n, o, i), this.render.view.notifyShowContextToolbox();
              }
            }, t.prototype.notifyHideContextToolbox = function () {
              this.onHideContextToolbox && this.render && (this.onHideContextToolbox(), this.render.view.notifyHideContextToolbox()), this.cleanContextToolbox();
            }, t.prototype.notifyShapeDescriptionChanged = function (t) {
              this.modelManipulator.updateShapeDescription(t);
            }, t.prototype.notifyImageCacheReadyStateChanged = function (t) {
              this.barManager.updateItemsState();
            }, t.prototype.raiseCanvasViewActualZoomChanged = function () {
              this.render.view.raiseActualZoomChanged();
            }, t.prototype.notifyRequestOperation = function (t, e) {
              this.requestOperationByDataSource(t, e) || this.onRequestOperation && this.onRequestOperation(t, e);
            }, t.prototype.requestOperationByDataSource = function (t, e) {
              if (!this.documentDataSource || !this.documentDataSource.IsNodeParentIdMode() && !this.documentDataSource.IsNodeItemsMode()) return !1;
              if (t === y.DiagramModelOperation.ChangeConnection) {
                var n = e,
                  o = n.shape && this.model.findItem(n.shape.id),
                  i = n.connector && this.model.findItem(n.connector.id);
                if (!o || !i) return;
                if (n.position === I.ConnectorPosition.End) for (var r = 0; r < o.attachedConnectors.length; r++) {
                  var s = o.attachedConnectors[r];
                  if (s !== i && s.endItem && s.endItem === o) {
                    n.allowed = !1;
                    break;
                  }
                }
                n.allowed && i.beginItem && i.endItem && this.isShapeParent(i.endItem, i.beginItem) && (n.allowed = !1);
              }
              return !e.allowed;
            }, t.prototype.isShapeParent = function (t, e) {
              if (t === e) return !0;
              for (var n = 0; n < t.attachedConnectors.length; n++) {
                var o = t.attachedConnectors[n];
                if (o.beginItem === t && o.endItem) {
                  var i = o.endItem;
                  if (i === e || this.isShapeParent(i, e)) return !0;
                }
              }
              return !1;
            }, t.prototype.isChangesLocked = function () {
              return this.updateLockCount > 0;
            }, t.prototype.beginChangesNotification = function () {
              this.isChangesLocked() || this.changesLockChanged && this.changesLockChanged(!0), this.updateLockCount++;
            }, t.prototype.endChangesNotification = function (t) {
              var e = this;
              this.updateLockCount--, this.isChangesLocked() || (this.changesLockChanged(!1), t || setTimeout(function () {
                e.notifyReloadContent(), e.notifyDataChanges();
              }, 0));
            }, t.prototype.changesLockChanged = function (t) {
              t ? this.lockedReadOnly = this.settings.readOnly : t = this.lockedReadOnly, this.commandManager.getCommand(r.DiagramCommand.ToggleReadOnly).execute(t);
            }, t.prototype.notifyDataChanges = function () {
              this.isChangesLocked() || (this.shouldUpdateItemsByModel && (this.documentDataSource.updateItemsByModel(this.model), this.shouldUpdateItemsByModel = !1), this.raiseOnChanged());
            }, t.prototype.notifyReloadContent = function () {
              this.reloadContentNeeded && (this.reloadContentParameters.empty || this.reloadContentCore(this.reloadContentParameters, !1), this.reloadContentByExternalChangesParameters.empty || this.reloadContentCore(this.reloadContentByExternalChangesParameters, !0), this.reloadContentNeeded = !1);
            }, t.prototype.raiseOnChanged = function () {
              this.onChanged && this.onChanged();
            }, t;
          }();
        e.DiagramControl = D;
      },
      720: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AutoLayoutTreeVerticalBottomToTopCommand = void 0;
        var r = n(9212),
          s = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), e.prototype.createLayoutSettings = function () {
              var e = t.prototype.createLayoutSettings.call(this);
              return e.direction = r.LogicalDirectionKind.Backward, e;
            }, e;
          }(n(1893).AutoLayoutTreeVerticalCommand);
        e.AutoLayoutTreeVerticalBottomToTopCommand = s;
      },
      728: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ChangeConnectorRoutingModeCommand = void 0;
        var r = n(3913),
          s = n(9307),
          a = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), e.prototype.getValue = function () {
              return this.control.settings.connectorRoutingMode;
            }, e.prototype.executeCore = function (t, e) {
              var n = void 0 !== e ? e : s.ConnectorRoutingMode.None;
              return this.control.settings.connectorRoutingMode = n, !0;
            }, e;
          }(r.SimpleCommandBase);
        e.ChangeConnectorRoutingModeCommand = a;
      },
      750: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.DomUtils = void 0;
        var o = n(8424),
          i = n(961),
          r = n(594),
          s = n(4989),
          a = function () {
            function t() {}
            return t.clearInnerHtml = function (t) {
              for (; t.firstChild;) t.removeChild(t.firstChild);
            }, t.setStylePosition = function (t, e) {
              t.left = r.MathUtils.round(e.x, 3) + "px", t.top = r.MathUtils.round(e.y, 3) + "px";
            }, t.setStyleSize = function (t, e) {
              t.width = r.MathUtils.round(e.width, 3) + "px", t.height = r.MathUtils.round(e.height, 3) + "px";
            }, t.setStyleSizeAndPosition = function (e, n) {
              t.setStylePosition(e, n), t.setStyleSize(e, n);
            }, t.hideNode = function (t) {
              if (t) {
                var e = t.parentNode;
                e && e.removeChild(t);
              }
            }, t.isHTMLElementNode = function (t) {
              return t.nodeType === Node.ELEMENT_NODE;
            }, t.isTextNode = function (t) {
              return t.nodeType === Node.TEXT_NODE;
            }, t.isElementNode = function (t) {
              return t.nodeType === Node.ELEMENT_NODE;
            }, t.isHTMLTableRowElement = function (t) {
              return "TR" === t.tagName;
            }, t.isItParent = function (t, e) {
              if (!t || !e) return !1;
              for (; e;) {
                if (e === t) return !0;
                if ("BODY" === e.tagName) return !1;
                e = e.parentNode;
              }
              return !1;
            }, t.getParentByTagName = function (t, e) {
              for (e = e.toUpperCase(); t;) {
                if ("BODY" === t.tagName) return null;
                if (t.tagName === e) return t;
                t = t.parentNode;
              }
              return null;
            }, t.getDocumentScrollTop = function () {
              var e = o.Browser.IE && "hidden" === t.getCurrentStyle(document.body).overflow && document.body.scrollTop > 0;
              return o.Browser.WebKitFamily || o.Browser.Edge || e ? o.Browser.MacOSMobilePlatform ? window.pageYOffset : o.Browser.WebKitFamily && document.documentElement.scrollTop || document.body.scrollTop : document.documentElement.scrollTop;
            }, t.getDocumentScrollLeft = function () {
              var e = o.Browser.IE && "hidden" === t.getCurrentStyle(document.body).overflow && document.body.scrollLeft > 0;
              return o.Browser.Edge || e ? document.body ? document.body.scrollLeft : document.documentElement.scrollLeft : o.Browser.WebKitFamily ? document.documentElement.scrollLeft || document.body.scrollLeft : document.documentElement.scrollLeft;
            }, t.getCurrentStyle = function (t) {
              if (t.currentStyle) return t.currentStyle;
              if (document.defaultView && document.defaultView.getComputedStyle) {
                var e = document.defaultView.getComputedStyle(t, null);
                if (!e && o.Browser.Firefox && window.frameElement) {
                  for (var n = [], r = window.frameElement; !(e = document.defaultView.getComputedStyle(t, null));) n.push([r, r.style.display]), r.style.setProperty("display", "block", "important"), r = "BODY" === r.tagName ? r.ownerDocument.defaultView.frameElement : r.parentNode;
                  e = function (t) {
                    if ("object" != typeof t || !i.isDefined(t)) return t;
                    var e = {};
                    for (var n in t) e[n] = t[n];
                    return e;
                  }(e);
                  for (var s = void 0, a = 0; s = n[a]; a++) s[0].style.display = s[1];
                  document.body.offsetWidth;
                }
                return e;
              }
              return window.getComputedStyle(t, null);
            }, t.setFocus = function (t) {
              function e() {
                try {
                  t.focus(), o.Browser.IE && document.activeElement !== t && t.focus();
                } catch (t) {}
              }
              o.Browser.MacOSMobilePlatform ? e() : setTimeout(function () {
                e();
              }, 100);
            }, t.hasClassName = function (t, e) {
              try {
                var n = e.split(" "),
                  o = t.classList;
                if (o) {
                  for (var i = n.length - 1; i >= 0; i--) if (!o.contains(n[i])) return !1;
                } else {
                  var r = t.getAttribute && t.getAttribute("class");
                  if (!r) return !1;
                  var s = r.split(" ");
                  for (i = n.length - 1; i >= 0; i--) if (s.indexOf(n[i]) < 0) return !1;
                }
                return !0;
              } catch (t) {
                return !1;
              }
            }, t.addClassName = function (e, n) {
              if (!t.hasClassName(e, n)) {
                var o = e.getAttribute && e.getAttribute("class");
                e.setAttribute("class", "" === o ? n : o + " " + n);
              }
            }, t.removeClassName = function (t, e) {
              var n = " " + (t.getAttribute && t.getAttribute("class")) + " ",
                o = n.replace(" " + e + " ", " ");
              n.length !== o.length && t.setAttribute("class", s.StringUtils.trim(o));
            }, t.toggleClassName = function (e, n, o) {
              void 0 === o ? t.hasClassName(e, n) ? t.removeClassName(e, n) : t.addClassName(e, n) : o ? t.addClassName(e, n) : t.removeClassName(e, n);
            }, t.pxToInt = function (t) {
              return c(t, parseInt);
            }, t.pxToFloat = function (t) {
              return c(t, parseFloat);
            }, t.getAbsolutePositionY = function (e) {
              function n(e) {
                return Math.round(e.getBoundingClientRect().top + t.getDocumentScrollTop());
              }
              return e ? o.Browser.IE ? function (e) {
                return o.Browser.IE && null === e.parentNode ? 0 : e.getBoundingClientRect().top + t.getDocumentScrollTop();
              }(e) : o.Browser.Firefox && o.Browser.Version >= 3 ? n(e) : o.Browser.NetscapeFamily && (!o.Browser.Firefox || o.Browser.Version < 3) ? function (e) {
                for (var n = u(e, !1), i = !0; null != e;) {
                  if (n += e.offsetTop, i || null == e.offsetParent || (n -= e.scrollTop), !i && o.Browser.Firefox) {
                    var r = t.getCurrentStyle(e);
                    "DIV" === e.tagName && "visible" !== r.overflow && (n += t.pxToInt(r.borderTopWidth));
                  }
                  i = !1, e = e.offsetParent;
                }
                return n;
              }(e) : o.Browser.WebKitFamily || o.Browser.Edge ? n(e) : function (t) {
                for (var e = 0, n = !0; null != t;) e += t.offsetTop, n || null == t.offsetParent || (e -= t.scrollTop), n = !1, t = t.offsetParent;
                return e;
              }(e) : 0;
            }, t.getAbsolutePositionX = function (e) {
              function n(e) {
                return Math.round(e.getBoundingClientRect().left + t.getDocumentScrollLeft());
              }
              return e ? o.Browser.IE ? function (e) {
                return o.Browser.IE && null === e.parentNode ? 0 : e.getBoundingClientRect().left + t.getDocumentScrollLeft();
              }(e) : o.Browser.Firefox && o.Browser.Version >= 3 ? n(e) : o.Browser.Opera && o.Browser.Version <= 12 ? function (t) {
                for (var e = !0, n = u(t, !0); null != t;) n += t.offsetLeft, e || (n -= t.scrollLeft), t = t.offsetParent, e = !1;
                return n += document.body.scrollLeft;
              }(e) : o.Browser.NetscapeFamily && (!o.Browser.Firefox || o.Browser.Version < 3) ? function (e) {
                for (var n = u(e, !0), i = !0; null != e;) {
                  if (n += e.offsetLeft, i || null == e.offsetParent || (n -= e.scrollLeft), !i && o.Browser.Firefox) {
                    var r = t.getCurrentStyle(e);
                    "DIV" === e.tagName && "visible" !== r.overflow && (n += t.pxToInt(r.borderLeftWidth));
                  }
                  i = !1, e = e.offsetParent;
                }
                return n;
              }(e) : o.Browser.WebKitFamily || o.Browser.Edge ? n(e) : function (t) {
                for (var e = 0, n = !0; null != t;) e += t.offsetLeft, n || null == t.offsetParent || (e -= t.scrollLeft), n = !1, t = t.offsetParent;
                return e;
              }(e) : 0;
            }, t.isInteractiveControl = function (t) {
              return ["A", "INPUT", "SELECT", "OPTION", "TEXTAREA", "BUTTON", "IFRAME"].indexOf(t.tagName) > -1;
            }, t.getClearClientHeight = function (e) {
              return e.offsetHeight - (t.getTopBottomPaddings(e) + t.getVerticalBordersWidth(e));
            }, t.getTopBottomPaddings = function (e, n) {
              var o = n || t.getCurrentStyle(e);
              return t.pxToInt(o.paddingTop) + t.pxToInt(o.paddingBottom);
            }, t.getVerticalBordersWidth = function (e, n) {
              i.isDefined(n) || (n = o.Browser.IE && 9 !== o.Browser.MajorVersion && window.getComputedStyle ? window.getComputedStyle(e) : t.getCurrentStyle(e));
              var r = 0;
              return "none" !== n.borderTopStyle && (r += t.pxToFloat(n.borderTopWidth)), "none" !== n.borderBottomStyle && (r += t.pxToFloat(n.borderBottomWidth)), r;
            }, t.getNodes = function (t, e) {
              for (var n = t.all || t.getElementsByTagName("*"), o = [], i = 0; i < n.length; i++) {
                var r = n[i];
                e(r) && o.push(r);
              }
              return o;
            }, t.getChildNodes = function (t, e) {
              for (var n = t.childNodes, o = [], i = 0; i < n.length; i++) {
                var r = n[i];
                e(r) && o.push(r);
              }
              return o;
            }, t.getNodesByClassName = function (e, n) {
              if (e.querySelectorAll) {
                var o = e.querySelectorAll("." + n),
                  i = [];
                return o.forEach(function (t) {
                  return i.push(t);
                }), i;
              }
              return t.getNodes(e, function (e) {
                return t.hasClassName(e, n);
              });
            }, t.getChildNodesByClassName = function (e, n) {
              return e.querySelectorAll ? function (t, e) {
                for (var n = [], o = 0; o < t.length; o++) {
                  var i = t[o];
                  e(i) && n.push(i);
                }
                return n;
              }(e.querySelectorAll("." + n), function (t) {
                return t.parentNode === e;
              }) : t.getChildNodes(e, function (e) {
                return !!t.isElementNode(e) && i.isNonNullString(e.className) && t.hasClassName(e, e.className);
              });
            }, t.getVerticalScrollBarWidth = function () {
              if (void 0 === t.verticalScrollBarWidth) {
                var e = document.createElement("DIV");
                e.style.cssText = "position: absolute; top: 0px; left: 0px; visibility: hidden; width: 200px; height: 150px; overflow: hidden; box-sizing: content-box", document.body.appendChild(e);
                var n = document.createElement("P");
                e.appendChild(n), n.style.cssText = "width: 100%; height: 200px;";
                var o = n.offsetWidth;
                e.style.overflow = "scroll";
                var i = n.offsetWidth;
                o === i && (i = e.clientWidth), t.verticalScrollBarWidth = o - i, document.body.removeChild(e);
              }
              return t.verticalScrollBarWidth;
            }, t.getHorizontalBordersWidth = function (e, n) {
              i.isDefined(n) || (n = o.Browser.IE && window.getComputedStyle ? window.getComputedStyle(e) : t.getCurrentStyle(e));
              var r = 0;
              return "none" !== n.borderLeftStyle && (r += t.pxToFloat(n.borderLeftWidth)), "none" !== n.borderRightStyle && (r += t.pxToFloat(n.borderRightWidth)), r;
            }, t.getFontFamiliesFromCssString = function (t) {
              return t.split(",").map(function (t) {
                return s.StringUtils.trim(t.replace(/'|"/gi, ""));
              });
            }, t.getInnerText = function (e) {
              if (o.Browser.Safari && o.Browser.MajorVersion <= 5) {
                null === t.html2PlainTextFilter && (t.html2PlainTextFilter = document.createElement("DIV"), t.html2PlainTextFilter.style.width = "0", t.html2PlainTextFilter.style.height = "0", t.html2PlainTextFilter.style.overflow = "visible", t.html2PlainTextFilter.style.display = "none", document.body.appendChild(t.html2PlainTextFilter));
                var n = t.html2PlainTextFilter;
                n.innerHTML = e.innerHTML, n.style.display = "";
                var i = n.innerText;
                return n.style.display = "none", i;
              }
              return o.Browser.NetscapeFamily || o.Browser.WebKitFamily || o.Browser.IE && o.Browser.Version >= 9 || o.Browser.Edge ? e.textContent : e.innerText;
            }, t.html2PlainTextFilter = null, t.verticalScrollBarWidth = void 0, t;
          }();
        function c(t, e) {
          var n = 0;
          if (i.isDefined(t) && "" !== t) try {
            var o = t.indexOf("px");
            o > -1 && (n = e(t.substr(0, o)));
          } catch (t) {}
          return n;
        }
        function u(t, e) {
          for (var n = 0, o = !0; null != t && "BODY" !== t.tagName;) {
            var i = a.getCurrentStyle(t);
            if ("absolute" === i.position) break;
            o || "DIV" !== t.tagName || "" !== i.position && "static" !== i.position || (n -= e ? t.scrollLeft : t.scrollTop), t = t.parentNode, o = !1;
          }
          return n;
        }
        e.DomUtils = a;
      },
      779: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MouseHandler = void 0;
        var o = n(7011),
          i = n(5428),
          r = n(5327),
          s = n(1922),
          a = n(9782),
          c = n(9157),
          u = n(6696),
          p = n(6537),
          h = n(41),
          l = function () {
            function t(t, e, n, o, i, r, s, a, c, u, p) {
              this.history = t, this.selection = e, this.model = n, this.eventManager = o, this.readOnly = i, this.view = r, this.visualizerManager = s, this.contextToolboxHandler = a, this.shapeDescriptionManager = c, this.settings = u, this.permissionsProvider = p, this.finishStateLock = 0, this.initialize(n), this.selection.onChanged.add(this);
            }
            return t.prototype.initialize = function (t) {
              this.model = t, this.allowMultipleSelection = !0, this.allowCopyDiagramItems = !0, this.allowSnapToCellOnDragDiagramItem = !0, this.allowSnapToCellOnDragPoint = !0, this.allowSnapToCellOnResizeShape = !0, this.allowFixedDrag = !0, this.allowZoomOnWheel = !0, this.allowScrollPage = !0, this.shouldScrollPage = !1, this.copyDiagramItemsByCtrlAndShift = !1, this.startScrollingPageByCtrl = !1, this.initializeDefaultState();
            }, t.prototype.initializeDefaultState = function () {
              this.defaultState = this.readOnly ? h.EventUtils.isTouchMode() ? new a.MouseHandlerDefaultReadOnlyTouchState(this, this.history, this.selection, this.model, this.view, this.visualizerManager, this.shapeDescriptionManager, this.settings) : new c.MouseHandlerDefaultReadOnlyState(this, this.history, this.selection, this.model, this.view, this.visualizerManager, this.shapeDescriptionManager, this.settings) : h.EventUtils.isTouchMode() ? new u.MouseHandlerDefaultTouchState(this, this.history, this.selection, this.model, this.view, this.visualizerManager, this.shapeDescriptionManager, this.settings) : new o.MouseHandlerDefaultState(this, this.history, this.selection, this.model, this.view, this.visualizerManager, this.shapeDescriptionManager, this.settings), this.switchToDefaultState();
            }, t.prototype.onMouseDown = function (t) {
              this.mouseDownEvent = t, this.state.onMouseDown(t);
            }, t.prototype.onMouseMove = function (t) {
              this.state.onMouseMove(t);
            }, t.prototype.onMouseUp = function (t) {
              this.state.onMouseUp(t);
            }, t.prototype.onMouseDblClick = function (t) {
              this.state.onMouseDblClick(t);
            }, t.prototype.onMouseClick = function (t) {
              this.state.onMouseClick(t);
            }, t.prototype.onLongTouch = function (t) {
              if (t.touches && !(t.touches.length > 1)) {
                var e = t.source.key;
                void 0 === e ? this.selection.clear() : this.selection.hasKey(e) ? this.selection.remove(e) : this.selection.add(e);
              }
            }, t.prototype.onShortcut = function (t) {
              return this.state.onShortcut(t);
            }, t.prototype.onWheel = function (t) {
              return this.state.onMouseWheel(t);
            }, t.prototype.onDragStart = function (t) {
              this.state.onDragStart(t);
            }, t.prototype.onDragEnd = function (t) {
              this.state.onDragEnd(t);
            }, t.prototype.onKeyDown = function (t) {
              this.state.onKeyDown(t);
            }, t.prototype.onKeyUp = function (t) {
              this.state.onKeyUp(t);
            }, t.prototype.showContextToolbox = function (t, e, n, o, i, r) {
              this.contextToolboxHandler.showContextToolbox(t, e, n, o, i, r);
            }, t.prototype.hideContextToolbox = function (t) {
              this.contextToolboxHandler.hideContextToolbox(t);
            }, t.prototype.canScrollPage = function (t) {
              return this.startScrollingPageByCtrl ? !!this.hasCtrlModifier(t.modifiers) && (!this.copyDiagramItemsByCtrlAndShift || !t.source.isConnector && !t.source.isShape) : this.allowScrollPage && this.shouldScrollPage;
            }, t.prototype.canMultipleSelection = function (t) {
              return this.allowMultipleSelection && this.hasCtrlOrShiftModifier(t.modifiers);
            }, t.prototype.canCopySelectedItems = function (t) {
              return !!this.allowCopyDiagramItems && (this.copyDiagramItemsByCtrlAndShift ? this.hasCtrlAndShiftModifier(t.modifiers) : this.hasAltModifier(t.modifiers));
            }, t.prototype.canCalculateFixedPosition = function (t) {
              return !(!this.allowFixedDrag || !this.hasShiftModifier(t.modifiers)) && (!this.copyDiagramItemsByCtrlAndShift || !this.hasCtrlModifier(t.modifiers));
            }, t.prototype.canStartZoomOnWheel = function (t) {
              return this.allowZoomOnWheel && this.hasCtrlModifier(t.modifiers);
            }, t.prototype.canFinishZoomOnWheel = function (t) {
              return this.allowZoomOnWheel && !this.hasCtrlModifier(t.modifiers);
            }, t.prototype.onStartScrollPageByKeyboard = function (t) {
              this.canStartScrollingPageByKeyboard(t) && (this.raiseDragScrollStart(), this.shouldScrollPage = !0);
            }, t.prototype.onFinishScrollPageByKeyboard = function (t) {
              this.canEndScrollingPageByKeyboard(t) && this.finishScrollingPage();
            }, t.prototype.onFinishScrollPageByMouse = function (t) {
              this.canEndScrollingPage(t) && this.finishScrollingPage();
            }, t.prototype.finishScrollingPage = function () {
              this.shouldScrollPage = !1, this.raiseDragScrollEnd(), this.switchToDefaultState();
            }, t.prototype.hasCtrlOrShiftModifier = function (t) {
              return this.hasCtrlModifier(t) || this.hasShiftModifier(t);
            }, t.prototype.hasCtrlAndShiftModifier = function (t) {
              return this.hasCtrlModifier(t) && this.hasShiftModifier(t);
            }, t.prototype.hasCtrlModifier = function (t) {
              return (t & p.ModifierKey.Ctrl) > 0;
            }, t.prototype.hasAltModifier = function (t) {
              return (t & p.ModifierKey.Alt) > 0;
            }, t.prototype.hasShiftModifier = function (t) {
              return (t & p.ModifierKey.Shift) > 0;
            }, t.prototype.canStartScrollingPageByKeyboard = function (t) {
              return !this.startScrollingPageByCtrl && !this.shouldScrollPage && t.keyCode === p.KeyCode.Space;
            }, t.prototype.canEndScrollingPageByKeyboard = function (t) {
              return !this.startScrollingPageByCtrl && t.keyCode === p.KeyCode.Space;
            }, t.prototype.canEndScrollingPage = function (t) {
              return !this.startScrollingPageByCtrl || this.hasCtrlModifier(t.modifiers);
            }, t.prototype.getSnappedPointOnDragDiagramItem = function (t, e, n, o, i) {
              var s = this.getSnapToCellOnDragDiagramItem(t);
              return new r.Point(this.getSnappedPos(this.getFixedXPosition(t, e, n, i), !0, s), this.getSnappedPos(this.getFixedYPosition(t, e, o, i), !1, s));
            }, t.prototype.getSnappedPointOnDragPoint = function (t, e, n) {
              var o = this.getSnapToCellOnDragPoint(t),
                i = this.getSnappedPos(e.x, !0, o),
                s = this.getSnappedPos(e.y, !1, o);
              return void 0 === n || Math.pow(e.x - i, 2) + Math.pow(e.y - s, 2) < Math.pow(e.x - n.x, 2) + Math.pow(e.y - n.y, 2) ? new r.Point(i, s) : n;
            }, t.prototype.getSnappedOffsetOnDragPoint = function (t, e) {
              var n = this.getSnapToCellOnDragPoint(t);
              return new r.Point(this.getSnappedPos(t.modelPoint.x - e.x, !0, n), this.getSnappedPos(t.modelPoint.y - e.y, !1, n));
            }, t.prototype.lockAspectRatioOnShapeResize = function (t) {
              return this.hasShiftModifier(t.modifiers);
            }, t.prototype.getSnappedPositionOnResizeShape = function (t, e, n) {
              return this.getSnapToCellOnResizeShape(t) ? s.ModelUtils.getSnappedPos(this.model, this.settings.gridSize, e, n) : e;
            }, t.prototype.getSnappedPos = function (t, e, n) {
              return n ? s.ModelUtils.getSnappedPos(this.model, this.settings.gridSize, t, e) : t;
            }, t.prototype.getFixedXPosition = function (t, e, n, o) {
              return n ? e.x : e.x + t.modelPoint.x - o.x;
            }, t.prototype.getFixedYPosition = function (t, e, n, o) {
              return n ? e.y : e.y + t.modelPoint.y - o.y;
            }, t.prototype.getSnapToCellOnDragDiagramItem = function (t) {
              return this.allowSnapToCellOnDragDiagramItem && this.settings.snapToGrid && !this.hasCtrlModifier(t.modifiers);
            }, t.prototype.getSnapToCellOnDragPoint = function (t) {
              return this.allowSnapToCellOnDragPoint && this.settings.snapToGrid && !this.hasCtrlModifier(t.modifiers);
            }, t.prototype.getSnapToCellOnResizeShape = function (t) {
              return this.allowSnapToCellOnResizeShape && this.settings.snapToGrid && !this.hasCtrlModifier(t.modifiers);
            }, t.prototype.tryUpdateModelSize = function (t) {
              this.lockPermissions(), s.ModelUtils.tryUpdateModelRectangle(this.history, t), this.unlockPermissions();
            }, t.prototype.canAddDiagramItemToSelection = function (t) {
              return t.source.key && (t.button === i.MouseButton.Left || t.button === i.MouseButton.Right);
            }, t.prototype.addDiagramItemToSelection = function (t) {
              this.pressedDiagramItemKey = t.source.key, this.pressedDiagramItemInSelection = this.selection.hasKey(this.pressedDiagramItemKey), this.canMultipleSelection(t) ? this.selection.add(t.source.key) : this.changeSingleSelection(t.source.key);
            }, t.prototype.canRemoveDiagramItemToSelection = function (t) {
              return this.pressedDiagramItemKey && t.source.key && this.pressedDiagramItemKey === t.source.key && (t.button === i.MouseButton.Left || t.button === i.MouseButton.Right);
            }, t.prototype.removeDiagramItemFromSelection = function (t, e) {
              this.pressedDiagramItemInSelection && this.selection.getKeys().length > 1 && t === i.MouseButton.Left && this.selection.remove(e);
            }, t.prototype.changeSingleSelection = function (t) {
              this.selection.hasKey(t) || this.selection.set([t]);
            }, t.prototype.notifySelectionChanged = function (t) {
              this.pressedDiagramItemKey && !this.selection.hasKey(this.pressedDiagramItemKey) && (this.pressedDiagramItemKey = void 0, this.pressedDiagramItemInSelection = !1);
            }, t.prototype.raiseDragStart = function (t) {
              this.eventManager.onDocumentDragStart(t);
            }, t.prototype.raiseDragEnd = function (t) {
              this.eventManager.onDocumentDragEnd(t);
            }, t.prototype.raiseDragScrollStart = function () {
              this.eventManager.onDocumentDragScrollStart();
            }, t.prototype.raiseDragScrollEnd = function () {
              this.eventManager.onDocumentDragScrollEnd();
            }, t.prototype.raiseClick = function (t) {
              this.eventManager.onDocumentClick(t);
            }, t.prototype.beginStorePermissions = function () {
              this.permissionsProvider.beginStorePermissions();
            }, t.prototype.endStorePermissions = function () {
              this.permissionsProvider.endStorePermissions();
            }, t.prototype.isStoredPermissionsGranted = function () {
              return this.permissionsProvider.isStoredPermissionsGranted();
            }, t.prototype.lockPermissions = function () {
              this.permissionsProvider.lockPermissions();
            }, t.prototype.unlockPermissions = function () {
              this.permissionsProvider.unlockPermissions();
            }, t.prototype.canPerformChangeConnection = function (t, e) {
              var n = !0;
              return t ? n = this.permissionsProvider.canChangeConnection(t, e.item, e.oldItem, e.position, e.connectionPointIndex) : e.item && (n = this.permissionsProvider.canChangeConnection(void 0, e.item, e.oldItem, e.position, e.connectionPointIndex)), n;
            }, t.prototype.canPerformChangeConnectionOnUpdateUI = function (t, e) {
              this.permissionsProvider.beginUpdateUI();
              var n = this.canPerformChangeConnection(t, e);
              return this.permissionsProvider.endUpdateUI(), n;
            }, t.prototype.canFinishTextEditing = function () {
              return this.eventManager.canFinishTextEditing();
            }, t.prototype.restartState = function () {
              this.state && !this.finishStateLock && (this.finishStateLock++, this.state.finish(), this.finishStateLock--), this.state.start();
            }, t.prototype.switchToDefaultState = function () {
              this.switchState(this.defaultState);
            }, t.prototype.switchState = function (t) {
              this.newState = t, this.state && !this.finishStateLock && (this.finishStateLock++, this.state.finish(), this.finishStateLock--), this.newState && (this.state = this.newState, this.state.start(), this.newState = void 0);
            }, t.prototype.addInteractingItem = function (t, e) {
              this.permissionsProvider.addInteractingItem(t, e);
            }, t.prototype.clearInteractingItems = function () {
              this.permissionsProvider.clearInteractingItems();
            }, t.prototype.notifyReadOnlyChanged = function (t) {
              this.readOnly = t, this.initializeDefaultState();
            }, t.prototype.notifySelectionRectShow = function (t) {}, t.prototype.notifySelectionRectHide = function () {}, t.prototype.notifyResizeInfoShow = function (t, e) {}, t.prototype.notifyResizeInfoHide = function () {}, t.prototype.notifyConnectionPointsShow = function (t, e, n, o) {
              this.state.onConnectionPointsShow(t, e);
            }, t.prototype.notifyConnectionPointsHide = function () {}, t.prototype.notifyConnectionTargetShow = function (t, e) {
              this.state.onConnectionTargetShow(t, e);
            }, t.prototype.notifyConnectionTargetHide = function () {}, t.prototype.notifyContainerTargetShow = function (t, e) {}, t.prototype.notifyContainerTargetHide = function () {}, t.prototype.notifyExtensionLinesShow = function (t) {}, t.prototype.notifyExtensionLinesHide = function () {}, t;
          }();
        e.MouseHandler = l;
      },
      807: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Base64Utils = void 0;
        var o = n(1930),
          i = n(3233),
          r = function () {
            function t() {}
            return t.normalizeToDataUrl = function (e, n) {
              return t.checkPrependDataUrl(e) || (e = t.prependByDataUrl(e, n)), e;
            }, t.prependByDataUrl = function (t, e) {
              return "data:" + e + ";base64," + t;
            }, t.checkPrependDataUrl = function (e) {
              return t.dataUrl.test(e);
            }, t.deleteDataUrlPrefix = function (e) {
              return e.replace(t.dataUrl, "");
            }, t.getUint8Array = function (t) {
              for (var e = (t = atob(t)).length, n = new Uint8Array(e); e--;) n[e] = t.charCodeAt(e);
              return n;
            }, t.fromArrayBuffer = function (t) {
              for (var e = [], n = new Uint8Array(t), o = n.byteLength, i = 0; i < o; i++) e.push(String.fromCharCode(n[i]));
              return window.btoa(e.join(""));
            }, t.getFileFromBase64 = function (e, n, i) {
              void 0 === n && (n = "");
              var r = t.getUint8Array(e);
              return o.FileUtils.createFile([r], n, i);
            }, t.getMimeTypeAsString = function (e) {
              var n = e.match(t.dataUrl);
              return n ? n[1] : null;
            }, t.getKnownMimeType = function (e) {
              var n = e.match(t.dataUrl);
              return n ? i.MimeTypeUtils.stringTypeToType(n[1]) : i.DxMimeType.Unknown;
            }, t.fromBlobAsArrayBuffer = function (e, n) {
              var o = new FileReader();
              o.onloadend = function () {
                return n(t.fromArrayBuffer(o.result));
              }, o.readAsArrayBuffer(e);
            }, t.fromBlobAsDataUrl = function (t, e) {
              var n = new FileReader();
              n.onloadend = function () {
                return e(n.result);
              }, n.readAsDataURL(t);
            }, t.dataUrl = /^data:(.*?)(;(.*?))??(;base64)?,/, t;
          }();
        e.Base64Utils = r;
      },
      815: (t, e) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.EmptyBatchUpdatableObject = e.BatchUpdatableObject = void 0;
        var n = function () {
          function t() {
            this.suspendUpdateCount = 0, this.occurredEvents = 0;
          }
          return t.prototype.beginUpdate = function () {
            0 === this.suspendUpdateCount && this.onUpdateLocked(), this.suspendUpdateCount < 0 ? this.suspendUpdateCount-- : this.suspendUpdateCount++;
          }, t.prototype.endUpdate = function () {
            if (this.suspendUpdateCount < 0 ? this.suspendUpdateCount++ : this.suspendUpdateCount > 0 && this.suspendUpdateCount--, !this.isUpdateLocked()) {
              var t = this.occurredEvents;
              this.occurredEvents = 0, this.onUpdateUnlocked(t);
            }
          }, t.prototype.suspendUpdate = function () {
            if (this.suspendUpdateCount > 0) {
              this.suspendUpdateCount *= -1;
              var t = this.occurredEvents;
              this.occurredEvents = 0, this.onUpdateUnlocked(t);
            }
          }, t.prototype.continueUpdate = function () {
            this.suspendUpdateCount < 0 && (this.suspendUpdateCount *= -1);
          }, t.prototype.isUpdateLocked = function () {
            return this.suspendUpdateCount > 0;
          }, t.prototype.onUpdateLocked = function () {}, t.prototype.registerOccurredEvent = function (t) {
            this.occurredEvents |= t;
          }, t.prototype.resetOccurredEvents = function () {
            this.occurredEvents = 0;
          }, t.prototype.isLocked = function () {
            return 0 !== this.suspendUpdateCount;
          }, t;
        }();
        e.BatchUpdatableObject = n;
        var o = function () {
          function t() {}
          return t.prototype.beginUpdate = function () {}, t.prototype.endUpdate = function () {}, t;
        }();
        e.EmptyBatchUpdatableObject = o;
      },
      820: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.DiagramLocalizationService = void 0;
        var o = n(3255),
          i = n(9254),
          r = function () {
            function t() {}
            return t.unitItems = {}, t.formatUnit = function (t) {
              return t.toString();
            }, t.shapeTexts = {}, t;
          }();
        e.DiagramLocalizationService = r, r.unitItems[i.DiagramUnit.In] = "in", r.unitItems[i.DiagramUnit.Cm] = "cm", r.unitItems[i.DiagramUnit.Px] = "px", r.shapeTexts[o.ShapeTypes.Text] = "Text", r.shapeTexts[o.ShapeTypes.Rectangle] = "Rectangle", r.shapeTexts[o.ShapeTypes.Ellipse] = "Ellipse", r.shapeTexts[o.ShapeTypes.Cross] = "Cross", r.shapeTexts[o.ShapeTypes.Triangle] = "Triangle", r.shapeTexts[o.ShapeTypes.Diamond] = "Diamond", r.shapeTexts[o.ShapeTypes.Heart] = "Heart", r.shapeTexts[o.ShapeTypes.Pentagon] = "Pentagon", r.shapeTexts[o.ShapeTypes.Hexagon] = "Hexagon", r.shapeTexts[o.ShapeTypes.Octagon] = "Octagon", r.shapeTexts[o.ShapeTypes.Star] = "Star", r.shapeTexts[o.ShapeTypes.ArrowLeft] = "Left Arrow", r.shapeTexts[o.ShapeTypes.ArrowUp] = "Up Arrow", r.shapeTexts[o.ShapeTypes.ArrowRight] = "Right Arrow", r.shapeTexts[o.ShapeTypes.ArrowDown] = "Down Arrow", r.shapeTexts[o.ShapeTypes.ArrowUpDown] = "Up Down Arrow", r.shapeTexts[o.ShapeTypes.ArrowLeftRight] = "Left Right Arrow", r.shapeTexts[o.ShapeTypes.Process] = "Process", r.shapeTexts[o.ShapeTypes.Decision] = "Decision", r.shapeTexts[o.ShapeTypes.Terminator] = "Terminator", r.shapeTexts[o.ShapeTypes.PredefinedProcess] = "Predefined Process", r.shapeTexts[o.ShapeTypes.Document] = "Document", r.shapeTexts[o.ShapeTypes.MultipleDocuments] = "Multiple Documents", r.shapeTexts[o.ShapeTypes.ManualInput] = "Manual Input", r.shapeTexts[o.ShapeTypes.Preparation] = "Preparation", r.shapeTexts[o.ShapeTypes.Data] = "Data", r.shapeTexts[o.ShapeTypes.Database] = "Database", r.shapeTexts[o.ShapeTypes.HardDisk] = "Hard Disk", r.shapeTexts[o.ShapeTypes.InternalStorage] = "Internal Storage", r.shapeTexts[o.ShapeTypes.PaperTape] = "Paper Tape", r.shapeTexts[o.ShapeTypes.ManualOperation] = "Manual Operation", r.shapeTexts[o.ShapeTypes.Delay] = "Delay", r.shapeTexts[o.ShapeTypes.StoredData] = "Stored Data", r.shapeTexts[o.ShapeTypes.Display] = "Display", r.shapeTexts[o.ShapeTypes.Merge] = "Merge", r.shapeTexts[o.ShapeTypes.Connector] = "Connector", r.shapeTexts[o.ShapeTypes.Or] = "Or", r.shapeTexts[o.ShapeTypes.SummingJunction] = "Summing Junction", r.shapeTexts[o.ShapeTypes.Container] = "Container", r.shapeTexts[o.ShapeTypes.VerticalContainer] = "Vertical Container", r.shapeTexts[o.ShapeTypes.HorizontalContainer] = "Horizontal Container", r.shapeTexts[o.ShapeTypes.Card] = "Person's Name", r.shapeTexts[o.ShapeTypes.CardWithImageOnLeft] = "Card with Image on the Left", r.shapeTexts[o.ShapeTypes.CardWithImageOnTop] = "Card with Image on the Top", r.shapeTexts[o.ShapeTypes.CardWithImageOnRight] = "Card with Image on the Right";
      },
      868: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MouseHandlerToggleShapeExpandedState = void 0;
        var r = n(9589),
          s = n(946),
          a = n(1922),
          c = function (t) {
            function e(e, n, o, i) {
              var r = t.call(this, e) || this;
              return r.history = n, r.model = o, r.selection = i, r;
            }
            return i(e, t), e.prototype.onMouseUp = function (t) {
              var e = this.model.findShape(t.source.key);
              e && !e.isLocked && (this.history.beginTransaction(), this.history.addAndRedo(new s.ToggleShapeExpandedHistoryItem(e)), a.ModelUtils.updateShapeAttachedConnectors(this.history, this.model, e), a.ModelUtils.updateContainerConnectorsAttachedPoints(this.history, this.model, e), a.ModelUtils.updateSelection(this.history, this.selection), this.handler.tryUpdateModelSize(), this.history.endTransaction(), this.handler.raiseClick([e.key])), this.handler.switchToDefaultState();
            }, e;
          }(r.MouseHandlerStateBase);
        e.MouseHandlerToggleShapeExpandedState = c;
      },
      871: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ToggleAutoZoomCommand = e.ToggleAutoZoomToWidthCommand = e.ToggleAutoZoomToContentCommand = e.SwitchAutoZoomCommand = e.FitToWidthCommand = e.FitToScreenCommand = e.ChangeZoomLevelItemsCommand = e.ChangeZoomLevelTo200Command = e.ChangeZoomLevelTo150Command = e.ChangeZoomLevelTo125Command = e.ChangeZoomLevelTo100Command = e.ChangeZoomLevelTo75Command = e.ChangeZoomLevelTo50Command = e.ChangeZoomLevelTo25Command = e.ChangeZoomLevelInPercentageCommand = e.ChangeZoomLevelCommand = void 0;
        var r = n(3913),
          s = n(9307),
          a = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), e.prototype.isEnabledInReadOnlyMode = function () {
              return !0;
            }, e.prototype.getValue = function () {
              return this.control.view.getZoom();
            }, e.prototype.executeCore = function (t, e) {
              return this.control.settings.zoomLevel = e, this.control.settings.autoZoom = s.AutoZoomMode.Disabled, this.control.updateLayout(!0), !0;
            }, e.prototype.getItems = function () {
              return this.control.settings.zoomLevelItems.map(function (t) {
                return {
                  value: t,
                  text: 100 * t + "%"
                };
              });
            }, e;
          }(r.SimpleCommandBase);
        e.ChangeZoomLevelCommand = a;
        var c = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(e, t), e.prototype.executeCore = function (e, n) {
            return t.prototype.executeCore.call(this, e, n / 100);
          }, e.prototype.getValue = function () {
            return 100 * this.control.view.getZoom();
          }, e;
        }(a);
        e.ChangeZoomLevelInPercentageCommand = c;
        var u = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), e.prototype.getValue = function () {
              return this.control.view.getZoom() === this.exactValue;
            }, e.prototype.executeCore = function (e, n) {
              return t.prototype.executeCore.call(this, e, this.exactValue), !0;
            }, e.prototype.getItems = function () {}, e;
          }(a),
          p = function (t) {
            function e() {
              var e = null !== t && t.apply(this, arguments) || this;
              return e.exactValue = .25, e;
            }
            return i(e, t), e;
          }(u);
        e.ChangeZoomLevelTo25Command = p;
        var h = function (t) {
          function e() {
            var e = null !== t && t.apply(this, arguments) || this;
            return e.exactValue = .5, e;
          }
          return i(e, t), e;
        }(u);
        e.ChangeZoomLevelTo50Command = h;
        var l = function (t) {
          function e() {
            var e = null !== t && t.apply(this, arguments) || this;
            return e.exactValue = .75, e;
          }
          return i(e, t), e;
        }(u);
        e.ChangeZoomLevelTo75Command = l;
        var d = function (t) {
          function e() {
            var e = null !== t && t.apply(this, arguments) || this;
            return e.exactValue = 1, e;
          }
          return i(e, t), e;
        }(u);
        e.ChangeZoomLevelTo100Command = d;
        var f = function (t) {
          function e() {
            var e = null !== t && t.apply(this, arguments) || this;
            return e.exactValue = 1.25, e;
          }
          return i(e, t), e;
        }(u);
        e.ChangeZoomLevelTo125Command = f;
        var y = function (t) {
          function e() {
            var e = null !== t && t.apply(this, arguments) || this;
            return e.exactValue = 1.5, e;
          }
          return i(e, t), e;
        }(u);
        e.ChangeZoomLevelTo150Command = y;
        var g = function (t) {
          function e() {
            var e = null !== t && t.apply(this, arguments) || this;
            return e.exactValue = 2, e;
          }
          return i(e, t), e;
        }(u);
        e.ChangeZoomLevelTo200Command = g;
        var m = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(e, t), e.prototype.isEnabledInReadOnlyMode = function () {
            return !0;
          }, e.prototype.getValue = function () {
            return this.control.settings.zoomLevelItems;
          }, e.prototype.executeCore = function (t, e) {
            return this.control.settings.zoomLevelItems = e, !0;
          }, e;
        }(r.SimpleCommandBase);
        e.ChangeZoomLevelItemsCommand = m;
        var v = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), e.prototype.isEnabled = function () {
              return t.prototype.isEnabled.call(this) && !!this.control.render;
            }, e.prototype.isEnabledInReadOnlyMode = function () {
              return !0;
            }, e.prototype.executeCore = function (t) {
              var e = this.getZoomLevel();
              return this.control.settings.zoomLevel = e, this.control.settings.autoZoom = s.AutoZoomMode.Disabled, this.control.updateLayout(!0), !0;
            }, e;
          }(r.SimpleCommandBase),
          P = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), e.prototype.getZoomLevel = function () {
              return this.control.render.view.getActualAutoZoomLevel(s.AutoZoomMode.FitContent);
            }, e;
          }(v);
        e.FitToScreenCommand = P;
        var C = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(e, t), e.prototype.getZoomLevel = function () {
            return this.control.render.view.getActualAutoZoomLevel(s.AutoZoomMode.FitToWidth);
          }, e;
        }(v);
        e.FitToWidthCommand = C;
        var S = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(e, t), e.prototype.isEnabledInReadOnlyMode = function () {
            return !0;
          }, e.prototype.getValue = function () {
            return this.control.settings.autoZoom;
          }, e.prototype.executeCore = function (t, e) {
            return e = parseInt(e), this.control.settings.autoZoom !== e && (e === s.AutoZoomMode.Disabled && (this.control.settings.zoomLevel = this.control.view.getZoom()), this.control.settings.autoZoom = e, this.control.updateLayout(!0), !0);
          }, e;
        }(r.SimpleCommandBase);
        e.SwitchAutoZoomCommand = S;
        var x = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(e, t), e.prototype.getValue = function () {
            return this.control.settings.autoZoom === s.AutoZoomMode.FitContent;
          }, e.prototype.executeCore = function (e, n) {
            return t.prototype.executeCore.call(this, e, s.AutoZoomMode.FitContent);
          }, e;
        }(S);
        e.ToggleAutoZoomToContentCommand = x;
        var b = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(e, t), e.prototype.getValue = function () {
            return this.control.settings.autoZoom === s.AutoZoomMode.FitToWidth;
          }, e.prototype.executeCore = function (e, n) {
            return t.prototype.executeCore.call(this, e, s.AutoZoomMode.FitToWidth);
          }, e;
        }(S);
        e.ToggleAutoZoomToWidthCommand = b;
        var w = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(e, t), e.prototype.isEnabled = function () {
            return t.prototype.isEnabled.call(this) && !!this.control.render;
          }, e.prototype.isEnabledInReadOnlyMode = function () {
            return !0;
          }, e.prototype.getValue = function () {
            return this.control.settings.autoZoom;
          }, e.prototype.executeCore = function (t, e) {
            var n;
            return n = void 0 === e ? this.control.settings.autoZoom === s.AutoZoomMode.Disabled ? s.AutoZoomMode.FitContent : s.AutoZoomMode.Disabled : e ? s.AutoZoomMode.FitContent : s.AutoZoomMode.Disabled, this.control.settings.autoZoom !== n && (n || (this.control.settings.zoomLevel = this.control.view.getZoom()), this.control.settings.autoZoom = n, this.control.updateLayout(!0), !0);
          }, e;
        }(r.SimpleCommandBase);
        e.ToggleAutoZoomCommand = w;
      },
      877: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.EditShapeImageCommandBase = void 0;
        var r = n(472),
          s = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), e.prototype.isEnabled = function () {
              var e = this.getSelectedShape();
              return t.prototype.isEnabled.call(this) && !!e && !e.locked && e.enableImage && e.allowEditImage;
            }, e.prototype.getValue = function () {
              var t = this.getSelectedShape();
              return t ? t.image.exportUrl : void 0;
            }, e.prototype.getSelectedShape = function () {
              var t = this.control.selection.getSelectedShapes(!0);
              return 1 === t.length ? t[0] : void 0;
            }, e.prototype.executeCore = function (t, e) {
              this.control.history.beginTransaction();
              var n = this.control.selection.getSelectedShapes(!1);
              return this.control.history.addAndRedo(new r.ChangeShapeImageHistoryItem(n[0], e)), this.control.history.endTransaction(), !0;
            }, e;
          }(n(3913).SimpleCommandBase);
        e.EditShapeImageCommandBase = s;
      },
      946: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ToggleShapeExpandedHistoryItem = void 0;
        var r = function (t) {
          function e(e) {
            var n = t.call(this) || this;
            return n.shapeKey = e.key, n.expanded = e.expanded, n;
          }
          return i(e, t), e.prototype.redo = function (t) {
            var e = t.model.findShape(this.shapeKey);
            t.changeShapeExpanded(e, !this.expanded);
          }, e.prototype.undo = function (t) {
            var e = t.model.findShape(this.shapeKey);
            t.changeShapeExpanded(e, this.expanded);
          }, e;
        }(n(2616).HistoryItem);
        e.ToggleShapeExpandedHistoryItem = r;
      },
      961: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.numberToStringHex = e.numberToStringBin = e.isOdd = e.isEven = e.isNonNullString = e.isString = e.isNumber = e.boolToString = e.boolToInt = e.isDefined = void 0;
        var o = n(4989);
        e.isDefined = function (t) {
          return null != t;
        }, e.boolToInt = function (t) {
          return t ? 1 : 0;
        }, e.boolToString = function (t) {
          return t ? "1" : "0";
        }, e.isNumber = function (t) {
          return "number" == typeof t;
        }, e.isString = function (t) {
          return "string" == typeof t;
        }, e.isNonNullString = function (t) {
          return !!t;
        }, e.isEven = function (t) {
          return t % 2 != 0;
        }, e.isOdd = function (t) {
          return t % 2 == 0;
        }, e.numberToStringBin = function (t, e) {
          return void 0 === e && (e = 0), o.StringUtils.padLeft(t.toString(2), e, "0");
        }, e.numberToStringHex = function (t, e) {
          return void 0 === e && (e = 0), o.StringUtils.padLeft(t.toString(16), e, "0");
        };
      },
      1040: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.PermissionsProvider = void 0;
        var o = n(8408),
          i = n(41),
          r = n(5225),
          s = n(6320),
          a = n(1425),
          c = n(3505),
          u = n(1891),
          p = n(5678),
          h = n(1245),
          l = n(5261),
          d = n(3490),
          f = n(564),
          y = n(1675),
          g = n(6547),
          m = n(1387),
          v = n(8128),
          P = n(131),
          C = function () {
            function t(t) {
              this.onRequestOperation = new i.EventDispatcher(), this.cache = [], this.permissionsLockCount = 0, this.requestDeleteItems = {}, this.updateUICount = 0, this.apiController = t, this.operationSettings = new r.ModelOperationSettings(), this.storage = new m.PermissionsProviderStorage();
            }
            return t.prototype.notifySelectionChanged = function (t) {
              this.clearCache();
            }, t.prototype.notifyModelChanged = function (t) {
              this.clearCache();
            }, t.prototype.notifyPageColorChanged = function (t) {}, t.prototype.notifyPageSizeChanged = function (t, e) {}, t.prototype.clearCache = function (t) {
              this.cache = void 0 !== t ? this.cache.filter(function (e) {
                return e.operation !== t;
              }) : [];
            }, t.prototype.canDeleteItems = function (t) {
              var e = this,
                n = !0;
              return t.forEach(function (t) {
                var i;
                t instanceof o.Shape && (i = new c.DeleteShapeRequestedEntity(e.apiController, t)), t instanceof s.Connector && (i = new u.DeleteConnectorRequestedEntity(e.apiController, t)), n = n && e.requestOperation(i);
              }), n;
            }, t.prototype.canAddItems = function (t) {
              var e = this,
                n = !0;
              return t.forEach(function (t) {
                t instanceof o.Shape && (n = n && e.requestOperation(new a.AddShapeRequestedEntity(e.apiController, t))), t instanceof s.Connector && (n = (n = n && e.canChangeConnection(t, t.beginItem, void 0, s.ConnectorPosition.Begin, t.beginConnectionPointIndex)) && e.canChangeConnection(t, t.endItem, void 0, s.ConnectorPosition.End, t.endConnectionPointIndex));
              }), n;
            }, t.prototype.canAddShapeFromToolbox = function (t) {
              return this.requestOperation(new p.AddShapeFromToolboxRequestedEntity(this.apiController, t));
            }, t.prototype.canChangeConnection = function (t, e, n, i, r) {
              return !(!t || !this.requestDeleteItems[t.key]) || !(null == e || e instanceof o.Shape) || this.requestOperation(new h.ChangeConnectionRequestedEntity(this.apiController, t, e, n, i, r));
            }, t.prototype.canChangeConnectorPoints = function (t, e, n) {
              return !(!t || !this.requestDeleteItems[t.key]) || this.requestOperation(new l.ChangeConnectorPointsRequestedEntity(this.apiController, t, e, n));
            }, t.prototype.canChangeShapeText = function (t) {
              return this.requestOperation(new d.BeforeChangeShapeTextRequestedEntity(this.apiController, t));
            }, t.prototype.canChangeConnectorText = function (t, e) {
              return this.requestOperation(new f.BeforeChangeConnectorTextRequestedEntity(this.apiController, t, e));
            }, t.prototype.canApplyShapeTextChange = function (t, e) {
              return this.requestOperation(new y.ChangeShapeTextRequestedEntity(this.apiController, t, e));
            }, t.prototype.canApplyConnectorTextChange = function (t, e, n) {
              return this.requestOperation(new g.ChangeConnectorTextRequestedEntity(this.apiController, t, e, n));
            }, t.prototype.canResizeShapes = function (t) {
              var e = this,
                n = !0;
              return t.forEach(function (t) {
                n = n && e.requestOperation(new v.ResizeShapeRequestedEntity(e.apiController, t.shape, t.oldSize, t.size));
              }), n;
            }, t.prototype.canMoveShapes = function (t) {
              var e = this,
                n = !0;
              return t.forEach(function (t) {
                n = n && e.requestOperation(new P.MoveShapeRequestedEntity(e.apiController, t.shape, t.oldPosition, t.position));
              }), n;
            }, t.prototype.requestOperation = function (t) {
              var e,
                n = !0;
              if (!this.permissionsLockCount && (this.updateUICount > 0 && this.cache.forEach(function (n) {
                n.equals(t) && (e = n);
              }), e ? n = e.allowed : (this.requestOperationCore(t), this.updateUICount > 0 && this.cache.push(t), n = t.allowed), 0 === this.updateUICount && this.storage.needStorePermissions())) return this.storage.storePermission(t.storageKey, n), this.storage.isStoredPermissionsGranted();
              return n;
            }, t.prototype.requestOperationCore = function (t) {
              t.eventArgs.allowed = this.operationSettings[t.settingsKey], t.eventArgs.updateUI = this.updateUICount > 0, t.allowed && this.onRequestOperation.raise("notifyRequestOperation", t.operation, t.eventArgs);
            }, t.prototype.lockPermissions = function () {
              this.permissionsLockCount++;
            }, t.prototype.unlockPermissions = function () {
              this.permissionsLockCount--;
            }, t.prototype.beginDeleteItems = function (t) {
              var e = this;
              t.forEach(function (t) {
                return e.requestDeleteItems[t.key] = t;
              });
            }, t.prototype.endDeleteItems = function () {
              this.requestDeleteItems = {};
            }, t.prototype.beginUpdateUI = function () {
              this.updateUICount++;
            }, t.prototype.endUpdateUI = function () {
              this.updateUICount--;
            }, t.prototype.addInteractingItem = function (t, e) {
              this.storage.addInteractingItem(t, e);
            }, t.prototype.getInteractingItem = function (t, e) {
              return this.storage.getInteractingItem(t, e);
            }, t.prototype.getInteractingItemCount = function () {
              return this.storage.getInteractingItemCount();
            }, t.prototype.clearInteractingItems = function () {
              this.storage.clearInteractingItems();
            }, t.prototype.beginStorePermissions = function () {
              this.storage.beginStorePermissions();
            }, t.prototype.endStorePermissions = function () {
              this.storage.endStorePermissions();
            }, t.prototype.isStoredPermissionsGranted = function () {
              return this.permissionsLockCount > 0 || this.storage.isStoredPermissionsGranted();
            }, t;
          }();
        e.PermissionsProvider = C;
      },
      1065: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.TouchUtils = void 0;
        var o = n(8424),
          i = n(961),
          r = function () {
            function t() {}
            return t.onEventAttachingToDocument = function (e, n) {
              return !o.Browser.MacOSMobilePlatform || !t.isTouchEventName(e) || (t.documentTouchHandlers[e] || (t.documentTouchHandlers[e] = []), t.documentTouchHandlers[e].push(n), t.documentEventAttachingAllowed);
            }, t.isTouchEventName = function (t) {
              return o.Browser.WebKitTouchUI && (t.indexOf("touch") > -1 || t.indexOf("gesture") > -1);
            }, t.isTouchEvent = function (t) {
              return o.Browser.WebKitTouchUI && i.isDefined(t.changedTouches);
            }, t.getEventX = function (t) {
              return o.Browser.IE ? t.pageX : t.changedTouches[0].pageX;
            }, t.getEventY = function (t) {
              return o.Browser.IE ? t.pageY : t.changedTouches[0].pageY;
            }, t.touchMouseDownEventName = o.Browser.WebKitTouchUI ? "touchstart" : o.Browser.Edge && o.Browser.MSTouchUI && window.PointerEvent ? "pointerdown" : "mousedown", t.touchMouseUpEventName = o.Browser.WebKitTouchUI ? "touchend" : o.Browser.Edge && o.Browser.MSTouchUI && window.PointerEvent ? "pointerup" : "mouseup", t.touchMouseMoveEventName = o.Browser.WebKitTouchUI ? "touchmove" : o.Browser.Edge && o.Browser.MSTouchUI && window.PointerEvent ? "pointermove" : "mousemove", t.msTouchDraggableClassName = "dxMSTouchDraggable", t.documentTouchHandlers = {}, t.documentEventAttachingAllowed = !0, t;
          }();
        e.TouchUtils = r;
      },
      1114: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CycleRemover = void 0;
        var o = n(9071),
          i = n(8573),
          r = n(6961),
          s = function () {
            function t() {}
            return t.removeCycles = function (t) {
              var e = this.getFeedbackSet(t);
              return this.reverseEdges(t, e);
            }, t.getFeedbackSet = function (t) {
              for (var e = this, n = {}, o = this.getNonTrivialStronglyConnectedComponents(t); o.length;) o.forEach(function (t) {
                var o = e.getMaxCyclicEdges(t);
                o.forEach(function (t) {
                  return delete n[t.reverse().getHashKey()];
                }), o.forEach(function (t) {
                  return n[t.getHashKey()] = !0;
                });
              }), o = this.getNonTrivialStronglyConnectedComponents(this.reverseEdges(t, n).graph);
              return n;
            }, t.getMaxCyclicEdges = function (t) {
              var e = {},
                n = {},
                o = {},
                s = [],
                a = [],
                c = t.createIterator(i.ConnectionMode.Outgoing);
              c.visitEachEdgeOnce = !1, c.onNode = function (t) {
                n[t.key] = !0;
              }, c.skipNode = function (t) {
                if (n[t.key]) {
                  for (var i = [], r = 0; r < s.length; r++) {
                    var c = s[r];
                    if (void 0 === o[c.key] && (o[c.key] = 0), o[c.key]++, i.push(c), c.from === t.key) break;
                  }
                  a.push(i);
                }
                return n[t.key] || e[t.key];
              }, c.skipEdge = function (t) {
                return !1;
              }, c.onEdge = function (t) {
                s.splice(0, 0, t);
              }, c.onAfterEdge = function (t) {
                s.splice(0, 1);
              }, c.onAllEdges = function (t) {
                e[t.key] = !0, n[t.key] = !1;
              }, c.iterate(t.nodes[0]);
              var u = new r.HashSet([], function (t) {
                return t.key;
              });
              return a.forEach(function (t) {
                u.tryPush(t.reduce(function (t, e) {
                  return o[e.key] > o[t.key] ? e : t;
                }, t[0]));
              }), u.list();
            }, t.reverseEdges = function (t, e) {
              var n = new r.HashSet([], function (t) {
                  return t.getHashKey();
                }),
                i = {},
                s = {};
              return t.edges.forEach(function (t) {
                e[t.getHashKey()] && (t = t.reverse(), i[t.key] = !0), n.tryPush(t) || (s[t.key] = !0, delete i[t.key]);
              }), {
                graph: new o.Graph(t.nodes.map(function (e) {
                  return t.getNode(e);
                }), n.list()),
                reversedEdges: i,
                removedEdges: s
              };
            }, t.getNonTrivialStronglyConnectedComponents = function (t) {
              return this.getStronglyConnectedComponents(t).filter(function (t) {
                return t.edges.length;
              });
            }, t.getStronglyConnectedComponents = function (t) {
              for (var e = this, n = [], o = 0, r = {}, s = {}, a = {}, c = [], u = {}, p = 0; p < t.nodes.length; p++) {
                var h = t.nodes[p],
                  l = t.createIterator(i.ConnectionMode.Outgoing);
                l.visitEachEdgeOnce = !1, l.visitEachNodeOnce = !1, l.onNode = function (t) {
                  u[t.key] = !0, n.push(t), a[t.key] = !0, s[t.key] = o, r[t.key] = o, o++;
                }, l.skipNode = function (t) {
                  return u[t.key];
                }, l.skipEdge = function (t) {
                  var e = u[t.to];
                  return e && a[t.to] && (s[t.from] = Math.min(s[t.from], r[t.to])), e;
                }, l.onAfterEdge = function (t) {
                  s[t.from] = Math.min(s[t.from], s[t.to]);
                }, l.onAllEdges = function (o, i) {
                  i && s[o.key] === r[o.key] && c.push(e.getStronglyConnectedComponent(t, o, n, a));
                }, l.iterate(h);
              }
              return c;
            }, t.getStronglyConnectedComponent = function (t, e, n, r) {
              var s,
                a = {},
                c = [],
                u = [];
              do {
                s = n.pop(), a[s.key] || c.push(s), a[s.key] = !0, r[s.key] = !1;
              } while (s !== e);
              return c.forEach(function (e) {
                var n = t.getAdjacentEdges(e.key, i.ConnectionMode.Outgoing);
                u = u.concat(n.filter(function (t) {
                  return !a[t.key] && a[t.to];
                })), n.forEach(function (t) {
                  return a[t.key] = !0;
                });
              }), new o.Graph(c, u);
            }, t;
          }();
        e.CycleRemover = s;
      },
      1118: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.TextFloodFilterPrimitive = e.TextFilterPrimitive = void 0;
        var r = n(8509),
          s = n(9707),
          a = n(455),
          c = n(9553),
          u = function (t) {
            function e(e, n, o, i, r) {
              void 0 === n && (n = "-0.05"), void 0 === o && (o = "-0.05"), void 0 === i && (i = "1.1"), void 0 === r && (r = "1.1");
              var s = t.call(this, e, n, o, i, r) || this;
              return s.id = e, s.x = n, s.y = o, s.width = i, s.height = r, s;
            }
            return i(e, t), e.prototype.createChildElements = function (t) {
              var e = document.createElementNS(r.svgNS, "feFlood");
              t.appendChild(e);
              var n = document.createElementNS(r.svgNS, "feComposite");
              n.setAttribute("in", "SourceGraphic"), n.setAttribute("operator", "atop"), t.appendChild(n);
            }, e;
          }(s.FilterPrimitive);
        e.TextFilterPrimitive = u;
        var p = function (t) {
          function e(e, n, o, i, r, s) {
            void 0 === o && (o = "-0.05"), void 0 === i && (i = "-0.05"), void 0 === r && (r = "1.1"), void 0 === s && (s = "1.1");
            var a = t.call(this, e, o, i, r, s) || this;
            return a.id = e, a.floodColor = n, a.x = o, a.y = i, a.width = r, a.height = s, a;
          }
          return i(e, t), e.prototype.applyChildrenProperties = function (t) {
            for (var e = void 0, n = 0; e = t.childNodes[n]; n++) if (e.nodeName && "FEFLOOD" === e.nodeName.toUpperCase()) {
              this.prepareFEFloodNode(e);
              break;
            }
          }, e.prototype.prepareFEFloodNode = function (t) {
            var e = c.ColorUtils.colorToHash(this.floodColor);
            t.setAttribute("flood-color", e), t.setAttribute("class", "text-filter-flood"), this.floodColor !== a.DiagramModel.defaultPageColor ? t.style.setProperty("flood-color", e) : t.style.setProperty("flood-color", "");
          }, e;
        }(u);
        e.TextFloodFilterPrimitive = p;
      },
      1188: (t, e) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AStarCalculator = void 0;
        var n = function () {
          function t() {}
          return t.calculate = function (t) {
            if (t) for (var e = this.start(t); e;) e = e(t);
          }, t.start = function (e) {
            return e.start(), e.shouldStartContinue ? t.startContinue : t.finishWithPath;
          }, t.startContinue = function (e) {
            return e.startContinue(), e.shouldFinish ? t.finishWithPath : t.endContinue;
          }, t.endContinue = function (e) {
            return e.endContinue(), e.shouldStartContinue ? t.startContinue : t.finishWithoutPath;
          }, t.finishWithPath = function (t) {
            t.finishWithPath();
          }, t.finishWithoutPath = function (t) {
            t.finishWithoutPath();
          }, t;
        }();
        e.AStarCalculator = n;
      },
      1245: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ChangeConnectionEventArgs = e.ChangeConnectionRequestedEntity = void 0;
        var r = n(5225),
          s = n(5102),
          a = function (t) {
            function e(e, n, o, i, r, s) {
              var a = t.call(this, e) || this;
              return a.connector = n, a.shape = o, a.oldShape = i, a.position = r, a.connectionPointIndex = s, a;
            }
            return i(e, t), Object.defineProperty(e.prototype, "operation", {
              get: function () {
                return r.DiagramModelOperation.ChangeConnection;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.createEventArgs = function () {
              return new c(this.apiController.createNativeConnector(this.connector), this.apiController.createNativeShape(this.shape), this.apiController.createNativeShape(this.oldShape), this.position, this.connectionPointIndex);
            }, Object.defineProperty(e.prototype, "settingsKey", {
              get: function () {
                return "changeConnection";
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "storageKey", {
              get: function () {
                return this.settingsKey + "_" + (this.connector && this.connector.key) + "_" + this.position;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.equals = function (t) {
              if (t instanceof e) {
                var n = !this.connector && !t.connector || this.connector && t.connector && this.connector === t.connector,
                  o = !this.shape && !t.shape || this.shape && t.shape && this.shape === t.shape,
                  i = !this.oldShape && !t.oldShape || this.oldShape && t.oldShape && this.oldShape === t.oldShape;
                return o && i && n && this.position === t.position && this.connectionPointIndex === t.connectionPointIndex;
              }
              return !1;
            }, e;
          }(s.RequestedEntity);
        e.ChangeConnectionRequestedEntity = a;
        var c = function (t) {
          function e(e, n, o, i, r) {
            var s = t.call(this) || this;
            return s.connector = e, s.shape = n, s.oldShape = o, s.position = i, s.connectionPointIndex = r, s;
          }
          return i(e, t), e;
        }(s.PermissionRequestEventArgs);
        e.ChangeConnectionEventArgs = c;
      },
      1280: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ShapeDescription = e.ShapeTextPadding = e.ShapeDefaultSize = e.ShapeMinDimension = e.ShapeDefaultDimension = void 0;
        var o = n(9500),
          i = n(3844),
          r = n(820),
          s = n(5650),
          a = n(94),
          c = n(128),
          u = n(41),
          p = n(4856),
          h = n(4824);
        e.ShapeDefaultDimension = 1440, e.ShapeMinDimension = 360, e.ShapeDefaultSize = new i.Size(e.ShapeDefaultDimension, e.ShapeDefaultDimension), e.ShapeTextPadding = o.UnitConverter.pixelsToTwips(10);
        var l = function () {
          function t(t, n) {
            void 0 === t && (t = e.ShapeDefaultSize.clone()), this.defaultSize = t, this.hasDefaultText = n, this.onChanged = new u.EventDispatcher(), this.connectionPoints = this.createConnectionPoints();
          }
          return Object.defineProperty(t.prototype, "enableText", {
            get: function () {
              return !0;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "allowEditText", {
            get: function () {
              return !0;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "enableImage", {
            get: function () {
              return !1;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "allowEditImage", {
            get: function () {
              return !0;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "hasTemplate", {
            get: function () {
              return !1;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "enableChildren", {
            get: function () {
              return !1;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "minWidth", {
            get: function () {},
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "minHeight", {
            get: function () {},
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "maxWidth", {
            get: function () {},
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "maxHeight", {
            get: function () {},
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "toolboxSize", {
            get: function () {
              return this.defaultSize;
            },
            enumerable: !1,
            configurable: !0
          }), t.prototype.getTitle = function () {
            return r.DiagramLocalizationService.shapeTexts[this.key];
          }, t.prototype.getDefaultText = function () {
            return this.hasDefaultText ? r.DiagramLocalizationService.shapeTexts[this.key] : "";
          }, t.prototype.getDefaultImageUrl = function () {
            return "";
          }, t.prototype.getConnectionPoints = function () {
            return this.connectionPoints;
          }, t.prototype.createConnectionPoints = function () {
            return [new p.ConnectionPoint(.5, 0, h.ConnectionPointSide.North), new p.ConnectionPoint(1, .5, h.ConnectionPointSide.East), new p.ConnectionPoint(.5, 1, h.ConnectionPointSide.South), new p.ConnectionPoint(0, .5, h.ConnectionPointSide.West)];
          }, t.prototype.processConnectionPoint = function (t, e) {}, t.prototype.getConnectionPointIndexForItem = function (t, e) {
            return e;
          }, t.prototype.getConnectionPointIndexForSide = function (t) {
            return t;
          }, t.getConnectionPointSideByGeometry = function (t) {
            return t.x >= t.y && (t.x > 0 || t.y > 0) ? t.x < .5 || 1 - t.x >= t.y ? h.ConnectionPointSide.North : h.ConnectionPointSide.East : t.x > .5 || 1 - t.x <= t.y ? h.ConnectionPointSide.South : h.ConnectionPointSide.West;
          }, t.prototype.createParameters = function (t) {}, t.prototype.normalizeParameters = function (t, e) {}, t.prototype.modifyParameters = function (t, e, n, o) {
            throw Error("Not implemented");
          }, t.prototype.changeParameterValue = function (t, e, n) {
            var o = t.get(e);
            o.value = n(o);
          }, t.prototype.getParameterPoints = function (t) {
            return [];
          }, t.prototype.getExpandedSize = function (t) {
            return t.size;
          }, t.prototype.getCollapsedSize = function (t) {
            return t.size;
          }, t.prototype.getToolboxHeightToWidthRatio = function (t, e) {
            return e / t;
          }, t.prototype.allowResizeHorizontally = function (t) {
            return !0;
          }, t.prototype.allowResizeVertically = function (t) {
            return !0;
          }, t.prototype.createPrimitives = function (t, e, n) {
            var o = [];
            return o = o.concat(this.createShapePrimitives(t, n)), this.enableImage && (o = o.concat(this.createImagePrimitives(t, n))), this.enableText && (o = o.concat(this.createTextPrimitives(t, n))), o;
          }, t.prototype.createImagePrimitives = function (t, e) {
            return [];
          }, t.prototype.createTextPrimitives = function (e, n) {
            if (void 0 === e.text || "" === e.text) return [];
            var o = this.getTextRectangle(e);
            return [new c.TextPrimitive(o.x, o.y, e.text, s.TextOwner.Shape, o.width, o.height, t.textSpacing, e.styleText, !1, this.getTextClipPathId(n), void 0, this.getTextAngle())];
          }, t.prototype.getTextClipPathId = function (t) {}, t.prototype.getTextAngle = function () {
            return c.TextAngle.Angle0deg;
          }, t.prototype.getClientRectangle = function (t) {
            return t.rectangle;
          }, t.prototype.getTextEditRectangle = function (t) {
            return this.getTextRectangle(t);
          }, t.prototype.createSelectorPrimitives = function (t) {
            return [new a.RectanglePrimitive(t.position.x, t.position.y, t.size.width, t.size.height, null, "selector")];
          }, t.prototype.raiseShapeDescriptionChanged = function (t) {
            this.onChanged.raise1(function (e) {
              return e.notifyShapeDescriptionChanged(t);
            });
          }, t.textSpacing = o.UnitConverter.pixelsToTwips(2), t;
        }();
        e.ShapeDescription = l;
      },
      1311: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ClipboardCommand = void 0;
        var r = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(e, t), e.prototype.setClipboardData = function (t) {
            this.control.render && this.control.render.input.setClipboardData(t), e.clipboardData = t;
          }, e.prototype.getClipboardData = function (t) {
            this.control.render && this.isPasteSupportedByBrowser() ? this.control.render.input.getClipboardData(t) : t(e.clipboardData);
          }, e.prototype.isPasteSupportedByBrowser = function () {
            return this.control.render && this.control.render.input.isPasteSupportedByBrowser();
          }, e;
        }(n(3913).SimpleCommandBase);
        e.ClipboardCommand = r;
      },
      1377: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CanvasViewManager = e.CROP_OFFSET = e.CANVAS_SCROLL_PADDING = e.CANVAS_MIN_PADDING = void 0;
        var r = n(5707),
          s = n(9307),
          a = n(41),
          c = n(8601),
          u = n(3844),
          p = n(5327),
          h = n(6709),
          l = n(5654),
          d = n(94),
          f = n(2136),
          y = n(9299),
          g = n(5059),
          m = n(750),
          v = n(9500);
        e.CANVAS_MIN_PADDING = 8, e.CANVAS_SCROLL_PADDING = 18, e.CROP_OFFSET = 40;
        var P = "dxdi-drag-scroll",
          C = "dxdi-drag-item",
          S = function (t) {
            function n(e, n, o, i, r, s, u, h, l) {
              var d = t.call(this, i, h, l) || this;
              return d.svgElement = n, d.paddings = new c.Offsets(0, 0, 0, 0), d.scroll = new p.Point(0, 0), d.crop = c.Offsets.empty(), d.lockAutoZoom = !1, d.autoScrollLocker = 0, d.pageClipPathId = f.RenderUtils.generateSvgElementId("page-clip"), d.pageShadowId = f.RenderUtils.generateSvgElementId("page-shadow"), d.onViewChanged = new a.EventDispatcher(), e.onScroll.add(d), o = o.clone().applyConverter(v.UnitConverter.twipsToPixelsF), d.scrollView = e, d.modelSize = o, d.simpleView = s, d.fixedZoomLevel = i, d.autoZoom = r, d.crop = d.rectangleToCrop(u, o), d.updateElements(o.clone().multiply(i, i), p.Point.zero(), s), d.getOrCreateElement("shadow", new y.ShadowFilterPrimitive(d.pageShadowId), d.svgElement), d.containerSize = e.getSize(), d;
            }
            return i(n, t), n.prototype.adjust = function (t, e) {
              var n;
              t || (t = {
                vertical: !1,
                horizontal: !1
              }, n = c.Offsets.empty()), this.containerSize = this.scrollView.getSize(), this.adjustCore(this.modelSize, this.fixedZoomLevel, this.autoZoom, this.simpleView, this.crop, t, this.containerSize, n, e), this.tryNormalizePaddings();
            }, n.prototype.notifyModelSizeChanged = function (t, e) {
              t = t.clone().applyConverter(v.UnitConverter.twipsToPixelsF);
              var n = {
                horizontal: !e,
                vertical: !e
              };
              this.adjustCore(t, this.fixedZoomLevel, this.autoZoom, this.simpleView, this.crop, n, this.containerSize, e && e.clone().applyConverter(v.UnitConverter.twipsToPixelsF)), this.modelSize = t;
            }, n.prototype.notifyModelRectangleChanged = function (t) {
              var e = this.rectangleToCrop(t, this.modelSize);
              this.crop && this.crop.equals(e) || (this.simpleView && this.adjustCore(this.modelSize, this.fixedZoomLevel, this.autoZoom, this.simpleView, e, {
                horizontal: !1,
                vertical: !1
              }, this.containerSize, c.Offsets.empty()), this.crop = e);
            }, n.prototype.notifySnapPointPositionChanged = function (t) {}, n.prototype.notifyZoomChanged = function (t, e) {
              this.adjustCore(this.modelSize, t, e, this.simpleView, this.crop, {
                horizontal: !1,
                vertical: !1
              }, this.containerSize), this.fixedZoomLevel = t, this.autoZoom = e;
            }, n.prototype.notifyViewChanged = function (t) {
              this.adjustCore(this.modelSize, this.fixedZoomLevel, this.autoZoom, t, this.crop, {
                vertical: !0,
                horizontal: !0
              }, this.containerSize), this.simpleView = t;
            }, n.prototype.notifyGridChanged = function (t, e) {}, n.prototype.notifyDragStart = function (t) {
              this.lockAutoZoom = !0, m.DomUtils.addClassName(this.svgElement, C);
            }, n.prototype.notifyDragEnd = function (t) {
              this.lockAutoZoom = !1, m.DomUtils.removeClassName(this.svgElement, C), this.adjustAfterDragEnd();
            }, n.prototype.adjustAfterDragEnd = function () {
              this.autoZoom && !this.autoZoomLocked && this.adjust({
                horizontal: !0,
                vertical: this.autoZoom === s.AutoZoomMode.FitContent
              }, this.autoZoom === s.AutoZoomMode.FitToWidth);
            }, n.prototype.notifyShowContextToolbox = function () {
              this.autoZoomLocked = !0;
            }, n.prototype.notifyHideContextToolbox = function () {
              this.autoZoomLocked = !1, this.adjustAfterDragEnd();
            }, n.prototype.notifyDragScrollStart = function () {
              m.DomUtils.addClassName(this.svgElement, P);
            }, n.prototype.notifyDragScrollEnd = function () {
              m.DomUtils.removeClassName(this.svgElement, P);
            }, n.prototype.notifyScrollChanged = function (t) {
              this.scroll = t();
            }, n.prototype.checkFitToCanvas = function (t) {
              t = t || this.containerSize;
              var n = this.scrollView.getScrollBarWidth();
              t = t.clone().offset(2 * -e.CANVAS_MIN_PADDING, 2 * -e.CANVAS_MIN_PADDING).nonNegativeSize();
              var o = this.getActualModelSizeWithoutZoom(this.modelSize, this.simpleView, this.crop).clone().multiply(this.actualZoom, this.actualZoom),
                i = this.checkScrollBars(t, n, o, c.Offsets.empty());
              return {
                vertical: (t = t.clone().offset(i.vertical ? -n : 0, i.horizontal ? -n : 0).nonNegativeSize()).height >= o.height,
                horizontal: t.width >= o.width
              };
            }, n.prototype.rectangleToCrop = function (t, e) {
              var n = t.clone().applyConverter(v.UnitConverter.twipsToPixelsF);
              return new c.Offsets(this.correctCrop(n.x), this.correctCrop(e.width - n.right), this.correctCrop(n.y), this.correctCrop(e.height - n.bottom));
            }, n.prototype.correctCrop = function (t) {
              return e.CROP_OFFSET * Math.floor(t / e.CROP_OFFSET);
            }, n.prototype.setActualZoom = function (t) {
              this.actualZoom !== t && (this.actualZoom = t, this.raiseActualZoomChanged());
            }, n.prototype.getActualAutoZoomLevel = function (t) {
              if (t === s.AutoZoomMode.Disabled) return this.actualZoom;
              var e = this.containerSize,
                n = this.scrollView.getScrollBarWidth(),
                o = this.getActualModelSizeWithoutZoom(this.modelSize, this.simpleView, this.crop);
              return this.getActualAutoZoom(e, n, o, t);
            }, n.prototype.getActualZoom = function (t, e, n, o, i) {
              return this.lockAutoZoom ? this.actualZoom : i === s.AutoZoomMode.Disabled ? o : this.getActualAutoZoom(t, e, n, i);
            }, n.prototype.getActualAutoZoom = function (t, n, o, i) {
              return 0 === t.width || 0 === t.height ? 1 : i === s.AutoZoomMode.FitContent ? Math.min((t.width - 2 * e.CANVAS_MIN_PADDING) / o.width, (t.height - 2 * e.CANVAS_MIN_PADDING) / o.height, 1) : Math.min((t.width - 2 * e.CANVAS_MIN_PADDING - n) / o.width, 1);
            }, n.prototype.raiseActualZoomChanged = function () {
              var t = this;
              this.onViewChanged.raise1(function (e) {
                return e.notifyActualZoomChanged(t.actualZoom);
              });
            }, n.prototype.tryNormalizePaddings = function () {
              var t = this.scrollView.getScrollBarWidth(),
                e = this.getActualModelSizeWithoutZoom(this.modelSize, this.simpleView, this.crop).clone().multiply(this.actualZoom, this.actualZoom),
                n = new p.Point(this.paddings.left, this.paddings.top),
                o = new u.Size(this.paddings.right, this.paddings.bottom),
                i = this.getTailSpace(n, this.scroll, e, this.containerSize, t);
              i.equals(o) || this.applyChanges(new c.Offsets(n.x, i.width, n.y, i.height), e, this.simpleView, this.crop.clone().multiply(this.actualZoom));
            }, n.prototype.scrollBy = function (t) {
              var e,
                n,
                o,
                i = this.scroll,
                r = this.containerSize,
                s = this.scrollView.getScrollBarWidth(),
                a = this.getActualModelSizeWithoutZoom(this.modelSize, this.simpleView, this.crop).clone().multiply(this.actualZoom, this.actualZoom),
                h = this.checkScrollBars(r, s, a, this.paddings),
                l = new p.Point(this.paddings.left, this.paddings.top),
                d = new u.Size(this.paddings.right, this.paddings.bottom);
              return i = (e = this.changeScrollByOffset(l, i, d, a, t, r, h)).scroll, t = e.offset, l = (n = this.changeTranslateByOffset(l, d, t, h)).translate, t = n.offset, l = (o = this.cropHiddenHead(l, i)).translate, i = o.scroll, d = this.getTailSpace(l, i, a, r, s), this.applyChanges(new c.Offsets(l.x, d.width, l.y, d.height), a, this.simpleView, this.crop.clone().multiply(this.actualZoom), i), t;
            }, n.prototype.changeScrollByOffset = function (t, e, n, o, i, r, s) {
              var a = e.clone(),
                c = i.clone();
              return i.x && s.horizontal && (a.x -= c.x = -this.getScrollDeltaByOffset(i.x, e.x, t.x + o.width + n.width, r.width, s.vertical)), i.y && s.vertical && (a.y -= c.y = -this.getScrollDeltaByOffset(i.y, e.y, t.y + o.height + n.height, r.height, s.horizontal)), {
                scroll: a,
                offset: c
              };
            }, n.prototype.changeTranslateByOffset = function (t, e, n, o) {
              var i = t.clone(),
                r = n.clone();
              return n.x && !o.horizontal && (i.x += r.x = this.getTranslateDeltaByOffset(n.x, i.x, e.width)), n.y && !o.vertical && (i.y += r.y = this.getTranslateDeltaByOffset(n.y, i.y, e.height)), {
                translate: i,
                offset: r
              };
            }, n.prototype.getScrollDeltaByOffset = function (t, e, n, o, i) {
              if (t > 0) return -Math.min(e, t);
              var r = n - (o - (i ? this.scrollView.getScrollBarWidth() : 0));
              return Math.min(r - e, -t);
            }, n.prototype.getTranslateDeltaByOffset = function (t, n, o) {
              return t ? t < 0 ? -Math.min(n - e.CANVAS_MIN_PADDING, -t) : Math.min(o - e.CANVAS_MIN_PADDING, t) : 0;
            }, n.prototype.getActualModelSizeWithoutZoom = function (t, e, n) {
              return e && n ? t.clone().offset(-n.horizontal, -n.vertical).nonNegativeSize() : t;
            }, n.prototype.setScrollTo = function (t, n) {
              var o = this.containerSize,
                i = this.getVisibileAreaAbsShift(),
                r = t.clone().applyConverter(v.UnitConverter.twipsToPixelsF).clone().multiply(this.actualZoom, this.actualZoom).clone().offset(i.x, i.y),
                s = this.scroll;
              n ? (s.x += r.x - n.x, s.y += r.y - n.y) : (r.x < 0 && (s.x += r.x - e.CANVAS_MIN_PADDING), r.y < 0 && (s.y += r.y - e.CANVAS_MIN_PADDING), r.x > o.width && (s.x += r.x - o.width + e.CANVAS_MIN_PADDING), r.y > o.height && (s.y += r.y - o.height + e.CANVAS_MIN_PADDING)), this.setScroll(s);
            }, n.prototype.scrollIntoView = function (t) {
              var n = this.getVisibileAreaAbsShift(!0);
              t = t.clone().applyConverter(v.UnitConverter.twipsToPixelsF).multiply(this.actualZoom, this.actualZoom).moveRectangle(n.x, n.y);
              var o = this.scroll,
                i = this.containerSize;
              if (!(t.x >= o.x && t.y >= o.y && t.right <= o.x + i.width && t.bottom <= o.y + i.height)) {
                var r = o.clone();
                t.x < o.x ? r.x = t.x - e.CANVAS_SCROLL_PADDING : t.right > o.x + i.width && (r.x = Math.min(t.x - e.CANVAS_SCROLL_PADDING, t.right + e.CANVAS_SCROLL_PADDING - i.width)), t.y < o.y ? r.y = t.y - e.CANVAS_SCROLL_PADDING : r.y = Math.min(t.y - e.CANVAS_SCROLL_PADDING, t.bottom + e.CANVAS_SCROLL_PADDING - i.height), this.setScroll(r);
              }
            }, n.prototype.setScroll = function (t) {
              var e = this,
                n = this.modelSize.clone().multiply(this.actualZoom, this.actualZoom);
              t.x = Math.max(0, Math.min(t.x, n.width + this.paddings.horizontal - this.containerSize.width)), t.y = Math.max(0, Math.min(t.y, n.height + this.paddings.vertical - this.containerSize.height)), this.dom.changeByFunc(null, function () {
                e.scrollView.setScroll(t.x, t.y);
              }), this.scroll = t.clone();
            }, n.prototype.updateElements = function (t, e, n) {
              this.updatePageElement(t, e, n), this.updateCanvasElement(e);
            }, n.prototype.updateCanvasElement = function (t) {
              this.canvasElement = this.getOrCreateElement("dxdi-main", new h.GroupPrimitive([], "dxdi-main", null, null, function (e) {
                e.setAttribute("transform", "translate(".concat(Math.round(t.x), ", ").concat(Math.round(t.y), ")"));
              }), this.svgElement);
            }, n.prototype.updatePageElement = function (t, e, n) {
              if (n) this.updatePageElementCore("", 0, 0, t.width, t.height);else {
                var o = e.x,
                  i = e.y,
                  r = t.width,
                  s = t.height;
                this.createPageShadow(o, i, r, s), this.updatePageElementCore(this.pageClipPathId, Math.round(o), Math.round(i), r, s);
              }
            }, n.prototype.createPageShadow = function (t, e, n, o) {
              this.getOrCreateElement("pageShadowRect", new d.RectanglePrimitive(t.toString(), e.toString(), n.toString(), o.toString(), new g.EmptyStyle({
                filter: f.RenderUtils.getUrlPathById(this.pageShadowId)
              }), "dxdi-page-shadow"), this.svgElement, this.svgElement.firstChild);
            }, n.prototype.updatePageElementCore = function (t, e, n, o, i) {
              this.pageElement = this.getOrCreateElement("page", new h.GroupPrimitive([], "dxdi-page", null, t, function (t) {
                t.setAttribute("transform", "translate(".concat(e, ", ").concat(n, ")"));
              }), this.svgElement), this.getOrCreateElement("pageClip", this.createPageClipPathPrimitive(o, i), this.svgElement);
            }, n.prototype.createPageClipPathPrimitive = function (t, e) {
              return new l.ClipPathPrimitive(this.pageClipPathId, [new d.RectanglePrimitive(0, 0, t.toString(), e.toString())]);
            }, n.prototype.adjustCore = function (t, e, n, o, i, r, s, a, u) {
              var p = this.getActualModelSizeWithoutZoom(t, o, i);
              if (this.lockAutoZoom || !n && a && this.modelSize) this.resizeView(p, this.actualZoom, s, o, i, a || c.Offsets.empty());else {
                var h = this.scrollView.getScrollBarWidth(),
                  l = this.getActualZoom(s, h, p, e, n);
                !n || l !== this.actualZoom || r.horizontal && (r.vertical || u) ? (this.resetView(p, l, s, o, i, r), this.setActualZoom(l)) : this.resizeView(p, l, s, o, i, a || c.Offsets.empty());
              }
            }, n.prototype.resetView = function (t, n, o, i, r, s) {
              var a = t.clone().multiply(n, n),
                u = c.Offsets.fromNumber(e.CANVAS_MIN_PADDING);
              !(s = s || {
                horizontal: !0,
                vertical: !0
              }).horizontal && this.paddings && (u.left = this.paddings.left, u.right = this.paddings.right), !s.vertical && this.paddings && (u.top = this.paddings.top, u.bottom = this.paddings.bottom);
              var p = this.checkScrollBars(o, this.scrollView.getScrollBarWidth(), a, u),
                h = this.scrollView.getScrollBarWidth(),
                l = s.horizontal || s.vertical ? this.scroll : void 0;
              if (s.horizontal) {
                var d = Math.max((o.width - (p.vertical ? h : 0) - a.width) / 2, e.CANVAS_MIN_PADDING);
                u.left = d, u.right = d, l.x = 0;
              }
              if (s.vertical) {
                var f = Math.max((o.height - (p.horizontal ? h : 0) - a.height) / 2, e.CANVAS_MIN_PADDING);
                u.top = f, u.bottom = f, l.y = 0;
              }
              this.applyChanges(u, a, i, r.clone().multiply(n), l);
            }, n.prototype.resizeView = function (t, n, o, i, r, s) {
              var a,
                u,
                h = this.actualZoom,
                l = this.simpleView && this.crop ? this.crop.clone().multiply(h) : c.Offsets.empty(),
                d = t.clone().multiply(n, n);
              s = s.clone().multiply(n);
              var f = i && r ? r.clone().multiply(n) : c.Offsets.empty(),
                y = new p.Point(this.paddings.left, this.paddings.top),
                g = this.scroll;
              y = (a = this.applyOffset(y, g, l, f, s)).translate, g = a.scroll, y = (u = this.cropHiddenHead(y, g)).translate, g = u.scroll;
              var m = this.getTailSpace(y, g, d, o, this.scrollView.getScrollBarWidth());
              if (!i) {
                var v = o.width - e.CANVAS_SCROLL_PADDING,
                  P = o.height - e.CANVAS_SCROLL_PADDING;
                s.left < 0 && y.x > v && (y.x = v, g.x = 0), s.right < 0 && m.width > v && (m.width = v, g.x > d.width && (g.x = d.width)), s.top < 0 && y.y > P && (y.y = P, g.y = 0), s.bottom < 0 && m.height > P && (m.height = P, g.y > d.height && (g.y = d.height));
              }
              var C = new c.Offsets(y.x, m.width, y.y, m.height);
              this.applyChanges(C, d, i, f, g);
            }, n.prototype.applyChanges = function (t, e, n, o, i) {
              var r = this,
                s = new p.Point(t.left, t.top);
              n && o && (s = s.clone().offset(-o.left, -o.top)), this.updateElements(e, s, n), this.setSvgSize(e.width + t.horizontal, e.height + t.vertical), this.onViewChanged.raise1(function (t) {
                return t.notifyViewAdjusted(new p.Point(s.x, s.y));
              }), i && (this.lockAutoScroll(), i && this.dom.changeByFunc(this.scrollView, function (t) {
                t.setScroll(i.x, i.y), r.unlockAutoScroll();
              }), this.scroll = i), this.paddings = t;
            }, n.prototype.isAutoScrollLocked = function () {
              return 0 !== this.autoScrollLocker;
            }, n.prototype.lockAutoScroll = function () {
              this.autoScrollLocker++;
            }, n.prototype.unlockAutoScroll = function () {
              this.autoScrollLocker--;
            }, n.prototype.applyOffset = function (t, n, o, i, r) {
              var s = t.clone(),
                a = n.clone(),
                c = this.getActualOffset(o, i, r);
              return c.left && (s.x = Math.max(e.CANVAS_MIN_PADDING, s.x - c.left), a.x += c.left - (t.x - s.x)), c.top && (s.y = Math.max(e.CANVAS_MIN_PADDING, s.y - c.top), a.y += c.top - (t.y - s.y)), {
                translate: s,
                scroll: a
              };
            }, n.prototype.cropHiddenHead = function (t, n) {
              var o = n.clone(),
                i = t.clone();
              if (o.x && i.x > e.CANVAS_MIN_PADDING) {
                var r = i.x - Math.max(e.CANVAS_MIN_PADDING, i.x - o.x);
                i.x -= r, o.x -= r;
              }
              if (o.y && i.y > e.CANVAS_MIN_PADDING) {
                r = i.y - Math.max(e.CANVAS_MIN_PADDING, i.y - o.y);
                i.y -= r, o.y -= r;
              }
              return {
                translate: i,
                scroll: o
              };
            }, n.prototype.getTailSpace = function (t, n, o, i, r) {
              var s = t.clone(),
                a = n.clone(),
                p = Math.max(i.width + a.x - (s.x + o.width), e.CANVAS_MIN_PADDING),
                h = Math.max(i.height + a.y - (s.y + o.height), e.CANVAS_MIN_PADDING),
                l = this.checkScrollBars(i, r, o, new c.Offsets(s.x, p, s.y, h));
              return l.vertical && (p = Math.max(e.CANVAS_MIN_PADDING, p - r)), l.horizontal && (h = Math.max(e.CANVAS_MIN_PADDING, h - r)), new u.Size(p, h);
            }, n.prototype.getActualOffset = function (t, e, n) {
              return new c.Offsets(-(e.left - t.left) + n.left, -(e.right - t.right) + n.right, -(e.top - t.top) + n.top, -(e.bottom - t.bottom) + n.bottom);
            }, n.prototype.checkScrollBars = function (t, e, n, o) {
              var i = t.width < n.width + o.horizontal,
                r = t.height < n.height + o.vertical;
              return i && !r && (r = t.height - e < n.height + o.vertical), r && !i && (i = t.width - e < n.width + o.horizontal), {
                horizontal: i,
                vertical: r
              };
            }, n.prototype.setSvgSize = function (t, e) {
              t === this.lastWidth && e === this.lastHeight || (this.dom.changeByFunc(this.svgElement, function (n) {
                return f.RenderUtils.updateSvgElementSize(n, t, e);
              }), this.lastWidth = t, this.lastHeight = e);
            }, n.prototype.getVisibileAreaAbsShift = function (t) {
              var e = this.scroll,
                n = this.paddings.clone(),
                o = this.simpleView,
                i = o && this.crop ? this.crop.left * this.actualZoom : 0,
                r = o && this.crop ? this.crop.top * this.actualZoom : 0;
              return new p.Point(n.left - i - (t ? 0 : e.x), n.top - r - (t ? 0 : e.y));
            }, n.prototype.getModelPoint = function (t, e) {
              var n = this.getVisibileAreaAbsShift(),
                o = t.clone().offset(-n.x, -n.y).multiply(1 / this.actualZoom, 1 / this.actualZoom);
              if (e) {
                var i = this.containerSize;
                if (t.x < 0 || t.y < 0 || t.x > i.width || t.y > i.height) return null;
                if (o.x < 0 || o.y < 0) return null;
                if (o.x > this.modelSize.width || o.y > this.modelSize.height) return null;
              }
              return o.clone().applyConverter(v.UnitConverter.pixelsToTwips);
            }, n.prototype.getAbsolutePoint = function (t, e, n) {
              var o = this.getVisibileAreaAbsShift(e),
                i = t.clone().multiply(this.actualZoom, this.actualZoom).clone().applyConverter(v.UnitConverter.twipsToPixelsF).clone().offset(o.x, o.y);
              if (n) {
                if (i.x < 0 || i.y < 0) return null;
                var r = this.containerSize;
                if (i.x > r.width || i.y > r.height) return null;
              }
              return i;
            }, n;
          }(r.CanvasManagerBase);
        e.CanvasViewManager = S;
      },
      1381: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.PaperTapeShapeDescription = void 0;
        var r = n(3190),
          s = n(3255),
          a = n(6208),
          c = n(4824),
          u = n(1280),
          p = n(3844),
          h = function (t) {
            function e() {
              return t.call(this, void 0, !0) || this;
            }
            return i(e, t), Object.defineProperty(e.prototype, "key", {
              get: function () {
                return s.ShapeTypes.PaperTape;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "keepRatioOnAutoSize", {
              get: function () {
                return !1;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.createShapePrimitives = function (t) {
              return this.createDocumentPrimitives(t.rectangle, t.style);
            }, e.prototype.createDocumentPrimitives = function (t, n) {
              var o = t.x,
                i = t.y,
                r = t.right,
                s = t.bottom,
                c = t.width,
                u = t.height,
                p = t.center.x,
                h = u * e.curveOffsetRatio;
              return [].concat([new a.PathPrimitive([new a.PathPrimitiveMoveToCommand(o, i), new a.PathPrimitiveQuadraticCurveToCommand(o + .25 * c, i + 2 * h, p, i + h), new a.PathPrimitiveQuadraticCurveToCommand(r - .25 * c, i - h, r, i + h), new a.PathPrimitiveLineToCommand(r, s), new a.PathPrimitiveQuadraticCurveToCommand(r - .25 * c, s - 2 * h, p, s - h), new a.PathPrimitiveQuadraticCurveToCommand(o + .25 * c, s + h, o, s - h), new a.PathPrimitiveClosePathCommand()], n)]);
            }, e.prototype.processConnectionPoint = function (t, n) {
              var o = t.getConnectionPointSide(n);
              o === c.ConnectionPointSide.North && (n.y += t.size.height * e.curveOffsetRatio), o === c.ConnectionPointSide.South && (n.y -= t.size.height * e.curveOffsetRatio);
            }, e.prototype.getTextRectangle = function (t) {
              var n = t.rectangle;
              return n.clone().inflate(u.ShapeTextPadding, -n.height * e.curveOffsetRatio);
            }, e.prototype.getSizeByText = function (t, n) {
              return new p.Size(t.width + 2 * u.ShapeTextPadding, t.height / (1 - 2 * e.curveOffsetRatio));
            }, e.curveOffsetRatio = .1, e;
          }(r.RectangleShapeDescription);
        e.PaperTapeShapeDescription = h;
      },
      1387: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.PermissionsProviderStorage = void 0;
        var o = n(8408),
          i = n(6320),
          r = function () {
            function t() {
              this.interactingItems = {}, this.storedPermissions = {};
            }
            return t.prototype.addInteractingItem = function (t, e) {
              var n = this.getInteractingItemKey(t, e);
              void 0 === this.interactingItems[n] && (t instanceof o.Shape || t instanceof i.Connector) && (this.interactingItems[n] = t.clone());
            }, t.prototype.getInteractingItem = function (t, e) {
              var n = this.getInteractingItemKey(t, e);
              return this.interactingItems[n];
            }, t.prototype.getInteractingItemCount = function () {
              return Object.keys(this.interactingItems).length;
            }, t.prototype.clearInteractingItems = function () {
              this.interactingItems = {};
            }, t.prototype.getInteractingItemKey = function (t, e) {
              return t.key + (void 0 !== e ? "_" + e.toString() : "");
            }, t.prototype.needStorePermissions = function () {
              return this.storePermissions;
            }, t.prototype.beginStorePermissions = function () {
              this.storePermissions = !0;
            }, t.prototype.endStorePermissions = function () {
              this.storePermissions = !1, this.storedPermissions = {};
            }, t.prototype.isStoredPermissionsGranted = function () {
              for (var t = Object.keys(this.storedPermissions), e = !0, n = 0; n < t.length; n++) e = e && this.storedPermissions[t[n]];
              return e;
            }, t.prototype.storePermission = function (t, e) {
              this.storedPermissions[t] = e;
            }, t;
          }();
        e.PermissionsProviderStorage = r;
      },
      1416: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.DraggingConnector = e.SelectionDragHelper = void 0;
        var o = n(4166),
          i = n(8818),
          r = n(5359),
          s = n(1922),
          a = n(9956),
          c = n(5225),
          u = function () {
            function t(t, e, n, o, i) {
              var r = this;
              this.history = t, this.model = e, this.permissionsProvider = n, this.startPoint = o, this.draggingShapes = [], this.draggingConnectors = [], this.selectedItems = {}, this.draggingConnectorsIndexByKey = {}, i.forEach(function (t) {
                return r.selectedItems[t.key] = t;
              });
            }
            return t.prototype.initDraggingShapes = function (t, e) {
              var n = this;
              this.draggingShapes = t.map(function (t) {
                return new h(t);
              }), e || this.draggingShapes.forEach(function (t) {
                return n.permissionsProvider.addInteractingItem(t.shape, c.DiagramModelOperation.MoveShape);
              });
            }, t.prototype.initDraggingConnectors = function (t, e) {
              var n = this;
              this.draggingConnectors = [], this.draggingConnectorsIndexByKey = {}, t.forEach(function (t) {
                return n.registerConnector(t);
              }), e || this.draggingShapes.forEach(function (t) {
                var e = t.shape.attachedConnectors;
                e && e.forEach(function (t) {
                  n.containsDraggingConnectorByKey(t.key) || n.registerConnector(t);
                });
              }), this.modelConnectorsWithoutBeginItemInfo = this.createModelConnectorsWithoutBeginItemInfo(), this.modelConnectorsWithoutEndItemInfo = this.createModelConnectorsWithoutEndItemInfo();
            }, t.prototype.move = function (t, e, n, i) {
              var r = this;
              if (this.draggingShapes.length) {
                var s = this.draggingShapes.map(function (t) {
                  return t.shape;
                });
                this.draggingShapes.forEach(function (t) {
                  for (var o = t.shape; o.container;) {
                    if (-1 !== s.indexOf(o.container)) return !1;
                    o = o.container;
                  }
                  r.moveShape(t, e, n, i);
                });
                var a = this.draggingShapes[0],
                  c = o.Vector.fromPoints(a.startPosition.clone(), a.shape.position.clone());
                (c.x || c.y) && this.draggingConnectors.forEach(function (e) {
                  return r.moveConnectorCore(e.connector, e.startPoints, e.startRenderContext, c, t);
                });
              } else this.draggingConnectors.forEach(function (n) {
                return r.moveConnector(n, t, e);
              });
            }, t.prototype.containsDraggingConnectorByKey = function (t) {
              return void 0 !== this.draggingConnectorsIndexByKey[t];
            }, t.prototype.onTryUpdateModelSize = function (t, e) {
              this.modelConnectorsWithoutBeginItemInfo.forEach(function (n) {
                n.point.x += t, n.point.y += e;
              }), this.modelConnectorsWithoutEndItemInfo.forEach(function (n) {
                n.point.x += t, n.point.y += e;
              });
            }, t.prototype.finish = function () {
              this.draggingConnectors.forEach(function (t) {
                return t.connector.unlockCreateRenderPoints();
              });
            }, t.prototype.moveConnector = function (t, e, n) {
              var i = t.startPoints,
                r = o.Vector.fromPoints(i[0].clone(), n(i[0]).clone());
              (r.x || r.y) && this.moveConnectorCore(t.connector, i, t.startRenderContext, r, e);
            }, t.prototype.moveConnectorCore = function (t, e, n, o, i) {
              i || s.ModelUtils.canMoveConnector(this.selectedItems, t) ? this.offsetConnector(t, e, n, o) : this.changeConnector(t);
            }, t.prototype.moveShape = function (t, e, n, o) {
              var i = this,
                r = t.shape,
                a = e(t.startPosition);
              s.ModelUtils.setShapePosition(this.history, this.model, r, a), s.ModelUtils.updateMovingShapeConnections(this.history, r, this.modelConnectorsWithoutBeginItemInfo, this.modelConnectorsWithoutEndItemInfo, n, o, function (t) {
                return i.permissionsProvider.addInteractingItem(t);
              }), this.draggingConnectors.filter(function (t) {
                return !!i.selectedItems[t.connector.key];
              }).length || s.ModelUtils.updateShapeAttachedConnectors(this.history, this.model, r);
            }, t.prototype.offsetConnector = function (t, e, n, o) {
              var r = this,
                s = e.map(function (t) {
                  return r.offsetPoint(t, o);
                });
              s[0].equals(t.points[0]) || this.history.addAndRedo(new i.ChangeConnectorPointsHistoryItem(t.key, s, this.offsetRenderContext(n, o)));
            }, t.prototype.offsetRenderContext = function (t, e) {
              var n = this;
              if (void 0 !== t) return new r.ConnectorRenderPointsContext(t.renderPoints.map(function (t) {
                var o = n.offsetPoint(t, e);
                return new a.ConnectorRenderPoint(o.x, o.y, t.pointIndex, t.skipped);
              }), !0, t.actualRoutingMode);
            }, t.prototype.offsetPoint = function (t, e) {
              var n = o.Vector.fromPoints(t, this.startPoint);
              return this.startPoint.clone().offset(e.x - n.x, e.y - n.y);
            }, t.prototype.changeConnector = function (t) {
              s.ModelUtils.tryRemoveConnectorIntermediatePoints(this.history, t), s.ModelUtils.updateConnectorAttachedPoints(this.history, this.model, t);
            }, t.prototype.registerConnector = function (t) {
              this.draggingConnectorsIndexByKey[t.key] = this.draggingConnectors.push(new p(t)) - 1;
            }, t.prototype.createModelConnectorsWithoutBeginItemInfo = function () {
              var t = this;
              return this.model.findConnectorsCore(function (e) {
                return !e.beginItem && !t.containsDraggingConnectorByKey(e.key);
              }).map(function (t) {
                return {
                  connector: t,
                  point: t.points[0].clone()
                };
              });
            }, t.prototype.createModelConnectorsWithoutEndItemInfo = function () {
              var t = this;
              return this.model.findConnectorsCore(function (e) {
                return !e.endItem && !t.containsDraggingConnectorByKey(e.key);
              }).map(function (t) {
                return {
                  connector: t,
                  point: t.points[t.points.length - 1].clone()
                };
              });
            }, t;
          }();
        e.SelectionDragHelper = u;
        var p = function (t) {
          this.connector = t, this.startPoints = t.points.map(function (t) {
            return t.clone();
          }), this.startRenderContext = t.tryCreateRenderPointsContext();
        };
        e.DraggingConnector = p;
        var h = function (t) {
          this.shape = t, this.startPosition = t.position.clone();
        };
      },
      1425: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AddShapeEventArgs = e.AddShapeRequestedEntity = void 0;
        var r = n(5225),
          s = n(5102),
          a = function (t) {
            function e(e, n) {
              var o = t.call(this, e) || this;
              return o.shape = n, o;
            }
            return i(e, t), Object.defineProperty(e.prototype, "operation", {
              get: function () {
                return r.DiagramModelOperation.AddShape;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.createEventArgs = function () {
              return new c(this.apiController.createNativeShape(this.shape), this.apiController.convertPoint(this.shape.position));
            }, Object.defineProperty(e.prototype, "settingsKey", {
              get: function () {
                return "addShape";
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "storageKey", {
              get: function () {
                return this.settingsKey + "_" + (this.shape && this.shape.key);
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.equals = function (t) {
              return t instanceof e && this.shape === t.shape && this.shape.position.equals(t.shape.position);
            }, e;
          }(s.RequestedEntity);
        e.AddShapeRequestedEntity = a;
        var c = function (t) {
          function e(e, n) {
            var o = t.call(this) || this;
            return o.shape = e, o.position = n, o;
          }
          return i(e, t), e;
        }(s.PermissionRequestEventArgs);
        e.AddShapeEventArgs = c;
      },
      1441: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.GraphLayout = void 0;
        var o = n(41),
          i = n(8501),
          r = function () {
            function t() {
              this.nodeKeys = [], this.nodeToLayout = {}, this.edgeToPosition = {};
            }
            return t.prototype.forEachNode = function (t) {
              var e = this;
              this.nodeKeys.forEach(function (n) {
                return t(e.nodeToLayout[n], n);
              });
            }, t.prototype.reduce = function (t, e) {
              var n = this;
              return this.nodeKeys.reduce(function (e, o, i) {
                return t(e, n.nodeToLayout[o], i);
              }, e);
            }, t.prototype.addNode = function (t) {
              if (this.nodeToLayout[t.key]) throw Error("Node layout is already registered");
              return this.nodeKeys.push(t.key), this.nodeToLayout[t.key] = t, t;
            }, t.prototype.hasNode = function (t) {
              return !!this.nodeToLayout[t];
            }, t.prototype.addEdge = function (t) {
              if (this.edgeToPosition[t.key]) throw Error("Edge layout is already registered");
              this.edgeToPosition[t.key] = t;
            }, t.prototype.getRectangle = function (t) {
              var e = this;
              return o.GeometryUtils.getCommonRectangle(this.nodeKeys.map(function (t) {
                return e.nodeToLayout[t].rectangle;
              }));
            }, t.prototype.offsetNodes = function (e, n) {
              var o = this;
              void 0 === e && (e = 0), void 0 === n && (n = 0);
              var r = new t();
              return this.nodeKeys.forEach(function (t) {
                var s = o.nodeToLayout[t];
                r.addNode(new i.NodeLayout(s.info, s.position.clone().offset(e, n)));
              }), r.copyEdges(this), r;
            }, t.prototype.extend = function (t) {
              var e = this;
              t.forEachNode(function (t) {
                return e.addNode(t);
              }), this.copyEdges(t);
            }, t.prototype.copyEdges = function (t) {
              var e = this;
              Object.keys(t.edgeToPosition).forEach(function (n) {
                var o = t.edgeToPosition[n];
                e.addEdge(new i.EdgeLayout(o.key, o.beginIndex, o.endIndex));
              });
            }, t;
          }();
        e.GraphLayout = r;
      },
      1454: (t, e) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SparseIntervalsIterator = void 0;
        var n = function () {
          function t(t) {
            this.sparseIntervals = t, this.intervalIndex = -1;
          }
          return Object.defineProperty(t.prototype, "isStarted", {
            get: function () {
              return !!this.curr;
            },
            enumerable: !1,
            configurable: !0
          }), t.prototype.moveNext = function () {
            return this.curr && this.posInInterval + 1 < this.curr.length ? (this.posInInterval++, this.index++, this.initObject(), !0) : this.intervalIndex + 1 < this.sparseIntervals.numIntervals && (this.intervalIndex++, this.curr = this.sparseIntervals.getInterval(this.intervalIndex), this.curr.length ? (this.posInInterval = 0, this.index = this.curr.start, this.initObject(), !0) : this.moveNext());
          }, t.prototype.movePrev = function () {
            return this.curr && this.posInInterval - 1 >= this.curr.start ? (this.posInInterval--, this.index--, this.initObject(), !0) : (this.isStarted || (this.intervalIndex = this.sparseIntervals.numIntervals), this.intervalIndex - 1 >= 0 && (this.intervalIndex--, this.curr = this.sparseIntervals.getInterval(this.intervalIndex), this.posInInterval = Math.max(this.curr.length - 1, this.curr.start), this.index = this.curr.start, this.initObject(), !0));
          }, t.prototype.initObject = function () {}, t;
        }();
        e.SparseIntervalsIterator = n;
      },
      1493: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SummingJunctionShapeDescription = void 0;
        var r = n(3255),
          s = n(3844),
          a = n(1280),
          c = n(9829),
          u = n(6208),
          p = function (t) {
            function e() {
              var e = t.call(this, !0) || this;
              return e.defaultSize = new s.Size(.5 * a.ShapeDefaultDimension, .5 * a.ShapeDefaultDimension), e;
            }
            return i(e, t), Object.defineProperty(e.prototype, "key", {
              get: function () {
                return r.ShapeTypes.SummingJunction;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "keepRatioOnAutoSize", {
              get: function () {
                return !0;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "enableText", {
              get: function () {
                return !1;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.createShapePrimitives = function (e) {
              var n = e.rectangle,
                o = n.width,
                i = n.height,
                r = n.center,
                s = r.x,
                a = r.y,
                c = o / 2,
                p = i / 2,
                h = Math.atan(p / c),
                l = 1 / Math.sqrt(1 / Math.pow(c, 2) + Math.pow(Math.tan(h), 2) / Math.pow(p, 2)),
                d = l * Math.tan(h);
              return [].concat(t.prototype.createShapePrimitives.call(this, e)).concat([new u.PathPrimitive([new u.PathPrimitiveMoveToCommand(s - l, a - d), new u.PathPrimitiveLineToCommand(s + l, a + d), new u.PathPrimitiveMoveToCommand(s - l, a + d), new u.PathPrimitiveLineToCommand(s + l, a - d)], e.style)]);
            }, e;
          }(c.EllipseShapeDescription);
        e.SummingJunctionShapeDescription = p;
      },
      1530: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.InputPosition = void 0;
        var o = n(5075),
          i = n(2620),
          r = function () {
            function t(t) {
              this.selection = t, this.initialProperties = new o.InputPositionProperties(this.selection), this.defaultProperties = new o.InputPositionProperties(this.selection, this.initialProperties, !0), this.currentProperties = new o.InputPositionProperties(this.selection, this.defaultProperties);
            }
            return t.prototype.initialize = function () {
              this.reset(), this.defaultProperties.reset();
            }, t.prototype.reset = function () {
              this.currentProperties.reset();
            }, t.prototype.getDefaultConnectorProperties = function () {
              return this.defaultProperties.getConnectorProperties();
            }, t.prototype.getDefaultConnectorPropertyValue = function (t) {
              return this.defaultProperties.getConnectorPropertyValue(t);
            }, t.prototype.getCurrentConnectorPropertyValue = function (t) {
              return this.currentProperties.getConnectorPropertyValue(t);
            }, t.prototype.setConnectorPropertyValue = function (t, e) {
              this.currentProperties.setConnectorPropertyValue(t, e), this.selection.isEmpty(!0) && this.defaultProperties.setConnectorPropertyValue(t, e);
            }, t.prototype.setInitialConnectorProperties = function (t) {
              for (var e in this.defaultProperties.reset(), this.currentProperties.reset(), t) Object.prototype.hasOwnProperty.call(t, e) && this.initialProperties.setConnectorPropertyValue(e, t[e]);
            }, t.prototype.getDefaultStyle = function () {
              return this.defaultProperties.getStyle();
            }, t.prototype.getDefaultStylePropertyValue = function (t) {
              return this.defaultProperties.getStylePropertyValue(t);
            }, t.prototype.getDefaultTextStyle = function () {
              return this.defaultProperties.getTextStyle();
            }, t.prototype.getDefaultTextStylePropertyValue = function (t) {
              return this.defaultProperties.getTextStylePropertyValue(t);
            }, t.prototype.getCurrentStylePropertyValue = function (t) {
              return this.currentProperties.getStylePropertyValue(t);
            }, t.prototype.getCurrentTextStylePropertyValue = function (t) {
              return this.currentProperties.getTextStylePropertyValue(t);
            }, t.prototype.setStylePropertyValue = function (t, e) {
              this.currentProperties.setStylePropertyValue(t, e), this.selection.isEmpty(!0) && this.defaultProperties.setStylePropertyValue(t, e);
            }, t.prototype.setTextStylePropertyValue = function (t, e) {
              this.currentProperties.setTextStylePropertyValue(t, e), this.selection.isEmpty(!0) && this.defaultProperties.setTextStylePropertyValue(t, e);
            }, t.prototype.setInitialStyleProperties = function (t) {
              this.defaultProperties.reset(), this.currentProperties.reset();
              var e = "string" == typeof t ? i.Data.cssTextToObject(t) : t;
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && this.initialProperties.setStylePropertyValue(n, e[n]);
            }, t.prototype.setInitialTextStyleProperties = function (t) {
              this.defaultProperties.reset(), this.currentProperties.reset();
              var e = "string" == typeof t ? i.Data.cssTextToObject(t) : t;
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && this.initialProperties.setTextStylePropertyValue(n, e[n]);
            }, t.prototype.notifySelectionChanged = function (t) {
              this.reset();
            }, t;
          }();
        e.InputPosition = r;
      },
      1532: (t, e) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ConnectorPointsCalculatorBase = void 0;
        var n = function (t) {
          this.connector = t;
        };
        e.ConnectorPointsCalculatorBase = n;
      },
      1540: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ChangePagePropertyCommand = void 0;
        var r = n(1922),
          s = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), e.prototype.executeCore = function (t, e) {
              var n = this;
              return this.control.history.beginTransaction(), this.createHistoryItems(e).forEach(function (t) {
                n.control.history.addAndRedo(t);
              }), r.ModelUtils.tryUpdateModelRectangle(this.control.history), this.control.history.endTransaction(), !0;
            }, e.prototype.getItems = function () {
              return null;
            }, e;
          }(n(3913).SimpleCommandBase);
        e.ChangePagePropertyCommand = s;
      },
      1548: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ChangePageColorCommand = void 0;
        var r = n(1540),
          s = n(3158),
          a = n(455),
          c = n(9553),
          u = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), e.prototype.getValue = function () {
              return c.ColorUtils.colorToHash(this.control.model.pageColor);
            }, e.prototype.getDefaultValue = function () {
              return c.ColorUtils.colorToHash(a.DiagramModel.defaultPageColor);
            }, e.prototype.createHistoryItems = function (t) {
              return [new s.ChangePageColorHistoryItem(c.ColorUtils.fromString(t))];
            }, e;
          }(r.ChangePagePropertyCommand);
        e.ChangePageColorCommand = u;
      },
      1550: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ChangeConnectorEndLineEndingCommand = e.ChangeConnectorStartLineEndingCommand = void 0;
        var r = n(2078),
          s = n(4385),
          a = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), e.prototype.getPropertyName = function () {
              return "startLineEnding";
            }, e.prototype.getPropertyDefaultValue = function () {
              return s.ConnectorLineEnding.None;
            }, e;
          }(r.ChangeConnectorPropertyCommand);
        e.ChangeConnectorStartLineEndingCommand = a;
        var c = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(e, t), e.prototype.getPropertyName = function () {
            return "endLineEnding";
          }, e.prototype.getPropertyDefaultValue = function () {
            return s.ConnectorLineEnding.Arrow;
          }, e;
        }(r.ChangeConnectorPropertyCommand);
        e.ChangeConnectorEndLineEndingCommand = c;
      },
      1581: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.DocumentDataSource = e.UpdateNodeKeyRelatedObjectsStackAction = e.UpdateNodeKeyRelatedObjectsStackItem = void 0;
        var r = n(3255),
          s = n(8408),
          a = n(6320),
          c = n(8716),
          u = n(1922),
          p = n(2620),
          h = n(41),
          l = n(4989),
          d = n(594),
          f = function (t, e) {
            this.shape = t, this.nodeObj = e;
          };
        e.UpdateNodeKeyRelatedObjectsStackItem = f;
        var y = function (t, e) {
          this.kind = t, this.nodeObj = e;
        };
        e.UpdateNodeKeyRelatedObjectsStackAction = y;
        var g = function (t) {
          function e(e, n, o, i, r, s) {
            var a = t.call(this, "Document", n, o, i, r, s) || this;
            return a.changesListener = e, a.nodeInsertingLockCount = 0, a.updateNodeKeyRelatedObjectsCount = 0, a.updateNodeKeyRelatedObjectsStack = [], a.updateNodeKeyRelatedObjectsStackActions = [], a;
          }
          return i(e, t), e.prototype.updateItemsByModel = function (t) {
            var e = this;
            this.beginChangesNotification();
            var n = {
              inserts: [],
              updates: [],
              deletes: []
            };
            this.deleteNodes(t, n), t.items.forEach(function (o) {
              o instanceof s.Shape && e.updateNode(t, o, n);
            }), t.items.forEach(function (t) {
              t instanceof s.Shape && e.updateNodeObjectConnectedProperties(t, e.findNode(t.dataKey), e.changesListener);
            }), this.applyDelayedNodeNotifications(n), this.deleteEdges(t), t.items.forEach(function (n) {
              n instanceof a.Connector && e.updateEdge(t, n);
            }), this.endChangesNotification(!1);
          }, e.prototype.applyDelayedNodeNotifications = function (t) {
            var e = this;
            t.deletes.forEach(function (t) {
              e.beginChangesNotification(), e.changesListener.notifyNodeRemoved.call(e.changesListener, t[0], t[1].dataObj, function (t, n) {
                e.endChangesNotification(!1);
              }, function (t) {
                e.endChangesNotification(!1);
              });
            }), t.inserts.forEach(function (t) {
              e.beginChangesNotification(), e.beginNodeInserting(), e.changesListener.notifyNodeInserted.call(e.changesListener, t[1].dataObj, function (n) {
                e.updateNodeObjectKey(t[0], t[1], n), e.endNodeInserting(), e.endChangesNotification(!1);
              }, function (t) {
                e.endNodeInserting(), e.endChangesNotification(!1);
              });
            }), t.updates.forEach(function (t) {
              e.beginChangesNotification(), e.changesListener.notifyNodeUpdated.call(e.changesListener, e.nodeDataImporter.getKey(t[1].dataObj || t[1].key), t[1].dataObj, function (t, n) {
                e.endChangesNotification(!1);
              }, function (t) {
                e.endChangesNotification(!1);
              });
            });
          }, e.prototype.isItemObjectModified = function (t, e, n) {
            var o = n.setLocked && e.locked !== t.locked || n.setZIndex && e.zIndex !== t.zIndex || n.setCustomData && !h.ObjectUtils.compareObjects(e.customData, t.customData);
            if (!o && n.setStyle) {
              var i = t.style.getDefaultInstance();
              t.style.forEach(function (n) {
                t.style[n] !== i[n] && t.style[n] !== (e.style && e.style[n]) && (o = !0);
              });
            }
            if (!o && n.setStyleText) {
              var r = t.styleText.getDefaultInstance();
              t.styleText.forEach(function (n) {
                t.styleText[n] !== r[n] && t.styleText[n] !== (e.styleText && e.styleText[n]) && (o = !0);
              });
            }
            return o;
          }, e.prototype.setDataObjectKeyRelatedProperty = function (t, e, n, o) {
            (o || void 0 === this.autoGeneratedDataKeys[n]) && t(e, n);
          }, e.prototype.updateItemObjectProperties = function (t, e, n) {
            if (n.setCustomData && (t.customData = h.ObjectUtils.cloneObject(e.customData), t.dataObj && void 0 !== t.customData && n.setCustomData(t.dataObj, e.customData)), n.setLocked && (t.locked = e.locked, t.dataObj && void 0 !== t.locked && n.setLocked(t.dataObj, e.locked)), n.setStyle) {
              var o = e.style.toObject();
              t.style = o, t.dataObj && void 0 !== t.style && n.setStyle(t.dataObj, p.Data.objectToCssText(o));
            }
            if (n.setStyleText) {
              var i = e.styleText.toObject();
              t.styleText = i, t.dataObj && void 0 !== t.styleText && n.setStyleText(t.dataObj, p.Data.objectToCssText(i));
            }
            n.setZIndex && (t.zIndex = e.zIndex, t.dataObj && void 0 !== t.zIndex && n.setZIndex(t.dataObj, e.zIndex));
          }, e.prototype.deleteItems = function (t, e, n, o) {
            t.slice().forEach(function (t) {
              if (void 0 !== t.key && null !== t.key && !e(t.key)) {
                var i = n(t),
                  r = i.indexOf(t.dataObj);
                i.splice(r, 1), o(t, r > -1);
              }
            });
          }, e.prototype.updateNode = function (t, e, n) {
            var o = this.findNode(e.dataKey);
            if (o) this.isNodeObjectModified(e, o, t.units) ? (this.updateNodeObjectProperties(e, o, t.units), this.updateNodeObjectConnectedProperties(e, o), n.updates.push([e, o])) : this.updateNodeObjectConnectedProperties(e, o, this.changesListener);else {
              var i = {};
              void 0 !== e.dataKey && null !== e.dataKey && this.nodeDataImporter.setKey(i, e.dataKey), o = this.addNodeInternal(i, e.description.key, e.text), this.nodeDataSource.push(o.dataObj), this.setDataObjectKeyRelatedProperty(this.nodeDataImporter.setKey, i, o.key, this.addInternalKeyOnInsert), this.updateNodeObjectProperties(e, o, t.units), this.updateNodeObjectConnectedProperties(e, o), this.updateNodeObjectKey(e, o, o.dataObj), n.inserts.push([e, o]);
            }
          }, e.prototype.areImageUrlsEqual = function (t, e) {
            return t === e || l.StringUtils.isNullOrEmpty(t) && l.StringUtils.isNullOrEmpty(e);
          }, e.prototype.isNodeObjectModified = function (t, e, n) {
            return this.isItemObjectModified(t, e, this.nodeDataImporter) || e.type !== t.description.key && !(void 0 === e.type && t.description.key === r.ShapeTypes.Rectangle) || !this.compareStrings(e.text, t.text) || this.nodeDataImporter.setImage && !this.areImageUrlsEqual(e.image, t.image.actualUrl) || this.nodeDataImporter.setLeft && !d.MathUtils.numberCloseTo(e.left, u.ModelUtils.getlUnitValue(n, t.position.x)) || this.nodeDataImporter.setTop && !d.MathUtils.numberCloseTo(e.top, u.ModelUtils.getlUnitValue(n, t.position.y)) || this.nodeDataImporter.setWidth && !d.MathUtils.numberCloseTo(e.width, u.ModelUtils.getlUnitValue(n, t.size.width)) || this.nodeDataImporter.setHeight && !d.MathUtils.numberCloseTo(e.height, u.ModelUtils.getlUnitValue(n, t.size.height));
          }, e.prototype.updateNodeObjectProperties = function (t, e, n) {
            if (this.updateItemObjectProperties(e, t, this.nodeDataImporter), this.nodeDataImporter.setType && (e.type = t.description.key, this.nodeDataImporter.setType(e.dataObj, t.description.key)), this.nodeDataImporter.setText && (e.text = t.text, this.nodeDataImporter.setText(e.dataObj, t.text)), this.nodeDataImporter.setImage && (e.image = t.image.actualUrl, this.nodeDataImporter.setImage(e.dataObj, void 0 === t.image.actualUrl ? null : t.image.actualUrl)), this.nodeDataImporter.setLeft) {
              var o = u.ModelUtils.getlUnitValue(n, t.position.x);
              e.left = o, this.nodeDataImporter.setLeft(e.dataObj, o);
            }
            if (this.nodeDataImporter.setTop) {
              var i = u.ModelUtils.getlUnitValue(n, t.position.y);
              e.top = i, this.nodeDataImporter.setTop(e.dataObj, i);
            }
            if (this.nodeDataImporter.setWidth) {
              var r = u.ModelUtils.getlUnitValue(n, t.size.width);
              e.width = r, this.nodeDataImporter.setWidth(e.dataObj, r);
            }
            if (this.nodeDataImporter.setHeight) {
              var s = u.ModelUtils.getlUnitValue(n, t.size.height);
              e.height = s, this.nodeDataImporter.setHeight(e.dataObj, s);
            }
          }, e.prototype.updateNodeObjectConnectedProperties = function (t, e, n) {
            if (this.useNodeParentId && void 0 !== this.nodeDataImporter.setParentKey) {
              var o = this.getParentItemKey(t),
                i = this.findNode(o);
              this.updateNodeObjectParentKey(e, i, n);
            }
            if (this.useNodeContainerId && void 0 !== this.nodeDataImporter.setContainerKey) {
              var r = this.getContainerShapeKey(t),
                s = this.findNode(r);
              this.updateNodeObjectContainerKey(e, s, n);
            }
            if (this.useNodeItems && void 0 !== this.nodeDataImporter.setItems) {
              o = this.getParentItemKey(t), i = this.findNode(o);
              this.updateNodeObjectItems(e, i, n);
            }
            if (this.useNodeChildren && void 0 !== this.nodeDataImporter.setChildren) {
              r = this.getContainerShapeKey(t), s = this.findNode(r);
              this.updateNodeObjectChildren(e, s, n);
            }
          }, e.prototype.IsNodeParentIdMode = function () {
            return this.useNodeParentId && void 0 !== this.nodeDataImporter.setParentKey;
          }, e.prototype.IsNodeItemsMode = function () {
            return this.useNodeItems && void 0 !== this.nodeDataImporter.setItems;
          }, e.prototype.updateNodeObjectParentKey = function (t, e, n) {
            var o = this.nodeDataImporter.getParentKey(t.dataObj),
              i = e ? this.nodeDataImporter.getKey(e.dataObj) : void 0;
            o === i || this.isRootParentKey(o) && this.isRootParentKey(i) || (this.setDataObjectKeyRelatedProperty(this.nodeDataImporter.setParentKey, t.dataObj, i, !1), n && (this.isInUpdateNodeKeyRelatedObjects() ? this.addToUpdateNodeKeyRelatedObjectsStackAction("shape", t) : this.updateNodeObjectContainerOrParentKeyInternal(t, n)));
          }, e.prototype.updateNodeObjectParentKeyInternal = function (t, e) {
            var n = this;
            this.beginChangesNotification(), e.notifyNodeUpdated.call(e, this.nodeDataImporter.getKey(t.dataObj) || t.key, t.dataObj, function (t, e) {
              n.endChangesNotification(!1);
            }, function (t) {
              n.endChangesNotification(!1);
            });
          }, e.prototype.updateNodeObjectContainerKey = function (t, e, n) {
            var o = this.nodeDataImporter.getContainerKey(t.dataObj),
              i = e ? this.nodeDataImporter.getKey(e.dataObj) : void 0;
            o === i || this.isRootParentKey(o) && this.isRootParentKey(i) || (this.setDataObjectKeyRelatedProperty(this.nodeDataImporter.setContainerKey, t.dataObj, i, !1), n && (this.isInUpdateNodeKeyRelatedObjects() ? this.addToUpdateNodeKeyRelatedObjectsStackAction("shape", t) : this.updateNodeObjectContainerOrParentKeyInternal(t, n)));
          }, e.prototype.updateNodeObjectContainerOrParentKeyInternal = function (t, e) {
            var n = this;
            this.beginChangesNotification(), e.notifyNodeUpdated.call(e, this.nodeDataImporter.getKey(t.dataObj) || t.key, t.dataObj, function (t, e) {
              n.endChangesNotification(!1);
            }, function (t) {
              n.endChangesNotification(!1);
            });
          }, e.prototype.isRootParentKey = function (t) {
            return null == t || !this.findNode(t);
          }, e.prototype.updateNodeObjectItems = function (t, e, n) {
            var o = this;
            if ((e && t.parentDataObj !== e.dataObj || !e && t.parentDataObj) && (!e || !this.checkNodeCyrcleItems(t.dataObj, e.dataObj))) {
              var i = t.parentDataObj ? this.nodeDataImporter.getItems(t.parentDataObj) : this.nodeDataSource,
                r = i.indexOf(t.dataObj);
              i.splice(r, 1);
              var s = e ? this.nodeDataImporter.getItems(e.dataObj) : this.nodeDataSource;
              s ? s.push(t.dataObj) : this.nodeDataImporter.setItems(e.dataObj, [t.dataObj]), t.parentDataObj = e && e.dataObj, n && (this.beginChangesNotification(), n.notifyNodeUpdated.call(n, this.nodeDataImporter.getKey(t.dataObj) || t.key, t.dataObj, function (t, e) {
                o.endChangesNotification(!1);
              }, function (t) {
                o.endChangesNotification(!1);
              }));
            }
          }, e.prototype.updateNodeObjectChildren = function (t, e, n) {
            var o = this;
            if (e && t.containerDataObj !== e.dataObj || !e && t.containerDataObj) {
              var i = t.containerDataObj ? this.nodeDataImporter.getChildren(t.containerDataObj) : this.nodeDataSource,
                r = i.indexOf(t.dataObj);
              i.splice(r, 1);
              var s = e ? this.nodeDataImporter.getChildren(e.dataObj) : this.nodeDataSource;
              s ? s.push(t.dataObj) : this.nodeDataImporter.setChildren(e.dataObj, [t.dataObj]), t.containerDataObj = e && e.dataObj, n && (this.beginChangesNotification(), n.notifyNodeUpdated.call(n, this.nodeDataImporter.getKey(t.dataObj) || t.key, t.dataObj, function (t, e) {
                o.endChangesNotification(!1);
              }, function (t) {
                o.endChangesNotification(!1);
              }));
            }
          }, e.prototype.checkNodeCyrcleItems = function (t, e) {
            var n = this,
              o = !1,
              i = this.nodeDataImporter.getItems(t);
            return i && i.forEach(function (t) {
              o = o || t === e || n.checkNodeCyrcleItems(t, e);
            }), o;
          }, e.prototype.updateNodeObjectKey = function (t, e, n) {
            var o = this.nodeDataImporter.getKey(n),
              i = !1;
            if (null != o && o !== e.key && (delete this.autoGeneratedDataKeys[e.key], e.key = o, i = !0), t.dataKey = e.key, e.dataObj !== n) {
              var r = this.getNodeArray(e),
                s = r.indexOf(e.dataObj);
              r.splice(s, 1, n), e.dataObj = n;
            }
            i && this.updateNodeKeyRelatedObjects(t, e);
          }, e.prototype.updateNodeKeyRelatedObjects = function (t, e) {
            var n = this;
            if (this.isInNodeInserting()) this.addToUpdateNodeKeyRelatedObjectsStack(t, e);else {
              if (this.useNodeParentId && void 0 !== this.nodeDataImporter.setParentKey) this.getChildItems(t).forEach(function (t) {
                var o = n.findNode(t.dataKey);
                o && n.updateNodeObjectParentKey(o, e, n.changesListener);
              });
              this.useNodeContainerId && void 0 !== this.nodeDataImporter.setContainerKey && t.children.forEach(function (t) {
                var o = t instanceof s.Shape ? n.findNode(t.dataKey) : void 0;
                o && n.updateNodeObjectContainerKey(o, e, n.changesListener);
              }), this.useEdgesArray() && t.attachedConnectors.forEach(function (o) {
                var i = n.findEdge(o.dataKey);
                i && (t === o.beginItem && n.updateEdgeObjectFromProperty(e, i, n.changesListener), t === o.endItem && n.updateEdgeObjectToProperty(e, i, n.changesListener));
              });
            }
          }, e.prototype.deleteNodes = function (t, e) {
            var n = this;
            this.deleteItems(this.nodes, function (e) {
              return t.findShapeByDataKey(e);
            }, function (t) {
              return n.getNodeArray(t);
            }, function (t, o) {
              var i = t.dataObj && n.nodeDataImporter.getKey(t.dataObj) || t.key,
                r = n.findNode(i);
              r && n.nodes.splice(n.nodes.indexOf(r), 1), o && e.deletes.push([i, t]);
            });
          }, e.prototype.getParentItem = function (t) {
            for (var e = 0; e < t.attachedConnectors.length; e++) if (t.attachedConnectors[e].endItem === t) return t.attachedConnectors[e].beginItem;
          }, e.prototype.getParentItemKey = function (t) {
            var e = this.getParentItem(t);
            return e && e.dataKey;
          }, e.prototype.getNodeArray = function (t) {
            var e;
            return this.useNodeItems && t.parentDataObj ? e = this.nodeDataImporter.getItems(t.parentDataObj) : t.containerDataObj && (e = this.nodeDataImporter.getChildren(t.containerDataObj)), e || this.nodeDataSource;
          }, e.prototype.getContainerShapeKey = function (t) {
            return t.container && t.container.dataKey;
          }, e.prototype.getChildItems = function (t) {
            for (var e = [], n = 0; n < t.attachedConnectors.length; n++) t.attachedConnectors[n].beginItem === t && t.attachedConnectors[n].endItem && e.push(t.attachedConnectors[n].endItem);
            return e;
          }, e.prototype.updateEdge = function (t, e) {
            var n = this,
              o = e.beginItem ? e.beginItem.dataKey : void 0,
              i = e.endItem ? e.endItem.dataKey : void 0,
              r = this.findEdge(e.dataKey);
            if (r) this.isEdgeObjectModified(e, r, t.units) && (this.updateEdgeObjectProperties(e, r, t.units), r.dataObj && (this.beginChangesNotification(), this.changesListener.notifyEdgeUpdated.call(this.changesListener, this.edgeDataImporter.getKey(r.dataObj) || r.key, r.dataObj, function (t, e) {
              n.endChangesNotification(!1);
            }, function (t) {
              n.endChangesNotification(!1);
            })));else {
              var s = this.useEdgesArray() && this.canUpdateEdgeDataSource ? {} : void 0;
              s && void 0 !== e.dataKey && null !== e.dataKey && this.edgeDataImporter.setKey(s, e.dataKey), r = this.addEdgeInternal(s, o, i), s && (this.setDataObjectKeyRelatedProperty(this.edgeDataImporter.setKey, s, r.key, this.addInternalKeyOnInsert), this.edgeDataSource.push(r.dataObj)), this.updateEdgeObjectProperties(e, r, t.units), this.updateEdgeObjectKey(e, r, r.dataObj), s && (this.beginChangesNotification(), this.beginNodeInserting(), this.changesListener.notifyEdgeInserted.call(this.changesListener, r.dataObj, function (t) {
                n.updateEdgeObjectKey(e, r, t), n.endNodeInserting(), n.endChangesNotification(!1);
              }, function (t) {
                n.endNodeInserting(), n.endChangesNotification(!1);
              }));
            }
          }, e.prototype.isEdgeObjectModified = function (t, e, n) {
            return this.isItemObjectModified(t, e, this.edgeDataImporter) || (null !== e.from ? e.from : void 0) !== (t.beginItem ? t.beginItem.dataKey : void 0) || (null === e.to ? void 0 : e.to) !== (t.endItem ? t.endItem.dataKey : void 0) || this.edgeDataImporter.setFromPointIndex && e.fromPointIndex !== t.beginConnectionPointIndex || this.edgeDataImporter.setToPointIndex && e.toPointIndex !== t.endConnectionPointIndex || this.edgeDataImporter.setPoints && (!e.points || !this.pointsAreEqual(e.points.map(function (t) {
              return t.x;
            }), t.points.map(function (t) {
              return u.ModelUtils.getlUnitValue(n, t.x);
            })) || !this.pointsAreEqual(e.points.map(function (t) {
              return t.y;
            }), t.points.map(function (t) {
              return u.ModelUtils.getlUnitValue(n, t.y);
            }))) || this.edgeDataImporter.setText && !this.compareTexts(e, t) || this.edgeDataImporter.setLineOption && e.lineOption !== t.properties.lineOption || this.edgeDataImporter.setStartLineEnding && e.startLineEnding !== t.properties.startLineEnding || this.edgeDataImporter.setEndLineEnding && e.endLineEnding !== t.properties.endLineEnding;
          }, e.prototype.pointsAreEqual = function (t, e) {
            var n = t.length;
            if (n !== t.length) return !1;
            for (var o = 0; o < n; o++) if (!d.MathUtils.numberCloseTo(t[o], e[o])) return !1;
            return !0;
          }, e.prototype.updateEdgeObjectFromProperty = function (t, e, n) {
            if (e.from = t && t.key, e.dataObj) {
              var o = t && t.dataObj && this.nodeDataImporter.getKey(t.dataObj);
              this.setDataObjectKeyRelatedProperty(this.edgeDataImporter.setFrom, e.dataObj, o, !1), n && (this.isInUpdateNodeKeyRelatedObjects() ? this.addToUpdateNodeKeyRelatedObjectsStackAction("edge", e) : this.updateEdgeObjectFromOrToPropertyInternal(e, n));
            }
          }, e.prototype.updateEdgeObjectFromOrToPropertyInternal = function (t, e) {
            var n = this;
            this.beginChangesNotification(), e.notifyEdgeUpdated.call(e, this.nodeDataImporter.getKey(t.dataObj) || t.key, t.dataObj, function (t, e) {
              n.endChangesNotification(!1);
            }, function (t) {
              n.endChangesNotification(!1);
            });
          }, e.prototype.updateEdgeObjectToProperty = function (t, e, n) {
            if (e.to = t && t.key, e.dataObj) {
              var o = t && t.dataObj && this.nodeDataImporter.getKey(t.dataObj);
              this.setDataObjectKeyRelatedProperty(this.edgeDataImporter.setTo, e.dataObj, o, !1), n && (this.isInUpdateNodeKeyRelatedObjects() ? this.addToUpdateNodeKeyRelatedObjectsStackAction("edge", e) : this.updateEdgeObjectFromOrToPropertyInternal(e, n));
            }
          }, e.prototype.updateEdgeObjectProperties = function (t, e, n) {
            if (this.updateItemObjectProperties(e, t, this.edgeDataImporter), this.edgeDataImporter.setFrom) {
              var o = this.findNode(t.beginItem && t.beginItem.dataKey);
              this.updateEdgeObjectFromProperty(o, e);
            }
            if (this.edgeDataImporter.setTo) {
              var i = this.findNode(t.endItem && t.endItem.dataKey);
              this.updateEdgeObjectToProperty(i, e);
            }
            if (this.edgeDataImporter.setFromPointIndex && (e.fromPointIndex = t.beginConnectionPointIndex, e.dataObj && this.edgeDataImporter.setFromPointIndex(e.dataObj, t.beginConnectionPointIndex)), this.edgeDataImporter.setToPointIndex && (e.toPointIndex = t.endConnectionPointIndex, e.dataObj && this.edgeDataImporter.setToPointIndex(e.dataObj, t.endConnectionPointIndex)), this.edgeDataImporter.setPoints) {
              var r = t.points.map(function (t) {
                return {
                  x: u.ModelUtils.getlUnitValue(n, t.x),
                  y: u.ModelUtils.getlUnitValue(n, t.y)
                };
              });
              e.points = r, e.dataObj && this.edgeDataImporter.setPoints(e.dataObj, r);
            }
            if (this.edgeDataImporter.setText) {
              var s = void 0;
              1 === t.getTextCount() && t.getText() && (s = t.getText());
              var a = {};
              if (t.texts.forEach(function (t) {
                a[t.position] = t.value;
              }), e.texts = a, e.dataObj) {
                var c = "";
                s ? c = s : a && Object.keys(a).length && (c = a), this.edgeDataImporter.setText(e.dataObj, c);
              }
            }
            this.edgeDataImporter.setLineOption && (e.lineOption = t.properties.lineOption, e.dataObj && this.edgeDataImporter.setLineOption(e.dataObj, t.properties.lineOption)), this.edgeDataImporter.setStartLineEnding && (e.startLineEnding = t.properties.startLineEnding, e.dataObj && this.edgeDataImporter.setStartLineEnding(e.dataObj, t.properties.startLineEnding)), this.edgeDataImporter.setEndLineEnding && (e.endLineEnding = t.properties.endLineEnding, e.dataObj && this.edgeDataImporter.setEndLineEnding(e.dataObj, t.properties.endLineEnding));
          }, e.prototype.updateEdgeObjectKey = function (t, e, n) {
            var o = n && this.edgeDataImporter.getKey(n);
            if (null != o && o !== e.key && (delete this.autoGeneratedDataKeys[e.key], e.key = o), t.dataKey = e.key, e.dataObj !== n) {
              var i = this.edgeDataSource,
                r = i.indexOf(e.dataObj);
              i.splice(r, 1, n), e.dataObj = n;
            }
          }, e.prototype.deleteEdges = function (t) {
            var e = this;
            this.deleteItems(this.edges, function (e) {
              return t.findConnectorByDataKey(e);
            }, function (t) {
              return e.edgeDataSource;
            }, function (t, n) {
              var o = t.dataObj && e.edgeDataImporter.getKey(t.dataObj) || t.key,
                i = e.findEdge(o);
              i && e.edges.splice(e.edges.indexOf(i), 1), n && (e.beginChangesNotification(), e.changesListener.notifyEdgeRemoved.call(e.changesListener, o, t.dataObj, function (t, n) {
                e.endChangesNotification(!1);
              }, function (t) {
                e.endChangesNotification(!1);
              }));
            });
          }, e.prototype.beginNodeInserting = function () {
            this.nodeInsertingLockCount++;
          }, e.prototype.endNodeInserting = function () {
            this.nodeInsertingLockCount--, 0 === this.nodeInsertingLockCount && this.raiseNodeInsertingStack();
          }, e.prototype.isInNodeInserting = function () {
            return this.nodeInsertingLockCount > 0;
          }, e.prototype.addToUpdateNodeKeyRelatedObjectsStack = function (t, e) {
            var n = new f(t, e);
            this.updateNodeKeyRelatedObjectsStack.push(n);
          }, e.prototype.raiseNodeInsertingStack = function () {
            for (this.beginUpdateNodeKeyRelatedObjects(); this.updateNodeKeyRelatedObjectsStack.length > 0;) {
              var t = this.updateNodeKeyRelatedObjectsStack[0];
              this.updateNodeKeyRelatedObjects(t.shape, t.nodeObj), this.updateNodeKeyRelatedObjectsStack.splice(0, 1), t.shape.description.hasTemplate && t.nodeObj && this.changesListener.reloadInsertedItem(t.nodeObj.key);
            }
            this.endUpdateNodeKeyRelatedObjects();
          }, e.prototype.beginUpdateNodeKeyRelatedObjects = function () {
            this.updateNodeKeyRelatedObjectsCount++;
          }, e.prototype.endUpdateNodeKeyRelatedObjects = function () {
            this.updateNodeKeyRelatedObjectsCount--, 0 === this.updateNodeKeyRelatedObjectsCount && this.raiseUpdateNodeKeyRelatedObjectsStack();
          }, e.prototype.isInUpdateNodeKeyRelatedObjects = function () {
            return this.updateNodeKeyRelatedObjectsCount > 0;
          }, e.prototype.addToUpdateNodeKeyRelatedObjectsStackAction = function (t, e) {
            for (var n = new y(t, e), o = 0; o < this.updateNodeKeyRelatedObjectsStackActions.length; o++) if (this.updateNodeKeyRelatedObjectsStackActions[o].kind === t && this.updateNodeKeyRelatedObjectsStackActions[o].nodeObj === e) return;
            this.updateNodeKeyRelatedObjectsStackActions.push(n);
          }, e.prototype.raiseUpdateNodeKeyRelatedObjectsStack = function () {
            for (; this.updateNodeKeyRelatedObjectsStackActions.length > 0;) {
              var t = this.updateNodeKeyRelatedObjectsStackActions[0];
              switch (t.kind) {
                case "shape":
                  this.updateNodeObjectContainerOrParentKeyInternal(t.nodeObj, this.changesListener);
                  break;
                case "edge":
                  this.updateEdgeObjectFromOrToPropertyInternal(t.nodeObj, this.changesListener);
              }
              this.updateNodeKeyRelatedObjectsStackActions.splice(0, 1);
            }
          }, e.prototype.beginChangesNotification = function () {
            this.changesListener.beginChangesNotification();
          }, e.prototype.endChangesNotification = function (t) {
            this.changesListener.endChangesNotification(t);
          }, e;
        }(c.DataSource);
        e.DocumentDataSource = g;
      },
      1616: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MouseHandlerMoveConnectorState = void 0;
        var r = n(1922),
          s = function (t) {
            function e(e, n, o, i, r) {
              var s = t.call(this, e, n, o, i, r) || this;
              return s.model = o, s.selection = i, s.visualizerManager = r, s;
            }
            return i(e, t), Object.defineProperty(e.prototype, "areValidDraggingShapes", {
              get: function () {
                return !0;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "areValidDraggingConnectors", {
              get: function () {
                var t = this;
                return this.shouldClone ? this.dragHelper.draggingShapes.length > 0 || this.dragHelper.draggingConnectors.length > 0 : !!this.dragHelper.draggingConnectors.length && (this.dragHelper.draggingShapes.length ? r.ModelUtils.canMoveConnector(this.dragHelper.selectedItems, this.dragHelper.draggingConnectors[this.dragHelper.draggingConnectorsIndexByKey[this.handler.mouseDownEvent.source.key]].connector) : !this.dragHelper.draggingConnectors.some(function (e) {
                  return !r.ModelUtils.canMoveConnector(t.dragHelper.selectedItems, e.connector);
                }));
              },
              enumerable: !1,
              configurable: !0
            }), e;
          }(n(9993).MouseHandlerDragDiagramItemStateBase);
        e.MouseHandlerMoveConnectorState = s;
      },
      1659: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ToolboxManager = void 0;
        var o = n(2651),
          i = n(481),
          r = n(6727),
          s = n(594),
          a = function () {
            function t(t) {
              this.shapeDescriptionManager = t, this.toolboxes = [], this.measurers = {};
            }
            return t.prototype.create = function (t, e, n, r, s, a, c, u) {
              var p = Array.isArray(s) ? s : this.shapeDescriptionManager.getTypesByCategory(s),
                h = r ? new o.TextToolbox(t, e, n, this.shapeDescriptionManager, p, a) : new i.IconToolbox(t, e, n, this.shapeDescriptionManager, p, a, u, this.getOrCreateMeasurer(t), c);
              return h.render(), this.toolboxes.push(h), h;
            }, t.prototype.clean = function (t, e) {
              var n = this;
              if (e) e.clean(t), this.toolboxes.splice(this.toolboxes.indexOf(e), 1), Object.keys(this.measurers).forEach(function (t) {
                n.measurers[t] === e.measurer && delete n.measurers[t];
              });else {
                for (var o = 0; o < this.toolboxes.length; o++) this.toolboxes[o].clean(t);
                this.toolboxes = [], this.measurers = {};
              }
            }, t.prototype.refresh = function (t) {
              this.toolboxes.forEach(function (e, n) {
                (!t || Array.isArray(t) && t.indexOf(n) > -1 || n === t) && e.render();
              });
            }, t.prototype.applyFilter = function (t, e) {
              var n = this;
              return this.toolboxes.reduce(function (o, i, r) {
                return (!e || Array.isArray(e) && e.indexOf(r) > -1 || r === e) && i.render(function (e) {
                  return n.searchFilter(e, t, r);
                }) && o.push(r), o;
              }, []);
            }, t.prototype.searchFilter = function (t, e, n, o) {
              if (!e || o && -1 === o.indexOf(n)) return !0;
              e = e.toLowerCase();
              var i = this.shapeDescriptionManager.get(t);
              return i.getTitle().toLowerCase().indexOf(e) > -1 || i.getDefaultText().toLowerCase().indexOf(e) > -1;
            }, t.prototype.getOrCreateMeasurer = function (t) {
              var e = t.getAttribute("data-dxdiMeasurerID");
              return e && this.measurers[e] || (e = s.MathUtils.generateGuid(), this.measurers[e] = new r.TextMeasurer(t), t.setAttribute("data-dxdiMeasurerID", e)), this.measurers[e];
            }, t;
          }();
        e.ToolboxManager = a;
      },
      1675: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ChangeShapeTextEventArgs = e.ChangeShapeTextRequestedEntity = void 0;
        var r = n(5225),
          s = n(5102),
          a = function (t) {
            function e(e, n, o) {
              var i = t.call(this, e) || this;
              return i.shape = n, i.text = o, i;
            }
            return i(e, t), Object.defineProperty(e.prototype, "operation", {
              get: function () {
                return r.DiagramModelOperation.ChangeShapeText;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.createEventArgs = function () {
              return new c(this.apiController.createNativeShape(this.shape), this.text);
            }, Object.defineProperty(e.prototype, "settingsKey", {
              get: function () {
                return "changeShapeText";
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "storageKey", {
              get: function () {
                return this.settingsKey + "_" + (this.shape && this.shape.key);
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.equals = function (t) {
              return t instanceof e && this.shape === t.shape && this.text === t.text;
            }, e;
          }(s.RequestedEntity);
        e.ChangeShapeTextRequestedEntity = a;
        var c = function (t) {
          function e(e, n) {
            var o = t.call(this) || this;
            return o.shape = e, o.text = n, o;
          }
          return i(e, t), e;
        }(s.PermissionRequestEventArgs);
        e.ChangeShapeTextEventArgs = c;
      },
      1684: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ChangeLockedHistoryItem = void 0;
        var r = function (t) {
          function e(e, n) {
            var o = t.call(this) || this;
            return o.itemKey = e.key, o.locked = n, o;
          }
          return i(e, t), e.prototype.redo = function (t) {
            var e = t.model.findItem(this.itemKey);
            this.oldLocked = e.locked, t.changeLocked(e, this.locked);
          }, e.prototype.undo = function (t) {
            var e = t.model.findItem(this.itemKey);
            t.changeLocked(e, this.oldLocked);
          }, e;
        }(n(2616).HistoryItem);
        e.ChangeLockedHistoryItem = r;
      },
      1785: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.DeleteShapeHistoryItem = void 0;
        var r = function (t) {
          function e(e, n) {
            void 0 === n && (n = !0);
            var o = t.call(this) || this;
            return o.shapeKey = e, o.allowed = n, o;
          }
          return i(e, t), e.prototype.redo = function (t) {
            var e = t.model.findShape(this.shapeKey);
            this.shape = e.clone(), t.deleteShape(e, this.allowed);
          }, e.prototype.undo = function (t) {
            t.addShape(this.shape, this.shape.key);
          }, e;
        }(n(2616).HistoryItem);
        e.DeleteShapeHistoryItem = r;
      },
      1833: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.TriangleShapeDescription = void 0;
        var r = n(1280),
          s = n(6208),
          a = n(3255),
          c = n(4856),
          u = n(4824),
          p = n(4412),
          h = n(3844),
          l = function (t) {
            function e(e) {
              var n = t.call(this, void 0, e) || this;
              return n.defaultSize.height = n.calculateHeight(r.ShapeDefaultDimension), n;
            }
            return i(e, t), Object.defineProperty(e.prototype, "key", {
              get: function () {
                return a.ShapeTypes.Triangle;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "keepRatioOnAutoSize", {
              get: function () {
                return !1;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.createConnectionPoints = function () {
              return [new c.ConnectionPoint(.5, 0, u.ConnectionPointSide.North), new c.ConnectionPoint(.75, .5, u.ConnectionPointSide.East), new c.ConnectionPoint(.5, 1, u.ConnectionPointSide.South), new c.ConnectionPoint(.25, .5, u.ConnectionPointSide.West)];
            }, e.prototype.createShapePrimitives = function (t) {
              var e = t.rectangle,
                n = e.x,
                o = e.y,
                i = e.right,
                r = e.bottom;
              return [new s.PathPrimitive([new s.PathPrimitiveMoveToCommand(e.center.x, o), new s.PathPrimitiveLineToCommand(i, r), new s.PathPrimitiveLineToCommand(n, r), new s.PathPrimitiveClosePathCommand()], t.style)];
            }, e.prototype.calculateHeight = function (t) {
              return Math.sqrt(Math.pow(t, 2) - Math.pow(t / 2, 2));
            }, e.prototype.getTextRectangle = function (t) {
              return new p.Rectangle(t.position.x + t.size.width / 4, t.position.y + t.size.height / 2, t.size.width / 2, t.size.height / 2 - r.ShapeTextPadding).nonNegativeSize();
            }, e.prototype.getSizeByText = function (t, e) {
              return new h.Size(2 * t.width, 2 * t.height + r.ShapeTextPadding);
            }, e;
          }(r.ShapeDescription);
        e.TriangleShapeDescription = l;
      },
      1842: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.getLineHeight = e.getTextHeight = e.getTextLineSize = e.getOptimalTextRectangle = e.TEXTRECT_RATIO_EPS = e.textToParagraphs = e.textToWords = e.wordsByLines = e.LINE_HEIGHT = void 0;
        var o = n(41),
          i = n(3844),
          r = n(2620),
          s = /\s/gm;
        function a(t, e, n) {
          if (1 === e.length) return e;
          for (var o = n(), i = o.words[" "].width, r = [], s = 0, a = -1, c = 0; c < e.length; c++) {
            var u = e[c],
              p = o.words[u].width;
            -1 === a || s + i + p > t ? (a = r.push(u) - 1, s = p) : (s += i + p, r[a] += " " + u);
          }
          return r;
        }
        function c(t) {
          return t.split(s).filter(function (t) {
            return t.length;
          });
        }
        function u(t) {
          return t.split("\n");
        }
        e.LINE_HEIGHT = 1.05, e.wordsByLines = a, e.textToWords = c, e.textToParagraphs = u, e.TEXTRECT_RATIO_EPS = 1.2;
        function p(t, e, n) {
          var o = t < 1 ? 1 / t : t,
            i = e < 1 ? 1 / e : e,
            r = o / i;
          return (r < 1 ? 1 / r : r) <= n ? 0 : i > o ? 1 : -1;
        }
        function h(t, e, n, o) {
          return l(f(t, e, n, !1), o);
        }
        function l(t, e) {
          return [r.Data.byRange(t, e.from, e.to), t <= e.to];
        }
        function d(t, e) {
          return c(t).reduce(function (t, n, o) {
            var i = e.words[n];
            return t.width += i.width, t.height = Math.max(t.height, i.height), o > 0 && (t.width += e.words[" "].width), t;
          }, new i.Size(0, 0));
        }
        function f(t, e, n, o) {
          var i = Array.isArray(t) ? t : u(t);
          return !o || i.length && (1 !== i.length || i[0].length) ? i.reduce(function (t, o) {
            return t + a(e, c(o), function () {
              return n;
            }).length;
          }, 0) * y(n) : y(n);
        }
        function y(t) {
          return t.fontSize * e.LINE_HEIGHT;
        }
        e.getOptimalTextRectangle = function (t, n, s, a, c, y, g, m, v, P) {
          if (void 0 === g && (g = 0), void 0 === m && (m = Number.MAX_SAFE_INTEGER || Number.MAX_VALUE), void 0 === v && (v = 0), void 0 === P && (P = Number.MAX_SAFE_INTEGER || Number.MAX_VALUE), !t) return new i.Size(r.Data.byRange(c.width, g, m), r.Data.byRange(c.height, v, P));
          if (g > m || v > P) throw new Error("Min size cannot exceed max size");
          if (g === m && v === P) return new i.Size(g, v);
          var C = a.measureWords(t, n, s),
            S = u(t),
            x = Object.keys(C.words).reduce(function (t, e) {
              return Math.max(t, C.words[e].width);
            }, 0),
            b = new o.Range(r.Data.byRange(Math.max(c.width, x), g, m), m),
            w = new o.Range(r.Data.byRange(c.height, v, P), P);
          if (x <= c.width && f(S, c.width, C, !1) <= c.height && b.includes(c.width) && w.includes(c.height)) return c;
          var I = c.width / c.height;
          return function (t, n, o, s, a, c) {
            for (var u, f, y = t.reduce(function (t, e) {
                return Math.max(t, d(e, n).width);
              }, 0), g = new i.Size(0, 0), m = new i.Size(0, 0), v = 0, P = 0, C = 0; C < 5; C++) {
              if (0 === C) m.width = l(y, s)[0];else {
                if (!(Math.abs(v) > 1)) break;
                m.width = l(g.width + v, s)[0];
              }
              if (u = h(t, m.width, n, a), m.height = u[0], f = u[1], 0 === C && (P = (g = m.clone()).width / g.height / o), 0 === C && !f) break;
              var S = m.width / m.height,
                x = S / o;
              if (0 === C) v = (m.width / x - m.width) / 2;else if (f) {
                if (!p(o, S, e.TEXTRECT_RATIO_EPS)) {
                  g = m.clone(), P = x;
                  break;
                }
                if (!(p(P, x, 1) < 0)) break;
                g = m.clone(), P = x, v = (m.width / x - m.width) / 2, x < 1 && (v /= 2);
              } else v /= 2;
            }
            c && (g.height = r.Data.byRange(g.width / o, g.height, a.to));
            return g;
          }(S, C, I, b, w, y);
        }, e.getTextLineSize = d, e.getTextHeight = f, e.getLineHeight = y;
      },
      1851: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ToggleFontBoldCommand = void 0;
        var r = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(e, t), e.prototype.getStyleProperty = function () {
            return "font-weight";
          }, e.prototype.getStylePropertyValue = function () {
            return "bold";
          }, e;
        }(n(3210).ToggleStyleTextPropertyCommand);
        e.ToggleFontBoldCommand = r;
      },
      1891: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.DeleteConnectorEventArgs = e.DeleteConnectorRequestedEntity = void 0;
        var r = n(5225),
          s = n(5102),
          a = function (t) {
            function e(e, n) {
              var o = t.call(this, e) || this;
              return o.connector = n, o;
            }
            return i(e, t), Object.defineProperty(e.prototype, "operation", {
              get: function () {
                return r.DiagramModelOperation.DeleteConnector;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.createEventArgs = function () {
              return new c(this.apiController.createNativeConnector(this.connector));
            }, Object.defineProperty(e.prototype, "settingsKey", {
              get: function () {
                return "deleteConnector";
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "storageKey", {
              get: function () {
                return this.settingsKey + "_" + (this.connector && this.connector.key);
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.equals = function (t) {
              return t instanceof e && this.connector === t.connector;
            }, e;
          }(s.RequestedEntity);
        e.DeleteConnectorRequestedEntity = a;
        var c = function (t) {
          function e(e) {
            var n = t.call(this) || this;
            return n.connector = e, n;
          }
          return i(e, t), e;
        }(s.PermissionRequestEventArgs);
        e.DeleteConnectorEventArgs = c;
      },
      1893: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AutoLayoutTreeVerticalCommand = void 0;
        var r = n(8674),
          s = n(8533),
          a = n(9212),
          c = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), e.prototype.createLayoutSettings = function () {
              var t = this.control.settings.snapToGrid ? this.control.settings.gridSize : void 0,
                e = new a.TreeLayoutSettings(t);
              return e.orientation = a.DataLayoutOrientation.Vertical, e;
            }, e.prototype.createLayout = function (t, e) {
              return new s.TreeLayoutBuilder(t, e).build();
            }, e;
          }(r.AutoLayoutCommandBase);
        e.AutoLayoutTreeVerticalCommand = c;
      },
      1914: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ChangeConnectorTextHistoryItem = void 0;
        var r = function (t) {
          function e(e, n, o) {
            var i = t.call(this) || this;
            return i.connectorKey = e.key, i.text = o, i.position = n, i;
          }
          return i(e, t), e.prototype.redo = function (t) {
            var e = t.model.findConnector(this.connectorKey);
            this.oldText = e.getText(this.position), t.changeConnectorText(e, this.text, this.position);
          }, e.prototype.undo = function (t) {
            var e = t.model.findConnector(this.connectorKey);
            t.changeConnectorText(e, this.oldText, this.position);
          }, e;
        }(n(2616).HistoryItem);
        e.ChangeConnectorTextHistoryItem = r;
      },
      1917: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ChangeSnapToGridCommand = void 0;
        var r = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(e, t), e.prototype.executeCore = function (t, e) {
            var n = void 0 === e ? !this.control.settings.snapToGrid : !!e;
            return this.control.settings.snapToGrid !== n && (this.control.settings.snapToGrid = n, !0);
          }, e.prototype.getValue = function () {
            return this.control.settings.snapToGrid;
          }, e;
        }(n(3913).SimpleCommandBase);
        e.ChangeSnapToGridCommand = r;
      },
      1922: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ModelUtils = void 0;
        var o = n(9500),
          i = n(4496),
          r = n(5327),
          s = n(4412),
          a = n(3844),
          c = n(4166),
          u = n(594),
          p = n(9254),
          h = n(4139),
          l = n(4048),
          d = n(8226),
          f = n(8214),
          y = n(8818),
          g = n(7489),
          m = n(6155),
          v = n(7392),
          P = n(1785),
          C = n(5323),
          S = n(6904),
          x = n(3312),
          b = n(7271),
          w = n(5685),
          I = n(6512),
          T = n(6035),
          O = n(4715),
          _ = n(2448),
          E = n(1914),
          M = n(9735),
          D = n(1684),
          A = n(3550),
          R = n(5755),
          j = n(9071),
          L = n(3903),
          N = n(8573),
          z = n(41),
          U = n(6320),
          k = n(4385),
          B = n(9956),
          H = n(5359),
          K = n(8408),
          V = n(2389),
          F = function () {
            function t() {}
            return t.setShapePosition = function (e, n, o, i, r) {
              if (void 0 === r && (r = !0), !o.position.equals(i)) {
                var s = i.clone().offset(-o.position.x, -o.position.y);
                return e.addAndRedo(new x.MoveShapeHistoryItem(o.key, i)), r && o.children.forEach(function (o) {
                  if (o instanceof K.Shape) {
                    var i = o.position.clone().offset(s.x, s.y);
                    t.setShapePosition(e, n, o, i);
                  }
                }), !0;
              }
              return !1;
            }, t.setShapeSize = function (t, e, n, o, i) {
              return (!n.size.equals(i) || !n.position.equals(o)) && (t.addAndRedo(new w.ResizeShapeHistoryItem(n.key, o, i)), !0);
            }, t.addConnectorPoint = function (t, e, n, o) {
              t.addAndRedo(new d.AddConnectorPointHistoryItem(e, n, o));
            }, t.deleteConnectorCustomPoints = function (t, e) {
              if (e.points.length > 2) {
                var n = e.tryCreateRenderPointsContext();
                if (e.properties.lineOption !== k.ConnectorLineOption.Straight && n) {
                  var o = e.points[0].clone(),
                    i = e.points[e.points.length - 1].clone();
                  t.addAndRedo(new y.ChangeConnectorPointsHistoryItem(e.key, [o, i], new H.ConnectorRenderPointsContext([new B.ConnectorRenderPoint(o.x, o.y, 0), new B.ConnectorRenderPoint(i.x, i.y, 1)], !1, n.actualRoutingMode)));
                } else t.addAndRedo(new y.ReplaceConnectorPointsHistoryItem(e.key, [e.points[0].clone(), e.points[e.points.length - 1].clone()]));
              }
            }, t.deleteConnectorUnnecessaryPoints = function (e, n) {
              var o = n.getRenderPoints(!0).map(function (t) {
                return t.clone();
              });
              if (n.properties.lineOption === k.ConnectorLineOption.Straight) {
                var i = t.createUnnecessaryRenderPoints(o.filter(function (t) {
                  return !t.skipped;
                }).map(function (t) {
                  return t.clone();
                }), n.skippedRenderPoints, function (e) {
                  return t.findFirstPointIndex(o, function (t) {
                    return B.ConnectorRenderPoint.equal(t, e);
                  });
                });
                Object.keys(i).length && e.addAndRedo(new y.ReplaceConnectorPointsHistoryItem(n.key, t.createNecessaryPoints(n.points.map(function (t) {
                  return t.clone();
                }), i)));
              } else {
                var r = n.tryCreateRenderPointsContext(!0),
                  s = o.filter(function (t) {
                    return !t.skipped;
                  }).map(function (t) {
                    return t.clone();
                  });
                i = t.createUnnecessaryRightAngleRenderPoints(s, n.skippedRenderPoints, function (e) {
                  return t.findFirstPointIndex(o, function (t) {
                    return B.ConnectorRenderPoint.equal(t, e);
                  });
                });
                if (Object.keys(i).length) {
                  var a = t.createNecessaryPoints(n.points.map(function (t) {
                      return t.clone();
                    }), i),
                    c = new H.ConnectorRenderPointsContext(t.validateRenderPointIndexes(a, s, 0), r.lockCreateRenderPoints, r.actualRoutingMode);
                  e.addAndRedo(new y.ChangeConnectorPointsHistoryItem(n.key, a, c));
                }
              }
            }, t.fixConnectorBeginEndConnectionIndex = function (t, e) {
              if (e.beginItem && -1 === e.beginConnectionPointIndex) {
                var n = e.beginItem.getNearestConnectionPoint(e.points[0]);
                t.addAndRedo(new h.SetConnectionPointIndexHistoryItem(e, n, U.ConnectorPosition.Begin));
              }
              if (e.endItem && -1 === e.endConnectionPointIndex) {
                var o = e.endItem.getNearestConnectionPoint(e.points[e.points.length - 1]);
                t.addAndRedo(new h.SetConnectionPointIndexHistoryItem(e, o, U.ConnectorPosition.End));
              }
            }, t.skipUnnecessaryRenderPoints = function (e, n) {
              z.GeometryUtils.removeUnnecessaryPoints(e, function (o, i) {
                return t.removeUnnecessaryPoint(e, o, i, n);
              }, function (t) {
                return void 0 !== t && !t.skipped;
              }), e[0].skipped = !1, e[e.length - 1].skipped = !1;
            }, t.skipUnnecessaryRightAngleRenderPoints = function (e, n) {
              z.GeometryUtils.removeUnnecessaryRightAnglePoints(e, function (o, i) {
                return t.removeUnnecessaryPoint(e, o, i, n);
              }, function (t) {
                return void 0 !== t && !t.skipped;
              }), e[0].skipped = !1, e[e.length - 1].skipped = !1;
            }, t.createUnnecessaryRenderPoints = function (e, n, o, i) {
              void 0 === i && (i = function (t) {
                return !0;
              });
              var r = {};
              return z.GeometryUtils.removeUnnecessaryPoints(e, function (n, s) {
                return t.collectNotSkippedRenderPoints(r, e, n, s, o, i);
              }), t.collectSkippedRenderPoints(r, n, o, i), r;
            }, t.createUnnecessaryRightAngleRenderPoints = function (e, n, o, i) {
              void 0 === i && (i = function (t) {
                return !0;
              });
              var r = {};
              return z.GeometryUtils.removeUnnecessaryRightAnglePoints(e, function (n, s) {
                return t.collectNotSkippedRenderPoints(r, e, n, s, o, i);
              }), t.collectSkippedRenderPoints(r, n, o, i), r;
            }, t.createNecessaryPoints = function (t, e) {
              var n = this,
                o = [],
                i = t.length - 1;
              return t.forEach(function (t, r) {
                (0 === r || r === i || n.isNecessaryPoint(t, r, e)) && o.push(t.clone());
              }), o;
            }, t.isNecessaryPoint = function (t, e, n) {
              return !Object.keys(n).some(function (o) {
                var i = n[o];
                return i.pointIndex === e && z.GeometryUtils.areDuplicatedPoints(t, i);
              });
            }, t.collectSkippedRenderPoints = function (t, e, n, o) {
              void 0 === o && (o = function (t) {
                return !0;
              }), e && e.forEach(function (e) {
                if (o(e)) {
                  var i = n(e);
                  void 0 === t[i] && (t[i] = e);
                }
              });
            }, t.collectNotSkippedRenderPoints = function (t, e, n, o, i, r) {
              if (void 0 === r && (r = function (t) {
                return !0;
              }), r(n)) {
                var s = i(n);
                if (void 0 === t[s]) return t[s] = n, n.skipped = !0, e.splice(o, 1), !0;
              }
              return !1;
            }, t.removeUnnecessaryPoint = function (t, e, n, o) {
              return o && -1 === e.pointIndex ? (t.splice(n, 1), !0) : (e.skipped = !0, !1);
            }, t.validateRenderPointIndexes = function (t, e, n) {
              var o = this,
                i = e.map(function (e, i) {
                  return new B.ConnectorRenderPoint(e.x, e.y, i >= n && e.pointIndex >= 0 ? o.findFirstPointIndex(t, function (t) {
                    return t.equals(e);
                  }) : e.pointIndex, e.skipped);
                });
              return i[0].skipped = !1, i[i.length - 1].skipped = !1, i;
            }, t.findFirstPointIndex = function (t, e) {
              if (!t || !e) return -1;
              for (var n = 0; n < t.length; n++) if (e(t[n])) return n;
              return -1;
            }, t.moveConnectorRightAnglePoints = function (t, e, n, o, i, s) {
              e.points.slice(n, o + 1).some(function (t) {
                return !z.GeometryUtils.areDuplicatedPoints(t, new r.Point(void 0 === i ? t.x : i, void 0 === s ? t.y : s));
              }) && t.addAndRedo(new S.MoveConnectorRightAnglePointsHistoryItem(e.key, n, o, i, s));
            }, t.moveConnectorPoint = function (t, e, n, o) {
              return !e.points[n].equals(o) && (t.addAndRedo(new S.MoveConnectorPointHistoryItem(e.key, n, o)), !0);
            }, t.updateConnectorAttachedPoints = function (t, e, n) {
              t.beginTransaction();
              var o = n.beginItem && e.findItemCollapsedContainer(n.beginItem),
                i = o && (!n.endItem || !e.isContainerItem(o, n.endItem)),
                r = n.endItem && e.findItemCollapsedContainer(n.endItem),
                s = r && (!n.beginItem || !e.isContainerItem(r, n.beginItem)),
                a = !1;
              return a = i ? this.updateConnectorBeginPoint(t, n, o, s && r || n.endItem, function (t) {
                return o.getConnectionPointIndexForItem(n.beginItem, t);
              }) || a : this.updateConnectorBeginPoint(t, n, n.beginItem, s && r || n.endItem) || a, a = s ? this.updateConnectorEndPoint(t, n, r, function (t) {
                return r.getConnectionPointIndexForItem(n.beginItem, t);
              }) || a : this.updateConnectorEndPoint(t, n, n.endItem) || a, t.endTransaction(), a;
            }, t.updateConnectorBeginPoint = function (t, e, n, o, i) {
              if (n) {
                var s = void 0 !== i ? i(e.beginConnectionPointIndex) : e.beginConnectionPointIndex,
                  a = e.points[1];
                o && 2 === e.points.length && (a = -1 !== e.endConnectionPointIndex ? o.getConnectionPointPosition(e.endConnectionPointIndex, r.Point.zero()) : o.rectangle.center);
                var c = n.getConnectionPointPosition(s, a);
                return this.moveConnectorPoint(t, e, 0, c.clone());
              }
            }, t.updateConnectorEndPoint = function (t, e, n, o) {
              if (n) {
                var i = void 0 !== o ? o(e.endConnectionPointIndex) : e.endConnectionPointIndex,
                  r = n.getConnectionPointPosition(i, e.points[e.points.length - 2]);
                return this.moveConnectorPoint(t, e, e.points.length - 1, r);
              }
            }, t.updateContainerConnectorsAttachedPoints = function (t, e, n, o) {
              var i = this;
              void 0 === o && (o = n), t.beginTransaction(), e.getChildren(o).forEach(function (r) {
                r instanceof K.Shape && (r.attachedConnectors.forEach(function (r) {
                  var s = r.beginItem && e.isContainerItem(o, r.beginItem),
                    a = r.endItem && e.isContainerItem(o, r.endItem);
                  if (s && !a) {
                    var c = e.findItemTopCollapsedContainer(r.beginItem),
                      u = r.endItem && e.findItemTopCollapsedContainer(r.endItem);
                    c ? i.updateConnectorBeginPoint(t, r, c, u || r.endItem, function (t) {
                      return n.getConnectionPointIndexForItem(r.beginItem, t);
                    }) : i.updateConnectorBeginPoint(t, r, r.beginItem, u || r.endItem);
                  }
                  a && !s && ((c = e.findItemTopCollapsedContainer(r.endItem)) ? i.updateConnectorEndPoint(t, r, c, function (t) {
                    return n.getConnectionPointIndexForItem(r.endItem, t);
                  }) : i.updateConnectorEndPoint(t, r, r.endItem));
                }), i.updateContainerConnectorsAttachedPoints(t, e, n, r));
              }), t.endTransaction();
            }, t.getConnectorsWithoutBeginItemInfo = function (t) {
              return t.findConnectorsWithoutBeginItem().map(function (t) {
                return {
                  connector: t,
                  point: t.points[0].clone()
                };
              });
            }, t.getConnectorsWithoutEndItemInfo = function (t) {
              return t.findConnectorsWithoutEndItem().map(function (t) {
                return {
                  connector: t,
                  point: t.points[t.points.length - 1].clone()
                };
              });
            }, t.updateShapeAttachedConnectors = function (t, e, n) {
              var o = this;
              n.attachedConnectors.forEach(function (n) {
                o.tryRemoveConnectorIntermediatePoints(t, n), o.updateConnectorAttachedPoints(t, e, n);
              });
            }, t.updateMovingShapeConnections = function (t, e, n, o, i, r, s) {
              var a = this;
              i(), n.forEach(function (n) {
                var o = a.getMovingShapeConnectionPointIndex(e, n.point);
                e.rectangle.containsPoint(n.point) || o > -1 ? (r(e, o), o !== n.connector.beginConnectionPointIndex && n.connector.beginItem && t.addAndRedo(new m.DeleteConnectionHistoryItem(n.connector, U.ConnectorPosition.Begin)), s(n.connector), t.addAndRedo(new h.AddConnectionHistoryItem(n.connector, e, o, U.ConnectorPosition.Begin))) : n.connector.beginItem && (t.addAndRedo(new m.DeleteConnectionHistoryItem(n.connector, U.ConnectorPosition.Begin)), t.addAndRedo(new S.MoveConnectorPointHistoryItem(n.connector.key, 0, n.point)));
              }), o.forEach(function (n) {
                var o = a.getMovingShapeConnectionPointIndex(e, n.point);
                e.rectangle.containsPoint(n.point) || o > -1 ? (r(e, o), o !== n.connector.endConnectionPointIndex && n.connector.endItem && t.addAndRedo(new m.DeleteConnectionHistoryItem(n.connector, U.ConnectorPosition.End)), s(n.connector), t.addAndRedo(new h.AddConnectionHistoryItem(n.connector, e, o, U.ConnectorPosition.End))) : n.connector.endItem && (t.addAndRedo(new m.DeleteConnectionHistoryItem(n.connector, U.ConnectorPosition.End)), t.addAndRedo(new S.MoveConnectorPointHistoryItem(n.connector.key, n.connector.points.length - 1, n.point)));
              });
            }, t.getMovingShapeConnectionPointIndex = function (t, e) {
              var n = this,
                o = -1;
              return t.getConnectionPoints().forEach(function (t, r) {
                i.Metrics.euclideanDistance(e, t) < n.connectionPointActionSize && (o = r);
              }), o;
            }, t.shouldRemoveConnectorIntermediatePoints = function (t, e) {
              if (t.properties.lineOption !== k.ConnectorLineOption.Orthogonal || 2 === t.points.length || !e || !e.length) return !1;
              for (var n, o = 0; n = e[o];) {
                if (this.isShapeIntersectConnectorCustomPoints(n, t)) return !0;
                o++;
              }
              return !1;
            }, t.tryRemoveConnectorIntermediatePoints = function (t, e) {
              this.shouldRemoveConnectorIntermediatePoints(e, [e.beginItem, e.endItem]) && this.deleteConnectorCustomPoints(t, e);
            }, t.isShapeIntersectConnectorCustomPoints = function (t, e) {
              if (!t) return !1;
              var n = e.getCustomRenderPoints(!0);
              if (!n.length) return !1;
              var i = U.Connector.minOffset - o.UnitConverter.pixelsToTwips(1);
              return z.GeometryUtils.areIntersectedSegments(z.GeometryUtils.createSegments(n), z.GeometryUtils.createSegmentsFromRectangle(t.rectangle.clone().inflate(i, i)));
            }, t.getSnappedPos = function (t, e, n, o) {
              var i = o ? t.snapStartPoint.x : t.snapStartPoint.y;
              return Math.round((n - i) / e) * e + i;
            }, t.tryUpdateModelRectangle = function (t, e) {
              var n = t.modelManipulator.getModelSizeUpdateOffset();
              n.isEmpty() || (t.addAndRedo(new T.ModelResizeHistoryItem(n)), (n.left || n.top) && (t.addAndRedo(new O.UpdatePositionsOnPageResizeHistoryItem(new c.Vector(n.left, n.top))), void 0 !== e && e(n.left, n.top)), t.modelManipulator.raiseModelRectangleChanged(t.modelManipulator.model.getRectangle(!0)));
            }, t.deleteItems = function (t, e, n, o, i) {
              t.beginTransaction();
              var r = {};
              o.forEach(function (t) {
                return r[t.key] = t;
              });
              var s = n.getKeys().filter(function (t) {
                return !r[t];
              });
              t.addAndRedo(new I.SetSelectionHistoryItem(n, s)), this.deleteItemsCore(t, e, o, i), this.tryUpdateModelRectangle(t), t.endTransaction();
            }, t.deleteItemsCore = function (t, e, n, o) {
              var i = this;
              n.sort(function (t, e) {
                return (t instanceof U.Connector ? 0 : 1) - (e instanceof U.Connector ? 0 : 1);
              }), n.forEach(function (n) {
                if (n.container && i.removeFromContainer(t, e, n), n instanceof K.Shape) {
                  var r = e.getChildren(n);
                  r.length && (r.forEach(function (n) {
                    t.addAndRedo(new b.RemoveFromContainerHistoryItem(n)), i.updateAttachedConnectorsContainer(t, e, n);
                  }), i.deleteItemsCore(t, e, r.filter(function (t) {
                    return !t.locked || o;
                  }), o)), e.findItem(n.key) && i.deleteShape(t, n);
                }
                n instanceof U.Connector && e.findItem(n.key) && i.deleteConnector(t, n);
              });
            }, t.detachConnectors = function (t, e) {
              for (t.beginTransaction(); e.attachedConnectors.length > 0;) {
                var n = e.attachedConnectors[0];
                t.addAndRedo(new m.DeleteConnectionHistoryItem(n, n.beginItem === e ? U.ConnectorPosition.Begin : U.ConnectorPosition.End));
              }
              t.endTransaction();
            }, t.deleteShape = function (t, e) {
              var n = t.modelManipulator.permissionsProvider.canDeleteItems([e]);
              t.beginTransaction(), this.detachConnectors(t, e), t.addAndRedo(new P.DeleteShapeHistoryItem(e.key, n)), t.endTransaction();
            }, t.deleteConnector = function (t, e) {
              t.beginTransaction(), e.beginItem && t.addAndRedo(new m.DeleteConnectionHistoryItem(e, U.ConnectorPosition.Begin)), e.endItem && t.addAndRedo(new m.DeleteConnectionHistoryItem(e, U.ConnectorPosition.End)), t.addAndRedo(new v.DeleteConnectorHistoryItem(e.key)), t.endTransaction();
            }, t.deleteAllItems = function (t, e, n) {
              this.deleteItems(t, e, n, e.items.slice(), !0);
            }, t.deleteSelection = function (t, e, n) {
              this.deleteItems(t, e, n, n.getSelectedItems());
            }, t.changeSelectionLocked = function (e, n, o, i) {
              e.beginTransaction(), o.getSelectedItems(!0).forEach(function (t) {
                e.addAndRedo(new D.ChangeLockedHistoryItem(t, i));
              }), t.updateSelection(e, o), e.endTransaction();
            }, t.copyStylesToItem = function (t, e, n, o) {
              var i = e.findItem(o);
              n.styleText.forEach(function (e) {
                n.styleText[e] !== i.styleText[e] && t.addAndRedo(new R.ChangeStyleTextHistoryItem(o, e, n.styleText[e]));
              }), n.style.forEach(function (e) {
                n.style[e] !== i.style[e] && t.addAndRedo(new A.ChangeStyleHistoryItem(o, e, n.style[e]));
              });
            }, t.updateSelection = function (t, e) {
              t.addAndRedo(new I.SetSelectionHistoryItem(e, e.getKeys(), !0));
            }, t.cloneShapeToOffset = function (t, e, n, o, i) {
              t.beginTransaction();
              var r = n.position.clone().offset(o, i),
                s = new f.AddShapeHistoryItem(n.description, r, n.text);
              t.addAndRedo(s);
              var a = s.shapeKey;
              return t.addAndRedo(new w.ResizeShapeHistoryItem(a, r, n.size.clone())), t.addAndRedo(new M.ChangeCustomDataHistoryItem(a, z.ObjectUtils.cloneObject(n.customData))), t.addAndRedo(new g.ChangeShapeParametersHistoryItem(a, n.parameters.clone())), this.copyStylesToItem(t, e, n, a), t.endTransaction(), a;
            }, t.applyOffsetToConnectorRenderPointsContext = function (t, e, n) {
              return t && t.renderPoints ? new H.ConnectorRenderPointsContext(t.renderPoints.map(function (t) {
                return t.clone().offset(e, n);
              }), !0, t.actualRoutingMode) : void 0;
            }, t.cloneConnectorToOffset = function (t, e, n, o, i, r, s) {
              t.beginTransaction();
              var a = n.points.map(function (t) {
                  return t.clone().offset(r, s);
                }),
                c = new l.AddConnectorHistoryItem(a, void 0, this.applyOffsetToConnectorRenderPointsContext(n.tryCreateRenderPointsContext(), r, s));
              t.addAndRedo(c);
              var u = c.connectorKey,
                p = e.findConnector(u);
              if (n.properties.forEach(function (e) {
                n.properties[e] !== p.properties[e] && t.addAndRedo(new _.ChangeConnectorPropertyHistoryItem(u, e, n.properties[e]));
              }), o) {
                var d = e.findShape(o);
                t.addAndRedo(new h.AddConnectionHistoryItem(p, d, n.beginConnectionPointIndex, U.ConnectorPosition.Begin));
              }
              if (i) {
                var f = e.findShape(i);
                t.addAndRedo(new h.AddConnectionHistoryItem(p, f, n.endConnectionPointIndex, U.ConnectorPosition.End));
              }
              return n.texts.clone().forEach(function (e) {
                t.addAndRedo(new E.ChangeConnectorTextHistoryItem(p, e.position, e.value));
              }), this.copyStylesToItem(t, e, n, u), t.endTransaction(), u;
            }, t.cloneSelectionToOffset = function (e, n, o, i, r, s) {
              var a = this;
              e.beginTransaction();
              var c = {},
                u = [];
              i.getSelectedShapes().forEach(function (t) {
                var i = a.cloneShapeToOffset(e, n, t, r, s);
                c[t.key] = i, u.push(i), o && o(i);
              }), i.getSelectedConnectors().forEach(function (t) {
                var i = t.beginItem ? c[t.beginItem.key] : null,
                  p = t.endItem ? c[t.endItem.key] : null,
                  h = a.cloneConnectorToOffset(e, n, t, i, p, r, s);
                u.push(h), o && o(h);
              }), e.addAndRedo(new I.SetSelectionHistoryItem(i, u)), t.tryUpdateModelRectangle(e), e.endTransaction();
            }, t.findContainerByEventKey = function (e, n, o) {
              var i = e.findContainer(o);
              if (i && !i.isLocked) return i;
              var r = e.findShape(o);
              return r && r.container && !n.hasKey(r.key) ? t.findContainerByEventKey(e, n, r.container.key) : void 0;
            }, t.canInsertToContainer = function (t, e, n) {
              return e !== n && !(e instanceof K.Shape && t.findChild(e, n.key));
            }, t.canInsertSelectionToContainer = function (t, e, n) {
              var o = !0;
              return e.getSelectedItems().forEach(function (e) {
                e !== n ? e instanceof K.Shape && t.findChild(e, n.key) && (o = !1) : o = !1;
              }), o;
            }, t.insertToContainer = function (t, e, n, o) {
              if (!o.enableChildren) throw Error("Inpossible to add children to non-container shape.");
              if (this.canInsertToContainer(e, n, o)) {
                var i = n.container;
                i !== o && (t.beginTransaction(), i && (t.addAndRedo(new b.RemoveFromContainerHistoryItem(n)), n.attachedConnectors.forEach(function (e) {
                  e.container && t.addAndRedo(new b.RemoveFromContainerHistoryItem(e));
                })), t.addAndRedo(new C.InsertToContainerHistoryItem(n, o)), this.updateAttachedConnectorsContainer(t, e, n), t.endTransaction());
              }
            }, t.removeFromContainer = function (t, e, n) {
              n.container && (t.beginTransaction(), t.addAndRedo(new b.RemoveFromContainerHistoryItem(n)), this.updateAttachedConnectorsContainer(t, e, n), t.endTransaction());
            }, t.insertSelectionToContainer = function (t, e, n, o) {
              var i = this;
              t.beginTransaction();
              var r = n.getSelectedItems();
              r.filter(function (t) {
                return !t.container || -1 === r.indexOf(t.container);
              }).forEach(function (n) {
                i.insertToContainer(t, e, n, o);
              }), t.endTransaction();
            }, t.removeSelectionFromContainer = function (t, e, n) {
              var o = this;
              t.beginTransaction(), n.getSelectedItems().forEach(function (i) {
                i.container && !n.hasKey(i.container.key) && (t.addAndRedo(new b.RemoveFromContainerHistoryItem(i)), o.updateAttachedConnectorsContainer(t, e, i));
              }), t.endTransaction();
            }, t.getConnectorContainer = function (t) {
              if (t.beginItem && t.endItem) {
                for (var e = {}, n = t.beginItem.container; n;) e[n.key] = !0, n = n.container;
                for (var o = t.endItem.container; o;) {
                  if (void 0 !== e[o.key]) return o;
                  o = o.container;
                }
              }
            }, t.updateAttachedConnectorsContainer = function (t, e, n) {
              var o = this;
              t.beginTransaction(), n.attachedConnectors.forEach(function (n) {
                o.updateConnectorContainer(t, e, n);
              }), t.endTransaction();
            }, t.updateConnectorContainer = function (t, e, n) {
              var o = this.getConnectorContainer(n);
              o ? t.addAndRedo(new C.InsertToContainerHistoryItem(n, o)) : n.container && t.addAndRedo(new b.RemoveFromContainerHistoryItem(n));
            }, t.updateNewShapeProperties = function (t, e, n) {
              e.inputPosition.getDefaultStyle().forEach(function (o) {
                t.addAndRedo(new A.ChangeStyleHistoryItem(n, o, e.inputPosition.getDefaultStylePropertyValue(o)));
              }), e.inputPosition.getDefaultTextStyle().forEach(function (o) {
                t.addAndRedo(new R.ChangeStyleTextHistoryItem(n, o, e.inputPosition.getDefaultTextStylePropertyValue(o)));
              });
            }, t.updateNewConnectorProperties = function (t, e, n) {
              e.inputPosition.getDefaultConnectorProperties().forEach(function (o) {
                t.addAndRedo(new _.ChangeConnectorPropertyHistoryItem(n, o, e.inputPosition.getDefaultConnectorPropertyValue(o)));
              }), e.inputPosition.getDefaultStyle().forEach(function (o) {
                t.addAndRedo(new A.ChangeStyleHistoryItem(n, o, e.inputPosition.getDefaultStylePropertyValue(o)));
              }), e.inputPosition.getDefaultTextStyle().forEach(function (o) {
                t.addAndRedo(new R.ChangeStyleTextHistoryItem(n, o, e.inputPosition.getDefaultTextStylePropertyValue(o)));
              });
            }, t.applyLayout = function (t, e, n, o, i, r, s, a, c, u) {
              t.beginTransaction();
              var p = this.getOccupiedRectangles(r, n);
              return i = this.offsetLayoutToFreeSpace(i, n && n.clientRectangle, p, s.containerPadding), a && this.adjustLayoutToSnapGrid(e, i, c), n && this.resizeContainerOnLayout(t, e, i, n, s.containerPadding), this.applyLayoutToNodes(t, e, i, o.edges.map(function (t) {
                return e.findConnector(t.key);
              })), this.applyLayoutToConnectors(t, e, i, o.edges.map(function (t) {
                return e.findConnector(t.key);
              }), u), t.endTransaction(), i.getRectangle(!0);
            }, t.getNonGraphItems = function (t, e, n, o, i) {
              return (e ? t.getChildren(e) : t.items.filter(function (t) {
                return !t.container;
              })).filter(function (t) {
                return t instanceof U.Connector ? !(t.beginItem && n[t.beginItem.key] || t.endItem && n[t.endItem.key] || -1 !== i.indexOf(t)) : t instanceof K.Shape ? !n[t.key] && -1 === o.indexOf(t) : void 0;
              });
            }, t.getOccupiedRectangles = function (t, e) {
              var n = t.map(function (t) {
                return t.rectangle;
              });
              if (e && n.length) {
                var o = e.clientRectangle;
                n.push(new s.Rectangle(o.right, o.y, 1, 1)), n.push(new s.Rectangle(o.right, o.bottom, 1, 1));
              }
              return n;
            }, t.offsetLayoutToFreeSpace = function (t, e, n, o) {
              var i = t.getRectangle(!0),
                r = z.GeometryUtils.findFreeSpace(n, i.createSize().offset(o, o).nonNegativeSize(), !1, e);
              if (r) {
                var s = r.x + o,
                  a = r.y + o;
                return t.offsetNodes(s, a);
              }
              var c = n && n.length ? n.reduce(function (t, e) {
                  return e.right > t ? e.right : t;
                }, 0) : e ? e.x : 0,
                u = e ? e.y : Math.max(0, i.y);
              return t.offsetNodes(c + o, u + o);
            }, t.resizeContainerOnLayout = function (e, n, o, i, r) {
              var s = o.getRectangle(!0),
                c = i.children.filter(function (t) {
                  return t instanceof K.Shape ? -1 === o.nodeKeys.indexOf(t.key) : !!(t instanceof U.Connector && t.beginItem && t.endItem) && -1 === o.nodeKeys.indexOf(t.beginItem.key) && -1 === o.nodeKeys.indexOf(t.endItem.key);
                }).map(function (t) {
                  return t.rectangle;
                }),
                u = c.map(function (t) {
                  return t.right;
                }).reduce(function (t, e) {
                  return Math.max(t, e);
                }, s.right),
                p = c.map(function (t) {
                  return t.bottom;
                }).reduce(function (t, e) {
                  return Math.max(t, e);
                }, s.bottom),
                h = i.rectangle.width + u + r - i.rectangle.right,
                l = i.rectangle.height + p + r - i.rectangle.bottom;
              t.setShapeSize(e, n, i, i.position, new a.Size(h, l)), t.updateShapeAttachedConnectors(e, n, i);
            }, t.applyLayoutToNodes = function (t, e, n, o) {
              var i = this,
                r = o.reduce(function (t, e) {
                  return t[e.key] = t;
                }, {});
              n.forEachNode(function (n, o) {
                var s = e.findShape(o);
                i.applyLayoutToNode(t, e, s, n.position, r);
              });
            }, t.applyLayoutToNode = function (e, n, o, i, r) {
              var s = this,
                a = i.clone().offset(-o.position.x, -o.position.y);
              t.setShapePosition(e, n, o, i, !1), 0 === a.x && 0 === a.y || (o.attachedConnectors.filter(function (t) {
                return !r[t.key];
              }).forEach(function (t) {
                s.updateConnectorAttachedPoints(e, n, t);
                for (var o = t.beginItem ? 1 : 0, i = t.endItem ? t.points.length - 2 : t.points.length - 1, r = o; r <= i; r++) s.moveConnectorPoint(e, t, r, t.points[r].offset(a.x, a.y));
              }), n.getChildren(o).forEach(function (t) {
                if (t instanceof K.Shape) {
                  var o = t.position.clone().offset(a.x, a.y);
                  s.applyLayoutToNode(e, n, t, o, r);
                }
              }));
            }, t.applyLayoutToConnectors = function (t, e, n, o, i) {
              var r = this;
              o.filter(function (t) {
                return t.beginItem || t.endItem;
              }).forEach(function (o) {
                var s = n.edgeToPosition[o.key];
                if (o.beginItem && o.endItem && !i && s) {
                  var a = o.beginItem.getConnectionPointIndexForSide(s.beginIndex);
                  a !== o.beginConnectionPointIndex && t.addAndRedo(new h.SetConnectionPointIndexHistoryItem(o, a, U.ConnectorPosition.Begin));
                  var c = o.endItem.getConnectionPointIndexForSide(s.endIndex);
                  c !== o.endConnectionPointIndex && t.addAndRedo(new h.SetConnectionPointIndexHistoryItem(o, c, U.ConnectorPosition.End));
                }
                r.updateConnectorAttachedPoints(t, e, o), s && r.deleteConnectorCustomPoints(t, o);
              });
            }, t.adjustLayoutToSnapGrid = function (t, e, n) {
              var o = this;
              e.nodeKeys.forEach(function (i) {
                e.nodeToLayout[i].position.x = o.getSnappedPos(t, n, e.nodeToLayout[i].position.x, !0), e.nodeToLayout[i].position.y = o.getSnappedPos(t, n, e.nodeToLayout[i].position.y, !1);
              });
            }, t.getGraphInfoByItems = function (t, e, n, o) {
              void 0 === o && (o = !0);
              var i = {};
              [].concat(e).concat(n).forEach(function (t) {
                var e = t.container && t.container.key;
                i[e] || (i[e] = []), i[e].push(t);
              });
              var r = [];
              for (var s in i) if (Object.prototype.hasOwnProperty.call(i, s)) {
                var a = s && t.findContainer(s);
                if (!a || a.expanded && !t.findItemCollapsedContainer(a)) {
                  var c = a && a.key,
                    u = this.getGraphByItems(t, i[s], c, !o),
                    p = !1;
                  (u.nodes.length > 1 || u.nodes.length && (o || a && i[a.container && a.container.key])) && (p = !0), p && r.push(new L.GraphInfo(a, u));
                }
              }
              return r.sort(function (t, e) {
                return e.level - t.level;
              });
            }, t.getGraphByItems = function (t, e, n, o) {
              var i = this,
                r = new j.Graph([], []),
                s = {};
              return e.forEach(function (t) {
                i.extendByConnectedComponents(t, r, n, s, o);
              }), r.nodes.sort(function (e, n) {
                return t.getItemIndex(t.findItem(e)) - t.getItemIndex(t.findItem(n));
              }), r.edges.sort(function (e, n) {
                return t.getItemIndex(t.findItem(e.key)) - t.getItemIndex(t.findItem(n.key));
              }), r.edges = r.edges.filter(function (t) {
                return r.getNode(t.from) && r.getNode(t.to);
              }), r;
            }, t.extendByConnectedComponents = function (t, e, n, o, i) {
              var r = this;
              !t || i && t.locked || o[t.key] || (o[t.key] = !0, !(t instanceof U.Connector && (t.container && t.container.key) === n && t.beginItem) || t.beginItem.locked && i || !t.endItem || t.endItem.locked && i || t.beginItem === t.endItem ? t instanceof K.Shape && (t.container && t.container.key) === n && (e.addNode(t), t.attachedConnectors.forEach(function (t) {
                return r.extendByConnectedComponents(t, e, n, o, i);
              })) : (e.addEdge(new N.Edge(t.key, t.beginItem && t.beginItem.key, t.endItem && t.endItem.key)), this.extendByConnectedComponents(t.beginItem, e, n, o, i), this.extendByConnectedComponents(t.endItem, e, n, o, i)));
            }, t.getlUnitValue = function (t, e) {
              switch (t) {
                case p.DiagramUnit.Cm:
                  return o.UnitConverter.twipsToCentimeters(e);
                case p.DiagramUnit.In:
                  return o.UnitConverter.twipsToInches(e);
                case p.DiagramUnit.Px:
                  return o.UnitConverter.twipsToPixels(e);
              }
            }, t.getUnitText = function (t, e, n, o, i) {
              void 0 === i && (i = 2);
              var r = e[t] ? " " + e[t] : "",
                s = this.getlUnitValue(t, o);
              switch (t) {
                case p.DiagramUnit.Cm:
                case p.DiagramUnit.In:
                  return n(+s.toFixed(i)) + r;
                case p.DiagramUnit.Px:
                  return n(+s.toFixed(0)) + r;
              }
            }, t.getTwipsValue = function (t, e) {
              switch (t) {
                case p.DiagramUnit.Cm:
                  return o.UnitConverter.centimetersToTwips(e);
                case p.DiagramUnit.In:
                  return o.UnitConverter.inchesToTwips(e);
                case p.DiagramUnit.Px:
                  return o.UnitConverter.pixelsToTwips(e);
              }
            }, t.getGuidItemKey = function () {
              return u.MathUtils.generateGuid();
            }, t.createSelectedItems = function (t) {
              var e = {};
              return t.getSelectedItems(!0).forEach(function (t) {
                return e[t.key] = t;
              }), e;
            }, t.canMoveConnector = function (t, e) {
              var n = e.beginItem,
                o = e.endItem;
              return n || o ? !!t[e.key] && (n === o ? !!t[n.key] : n ? o ? !!t[n.key] && !!t[o.key] : !!t[n.key] : !!t[o.key]) : !e.isLocked;
            }, t.createRectangle = function (t) {
              return z.GeometryUtils.getCommonRectangle(t.map(function (t) {
                return t.rectangle;
              }));
            }, t.changeShapeType = function (t, e, n, o) {
              if (n.description.key === o) return !1;
              t.beginTransaction();
              var i = n.getConnectionPoints(),
                r = i.map(function (t) {
                  return n.getConnectionPointSide(t);
                });
              t.addAndRedo(new V.ChangeShapeTypeHistoryItem(n, o));
              for (var s = n.getConnectionPoints(), a = s.map(function (t) {
                  return n.getConnectionPointSide(t);
                }), c = 0, u = void 0; u = n.attachedConnectors[c]; c++) u.beginItem === n && this.updateConnectionIndexByNewShapeType(t, u, U.ConnectorPosition.Begin, u.beginConnectionPointIndex, i, r, s, a), u.endItem === n && this.updateConnectionIndexByNewShapeType(t, u, U.ConnectorPosition.End, u.endConnectionPointIndex, i, r, s, a), this.updateConnectorAttachedPoints(t, e, u);
              return t.endTransaction(), !0;
            }, t.updateConnectionIndexByNewShapeType = function (t, e, n, o, i, r, s, a) {
              if (!(o < 0)) {
                var c = r[o],
                  u = i[o];
                if (!(o < s.length && c === a[o])) {
                  var p = this.findNearestPointIndex(s, u, function (t) {
                    return a[t] === c;
                  });
                  -1 === p && (p = this.findNearestPointIndex(s, u, function () {
                    return !0;
                  })), p !== o && t.addAndRedo(new h.SetConnectionPointIndexHistoryItem(e, p, n));
                }
              }
            }, t.findNearestPointIndex = function (t, e, n) {
              return t.reduce(function (o, r, s) {
                if (n(s)) {
                  var a = i.Metrics.euclideanDistance(e, t[s]);
                  (-1 === o.index || o.distance > a) && (o.index = s, o.distance = a);
                }
                return o;
              }, {
                distance: Number.MAX_SAFE_INTEGER,
                index: -1
              }).index;
            }, t.connectionPointActionSize = o.UnitConverter.pixelsToTwips(8), t;
          }();
        e.ModelUtils = F;
      },
      1930: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.FileUtils = void 0;
        var o = n(8424),
          i = n(807),
          r = n(961),
          s = function () {
            function t() {}
            return t.loadJavascriptFile = function (t, e) {
              var n,
                o = document.getElementsByTagName("head")[0];
              if (!o) {
                o = document.createElement("head");
                var i = document.getElementsByTagName("body")[0];
                null === (n = i.parentNode) || void 0 === n || n.insertBefore(o, i);
              }
              var r = document.createElement("script");
              return r.onload = e, r.src = t, o.appendChild(r), {
                htmlScriptElement: r
              };
            }, t.startDownloadFileLocal = function (t, e) {
              if (t instanceof ArrayBuffer && (t = i.Base64Utils.fromArrayBuffer(t)), r.isString(t) && (t = i.Base64Utils.getFileFromBase64(t)), window.navigator.msSaveOrOpenBlob) window.navigator.msSaveOrOpenBlob(t, e);else {
                var n = document.createElement("a"),
                  o = URL.createObjectURL(t);
                n.href = o, n.download = e, document.body.appendChild(n), n.click(), setTimeout(function () {
                  document.body.removeChild(n), window.URL.revokeObjectURL(o);
                }, 0);
              }
            }, t.createFile = function (t, e, n) {
              var i;
              if (o.Browser.IE || o.Browser.Edge && o.Browser.MajorVersion < 86) {
                var r = new Blob(t, n);
                return r.lastModifiedDate = null !== (i = null == n ? void 0 : n.lastModified) && void 0 !== i ? i : Date.now(), r.name = e, r;
              }
              return new File(t, e, n);
            }, t.isFile = function (t) {
              return o.Browser.IE || o.Browser.Edge && o.Browser.MajorVersion < 86 ? t instanceof File || t instanceof Blob && r.isDefined(t.name) : t instanceof File;
            }, t;
          }();
        e.FileUtils = s;
      },
      1932: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ChangeStrokeStyleCommand = void 0;
        var r = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(e, t), e.prototype.getStyleProperty = function () {
            return "stroke-dasharray";
          }, e;
        }(n(5963).ChangeStylePropertyCommand);
        e.ChangeStrokeStyleCommand = r;
      },
      1960: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ConnectorLineEndingFilledTriangleStrategy = e.ConnectorLineEndingOutlinedTriangleStrategy = e.ConnectorLineEndingArrowStrategy = e.ConnectorLineEndingNoneStrategy = e.ConnectorLineEndingStrategy = void 0;
        var r = n(41),
          s = n(6208),
          a = function () {
            function t(t) {
              this.style = t;
            }
            return t.prototype.hasCommands = function () {
              return !0;
            }, t.prototype.needCreateSeparatePrimitive = function () {
              return !1;
            }, t.prototype.createPrimitive = function () {
              return new s.PathPrimitive([], this.getStyle(), this.getCssClass());
            }, t.prototype.createCommands = function (t, e) {
              return [];
            }, t.prototype.getStyle = function () {
              var t = this.style.clone();
              return t.resetStrokeDashArray(), t;
            }, t.prototype.getCssClass = function () {}, t;
          }();
        e.ConnectorLineEndingStrategy = a;
        var c = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(e, t), e.prototype.hasCommands = function () {
            return !1;
          }, e;
        }(a);
        e.ConnectorLineEndingNoneStrategy = c;
        var u = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(e, t), Object.defineProperty(e.prototype, "arrowHeight", {
            get: function () {
              return 6 * this.style.strokeWidth;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "arrowWidth", {
            get: function () {
              return 2 * this.style.strokeWidth;
            },
            enumerable: !1,
            configurable: !0
          }), e.prototype.needCreateSeparatePrimitive = function () {
            return !this.style.isDefaultStrokeDashArray();
          }, e.prototype.createCommands = function (t, e) {
            var n = this.getArrowPoints(t, e),
              o = [new s.PathPrimitiveMoveToCommand(n.point1.x, n.point1.y), new s.PathPrimitiveLineToCommand(t.x, t.y), new s.PathPrimitiveLineToCommand(n.point2.x, n.point2.y)];
            return this.style.isDefaultStrokeDashArray() || (o = o.concat([new s.PathPrimitiveMoveToCommand(t.x, t.y), new s.PathPrimitiveLineToCommand(n.point3.x, n.point3.y)])), o;
          }, e.prototype.getArrowPoints = function (t, e) {
            var n,
              o = this.arrowHeight;
            t.x === e.x && (n = Math.abs(t.y - e.y)) < o && (o = n);
            t.y === e.y && (n = Math.abs(t.x - e.x)) < o && (o = n);
            return r.GeometryUtils.getArrowPoints(t, e, o, this.arrowWidth);
          }, e;
        }(a);
        e.ConnectorLineEndingArrowStrategy = u;
        var p = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(e, t), e.prototype.needCreateSeparatePrimitive = function () {
            return !0;
          }, e.prototype.createCommands = function (t, e) {
            var n = this.getArrowPoints(t, e);
            return [new s.PathPrimitiveMoveToCommand(n.point1.x, n.point1.y), new s.PathPrimitiveLineToCommand(t.x, t.y), new s.PathPrimitiveLineToCommand(n.point2.x, n.point2.y), new s.PathPrimitiveClosePathCommand()];
          }, e.prototype.getCssClass = function () {
            return "outlined-line-ending";
          }, e;
        }(u);
        e.ConnectorLineEndingOutlinedTriangleStrategy = p;
        var h = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(e, t), e.prototype.getStyle = function () {
            var e = t.prototype.getStyle.call(this);
            return e.fill = e.stroke, e;
          }, e.prototype.getCssClass = function () {
            return "filled-line-ending";
          }, e;
        }(p);
        e.ConnectorLineEndingFilledTriangleStrategy = h;
      },
      1988: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MouseHandlerMoveConnectorOrthogonalSideState = void 0;
        var r = n(5327),
          s = n(6320),
          a = n(4824),
          c = n(1922),
          u = n(2815),
          p = n(41),
          h = function (t) {
            function e(e, n, o) {
              var i = t.call(this, e, n) || this;
              return i.model = o, i.canCreatePoints = !0, i;
            }
            return i(e, t), e.prototype.saveSidePoints = function (t, e) {
              var n = this,
                o = this.connector.getRenderPoints(!0);
              this.isHorizontal = o[t].y === o[e].y, this.iterateRenderPoints(o, t, !1, function (t, e) {
                -1 !== t.pointIndex && (n.leftPointIndex = t.pointIndex), n.leftRenderPointIndex = e;
              }, function (e) {
                return !p.GeometryUtils.arePointsOfOrthogonalLine(o[t], e, n.isHorizontal);
              }), this.iterateRenderPoints(o, this.leftRenderPointIndex, !0, function (t, e) {
                -1 !== t.pointIndex && (n.rightPointIndex = t.pointIndex), n.rightRenderPointIndex = e;
              }, function (e) {
                return !p.GeometryUtils.arePointsOfOrthogonalLine(o[t], e, n.isHorizontal);
              });
            }, e.prototype.iterateRenderPoints = function (t, e, n, o, i) {
              for (var r = e; n ? r < t.length : r >= 0; n ? r++ : r--) {
                var s = t[r];
                if (i && i(s, r)) break;
                o(s, r);
              }
            }, e.prototype.onMouseDown = function (e) {
              this.startPoint = e.modelPoint, this.connector = this.model.findConnector(e.source.key), this.handler.addInteractingItem(this.connector);
              var n = e.source.value.split("_");
              this.saveSidePoints(parseInt(n[0]), parseInt(n[1])), t.prototype.onMouseDown.call(this, e);
            }, e.prototype.shouldCreatePoint = function (t) {
              if (!this.canCreatePoints) return !1;
              if (t && (void 0 === this.leftPointIndex || 0 === this.leftPointIndex)) return !0;
              if (!t && (void 0 === this.rightPointIndex || this.rightPointIndex === this.connector.points.length - 1)) return !0;
              var e = this.connector.getRenderPoints(!0);
              return !(!t || this.connector.points[this.leftPointIndex].equals(e[this.leftRenderPointIndex])) || !t && !this.connector.points[this.rightPointIndex].equals(e[this.rightRenderPointIndex]);
            }, e.prototype.onApplyChanges = function (t) {
              var e = this;
              if (this.shouldCreatePoint(!0) || this.shouldCreatePoint(!1)) {
                var n = this.connector.getRenderPoints(!0),
                  o = n[this.leftRenderPointIndex],
                  i = n[this.rightRenderPointIndex];
                if (this.shouldCreatePoint(!0)) {
                  var s = new r.Point(o.x, o.y);
                  0 === this.leftPointIndex ? (this.leftPointIndex = 1, this.correctEdgePoint(s, i, this.connector.beginItem, this.connector.beginConnectionPointIndex)) : void 0 === this.leftPointIndex && this.iterateRenderPoints(n, this.leftRenderPointIndex, !0, function (t) {
                    -1 !== t.pointIndex && (e.leftPointIndex = t.pointIndex);
                  }, function () {
                    return void 0 !== e.leftPointIndex;
                  }), c.ModelUtils.addConnectorPoint(this.history, this.connector.key, this.leftPointIndex, s), void 0 !== this.rightPointIndex && this.rightPointIndex++;
                }
                if (this.shouldCreatePoint(!1)) {
                  n = this.connector.getRenderPoints(!0);
                  var a = new r.Point(i.x, i.y);
                  this.rightPointIndex === this.connector.points.length - 1 ? (this.correctEdgePoint(a, o, this.connector.endItem, this.connector.endConnectionPointIndex), this.rightPointIndex--) : void 0 === this.rightPointIndex && this.iterateRenderPoints(n, this.rightRenderPointIndex, !1, function (t) {
                    -1 !== t.pointIndex && (e.rightPointIndex = t.pointIndex);
                  }, function () {
                    return e.rightPointIndex === e.leftPointIndex;
                  }), this.rightPointIndex++, c.ModelUtils.addConnectorPoint(this.history, this.connector.key, this.rightPointIndex, a);
                }
              }
              this.canCreatePoints = !1;
              var u = this.getSnappedPoint(t, t.modelPoint);
              c.ModelUtils.moveConnectorRightAnglePoints(this.history, this.connector, this.leftPointIndex, this.rightPointIndex, this.isHorizontal ? void 0 : u.x, this.isHorizontal ? u.y : void 0), this.handler.tryUpdateModelSize();
            }, e.prototype.onFinishWithChanges = function () {
              c.ModelUtils.deleteConnectorUnnecessaryPoints(this.history, this.connector), c.ModelUtils.fixConnectorBeginEndConnectionIndex(this.history, this.connector), this.handler.tryUpdateModelSize();
            }, e.prototype.correctEdgePoint = function (t, e, n, o) {
              var i = 0;
              if (n) {
                var r = n.getConnectionPointSideByIndex(o),
                  c = n.rectangle;
                switch (i = s.Connector.minOffset, r) {
                  case a.ConnectionPointSide.South:
                    i += c.bottom - t.y;
                    break;
                  case a.ConnectionPointSide.North:
                    i += t.y - c.y;
                    break;
                  case a.ConnectionPointSide.East:
                    i += c.right - t.x;
                    break;
                  case a.ConnectionPointSide.West:
                    i += t.x - c.x;
                }
              }
              this.isHorizontal ? t.x > e.x ? t.x -= Math.min(i, t.x - e.x) : t.x += Math.min(i, e.x - t.x) : t.y > e.y ? t.y -= Math.min(i, t.y - e.y) : t.y += Math.min(i, e.y - t.y);
            }, e.prototype.getDraggingElementKeys = function () {
              return [this.connector.key];
            }, e;
          }(u.MouseHandlerDraggingState);
        e.MouseHandlerMoveConnectorOrthogonalSideState = h;
      },
      1998: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MoveStepDownCommand = e.MoveDownCommand = e.MoveStepUpCommand = e.MoveUpCommand = e.MoveStepRightCommand = e.MoveRightCommand = e.MoveStepLeftCommand = e.MoveLeftCommand = e.MoveCommand = void 0;
        var r = n(5327),
          s = n(1922),
          a = n(9500),
          c = n(3913),
          u = n(1416),
          p = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), e.prototype.isEnabled = function () {
              return t.prototype.isEnabled.call(this) && !this.control.selection.isEmpty();
            }, e.prototype.executeCore = function (t, e) {
              var n = this;
              this.control.history.beginTransaction();
              var o = this.control.selection,
                i = new u.SelectionDragHelper(this.control.history, this.control.model, this.permissionsProvider, new r.Point(0, 0), o.getSelectedItems(!0));
              return i.initDraggingShapes(o.getSelectedShapes(!1, !0), !1), i.initDraggingConnectors(o.getSelectedConnectors(!1, !0), !1), i.move(!1, function (t) {
                return n.getPosition(t);
              }, function () {}, function () {}), i.finish(), s.ModelUtils.tryUpdateModelRectangle(this.control.history, function (t, e) {
                return i.onTryUpdateModelSize(t, e);
              }), this.control.history.endTransaction(), !0;
            }, Object.defineProperty(e.prototype, "isPermissionsRequired", {
              get: function () {
                return !0;
              },
              enumerable: !1,
              configurable: !0
            }), e;
          }(c.SimpleCommandBase);
        e.MoveCommand = p;
        var h = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(e, t), e.prototype.getPosition = function (t) {
            return t.clone().offset(-a.UnitConverter.pixelsToTwips(1), 0);
          }, e;
        }(p);
        e.MoveLeftCommand = h;
        var l = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(e, t), e.prototype.getPosition = function (t) {
            return this.control.settings.snapToGrid ? new r.Point(s.ModelUtils.getSnappedPos(this.control.model, this.control.settings.gridSize, t.x - (this.control.settings.gridSize / 2 + 2), !0), t.y) : t.clone().offset(-this.control.settings.gridSize, 0);
          }, e;
        }(p);
        e.MoveStepLeftCommand = l;
        var d = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(e, t), e.prototype.getPosition = function (t) {
            return t.clone().offset(a.UnitConverter.pixelsToTwips(1), 0);
          }, e;
        }(p);
        e.MoveRightCommand = d;
        var f = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(e, t), e.prototype.getPosition = function (t) {
            return this.control.settings.snapToGrid ? new r.Point(s.ModelUtils.getSnappedPos(this.control.model, this.control.settings.gridSize, t.x + (this.control.settings.gridSize / 2 + 2), !0), t.y) : t.clone().offset(this.control.settings.gridSize, 0);
          }, e;
        }(p);
        e.MoveStepRightCommand = f;
        var y = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(e, t), e.prototype.getPosition = function (t) {
            return t.clone().offset(0, -a.UnitConverter.pixelsToTwips(1));
          }, e;
        }(p);
        e.MoveUpCommand = y;
        var g = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(e, t), e.prototype.getPosition = function (t) {
            return this.control.settings.snapToGrid ? new r.Point(t.x, s.ModelUtils.getSnappedPos(this.control.model, this.control.settings.gridSize, t.y - (this.control.settings.gridSize / 2 + 2), !1)) : t.clone().offset(0, -this.control.settings.gridSize);
          }, e;
        }(p);
        e.MoveStepUpCommand = g;
        var m = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(e, t), e.prototype.getPosition = function (t) {
            return t.clone().offset(0, a.UnitConverter.pixelsToTwips(1));
          }, e;
        }(p);
        e.MoveDownCommand = m;
        var v = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(e, t), e.prototype.getPosition = function (t) {
            return this.control.settings.snapToGrid ? new r.Point(t.x, s.ModelUtils.getSnappedPos(this.control.model, this.control.settings.gridSize, t.y + (this.control.settings.gridSize / 2 + 2), !1)) : t.clone().offset(0, this.control.settings.gridSize);
          }, e;
        }(p);
        e.MoveStepDownCommand = v;
      },
      2016: (t, e) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.TargetVisualizerBase = void 0;
        var n = function () {
          function t(t) {
            this.dispatcher = t;
          }
          return t.prototype.getKey = function () {
            return this.key;
          }, t.prototype.setTargetRect = function (t, e, n) {
            this.key !== t && (this.key = t, this.targetRect = e, this.targetStrokeWidth = n, this.raiseShow());
          }, t.prototype.reset = function () {
            "-1" !== this.key && (this.key = "-1", this.targetRect = void 0, this.targetStrokeWidth = 0, this.raiseHide());
          }, t;
        }();
        e.TargetVisualizerBase = n;
      },
      2037: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MouseHandlerMoveConnectorTextState = void 0;
        var r = n(2815),
          s = n(2771),
          a = n(1914),
          c = function (t) {
            function e(e, n, o) {
              var i = t.call(this, e, n) || this;
              return i.model = o, i;
            }
            return i(e, t), e.prototype.onMouseDown = function (e) {
              this.connector = this.model.findConnector(e.source.key), this.position = parseFloat(e.source.value), this.text = this.connector.getText(this.position), this.savedText = "", t.prototype.onMouseDown.call(this, e);
            }, e.prototype.onApplyChanges = function (t) {
              var e = this.connector.getTextPositionByPoint(t.modelPoint);
              if (e !== this.position) {
                var n = this.connector.getText(e);
                "" !== n && n !== this.text && (this.history.addAndRedo(new a.ChangeConnectorTextHistoryItem(this.connector, e, "")), this.savedText = n), this.history.addAndRedo(new s.ChangeConnectorTextPositionHistoryItem(this.connector, this.position, e)), "" !== this.savedText && this.savedText !== n && (this.history.addAndRedo(new a.ChangeConnectorTextHistoryItem(this.connector, this.position, this.savedText)), this.savedText = ""), this.position = e;
              }
            }, e.prototype.getDraggingElementKeys = function () {
              return [this.connector.key];
            }, e;
          }(r.MouseHandlerDraggingState);
        e.MouseHandlerMoveConnectorTextState = c;
      },
      2078: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ChangeConnectorPropertyCommand = void 0;
        var r = n(2448),
          s = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), e.prototype.getValue = function () {
              return this.control.selection.inputPosition.getCurrentConnectorPropertyValue(this.getPropertyName());
            }, e.prototype.getDefaultValue = function () {
              return this.getPropertyDefaultValue();
            }, e.prototype.executeCore = function (t, e) {
              var n = this;
              return this.control.history.beginTransaction(), this.control.selection.getSelectedConnectors().forEach(function (t) {
                var o = n.getPropertyName();
                n.control.history.addAndRedo(new r.ChangeConnectorPropertyHistoryItem(t.key, o, e));
              }), this.control.selection.inputPosition.setConnectorPropertyValue(this.getPropertyName(), e), this.control.history.endTransaction(), !0;
            }, e.prototype.lockInputPositionUpdating = function () {
              return !0;
            }, e.prototype.isEnabled = function () {
              var e = this.control.selection.getSelectedConnectors();
              return t.prototype.isEnabled.call(this) && e.length > 0;
            }, e;
          }(n(3913).SimpleCommandBase);
        e.ChangeConnectorPropertyCommand = s;
      },
      2092: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.OrShapeDescription = void 0;
        var r = n(3255),
          s = n(3844),
          a = n(1280),
          c = n(9829),
          u = n(6208),
          p = function (t) {
            function e() {
              var e = t.call(this, !0) || this;
              return e.defaultSize = new s.Size(.5 * a.ShapeDefaultDimension, .5 * a.ShapeDefaultDimension), e;
            }
            return i(e, t), Object.defineProperty(e.prototype, "key", {
              get: function () {
                return r.ShapeTypes.Or;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "keepRatioOnAutoSize", {
              get: function () {
                return !0;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "enableText", {
              get: function () {
                return !1;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.createShapePrimitives = function (e) {
              var n = e.rectangle,
                o = n.x,
                i = n.y,
                r = n.right,
                s = n.bottom,
                a = n.center,
                c = a.x,
                p = a.y;
              return [].concat(t.prototype.createShapePrimitives.call(this, e)).concat([new u.PathPrimitive([new u.PathPrimitiveMoveToCommand(c, i), new u.PathPrimitiveLineToCommand(c, s), new u.PathPrimitiveMoveToCommand(o, p), new u.PathPrimitiveLineToCommand(r, p)], e.style)]);
            }, e;
          }(c.EllipseShapeDescription);
        e.OrShapeDescription = p;
      },
      2095: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.IntervalAlgorithms = void 0;
        var o = n(2892),
          i = n(124),
          r = n(2871),
          s = n(5725),
          a = function () {
            function t() {}
            return t.oneConstainsOtherArraysOfInterval = function (t, e) {
              for (var n = o.ListUtils.deepCopy(e), i = n.pop(); i;) {
                if (!o.ListUtils.unsafeAnyOf(t, function (t) {
                  return t.containsInterval(i);
                })) return !1;
                i = n.pop();
              }
              return !0;
            }, t.getIntersection = function (e, n) {
              return t.getIntersectionTemplate(e, n, e);
            }, t.getIntersectionTemplate = function (t, e, n) {
              var o = Math.max(t.start, e.start),
                i = Math.min(t.end, e.end);
              return o > i ? null : n.makeByStartEnd(o, i);
            }, t.getIntersectionNonNullLength = function (e, n) {
              return t.getIntersectionNonNullLengthTemplate(e, n, e);
            }, t.getIntersectionNonNullLengthTemplate = function (e, n, o) {
              var i = t.getIntersectionTemplate(e, n, o);
              return i && i.length ? i : null;
            }, t.getIntersectionsTwoArraysOfInterval = function (e, n) {
              return t.getIntersectionsTwoArraysOfIntervalTemplate(e, n, e[0]);
            }, t.getIntersectionsTwoArraysOfIntervalTemplate = function (e, n, o) {
              for (var i = [], r = e.length, s = n.length, a = 0, c = 0, u = e[a], p = n[c], h = null; a < r && c < s;) {
                var l = t.getIntersectionTemplate(u, p, o);
                l && (h && h.end === l.start ? h.length += l.length : (h = l, i.push(h))), u.end < p.end ? u = e[++a] : p = n[++c];
              }
              return i;
            }, t.getAffectedObjects = function (e, n, o, r) {
              return void 0 === o && (o = function (t) {
                return i.SearchUtils.normedInterpolationIndexOf(e, function (t) {
                  return t.interval.start;
                }, t);
              }), void 0 === r && (r = function (t, e, n) {
                return t.start === n && 0 === e;
              }), t.getAffectedObjectsTemplate(e, n, n[0], o, r);
            }, t.getAffectedObjectsTemplate = function (e, n, o, r, a) {
              void 0 === r && (r = function (t) {
                return i.SearchUtils.normedInterpolationIndexOf(e, function (t) {
                  return t.interval.start;
                }, t);
              }), void 0 === a && (a = function (t, e, n) {
                return t.start === n && 0 === e;
              });
              for (var c = new s.SparseIntervalsCollector(o), u = 0, p = n; u < p.length; u++) for (var h = p[u], l = Math.max(0, r(h.start, e)), d = void 0; d = e[l]; l++) {
                var f = d.interval;
                if (f.start > h.end) break;
                var y = t.getIntersectionTemplate(f, h, o);
                y && (y.length || a(f, h.length, y.start)) && c.add(l);
              }
              return c.getIntervals();
            }, t.handleAffectedObjects = function (e, n, o, s) {
              void 0 === s && (s = function (t) {
                return i.SearchUtils.normedInterpolationIndexOf(e, function (t) {
                  return t.interval.start;
                }, t);
              });
              for (var a = new r.FixedInterval(0, 0), c = 0, u = n; c < u.length; c++) for (var p = u[c], h = Math.max(0, s(p.start, e)), l = void 0; l = e[h]; h++) {
                var d = l.interval;
                if (d.start > p.end) break;
                var f = t.getIntersectionTemplate(d, p, a);
                f && o(l, h, p, f);
              }
            }, t.getMergedIntervals = function (e, n) {
              return t.getMergedIntervalsTemplate(e, n, e[0]);
            }, t.getMergedIntervalsTemplate = function (t, e, n) {
              if (t.length < 2) return t.length > 0 ? [n.makeByStartLength(t[0].start, t[0].length)] : [];
              for (var o = e ? [].concat(t).sort(function (t, e) {
                  return t.start - e.start;
                }) : t, i = [], r = 0, s = void 0; s = o[r];) {
                var a = s.start,
                  c = s.end;
                for (++r; void 0 !== (s = o[r]) && s.start <= c; r++) s.end > c && (c = s.end);
                i.push(n.makeByStartEnd(a, c));
              }
              return i;
            }, t.reflectIntervals = function (e, n) {
              return t.reflectIntervalsTemplate(e, n, n);
            }, t.reflectIntervalsTemplate = function (e, n, i) {
              if (!e.length) return [i.makeByStartLength(n.start, n.length)];
              var r = o.ListUtils.last(e).end,
                s = o.ListUtils.reducedMap(e, function (o, r) {
                  return t.getIntersectionNonNullLengthTemplate(i.makeByStartEnd(e[r - 1].end, o.start), n, i);
                }, 1);
              return n.start < e[0].start && s.unshift(i.makeByStartEnd(n.start, e[0].start)), n.end > r && s.push(i.makeByStartEnd(r, n.end)), s;
            }, t.reflectionOfPointOnInterval = function (t, e, n) {
              return (t - e.start) / e.length * n.length + n.start;
            }, t;
          }();
        e.IntervalAlgorithms = a;
      },
      2136: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.raiseEvent = e.RenderUtils = void 0;
        var o = n(5428),
          i = n(594),
          r = function () {
            function t() {}
            return t.updateSvgElementSize = function (t, e, n, o) {
              t.style.width = e + "px", t.style.height = n + "px", t.setAttribute("viewBox", "0 0 " + e + " " + n), o && (t.setAttribute("width", e.toString()), t.setAttribute("height", n.toString()));
            }, t.removeElement = function (t) {
              t && t.parentNode && t.parentNode.removeChild(t);
            }, t.removeContent = function (t) {
              for (; t && t.firstChild;) t.removeChild(t.firstChild);
            }, t.setElementEventData = function (t, e, n, i) {
              e !== o.MouseEventElementType.Undefined && (t.setAttribute("data-type", e.toString()), void 0 !== n && t.setAttribute("data-key", n.toString()), void 0 !== i && t.setAttribute("data-value", i.toString()));
            }, t.getElementEventData = function (t) {
              if (t.getAttribute && t.getAttribute("data-type")) return new o.MouseEventSource(parseInt(t.getAttribute("data-type")), t.getAttribute("data-key"), t.getAttribute("data-value"));
              var e = t.getAttribute && t.getAttribute("class");
              return "dxdi-page" === e || "dxdi-main" === e ? new o.MouseEventSource(o.MouseEventElementType.Document) : void 0;
            }, t.getHtmlElementStylePropertyName = function (t) {
              switch (t) {
                case "fill":
                  return "color";
                case "text-anchor":
                  return "text-align";
              }
              return t;
            }, t.getTextAnchorValue = function (t, e) {
              if (void 0 === e && (e = !1), e) {
                if ("start" === t) return "end";
                if ("end" === t) return "start";
              }
              return t;
            }, t.getStrokeDasharrayValue = function (t, e) {
              if (e) {
                var n = t && t.toString();
                return (n ? n.split(/[\s,]+/) : []).map(function (t) {
                  return parseInt(t) / 2 * e;
                }).join(",");
              }
              return t;
            }, t.applyStyleToElement = function (t, e, n) {
              var o = this;
              void 0 === n && (n = !1);
              var i = t.getDefaultInstance();
              t.forEach(function (r) {
                var s = t[r],
                  a = e instanceof HTMLElement ? o.getHtmlElementStylePropertyName(r) : r;
                if (void 0 !== s && "" !== s && s !== i[r]) {
                  switch (r) {
                    case "text-anchor":
                      s = o.getTextAnchorValue(s, n);
                      break;
                    case "stroke-dasharray":
                      s = o.getStrokeDasharrayValue(s, parseInt(t["stroke-width"]));
                  }
                  e.style.setProperty(a, s);
                } else e.style.setProperty(a, "");
              });
            }, t.generateSvgElementId = function (t) {
              return t + "_" + i.MathUtils.generateGuid();
            }, t.getUrlPathById = function (t) {
              return "url(#" + t + ")";
            }, t;
          }();
        e.RenderUtils = r, e.raiseEvent = function (t, e, n) {
          n(e), e.preventDefault && t.preventDefault();
        };
      },
      2175: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.DataLayoutParameters = e.DataLayoutType = void 0;
        var o,
          i = n(9212),
          r = n(8533),
          s = n(2626);
        !function (t) {
          t[t.Tree = 0] = "Tree", t[t.Sugiyama = 1] = "Sugiyama";
        }(o = e.DataLayoutType || (e.DataLayoutType = {}));
        var a = function () {
          function t(t, e) {
            this.sizeSettings = t, e && (void 0 !== e.type && (this.layoutType = e.type, this.layoutSettings = this.layoutType === o.Sugiyama ? new i.LayoutSettings() : new i.TreeLayoutSettings()), void 0 !== e.orientation && (this.layoutSettings.orientation = e.orientation), this.skipPointIndices = e.skipPointIndices, this.autoSizeEnabled = e.autoSizeEnabled);
          }
          return Object.defineProperty(t.prototype, "needAutoLayout", {
            get: function () {
              return void 0 !== this.layoutType;
            },
            enumerable: !1,
            configurable: !0
          }), t.prototype.getLayoutBuilder = function (t) {
            return this.layoutType === o.Tree ? new r.TreeLayoutBuilder(this.layoutSettings, t) : new s.SugiyamaLayoutBuilder(this.layoutSettings, t);
          }, t;
        }();
        e.DataLayoutParameters = a;
      },
      2198: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ChangePageLandscapeCommand = void 0;
        var r = n(1540),
          s = n(8912),
          a = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), e.prototype.getValue = function () {
              return this.control.model.pageLandscape;
            }, e.prototype.createHistoryItems = function (t) {
              return [new s.ChangePageLandscapeHistoryItem(t)];
            }, e;
          }(r.ChangePagePropertyCommand);
        e.ChangePageLandscapeCommand = a;
      },
      2270: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MouseHandlerZoomOnPinchState = void 0;
        var r = n(9307),
          s = n(5327),
          a = n(2325),
          c = n(4496),
          u = function (t) {
            function e(e, n, o, i) {
              var r = t.call(this, e, i, n) || this;
              return r.selection = n, r.settings = o, r.view = i, r;
            }
            return i(e, t), e.prototype.onMouseDown = function (e) {
              t.prototype.onMouseDown.call(this, e), e.touches.length > 1 && (this.startDistance = this.getTouchDistance(e), this.startZoomLevel = this.settings.zoomLevel, this.prevDistance = this.startDistance);
            }, e.prototype.onMouseMove = function (e) {
              if (e.touches.length > 1) {
                var n = this.getTouchDistance(e);
                Math.abs(this.prevDistance - n) > 1 && (this.settings.zoomLevel = this.startZoomLevel * (n / this.startDistance), this.view.scrollTo(this.getMiddleLayoutPoint(e), this.getMiddleAbsPoint(e)), this.view.normalize(), this.prevDistance = n);
              }
              t.prototype.onMouseMove.call(this, e);
            }, e.prototype.onMouseUp = function (t) {
              0 === t.touches.length && setTimeout(function () {
                this.handler.switchToDefaultState();
              }.bind(this), 1);
            }, e.prototype.start = function () {
              t.prototype.start.call(this), this.settings.zoomLevel = this.view.getZoom(), this.settings.autoZoom = r.AutoZoomMode.Disabled;
            }, e.prototype.getTouchDistance = function (t) {
              var e = new s.Point(t.touches[0].offsetPoint.x, t.touches[0].offsetPoint.y),
                n = new s.Point(t.touches[1].offsetPoint.x, t.touches[1].offsetPoint.y);
              return c.Metrics.euclideanDistance(e, n);
            }, e.prototype.getPointByEvent = function (t) {
              return this.getMiddleAbsPoint(t);
            }, e.prototype.getMiddleAbsPoint = function (t) {
              return t.touches.length > 1 ? e.getMiddlePointByEvent(t, function (t) {
                return t.offsetPoint;
              }) : t.offsetPoint;
            }, e.prototype.getMiddleLayoutPoint = function (t) {
              return t.touches.length > 1 ? e.getMiddlePointByEvent(t, function (t) {
                return t.modelPoint;
              }) : t.modelPoint;
            }, e.getMiddlePointByEvent = function (t, e) {
              if (t.touches.length > 1) return new s.Point((e(t.touches[0]).x + e(t.touches[1]).x) / 2, (e(t.touches[0]).y + e(t.touches[1]).y) / 2);
            }, e;
          }(a.MouseHandlerScrollingState);
        e.MouseHandlerZoomOnPinchState = u;
      },
      2325: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MouseHandlerScrollingState = void 0;
        var r = n(9589),
          s = n(5428),
          a = n(5327),
          c = function (t) {
            function e(e, n, o) {
              var i = t.call(this, e) || this;
              return i.view = n, i.selection = o, i.lastOffset = new a.Point(0, 0), i;
            }
            return i(e, t), e.prototype.onKeyUp = function (t) {
              this.handler.onFinishScrollPageByKeyboard(t);
            }, e.prototype.onMouseDown = function (t) {
              t.preventDefault = !0, this.startPoint = this.getPointByEvent(t);
            }, e.prototype.onMouseMove = function (t) {
              if (t.button === s.MouseButton.Left) {
                var e = this.currentPoint || this.startPoint;
                t.preventDefault = !0;
                var n = this.getPointByEvent(t),
                  o = this.view.scrollBy(new a.Point(n.x - e.x, n.y - e.y));
                this.lastOffset = this.lastOffset.clone().offset(o.x, o.y), this.currentPoint = n;
              } else this.handler.onFinishScrollPageByMouse(t);
            }, e.prototype.onMouseUp = function (t) {
              t.button === s.MouseButton.Left && this.handler.onFinishScrollPageByMouse(t), this.handler.switchToDefaultState();
            }, e.prototype.cancelChanges = function () {
              this.currentPoint && this.view.scrollBy(this.lastOffset.clone().multiply(-1, -1));
            }, e.prototype.finish = function () {
              this.currentPoint && this.startPoint && !this.currentPoint.equals(this.startPoint) || this.selection.set([]), t.prototype.finish.call(this);
            }, e.prototype.getPointByEvent = function (t) {
              return t.offsetPoint;
            }, e;
          }(r.MouseHandlerCancellableState);
        e.MouseHandlerScrollingState = c;
      },
      2383: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ExportSvgCommand = void 0;
        var r = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(e, t), e.prototype.getExtension = function () {
            return "svg";
          }, e.prototype.getExportFunc = function () {
            return this.exporter.exportSvg;
          }, e;
        }(n(6634).ExportImageCommand);
        e.ExportSvgCommand = r;
      },
      2389: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ChangeShapeTypeHistoryItem = void 0;
        var r = n(4636),
          s = function (t) {
            function e(e, n) {
              var o = t.call(this) || this;
              return o.shapeKey = e.key, o.newType = n, o;
            }
            return i(e, t), e.prototype.redo = function (t) {
              var e = t.model.findShape(this.shapeKey);
              this.oldType = e.description.key, this.oldParameters = e.parameters.clone(), t.updateShapeType(e, this.newType, new r.ShapeParameters());
            }, e.prototype.undo = function (t) {
              var e = t.model.findShape(this.shapeKey);
              t.updateShapeType(e, this.oldType, this.oldParameters);
            }, e;
          }(n(2616).HistoryItem);
        e.ChangeShapeTypeHistoryItem = s;
      },
      2392: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ManualOperationShapeDescription = void 0;
        var r = n(3190),
          s = n(3255),
          a = n(6208),
          c = n(4824),
          u = n(1280),
          p = function (t) {
            function e() {
              return t.call(this, void 0, !0) || this;
            }
            return i(e, t), Object.defineProperty(e.prototype, "key", {
              get: function () {
                return s.ShapeTypes.ManualOperation;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "keepRatioOnAutoSize", {
              get: function () {
                return !1;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.createShapePrimitives = function (t) {
              var n = t.rectangle,
                o = t.rectangle,
                i = o.x,
                r = o.y,
                s = o.right,
                c = o.bottom,
                u = o.width,
                p = o.height,
                h = Math.min(Math.max(0, p / Math.tan(e.slopeAngle)), u),
                l = n.center.x,
                d = Math.min(i + h, l),
                f = Math.max(s - h, l);
              return [new a.PathPrimitive([new a.PathPrimitiveMoveToCommand(i, r), new a.PathPrimitiveLineToCommand(s, r), new a.PathPrimitiveLineToCommand(f, c), new a.PathPrimitiveLineToCommand(d, c), new a.PathPrimitiveClosePathCommand()], t.style)];
            }, e.prototype.processConnectionPoint = function (t, n) {
              var o = t.size.height / Math.tan(e.slopeAngle),
                i = t.getConnectionPointSide(n);
              i === c.ConnectionPointSide.East ? n.x -= o / 2 : i === c.ConnectionPointSide.West && (n.x += o / 2);
            }, e.prototype.getTextRectangle = function (t) {
              var n = Math.min(Math.max(0, t.size.height / Math.tan(e.slopeAngle)), t.size.width);
              return t.rectangle.clone().moveRectangle(n, u.ShapeTextPadding).resize(2 * -n, 2 * -u.ShapeTextPadding).nonNegativeSize();
            }, e.slopeAngle = 81 * Math.PI / 180, e;
          }(r.RectangleShapeDescription);
        e.ManualOperationShapeDescription = p;
      },
      2394: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ContextMenuTouchHandler = void 0;
        var r = n(5428),
          s = n(2803),
          a = n(1922),
          c = function (t) {
            function e(e) {
              var n = t.call(this) || this;
              return n.selection = e, n.contextToolboxVisible = !1, n.selection.onChanged.add(n), n;
            }
            return i(e, t), e.prototype.onMouseDown = function (t) {
              void 0 === t.source.key && this.hideContextMenu();
            }, e.prototype.onMouseUp = function (t) {}, e.prototype.onFocus = function (t) {
              var e = this;
              setTimeout(function () {
                e.showContextMenuAtSelection();
              }, 1);
            }, e.prototype.onBlur = function (t) {
              var e = this;
              setTimeout(function () {
                e.hideContextMenu();
              }, 1);
            }, e.prototype.onTextInputFocus = function (t) {
              var e = this;
              setTimeout(function () {
                e.hideContextMenu();
              }, 1);
            }, e.prototype.onTextInputBlur = function (t) {
              var e = this;
              setTimeout(function () {
                e.showContextMenuAtSelection();
              }, 1);
            }, e.prototype.onLongTouch = function (t) {
              t.source.type === r.MouseEventElementType.Document && this.showContextMenuAtEmptySelection(t.modelPoint);
            }, e.prototype.onKeyDown = function (t) {}, e.prototype.onShortcut = function (t) {}, e.prototype.getSelectedItems = function () {
              return this.selection.getSelectedItems(!0);
            }, e.prototype.showContextMenuAtSelection = function () {
              if (!this.contextToolboxVisible) {
                var t = this.getSelectedItems();
                0 !== t.length && this.showContextMenu(void 0, a.ModelUtils.createRectangle(t).createPosition());
              }
            }, e.prototype.showContextMenuAtEmptySelection = function (t) {
              this.contextToolboxVisible || 0 === this.getSelectedItems().length && this.showContextMenu(void 0, t);
            }, e.prototype.notifyDragStart = function (t) {
              this.hideContextMenu();
            }, e.prototype.notifyDragEnd = function (t) {
              this.showContextMenuAtSelection();
            }, e.prototype.notifySelectionChanged = function (t) {
              this.isUpdateLocked() ? this.registerOccurredEvent(1) : this.raiseSelectionChanged();
            }, e.prototype.raiseSelectionChanged = function () {
              0 !== this.getSelectedItems().length ? this.showContextMenuAtSelection() : this.hideContextMenu();
            }, e.prototype.onUpdateUnlocked = function (t) {
              1 & t && this.raiseSelectionChanged();
            }, e.prototype.notifyShowContextToolbox = function (t, e, n, o, i) {
              this.contextToolboxVisible = !0, this.hideContextMenu();
            }, e.prototype.notifyHideContextToolbox = function () {
              this.contextToolboxVisible = !1, this.showContextMenuAtSelection();
            }, e;
          }(s.ContextMenuHandler);
        e.ContextMenuTouchHandler = c;
      },
      2408: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SendToBackCommand = void 0;
        var r = n(672),
          s = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), e.prototype.isEnabled = function () {
              var e = this.control.selection.getSelectedItems();
              return t.prototype.isEnabled.call(this) && e.length > 0 && this.needSendToBack(e);
            }, e.prototype.executeCore = function (t, e) {
              var n = this;
              return this.control.history.beginTransaction(), this.control.selection.getSelectedItems().forEach(function (t) {
                var e = n.control.model.getIntersectItemsMinZIndex(t) - 1;
                n.control.history.addAndRedo(new r.ChangeZindexHistoryItem(t, e));
              }), this.control.history.endTransaction(), !0;
            }, e.prototype.needSendToBack = function (t) {
              for (var e = this, n = function (n) {
                  var i = o.control.model.getIntersectItemsMinZIndex(t[n]);
                  if (i < t[n].zIndex) return {
                    value: !0
                  };
                  if (i === t[n].zIndex) {
                    var r = !1;
                    return o.control.model.getIntersectItems(t[n]).filter(function (e) {
                      return e.zIndex === t[n].zIndex;
                    }).forEach(function (o) {
                      e.control.model.getItemIndex(o) < e.control.model.getItemIndex(t[n]) && (r = !0);
                    }), {
                      value: r
                    };
                  }
                }, o = this, i = 0; i < t.length; i++) {
                var r = n(i);
                if ("object" == typeof r) return r.value;
              }
              return !1;
            }, e;
          }(n(3913).SimpleCommandBase);
        e.SendToBackCommand = s;
      },
      2428: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SparseIntervals = void 0;
        var o = n(1454),
          i = n(149),
          r = function () {
            function t(t) {
              void 0 === t && (t = []), this.list = t, this._count = 0, this._numIntervals = 0;
              for (var e = 0, n = t; e < n.length; e++) {
                var o = n[e];
                this._count += o.length, this._numIntervals++;
              }
            }
            return Object.defineProperty(t.prototype, "count", {
              get: function () {
                return this._count;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(t.prototype, "numIntervals", {
              get: function () {
                return this._numIntervals;
              },
              enumerable: !1,
              configurable: !0
            }), t.prototype.getInterval = function (t) {
              return this.list[t];
            }, t.prototype.getNativeIterator = function () {
              return new o.SparseIntervalsIterator(this);
            }, t.prototype.getObjectsIterator = function (t) {
              return new i.SparseObjectsIterator(this, t);
            }, t;
          }();
        e.SparseIntervals = r;
      },
      2444: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ArrowRightShapeDescription = void 0;
        var r = n(6208),
          s = n(9090),
          a = n(9763),
          c = n(5327),
          u = n(3255),
          p = n(4824),
          h = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), Object.defineProperty(e.prototype, "key", {
              get: function () {
                return u.ShapeTypes.ArrowRight;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.createShapePrimitives = function (t) {
              var e = t.rectangle,
                n = e.x,
                o = e.y,
                i = e.right,
                a = e.bottom,
                c = e.width,
                u = e.height,
                p = e.center.y,
                h = c - t.parameters.get(s.ArrowVerticalTriangleWidthParameterName).value,
                l = (u - t.parameters.get(s.ArrowVerticalLineHeightParameterName).value) / 2,
                d = t.normalizeX(n + h),
                f = t.normalizeY(o + l),
                y = t.normalizeY(a - l);
              return [new r.PathPrimitive([new r.PathPrimitiveMoveToCommand(n, f), new r.PathPrimitiveLineToCommand(d, f), new r.PathPrimitiveLineToCommand(d, o), new r.PathPrimitiveLineToCommand(i, p), new r.PathPrimitiveLineToCommand(d, a), new r.PathPrimitiveLineToCommand(d, y), new r.PathPrimitiveLineToCommand(n, y), new r.PathPrimitiveClosePathCommand()], t.style)];
            }, e.prototype.modifyParameters = function (t, e, n, o) {
              this.changeParameterValue(e, s.ArrowVerticalTriangleWidthParameterName, function (t) {
                return t.value - n;
              }), this.changeParameterValue(e, s.ArrowVerticalLineHeightParameterName, function (t) {
                return t.value - 2 * o;
              }), this.normalizeParameters(t, e);
            }, e.prototype.getParameterPoints = function (t) {
              return [new a.ShapeParameterPoint("c", new c.Point(t.normalizeX(t.position.x + t.size.width - t.parameters.get(s.ArrowVerticalTriangleWidthParameterName).value), t.normalizeY(t.position.y + (t.size.height - t.parameters.get(s.ArrowVerticalLineHeightParameterName).value) / 2)))];
            }, e.prototype.processConnectionPoint = function (e, n) {
              var o = e.parameters.get(s.ArrowVerticalTriangleWidthParameterName).value;
              if (n.x > e.position.x + e.size.width - o) {
                var i = e.size.height / 2 / o,
                  r = (n.x - (e.position.x + e.size.width - o)) * i,
                  a = e.getConnectionPointSide(n);
                a === p.ConnectionPointSide.North ? n.y += r : a === p.ConnectionPointSide.South && (n.y -= r);
              } else t.prototype.processConnectionPoint.call(this, e, n);
            }, e;
          }(s.ArrowHorizontalShapeDescription);
        e.ArrowRightShapeDescription = h;
      },
      2448: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ChangeConnectorPropertyHistoryItem = void 0;
        var r = function (t) {
          function e(e, n, o) {
            var i = t.call(this) || this;
            return i.connectorKey = e, i.propertyName = n, i.value = o, i;
          }
          return i(e, t), e.prototype.redo = function (t) {
            var e = t.model.findConnector(this.connectorKey);
            this.oldValue = e.properties[this.propertyName], t.changeConnectorProperty(e, this.propertyName, this.value);
          }, e.prototype.undo = function (t) {
            var e = t.model.findConnector(this.connectorKey);
            t.changeConnectorProperty(e, this.propertyName, this.oldValue);
          }, e;
        }(n(2616).HistoryItem);
        e.ChangeConnectorPropertyHistoryItem = r;
      },
      2564: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ConnectorPointsOrthogonalNorthSideCalculator = void 0;
        var r = n(4824),
          s = n(3976),
          a = n(9956),
          c = function (t) {
            function e(e) {
              return t.call(this, e) || this;
            }
            return i(e, t), e.prototype.getCorrectOriginPoint = function (t, e) {
              return t.y > e.y && (t = t.clone().offset(0, e.y - t.y)), t;
            }, e.prototype.getSameShapeOffsetPoints = function (t, e, n, o) {
              switch (t) {
                case r.ConnectionPointSide.East:
                case r.ConnectionPointSide.West:
                case r.ConnectionPointSide.North:
                  return [e.clone().offset(0, -this.getMinOffset())];
                case r.ConnectionPointSide.South:
                  return this.getAsideOffsetPoints(e, n, o, this.getMinOffset(), this.getMinOffset());
              }
            }, e.prototype.getOverlappedPointsOffsetPoints = function (t, e, n, o) {
              switch (t) {
                case r.ConnectionPointSide.South:
                  return [e.clone().offset(0, this.getMinOffset())];
                case r.ConnectionPointSide.North:
                  return [e.clone().offset(0, -this.getMinOffset())];
              }
              return [];
            }, e.prototype.getBeginOverlappedShapeOffsetPoints = function (t, e, n, o) {
              switch (t) {
                case r.ConnectionPointSide.East:
                  return e.y > n.y ? e.x > n.x ? [] : [e.clone().offset(0, -this.getMinOffset())] : e.y < this.endRect.y ? this.getAsideOffsetPoints(e, n, o, this.getMinOffset(), this.getMinOffset(), !1) : [e.clone().offset(0, -this.getMinOffset())];
                case r.ConnectionPointSide.West:
                  return e.y > n.y ? e.x < n.x ? [] : [e.clone().offset(0, -this.getMinOffset())] : e.y < this.endRect.y ? this.getAsideOffsetPoints(e, n, o, this.getMinOffset(), this.getMinOffset(), !0) : [e.clone().offset(0, -this.getMinOffset())];
                case r.ConnectionPointSide.North:
                  return [e.clone().offset(0, -this.getMinOffset())];
                case r.ConnectionPointSide.South:
                  return this.getAsideOffsetPoints(e, n, o, this.getMinOffset(), this.getMinOffset(), e.x < n.x);
              }
            }, e.prototype.getEndOverlappedShapeOffsetPoints = function (t, e, n, o) {
              switch (t) {
                case r.ConnectionPointSide.East:
                  return n.y > e.y ? this.getAsideOffsetPoints(e, n, o, this.getMinOffset(), this.getMinOffset(), !1) : e.x < n.x ? [e.clone().offset(0, -this.getMinOffset())] : [];
                case r.ConnectionPointSide.West:
                  return n.y > e.y ? this.getAsideOffsetPoints(e, n, o, this.getMinOffset(), this.getMinOffset(), !0) : e.x > n.x ? [e.clone().offset(0, -this.getMinOffset())] : [];
                case r.ConnectionPointSide.North:
                  return [e.clone().offset(0, -this.getMinOffset())];
                case r.ConnectionPointSide.South:
                  var i = -this.getMinOffset();
                  return this.beginRect.y < e.y && (i -= e.y - this.beginRect.y), [e.clone().offset(0, i)];
              }
            }, e.prototype.getBeginOnSideOffsetPoints = function (t, e, n, o) {
              return [e.clone().offset(0, -this.getScaleableOffsetY(e, n, !1))];
            }, e.prototype.getEndOnSideOffsetPoints = function (t, e, n, o) {
              return [e.clone().offset(0, -this.getScaleableOffsetY(e, n, !0))];
            }, e.prototype.getBeginOffSideOffsetPoints = function (t, e, n, o) {
              switch (t) {
                case r.ConnectionPointSide.East:
                  if (this.isBeginEndOverlappedX()) return this.getScaleableAsideOffsetPoints(e, n, o, !1, !1);
                  break;
                case r.ConnectionPointSide.West:
                  if (this.isBeginEndOverlappedX()) return this.getScaleableAsideOffsetPoints(e, n, o, !1, !0);
                  break;
                case r.ConnectionPointSide.North:
                  if (this.isBeginEndOverlappedX()) return this.getScaleableAsideOffsetPoints(e, n, o, !1);
                  break;
                case r.ConnectionPointSide.Undefined:
                case r.ConnectionPointSide.South:
                  return this.getScaleableAsideOffsetPoints(e, n, o, !1);
              }
              return [e.clone().offset(0, -this.getScaleableOffsetY(e, n, !1))];
            }, e.prototype.getEndOffSideOffsetPoints = function (t, e, n, o) {
              if (t === r.ConnectionPointSide.Undefined) return this.getScaleableAsideOffsetPoints(e, n, o, !0);
              if (this.isBeginEndOverlappedX()) {
                var i = this.beginRect.center.x > this.endRect.center.x;
                return this.getScaleableAsideOffsetPoints(e, n, o, !0, i);
              }
              return [e.clone().offset(0, -this.getScaleableOffsetY(e, n, !0))];
            }, e.prototype.getAsideOffsetPoints = function (t, e, n, o, i, r) {
              var s = [];
              return void 0 !== n && (void 0 === r && (r = e.x < t.x), r ? s.push(t.clone().offset(-(t.x - n.x + i), -o)) : s.push(t.clone().offset(n.right - t.x + i, -o))), s.push(t.clone().offset(0, -o)), s;
            }, e.prototype.getScaleableAsideOffsetPoints = function (t, e, n, o, i) {
              var r = this.getScaleableOffsetY(t, e, o),
                s = this.getScaleableOffsetX(t, e, o);
              return this.getAsideOffsetPoints(t, e, n, r, s, i);
            }, e.prototype.getScaleableOffsetX = function (t, e, n) {
              if (this.beginRect && this.endRect && !n && !this.isBeginEndOverlappedX()) {
                var o = void 0;
                if ((o = e.x < t.x ? this.beginRect.x - this.endRect.right : this.endRect.x - this.beginRect.right) < 2 * this.getMinOffset()) return o / 2;
              }
              return this.getMinOffset();
            }, e.prototype.getScaleableOffsetY = function (t, e, n) {
              if (this.beginRect && this.endRect) {
                var o = n ? t.y - this.beginRect.bottom : t.y - this.endRect.bottom;
                if (o > 0 && o < 2 * this.getMinOffset()) return o / 2;
              }
              return this.getMinOffset();
            }, e.prototype.isOnSidePoint = function (t, e) {
              return e.y < t.y;
            }, e.prototype.isDirectConnectionAllowed = function (t, e, n) {
              return t === r.ConnectionPointSide.South || t === r.ConnectionPointSide.Undefined;
            }, e.prototype.getDirectConnectionPoints = function (t, e) {
              var n = e.y + (t.y - e.y) / 2;
              return [new a.ConnectorRenderPoint(t.x, n), new a.ConnectorRenderPoint(e.x, n)];
            }, e;
          }(s.ConnectorPointsOrthogonalSideCalculatorBase);
        e.ConnectorPointsOrthogonalNorthSideCalculator = c;
      },
      2567: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CustomShapeDescription = void 0;
        var r = n(4),
          s = n(4412),
          a = n(3844),
          c = n(5327),
          u = n(4856),
          p = n(4824),
          h = n(7185),
          l = n(1280),
          d = n(9406),
          f = n(4062),
          y = n(7841),
          g = n(9551),
          m = function (t) {
            function e(e, n) {
              var o = t.call(this, new a.Size(e.defaultWidth || n && n.defaultSize.width || l.ShapeDefaultDimension, e.defaultHeight || n && n.defaultSize.height || l.ShapeDefaultDimension)) || this;
              if (o.properties = e, o.baseDescription = n, o.imageLoader = new y.ImageLoader(o.updateSvgImage.bind(o)), o.defaultText = void 0 !== e.defaultText ? e.defaultText : n && n.getDefaultText(), o.defaultImageUrl = e.defaultImageUrl || n && n.getDefaultImageUrl(), o.title = e.title || n && n.getTitle() || o.defaultText || "", o.connectionPoints = o.createConnectionPoints(), e.svgUrl) {
                o.svgImage = new d.ImageInfo(e.svgUrl);
                var i = f.ImageCache.instance.createUnloadedInfoByShapeImageInfo(o.svgImage);
                o.imageLoader.load(i);
              }
              if (e.svgToolboxUrl) {
                o.svgToolboxImage = new d.ImageInfo(e.svgToolboxUrl);
                i = f.ImageCache.instance.createUnloadedInfoByShapeImageInfo(o.svgToolboxImage);
                o.imageLoader.load(i);
              }
              return o;
            }
            return i(e, t), Object.defineProperty(e.prototype, "key", {
              get: function () {
                return this.properties.type;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "allowEditText", {
              get: function () {
                return !1 !== this.properties.allowEditText;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "allowEditImage", {
              get: function () {
                return this.baseDescription ? this.baseDescription.allowEditImage : !0 === this.properties.allowEditImage;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "enableChildren", {
              get: function () {
                return this.baseDescription && this.baseDescription.enableChildren;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "hasTemplate", {
              get: function () {
                return !!this.properties.createTemplate;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "minWidth", {
              get: function () {
                return this.properties.minWidth || this.baseDescription && this.baseDescription.minWidth;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "minHeight", {
              get: function () {
                return this.properties.minHeight || this.baseDescription && this.baseDescription.minHeight;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "maxWidth", {
              get: function () {
                return this.properties.maxWidth || this.baseDescription && this.baseDescription.maxWidth;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "maxHeight", {
              get: function () {
                return this.properties.maxHeight || this.baseDescription && this.baseDescription.maxHeight;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "keepRatioOnAutoSize", {
              get: function () {
                return this.properties.keepRatioOnAutoSize;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "toolboxSize", {
              get: function () {
                return this.properties.toolboxWidthToHeightRatio ? new a.Size(this.defaultSize.width, this.defaultSize.width / this.properties.toolboxWidthToHeightRatio) : this.defaultSize;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.getTextAngle = function () {
              return this.baseDescription && this.baseDescription.getTextAngle() || t.prototype.getTextAngle.call(this);
            }, e.prototype.getTitle = function () {
              return void 0 !== this.title ? this.title : t.prototype.getTitle.call(this);
            }, e.prototype.getDefaultText = function () {
              return void 0 !== this.defaultText ? this.defaultText : t.prototype.getDefaultText.call(this);
            }, e.prototype.getDefaultImageUrl = function () {
              return void 0 !== this.defaultImageUrl ? this.defaultImageUrl : t.prototype.getDefaultImageUrl.call(this);
            }, e.prototype.allowResizeHorizontally = function (e) {
              return !1 !== this.properties.allowResize && (this.baseDescription ? this.baseDescription.allowResizeHorizontally(e) : t.prototype.allowResizeHorizontally.call(this, e));
            }, e.prototype.allowResizeVertically = function (e) {
              return !1 !== this.properties.allowResize && (this.baseDescription ? this.baseDescription.allowResizeVertically(e) : t.prototype.allowResizeVertically.call(this, e));
            }, e.prototype.createConnectionPoints = function () {
              return this.properties && this.properties.connectionPoints && this.properties.connectionPoints.length ? this.properties.connectionPoints.map(function (t) {
                if (t && "number" == typeof t.x && "number" == typeof t.y) {
                  var e = "number" == typeof t.side ? t.side : p.ConnectionPointSide.Undefined;
                  return new u.ConnectionPoint(t.x, t.y, e);
                }
              }).filter(function (t) {
                return t;
              }) : t.prototype.createConnectionPoints.call(this);
            }, e.prototype.getConnectionPointSides = function () {
              for (var t = {}, e = 0; e < this.connectionPoints.length; e++) {
                var n = l.ShapeDescription.getConnectionPointSideByGeometry(this.connectionPoints[e]);
                t[n] || (t[n] = []), t[n].push(e);
              }
              return t;
            }, e.prototype.getConnectionPointIndexForSide = function (t) {
              var e = this.getConnectionPointSides(),
                n = e[t];
              if (n) {
                var o = Math.floor(n.length / 2);
                return n.length % 2 == 0 && o--, n[o];
              }
              return (n = e[(t + 1) % 4]) ? n[0] : (n = e[(t + 3) % 4]) ? n[n.length - 1] : (n = e[(t + 2) % 4]) ? n[0] : t;
            }, e.prototype.createImagePrimitives = function (e, n) {
              return this.baseDescription ? this.baseDescription.createImagePrimitives(e, n) : t.prototype.createImagePrimitives.call(this, e, n);
            }, e.prototype.createShapePrimitives = function (t, e) {
              var n = [],
                o = t.rectangle,
                i = o.x,
                s = o.y,
                a = o.width,
                c = o.height;
              if (this.baseDescription) n = this.baseDescription.createShapePrimitives(t, e);else {
                var u = e && this.svgToolboxImage ? this.svgToolboxImage : this.svgImage;
                if (u) {
                  var p = i + (this.properties.svgLeft && !e ? this.properties.svgLeft * a : 0),
                    h = s + (this.properties.svgTop && !e ? this.properties.svgTop * c : 0),
                    l = this.properties.svgWidth && !e ? this.properties.svgWidth * a : a,
                    d = this.properties.svgHeight && !e ? this.properties.svgHeight * c : c;
                  n = n.concat([new r.ImagePrimitive(p, h, l, d, u.exportUrl)]);
                }
              }
              var f = e && this.properties.createToolboxTemplate || this.properties.createTemplate;
              if (f) {
                var y = i + (this.properties.templateLeft && !e ? this.properties.templateLeft * a : 0),
                  m = s + (this.properties.templateTop && !e ? this.properties.templateTop * c : 0),
                  v = this.properties.templateWidth && !e ? this.properties.templateWidth * a : a,
                  P = this.properties.templateHeight && !e ? this.properties.templateHeight * c : c,
                  C = this.properties.apiController ? this.properties.apiController.createNativeShape(t) : t.toNative();
                n = n.concat([new g.SvgElementPrimitive(y, m, v, P, f, this.properties.destroyTemplate, C)]);
              }
              return n;
            }, e.prototype.createParameters = function (e) {
              return this.baseDescription ? this.baseDescription.createParameters(e) : t.prototype.createParameters.call(this, e);
            }, e.prototype.normalizeParameters = function (e, n) {
              this.baseDescription ? this.baseDescription.normalizeParameters(e, n) : t.prototype.normalizeParameters.call(this, e, n);
            }, e.prototype.modifyParameters = function (e, n, o, i) {
              this.baseDescription ? this.baseDescription.modifyParameters(e, n, o, i) : t.prototype.modifyParameters.call(this, e, n, o, i);
            }, e.prototype.getParameterPoints = function (e) {
              return this.baseDescription ? this.baseDescription.getParameterPoints(e) : t.prototype.getParameterPoints.call(this, e);
            }, e.prototype.getTextRectangle = function (t) {
              if (this.baseDescription) return this.baseDescription.getTextRectangle(t);
              var e = t.rectangle,
                n = e.x,
                o = e.y,
                i = e.width,
                r = e.height;
              return new s.Rectangle(n + (this.properties.textLeft ? this.properties.textLeft * i : 0), o + (this.properties.textTop ? this.properties.textTop * r : 0), this.properties.textWidth ? this.properties.textWidth * i : i, this.properties.textHeight ? this.properties.textHeight * r : r);
            }, e.prototype.getSizeByText = function (t, e) {
              if (this.baseDescription) return this.baseDescription.getSizeByText(t, e);
              var n = this.properties.textWidth;
              n || (n = 1);
              var o = this.properties.textHeight;
              return o || (o = 1), new a.Size(t.width / n, t.height / o);
            }, e.prototype.getImageSize = function (t, e, n) {
              return this.baseDescription ? this.baseDescription instanceof h.ShapeWithImageDescription ? this.baseDescription.getImageSize(t, e, n) : a.Size.empty() : new a.Size(this.properties.imageWidth ? this.properties.imageWidth * t.width : t.width, this.properties.imageHeight ? this.properties.imageHeight * t.height : t.height).nonNegativeSize();
            }, e.prototype.getImagePlacementRectangle = function (t, e) {
              if (this.baseDescription) return this.baseDescription instanceof h.ShapeWithImageDescription ? this.baseDescription.getImagePlacementRectangle(t, e) : s.Rectangle.fromGeometry(c.Point.zero(), a.Size.empty());
              var n = t.x,
                o = t.y,
                i = t.width,
                r = t.height;
              return new s.Rectangle(n + (this.properties.imageLeft && !e ? this.properties.imageLeft * i : 0), o + (this.properties.imageTop && !e ? this.properties.imageTop * r : 0), this.properties.imageWidth && !e ? this.properties.imageWidth * i : i, this.properties.imageHeight && !e ? this.properties.imageHeight * r : r);
            }, e.prototype.updateSvgImage = function (t) {
              var e = this.svgToolboxImage && t.imageUrl && t.imageUrl === this.properties.svgToolboxUrl,
                n = e ? this.svgToolboxImage : this.svgImage;
              t.base64 ? n.loadBase64Content(t.base64) : n.setUnableToLoadFlag(), e || this.raiseShapeDescriptionChanged(this);
            }, e;
          }(h.ShapeWithImageDescription);
        e.CustomShapeDescription = m;
      },
      2616: function (t, e) {
        var n,
          o = this && this.__extends || (n = function (t, e) {
            return n = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, n(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function o() {
              this.constructor = t;
            }
            n(t, e), t.prototype = null === e ? Object.create(e) : (o.prototype = e.prototype, new o());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CompositionHistoryItem = e.HistoryItem = void 0;
        var i = function () {
          function t() {
            this.uniqueId = -1;
          }
          return t.prototype.changeModified = function () {
            return !0;
          }, t.prototype.getName = function () {
            return this.constructor.name;
          }, t;
        }();
        e.HistoryItem = i;
        var r = function (t) {
          function e() {
            var e = null !== t && t.apply(this, arguments) || this;
            return e.historyItems = [], e.dataSyncItems = [], e;
          }
          return o(e, t), e.prototype.changeModified = function () {
            for (var t, e = 0; t = this.historyItems[e]; e++) if (t.changeModified()) return !0;
            return !1;
          }, e.prototype.redo = function (t) {
            for (var e, n = 0; e = this.historyItems[n]; n++) e.redo(t);
          }, e.prototype.undo = function (t) {
            for (var e, n = this.dataSyncItems.length - 1; e = this.dataSyncItems[n]; n--) e.undo(t);
            this.dataSyncItems = [];
            for (n = this.historyItems.length - 1; e = this.historyItems[n]; n--) e.undo(t);
          }, e.prototype.add = function (t) {
            if (null == t) throw new Error("cannot be null");
            this.historyItems.push(t);
          }, e;
        }(i);
        e.CompositionHistoryItem = r;
      },
      2620: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Data = e.SetAbsoluteY = e.SetAbsoluteX = void 0;
        var o = n(750),
          i = n(961);
        function r(t) {
          return !isNaN(parseFloat(t)) && isFinite(t);
        }
        function s(t, e, n) {
          return t -= function (t, e) {
            var n = function (t) {
              var e = document.createElement("DIV");
              return e.style.top = "0px", e.style.left = "0px", e.style.visibility = "hidden", e.style.position = o.DomUtils.getCurrentStyle(t).position, e;
            }(t);
            "static" === n.style.position && (n.style.position = "absolute");
            t.parentNode.appendChild(n);
            var i = e ? o.DomUtils.getAbsolutePositionX(n) : o.DomUtils.getAbsolutePositionY(n);
            return t.parentNode.removeChild(n), Math.round(i);
          }(e, n), t;
        }
        e.SetAbsoluteX = function (t, e) {
          t.style.left = s(e, t, !0) + "px";
        }, e.SetAbsoluteY = function (t, e) {
          t.style.top = s(e, t, !1) + "px";
        };
        var a = function () {
          function t() {}
          return t.ArrayInsert = function (t, e, n) {
            if (0 <= n && n < t.length) {
              for (var o = t.length; o > n; o--) t[o] = t[o - 1];
              t[n] = e;
            } else t.push(e);
          }, t.ArrayRemove = function (e, n) {
            var o = t.ArrayIndexOf(e, n);
            o > -1 && t.ArrayRemoveAt(e, o);
          }, t.ArrayRemoveAt = function (t, e) {
            if (e >= 0 && e < t.length) {
              for (var n = e; n < t.length - 1; n++) t[n] = t[n + 1];
              t.pop();
            }
          }, t.ArrayClear = function (t) {
            for (; t.length > 0;) t.pop();
          }, t.ArrayIndexOf = function (t, e, n) {
            if (n) {
              for (o = 0; o < t.length; o++) if (n(t[o], e)) return o;
            } else for (var o = 0; o < t.length; o++) if (t[o] === e) return o;
            return -1;
          }, t.ArrayContains = function (e, n) {
            return t.ArrayIndexOf(e, n) >= 0;
          }, t.ArrayEqual = function (t, e) {
            var n = t.length;
            if (n !== e.length) return !1;
            for (var o = 0; o < n; o++) if (t[o] !== e[o]) return !1;
            return !0;
          }, t.ArraySame = function (e, n) {
            return e.length === n.length && e.every(function (e) {
              return t.ArrayContains(n, e);
            });
          }, t.ArrayGetIntegerEdgeValues = function (e) {
            var n = t.CollectionToArray(e);
            return t.ArrayIntegerAscendingSort(n), {
              start: n[0],
              end: n[n.length - 1]
            };
          }, t.ArrayIntegerAscendingSort = function (e) {
            t.ArrayIntegerSort(e, !1);
          }, t.ArrayIntegerSort = function (t, e) {
            t.sort(function (t, n) {
              var o = 0;
              return t > n ? o = 1 : t < n && (o = -1), e && (o *= -1), o;
            });
          }, t.CollectionsUnionToArray = function (t, e) {
            for (var n = [], o = t.length, i = e.length, r = 0; r < o + i; r++) r < o ? n.push(t[r]) : n.push(e[r - o]);
            return n;
          }, t.CollectionToArray = function (t) {
            for (var e = [], n = 0; n < t.length; n++) e.push(t[n]);
            return e;
          }, t.CreateHashTableFromArray = function (t) {
            for (var e = [], n = 0; n < t.length; n++) e[t[n]] = 1;
            return e;
          }, t.CreateIndexHashTableFromArray = function (t) {
            for (var e = [], n = 0; n < t.length; n++) e[t[n]] = n;
            return e;
          }, t.ArrayToHash = function (t, e, n) {
            return t instanceof Array ? t.reduce(function (t, o, i) {
              var r = e(o, i),
                s = n(o, i);
              return t[r] = s, t;
            }, {}) : {};
          }, t.Sum = function (t, e) {
            return t instanceof Array ? t.reduce(function (t, n) {
              var o = e ? e(n) : n;
              return r(o) || (o = 0), t + o;
            }, 0) : 0;
          }, t.Min = function (e, n) {
            return t.CalculateArrayMinMax(e, n, !1);
          }, t.Max = function (e, n) {
            return t.CalculateArrayMinMax(e, n, !0);
          }, t.NearestLeftBinarySearchComparer = function (t, e, n) {
            var o = t[e],
              i = o < n;
            return i && e === t.length - 1 || i && t[e + 1] >= n ? 0 : o < n ? -1 : 1;
          }, t.ArrayBinarySearch = function (e, n, o, r, s) {
            o || (o = t.defaultBinarySearchComparer), (0, i.isDefined)(r) || (r = 0), (0, i.isDefined)(s) || (s = e.length - r);
            for (var a = r + s - 1; r <= a;) {
              var c = r + (a - r >> 1),
                u = o(e, c, n);
              if (0 === u) return c;
              u < 0 ? r = c + 1 : a = c - 1;
            }
            return -(r + 1);
          }, t.ArrayFlatten = function (t) {
            var e = [];
            return t.forEach(function (t) {
              e = e.concat(t);
            }), e;
          }, t.GetDistinctArray = function (e) {
            for (var n = [], o = 0; o < e.length; o++) {
              var i = e[o];
              -1 === t.ArrayIndexOf(n, i) && n.push(i);
            }
            return n;
          }, t.ForEach = function (t, e) {
            if (Array.prototype.forEach) Array.prototype.forEach.call(t, e);else for (var n = 0, o = t.length; n < o; n++) e(t[n], n, t);
          }, t.MergeHashTables = function (t, e) {
            if (!e || "string" == typeof e) return t;
            for (var n in t || (t = {}), e) n && !(n in t) && (t[n] = e[n]);
            return t;
          }, t.Range = function (t, e) {
            return (t = parseInt(t) || 0) < 0 && (t = 0), (e = parseInt(e) || 0) < 0 && (e = 0), Array(t).map(function (t, n) {
              return e + n;
            });
          }, t.CalculateArrayMinMax = function (t, e, n) {
            if (!(t instanceof Array)) return 0;
            var o = n ? Number.NEGATIVE_INFINITY : Number.POSITIVE_INFINITY;
            return t.reduce(function (t, i) {
              var s = e ? e(i) : i;
              return r(s) || (s = o), (n ? Math.max : Math.min)(s, t);
            }, o);
          }, t.byRange = function (t, e, n) {
            return Math.min(Math.max(t, e), n);
          }, t.defaultBinarySearchComparer = function (t, e, n) {
            var o = t[e];
            return o === n ? 0 : o < n ? -1 : 1;
          }, t.cssTextToObject = function (t) {
            return t ? (t = t.replace(/\/\*(.|\s)*?\*\//g, "").replace(/\s+/g, " ")).split(";").reduce(function (t, e) {
              if (e) {
                var n = /\s*([^:]+?)\s*:\s*([^;]*)\s*$/.exec(e);
                if (n) {
                  var o = n[1],
                    i = n[2];
                  o && i && (t[o.trim()] = i.trim());
                }
                return t;
              }
              return t;
            }, {}) : {};
          }, t.objectToCssText = function (t) {
            return t ? Object.keys(t).reduce(function (e, n) {
              var o = n.trim(),
                i = t[n];
              return o && i && e.push(o + ": " + i.toString().trim()), e;
            }, []).join("; ") : "";
          }, t;
        }();
        e.Data = a;
      },
      2626: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.EdgeOnLayer = e.NodeOnLayer = e.SugiyamaNodesOrderer = e.SugiyamaLayerDistributor = e.SugiyamaLayoutBuilder = void 0;
        var r = n(8464),
          s = n(9071),
          a = n(8501),
          c = n(8573),
          u = n(6961),
          p = n(124),
          h = n(5327),
          l = n(9212),
          d = n(1441),
          f = n(6320),
          y = n(1114),
          g = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), e.prototype.build = function () {
              var t = this,
                e = 0,
                n = new d.GraphLayout(),
                o = new v();
              return this.graph.getConnectedComponents().forEach(function (i) {
                var r = y.CycleRemover.removeCycles(i),
                  s = m.getLayers(r.graph),
                  a = o.orderNodes(r.graph, s),
                  c = Object.keys(r.removedEdges).map(function (t) {
                    return i.getEdge(t);
                  }),
                  u = o.assignAbsCoordinates(a),
                  p = t.createInfoGraphLayout(u, r.reversedEdges, c);
                n.extend(t.setComponentOffset(p, e)), e += t.getComponentOffset(p);
              }), n;
            }, e.prototype.createInfoGraphLayout = function (t, e, n) {
              for (var o = this, i = new h.Point(0, 0), r = t.items, s = new u.HashSet(r.map(function (t) {
                  return t.layer;
                }).sort(function (t, e) {
                  return t - e;
                })), a = this.getAbsOffsetInfo(t.items), c = {}, p = 0, f = Number.MAX_SAFE_INTEGER || Number.MAX_VALUE, y = Number.MIN_SAFE_INTEGER || Number.MAX_VALUE, g = function (t) {
                  var e = s.item(t),
                    n = 0;
                  r.filter(function (t) {
                    return t.layer === e;
                  }).sort(function (t, e) {
                    return t.position - e.position;
                  }).forEach(function (t) {
                    var e = o.getDepthNodeSize(t),
                      r = o.chooseDirectionValue(0, e),
                      s = o.getAbsPosition(t.position, o.getBreadthNodeSize(t), a);
                    i = o.setBreadth(i, s);
                    var u = o.setDepthOffset(i, -r);
                    if (c[t.key] = u, !t.isDummy) {
                      var p = o.settings.orientation === l.DataLayoutOrientation.Horizontal ? u.y : u.x;
                      f = Math.min(f, p), y = Math.max(y, p + o.getBreadthNodeSize(t)), n = Math.max(n, o.getDepthNodeSize(t));
                    }
                  }), p += n, i = m.setBreadth(i, 0), i = m.setDepthOffset(i, m.getDirectionValue(n + m.settings.layerSpacing));
                }, m = this, v = 0; v < s.length; v++) g(v);
              p += (s.length - 1) * this.settings.layerSpacing;
              var P = new d.GraphLayout();
              return this.createNodesLayout(t, P, f, p, c), this.createEdgesLayout(t, P, e, n), P;
            }, e.prototype.createNodesLayout = function (t, e, n, o, i) {
              var r = this,
                s = this.settings.orientation === l.DataLayoutOrientation.Vertical ? new h.Point(-n, this.chooseDirectionValue(0, o)) : new h.Point(this.chooseDirectionValue(0, o), -n);
              t.items.forEach(function (t) {
                if (!t.isDummy) {
                  var n = r.graph.getNode(t.key);
                  e.addNode(new a.NodeLayout(n, i[t.key].clone().offset(s.x, s.y)));
                }
              });
            }, e.prototype.createEdgesLayout = function (t, e, n, o) {
              var i = this.getDirectEdgeLayout(),
                r = this.getDiffLevelEdgeLayout(!0),
                s = this.getDiffLevelEdgeLayout(!1),
                c = this.getSameLevelEdgeLayout(!0),
                u = this.getSameLevelEdgeLayout(!1),
                p = {};
              t.edges.filter(function (t) {
                return !t.isDummy;
              }).concat(o.map(function (t) {
                return new S(t.key, !1, t.from, t.to);
              })).sort(function (e, n) {
                return t.getNode(e.originFrom).layer - t.getNode(n.originFrom).layer || t.getNode(e.to).layer - t.getNode(n.to).layer;
              }).forEach(function (o) {
                var h = n[o.key],
                  l = t.getNode(h ? o.to : o.originFrom),
                  d = t.getNode(h ? o.originFrom : o.to);
                if (d.layer - l.layer === 1) e.addEdge(new a.EdgeLayout(o.key, i.from, i.to));else {
                  var y = [];
                  if (d.position - l.position >= 1) y.push(r), y.push({
                    from: i.from,
                    to: r.to
                  }), y.push({
                    from: r.from,
                    to: i.to
                  });else if (d.position - l.position <= -1) y.push(s), y.push({
                    from: i.from,
                    to: s.to
                  }), y.push({
                    from: s.from,
                    to: i.to
                  });else {
                    var g = l.position === d.position && 0 === d.position ? [c, u] : [u, c];
                    g.forEach(function (t) {
                      return y.push(t);
                    }), g.forEach(function (t) {
                      y.push({
                        from: t.from,
                        to: i.to
                      }), y.push({
                        from: i.from,
                        to: t.to
                      });
                    });
                  }
                  y.push(i);
                  for (var m = 0, v = void 0; v = y[m]; m++) {
                    var P = l.key + "_" + v.from,
                      C = d.key + "_" + v.to;
                    if (p[P] !== f.ConnectorPosition.End && p[C] !== f.ConnectorPosition.Begin) {
                      e.addEdge(new a.EdgeLayout(o.key, v.from, v.to)), p[P] = f.ConnectorPosition.Begin, p[C] = f.ConnectorPosition.End;
                      break;
                    }
                  }
                }
              });
            }, e.prototype.getDirectEdgeLayout = function () {
              return this.settings.orientation === l.DataLayoutOrientation.Horizontal ? this.settings.direction === l.LogicalDirectionKind.Forward ? {
                from: 1,
                to: 3
              } : {
                from: 3,
                to: 1
              } : this.settings.direction === l.LogicalDirectionKind.Forward ? {
                from: 2,
                to: 0
              } : {
                from: 0,
                to: 2
              };
            }, e.prototype.getDiffLevelEdgeLayout = function (t) {
              return this.settings.orientation === l.DataLayoutOrientation.Horizontal ? t ? {
                from: 2,
                to: 0
              } : {
                from: 0,
                to: 2
              } : t ? {
                from: 3,
                to: 1
              } : {
                from: 1,
                to: 3
              };
            }, e.prototype.getSameLevelEdgeLayout = function (t) {
              return this.settings.orientation === l.DataLayoutOrientation.Horizontal ? t ? {
                from: 0,
                to: 0
              } : {
                from: 2,
                to: 2
              } : t ? {
                from: 3,
                to: 3
              } : {
                from: 1,
                to: 1
              };
            }, e.prototype.getAbsOffsetInfo = function (t) {
              var e = this,
                n = {},
                o = function (t, o) {
                  void 0 === n[o] && (n[o] = e.getBreadthNodeSize(t)), n[o] = Math.max(n[o], e.getBreadthNodeSize(t));
                };
              t.forEach(function (t) {
                var e = x(t.position);
                o(t, e), n[e] % 1 != 0 && o(t, e + 1);
              });
              var i = {},
                r = 0;
              return Object.keys(n).sort(function (t, e) {
                return parseFloat(t) - parseFloat(e);
              }).forEach(function (t) {
                i[t] = {
                  leftOffset: r,
                  width: n[t]
                }, r += n[t] + e.settings.columnSpacing;
              }), i;
            }, e.prototype.setBreadth = function (t, e) {
              return this.settings.orientation === l.DataLayoutOrientation.Vertical ? new h.Point(e, t.y) : new h.Point(t.x, e);
            }, e.prototype.setDepthOffset = function (t, e) {
              return this.settings.orientation === l.DataLayoutOrientation.Horizontal ? new h.Point(t.x + e, t.y) : new h.Point(t.x, t.y + e);
            }, e.prototype.getAbsPosition = function (t, e, n) {
              var o = x(t),
                i = n[o].leftOffset,
                r = n[o].width;
              return t % 1 == 0 ? i + (r - e) / 2 : i + r - (e - this.settings.columnSpacing) / 2;
            }, e.prototype.getBreadthNodeSize = function (t) {
              return t.isDummy ? 0 : this.getBreadthNodeSizeCore(this.graph.getNode(t.key));
            }, e.prototype.getDepthNodeSize = function (t) {
              return t.isDummy ? 0 : this.getDepthNodeSizeCore(this.graph.getNode(t.key));
            }, e;
          }(r.LayoutBuilder);
        e.SugiyamaLayoutBuilder = g;
        var m = function () {
          function t() {}
          return t.getLayers = function (t) {
            var e = this.getFeasibleTree(t);
            return this.calcNodesLayers(e);
          }, t.getFeasibleTree = function (t) {
            var e = this.initLayerAssignment(t);
            return t.getSpanningGraph(t.nodes[0], c.ConnectionMode.OutgoingAndIncoming, function (t) {
              return e[t.to] - e[t.from];
            });
          }, t.initLayerAssignment = function (t) {
            for (var e = {}, n = 0, o = {}, i = t.nodes.filter(function (e) {
                return !t.getAdjacentEdges(e, c.ConnectionMode.Incoming).length;
              }), r = function () {
                i.forEach(function (t) {
                  e[t] = n, o[t] = !0;
                }), Object.keys(o).forEach(function (n) {
                  0 === t.getAdjacentEdges(n, c.ConnectionMode.Outgoing).filter(function (t) {
                    return void 0 === e[t.to];
                  }).length && delete o[n];
                });
                var r = {};
                Object.keys(o).forEach(function (n) {
                  t.getAdjacentEdges(n, c.ConnectionMode.Outgoing).map(function (t) {
                    return t.to;
                  }).filter(function (n) {
                    return void 0 === e[n] && t.getAdjacentEdges(n, c.ConnectionMode.Incoming).reduce(function (t, n) {
                      return t && void 0 !== e[n.from];
                    }, !0);
                  }).forEach(function (t) {
                    return r[t] = !0;
                  });
                }), i = Object.keys(r), n++;
              }; i.length;) r();
            return e;
          }, t.calcNodesLayers = function (t) {
            var e = {},
              n = Number.MAX_SAFE_INTEGER || Number.MAX_VALUE,
              o = 0,
              i = t.createIterator(c.ConnectionMode.OutgoingAndIncoming);
            for (var r in i.visitEachEdgeOnce = !1, i.onNode = function (t) {
              e[t.key] = o, n = Math.min(n, o);
            }, i.skipNode = function (t) {
              return void 0 !== e[t.key];
            }, i.skipEdge = function (t) {
              return void 0 !== e[t.from] && void 0 !== e[t.to];
            }, i.onEdge = function (t, n) {
              o = n ? e[t.from] + 1 : e[t.to] - 1;
            }, i.iterate(t.nodes[0]), e) Object.prototype.hasOwnProperty.call(e, r) && (e[r] -= n);
            return e;
          }, t;
        }();
        e.SugiyamaLayerDistributor = m;
        var v = function () {
          function t() {
            this.idCounter = -1e4;
          }
          return t.prototype.orderNodes = function (t, e) {
            for (var n = 1, o = this.initGraphInfo(t, e), i = o.items, r = this.initOrder(i), s = this.getNodeToPositionMap(i), a = this.getCrossCount(r, o), c = !0; n < 14 && 0 !== a;) {
              r = this.getNodesOrder(r, o, c);
              var u = this.getCrossCount(r, o);
              u < a && (s = this.getNodeToPositionMap(o.items), a = u), c = !c, n++;
            }
            return o.items.forEach(function (t) {
              return t.position = s[t.key];
            }), o;
          }, t.prototype.getNodesOrder = function (t, e, n) {
            var o = this,
              i = {},
              r = function (r) {
                if (!Object.prototype.hasOwnProperty.call(t, r)) return "continue";
                var a = {},
                  c = [];
                t[r].forEach(function (t) {
                  var i = (n ? e.getChildren(t.key) : e.getParents(t.key)).map(function (t) {
                    return e.getNode(t).position;
                  });
                  c.push(t.key), a[t.key] = o.getNodePosition(i);
                }), i[r] = s.sortNodes(c, a, e);
              },
              s = this;
            for (var a in t) r(a);
            return i;
          }, t.prototype.sortNodes = function (t, e, n) {
            return t.sort(function (t, n) {
              return e[t] - e[n];
            }).map(function (t, e) {
              var o = n.getNode(t);
              return o.position = e, o;
            });
          }, t.prototype.getNodePosition = function (t) {
            if (!(t = t.sort(function (t, e) {
              return t - e;
            })).length) return 0;
            var e = Math.floor(t.length / 2);
            if (2 === t.length || t.length % 2 == 1) return t[e];
            var n = t[e - 1] - t[0],
              o = t[t.length - 1] - t[e];
            return Math.floor((t[e - 1] * o + t[e] * n) / (n + o));
          }, t.prototype.initOrder = function (t) {
            var e = {};
            return t.forEach(function (t) {
              return (e[t.layer] || (e[t.layer] = [])).push(t);
            }), e;
          }, t.prototype.getCrossCount = function (t, e) {
            var n = 0,
              o = function (o) {
                if (!Object.prototype.hasOwnProperty.call(t, o)) return "continue";
                var i = [];
                t[o].forEach(function (t) {
                  var o = e.getChildren(t.key).map(function (t) {
                    return e.getNode(t).position;
                  });
                  o.forEach(function (t) {
                    n += i.filter(function (e) {
                      return t < e;
                    }).length;
                  }), i = i.concat(o);
                });
              };
            for (var i in t) o(i);
            return n;
          }, t.prototype.initGraphInfo = function (t, e) {
            var n = this,
              o = {},
              i = {},
              r = [],
              a = [];
            return t.nodes.forEach(function (t) {
              var n = e[t];
              void 0 === o[n] && (o[n] = 0);
              var s = new P(t, !1, n, o[n]++);
              i[t] = s, r.push(s);
            }), t.edges.forEach(function (t) {
              var s = e[t.to] - e[t.from];
              if (s > 1) {
                for (var c = i[t.from], u = 1; u < s; u++) {
                  var p = new P(n.createDummyID(), !0, e[t.from] + u, o[e[t.from] + u]++);
                  a.push(new S(n.createDummyID(), !0, c.key, p.key)), r.push(p), c = p;
                }
                a.push(new S(t.key, !1, c.key, i[t.to].key, i[t.from].key));
              } else a.push(new S(t.key, !1, i[t.from].key, i[t.to].key));
            }), new s.FastGraph(r, a);
          }, t.prototype.createDummyID = function () {
            return "dummy_" + --this.idCounter;
          }, t.prototype.getNodeToPositionMap = function (t) {
            return t.reduce(function (t, e) {
              return t[e.key] = e.position, t;
            }, {});
          }, t.prototype.assignAbsCoordinates = function (t) {
            var e = this.getAbsCoodinate(t);
            return new s.FastGraph(t.items.map(function (t) {
              return new P(t.key, t.isDummy, t.layer, e[t.key]);
            }), t.edges.slice(0));
          }, t.prototype.getAbsCoodinate = function (t) {
            var e = this,
              n = t.items.reduce(function (t, e) {
                t[e.layer] = t[e.layer] || [];
                var n = p.SearchUtils.binaryIndexOf(t[e.layer], function (t) {
                  return t.position - e.position;
                });
                return t[e.layer].splice(n < 0 ? ~n : n, 0, e), t;
              }, {}),
              o = [C.TopLeft, C.TopRight, C.BottomLeft, C.BottomRight].map(function (o) {
                return e.getPositionByMedian(t, o, n);
              }),
              i = {};
            return t.items.forEach(function (t) {
              var e = o.map(function (e) {
                return e[t.key];
              }).sort(function (t, e) {
                return t - e;
              });
              i[t.key] = (e[1] + e[2]) / 2;
            }), i;
          }, t.prototype.getPositionByMedian = function (t, e, n) {
            var o = t.items,
              i = this.getNodeToPositionMap(o),
              r = this.getMedians(t, o, e);
            return r = this.resolveMedianConflicts(t, n, r, e), this.getSortedBlocks(t, o, r, e).forEach(function (t) {
              var e = t.reduce(function (t, e) {
                return i[e.key] > t ? i[e.key] : t;
              }, -2);
              t.forEach(function (t) {
                var o = e - i[t.key];
                o > 0 && n[t.layer].filter(function (e) {
                  return e.position > t.position;
                }).forEach(function (t) {
                  return i[t.key] += o;
                }), i[t.key] = e;
              });
            }), i;
          }, t.prototype.getSortedBlocks = function (t, e, n, o) {
            for (var i = [], r = o === C.BottomLeft || o === C.BottomRight, s = new u.HashSet(e.slice(0).sort(function (t, e) {
                return r ? t.layer - e.layer : e.layer - t.layer;
              }), function (t) {
                return t.key;
              }), a = new u.HashSet(); s.length;) {
              var c = s.item(0),
                p = this.getBlock(t, c, n, o).filter(function (t) {
                  return a.tryPush(t.key);
                });
              i.push(p), p.forEach(function (t) {
                return s.remove(t);
              });
            }
            return i.sort(function (t, e) {
              var n = t.reduce(function (t, e) {
                  return e.position < t.position ? e : t;
                }, t[0]),
                o = e.filter(function (t) {
                  return t.layer === n.layer;
                })[0];
              if (o) return n.position > o.position ? 1 : -1;
              var i = e.reduce(function (t, e) {
                  return e.position < t.position ? e : t;
                }, e[0]),
                r = t.filter(function (t) {
                  return t.layer === i.layer;
                })[0];
              return r ? r.position > i.position ? 1 : -1 : n.layer > i.layer ? 1 : -1;
            }), i;
          }, t.prototype.getBlock = function (t, e, n, o) {
            var i = [],
              r = null;
            do {
              r && (e = o === C.TopLeft || o === C.TopRight ? t.getNode(r.from) : t.getNode(r.to)), i.push(e), r = n[e.key];
            } while (r);
            return i;
          }, t.prototype.resolveMedianConflicts = function (t, e, n, o) {
            var i = this,
              r = {},
              s = function (s) {
                if (!Object.prototype.hasOwnProperty.call(e, s)) return "continue";
                var a,
                  c,
                  u = e[s];
                o !== C.TopRight && o !== C.BottomRight || (u = u.slice(0).sort(function (t, e) {
                  return e.position - t.position;
                })), u.forEach(function (e) {
                  var s = n[e.key];
                  if (s) {
                    var u = o === C.TopLeft || o === C.TopRight ? s.from : s.to,
                      p = t.getNode(u).position;
                    i.checkMedianConfict(a, c, p, o) ? r[e.key] = null : (a = void 0 === a ? p : Math.min(a, p), c = void 0 === c ? p : Math.max(c, p), r[e.key] = s);
                  } else r[e.key] = null;
                });
              };
            for (var a in e) s(a);
            return r;
          }, t.prototype.checkMedianConfict = function (t, e, n, o) {
            return void 0 !== t && void 0 !== e && (o === C.TopLeft || o === C.BottomLeft ? e >= n : t <= n);
          }, t.prototype.getMedians = function (t, e, n) {
            var o = this,
              i = {};
            return e.forEach(function (e) {
              var r = o.getActualAdjacentEdges(t, e, n),
                s = o.getMedianPosition(r.length, n);
              i[e.key] = r[s];
            }), i;
          }, t.prototype.getMedianPosition = function (t, e) {
            if (0 === t) return -1;
            if (t % 2 != 0) return Math.floor(t / 2);
            if (e === C.TopLeft || e === C.BottomLeft) return Math.floor(t / 2) - 1;
            if (e === C.TopRight || e === C.BottomRight) return Math.floor(t / 2);
            throw new Error("Invalid Operation");
          }, t.prototype.getActualAdjacentEdges = function (t, e, n) {
            return n === C.TopLeft || n === C.TopRight ? t.getAdjacentEdges(e.key, c.ConnectionMode.Incoming).sort(function (e, n) {
              return t.getNode(e.from).position - t.getNode(n.from).position;
            }) : t.getAdjacentEdges(e.key, c.ConnectionMode.Outgoing).sort(function (e, n) {
              return t.getNode(e.to).position - t.getNode(n.to).position;
            });
          }, t;
        }();
        e.SugiyamaNodesOrderer = v;
        var P = function () {
          function t(t, e, n, o) {
            this.key = t, this.isDummy = e, this.layer = n, this.position = o;
          }
          return t.prototype.getHashCode = function () {
            return this.key.toString();
          }, t;
        }();
        e.NodeOnLayer = P;
        var C,
          S = function () {
            function t(t, e, n, o, i) {
              this.key = t, this.isDummy = e, this.from = n, this.to = o, this._originFrom = i;
            }
            return t.prototype.getHashCode = function () {
              return this.from + "-" + this.to;
            }, Object.defineProperty(t.prototype, "originFrom", {
              get: function () {
                return void 0 !== this._originFrom ? this._originFrom : this.from;
              },
              enumerable: !1,
              configurable: !0
            }), t;
          }();
        function x(t) {
          return Math.trunc ? Math.trunc(t) : isFinite(t) ? t - t % 1 || (t < 0 ? -0 : 0 === t ? t : 0) : t;
        }
        e.EdgeOnLayer = S, function (t) {
          t[t.TopLeft = 0] = "TopLeft", t[t.TopRight = 1] = "TopRight", t[t.BottomLeft = 2] = "BottomLeft", t[t.BottomRight = 3] = "BottomRight";
        }(C || (C = {}));
      },
      2638: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ToggleFontItalicCommand = void 0;
        var r = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(e, t), e.prototype.getStyleProperty = function () {
            return "font-style";
          }, e.prototype.getStylePropertyValue = function () {
            return "italic";
          }, e;
        }(n(3210).ToggleStyleTextPropertyCommand);
        e.ToggleFontItalicCommand = r;
      },
      2651: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.TextToolbox = void 0;
        var r = function (t) {
          function e(e, n, o, i, r, s) {
            return t.call(this, e, n, o, i, r, s) || this;
          }
          return i(e, t), e.prototype.createElements = function (t, e) {
            var n = this;
            e.forEach(function (e) {
              var o = n.shapeDescriptionManager.get(e),
                i = document.createElement("div");
              i.setAttribute("class", "toolbox-text-item"), i.setAttribute("data-tb-type", e), i.textContent = o.getDefaultText() || o.getTitle(), t.appendChild(i);
            });
          }, e.prototype.createDraggingElement = function (t) {
            var e = document.createElement("DIV");
            e.setAttribute("class", "dxdi-toolbox-drag-text-item");
            var n = this.shapeDescriptionManager.get(t.evt.data);
            return e.textContent = n.getDefaultText() || n.getTitle(), document.body.appendChild(e), e;
          }, e;
        }(n(5037).Toolbox);
        e.TextToolbox = r;
      },
      2703: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ModelManipulator = void 0;
        var o = n(8601),
          i = n(3844),
          r = n(9196),
          s = n(4062),
          a = n(7841),
          c = n(5225),
          u = n(41),
          p = n(6320),
          h = n(3427),
          l = n(1922),
          d = function () {
            function t(t, e, n, o) {
              this.onModelChanged = new u.EventDispatcher(), this.onModelSizeChanged = new u.EventDispatcher(), this.initializeCore(t, e), this.permissionsProvider = n, this.descriptionManager = o, this.imageLoader = new a.ImageLoader(this.updateShapeImage.bind(this));
            }
            return t.prototype.initialize = function (t, e) {
              this.initializeCore(t, e), this.model.loadAllImages(this.imageLoader), this.updateModelSize();
            }, t.prototype.initializeCore = function (t, e) {
              var n = this;
              this.model = t, this.routingModel = e, this.routingModel && (this.routingModel.initialize(t), t.iterateItems(function (t) {
                if (t instanceof p.Connector) {
                  var e = n.routingModel.createStrategy(t.properties.lineOption);
                  e ? t.changeRoutingStrategy(e) : t.invalidateRenderPoints();
                }
              }));
            }, t.prototype.commitPageChanges = function () {
              this.raisePageSizeChanged(this.model.pageSize.clone(), this.model.pageLandscape), this.raiseModelSizeChanged(this.model.size.clone()), this.raisePageColorChanged(this.model.pageColor), this.raiseModelRectangleChanged(l.ModelUtils.createRectangle(this.model.items));
            }, t.prototype.commitItemsCreateChanges = function () {
              r.Diagnostics.timer("new model: model changes"), this.commitItemsChangesCore(h.ItemChangeType.Create, this.model.items), r.Diagnostics.endTimer();
            }, t.prototype.commitItemUpdateChanges = function (t) {
              this.commitItemsChangesCore(h.ItemChangeType.UpdateStructure, [t]);
            }, t.prototype.commitItemsChangesCore = function (t, e) {
              var n = [];
              e.forEach(function (e) {
                n.push(new h.ItemChange(e, t));
              }), n.length && this.raiseModelChanged(n);
            }, t.prototype.insertToContainer = function (t, e) {
              if (t.container && e && t.container.key !== e.key) throw Error("To insert an item to a container it's necessary to remove it from the current container.");
              e && (-1 === e.children.indexOf(t) && e.children.push(t), t.container = e, this.raiseModelChanged([new h.ItemChange(t, h.ItemChangeType.Update)]));
            }, t.prototype.removeFromContainer = function (t) {
              if (t.container) {
                var e = t.container.children.indexOf(t);
                t.container.children.splice(e, 1), t.container = void 0, this.raiseModelChanged([new h.ItemChange(t, h.ItemChangeType.Update)]);
              }
            }, t.prototype.changeStyle = function (t, e, n) {
              this.changeStyleCore(t, t.style, e, n);
            }, t.prototype.changeStyleText = function (t, e, n) {
              this.changeStyleCore(t, t.styleText, e, n);
            }, t.prototype.changeStyleCore = function (t, e, n, o) {
              void 0 !== o ? e[n] = o : delete e[n], this.raiseModelChanged([new h.ItemChange(t, h.ItemChangeType.UpdateProperties)]);
            }, t.prototype.changeZIndex = function (t, e) {
              t.zIndex = e, this.raiseModelChanged([new h.ItemChange(t, h.ItemChangeType.Update)]);
            }, t.prototype.changeLocked = function (t, e) {
              t.locked = e, this.raiseModelChanged([new h.ItemChange(t, h.ItemChangeType.UpdateClassName)]);
            }, t.prototype.changeCustomData = function (t, e) {
              t.customData = u.ObjectUtils.cloneObject(e), this.raiseModelChanged([new h.ItemChange(t, h.ItemChangeType.UpdateStructure)]);
            }, t.prototype.addShape = function (t, e) {
              if (t.attachedConnectors.length) throw Error("A creating shape should not contain existing connectors.");
              return t.key = void 0 !== e ? e : this.model.getNextKey(), this.insertShape(t);
            }, t.prototype.insertShape = function (t) {
              this.model.pushItem(t);
              var e = this.permissionsProvider.canAddItems([t]);
              return this.raiseModelChanged([new h.ItemChange(t, h.ItemChangeType.Create, e)]), this.model.loadAllImages(this.imageLoader), t;
            }, t.prototype.resizeShape = function (t, e, n) {
              t.position = e, t.size = n;
              var o = this.permissionsProvider.isStoredPermissionsGranted(),
                i = this.getInteractingItem(t, c.DiagramModelOperation.ResizeShape);
              if (i) {
                var r = i.size.clone(),
                  s = t.size.clone();
                s.equals(r) || (o = this.permissionsProvider.canResizeShapes([{
                  shape: t,
                  size: s,
                  oldSize: r
                }]));
              }
              var a = this.getInteractingItem(t, c.DiagramModelOperation.MoveShape);
              if (a) {
                var u = a.position.clone(),
                  p = t.position.clone();
                p.equals(u) || (o = this.permissionsProvider.canMoveShapes([{
                  shape: t,
                  position: p,
                  oldPosition: u
                }]));
              }
              this.raiseModelChanged([new h.ItemChange(t, h.ItemChangeType.UpdateProperties, o)]);
            }, t.prototype.moveShape = function (t, e) {
              t.position = e;
              var n = this.permissionsProvider.isStoredPermissionsGranted();
              this.getInteractingItem(t, c.DiagramModelOperation.AddShape) && (n = this.permissionsProvider.canAddItems([t]));
              var o = this.getInteractingItem(t, c.DiagramModelOperation.MoveShape);
              if (o) {
                var i = o.position.clone(),
                  r = t.position.clone();
                r.equals(i) || (n = this.permissionsProvider.canMoveShapes([{
                  shape: t,
                  position: r,
                  oldPosition: i
                }]));
              }
              this.raiseModelChanged([new h.ItemChange(t, h.ItemChangeType.UpdateProperties, n)]);
            }, t.prototype.changeShapeParameters = function (t, e) {
              t.parameters.forEach(function (t) {
                var n = e.get(t.key);
                n && (t.value = n.value);
              }), this.raiseModelChanged([new h.ItemChange(t, h.ItemChangeType.UpdateProperties)]);
            }, t.prototype.changeShapeText = function (t, e) {
              t.text = e, this.raiseModelChanged([new h.ItemChange(t, h.ItemChangeType.UpdateStructure)]);
            }, t.prototype.changeShapeImage = function (t, e) {
              t.image = e;
              var n = s.ImageCache.instance.createUnloadedInfoByShapeImageInfo(e);
              this.imageLoader.load(n), this.raiseModelChanged([new h.ItemChange(t, h.ItemChangeType.UpdateStructure)]);
            }, t.prototype.changeShapeExpanded = function (t, e) {
              t.expanded = e, t.toggleExpandedSize(), this.raiseModelChanged([new h.ItemChange(t, h.ItemChangeType.UpdateStructure)]);
            }, t.prototype.deleteShape = function (t, e) {
              if (t.attachedConnectors.length) throw Error("A removing shape should not contain existing connectors.");
              this.removeShape(t, e);
            }, t.prototype.removeShape = function (t, e) {
              this.model.removeItem(t), this.raiseModelChanged([new h.ItemChange(t, h.ItemChangeType.Remove, e)]);
            }, t.prototype.updateShapeImage = function (t) {
              if (t.imageUrl) {
                var e = this.model.findShapesByImageUrl(t.imageUrl);
                e.forEach(function (e) {
                  t.base64 ? e.image.loadBase64Content(t.base64) : e.image.setUnableToLoadFlag();
                }), this.commitItemsChangesCore(h.ItemChangeType.UpdateStructure, e);
              }
            }, t.prototype.updateShapeDescription = function (t) {
              var e = this.model.findShapesByDescription(t);
              this.commitItemsChangesCore(h.ItemChangeType.UpdateProperties, e);
            }, t.prototype.updateShapeType = function (t, e, n) {
              var o = this.descriptionManager.get(e);
              t.description = o, t.parameters = n, o.createParameters(n), this.raiseModelChanged([new h.ItemChange(t, h.ItemChangeType.UpdateStructure)]);
            }, t.prototype.addConnector = function (t, e) {
              if (t.beginItem || t.endItem) throw Error("Creating connector should not contain begin/end items");
              return t.key = void 0 !== e ? e : this.model.getNextKey(), this.insertConnector(t);
            }, t.prototype.insertConnector = function (t) {
              this.model.pushItem(t);
              var e = this.routingModel.createStrategy(t.properties.lineOption);
              e ? t.changeRoutingStrategy(e) : t.clearRoutingStrategy();
              var n = this.permissionsProvider.canAddItems([t]);
              return this.raiseModelChanged([new h.ItemChange(t, h.ItemChangeType.Create, n)]), t;
            }, t.prototype.deleteConnector = function (t) {
              if (t.beginItem || t.endItem) throw Error("Creating connector should not contain begin/end items");
              this.removeConnector(t);
            }, t.prototype.removeConnector = function (t) {
              this.model.removeItem(t);
              var e = this.permissionsProvider.canDeleteItems([t]);
              this.raiseModelChanged([new h.ItemChange(t, h.ItemChangeType.Remove, e)]);
            }, t.prototype.addDeleteConnectorPoint = function (t, e) {
              var n = this.getConnectorInteractingPoints(t);
              e(t), this.addDeleteConnectorPointCore(t, n);
            }, t.prototype.moveConnectorPoint = function (t, e, n) {
              n(t), this.moveConnectorPointCore(t, e);
            }, t.prototype.changeConnectorPoints = function (t, e) {
              var n = this;
              e(t), t.points.forEach(function (e, o) {
                return n.moveConnectorPointCore(t, o);
              });
            }, t.prototype.moveConnectorPointCore = function (t, e) {
              var n = this.getInteractingItem(t),
                o = this.permissionsProvider.isStoredPermissionsGranted();
              if (n) {
                var i = 0 < e && e < t.points.length - 1;
                if (i = (i = i || 0 === e && !t.beginItem) || e === t.points.length - 1 && !t.endItem) {
                  var r = n.points.map(function (t) {
                      return t.clone();
                    }),
                    s = t.points.map(function (t) {
                      return t.clone();
                    });
                  u.GeometryUtils.arePointsEqual(r, s) || (o = this.permissionsProvider.canChangeConnectorPoints(t, r, s));
                }
              }
              this.raiseModelChanged([new h.ItemChange(t, h.ItemChangeType.UpdateProperties, o)]);
            }, t.prototype.getConnectorInteractingPoints = function (t) {
              var e = this.getInteractingItem(t);
              return e ? e.points.map(function (t) {
                return t.clone();
              }) : t.points.map(function (t) {
                return t.clone();
              });
            }, t.prototype.addDeleteConnectorPointCore = function (t, e) {
              var n = this.permissionsProvider.isStoredPermissionsGranted(),
                o = t.points.map(function (t) {
                  return t.clone();
                });
              u.GeometryUtils.arePointsEqual(e, o) || (n = this.permissionsProvider.canChangeConnectorPoints(t, e, o)), this.raiseModelChanged([new h.ItemChange(t, h.ItemChangeType.UpdateProperties, n)]);
            }, t.prototype.addConnection = function (t, e, n, o) {
              var i = t.getExtremeItem(o),
                r = t.getExtremeConnectionPointIndex(o);
              if (i !== e || r !== n) {
                if (i) throw Error("Connector is already connected");
                e.attachedConnectors.push(t), o === p.ConnectorPosition.Begin ? (t.beginItem = e, t.beginConnectionPointIndex = n) : (t.endItem = e, t.endConnectionPointIndex = n), t.invalidateRenderPoints();
                var s = this.permissionsProvider.canChangeConnection(t, e, void 0, o, n);
                this.raiseModelChanged([new h.ItemChange(t, h.ItemChangeType.UpdateProperties, s)]);
              }
            }, t.prototype.setConnectionPointIndex = function (t, e, n) {
              if (!t.getExtremeItem(n)) throw Error("Connection should be connected");
              n === p.ConnectorPosition.Begin ? t.beginConnectionPointIndex = e : t.endConnectionPointIndex = e, t.invalidateRenderPoints();
              var o = t.getExtremeItem(n),
                i = this.permissionsProvider.canChangeConnection(t, o, o, n, e);
              this.raiseModelChanged([new h.ItemChange(t, h.ItemChangeType.UpdateProperties, i)]);
            }, t.prototype.deleteConnection = function (t, e) {
              var n = t.getExtremeItem(e);
              if (n) {
                n.attachedConnectors.splice(n.attachedConnectors.indexOf(t), 1), e === p.ConnectorPosition.Begin ? (t.beginItem = null, t.beginConnectionPointIndex = -1) : (t.endItem = null, t.endConnectionPointIndex = -1), t.invalidateRenderPoints();
                var o = this.permissionsProvider.canChangeConnection(t, void 0, n, e, -1);
                this.raiseModelChanged([new h.ItemChange(t, h.ItemChangeType.UpdateProperties, o)]);
              }
            }, t.prototype.changeConnectorProperty = function (t, e, n) {
              if (t.properties[e] = n, "lineOption" === e) {
                var o = this.routingModel ? this.routingModel.createStrategy(t.properties.lineOption) : void 0;
                o ? t.changeRoutingStrategy(o) : t.clearRoutingStrategy();
              } else t.invalidateRenderPoints();
              this.raiseModelChanged([new h.ItemChange(t, h.ItemChangeType.UpdateProperties)]);
            }, t.prototype.changeConnectorText = function (t, e, n) {
              t.setText(e, n), this.raiseModelChanged([new h.ItemChange(t, h.ItemChangeType.UpdateStructure)]);
            }, t.prototype.changeConnectorTextPosition = function (t, e, n) {
              var o = t.getText(e);
              t.setText(null, e), t.setText(o, n), this.raiseModelChanged([new h.ItemChange(t, h.ItemChangeType.UpdateProperties)]);
            }, t.prototype.changeModelSize = function (t, e) {
              this.model.size.width = t.width, this.model.size.height = t.height, this.raiseModelSizeChanged(this.model.size.clone(), e), (e.left || e.top) && (this.model.snapStartPoint = this.model.snapStartPoint.clone().offset(e.left, e.top), this.raiseSnapPointChange(this.model.snapStartPoint));
            }, t.prototype.changePageSize = function (t) {
              this.model.pageSize.equals(t) || (this.model.pageSize = t, this.model.size = new i.Size(this.model.pageWidth, this.model.pageHeight), this.raiseModelSizeChanged(this.model.size.clone()), this.raisePageSizeChanged(this.model.pageSize, this.model.pageLandscape));
            }, t.prototype.changePageLandscape = function (t) {
              this.model.pageLandscape !== t && (this.model.pageLandscape = t, this.model.pageSize.width !== this.model.pageSize.height && (this.model.size = new i.Size(this.model.pageWidth, this.model.pageHeight), this.raiseModelSizeChanged(this.model.size.clone()), this.raisePageSizeChanged(this.model.pageSize, this.model.pageLandscape)));
            }, t.prototype.changePageColor = function (t) {
              this.model.pageColor !== t && (this.model.pageColor = t, this.raisePageColorChanged(t));
            }, t.prototype.updateModelSize = function () {
              var t = this.getModelSizeUpdateOffset();
              if (!t.isEmpty()) {
                var e = Math.max(this.model.size.width + t.left + t.right, this.model.pageWidth),
                  n = Math.max(this.model.size.height + t.top + t.bottom, this.model.pageHeight);
                this.model.size = new i.Size(e, n);
              }
            }, t.prototype.getModelSizeUpdateOffset = function () {
              var t = this.model.getRectangle(!1),
                e = this.model.getRectangle(!0);
              return e.equals(t) || this.raiseModelRectangleChanged(e), this.createModelRectangleOffset(e);
            }, t.prototype.createModelRectangleOffset = function (t) {
              var e = this.model.pageWidth,
                n = this.model.pageHeight,
                i = this.model.size;
              return new o.Offsets(-Math.floor(t.x / e) * e, -Math.floor((i.width - t.right) / e) * e, -Math.floor(t.y / n) * this.model.pageHeight, -Math.floor((i.height - t.bottom) / n) * n);
            }, t.prototype.raiseModelChanged = function (t) {
              this.onModelChanged.raise1(function (e) {
                return e.notifyModelChanged(t);
              });
            }, t.prototype.raisePageColorChanged = function (t) {
              this.onModelChanged.raise1(function (e) {
                return e.notifyPageColorChanged(t);
              });
            }, t.prototype.raisePageSizeChanged = function (t, e) {
              this.onModelChanged.raise1(function (n) {
                return n.notifyPageSizeChanged(t, e);
              });
            }, t.prototype.raiseModelSizeChanged = function (t, e) {
              this.onModelSizeChanged.raise1(function (n) {
                return n.notifyModelSizeChanged(t, e);
              });
            }, t.prototype.raiseModelRectangleChanged = function (t) {
              this.onModelSizeChanged.raise1(function (e) {
                return e.notifyModelRectangleChanged(t);
              });
            }, t.prototype.raiseSnapPointChange = function (t) {
              this.onModelSizeChanged.raise1(function (e) {
                return e.notifySnapPointPositionChanged(t);
              });
            }, t.prototype.getInteractingItem = function (t, e) {
              return this.permissionsProvider.getInteractingItem(t, e);
            }, t;
          }();
        e.ModelManipulator = d;
      },
      2721: (t, e) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.UniqueAStarNodePositions = void 0;
        var n = function () {
          function t(t) {
            void 0 === t && (t = function (t) {
              return t.toString();
            }), this.getKey = t, this.items = {}, this.length = 0;
          }
          return Object.defineProperty(t.prototype, "count", {
            get: function () {
              return this.length;
            },
            enumerable: !1,
            configurable: !0
          }), t.prototype.getNode = function (t) {
            var e = this.items[this.getKey(t)];
            return void 0 !== e ? e.node : void 0;
          }, t.prototype.add = function (t, e) {
            var n = this.getKey(t);
            void 0 === this.items[n] && (this.length++, this.items[n] = {
              position: t,
              node: e
            });
          }, t.prototype.remove = function (t) {
            var e = this.getKey(t);
            void 0 !== this.items[e] && (this.length--, delete this.items[e]);
          }, t;
        }();
        e.UniqueAStarNodePositions = n;
      },
      2740: (t, e) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AStarNode = void 0;
        var n = function () {
          function t(t, e) {
            this.position = t, this.distance = e, this.penalty = 0;
          }
          return Object.defineProperty(t.prototype, "key", {
            get: function () {
              return this.distance + this.penalty;
            },
            enumerable: !1,
            configurable: !0
          }), t.prototype.getPath = function () {
            for (var t = [], e = this; void 0 !== e;) t.splice(0, 0, e.position), e = e.parent;
            return t;
          }, t;
        }();
        e.AStarNode = n;
      },
      2748: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.BringToFrontCommand = void 0;
        var r = n(672),
          s = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), e.prototype.isEnabled = function () {
              var e = this.control.selection.getSelectedItems();
              return t.prototype.isEnabled.call(this) && e.length > 0 && this.needBringToFront(e);
            }, e.prototype.executeCore = function (t, e) {
              var n = this;
              return this.control.history.beginTransaction(), this.control.selection.getSelectedItems().forEach(function (t) {
                var e = n.control.model.getIntersectItemsMaxZIndex(t) + 1;
                n.control.history.addAndRedo(new r.ChangeZindexHistoryItem(t, e));
              }), this.control.history.endTransaction(), !0;
            }, e.prototype.needBringToFront = function (t) {
              for (var e = this, n = function (n) {
                  var i = o.control.model.getIntersectItemsMaxZIndex(t[n]);
                  if (i > t[n].zIndex) return {
                    value: !0
                  };
                  if (i === t[n].zIndex) {
                    var r = !1;
                    return o.control.model.getIntersectItems(t[n]).filter(function (e) {
                      return e.zIndex === t[n].zIndex;
                    }).forEach(function (o) {
                      e.control.model.getItemIndex(o) > e.control.model.getItemIndex(t[n]) && (r = !0);
                    }), {
                      value: r
                    };
                  }
                }, o = this, i = 0; i < t.length; i++) {
                var r = n(i);
                if ("object" == typeof r) return r.value;
              }
              return !1;
            }, e;
          }(n(3913).SimpleCommandBase);
        e.BringToFrontCommand = s;
      },
      2771: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ChangeConnectorTextPositionHistoryItem = void 0;
        var r = function (t) {
          function e(e, n, o) {
            var i = t.call(this) || this;
            return i.connectorKey = e.key, i.position = n, i.newPosition = o, i;
          }
          return i(e, t), e.prototype.redo = function (t) {
            var e = t.model.findConnector(this.connectorKey);
            t.changeConnectorTextPosition(e, this.position, this.newPosition);
          }, e.prototype.undo = function (t) {
            var e = t.model.findConnector(this.connectorKey);
            t.changeConnectorTextPosition(e, this.newPosition, this.position);
          }, e;
        }(n(2616).HistoryItem);
        e.ChangeConnectorTextPositionHistoryItem = r;
      },
      2781: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.HardDiskShapeDescription = void 0;
        var r = n(3190),
          s = n(3255),
          a = n(6208),
          c = n(7345),
          u = n(1280),
          p = n(3844),
          h = function (t) {
            function e() {
              return t.call(this, void 0, !0) || this;
            }
            return i(e, t), Object.defineProperty(e.prototype, "key", {
              get: function () {
                return s.ShapeTypes.HardDisk;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "keepRatioOnAutoSize", {
              get: function () {
                return !1;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.createShapePrimitives = function (t) {
              var n = t.rectangle,
                o = n.x,
                i = n.y,
                r = n.right,
                s = n.bottom,
                u = n.width,
                p = n.center.y,
                h = u * e.arcWidthRatio;
              return [new a.PathPrimitive([new a.PathPrimitiveMoveToCommand(r - h / 2, i), new a.PathPrimitiveLineToCommand(o + h / 2, i), new a.PathPrimitiveArcToCommand(h / 2, (s - i) / 2, 0, !1, !1, o + h / 2, s), new a.PathPrimitiveLineToCommand(r - h / 2, s)], t.style), new c.EllipsePrimitive(r - h / 2, p, h / 2, (s - i) / 2, t.style)];
            }, e.prototype.getTextRectangle = function (t) {
              var n = t.rectangle,
                o = n.width * e.arcWidthRatio * 1.5;
              return n.clone().resize(-o - 2 * u.ShapeTextPadding, -2 * u.ShapeTextPadding).moveRectangle(u.ShapeTextPadding, u.ShapeTextPadding).nonNegativeSize();
            }, e.prototype.getSizeByText = function (t, n) {
              return new p.Size((t.width + 2 * u.ShapeTextPadding) / (1 - 1.5 * e.arcWidthRatio), n.size.height + u.ShapeTextPadding);
            }, e.arcWidthRatio = .2, e;
          }(r.RectangleShapeDescription);
        e.HardDiskShapeDescription = h;
      },
      2803: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ContextMenuHandler = void 0;
        var r = n(41),
          s = n(5428),
          a = n(6537),
          c = n(815),
          u = n(8424),
          p = function (t) {
            function e() {
              var e = null !== t && t.apply(this, arguments) || this;
              return e.contextMenuVisible = !1, e.textInputStarted = !1, e.canHideContextMenu = !0, e.onVisibilityChanged = new r.EventDispatcher(), e;
            }
            return i(e, t), e.prototype.onMouseDown = function (t) {
              t.button === s.MouseButton.Left && t.source.type !== s.MouseEventElementType.Undefined && this.hideContextMenu();
            }, e.prototype.onMouseUp = function (t) {
              (!u.Browser.MacOSPlatform || u.Browser.MacOSPlatform && this.canHideContextMenu) && this.hideContextMenu(), this.canHideContextMenu = !0;
            }, e.prototype.onContextMenu = function (t) {
              u.Browser.MacOSPlatform && (this.canHideContextMenu = !1), this.showContextMenu(t.eventPoint, t.modelPoint);
            }, e.prototype.onFocus = function (t) {}, e.prototype.onBlur = function (t) {}, e.prototype.onTextInputFocus = function (t) {}, e.prototype.onTextInputBlur = function (t) {}, e.prototype.onLongTouch = function (t) {}, e.prototype.onKeyDown = function (t) {
              t.keyCode === a.KeyCode.Esc && this.hideContextMenu();
            }, e.prototype.onShortcut = function (t) {
              this.hideContextMenu();
            }, e.prototype.showContextMenu = function (t, e) {
              var n = this;
              this.textInputStarted || window.setTimeout(function () {
                n.onVisibilityChanged.raise1(function (n) {
                  return n.notifyShowContextMenu(t, e);
                }), n.contextMenuVisible = !0;
              }, 1);
            }, e.prototype.hideContextMenu = function () {
              var t = this;
              this.contextMenuVisible && window.setTimeout(function () {
                t.onVisibilityChanged.raise1(function (t) {
                  return t.notifyHideContextMenu();
                }), t.contextMenuVisible = !1;
              }, 1);
            }, e.prototype.notifyDragStart = function (t) {}, e.prototype.notifyDragEnd = function (t) {}, e.prototype.notifyDragScrollStart = function () {}, e.prototype.notifyDragScrollEnd = function () {}, e.prototype.notifyShowContextToolbox = function (t, e, n, o, i) {}, e.prototype.notifyHideContextToolbox = function () {}, e.prototype.notifyTextInputStart = function (t, e, n, o) {
              this.textInputStarted = !0;
            }, e.prototype.notifyTextInputEnd = function (t, e) {
              this.textInputStarted = !1;
            }, e.prototype.notifyTextInputPermissionsCheck = function (t, e) {}, e.prototype.onUpdateUnlocked = function (t) {}, e;
          }(c.BatchUpdatableObject);
        e.ContextMenuHandler = p;
      },
      2807: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MutableInterval = void 0;
        var o = n(5215),
          i = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o.__extends(e, t), e.prototype.normalizeLength = function () {
              return this.length < 0 && (this.length = 0), this;
            }, e;
          }(n(7446).ConstInterval);
        e.MutableInterval = i;
      },
      2815: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MouseHandlerDraggingState = void 0;
        var r = n(9589),
          s = n(5428),
          a = n(9500),
          c = function (t) {
            function e(e, n) {
              var o = t.call(this, e) || this;
              return o.history = n, o;
            }
            return i(e, t), e.prototype.canApplyChangesOnMouseMove = function (t, n) {
              return !t || !n || Math.abs(t.x - n.x) > e.dragStartLimit || Math.abs(t.y - n.y) > e.dragStartLimit;
            }, e.prototype.onAfterApplyChanges = function () {
              this.modified || this.handler.raiseDragStart(this.getDraggingElementKeys()), this.modified = !0, this.mouseDownPoint = void 0;
            }, e.prototype.onMouseDown = function (t) {
              this.mouseDownPoint = t.modelPoint.clone();
            }, e.prototype.onMouseMove = function (t) {
              this.mouseMoveEvent = t, t.button !== s.MouseButton.Left ? (this.cancelChanges(), this.handler.switchToDefaultState()) : t.button === s.MouseButton.Left && this.canApplyChangesOnMouseMove(this.mouseDownPoint, t.modelPoint) && (this.onApplyChanges(t), this.onAfterApplyChanges());
            }, e.prototype.onKeyDown = function (t) {
              !this.mouseMoveEvent || 16 !== t.keyCode && 17 !== t.keyCode && 18 !== t.keyCode || this.performMouseMoveEvent(t.modifiers);
            }, e.prototype.onKeyUp = function (t) {
              !this.mouseMoveEvent || 16 !== t.keyCode && 17 !== t.keyCode && 18 !== t.keyCode || this.performMouseMoveEvent(t.modifiers);
            }, e.prototype.onMouseUp = function (t) {
              this.mouseDownPoint = void 0, this.mouseMoveEvent = void 0, this.handler.switchToDefaultState();
            }, e.prototype.performMouseMoveEvent = function (t) {
              this.mouseMoveEvent.modifiers = t, this.onMouseMove(this.mouseMoveEvent);
            }, e.prototype.start = function () {
              this.handler.beginStorePermissions(), this.history.beginTransaction();
            }, e.prototype.finish = function () {
              this.checkStoredPermissionsOnFinish(), this.modified ? (this.onFinishWithChanges(), this.modified = !1, this.history.endTransaction(), this.handler.raiseDragEnd(this.getDraggingElementKeys())) : this.history.endTransaction(), this.handler.endStorePermissions(), this.handler.clearInteractingItems();
            }, e.prototype.checkStoredPermissionsOnFinish = function () {
              this.handler.isStoredPermissionsGranted() || (this.cancelChanges(), this.modified = !1);
            }, e.prototype.onFinishWithChanges = function () {}, e.prototype.cancelChanges = function () {
              this.handler.lockPermissions(), this.history.undoTransaction(), this.handler.unlockPermissions(), this.modified && this.handler.raiseDragEnd(this.getDraggingElementKeys()), this.modified = !1;
            }, e.prototype.getSnappedPoint = function (t, e) {
              return this.handler.getSnappedPointOnDragPoint(t, e);
            }, e.dragStartLimit = a.UnitConverter.pixelsToTwips(4), e;
          }(r.MouseHandlerCancellableState);
        e.MouseHandlerDraggingState = c;
      },
      2871: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.FixedInterval = void 0;
        var o = n(5215),
          i = function (t) {
            function e(e, n) {
              var o = t.call(this) || this;
              return o.start = e, o.length = n, o;
            }
            return o.__extends(e, t), Object.defineProperty(e.prototype, "end", {
              get: function () {
                return this.start + this.length;
              },
              set: function (t) {
                this.length = t - this.start;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "center", {
              get: function () {
                return this.start + this.length / 2;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.copyFrom = function (t) {
              this.start = t.start, this.length = t.length;
            }, e.prototype.equals = function (t) {
              return t && this.start === t.start && this.length === t.length;
            }, e.prototype.clone = function () {
              return new e(this.start, this.length);
            }, e.prototype.makeByStartEnd = function (t, n) {
              return new e(t, n - t);
            }, e.prototype.makeByStartLength = function (t, n) {
              return new e(t, n);
            }, e.prototype.makeByLengthEnd = function (t, n) {
              return new e(n - t, t);
            }, e.fromPositions = function (t, n) {
              return new e(t, n - t);
            }, e.makeByConstInterval = function (t) {
              return new e(t.start, t.length);
            }, e.prototype.expand = function (t) {
              var e = Math.max(t.end, this.end);
              return this.start = Math.min(t.start, this.start), this.end = e, this;
            }, e;
          }(n(2807).MutableInterval);
        e.FixedInterval = i;
      },
      2892: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ListUtils = void 0;
        var o = n(3196),
          i = n(3262),
          r = function () {
            function t() {}
            return t.remove = function (t, e) {
              var n = t.indexOf(e, 0);
              n >= 0 && t.splice(n, 1);
            }, t.removeBy = function (t, e) {
              for (var n = t.length, o = 0; o < n; o++) if (e(t[o], o)) return t.splice(o, 1)[0];
              return null;
            }, t.shallowCopy = function (t) {
              return t.slice();
            }, t.deepCopy = function (e) {
              return t.map(e, function (t) {
                return t.clone();
              });
            }, t.initByValue = function (t, e) {
              for (var n = []; t > 0; t--) n.push(e);
              return n;
            }, t.initByCallback = function (t, e) {
              for (var n = [], o = 0; o < t; o++) n.push(e(o));
              return n;
            }, t.forEachOnInterval = function (t, e) {
              for (var n = t.end, o = t.start; o < n; o++) e(o);
            }, t.reverseForEachOnInterval = function (t, e) {
              for (var n = t.start, o = t.end - 1; o >= n; o--) e(o);
            }, t.reducedMap = function (t, e, n, o) {
              void 0 === n && (n = 0), void 0 === o && (o = t.length);
              for (var i = [], r = n; r < o; r++) {
                var s = e(t[r], r);
                null !== s && i.push(s);
              }
              return i;
            }, t.filter = function (t, e, n, o) {
              void 0 === n && (n = 0), void 0 === o && (o = t.length);
              for (var i = [], r = n; r < o; r++) {
                var s = t[r];
                e(s, r) && i.push(s);
              }
              return i;
            }, t.map = function (t, e, n, o) {
              void 0 === n && (n = 0), void 0 === o && (o = t.length);
              for (var i = [], r = n; r < o; r++) i.push(e(t[r], r));
              return i;
            }, t.indexBy = function (t, e, n, o) {
              void 0 === n && (n = 0), void 0 === o && (o = t.length);
              for (var i = n; i < o; i++) if (e(t[i], i)) return i;
              return -1;
            }, t.reverseIndexBy = function (t, e, n, o) {
              void 0 === n && (n = t.length - 1), void 0 === o && (o = 0);
              for (var i = n; i >= o; i--) if (e(t[i], i)) return i;
              return -1;
            }, t.elementBy = function (e, n, o, i) {
              void 0 === o && (o = 0), void 0 === i && (i = e.length);
              var r = t.indexBy(e, n, o, i);
              return r < 0 ? null : e[r];
            }, t.reverseElementBy = function (e, n, o, i) {
              void 0 === o && (o = e.length - 1), void 0 === i && (i = 0);
              var r = t.reverseIndexBy(e, n, o, i);
              return r < 0 ? null : e[r];
            }, t.last = function (t) {
              return t[t.length - 1];
            }, t.setLast = function (t, e) {
              return t[t.length - 1] = e;
            }, t.incLast = function (t) {
              return ++t[t.length - 1];
            }, t.decLast = function (t) {
              return --t[t.length - 1];
            }, t.equals = function (e, n) {
              return e.length === n.length && t.allOf2(e, n, function (t, e) {
                return t.equals(e);
              });
            }, t.equalsByReference = function (t, e) {
              var n = t.length;
              if (n !== t.length) return !1;
              for (var o = 0; o < n; o++) if (t[o] !== e[o]) return !1;
              return !0;
            }, t.unique = function (e, n, o, i) {
              void 0 === o && (o = n), void 0 === i && (i = function () {});
              var r = e.length;
              if (0 === r) return [];
              var s = (e = e.sort(n))[0],
                a = t.reducedMap(e, function (t) {
                  return 0 !== o(s, t) ? (s = t, t) : (i(t), null);
                }, 1, r);
              return a.unshift(e[0]), a;
            }, t.uniqueNumber = function (t) {
              t = t.sort(i.Comparers.number);
              for (var e = Number.NaN, n = t.length - 1; n >= 0; n--) e === t[n] ? t.splice(n, 1) : e = t[n];
              return t;
            }, t.forEach = function (t, e, n, o) {
              void 0 === n && (n = 0), void 0 === o && (o = t.length);
              for (var i = n; i < o; i++) e(t[i], i);
            }, t.forEach2 = function (t, e, n, o, i) {
              void 0 === o && (o = 0), void 0 === i && (i = t.length);
              for (var r = o; r < i; r++) n(t[r], e[r], r);
            }, t.reverseForEach = function (t, e, n, o) {
              void 0 === n && (n = t.length - 1), void 0 === o && (o = 0);
              for (var i = n; i >= o; i--) e(t[i], i);
            }, t.reverseIndexOf = function (t, e, n, o) {
              void 0 === n && (n = t.length - 1), void 0 === o && (o = 0);
              for (var i = n; i >= o; i--) if (t[i] === e) return i;
              return -1;
            }, t.accumulate = function (t, e, n, o, i) {
              void 0 === o && (o = 0), void 0 === i && (i = t.length);
              for (var r = e, s = o; s < i; s++) r = n(r, t[s], s);
              return r;
            }, t.accumulateNumber = function (t, e, n, o, i) {
              void 0 === n && (n = 0), void 0 === o && (o = 0), void 0 === i && (i = t.length);
              for (var r = n, s = o; s < i; s++) r += e(t[s], s, r);
              return r;
            }, t.anyOf = function (t, e, n, o) {
              void 0 === n && (n = 0), void 0 === o && (o = t.length);
              for (var i = n; i < o; i++) if (e(t[i], i)) return !0;
              return !1;
            }, t.unsafeAnyOf = function (t, e, n, o) {
              void 0 === n && (n = 0), void 0 === o && (o = t.length);
              for (var i = n; i < o; i++) {
                var r = e(t[i], i);
                if (r) return r;
              }
              return null;
            }, t.reverseAnyOf = function (t, e, n, o) {
              void 0 === n && (n = t.length - 1), void 0 === o && (o = 0);
              for (var i = n; i >= o; i--) if (e(t[i], i)) return !0;
              return !1;
            }, t.unsafeReverseAnyOf = function (t, e, n, o) {
              void 0 === n && (n = t.length - 1), void 0 === o && (o = 0);
              for (var i = n; i >= o; i--) {
                var r = e(t[i], i);
                if (r) return r;
              }
              return null;
            }, t.anyOf2 = function (t, e, n, o, i) {
              void 0 === o && (o = 0), void 0 === i && (i = t.length);
              for (var r = o; r < i; r++) if (n(t[r], e[r], r)) return !0;
              return !1;
            }, t.allOf = function (t, e, n, o) {
              void 0 === n && (n = 0), void 0 === o && (o = t.length);
              for (var i = n; i < o; i++) if (!e(t[i], i)) return !1;
              return !0;
            }, t.allOf2 = function (t, e, n, o, i) {
              void 0 === o && (o = 0), void 0 === i && (i = t.length);
              for (var r = o; r < i; r++) if (!n(t[r], e[r], r)) return !1;
              return !0;
            }, t.allOfOnInterval = function (t, e) {
              for (var n = t.end, o = t.start; o < n; o++) if (!e(o)) return !1;
              return !0;
            }, t.addListOnTail = function (t, e) {
              for (var n = 0, o = void 0; o = e[n]; n++) t.push(o);
              return t;
            }, t.joinLists = function (e) {
              for (var n = [], o = 1; o < arguments.length; o++) n[o - 1] = arguments[o];
              return t.accumulate(n, [], function (n, o) {
                return t.addListOnTail(n, e(o)), n;
              });
            }, t.push = function (t, e) {
              return t.push(e), t;
            }, t.countIf = function (e, n) {
              return t.accumulateNumber(e, function (t, e) {
                return n(t, e) ? 1 : 0;
              });
            }, t.clear = function (t) {
              t.splice(0);
            }, t.merge = function (t, e, n, o, i, r) {
              if (void 0 === i && (i = 0), void 0 === r && (r = t.length), t = t.slice(i, r), r - i < 2) return t;
              for (var s = (t = t.sort(e))[i], a = [s], c = i + 1; c < r; c++) {
                var u = t[c];
                n(s, u) ? o(s, u) : (s = u, a.push(s));
              }
              return a;
            }, t.min = function (e, n, o, i) {
              void 0 === o && (o = 0), void 0 === i && (i = e.length);
              var r = t.minExtended(e, n, o, i);
              return r ? r.minElement : null;
            }, t.max = function (e, n, o, i) {
              void 0 === o && (o = 0), void 0 === i && (i = e.length);
              var r = t.maxExtended(e, n, o, i);
              return r ? r.maxElement : null;
            }, t.minMax = function (e, n, i, r) {
              void 0 === i && (i = 0), void 0 === r && (r = e.length);
              var s = t.minMaxExtended(e, n, i, r);
              return s ? new o.MinMax(s.minElement, s.maxElement) : null;
            }, t.minExtended = function (t, e, n, i) {
              if (void 0 === n && (n = 0), void 0 === i && (i = t.length), 0 === t.length) return null;
              for (var r = t[n], s = e(r), a = n + 1; a < i; a++) {
                var c = t[a],
                  u = e(c);
                u < s && (s = u, r = c);
              }
              return new o.ExtendedMin(r, s);
            }, t.maxExtended = function (t, e, n, i) {
              if (void 0 === n && (n = 0), void 0 === i && (i = t.length), 0 === t.length) return null;
              for (var r = t[n], s = e(r), a = n + 1; a < i; a++) {
                var c = t[a],
                  u = e(c);
                u > s && (s = u, r = c);
              }
              return new o.ExtendedMax(r, s);
            }, t.minMaxExtended = function (t, e, n, i) {
              if (void 0 === n && (n = 0), void 0 === i && (i = t.length), 0 === t.length) return null;
              for (var r = t[n], s = r, a = e(r), c = a, u = n + 1; u < i; u++) {
                var p = t[u],
                  h = e(p);
                h < a ? (a = h, r = p) : h > c && (c = h, s = p);
              }
              return new o.ExtendedMinMax(r, a, s, c);
            }, t.minByCmp = function (t, e, n, o) {
              if (void 0 === n && (n = 0), void 0 === o && (o = t.length), 0 === t.length) return null;
              for (var i = t[n], r = n + 1; r < o; r++) {
                var s = t[r];
                e(s, i) < 0 && (i = s);
              }
              return i;
            }, t.maxByCmp = function (t, e, n, o) {
              if (void 0 === n && (n = 0), void 0 === o && (o = t.length), 0 === t.length) return null;
              for (var i = t[n], r = n + 1; r < o; r++) {
                var s = t[r];
                e(s, i) > 0 && (i = s);
              }
              return i;
            }, t.minMaxByCmp = function (t, e, n, i) {
              if (void 0 === n && (n = 0), void 0 === i && (i = t.length), 0 === t.length) return null;
              for (var r = t[n], s = r, a = n + 1; a < i; a++) {
                var c = t[a],
                  u = e(c, r);
                u > 0 ? s = c : u < 0 && (r = c);
              }
              return new o.MinMax(r, s);
            }, t;
          }();
        e.ListUtils = r;
      },
      2899: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AutoLayoutTreeHorizontalRightToLeftCommand = void 0;
        var r = n(9212),
          s = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), e.prototype.createLayoutSettings = function () {
              var e = t.prototype.createLayoutSettings.call(this);
              return e.direction = r.LogicalDirectionKind.Backward, e;
            }, e;
          }(n(7283).AutoLayoutTreeHorizontalCommand);
        e.AutoLayoutTreeHorizontalRightToLeftCommand = s;
      },
      2993: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.DeleteCommand = void 0;
        var r = n(1922),
          s = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), e.prototype.isEnabled = function () {
              var e = this.control.selection.getSelectedItems();
              return t.prototype.isEnabled.call(this) && e.length && (e.length > 1 || this.permissionsProvider.canDeleteItems(e));
            }, e.prototype.executeCore = function (t) {
              var e = this.control.selection.getSelectedItems(!0, !0);
              return this.permissionsProvider.beginDeleteItems(e), r.ModelUtils.deleteSelection(this.control.history, this.control.model, this.control.selection), this.permissionsProvider.endDeleteItems(), !0;
            }, Object.defineProperty(e.prototype, "isPermissionsRequired", {
              get: function () {
                return !0;
              },
              enumerable: !1,
              configurable: !0
            }), e;
          }(n(3913).SimpleCommandBase);
        e.DeleteCommand = s;
      },
      3039: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.PasteSelectionInPositionCommand = void 0;
        var r = n(5451),
          s = n(8408),
          a = n(6320),
          c = n(5327),
          u = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), e.prototype.getEventPositionOffset = function (t, e) {
              if (!e) return c.Point.zero();
              var n = t.reduce(function (t, e) {
                  return {
                    x: Math.min(t.x, e instanceof s.Shape ? e.position.x : e instanceof a.Connector ? e.getMinX() : Number.MAX_VALUE),
                    y: Math.min(t.y, e instanceof s.Shape ? e.position.y : e instanceof a.Connector ? e.getMinY() : Number.MAX_VALUE)
                  };
                }, {
                  x: Number.MAX_VALUE,
                  y: Number.MAX_VALUE
                }),
                o = this.control.render.getModelPointByEventPoint(e.x, e.y);
              return new c.Point(o.x - n.x, o.y - n.y);
            }, e;
          }(r.PasteSelectionCommandBase);
        e.PasteSelectionInPositionCommand = u;
      },
      3054: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.BindDocumentCommand = void 0;
        var r = n(2175),
          s = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), e.prototype.isEnabledInReadOnlyMode = function () {
              return !0;
            }, e.prototype.executeCore = function (t, e) {
              if (!e || !Array.isArray(e.nodeDataSource)) throw Error("Format exception");
              return this.performImportData(e), this.control.updateLayout(!0), !0;
            }, e.prototype.performImportData = function (t) {
              var e = this.control.createDocumentDataSource(t.nodeDataSource, t.edgeDataSource, t.dataParameters, t.nodeDataImporter, t.edgeDataImporter);
              this.control.beginUpdateCanvas(), this.permissionsProvider.lockPermissions();
              var n = new r.DataLayoutParameters(this.control.settings, t.layoutParameters);
              e.createModelItems(this.control.history, this.control.model, this.control.shapeDescriptionManager, this.control.selection, n, this.control.settings.snapToGrid, this.control.settings.gridSize, this.control.measurer), this.permissionsProvider.unlockPermissions(), this.control.endUpdateCanvas();
            }, e;
          }(n(3913).SimpleCommandBase);
        e.BindDocumentCommand = s;
      },
      3099: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Selection = void 0;
        var o = n(41),
          i = n(1530),
          r = n(8408),
          s = n(6320),
          a = n(2620),
          c = function () {
            function t(t) {
              this.onChanged = new o.EventDispatcher(), this.inputPosition = new i.InputPosition(this), this.onChanged.add(this.inputPosition), this.initialize(t);
            }
            return t.prototype.initialize = function (t) {
              this.model = t, this.keys = [], this.inputPosition.initialize();
            }, t.prototype.add = function (t) {
              this.keys.indexOf(t) < 0 && (this.keys.push(t), this.raiseSelectionChanged());
            }, t.prototype.remove = function (t) {
              this.keys.indexOf(t) >= 0 && (this.keys.splice(this.keys.indexOf(t), 1), this.raiseSelectionChanged());
            }, t.prototype.clear = function () {
              this.keys.length > 0 && (this.keys = [], this.raiseSelectionChanged());
            }, t.prototype.set = function (t, e) {
              !e && a.Data.ArrayEqual(t, this.keys) || (this.keys = t, this.raiseSelectionChanged());
            }, t.prototype.getKeys = function () {
              return this.keys;
            }, t.prototype.getKey = function (t) {
              return this.keys[t];
            }, t.prototype.getSelectedItemsInsideContainers = function (t) {
              var e = this,
                n = t.slice();
              return t.forEach(function (t) {
                t instanceof r.Shape && e.getSelectedItemsInsideContainers(e.model.getChildren(t)).forEach(function (t) {
                  -1 !== n.indexOf(t) || e.hasKey(t.key) || n.push(t);
                });
              }), n;
            }, t.prototype.getSelectedItemsCore = function (t) {
              var e = this;
              return this.keys.map(function (t) {
                return e.model.findItem(t);
              }).filter(function (e) {
                return e && (t || !e.isLocked);
              });
            }, t.prototype.getSelectedItems = function (t, e) {
              return e ? this.getSelectedItemsInsideContainers(this.getSelectedItemsCore(t)) : this.getSelectedItemsCore(t);
            }, t.prototype.getSelectedShapes = function (t, e) {
              var n = this;
              if (e) {
                var o = this.getSelectedItemsCore(t);
                return this.getSelectedItemsInsideContainers(o).map(function (t) {
                  return t instanceof r.Shape ? t : void 0;
                }).filter(function (t) {
                  return t;
                });
              }
              return this.keys.map(function (t) {
                return n.model.findShape(t);
              }).filter(function (e) {
                return e && (t || !e.isLocked);
              });
            }, t.prototype.getSelectedConnectors = function (t, e) {
              var n = this;
              if (e) {
                var o = this.keys.map(function (t) {
                  return n.model.findItem(t);
                });
                return this.getSelectedItemsInsideContainers(o).map(function (t) {
                  return t instanceof s.Connector ? t : void 0;
                }).filter(function (e) {
                  return e && (t || !e.isLocked);
                });
              }
              return this.keys.map(function (t) {
                return n.model.findConnector(t);
              }).filter(function (e) {
                return e && (t || !e.isLocked);
              });
            }, t.prototype.hasKey = function (t) {
              return this.keys.indexOf(t) >= 0;
            }, t.prototype.isEmpty = function (t) {
              return !this.getSelectedItems(t).length;
            }, t.prototype.selectRect = function (t) {
              var e = [];
              this.model.iterateItems(function (n) {
                n.intersectedByRect(t) && e.push(n.key);
              }), this.set(e);
            }, t.prototype.raiseSelectionChanged = function () {
              this.onChanged.raise("notifySelectionChanged", this);
            }, t;
          }();
        e.Selection = c;
      },
      3105: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ConnectorPointsCalculator = void 0;
        var r = n(1532),
          s = n(9956),
          a = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), e.prototype.getPoints = function () {
              return this.connector.points.map(function (t, e) {
                return new s.ConnectorRenderPoint(t.x, t.y, e);
              });
            }, e;
          }(r.ConnectorPointsCalculatorBase);
        e.ConnectorPointsCalculator = a;
      },
      3158: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ChangePageColorHistoryItem = void 0;
        var r = function (t) {
          function e(e) {
            var n = t.call(this) || this;
            return n.value = e, n;
          }
          return i(e, t), e.prototype.redo = function (t) {
            this.oldValue = t.model.pageColor, t.changePageColor(this.value);
          }, e.prototype.undo = function (t) {
            t.changePageColor(this.oldValue);
          }, e;
        }(n(2616).HistoryItem);
        e.ChangePageColorHistoryItem = r;
      },
      3165: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.PentagonShapeDescription = void 0;
        var r = n(6208),
          s = n(3255),
          a = n(4717),
          c = n(4824),
          u = n(41),
          p = n(4412),
          h = function (t) {
            function e(e) {
              var n = t.call(this, e) || this;
              return n.defaultRatio = n.defaultSize.height / n.defaultSize.width, n;
            }
            return i(e, t), Object.defineProperty(e.prototype, "key", {
              get: function () {
                return s.ShapeTypes.Pentagon;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "angleCount", {
              get: function () {
                return 5;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.createShapePrimitives = function (t) {
              var e = t.rectangle,
                n = e.x,
                o = e.y,
                i = e.right,
                s = e.bottom,
                a = e.width,
                c = e.height,
                u = e.center.x,
                p = c / a / this.defaultRatio,
                h = Math.PI - this.angle,
                l = a / 2 * Math.tan(h / 2) * p,
                d = o + l,
                f = (c - l) / Math.tan(h) / p,
                y = n + f,
                g = i - f;
              return [new r.PathPrimitive([new r.PathPrimitiveMoveToCommand(u, o), new r.PathPrimitiveLineToCommand(i, d), new r.PathPrimitiveLineToCommand(g, s), new r.PathPrimitiveLineToCommand(y, s), new r.PathPrimitiveLineToCommand(n, d), new r.PathPrimitiveClosePathCommand()], t.style)];
            }, e.prototype.processConnectionPoint = function (t, e) {
              var n = t.getConnectionPointSide(e);
              if (n === c.ConnectionPointSide.East || n === c.ConnectionPointSide.West) {
                var o = t.rectangle,
                  i = o.y,
                  r = o.width,
                  s = o.height / r / this.defaultRatio,
                  a = Math.PI - this.angle,
                  u = i + r / 2 * Math.tan(a / 2) * s;
                (n === c.ConnectionPointSide.East || n === c.ConnectionPointSide.West) && (e.y = u);
              }
            }, e.prototype.calculateHeight = function (t) {
              var e = Math.PI - this.angle;
              return t / 2 * Math.tan(e / 2) + t / 2 / Math.cos(e / 2) * Math.sin(e);
            }, e.prototype.getTextRectangle = function (t) {
              var e = u.GeometryUtils.getMaxRectangleEnscribedInEllipse(t.size);
              return p.Rectangle.fromGeometry(t.position.clone().offset((t.size.width - e.width) / 2, (t.size.height - e.height) / 2), e);
            }, e.prototype.getSizeByText = function (t, e) {
              return u.GeometryUtils.getEllipseByEnscribedRectangle(t);
            }, e;
          }(a.PolygonShapeDescription);
        e.PentagonShapeDescription = h;
      },
      3188: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.TextRightAlignCommand = e.TextCenterAlignCommand = e.TextLeftAlignCommand = e.ChangeTextAlignCommand = void 0;
        var r = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(e, t), e.prototype.getStyleProperty = function () {
            return "text-anchor";
          }, e;
        }(n(3210).ToggleStyleTextPropertyCommand);
        e.ChangeTextAlignCommand = r;
        var s = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(e, t), e.prototype.getStylePropertyValue = function () {
            return "start";
          }, e;
        }(r);
        e.TextLeftAlignCommand = s;
        var a = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(e, t), e.prototype.getStylePropertyValue = function () {
            return "middle";
          }, e;
        }(r);
        e.TextCenterAlignCommand = a;
        var c = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(e, t), e.prototype.getStylePropertyValue = function () {
            return "end";
          }, e;
        }(r);
        e.TextRightAlignCommand = c;
      },
      3190: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.RectangleShapeDescription = void 0;
        var r = n(1280),
          s = n(3844),
          a = n(94),
          c = n(3255),
          u = function (t) {
            function e(e, n) {
              return void 0 === e && (e = new s.Size(r.ShapeDefaultDimension, .75 * r.ShapeDefaultDimension)), t.call(this, e, n) || this;
            }
            return i(e, t), Object.defineProperty(e.prototype, "key", {
              get: function () {
                return c.ShapeTypes.Rectangle;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "keepRatioOnAutoSize", {
              get: function () {
                return !1;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.createShapePrimitives = function (t) {
              var e = t.rectangle,
                n = e.x,
                o = e.y,
                i = e.width,
                r = e.height;
              return [new a.RectanglePrimitive(n, o, i, r, t.style)];
            }, e.prototype.getTextRectangle = function (t) {
              return t.rectangle.clone().inflate(-r.ShapeTextPadding, -r.ShapeTextPadding);
            }, e.prototype.getSizeByText = function (t, e) {
              return t.clone().offset(2 * r.ShapeTextPadding, 2 * r.ShapeTextPadding);
            }, e;
          }(r.ShapeDescription);
        e.RectangleShapeDescription = u;
      },
      3196: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ExtendedMinMax = e.ExtendedMax = e.ExtendedMin = e.MinMaxNumber = e.MinMax = void 0;
        var o = n(5215),
          i = function (t, e) {
            this.minElement = t, this.maxElement = e;
          };
        e.MinMax = i;
        var r = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o.__extends(e, t), Object.defineProperty(e.prototype, "length", {
            get: function () {
              return this.maxElement - this.minElement;
            },
            enumerable: !1,
            configurable: !0
          }), e;
        }(i);
        e.MinMaxNumber = r;
        var s = function (t, e) {
          this.minElement = t, this.minValue = e;
        };
        e.ExtendedMin = s;
        var a = function (t, e) {
          this.maxElement = t, this.maxValue = e;
        };
        e.ExtendedMax = a;
        var c = function (t) {
          function e(e, n, o, i) {
            var r = t.call(this, e, o) || this;
            return r.minValue = n, r.maxValue = i, r;
          }
          return o.__extends(e, t), e;
        }(i);
        e.ExtendedMinMax = c;
      },
      3210: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ToggleStyleTextPropertyCommand = void 0;
        var r = n(7418),
          s = n(5755),
          a = n(5059),
          c = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), e.prototype.getValue = function () {
              return this.control.selection.inputPosition.getCurrentTextStylePropertyValue(this.getStyleProperty()) === this.getStylePropertyValue();
            }, e.prototype.executeCore = function (t) {
              var e = this;
              this.control.history.beginTransaction();
              var n = this.getStyleProperty(),
                o = t.value ? a.TextStyle.defaultInstance[n] : this.getStylePropertyValue();
              return this.control.selection.getSelectedItems().forEach(function (t) {
                e.control.history.addAndRedo(new s.ChangeStyleTextHistoryItem(t.key, n, o));
              }), this.control.selection.inputPosition.setTextStylePropertyValue(this.getStyleProperty(), o), this.control.history.endTransaction(), !0;
            }, e.prototype.getStyleObj = function (t) {
              return t.styleText;
            }, e.prototype.getDefaultStyleObj = function () {
              return new a.TextStyle();
            }, e;
          }(r.StylePropertyCommandBase);
        e.ToggleStyleTextPropertyCommand = c;
      },
      3233: (t, e) => {
        var n, o, i, r;
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MimeTypeUtils = e.DxMimeType = e.ImageWebpMimeType = e.ImageWbmpMimeType = e.ImageIcoMimeType = e.ImageTiffMimeType = e.ImageSvgMimeType = e.ImagePjpegMimeType = e.ImageJpegMimeType = e.ImageGifMimeType = e.ImagePngMimeType = e.DocmMimeType = e.HtmlMimeType = e.PlainTextMimeType = e.RtfMimeType = e.OpenXmlMimeType = void 0, e.OpenXmlMimeType = "application/vnd.openxmlformats-officedocument.wordprocessingml.document", e.RtfMimeType = "application/rtf", e.PlainTextMimeType = "text/plain", e.HtmlMimeType = "text/html", e.DocmMimeType = "application/vnd.ms-word.document.macroEnabled.12", e.ImagePngMimeType = "image/png", e.ImageGifMimeType = "image/gif", e.ImageJpegMimeType = "image/jpeg", e.ImagePjpegMimeType = "image/pjpeg", e.ImageSvgMimeType = "image/svg+xml", e.ImageTiffMimeType = "image/tiff", e.ImageIcoMimeType = "image/vnd.microsoft.icon", e.ImageWbmpMimeType = "image/vnd.wap.wbmp", e.ImageWebpMimeType = "image/webp", function (t) {
          t[t.Unknown = 0] = "Unknown", t[t.OpenXml = 1] = "OpenXml", t[t.Rtf = 2] = "Rtf", t[t.PlainText = 3] = "PlainText", t[t.Docm = 4] = "Docm", t[t.Png = 5] = "Png", t[t.Gif = 6] = "Gif", t[t.Jpeg = 7] = "Jpeg", t[t.Pjpeg = 8] = "Pjpeg", t[t.Svg = 9] = "Svg", t[t.Tiff = 10] = "Tiff", t[t.Ico = 11] = "Ico", t[t.Wbmp = 12] = "Wbmp", t[t.Webp = 13] = "Webp", t[t.Html = 14] = "Html";
        }(r = e.DxMimeType || (e.DxMimeType = {}));
        var s = function () {
          function t() {}
          return t.stringTypeToExtension = function (e) {
            var n = t.stringTypeToTypeMap[e];
            return void 0 === n ? "" : t.typeToExtensionMap[n];
          }, t.typeToExtension = function (e) {
            var n = t.typeToExtensionMap[e];
            return null != n ? n : "";
          }, t.extensionToType = function (e) {
            "." !== (e = e.toLowerCase())[0] && (e += ".");
            var n = t.extensionToTypeMap[e];
            return null != n ? n : r.Unknown;
          }, t.typeToStringType = function (e) {
            var n = t.typeToStringTypeMap[e];
            return null != n ? n : "";
          }, t.stringTypeToType = function (e) {
            var n = t.stringTypeToTypeMap[e];
            return void 0 === n ? r.Unknown : n;
          }, t.stringTypeToTypeMap = ((n = {})[e.OpenXmlMimeType] = r.OpenXml, n[e.RtfMimeType] = r.Rtf, n[e.PlainTextMimeType] = r.PlainText, n[e.DocmMimeType] = r.Docm, n[e.HtmlMimeType] = r.Html, n[e.ImagePngMimeType] = r.Png, n[e.ImageGifMimeType] = r.Gif, n[e.ImageJpegMimeType] = r.Jpeg, n[e.ImagePjpegMimeType] = r.Pjpeg, n[e.ImageSvgMimeType] = r.Svg, n[e.ImageTiffMimeType] = r.Tiff, n[e.ImageIcoMimeType] = r.Ico, n[e.ImageWbmpMimeType] = r.Wbmp, n[e.ImageWebpMimeType] = r.Webp, n), t.typeToStringTypeMap = ((o = {})[r.Unknown] = void 0, o[r.OpenXml] = e.OpenXmlMimeType, o[r.Rtf] = e.RtfMimeType, o[r.PlainText] = e.PlainTextMimeType, o[r.Docm] = e.DocmMimeType, o[r.Html] = e.HtmlMimeType, o[r.Png] = e.ImagePngMimeType, o[r.Gif] = e.ImageGifMimeType, o[r.Jpeg] = e.ImageJpegMimeType, o[r.Pjpeg] = e.ImagePjpegMimeType, o[r.Svg] = e.ImageSvgMimeType, o[r.Tiff] = e.ImageTiffMimeType, o[r.Ico] = e.ImageIcoMimeType, o[r.Wbmp] = e.ImageWbmpMimeType, o[r.Webp] = e.ImageWebpMimeType, o), t.typeToExtensionMap = ((i = {})[r.Unknown] = void 0, i[r.OpenXml] = ".docx", i[r.Rtf] = ".rtf", i[r.PlainText] = ".txt", i[r.Docm] = ".docm", i[r.Html] = ".html", i[r.Png] = ".png", i[r.Gif] = ".gif", i[r.Jpeg] = ".jpeg", i[r.Pjpeg] = ".pjpeg", i[r.Svg] = ".svg", i[r.Tiff] = ".tiff", i[r.Ico] = ".ico", i[r.Wbmp] = ".wbmp", i[r.Webp] = ".webp", i), t.extensionToTypeMap = {
            ".docx": r.OpenXml,
            ".rtf": r.Rtf,
            ".txt": r.PlainText,
            ".docm": r.Docm,
            ".html": r.Html,
            ".htm": r.Html,
            ".png": r.Png,
            ".gif": r.Gif,
            ".jpeg": r.Jpeg,
            ".pjpeg": r.Pjpeg,
            ".svg": r.Svg,
            ".tiff": r.Tiff,
            ".ico": r.Ico,
            ".wbmp": r.Wbmp,
            ".webp": r.Webp
          }, t;
        }();
        e.MimeTypeUtils = s;
      },
      3255: (t, e) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ShapeType = e.ShapeTypes = e.ShapeCategories = void 0;
        var n = function () {
          function t() {}
          return t.General = "general", t.Flowchart = "flowchart", t.OrgChart = "orgChart", t.Containers = "containers", t.Custom = "custom", t;
        }();
        e.ShapeCategories = n;
        var o = function () {
          function t() {}
          return t.Text = "text", t.Rectangle = "rectangle", t.Ellipse = "ellipse", t.Cross = "cross", t.Triangle = "triangle", t.Diamond = "diamond", t.Heart = "heart", t.Pentagon = "pentagon", t.Hexagon = "hexagon", t.Octagon = "octagon", t.Star = "star", t.ArrowLeft = "arrowLeft", t.ArrowUp = "arrowTop", t.ArrowRight = "arrowRight", t.ArrowDown = "arrowBottom", t.ArrowUpDown = "arrowNorthSouth", t.ArrowLeftRight = "arrowEastWest", t.Process = "process", t.Decision = "decision", t.Terminator = "terminator", t.PredefinedProcess = "predefinedProcess", t.Document = "document", t.MultipleDocuments = "multipleDocuments", t.ManualInput = "manualInput", t.Preparation = "preparation", t.Data = "data", t.Database = "database", t.HardDisk = "hardDisk", t.InternalStorage = "internalStorage", t.PaperTape = "paperTape", t.ManualOperation = "manualOperation", t.Delay = "delay", t.StoredData = "storedData", t.Display = "display", t.Merge = "merge", t.Connector = "connector", t.Or = "or", t.SummingJunction = "summingJunction", t.Container = "container", t.VerticalContainer = "verticalContainer", t.HorizontalContainer = "horizontalContainer", t.Card = "card", t.CardWithImageOnLeft = "cardWithImageOnLeft", t.CardWithImageOnTop = "cardWithImageOnTop", t.CardWithImageOnRight = "cardWithImageOnRight", t;
        }();
        e.ShapeTypes = o, function (t) {
          t[t.text = 0] = "text", t[t.rectangle = 1] = "rectangle", t[t.ellipse = 2] = "ellipse", t[t.cross = 3] = "cross", t[t.triangle = 4] = "triangle", t[t.diamond = 5] = "diamond", t[t.heart = 6] = "heart", t[t.pentagon = 7] = "pentagon", t[t.hexagon = 8] = "hexagon", t[t.octagon = 9] = "octagon", t[t.star = 10] = "star", t[t.arrowLeft = 11] = "arrowLeft", t[t.arrowTop = 12] = "arrowTop", t[t.arrowRight = 13] = "arrowRight", t[t.arrowBottom = 14] = "arrowBottom", t[t.arrowNorthSouth = 15] = "arrowNorthSouth", t[t.arrowEastWest = 16] = "arrowEastWest", t[t.process = 17] = "process", t[t.decision = 18] = "decision", t[t.terminator = 19] = "terminator", t[t.predefinedProcess = 20] = "predefinedProcess", t[t.document = 21] = "document", t[t.multipleDocuments = 22] = "multipleDocuments", t[t.manualInput = 23] = "manualInput", t[t.preparation = 24] = "preparation", t[t.data = 25] = "data", t[t.database = 26] = "database", t[t.hardDisk = 27] = "hardDisk", t[t.internalStorage = 28] = "internalStorage", t[t.paperTape = 29] = "paperTape", t[t.manualOperation = 30] = "manualOperation", t[t.delay = 31] = "delay", t[t.storedData = 32] = "storedData", t[t.display = 33] = "display", t[t.merge = 34] = "merge", t[t.connector = 35] = "connector", t[t.or = 36] = "or", t[t.summingJunction = 37] = "summingJunction", t[t.verticalContainer = 38] = "verticalContainer", t[t.horizontalContainer = 39] = "horizontalContainer", t[t.cardWithImageOnLeft = 40] = "cardWithImageOnLeft", t[t.cardWithImageOnTop = 41] = "cardWithImageOnTop", t[t.cardWithImageOnRight = 42] = "cardWithImageOnRight";
        }(e.ShapeType || (e.ShapeType = {}));
      },
      3262: (t, e) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Equals = e.Comparers = void 0;
        var n = function () {
          function t() {}
          return t.number = function (t, e) {
            return t - e;
          }, t.string = function (t, e) {
            return t === e ? 0 : t > e ? 1 : -1;
          }, t.stringIgnoreCase = function (t, e) {
            return (t = t.toLowerCase()) === (e = e.toLowerCase()) ? 0 : t > e ? 1 : -1;
          }, t;
        }();
        e.Comparers = n;
        var o = function () {
          function t() {}
          return t.simpleType = function (t, e) {
            return t === e;
          }, t.object = function (t, e) {
            return t && e && (t === e || t.equals(e));
          }, t;
        }();
        e.Equals = o;
      },
      3283: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CanvasPageManager = void 0;
        var r = n(5059),
          s = n(94),
          a = n(6208),
          c = n(7301),
          u = n(5654),
          p = n(5707),
          h = n(3844),
          l = n(5327),
          d = n(2136),
          f = n(9553),
          y = n(9500),
          g = function (t) {
            function e(e, n, o, i) {
              var r = t.call(this, n.zoomLevel, o, i) || this;
              return r.snapPoint = new l.Point(0, 0), r.gridPatternId = d.RenderUtils.generateSvgElementId("gridPattern"), r.pagesGridPatternId = d.RenderUtils.generateSvgElementId("pagesGridPattern"), r.pagesGridClipId = d.RenderUtils.generateSvgElementId("pagesGridClip"), r.pageColor = n.pageColor, r.modelSize = n.modelSize, r.simpleView = n.simpleView, r.gridSize = n.gridSize, r.gridVisible = n.gridVisible, r.pageSize = n.pageLandscape ? new h.Size(n.pageSize.height, n.pageSize.width) : n.pageSize, r.canvasViewOffset = new l.Point(0, 0), r.initContainers(e), r;
            }
            return i(e, t), e.prototype.initContainers = function (t) {
              this.backgroundContainer = t;
            }, e.prototype.redraw = function () {
              this.redrawPage(this.pageColor), this.redrawGrid();
            }, e.prototype.redrawPage = function (t) {
              var e = new r.Style();
              e.fill = f.ColorUtils.colorToHash(t), this.getOrCreateElement("page-bg", new s.RectanglePrimitive(0, 0, "100%", "100%", e, "page"), this.backgroundContainer), this.createTextFloodFilter(this.instanceId, "page-bg-textflood-filter", this.backgroundContainer, t);
            }, e.prototype.redrawGrid = function () {
              this.updateGridElements(), this.updatePagesGridElements();
            }, e.prototype.getGridRectElement = function (t) {
              return void 0 === this.gridRectElement && (this.gridRectElement = this.createPrimitiveElement(t, this.backgroundContainer)), this.gridRectElement;
            }, e.prototype.getGridPatternElement = function (t) {
              return void 0 === this.gridPatternElement && (this.gridPatternElement = this.createPrimitiveElement(t, this.backgroundContainer)), this.gridPatternElement;
            }, e.prototype.updateGridElements = function () {
              var t = this,
                e = new s.RectanglePrimitive("0", "0", "100%", "100%", null, "grid", null, function (e) {
                  e.style.setProperty("fill", d.RenderUtils.getUrlPathById(t.gridPatternId));
                }),
                n = this.getGridRectElement(e);
              if (this.gridVisible) {
                n.style.display = "", this.changePrimitiveElement(e, n);
                for (var o = y.UnitConverter.twipsToPixelsF(this.gridSize) * this.actualZoom, i = [0, 1, 2, 3, 4].map(function (t) {
                    return Math.round(o * t);
                  }), r = [new a.PathPrimitiveMoveToCommand(i[4].toString(), "0"), new a.PathPrimitiveLineToCommand(i[4].toString(), i[4].toString()), new a.PathPrimitiveLineToCommand("0", i[4].toString())], u = [], p = 1; p <= 3; p++) u.push(new a.PathPrimitiveMoveToCommand(i[p].toString(), "0")), u.push(new a.PathPrimitiveLineToCommand(i[p].toString(), i[4].toString()));
                for (p = 1; p <= 3; p++) u.push(new a.PathPrimitiveMoveToCommand("0", i[p].toString())), u.push(new a.PathPrimitiveLineToCommand(i[4].toString(), i[p].toString()));
                var h = 4 * o,
                  f = this.simpleView ? this.canvasViewOffset : l.Point.zero(),
                  g = new c.PatternPrimitive(this.gridPatternId, [this.createGridPathPrimitive(r, "grid-outer-line"), this.createGridPathPrimitive(u, "grid-inner-line")], this.createGridPatternPrimitivePosition(f.x, this.snapPoint.x, h), this.createGridPatternPrimitivePosition(f.y, this.snapPoint.y, h), h.toString(), h.toString());
                this.changePrimitiveElement(g, this.getGridPatternElement(g));
              } else n.style.display = "none";
            }, e.prototype.createGridPatternPrimitivePosition = function (t, e, n) {
              return (((t + e * this.actualZoom) % n - n) % n).toString();
            }, e.prototype.createGridPathPrimitive = function (t, e) {
              return new a.PathPrimitive(t, r.StrokeStyle.default1pxNegativeOffsetInstance, e);
            }, e.prototype.getPagesGridRectElement = function (t) {
              return this.getOrCreateElement("grid-pages-rect", t, this.backgroundContainer);
            }, e.prototype.getPagesGridClipPathElement = function (t) {
              return void 0 === this.pagesGridClipPathElement && (this.pagesGridClipPathElement = this.createPrimitiveElement(t, this.backgroundContainer)), this.pagesGridClipPathElement;
            }, e.prototype.getPagesGridPatternElement = function (t) {
              return void 0 === this.pagesGridPatternElement && (this.pagesGridPatternElement = this.createPrimitiveElement(t, this.backgroundContainer)), this.pagesGridPatternElement;
            }, e.prototype.updatePagesGridElements = function () {
              var t = this,
                e = this.getAbsoluteSize(this.pageSize),
                n = new s.RectanglePrimitive("0", "0", "100%", "100%", null, "grid-page", this.pagesGridClipId, function (e) {
                  e.style.setProperty("fill", d.RenderUtils.getUrlPathById(t.pagesGridPatternId)), e.style.setProperty("display", t.simpleView ? "none" : "");
                });
              if (this.getPagesGridRectElement(n), !this.simpleView) {
                var o = this.modelSize.clone().multiply(this.actualZoom, this.actualZoom),
                  i = [new a.PathPrimitiveMoveToCommand((e.width - 1).toString(), "0"), new a.PathPrimitiveLineToCommand((e.width - 1).toString(), (e.height - 1).toString()), new a.PathPrimitiveLineToCommand("0", (e.height - 1).toString())],
                  r = new c.PatternPrimitive(this.pagesGridPatternId, [new a.PathPrimitive(i, null, "pages-grid-line")], 0, 0, e.width.toString(), e.height.toString());
                this.changePrimitiveElement(r, this.getPagesGridPatternElement(r));
                var p = new u.ClipPathPrimitive(this.pagesGridClipId, [new s.RectanglePrimitive(0, 0, (y.UnitConverter.twipsToPixelsF(o.width) - 4).toString(), (y.UnitConverter.twipsToPixelsF(o.height) - 4).toString())]);
                this.changePrimitiveElement(p, this.getPagesGridClipPathElement(p));
              }
            }, e.prototype.notifyModelSizeChanged = function (t, e) {
              this.modelSize = t.clone(), this.redraw();
            }, e.prototype.notifyModelRectangleChanged = function (t) {}, e.prototype.notifySnapPointPositionChanged = function (t) {
              this.snapPoint = t.clone().applyConverter(y.UnitConverter.twipsToPixelsF), this.redrawGrid();
            }, e.prototype.notifyPageColorChanged = function (t) {
              this.pageColor = t, this.redrawPage(this.pageColor);
            }, e.prototype.notifyModelChanged = function (t) {}, e.prototype.notifyPageSizeChanged = function (t, e) {
              this.pageSize = e ? new h.Size(t.height, t.width) : t.clone(), this.redraw();
            }, e.prototype.notifyActualZoomChanged = function (t) {
              this.actualZoom = t, this.redraw();
            }, e.prototype.notifyViewAdjusted = function (t) {
              this.canvasViewOffset.equals(t) || (this.canvasViewOffset = t, this.simpleView && this.redraw());
            }, e.prototype.notifyViewChanged = function (t) {
              this.simpleView = t, this.redraw();
            }, e.prototype.notifyGridChanged = function (t, e) {
              this.gridVisible = t, this.gridSize = e, this.redraw();
            }, e;
          }(p.CanvasManagerBase);
        e.CanvasPageManager = g;
      },
      3312: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MoveShapeHistoryItem = void 0;
        var r = function (t) {
          function e(e, n) {
            var o = t.call(this) || this;
            return o.shapeKey = e, o.position = n, o;
          }
          return i(e, t), e.prototype.redo = function (t) {
            var e = t.model.findShape(this.shapeKey);
            this.oldPosition = e.position.clone(), t.moveShape(e, this.position);
          }, e.prototype.undo = function (t) {
            var e = t.model.findShape(this.shapeKey);
            t.moveShape(e, this.oldPosition);
          }, e;
        }(n(2616).HistoryItem);
        e.MoveShapeHistoryItem = r;
      },
      3377: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.VisualizerTouchManager = void 0;
        var r = n(9860),
          s = n(5428),
          a = function (t) {
            function e(e, n, o, i, r) {
              void 0 === r && (r = i.readOnly);
              var s = t.call(this, e, n, o, i, r) || this;
              return e.onChanged.add(s), s;
            }
            return i(e, t), e.prototype.onBlur = function (t) {
              var e = this;
              setTimeout(function () {
                e.hideConnections();
              }, 1);
            }, e.prototype.onFocus = function (t) {
              var e = this;
              setTimeout(function () {
                e.showConnections();
              }, 1);
            }, e.prototype.hideConnections = function () {
              this.readOnly || this.resetConnectionPoints();
            }, e.prototype.showConnections = function () {
              if (!this.readOnly && this.needShowConnections()) {
                var t = this.selection.getSelectedShapes();
                1 === t.length && this.setConnectionPoints(t[0], s.MouseEventElementType.ShapeConnectionPoint, -1, !t[0].allowResizeHorizontally && !t[0].allowResizeVertically || t[0].isLocked);
              }
            }, e.prototype.needShowConnections = function () {
              var t = this.selection.getSelectedItems(),
                e = this.selection.getSelectedShapes();
              return 1 === t.length && 1 === e.length;
            }, e.prototype.notifySelectionChanged = function (t) {
              this.isUpdateLocked() ? this.registerOccurredEvent(1) : this.raiseSelectionChanged();
            }, e.prototype.raiseSelectionChanged = function () {
              this.needShowConnections() ? this.showConnections() : this.hideConnections();
            }, e.prototype.onUpdateUnlocked = function (t) {
              1 & t && this.raiseSelectionChanged();
            }, e.prototype.notifyDragStart = function (t) {
              this.hideConnections();
            }, e.prototype.notifyDragEnd = function (t) {
              this.showConnections();
            }, e;
          }(r.VisualizerManager);
        e.VisualizerTouchManager = a;
      },
      3393: (t, e) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Flag = void 0;
        var n = function () {
          function t(t) {
            void 0 === t && (t = 0), this.value = t;
          }
          return t.prototype.get = function (t) {
            return (this.value & t) === t;
          }, t.prototype.set = function (t, e) {
            return (this.value & t) === t !== e && (e ? this.value |= t : this.value ^= t), this;
          }, t.prototype.add = function (t) {
            this.value |= t;
          }, t.prototype.anyOf = function () {
            for (var t = [], e = 0; e < arguments.length; e++) t[e] = arguments[e];
            for (var n = 0, o = t; n < o.length; n++) {
              var i = o[n];
              if ((this.value & i) === i) return !0;
            }
            return !1;
          }, t.prototype.getValue = function () {
            return this.value;
          }, t.prototype.clone = function () {
            return new t(this.value);
          }, t;
        }();
        e.Flag = n;
      },
      3415: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CrossShapeDescription = e.CrossVerticalWidthParameterName = e.CrossHorizontalWidthParameterName = void 0;
        var r = n(1280),
          s = n(5327),
          a = n(4636),
          c = n(9763),
          u = n(6208),
          p = n(3255);
        e.CrossHorizontalWidthParameterName = "chw", e.CrossVerticalWidthParameterName = "cvw";
        var h = function (t) {
          function n() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(n, t), Object.defineProperty(n.prototype, "key", {
            get: function () {
              return p.ShapeTypes.Cross;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(n.prototype, "keepRatioOnAutoSize", {
            get: function () {
              return !0;
            },
            enumerable: !1,
            configurable: !0
          }), n.prototype.createShapePrimitives = function (t) {
            var n = t.rectangle,
              o = n.x,
              i = n.y,
              r = n.right,
              s = n.bottom,
              a = n.width,
              c = n.height,
              p = (a - t.parameters.get(e.CrossHorizontalWidthParameterName).value) / 2,
              h = (c - t.parameters.get(e.CrossVerticalWidthParameterName).value) / 2,
              l = t.normalizeX(o + p),
              d = t.normalizeY(i + h),
              f = t.normalizeX(r - p),
              y = t.normalizeY(s - h);
            return [new u.PathPrimitive([new u.PathPrimitiveMoveToCommand(o, d), new u.PathPrimitiveLineToCommand(l, d), new u.PathPrimitiveLineToCommand(l, i), new u.PathPrimitiveLineToCommand(f, i), new u.PathPrimitiveLineToCommand(f, d), new u.PathPrimitiveLineToCommand(r, d), new u.PathPrimitiveLineToCommand(r, y), new u.PathPrimitiveLineToCommand(f, y), new u.PathPrimitiveLineToCommand(f, s), new u.PathPrimitiveLineToCommand(l, s), new u.PathPrimitiveLineToCommand(l, y), new u.PathPrimitiveLineToCommand(o, y), new u.PathPrimitiveClosePathCommand()], t.style)];
          }, n.prototype.createParameters = function (t) {
            t.addRangeIfNotExists([new a.ShapeParameter(e.CrossHorizontalWidthParameterName, .2 * this.defaultSize.width), new a.ShapeParameter(e.CrossVerticalWidthParameterName, .2 * this.defaultSize.height)]);
          }, n.prototype.normalizeParameters = function (t, n) {
            this.changeParameterValue(n, e.CrossHorizontalWidthParameterName, function (e) {
              return Math.max(0, Math.min(t.size.width, e.value));
            }), this.changeParameterValue(n, e.CrossVerticalWidthParameterName, function (e) {
              return Math.max(0, Math.min(t.size.height, e.value));
            });
          }, n.prototype.modifyParameters = function (t, n, o, i) {
            this.changeParameterValue(n, e.CrossHorizontalWidthParameterName, function (t) {
              return t.value - 2 * o;
            }), this.changeParameterValue(n, e.CrossVerticalWidthParameterName, function (t) {
              return t.value - 2 * i;
            }), this.normalizeParameters(t, n);
          }, n.prototype.getParameterPoints = function (t) {
            return [new c.ShapeParameterPoint("c", new s.Point(t.normalizeX(t.position.x + (t.size.width - t.parameters.get(e.CrossHorizontalWidthParameterName).value) / 2), t.normalizeY(t.position.y + (t.size.height - t.parameters.get(e.CrossVerticalWidthParameterName).value) / 2)))];
          }, n.prototype.getTextRectangle = function (t) {
            return t.rectangle.clone().inflate(-r.ShapeTextPadding, -r.ShapeTextPadding);
          }, n.prototype.getSizeByText = function (t, e) {
            return t.clone().offset(2 * r.ShapeTextPadding, 2 * r.ShapeTextPadding);
          }, n;
        }(r.ShapeDescription);
        e.CrossShapeDescription = h;
      },
      3427: (t, e) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ItemChange = e.ItemChangeType = void 0, function (t) {
          t[t.Create = 0] = "Create", t[t.UpdateProperties = 1] = "UpdateProperties", t[t.UpdateStructure = 2] = "UpdateStructure", t[t.Update = 3] = "Update", t[t.Remove = 4] = "Remove", t[t.UpdateClassName = 5] = "UpdateClassName";
        }(e.ItemChangeType || (e.ItemChangeType = {}));
        var n = function () {
          function t(t, e, n) {
            void 0 === n && (n = !0), this.item = t, this.type = e, this.isValid = n;
          }
          return Object.defineProperty(t.prototype, "key", {
            get: function () {
              return this.item.key;
            },
            enumerable: !1,
            configurable: !0
          }), t;
        }();
        e.ItemChange = n;
      },
      3475: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ArrowLeftRightShapeDescription = void 0;
        var r = n(6208),
          s = n(9090),
          a = n(9763),
          c = n(5327),
          u = n(3255),
          p = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), Object.defineProperty(e.prototype, "key", {
              get: function () {
                return u.ShapeTypes.ArrowLeftRight;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.createShapePrimitives = function (t) {
              var e = t.rectangle,
                n = e.x,
                o = e.y,
                i = e.right,
                a = e.bottom,
                c = e.height,
                u = e.center.y,
                p = t.parameters.get(s.ArrowVerticalTriangleWidthParameterName).value,
                h = (c - t.parameters.get(s.ArrowVerticalLineHeightParameterName).value) / 2,
                l = t.normalizeX(n + p),
                d = t.normalizeY(o + h),
                f = t.normalizeX(i - p),
                y = t.normalizeY(a - h);
              return [new r.PathPrimitive([new r.PathPrimitiveMoveToCommand(n, u), new r.PathPrimitiveLineToCommand(l, o), new r.PathPrimitiveLineToCommand(l, d), new r.PathPrimitiveLineToCommand(f, d), new r.PathPrimitiveLineToCommand(f, o), new r.PathPrimitiveLineToCommand(i, u), new r.PathPrimitiveLineToCommand(f, a), new r.PathPrimitiveLineToCommand(f, y), new r.PathPrimitiveLineToCommand(l, y), new r.PathPrimitiveLineToCommand(l, a), new r.PathPrimitiveClosePathCommand()], t.style)];
            }, e.prototype.normalizeParameters = function (t, e) {
              this.changeParameterValue(e, s.ArrowVerticalTriangleWidthParameterName, function (e) {
                return Math.max(0, Math.min(t.size.width / 2 - 2 * t.strokeWidth, e.value));
              }), this.changeParameterValue(e, s.ArrowVerticalLineHeightParameterName, function (e) {
                return Math.max(0, Math.min(t.size.height, e.value));
              });
            }, e.prototype.modifyParameters = function (t, e, n, o) {
              this.changeParameterValue(e, s.ArrowVerticalTriangleWidthParameterName, function (t) {
                return t.value + n;
              }), this.changeParameterValue(e, s.ArrowVerticalLineHeightParameterName, function (t) {
                return t.value - 2 * o;
              }), this.normalizeParameters(t, e);
            }, e.prototype.getParameterPoints = function (t) {
              return [new a.ShapeParameterPoint("c", new c.Point(t.normalizeX(t.position.x + t.parameters.get(s.ArrowVerticalTriangleWidthParameterName).value), t.normalizeY(t.position.y + (t.size.height - t.parameters.get(s.ArrowVerticalLineHeightParameterName).value) / 2)))];
            }, e;
          }(s.ArrowHorizontalShapeDescription);
        e.ArrowLeftRightShapeDescription = p;
      },
      3489: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.DataShapeDescription = void 0;
        var r = n(3190),
          s = n(3255),
          a = n(6208),
          c = n(4824),
          u = n(1280),
          p = function (t) {
            function e() {
              return t.call(this, void 0, !0) || this;
            }
            return i(e, t), Object.defineProperty(e.prototype, "key", {
              get: function () {
                return s.ShapeTypes.Data;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "keepRatioOnAutoSize", {
              get: function () {
                return !1;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.createShapePrimitives = function (t) {
              var n = t.rectangle,
                o = n.x,
                i = n.y,
                r = n.right,
                s = n.bottom,
                c = n.width,
                u = n.height,
                p = Math.min(Math.max(0, u / Math.tan(e.slopeAngle)), c),
                h = o + p,
                l = r - p;
              return [new a.PathPrimitive([new a.PathPrimitiveMoveToCommand(h, i), new a.PathPrimitiveLineToCommand(r, i), new a.PathPrimitiveLineToCommand(l, s), new a.PathPrimitiveLineToCommand(o, s), new a.PathPrimitiveClosePathCommand()], t.style)];
            }, e.prototype.processConnectionPoint = function (t, n) {
              var o = t.size.height / Math.tan(e.slopeAngle),
                i = t.getConnectionPointSide(n);
              i === c.ConnectionPointSide.East ? n.x -= o / 2 : i === c.ConnectionPointSide.West && (n.x += o / 2);
            }, e.prototype.getTextRectangle = function (t) {
              var n = Math.min(Math.max(0, t.size.height / Math.tan(e.slopeAngle)), t.size.width);
              return t.rectangle.clone().moveRectangle(n, u.ShapeTextPadding).resize(2 * -n, 2 * -u.ShapeTextPadding);
            }, e.slopeAngle = 81 * Math.PI / 180, e;
          }(r.RectangleShapeDescription);
        e.DataShapeDescription = p;
      },
      3490: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.BeforeChangeShapeTextEventArgs = e.BeforeChangeShapeTextRequestedEntity = void 0;
        var r = n(5225),
          s = n(5102),
          a = function (t) {
            function e(e, n) {
              var o = t.call(this, e) || this;
              return o.shape = n, o;
            }
            return i(e, t), Object.defineProperty(e.prototype, "operation", {
              get: function () {
                return r.DiagramModelOperation.BeforeChangeShapeText;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.createEventArgs = function () {
              return new c(this.apiController.createNativeShape(this.shape));
            }, Object.defineProperty(e.prototype, "settingsKey", {
              get: function () {
                return "changeShapeText";
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "storageKey", {
              get: function () {
                return "before" + this.settingsKey + "_" + (this.shape && this.shape.key);
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.equals = function (t) {
              return t instanceof e && this.shape === t.shape && this.shape.text === t.shape.text;
            }, e;
          }(s.RequestedEntity);
        e.BeforeChangeShapeTextRequestedEntity = a;
        var c = function (t) {
          function e(e) {
            var n = t.call(this) || this;
            return n.shape = e, n;
          }
          return i(e, t), e;
        }(s.PermissionRequestEventArgs);
        e.BeforeChangeShapeTextEventArgs = c;
      },
      3505: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.DeleteShapeEventArgs = e.DeleteShapeRequestedEntity = void 0;
        var r = n(5225),
          s = n(5102),
          a = function (t) {
            function e(e, n) {
              var o = t.call(this, e) || this;
              return o.shape = n, o;
            }
            return i(e, t), Object.defineProperty(e.prototype, "operation", {
              get: function () {
                return r.DiagramModelOperation.DeleteShape;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.createEventArgs = function () {
              return new c(this.apiController.createNativeShape(this.shape));
            }, Object.defineProperty(e.prototype, "settingsKey", {
              get: function () {
                return "deleteShape";
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "storageKey", {
              get: function () {
                return this.settingsKey + "_" + (this.shape && this.shape.key);
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.equals = function (t) {
              return t instanceof e && this.shape === t.shape;
            }, e;
          }(s.RequestedEntity);
        e.DeleteShapeRequestedEntity = a;
        var c = function (t) {
          function e(e) {
            var n = t.call(this) || this;
            return n.shape = e, n;
          }
          return i(e, t), e;
        }(s.PermissionRequestEventArgs);
        e.DeleteShapeEventArgs = c;
      },
      3550: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ChangeStyleHistoryItem = void 0;
        var r = function (t) {
          function e(e, n, o) {
            return t.call(this, e, n, o) || this;
          }
          return i(e, t), e.prototype.redo = function (t) {
            var e = t.model.findItem(this.itemKey);
            this.oldStyleValue = e.style[this.styleProperty], t.changeStyle(e, this.styleProperty, this.styleValue);
          }, e.prototype.undo = function (t) {
            var e = t.model.findItem(this.itemKey);
            t.changeStyle(e, this.styleProperty, this.oldStyleValue);
          }, e;
        }(n(8371).ChangeStyleHistoryItemBase);
        e.ChangeStyleHistoryItem = r;
      },
      3577: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.LockCommand = void 0;
        var r = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(e, t), e.prototype.getLockState = function () {
            return !0;
          }, e;
        }(n(9314).ChangeLockedCommand);
        e.LockCommand = r;
      },
      3589: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AutoLayoutLayeredHorizontalRightToLeftCommand = void 0;
        var r = n(9212),
          s = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), e.prototype.createLayoutSettings = function () {
              var e = t.prototype.createLayoutSettings.call(this);
              return e.direction = r.LogicalDirectionKind.Backward, e;
            }, e;
          }(n(4214).AutoLayoutLayeredHorizontalCommand);
        e.AutoLayoutLayeredHorizontalRightToLeftCommand = s;
      },
      3591: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.UnbindDocumentCommand = void 0;
        var r = n(1922),
          s = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), e.prototype.isEnabledInReadOnlyMode = function () {
              return !0;
            }, e.prototype.executeCore = function (t) {
              return this.permissionsProvider.lockPermissions(), this.control.deleteDocumentDataSource(), r.ModelUtils.deleteAllItems(this.control.history, this.control.model, this.control.selection), this.control.history.clear(), this.permissionsProvider.unlockPermissions(), !0;
            }, e;
          }(n(3913).SimpleCommandBase);
        e.UnbindDocumentCommand = s;
      },
      3659: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ViewController = void 0;
        var o = n(5031),
          i = Math.log(.05),
          r = Math.log(3),
          s = p(1),
          a = [o.DiagramCommand.ZoomLevel, o.DiagramCommand.ZoomLevelInPercentage, o.DiagramCommand.Zoom100, o.DiagramCommand.Zoom125, o.DiagramCommand.Zoom200, o.DiagramCommand.Zoom25, o.DiagramCommand.Zoom50, o.DiagramCommand.Zoom75],
          c = [o.DiagramCommand.SwitchAutoZoom, o.DiagramCommand.ToggleAutoZoom, o.DiagramCommand.AutoZoomToContent, o.DiagramCommand.AutoZoomToWidth],
          u = function () {
            function t(t, e) {
              this.settings = t, this.bars = e, t.onZoomChanged.add(this), this.autoZoom = t.autoZoom;
            }
            return t.prototype.initialize = function (t) {
              this.view = t, this.view.onViewChanged.add(this);
            }, t.prototype.scrollTo = function (t, e) {
              this.view && this.view.setScrollTo(t, e);
            }, t.prototype.scrollBy = function (t) {
              return !this.view || 0 === t.x && 0 === t.y ? t : this.view.scrollBy(t);
            }, t.prototype.scrollIntoView = function (t) {
              this.view && this.view.scrollIntoView(t);
            }, t.prototype.normalize = function () {
              this.view.tryNormalizePaddings();
            }, t.prototype.getNextStepZoom = function (t) {
              var e = this.getNearestCurrentZoomStep(),
                n = t ? 1 : -1,
                o = Math.min(39, Math.max(0, e + n));
              if (o !== s) {
                var a = i + (r - i) * o / 39;
                return Math.exp(a);
              }
              return 1;
            }, t.prototype.getNearestCurrentZoomStep = function () {
              return p(this.getZoom());
            }, t.prototype.getZoom = function () {
              return this.view ? this.view.actualZoom : this.settings.zoomLevel;
            }, t.prototype.resetScroll = function () {
              this.view.adjust({
                horizontal: !0,
                vertical: !0
              });
            }, t.prototype.notifyViewAdjusted = function (t) {}, t.prototype.notifyActualZoomChanged = function (t) {
              this.bars.updateItemsState(a);
            }, t.prototype.notifyZoomChanged = function (t, e) {
              this.autoZoom !== e && (this.autoZoom = e, this.bars.updateItemsState(c));
            }, t;
          }();
        function p(t) {
          var e = Math.log(t);
          return Math.round(39 * (e - i) / (r - i));
        }
        e.ViewController = u;
      },
      3763: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.RoundedRectanglePrimitive = void 0;
        var r = n(8509),
          s = function (t) {
            function e(e, n, o, i, r, s, a, c, u, p) {
              void 0 === r && (r = 0), void 0 === s && (s = 0);
              var h = t.call(this, e, n, o, i, a, c, u, p) || this;
              return h.x = e, h.y = n, h.width = o, h.height = i, h.rx = r, h.ry = s, h;
            }
            return i(e, t), e.prototype.createMainElement = function () {
              return document.createElementNS(r.svgNS, "rect");
            }, e.prototype.applyElementProperties = function (e, n) {
              this.setUnitAttribute(e, "rx", this.rx), this.setUnitAttribute(e, "ry", this.ry), t.prototype.applyElementProperties.call(this, e, n);
            }, e;
          }(n(94).RectanglePrimitive);
        e.RoundedRectanglePrimitive = s;
      },
      3788: (t, e) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ExtensionLinesVisualizer = e.ExtensionLine = e.ExtensionLineType = void 0, function (t) {
          t[t.LeftToLeftAbove = 0] = "LeftToLeftAbove", t[t.LeftToLeftBelow = 1] = "LeftToLeftBelow", t[t.RightToRightAbove = 2] = "RightToRightAbove", t[t.RightToRightBelow = 3] = "RightToRightBelow", t[t.LeftToRightAbove = 4] = "LeftToRightAbove", t[t.LeftToRightBelow = 5] = "LeftToRightBelow", t[t.RightToLeftAbove = 6] = "RightToLeftAbove", t[t.RightToLeftBelow = 7] = "RightToLeftBelow", t[t.TopToTopBefore = 8] = "TopToTopBefore", t[t.TopToTopAfter = 9] = "TopToTopAfter", t[t.BottomToBottomBefore = 10] = "BottomToBottomBefore", t[t.BottomToBottomAfter = 11] = "BottomToBottomAfter", t[t.TopToBottomBefore = 12] = "TopToBottomBefore", t[t.TopToBottomAfter = 13] = "TopToBottomAfter", t[t.BottomToTopBefore = 14] = "BottomToTopBefore", t[t.BottomToTopAfter = 15] = "BottomToTopAfter", t[t.HorizontalCenterAbove = 16] = "HorizontalCenterAbove", t[t.HorizontalCenterBelow = 17] = "HorizontalCenterBelow", t[t.VerticalCenterBefore = 18] = "VerticalCenterBefore", t[t.VerticalCenterAfter = 19] = "VerticalCenterAfter", t[t.VerticalCenterToPageCenter = 20] = "VerticalCenterToPageCenter", t[t.HorizontalCenterToPageCenter = 21] = "HorizontalCenterToPageCenter", t[t.LeftToPageCenter = 22] = "LeftToPageCenter", t[t.RightToPageCenter = 23] = "RightToPageCenter", t[t.TopToPageCenter = 24] = "TopToPageCenter", t[t.BottomToPageCenter = 25] = "BottomToPageCenter";
        }(e.ExtensionLineType || (e.ExtensionLineType = {}));
        var n = function (t, e, n) {
          this.type = t, this.segment = e, this.text = n;
        };
        e.ExtensionLine = n;
        var o = function () {
          function t(t) {
            this.dispatcher = t, this.lines = [], this.lineIndexByType = {};
          }
          return t.prototype.addSegment = function (t, e, o) {
            var i = this.lineIndexByType[t];
            if (void 0 === i) {
              var r = new n(t, e, o),
                s = this.lines.push(r);
              this.lineIndexByType[r.type] = s - 1, this.raiseShow();
            } else if (e.length < this.lines[i].segment.length) {
              r = new n(t, e, o);
              this.lines.splice(i, 1, r), this.raiseShow();
            }
          }, t.prototype.update = function () {
            this.raiseShow();
          }, t.prototype.reset = function () {
            this.lines.length && (this.lines = [], this.lineIndexByType = {}, this.raiseHide());
          }, t.prototype.raiseShow = function () {
            var t = this;
            this.dispatcher.raise1(function (e) {
              return e.notifyExtensionLinesShow(t.lines);
            });
          }, t.prototype.raiseHide = function () {
            this.dispatcher.raise1(function (t) {
              return t.notifyExtensionLinesHide();
            });
          }, t;
        }();
        e.ExtensionLinesVisualizer = o;
      },
      3831: function (t, e) {
        var n,
          o = this && this.__extends || (n = function (t, e) {
            return n = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, n(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function o() {
              this.constructor = t;
            }
            n(t, e), t.prototype = null === e ? Object.create(e) : (o.prototype = e.prototype, new o());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.DataSourceEdgeDataImporter = e.DataSourceNodeDataImporter = e.DataSourceItemDataImporter = void 0;
        var i = function () {
          this.getKey = function (t) {
            return t.id;
          }, this.setKey = function (t, e) {
            t.id = e;
          }, this.getCustomData = void 0, this.setCustomData = void 0, this.getLocked = void 0, this.setLocked = void 0, this.getStyle = void 0, this.setStyle = void 0, this.getStyleText = void 0, this.setStyleText = void 0, this.getZIndex = void 0, this.setZIndex = void 0;
        };
        e.DataSourceItemDataImporter = i;
        var r = function (t) {
          function e() {
            var e = null !== t && t.apply(this, arguments) || this;
            return e.getType = void 0, e.setType = void 0, e.getText = void 0, e.setText = void 0, e.getImage = void 0, e.setImage = void 0, e.getLeft = void 0, e.setLeft = void 0, e.getTop = void 0, e.setTop = void 0, e.getWidth = void 0, e.setWidth = void 0, e.getHeight = void 0, e.setHeight = void 0, e.getChildren = void 0, e.setChildren = void 0, e.getParentKey = void 0, e.setParentKey = void 0, e.getItems = void 0, e.setItems = void 0, e.getContainerKey = void 0, e.setContainerKey = void 0, e;
          }
          return o(e, t), e;
        }(i);
        e.DataSourceNodeDataImporter = r;
        var s = function (t) {
          function e() {
            var e = null !== t && t.apply(this, arguments) || this;
            return e.getFrom = function (t) {
              return t.from;
            }, e.setFrom = function (t, e) {
              t.from = e;
            }, e.getFromPointIndex = void 0, e.setFromPointIndex = void 0, e.getTo = function (t) {
              return t.to;
            }, e.setTo = function (t, e) {
              t.to = e;
            }, e.getToPointIndex = void 0, e.setToPointIndex = void 0, e.getPoints = void 0, e.setPoints = void 0, e.getText = void 0, e.setText = void 0, e.getLineOption = void 0, e.setLineOption = void 0, e.getStartLineEnding = void 0, e.setStartLineEnding = void 0, e.getEndLineEnding = void 0, e.setEndLineEnding = void 0, e;
          }
          return o(e, t), e;
        }(i);
        e.DataSourceEdgeDataImporter = s;
      },
      3844: (t, e) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Size = void 0;
        var n = function () {
          function t(t, e) {
            this.width = t, this.height = e;
          }
          return t.empty = function () {
            return new t(0, 0);
          }, t.fromNumber = function (e) {
            return new t(e, e);
          }, t.initByCommonAction = function (e) {
            var n = function (t) {
                return t.width;
              },
              o = function (t) {
                return t.height;
              };
            return new t(e(n, o), e(o, n));
          }, t.prototype.isEmpty = function () {
            return 0 === this.width && 0 === this.height;
          }, t.prototype.toString = function () {
            return JSON.stringify(this);
          }, t.prototype.nonNegativeSize = function () {
            return this.width < 0 && (this.width = 0), this.height < 0 && (this.height = 0), this;
          }, t.prototype.offset = function (t, e) {
            return this.width = this.width + t, this.height = this.height + e, this;
          }, t.prototype.multiply = function (t, e) {
            return this.width *= t, this.height *= e, this;
          }, t.prototype.equals = function (t) {
            return this.width === t.width && this.height === t.height;
          }, t.prototype.clone = function () {
            return new t(this.width, this.height);
          }, t.prototype.copyFrom = function (t) {
            this.width = t.width, this.height = t.height;
          }, t.prototype.applyConverter = function (t) {
            return this.width = t(this.width), this.height = t(this.height), this;
          }, t.equals = function (t, e) {
            return t.width === e.width && t.height === e.height;
          }, t;
        }();
        e.Size = n;
      },
      3858: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.RTree = void 0;
        var r = n(4412),
          s = function () {
            function t(t) {
              void 0 === t && (t = 6), this.maxWidth = t, this.minWidth = Math.floor(t / 2), this.root = new u(new r.Rectangle(0, 0, 0, 0), []);
            }
            return t.prototype.search = function (t) {
              var e = [];
              if (!this.root.rect.containsPoint(t)) return e;
              var n = [];
              for (n.push(this.root.nodes); n.length;) for (var o = n.pop(), i = o.length - 1, r = void 0; r = o[i]; i--) r.rect.containsPoint(t) && (p(r) ? n.push(r.nodes) : e.push(r.obj));
              return e;
            }, t.prototype.insert = function (t, e) {
              var n = new c(t.clone(), e);
              if (!this.root.nodes.length) return this.root.rect = t.clone(), void this.root.nodes.push(n);
              for (var o, i, r = this.chooseLeafSubtree(n), s = n; r.length;) {
                if (o && p(o) && !o.nodes.length) {
                  i = o, o = r.pop();
                  for (var u = 0, h = void 0; h = o.nodes[u]; u++) if (p(h) && (h === i || !h.nodes.length)) {
                    h.nodes.splice(u, 1);
                    break;
                  }
                } else o = r.pop();
                if (s instanceof a || Array.isArray(s)) {
                  if (Array.isArray(s)) {
                    u = 0;
                    for (var d = void 0; d = s[u]; u++) l(o.rect, d.rect);
                    o.nodes = o.nodes.concat(s);
                  } else l(o.rect, s.rect), o.nodes.push(s);
                  if (o.nodes.length <= this.maxWidth) s = o.rect.clone();else {
                    var f = this.linearSplit(o.nodes);
                    s = f, r.length || (o.nodes.push(f[0]), r.push(o), s = f[1]);
                  }
                } else l(o.rect, s), s = o.rect.clone();
              }
            }, t.prototype.chooseLeafSubtree = function (t) {
              var e,
                n = [],
                o = -1,
                i = !0;
              n.push(this.root);
              for (var r = this.root.nodes; i || -1 !== o;) {
                i ? i = !1 : (n.push(r[o]), r = r[o].nodes, o = -1);
                for (var s = r.length - 1, a = void 0; a = r[s]; s--) {
                  if (!p(a)) {
                    o = -1;
                    break;
                  }
                  var c = h(a.rect.width, a.rect.height, a.nodes.length + 1),
                    u = h(Math.max(a.rect.x + a.rect.width, t.rect.x + t.rect.width) - Math.min(a.rect.x, t.rect.x), Math.max(a.rect.y + a.rect.height, t.rect.y + t.rect.height) - Math.min(a.rect.y, t.rect.y), a.nodes.length + 2);
                  (o < 0 || Math.abs(u - c) < e) && (e = Math.abs(u - c), o = s);
                }
              }
              return n;
            }, t.prototype.linearSplit = function (t) {
              for (var e = this.pickLinear(t); t.length > 0;) this.pickNext(t, e[0], e[1]);
              return e;
            }, t.prototype.pickLinear = function (t) {
              for (var e, n, o = t.length - 1, i = 0, r = t.length - 1, s = 0, a = t.length - 2, c = void 0; c = t[a]; a--) c.rect.x > t[i].rect.x ? i = a : c.rect.right < t[o].rect.right && (o = a), c.rect.y > t[s].rect.y ? s = a : c.rect.bottom < t[r].rect.bottom && (r = a);
              return Math.abs(t[o].rect.right - t[i].rect.x) > Math.abs(t[r].rect.bottom - t[s].rect.y) ? o > i ? (e = t.splice(o, 1)[0], n = t.splice(i, 1)[0]) : (n = t.splice(i, 1)[0], e = t.splice(o, 1)[0]) : r > s ? (e = t.splice(r, 1)[0], n = t.splice(s, 1)[0]) : (n = t.splice(s, 1)[0], e = t.splice(r, 1)[0]), [new u(e.rect.clone(), [e]), new u(n.rect.clone(), [n])];
            }, t.prototype.pickNext = function (t, e, n) {
              for (var o, i, s, a = h(e.rect.width, e.rect.height, e.nodes.length + 1), c = h(n.rect.width, n.rect.height, n.nodes.length + 1), u = t.length - 1, p = void 0; p = t[u]; u--) {
                var d = new r.Rectangle(Math.min(e.rect.x, p.rect.x), Math.min(e.rect.y, p.rect.y), 0, 0);
                d.width = Math.max(e.rect.right, p.rect.right) - d.x, d.height = Math.max(e.rect.bottom, p.rect.bottom) - d.y;
                var f = Math.abs(h(d.width, d.height, e.nodes.length + 2) - a),
                  y = new r.Rectangle(Math.min(n.rect.x, p.rect.x), Math.min(n.rect.y, p.rect.y), 0, 0);
                y.width = Math.max(n.rect.right, p.rect.right) - y.x, y.height = Math.max(n.rect.bottom, p.rect.bottom) - y.y;
                var g = Math.abs(h(y.width, y.height, n.nodes.length + 2) - c);
                (!i || !o || Math.abs(g - f) < o) && (i = u, o = Math.abs(g - f), s = g < f ? n : e);
              }
              var m = t.splice(i, 1)[0];
              e.nodes.length + t.length + 1 <= this.minWidth ? (e.nodes.push(m), l(e.rect, m.rect)) : n.nodes.length + t.length + 1 <= this.minWidth ? (n.nodes.push(m), l(n.rect, m.rect)) : (s.nodes.push(m), l(s.rect, m.rect));
            }, t;
          }();
        e.RTree = s;
        var a = function (t) {
            this.rect = t;
          },
          c = function (t) {
            function e(e, n) {
              var o = t.call(this, e) || this;
              return o.obj = n, o;
            }
            return i(e, t), e;
          }(a),
          u = function (t) {
            function e(e, n) {
              var o = t.call(this, e) || this;
              return o.nodes = n, o;
            }
            return i(e, t), e;
          }(a);
        function p(t) {
          return "nodes" in t;
        }
        function h(t, e, n) {
          var o = (t + e) / 2,
            i = t * e;
          return i * n / (i / (o * o));
        }
        function l(t, e) {
          var n = Math.max(t.right, e.right),
            o = Math.max(t.bottom, e.bottom);
          t.x = Math.min(t.x, e.x), t.y = Math.min(t.y, e.y), t.width = n - t.x, t.height = o - t.y;
        }
      },
      3894: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MouseHandlerMoveConnectorPointState = void 0;
        var r = n(5327),
          s = n(8619),
          a = n(6320),
          c = n(1922),
          u = n(4385),
          p = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), e.prototype.onMouseDown = function (e) {
              this.connector = this.model.findConnector(e.source.key), this.pointIndex = parseInt(e.source.value), 0 === this.pointIndex ? this.pointPosition = a.ConnectorPosition.Begin : this.pointIndex === this.connector.points.length - 1 && (this.pointPosition = a.ConnectorPosition.End), this.handler.addInteractingItem(this.connector), t.prototype.onMouseDown.call(this, e);
            }, e.prototype.onApplyChanges = function (e) {
              this.connector.properties.lineOption === u.ConnectorLineOption.Orthogonal && 0 !== this.pointIndex && this.pointIndex !== this.connector.points.length - 1 || t.prototype.onApplyChanges.call(this, e);
            }, e.prototype.onFinishWithChanges = function () {
              t.prototype.onFinishWithChanges.call(this), c.ModelUtils.deleteConnectorUnnecessaryPoints(this.history, this.connector), this.handler.tryUpdateModelSize();
            }, e.prototype.getSnappedPoint = function (t, e) {
              var n = this.connector.points,
                o = this.pointIndex;
              if (0 < o && o < n.length - 1) {
                var i = (n[o + 1].y - n[o - 1].y) / (n[o + 1].x - n[o - 1].x),
                  s = e.x,
                  a = n[o + 1].y - (n[o + 1].x - s) * i;
                return this.handler.getSnappedPointOnDragPoint(t, e, new r.Point(s, a));
              }
              return this.handler.getSnappedPointOnDragPoint(t, e);
            }, e;
          }(s.MouseHandlerMoveConnectorPointStateBase);
        e.MouseHandlerMoveConnectorPointState = p;
      },
      3903: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.GraphInfo = void 0;
        var o = n(8060),
          i = function () {
            function t(t, e) {
              this.container = t, this.sourceGraph = e;
            }
            return Object.defineProperty(t.prototype, "graph", {
              get: function () {
                return this._graph || (this._graph = this.getNodeInfoGraph());
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(t.prototype, "level", {
              get: function () {
                return void 0 !== this._level ? this._level : this._level = this.getLevel();
              },
              enumerable: !1,
              configurable: !0
            }), t.prototype.getNodeInfoGraph = function () {
              return this.sourceGraph.cast(o.LayoutUtils.shapeToLayout);
            }, t.prototype.getLevel = function () {
              var t = 0;
              return this.container && (t = this.getContainerLevel(this.container)), t;
            }, t.prototype.getContainerLevel = function (t) {
              var e = 1,
                n = t.container;
              return n && (e += this.getContainerLevel(n)), e;
            }, t;
          }();
        e.GraphInfo = i;
      },
      3913: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SimpleCommandBase = void 0;
        var r = n(4339),
          s = n(4424),
          a = n(1922),
          c = n(820),
          u = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), e.prototype.getState = function () {
              return new s.SimpleCommandState(this.isEnabled(), this.getValue(), this.getDefaultValue(), this.getItems(), this.isVisible());
            }, e.prototype.isVisible = function () {
              return !0;
            }, e.prototype.isEnabled = function () {
              return !this.control.settings.readOnly || this.isEnabledInReadOnlyMode();
            }, e.prototype.isEnabledInReadOnlyMode = function () {
              return !1;
            }, e.prototype.getValue = function () {}, e.prototype.getDefaultValue = function () {}, e.prototype.getItems = function () {}, e.prototype.getModelUnit = function (t) {
              return a.ModelUtils.getlUnitValue(this.control.model.units, t);
            }, e.prototype.getModelUnitText = function (t) {
              return a.ModelUtils.getUnitText(this.control.model.units, c.DiagramLocalizationService.unitItems, c.DiagramLocalizationService.formatUnit, t);
            }, e.prototype.getModelUnitTwipsValue = function (t) {
              return a.ModelUtils.getTwipsValue(this.control.model.units, t);
            }, e.prototype.getViewUnit = function (t) {
              return a.ModelUtils.getlUnitValue(this.control.settings.viewUnits, t);
            }, e.prototype.getViewUnitText = function (t) {
              return a.ModelUtils.getUnitText(this.control.settings.viewUnits, c.DiagramLocalizationService.unitItems, c.DiagramLocalizationService.formatUnit, t);
            }, e.prototype.getViewUnitTwipsValue = function (t) {
              return a.ModelUtils.getTwipsValue(this.control.settings.viewUnits, t);
            }, e;
          }(r.CommandBase);
        e.SimpleCommandBase = u;
      },
      3918: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ConnectorPointsOrthogonalCalculator = void 0;
        var r = n(4412),
          s = n(4824),
          a = n(1532),
          c = n(8535),
          u = n(5442),
          p = n(2564),
          h = n(6568),
          l = n(522),
          d = n(9956),
          f = n(1922),
          y = function (t) {
            function e(e) {
              var n = t.call(this, e) || this;
              return n.sideCalculators = {}, n.sideCalculators[s.ConnectionPointSide.Undefined] = new c.ConnectorPointsOrthogonalUndefinedSideCalculator(n), n.sideCalculators[s.ConnectionPointSide.South] = new u.ConnectorPointsOrthogonalSouthSideCalculator(n), n.sideCalculators[s.ConnectionPointSide.North] = new p.ConnectorPointsOrthogonalNorthSideCalculator(n), n.sideCalculators[s.ConnectionPointSide.East] = new h.ConnectorPointsOrthogonalEastSideCalculator(n), n.sideCalculators[s.ConnectionPointSide.West] = new l.ConnectorPointsOrthogonalWestSideCalculator(n), n;
            }
            return i(e, t), Object.defineProperty(e.prototype, "beginRect", {
              get: function () {
                return this.connector.beginItem ? this.connector.beginItem.rectangle : void 0;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "endRect", {
              get: function () {
                return this.connector.endItem ? this.connector.endItem.rectangle : void 0;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.getPoints = function () {
              var t = this.connector.points.map(function (t, e) {
                return new d.ConnectorRenderPoint(t.x, t.y, e);
              });
              f.ModelUtils.skipUnnecessaryRenderPoints(t, !0);
              var e = 0,
                n = t.length - 1,
                o = this.getPointSide(t, 0),
                i = this.getPointSide(t, 1),
                r = this.getPointSide(t, t.length - 1),
                s = this.getPointSide(t, t.length - 1 - 1),
                a = this.getSideCalculator(o),
                c = this.getSideCalculator(r),
                u = this.beginRect,
                p = a.getCorrectOriginPoint(t[e], u),
                h = t[e + 1];
              if (2 === t.length && a.isOnSidePoint(p, h) && a.isDirectConnectionAllowed(i, p, h)) {
                a.getDirectConnectionPoints(p, h).forEach(function (o) {
                  t.splice(e + 1, 0, o), e++, n++;
                });
              } else {
                var l = a.getBeginOffsetPoints(i, t[e], t[e + 1], this.beginRect);
                l.forEach(function (n) {
                  t.splice(e + 1, 0, n);
                }), e += l.length, n += l.length, c.getEndOffsetPoints(s, t[n], t[n - 1], this.endRect).forEach(function (e, o) {
                  t.splice(n + o, 0, e);
                }), this.addMiddlePoints(t, e, n);
              }
              return f.ModelUtils.skipUnnecessaryRenderPoints(t, !0), t;
            }, e.prototype.getSideCalculator = function (t) {
              return this.sideCalculators[t];
            }, e.prototype.getPointSide = function (t, e) {
              if (0 === e && this.connector.beginItem) {
                var n = this.connector.beginConnectionPointIndex;
                return this.connector.beginItem.getConnectionPointSideByIndex(n, t[1]);
              }
              if (e === t.length - 1 && this.connector.endItem) {
                n = this.connector.endConnectionPointIndex;
                return this.connector.endItem.getConnectionPointSideByIndex(n, t[t.length - 2]);
              }
              return s.ConnectionPointSide.Undefined;
            }, e.prototype.addMiddlePoints = function (t, e, n) {
              for (var o = e; o < n; o++) {
                var i = o + 1,
                  r = this.getMiddlePoint(t[o], t[o - 1], o - 1 == 0, t[i], t[i + 1], i + 1 === t.length - 1);
                void 0 !== r && (t.splice(o + 1, 0, r), o++, n++);
              }
            }, e.prototype.getMiddlePoints = function (t, e) {
              return t.x === e.x || t.y === e.y ? [] : [new d.ConnectorRenderPoint(t.x, e.y), new d.ConnectorRenderPoint(e.x, t.y)];
            }, e.prototype.getMiddlePoint = function (t, e, n, o, i, s) {
              var a,
                c = this,
                u = this.getMiddlePoints(t, o);
              return u.forEach(function (n) {
                var s = c.createPointsRect(t, n),
                  u = c.createPointsRect(n, o),
                  p = c.connector.beginItem ? c.connector.beginItem.rectangle : void 0,
                  h = c.connector.endItem ? c.connector.endItem.rectangle : void 0;
                p && (r.Rectangle.areIntersected(p, s) || r.Rectangle.areIntersected(p, u)) || h && (r.Rectangle.areIntersected(h, s) || r.Rectangle.areIntersected(h, u)) || c.isReturnPoint(n, t, e) && !c.isIntermediatePoints(t, e) || c.isReturnPoint(n, o, i) && !c.isIntermediatePoints(o, i) || (void 0 === a || c.isPriorMiddlePoint(n, t, e, o, i)) && (a = n);
              }), void 0 === a && u.length > 0 && (a = u[0]), a;
            }, e.prototype.createPointsRect = function (t, e) {
              var n = r.Rectangle.fromPoints(t, e);
              return n.width > 0 && (n = n.clone().inflate(-1, 0)), n.height > 0 && (n = n.clone().inflate(0, -1)), n;
            }, e.prototype.isPriorMiddlePoint = function (t, e, n, o, i) {
              return !(!n || t.x !== n.x && t.y !== n.y) || !(!i || t.x !== i.x && t.y !== i.y);
            }, e.prototype.isReturnPoint = function (t, e, n) {
              if (void 0 !== e && void 0 !== n) {
                if (t.x === n.x && (e.y < t.y && t.y < n.y || e.y > t.y && t.y > n.y)) return !0;
                if (t.y === n.y && (e.x < t.x && t.x < n.x || e.x > t.x && t.x > n.x)) return !0;
              }
              return !1;
            }, e.prototype.isIntermediatePoints = function (t, e) {
              return 0 < t.pointIndex && t.pointIndex < this.connector.points.length - 1 && 0 < e.pointIndex && e.pointIndex < this.connector.points.length - 1;
            }, e;
          }(a.ConnectorPointsCalculatorBase);
        e.ConnectorPointsOrthogonalCalculator = y;
      },
      3974: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AutoLayoutLayeredVerticalBottomToTopCommand = void 0;
        var r = n(9212),
          s = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), e.prototype.createLayoutSettings = function () {
              var e = t.prototype.createLayoutSettings.call(this);
              return e.direction = r.LogicalDirectionKind.Backward, e;
            }, e;
          }(n(8827).AutoLayoutLayeredVerticalCommand);
        e.AutoLayoutLayeredVerticalBottomToTopCommand = s;
      },
      3976: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ConnectorPointsOrthogonalSideCalculatorBase = void 0;
        var o = n(4412),
          i = n(4824),
          r = n(6320),
          s = function () {
            function t(t) {
              this.parent = t;
            }
            return Object.defineProperty(t.prototype, "connector", {
              get: function () {
                return this.parent.connector;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(t.prototype, "beginRect", {
              get: function () {
                return this.parent.beginRect;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(t.prototype, "endRect", {
              get: function () {
                return this.parent.endRect;
              },
              enumerable: !1,
              configurable: !0
            }), t.prototype.getBeginOffsetPoints = function (t, e, n, o) {
              if (e = this.getCorrectOriginPoint(e, o), t !== i.ConnectionPointSide.Undefined) {
                if (this.isBeginEndSame()) return this.getSameShapeOffsetPoints(t, e, n, o);
                if (this.isBeginEndOverlappedPoints(e, n)) return this.getOverlappedPointsOffsetPoints(t, e, n, o);
                if (this.isBeginEndOverlapped()) return this.getBeginOverlappedShapeOffsetPoints(t, e, n, o);
              } else if (this.isOriginRectContainsTargetPoint(o, n)) return this.getOverlappedPointsOffsetPoints(t, e, n, o);
              return this.isOnSidePoint(e, n) ? this.getBeginOnSideOffsetPoints(t, e, n, o) : this.getBeginOffSideOffsetPoints(t, e, n, o);
            }, t.prototype.getEndOffsetPoints = function (t, e, n, o) {
              if (e = this.getCorrectOriginPoint(e, o), t !== i.ConnectionPointSide.Undefined) {
                if (this.isBeginEndSame()) return this.getSameShapeOffsetPoints(t, e, n, o);
                if (this.isBeginEndOverlappedPoints(n, e)) return this.getOverlappedPointsOffsetPoints(t, e, n, o);
                if (this.isBeginEndOverlapped()) return this.getEndOverlappedShapeOffsetPoints(t, e, n, o);
              } else if (this.isOriginRectContainsTargetPoint(o, n)) return this.getOverlappedPointsOffsetPoints(t, e, n, o);
              return this.isOnSidePoint(e, n) ? this.getEndOnSideOffsetPoints(t, e, n, o) : this.getEndOffSideOffsetPoints(t, e, n, o);
            }, t.prototype.getSide = function (t, e) {
              return Math.abs(e.x - t.x) > Math.abs(e.y - t.y) ? e.x > t.x ? i.ConnectionPointSide.East : i.ConnectionPointSide.West : e.y > t.y ? i.ConnectionPointSide.South : i.ConnectionPointSide.North;
            }, t.prototype.getSideCalculator = function (t, e) {
              return this.parent.getSideCalculator(this.getSide(t, e));
            }, t.prototype.getMinOffset = function () {
              return r.Connector.minOffset;
            }, t.prototype.isBeginEndSame = function () {
              return this.connector.beginItem === this.connector.endItem;
            }, t.prototype.isBeginEndOverlapped = function () {
              return this.beginRect && this.endRect && o.Rectangle.areIntersected(this.beginRect, this.endRect);
            }, t.prototype.isBeginEndOverlappedX = function () {
              return this.beginRect && this.endRect && !!o.Rectangle.getHorizIntersection(this.beginRect, this.endRect);
            }, t.prototype.isBeginEndOverlappedY = function () {
              return this.beginRect && this.endRect && !!o.Rectangle.getVertIntersection(this.beginRect, this.endRect);
            }, t.prototype.isBeginEndOverlappedPoints = function (t, e) {
              return this.beginRect && this.endRect && (this.beginRect.containsPoint(e) || this.endRect.containsPoint(t));
            }, t.prototype.isOriginRectContainsTargetPoint = function (t, e) {
              return t && e && t.containsPoint(e);
            }, t;
          }();
        e.ConnectorPointsOrthogonalSideCalculatorBase = s;
      },
      4009: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ToggleFullscreenCommand = void 0;
        var r = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(e, t), e.prototype.isEnabledInReadOnlyMode = function () {
            return !0;
          }, e.prototype.getValue = function () {
            return this.control.settings.fullscreen;
          }, e.prototype.executeCore = function (t, e) {
            var n = "boolean" == typeof e ? e : !t.value;
            return this.control.settings.fullscreen !== n && (this.control.settings.fullscreen = !t.value, this.control.notifyToggleFullscreen(this.control.settings.fullscreen)), !0;
          }, e;
        }(n(3913).SimpleCommandBase);
        e.ToggleFullscreenCommand = r;
      },
      4044: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ScrollIntoViewOnUndoHistoryItem = e.ScrollIntoViewOnRedoHistoryItem = void 0;
        var r = n(2616),
          s = function (t) {
            function e(e, n) {
              var o = t.call(this) || this;
              return o.view = e, o.rectangle = n, o.view = e, o.rectangle = n.clone(), o;
            }
            return i(e, t), e.prototype.redo = function (t) {
              this.view.scrollIntoView(this.rectangle);
            }, e.prototype.undo = function (t) {}, e;
          }(r.HistoryItem);
        e.ScrollIntoViewOnRedoHistoryItem = s;
        var a = function (t) {
          function e(e, n) {
            var o = t.call(this) || this;
            return o.view = e, o.rectangle = n, o.view = e, o.rectangle = n.clone(), o;
          }
          return i(e, t), e.prototype.redo = function (t) {}, e.prototype.undo = function (t) {
            this.view.scrollIntoView(this.rectangle);
          }, e;
        }(r.HistoryItem);
        e.ScrollIntoViewOnUndoHistoryItem = a;
      },
      4045: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AStarContext = e.AStarContextBase = void 0;
        var r = n(6210),
          s = n(2721),
          a = n(2740),
          c = n(476),
          u = n(618),
          p = n(41),
          h = function () {
            function t(t, e, n) {
              this.startPosition = t, this.targetPosition = e, this.maxStepsCount = n, this.prohibitedPoints = {};
            }
            return Object.defineProperty(t.prototype, "shouldStartContinue", {
              get: function () {
                return this.updatableSet.count > 0 && this.stepsCount < this.maxStepsCount;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(t.prototype, "shouldFinish", {
              get: function () {
                return this.currentNode.position.equals(this.targetPosition);
              },
              enumerable: !1,
              configurable: !0
            }), t.prototype.start = function () {
              this.generalSet = new r.SortedQueues(function (t) {
                return t.key;
              }), this.updatableSet = new s.UniqueAStarNodePositions();
              var t = new a.AStarNode(this.startPosition, this.getDistance(this.startPosition, this.targetPosition));
              this.currentNode = t, this.generalSet.enqueue(t), this.updatableSet.add(t.position, t), this.stepsCount = 0, this.openNode = void 0;
            }, t.prototype.startContinue = function () {
              this.currentNode = this.generalSet.dequeueMin();
            }, t.prototype.endContinue = function () {
              var t = this,
                e = this.currentNode.position;
              this.updatableSet.remove(e), this.addProhibitedPoint(e), this.getNeighborPoints(e).forEach(function (e) {
                var n = t.getPenalty(t.currentNode, e),
                  o = t.updatableSet.getNode(e);
                if (void 0 === o) (o = new a.AStarNode(e, t.getDistance(e, t.targetPosition))).parent = t.currentNode, o.penalty = n, t.generalSet.enqueue(o), t.updatableSet.add(e, o);else if (o.penalty > n) {
                  var i = t.generalSet;
                  i.remove(o), o.parent = t.currentNode, o.penalty = n, i.enqueue(o);
                }
                t.openNode = o;
              }), this.stepsCount++;
            }, t.prototype.finishWithPath = function () {
              this.path = this.currentNode.getPath();
            }, t.prototype.finishWithoutPath = function () {
              this.path = [];
            }, t;
          }();
        e.AStarContextBase = h;
        var l = function (t) {
          function e(e, n, o, i, r, s) {
            var a = t.call(this, n, o, 1e4) || this;
            return a.routingContext = e, a.startPosition = n, a.targetPosition = o, a.prohibitedSegments = i, a.grid = r, a.metrics = s, a;
          }
          return i(e, t), e.prototype.addProhibitedPoint = function (t) {
            this.prohibitedPoints[t.x + "_" + t.y] = t;
          }, e.prototype.getNeighborPoints = function (t) {
            var e = this;
            return this.grid.getNeighborPoints(t).filter(function (t) {
              return e.allowPoint(t);
            });
          }, e.prototype.getDistance = function (t, e) {
            return this.metrics.distance(t, e);
          }, e.prototype.getPenalty = function (t, e) {
            var n = t.parent,
              o = t.position,
              i = this.getTurnDirection(n ? p.GeometryUtils.createAngle(n.position, o, e) : 0),
              r = this.getDistance(o, e),
              s = new c.Segment(o, e).center;
            return t.penalty + this.metrics.penalty(r, s, i, this.getIntersectedItems(s));
          }, e.prototype.allowPoint = function (t) {
            return !(t.x + "_" + t.y in this.prohibitedPoints) && (!this.prohibitedSegments || this.prohibitedSegments.allowPoint(t));
          }, e.prototype.getTurnDirection = function (t) {
            return u.RightAngleConnectorRoutingMathOperations.getTurnDirection(t);
          }, e.prototype.getIntersectedItems = function (t) {
            var e = this,
              n = this.routingContext.shapeMargins;
            return this.routingContext.getIntersectedItems(t, n).filter(function (t) {
              return e.hasOneShapeConnection(t) || !e.itemContainsConnectionPoints(t);
            });
          }, e.prototype.itemContainsConnectionPoints = function (t) {
            var e = t.rectangle;
            return e.containsPoint(this.routingContext.beginPoint) && e.containsPoint(this.routingContext.endPoint);
          }, e.prototype.hasOneShapeConnection = function (t) {
            var e = t.getConnectionPoints();
            return this.isConnectionPoint(e, this.routingContext.beginPoint) && this.isConnectionPoint(e, this.routingContext.endPoint);
          }, e.prototype.isConnectionPoint = function (t, e) {
            return t.filter(function (t) {
              return t.equals(e);
            }).length > 0;
          }, e;
        }(h);
        e.AStarContext = l;
      },
      4048: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AddConnectorHistoryItem = void 0;
        var r = n(2616),
          s = n(6320),
          a = function (t) {
            function e(e, n, o) {
              var i = t.call(this) || this;
              return i.points = e, i.dataKey = n, i.renderPointsContext = o, i;
            }
            return i(e, t), e.prototype.redo = function (t) {
              var e = new s.Connector(this.points);
              void 0 !== this.dataKey && (e.dataKey = this.dataKey), void 0 !== this.renderPointsContext && e.replaceRenderPoints(this.renderPointsContext), t.addConnector(e, this.connectorKey), this.connectorKey = e.key;
            }, e.prototype.undo = function (t) {
              var e = t.model.findConnector(this.connectorKey);
              t.deleteConnector(e);
            }, e;
          }(r.HistoryItem);
        e.AddConnectorHistoryItem = a;
      },
      4062: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ImageCache = e.CacheImageInfo = void 0;
        var o = n(807),
          i = n(9406),
          r = n(41),
          s = function () {
            function t(t, e, n, i, r) {
              this._base64 = void 0 !== t ? o.Base64Utils.normalizeToDataUrl(t, "image/png") : void 0, this.actualId = e, this._referenceInfo = i, this._isLoaded = void 0 !== r && r, this.imageUrl = n;
            }
            return Object.defineProperty(t.prototype, "isLoaded", {
              get: function () {
                return this._referenceInfo ? this._referenceInfo._isLoaded : this._isLoaded;
              },
              set: function (t) {
                this._isLoaded = t;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(t.prototype, "base64", {
              get: function () {
                return this._base64;
              },
              set: function (t) {
                this._base64 = o.Base64Utils.normalizeToDataUrl(t, "image/png");
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(t.prototype, "referenceInfo", {
              get: function () {
                return this._referenceInfo;
              },
              set: function (t) {
                this._referenceInfo = t, this._base64 = void 0, this._isLoaded = void 0;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(t.prototype, "isLoading", {
              get: function () {
                return this._referenceInfo ? this.referenceInfo._isLoading : this._isLoading;
              },
              enumerable: !1,
              configurable: !0
            }), t.prototype.startLoading = function () {
              this._referenceInfo ? this._referenceInfo.startLoading() : this._isLoading = !0;
            }, t.prototype.finalizeLoading = function () {
              this._referenceInfo ? this._referenceInfo.finalizeLoading() : this._isLoading = !1;
            }, t;
          }();
        e.CacheImageInfo = s;
        var a = function () {
          function t() {
            this.emptyImageId = 0, this.lastActualId = 0, this.onReadyStateChanged = new r.EventDispatcher(), this.cache = [], this.nonLoadedImages = [], this.createUnloadedInfoByBase64(i.ImageInfo.transparentOnePixelImage).isLoaded = !0;
          }
          return t.prototype.reset = function () {
            this.cache.splice(1), this.nonLoadedImages = [], this.lastActualId = 1;
          }, Object.defineProperty(t.prototype, "emptyImage", {
            get: function () {
              return this.cache[this.emptyImageId];
            },
            enumerable: !1,
            configurable: !0
          }), t.prototype.getImageData = function (t) {
            return this.cache[t];
          }, t.prototype.createUnloadedInfoByUrl = function (t) {
            var e = this.findInfoByUrl(t);
            return e || this.registerImageData(new s(void 0, this.getNextActualId(), t));
          }, t.prototype.createUnloadedInfoByBase64 = function (t) {
            var e = this.findInfoByBase64(t);
            return e || this.registerImageData(new s(t, this.getNextActualId()));
          }, t.prototype.createUnloadedInfoByShapeImageInfo = function (t) {
            var e = t.exportUrl;
            return o.Base64Utils.checkPrependDataUrl(e) ? this.createUnloadedInfoByBase64(e) : this.createUnloadedInfoByUrl(e);
          }, t.prototype.registerImageData = function (t) {
            var e = this.cache[t.actualId];
            return e || (e = t), void 0 !== t.actualId && (this.cache[t.actualId] = e), 0 !== t.actualId && (this.nonLoadedImages.push(t), 1 === this.nonLoadedImages.length && this.raiseReadyStateChanged(!1)), e;
          }, t.prototype.loadAllImages = function (t) {
            var e = this;
            this.cache.forEach(function (n) {
              e.emptyImageId === n.actualId || n.isLoaded || n.isLoading || t.load(n);
            });
          }, t.prototype.finalizeLoading = function (t, e) {
            t.finalizeLoading(), t.isLoaded = !0;
            var n = this.nonLoadedImages.indexOf(t);
            if (this.nonLoadedImages.splice(n, 1), 0 === this.nonLoadedImages.length && this.raiseReadyStateChanged(!0), !t.referenceInfo && e.base64) {
              var i = o.Base64Utils.normalizeToDataUrl(e.base64, "image/png");
              this.cache.forEach(function (e) {
                var n = e.base64 === i && e !== t && e.isLoaded;
                return n && (t.referenceInfo = e.referenceInfo ? e.referenceInfo : e), n;
              }), t.base64 = i;
            }
          }, t.prototype.hasNonLoadedImages = function () {
            return 0 !== this.nonLoadedImages.length;
          }, t.prototype.getNextActualId = function () {
            return this.lastActualId++;
          }, t.prototype.findInfoByBase64 = function (t) {
            return t = o.Base64Utils.normalizeToDataUrl(t, "image/png"), this.findInfoCore(function (e) {
              return e.base64 === t;
            });
          }, t.prototype.findInfoByUrl = function (t) {
            return this.findInfoCore(function (e) {
              return e.imageUrl === t;
            });
          }, t.prototype.findInfoCore = function (t) {
            var e;
            return this.cache.forEach(function (n) {
              t(n) && (e = n);
            }), e;
          }, t.prototype.raiseReadyStateChanged = function (t) {
            this.onReadyStateChanged.raise1(function (e) {
              return e.notifyImageCacheReadyStateChanged(t);
            });
          }, t.instance = new t(), t;
        }();
        e.ImageCache = a;
      },
      4092: (t, e, n) => {
        n(9491).polyfill();
      },
      4139: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SetConnectionPointIndexHistoryItem = e.AddConnectionHistoryItem = void 0;
        var r = n(2616),
          s = n(6320),
          a = function (t) {
            function e(e, n, o, i) {
              var r = t.call(this) || this;
              return r.connectorKey = e.key, r.itemKey = n.key, r.connectionPointIndex = o, r.position = i, r;
            }
            return i(e, t), e.prototype.redo = function (t) {
              var e = t.model.findConnector(this.connectorKey),
                n = t.model.findItem(this.itemKey);
              t.addConnection(e, n, this.connectionPointIndex, this.position);
            }, e.prototype.undo = function (t) {
              var e = t.model.findConnector(this.connectorKey);
              t.deleteConnection(e, this.position);
            }, e;
          }(r.HistoryItem);
        e.AddConnectionHistoryItem = a;
        var c = function (t) {
          function e(e, n, o) {
            var i = t.call(this) || this;
            return i.connectorKey = e.key, i.connectionPointIndex = n, i.position = o, i;
          }
          return i(e, t), e.prototype.redo = function (t) {
            var e = t.model.findConnector(this.connectorKey);
            this.oldConnectionPointIndex = this.position === s.ConnectorPosition.Begin ? e.beginConnectionPointIndex : e.endConnectionPointIndex, t.setConnectionPointIndex(e, this.connectionPointIndex, this.position);
          }, e.prototype.undo = function (t) {
            var e = t.model.findConnector(this.connectorKey);
            t.setConnectionPointIndex(e, this.oldConnectionPointIndex, this.position);
          }, e;
        }(r.HistoryItem);
        e.SetConnectionPointIndexHistoryItem = c;
      },
      4166: (t, e) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Vector = void 0;
        var n = function () {
          function t(t, e) {
            void 0 === t && (t = 0), void 0 === e && (e = 0), this.x = t, this.y = e;
          }
          return Object.defineProperty(t.prototype, "length", {
            get: function () {
              return Math.sqrt(this.x * this.x + this.y * this.y);
            },
            enumerable: !1,
            configurable: !0
          }), t.fromPoints = function (e, n) {
            return new t(n.x - e.x, n.y - e.y);
          }, t.fromSegment = function (e) {
            return new t(e.endPoint.x - e.startPoint.x, e.endPoint.y - e.startPoint.y);
          }, t.prototype.normalize = function () {
            var t = this.length;
            return 0 !== t && (this.x /= t, this.y /= t), this;
          }, t.prototype.negative = function () {
            return this.x *= -1, this.y *= -1, this;
          }, Object.defineProperty(t, "axisX", {
            get: function () {
              return new t(1, 0);
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t, "axisY", {
            get: function () {
              return new t(0, 1);
            },
            enumerable: !1,
            configurable: !0
          }), t.angleBetween = function (e, n) {
            var o = t.scalarProduct(e, n) / (e.length * n.length);
            return Math.acos(o);
          }, t.scalarProduct = function (t, e) {
            return t.x * e.x + t.y * e.y;
          }, t;
        }();
        e.Vector = n;
      },
      4214: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AutoLayoutLayeredHorizontalCommand = void 0;
        var r = n(8674),
          s = n(2626),
          a = n(9212),
          c = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), e.prototype.createLayoutSettings = function () {
              var t = new a.LayoutSettings();
              return t.orientation = a.DataLayoutOrientation.Horizontal, t;
            }, e.prototype.createLayout = function (t, e) {
              return new s.SugiyamaLayoutBuilder(t, e).build();
            }, e;
          }(r.AutoLayoutCommandBase);
        e.AutoLayoutLayeredHorizontalCommand = c;
      },
      4235: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.NativeConnector = e.NativeShape = e.NativeItem = void 0;
        var r = n(1922),
          s = function () {
            function t(t, e) {
              this.id = t, this.key = e, this.unitsApplied = !1;
            }
            return t.prototype.applyUnits = function (t) {
              this.unitsApplied || void 0 === t || (this.applyUnitsCore(t), this.unitsApplied = !0);
            }, t;
          }();
        e.NativeItem = s;
        var a = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(e, t), e.prototype.applyUnitsCore = function (t) {
            this.position.x = r.ModelUtils.getlUnitValue(t, this.position.x), this.position.y = r.ModelUtils.getlUnitValue(t, this.position.y), this.size.width = r.ModelUtils.getlUnitValue(t, this.size.width), this.size.height = r.ModelUtils.getlUnitValue(t, this.size.height);
          }, e;
        }(s);
        e.NativeShape = a;
        var c = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(e, t), e.prototype.applyUnitsCore = function (t) {
            this.points.forEach(function (e) {
              e.x = r.ModelUtils.getlUnitValue(t, e.x), e.y = r.ModelUtils.getlUnitValue(t, e.y);
            });
          }, e;
        }(s);
        e.NativeConnector = c;
      },
      4237: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MouseHandlerCreateConnectorState = void 0;
        var r = n(6320),
          s = n(4139),
          a = n(4048),
          c = n(4824),
          u = n(8619),
          p = n(6512),
          h = n(8214),
          l = n(1922),
          d = n(6155),
          f = n(7392),
          y = function (t) {
            function e(e, n, o, i, r, s, a) {
              var c = t.call(this, e, n, o, i) || this;
              return c.shapeDescriptionManager = r, c.selection = s, c.connectionPointIndex = a, c;
            }
            return i(e, t), e.prototype.onMouseDown = function (e) {
              void 0 === this.connectionPointIndex && (this.connectionPointIndex = parseInt(e.source.value)), this.connectedItem = this.model.findItem(e.source.key), this.pointIndex = 1, this.pointPosition = r.ConnectorPosition.End, t.prototype.onMouseDown.call(this, e);
            }, e.prototype.onMouseUp = function (e) {
              this.connector && !this.connector.endItem && this.createNewShapeAtConnectorEnd(e), t.prototype.onMouseUp.call(this, e);
            }, e.prototype.onApplyChanges = function (e) {
              var n = this.getSnappedPoint(e, e.modelPoint);
              if (this.connector) t.prototype.onApplyChanges.call(this, e);else {
                var o = new a.AddConnectorHistoryItem([this.connectedItem.getConnectionPointPosition(this.connectionPointIndex, n), n]);
                this.history.addAndRedo(o), this.connector = this.model.findConnector(o.connectorKey), this.handler.addInteractingItem(this.connector), this.history.addAndRedo(new s.AddConnectionHistoryItem(this.connector, this.connectedItem, this.connectionPointIndex, r.ConnectorPosition.Begin)), l.ModelUtils.updateNewConnectorProperties(this.history, this.selection, this.connector.key);
              }
            }, e.prototype.checkStoredPermissionsOnFinish = function () {
              this.connector && this.connector.endItem && t.prototype.checkStoredPermissionsOnFinish.call(this);
            }, e.prototype.onFinishWithChanges = function () {
              t.prototype.onFinishWithChanges.call(this), this.history.addAndRedo(new p.SetSelectionHistoryItem(this.selection, [this.connector.key]));
            }, e.prototype.createNewShapeAtConnectorEnd = function (t) {
              var e = this,
                n = this.connector && this.connector.beginItem;
              if (n) if (!this.connector || this.handler.canPerformChangeConnection(this.connector, {
                position: r.ConnectorPosition.End,
                connectionPointIndex: -1
              })) {
                var o = this.getNewShapeSide(this.connector),
                  i = this.getSnappedPoint(t, t.modelPoint),
                  a = this.shapeDescriptionManager.getCategoryByDescription(n.description);
                this.handler.showContextToolbox(i, function (n) {
                  var r = n.clone();
                  r.position = i.clone();
                  var s = e.getNewShapePosition(r, o);
                  return e.handler.getSnappedPointOnDragPoint(t, s);
                }, o, a, function (n) {
                  if (n) {
                    e.handler.beginStorePermissions(), e.history.beginTransaction();
                    var a = new h.AddShapeHistoryItem(e.shapeDescriptionManager.get(n), i);
                    e.history.addAndRedo(a);
                    var c = e.model.findShape(a.shapeKey),
                      u = e.targetItem && e.model.findNearestContainer(e.targetItem.key);
                    u && l.ModelUtils.insertToContainer(e.history, e.model, c, u);
                    var d = e.getNewShapePosition(c, o);
                    l.ModelUtils.setShapePosition(e.history, e.model, c, e.getSnappedPoint(t, d)), l.ModelUtils.updateNewShapeProperties(e.history, e.selection, c.key), e.history.addAndRedo(new s.AddConnectionHistoryItem(e.connector, c, c.getConnectionPointIndexForSide(o), r.ConnectorPosition.End)), u && l.ModelUtils.updateConnectorContainer(e.history, e.model, e.connector), l.ModelUtils.updateShapeAttachedConnectors(e.history, e.model, c), e.handler.isStoredPermissionsGranted() ? (e.handler.tryUpdateModelSize(), e.history.addAndRedo(new p.SetSelectionHistoryItem(e.selection, [c.key]))) : (e.handler.lockPermissions(), e.history.undoTransaction(), e.handler.unlockPermissions(), e.checkNewConnectorPermissions()), e.history.endTransaction(), e.handler.endStorePermissions(), e.handler.hideContextToolbox(!0);
                  }
                }, function () {
                  e.checkNewConnectorPermissions();
                });
              } else this.cancelChanges();
            }, e.prototype.checkNewConnectorPermissions = function () {
              this.connector && !this.handler.canPerformChangeConnection(this.connector, {
                position: r.ConnectorPosition.End,
                connectionPointIndex: -1
              }) && (this.handler.lockPermissions(), this.history.beginTransaction(), this.history.addAndRedo(new p.SetSelectionHistoryItem(this.selection, [])), this.connector.beginItem && this.history.addAndRedo(new d.DeleteConnectionHistoryItem(this.connector, r.ConnectorPosition.Begin)), this.connector.endItem && this.history.addAndRedo(new d.DeleteConnectionHistoryItem(this.connector, r.ConnectorPosition.End)), this.history.addAndRedo(new f.DeleteConnectorHistoryItem(this.connector.key)), this.history.endTransaction(), this.handler.unlockPermissions());
            }, e.prototype.getNewShapePosition = function (t, e) {
              switch (e) {
                case c.ConnectionPointSide.North:
                  return t.position.clone().offset(-t.size.width / 2, 0);
                case c.ConnectionPointSide.South:
                  return t.position.clone().offset(-t.size.width / 2, -t.size.height);
                case c.ConnectionPointSide.East:
                  return t.position.clone().offset(-t.size.width, -t.size.height / 2);
                case c.ConnectionPointSide.West:
                  return t.position.clone().offset(0, -t.size.height / 2);
              }
            }, e.prototype.getNewShapeSide = function (t) {
              var n = t.getRenderPoints();
              return e.getNewShapeSideByConnectorPoints(n[n.length - 1], n[n.length - 2]);
            }, e.prototype.getSourceItem = function () {
              return this.connectedItem;
            }, e.getNewShapeSideByConnectorPoints = function (t, e) {
              return t.x === e.x ? t.y > e.y ? c.ConnectionPointSide.North : c.ConnectionPointSide.South : t.x > e.x ? t.y === e.y ? c.ConnectionPointSide.West : t.y > e.y ? Math.abs(t.x - e.x) > Math.abs(t.y - e.y) ? c.ConnectionPointSide.West : c.ConnectionPointSide.North : Math.abs(t.x - e.x) > Math.abs(t.y - e.y) ? c.ConnectionPointSide.West : c.ConnectionPointSide.South : t.y === e.y ? c.ConnectionPointSide.East : t.y > e.y ? Math.abs(t.x - e.x) > Math.abs(t.y - e.y) ? c.ConnectionPointSide.East : c.ConnectionPointSide.North : Math.abs(t.x - e.x) > Math.abs(t.y - e.y) ? c.ConnectionPointSide.East : c.ConnectionPointSide.South;
            }, e;
          }(u.MouseHandlerMoveConnectorPointStateBase);
        e.MouseHandlerCreateConnectorState = y;
      },
      4276: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ChangeConnectorLineOptionCommand = void 0;
        var r = n(2078),
          s = n(4385),
          a = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), e.prototype.getPropertyName = function () {
              return "lineOption";
            }, e.prototype.getPropertyDefaultValue = function () {
              return s.ConnectorLineOption.Straight;
            }, e;
          }(r.ChangeConnectorPropertyCommand);
        e.ChangeConnectorLineOptionCommand = a;
      },
      4306: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.RenderManager = e.DBL_CLICK_TIMEOUT = e.LONG_TOUCH_TIMEOUT = void 0;
        var o = n(5428),
          i = n(8451),
          r = n(750),
          s = n(5327),
          a = n(6537),
          c = n(8424),
          u = n(2136),
          p = n(9922),
          h = n(7281),
          l = n(9307),
          d = n(7169),
          f = n(3283),
          y = n(1377),
          g = n(9700),
          m = n(7611),
          v = n(6727),
          P = n(8509),
          C = n(6873),
          S = n(41),
          x = "dxdi-touch-action";
        e.LONG_TOUCH_TIMEOUT = 500, e.DBL_CLICK_TIMEOUT = 500;
        var b = function () {
          function t(t, e, n, o, i, r, s) {
            this.moveLocked = !1, this.lockMouseMoveTimer = -1, this.lastClickElement = void 0, this.longTouchTimer = void 0, this.dblTouchTimer = void 0, this.pointers = {};
            var a = P.RenderHelper.createMainElement(t),
              c = P.RenderHelper.createSvgElement(a);
            this.instanceId = i, this.scroll = r || new h.NativeScrollView(t), this.measurer = n, this.dom = new C.DOMManipulator(this.measurer), this.view = new y.CanvasViewManager(this.scroll, c, o.modelSize, o.zoomLevel, o.autoZoom, o.simpleView, o.rectangle, this.dom, this.instanceId), this.input = new d.InputManager(a, this.view, e, this.measurer, o.zoomLevel, s), this.items = new p.CanvasItemsManager(this.view.canvasElement, o.zoomLevel, this.dom, this.instanceId), this.page = new f.CanvasPageManager(this.view.pageElement, o, this.dom, this.instanceId), this.selection = new g.CanvasSelectionManager(this.view.canvasElement, o.zoomLevel, o.readOnly, this.dom, this.instanceId), this.contextMenuEnabled = o.contextMenuEnabled, this.view.onViewChanged.add(this.page), this.view.onViewChanged.add(this.items), this.view.onViewChanged.add(this.selection), this.view.onViewChanged.add(this.input), this.autoScroll = new m.AutoScrollController(this.scroll, c, this.view, this.dom), this.attachEvents(c), this.mainElement = a, this.svgElement = c, this.events = e, this.notifyReadOnlyChanged(o.readOnly);
          }
          return t.prototype.clean = function (t) {
            this.killLockMouseMoveTimer(), this.clearLastMouseDownEvent(), this.detachEvents(this.svgElement), this.scroll.detachEvents(), this.input.detachEvents(), this.dom.cancelAnimation(), t && t(this.mainElement);
          }, t.prototype.replaceParent = function (t, e) {
            this.mainElement && this.mainElement.parentNode !== t && t.appendChild(this.mainElement), e && e !== this.scroll && (this.scroll && this.scroll.detachEvents(), this.scroll = e), this.measurer instanceof v.TextMeasurer && this.measurer.replaceParent(t);
          }, t.prototype.update = function (t) {
            this.view.adjust({
              horizontal: !t,
              vertical: !t
            }), this.page.redraw();
          }, t.prototype.onNewModel = function (t) {
            this.measurer.onNewModel(t, this.dom);
          }, t.prototype.clear = function () {
            this.items.clear(), this.selection.clear(), this.input.clear();
          }, t.prototype.attachPointerEvents = function (t) {
            r.DomUtils.addClassName(t, x), P.RenderHelper.addEventListener(t, "pointerdown", this.onPointerDownHandler), P.RenderHelper.addEventListener(t, "mousedown", this.onSvgMouseDownHandler), P.RenderHelper.addEventListener(t, "mousemove", this.onSvgMouseMoveHandler), P.RenderHelper.addEventListener(c.Browser.TouchUI ? t : document, "pointerup", this.onPointerUpHandler), P.RenderHelper.addEventListener(c.Browser.TouchUI ? t : document, "pointermove", this.onPointerMoveHandler), P.RenderHelper.addEventListener(t, "pointercancel", this.onPointerCancelHandler), P.RenderHelper.addEventListener(t, "pointerleave", this.onPointerLeaveHandler);
          }, t.prototype.detachPointerEvents = function (t) {
            P.RenderHelper.removeEventListener(t, "pointerdown", this.onPointerDownHandler), P.RenderHelper.removeEventListener(t, "mousedown", this.onSvgMouseDownHandler), P.RenderHelper.removeEventListener(t, "mousemove", this.onSvgMouseMoveHandler), P.RenderHelper.removeEventListener(c.Browser.TouchUI ? t : document, "pointerup", this.onPointerUpHandler), P.RenderHelper.removeEventListener(c.Browser.TouchUI ? t : document, "pointermove", this.onPointerMoveHandler), P.RenderHelper.removeEventListener(t, "pointercancel", this.onPointerCancelHandler), P.RenderHelper.removeEventListener(t, "pointerleave", this.onPointerLeaveHandler), r.DomUtils.removeClassName(t, x);
          }, t.prototype.attachEvents = function (t) {
            this.onPointerDownHandler = this.onPointerDown.bind(this), this.onPointerUpHandler = this.onPointerUp.bind(this), this.onPointerMoveHandler = this.onPointerMove.bind(this), this.onPointerCancelHandler = this.onPointerCancel.bind(this), this.onPointerLeaveHandler = this.onPointerLeave.bind(this), this.onSvgMouseDownHandler = this.onSvgMouseDown.bind(this), this.onSvgMouseMoveHandler = this.onSvgMouseMove.bind(this), this.onMouseWheelHandler = this.onMouseWheel.bind(this), this.onMouseDblClickHandler = this.onMouseDblClick.bind(this), this.onContextMenuHandler = this.onContextMenu.bind(this), this.onWindowResizelHandler = this.onWindowResize.bind(this), this.onOrientationChangeHandler = this.onOrientationChange.bind(this), this.onMouseClickHandler = this.onMouseClick.bind(this), this.attachPointerEvents(t), P.RenderHelper.addEventListener(t, "wheel", this.onMouseWheelHandler), P.RenderHelper.addEventListener(t, "dblclick", this.onMouseDblClickHandler), P.RenderHelper.addEventListener(t, "click", this.onMouseClickHandler), P.RenderHelper.addEventListener(t, "contextmenu", this.onContextMenuHandler), P.RenderHelper.addEventListener(window, "resize", this.onWindowResizelHandler), P.RenderHelper.addEventListener(window, "orientationchange", this.onOrientationChangeHandler), this.input.mouseWheelHandler = this.onMouseWheelHandler;
          }, t.prototype.detachEvents = function (t) {
            this.detachPointerEvents(t), P.RenderHelper.removeEventListener(t, "wheel", this.onMouseWheelHandler), P.RenderHelper.removeEventListener(t, "dblclick", this.onMouseDblClickHandler), P.RenderHelper.removeEventListener(t, "contextmenu", this.onContextMenuHandler), P.RenderHelper.removeEventListener(t, "click", this.onMouseClickHandler), P.RenderHelper.removeEventListener(window, "resize", this.onWindowResizelHandler), P.RenderHelper.removeEventListener(window, "orientationchange", this.onOrientationChangeHandler);
          }, t.prototype.setPointerPosition = function (t) {
            this.pointers[t.pointerId] = {
              clientX: t.clientX,
              clientY: t.clientY
            };
          }, t.prototype.clearPointerPosition = function (t) {
            delete this.pointers[t.pointerId];
          }, t.prototype.onPointerUp = function (t) {
            this.clearPointerPosition(t), this.onMouseUp(t);
          }, t.prototype.onPointerMove = function (t) {
            (c.Browser.TouchUI && !S.EventUtils.isMousePointer(t) || S.EventUtils.isLeftButtonPressed(t)) && this.setPointerPosition(t), this.onDocumentMouseMove(t);
          }, t.prototype.onPointerCancel = function (t) {
            this.clearPointerPosition(t);
          }, t.prototype.onPointerLeave = function (t) {
            S.EventUtils.isMousePointer(t) && this.onMouseLeave(t), this.clearPointerPosition(t);
          }, t.prototype.onPointerDown = function (t) {
            var e = this;
            this.setPointerPosition(t), this.getPointerCount() > 2 && (this.pointers = {}), this.lockMouseMove(), this.input.lockFocus(), this.autoScroll.onMouseDown(t), this.lastDownMouseEvent = this.createDiagramMouseEvent(t), (0, u.raiseEvent)(t, this.lastDownMouseEvent, function (t) {
              return e.events.onMouseDown(t);
            }), this.events.canFinishTextEditing() && this.input.captureFocus(), S.EventUtils.isTouchEvent(t) && this.processTouchDown(t);
          }, t.prototype.onSvgMouseDown = function (t) {
            i.EvtUtils.preventEvent(t);
          }, t.prototype.onDocumentMouseMove = function (t) {
            var e = this;
            this.moveLocked || (this.autoScroll.onMouseMove(t, function () {
              return e.onMouseMoveCore(t);
            }), this.onMouseMoveCore(t), c.Browser.IE && this.lockMouseMove(), S.EventUtils.isTouchEvent(t) && this.processTouchMove(t));
          }, t.prototype.onSvgMouseMove = function (t) {
            i.EvtUtils.preventEventAndBubble(t);
          }, t.prototype.onMouseMoveCore = function (t) {
            var e = this;
            (0, u.raiseEvent)(t, this.createDiagramMouseEvent(t), function (t) {
              return e.events.onMouseMove(t);
            });
          }, t.prototype.onMouseUp = function (t) {
            var e = this;
            this.lockMouseMove();
            var n = this.createDiagramMouseEvent(t);
            (0, u.raiseEvent)(t, n, function (t) {
              return e.events.onMouseUp(t);
            }), this.autoScroll.onMouseUp(t), n.source.type !== o.MouseEventElementType.Undefined && this.input.captureFocus(!0), S.EventUtils.isTouchEvent(t) && this.processTouchUp(t);
          }, t.prototype.onMouseEnter = function (t) {
            var e = this;
            this.autoScroll.onMouseEnter(t), (0, u.raiseEvent)(t, this.createDiagramMouseEvent(t), function (t) {
              return e.events.onMouseEnter(t);
            });
          }, t.prototype.onMouseLeave = function (t) {
            var e = this;
            (0, u.raiseEvent)(t, this.createDiagramMouseEvent(t), function (t) {
              return e.events.onMouseLeave(t);
            });
          }, t.prototype.onMouseDblClick = function (t) {
            var e = this;
            (0, u.raiseEvent)(t, this.createDiagramMouseEvent(t), function (t) {
              return e.events.onDblClick(t);
            });
          }, t.prototype.onMouseClick = function (t) {
            var e = this;
            S.EventUtils.isTouchEvent(t) ? S.EventUtils.isMousePointer(t) || this.input.captureFocus() : (0, u.raiseEvent)(t, this.createActualMouseClickEvent(t), function (t) {
              return e.events.onClick(t);
            });
          }, t.prototype.createActualMouseClickEvent = function (t) {
            return this.lastDownMouseEvent ? new o.DiagramMouseEvent(this.lastDownMouseEvent.modifiers, this.lastDownMouseEvent.button, this.lastDownMouseEvent.offsetPoint.clone(), this.lastDownMouseEvent.modelPoint.clone(), this.lastDownMouseEvent.source, this.createDiagramMouseEventTouches(t)) : this.createDiagramMouseEvent(t);
          }, t.prototype.onContextMenu = function (t) {
            var e = this;
            if (this.contextMenuEnabled) return 1 !== t.buttons && (0, u.raiseEvent)(t, this.createDiagramContextMenuEvent(t), function (t) {
              return e.events.onContextMenu(t);
            }), this.input.captureFocus(), i.EvtUtils.preventEventAndBubble(t);
          }, t.prototype.processTouchDown = function (t) {
            var n = this;
            this.touchDownPoint = this.getTouchPointFromEvent(t), this.resetLongTouch(), this.longTouchTimer = setTimeout(function () {
              (0, u.raiseEvent)(t, n.createDiagramMouseEvent(t), function (t) {
                return n.events.onLongTouch(t);
              }), n.resetLongTouch(), n.resetDblClick();
            }, e.LONG_TOUCH_TIMEOUT);
          }, t.prototype.processTouchMove = function (e) {
            var n = this.getTouchPointFromEvent(e);
            this.touchDownPoint && n && (Math.abs(this.touchDownPoint.x - n.x) > t.touchPositionLimit || Math.abs(this.touchDownPoint.y - n.y) > t.touchPositionLimit) && (this.resetLongTouch(), this.resetDblClick());
          }, t.prototype.getPointers = function () {
            var t = this;
            return Object.keys(this.pointers).map(function (e) {
              return t.pointers[e];
            });
          }, t.prototype.getPointerCount = function () {
            return Object.keys(this.pointers).length;
          }, t.prototype.getTouchPointFromEvent = function (t) {
            var e,
              n = t.touches;
            if (n && n.length > 0) e = new s.Point(n[0].clientX, n[0].clientY);else {
              var o = this.getPointers();
              o.length && (e = new s.Point(o[0].clientX, o[0].clientY));
            }
            return e;
          }, t.prototype.processTouchUp = function (t) {
            var n = this;
            if (void 0 !== this.longTouchTimer) {
              (0, u.raiseEvent)(t, this.createDiagramMouseEvent(t), function (t) {
                return n.events.onClick(t);
              });
              var o = i.EvtUtils.getEventSource(t);
              void 0 !== this.dblTouchTimer && this.lastClickElement === o ? ((0, u.raiseEvent)(t, this.createDiagramMouseEvent(t), function (t) {
                return n.events.onDblClick(t);
              }), this.resetDblClick()) : (this.resetDblClick(), this.dblTouchTimer = setTimeout(function () {
                return n.dblTouchTimer = void 0;
              }, e.DBL_CLICK_TIMEOUT)), this.lastClickElement = o;
            }
            this.resetLongTouch(), this.touchDownPoint = void 0;
          }, t.prototype.resetLongTouch = function () {
            void 0 !== this.longTouchTimer && clearTimeout(this.longTouchTimer), this.longTouchTimer = void 0;
          }, t.prototype.resetDblClick = function () {
            void 0 !== this.dblTouchTimer && clearTimeout(this.dblTouchTimer), this.dblTouchTimer = void 0;
          }, t.prototype.onOrientationChange = function () {
            var t = this;
            setTimeout(function () {
              return t.onWindowResize();
            }, 100);
          }, t.prototype.onWindowResize = function () {
            var t = {
              horizontal: !1,
              vertical: !1
            };
            if (this.view.autoZoom !== l.AutoZoomMode.Disabled) t.horizontal = !0, t.vertical = !0;else {
              var e = this.view.checkFitToCanvas(),
                n = this.view.checkFitToCanvas(this.scroll.getSize());
              t = {
                horizontal: e.horizontal !== n.horizontal || n.horizontal,
                vertical: e.vertical !== n.vertical || n.vertical
              };
            }
            this.view.adjust(t);
          }, t.prototype.onMouseWheel = function (t) {
            var e = this;
            (0, u.raiseEvent)(t, this.createDiagramWheelEvent(t), function (t) {
              return e.events.onMouseWheel(t);
            });
          }, t.prototype.notifyModelSizeChanged = function (t, e) {
            this.view.notifyModelSizeChanged(t, e);
          }, t.prototype.notifyModelRectangleChanged = function (t) {
            this.view.notifyModelRectangleChanged(t);
          }, t.prototype.notifyReadOnlyChanged = function (t) {
            r.DomUtils.toggleClassName(this.mainElement, "dxdi-read-only", t);
          }, t.prototype.notifyDragStart = function (t) {}, t.prototype.notifyDragEnd = function (t) {}, t.prototype.notifyDragScrollStart = function () {
            this.autoScroll.onDragScrollStart();
          }, t.prototype.notifyDragScrollEnd = function () {
            this.autoScroll.onDragScrollEnd();
          }, t.prototype.notifyToolboxDragStart = function (t) {
            this.onMouseEnter(t);
          }, t.prototype.notifyToolboxDragEnd = function (t) {
            t && S.EventUtils.isPointerEvents() && this.onMouseUp(t);
          }, t.prototype.notifyToolboxDraggingMouseMove = function (t) {
            this.onDocumentMouseMove(t);
          }, t.prototype.createDiagramMouseEvent = function (t) {
            var e = a.KeyUtils.getKeyModifiers(t),
              n = function (t) {
                return c.Browser.MSTouchUI ? 2 !== t.button : S.EventUtils.isLeftButtonPressed(t);
              }(t) ? o.MouseButton.Left : o.MouseButton.Right,
              i = this.getOffsetPointByEvent(t),
              r = this.getModelPoint(i),
              s = S.EventUtils.isTouchEvent(t),
              u = this.getEventSource(t, s),
              p = this.createDiagramMouseEventTouches(t);
            return new o.DiagramMouseEvent(e, n, i, r, u, p, s);
          }, t.prototype.createDiagramMouseEventTouches = function (t) {
            var e = [];
            if (t.touches) for (var n = 0; n < t.touches.length; n++) {
              var i = t.touches[n].clientX,
                r = t.touches[n].clientY,
                s = this.getOffsetPointByEventPoint(i, r),
                a = this.getModelPoint(s);
              e.push(new o.DiagramMouseEventTouch(s, a));
            } else {
              var c = this.getPointers();
              for (n = 0; n < c.length; n++) {
                i = c[n].clientX, r = c[n].clientY, s = this.getOffsetPointByEventPoint(i, r), a = this.getModelPoint(s);
                e.push(new o.DiagramMouseEventTouch(s, a));
              }
            }
            return e;
          }, t.prototype.createDiagramContextMenuEvent = function (t) {
            var e = a.KeyUtils.getKeyModifiers(t),
              n = new s.Point(t.pageX, t.pageY),
              i = this.getOffsetPointByEvent(t),
              r = this.getModelPoint(i);
            return new o.DiagramContextMenuEvent(e, n, r);
          }, t.prototype.createDiagramWheelEvent = function (t) {
            var e = a.KeyUtils.getKeyModifiers(t),
              n = this.getOffsetPointByEvent(t),
              i = this.view.getModelPoint(n),
              r = this.getEventSource(t),
              s = t.deltaX || t.originalEvent && t.originalEvent.deltaX,
              c = t.deltaY || t.originalEvent && t.originalEvent.deltaY;
            return new o.DiagramWheelEvent(e, s, c, n, i, r);
          }, t.prototype.getEventSource = function (t, e) {
            var n = e ? i.EvtUtils.getEventSourceByPosition(t) : i.EvtUtils.getEventSource(t);
            if (this.isDiagramControl(n)) for (; n && !this.isDocumentContainer(n);) {
              var r = u.RenderUtils.getElementEventData(n);
              if (void 0 !== r) return r;
              if (this.input.isTextInputElement(n)) return new o.MouseEventSource(o.MouseEventElementType.Document);
              n = n.parentNode;
            }
            var s = new o.MouseEventSource(o.MouseEventElementType.Undefined);
            return n && this.isDocumentContainer(n) && (s.type = o.MouseEventElementType.Background), s;
          }, t.prototype.isDiagramControl = function (t) {
            for (; t;) {
              if (this.isDocumentContainer(t)) return !0;
              t = t.parentNode;
            }
            return !1;
          }, t.prototype.isDocumentContainer = function (t) {
            return t === this.mainElement;
          }, t.prototype.lockMouseMove = function () {
            var t = this;
            this.moveLocked = !0, this.lockMouseMoveTimer = setTimeout(function () {
              t.moveLocked = !1, t.lockMouseMoveTimer = -1;
            }, 10);
          }, t.prototype.killLockMouseMoveTimer = function () {
            -1 !== this.lockMouseMoveTimer && (clearTimeout(this.lockMouseMoveTimer), this.lockMouseMoveTimer = -1);
          }, t.prototype.clearLastMouseDownEvent = function () {
            this.lastDownMouseEvent = void 0;
          }, t.prototype.getModelPoint = function (t) {
            return this.view.getModelPoint(t);
          }, t.prototype.getOffsetPointByEvent = function (t) {
            var e = i.EvtUtils.getEventX(t),
              n = i.EvtUtils.getEventY(t);
            return this.getOffsetPointByEventPoint(e, n);
          }, t.prototype.getOffsetPointByEventPoint = function (t, e) {
            var n = this.scroll.getScrollContainer(),
              o = r.DomUtils.getAbsolutePositionX(n),
              i = r.DomUtils.getAbsolutePositionY(n);
            return new s.Point(t - o, e - i);
          }, t.prototype.getModelPointByEventPoint = function (t, e) {
            var n = this.getOffsetPointByEventPoint(t, e);
            return this.view.getModelPoint(n);
          }, t.prototype.getEventPointByModelPoint = function (t) {
            var e = this.view.getAbsolutePoint(t),
              n = this.scroll.getScrollContainer();
            return new s.Point(r.DomUtils.getAbsolutePositionX(n) + e.x, r.DomUtils.getAbsolutePositionY(n) + e.y);
          }, t.touchPositionLimit = 4, t;
        }();
        e.RenderManager = b;
      },
      4339: (t, e) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CommandBase = void 0;
        var n = function () {
          function t(t) {
            this.control = t;
          }
          return t.prototype.execute = function (t) {
            this.isPermissionsRequired && this.permissionsProvider.lockPermissions();
            var e = this.getState();
            if (this.isPermissionsRequired && this.permissionsProvider.unlockPermissions(), !e.enabled) return !1;
            this.control.beginUpdate();
            var n = !1;
            return n = this.isPermissionsRequired ? this.executeWithPermissions(e, t) : this.executeCore(e, t), this.control.endUpdate(), n && this.updateControlState(), n;
          }, t.prototype.executeWithPermissions = function (t, e) {
            var n = !1;
            return this.permissionsProvider.beginStorePermissions(), this.control.history.beginTransaction(), n = this.executeCore(t, e), this.permissionsProvider.isStoredPermissionsGranted() || (this.permissionsProvider.lockPermissions(), this.control.history.undoTransaction(), this.permissionsProvider.unlockPermissions(), n = !1), this.control.history.endTransaction(), this.permissionsProvider.endStorePermissions(), n;
          }, t.prototype.updateControlState = function () {
            this.lockInputPositionUpdating() || this.control.selection.inputPosition.reset(), this.lockUIUpdating() || this.control.barManager.updateItemsState();
          }, Object.defineProperty(t.prototype, "permissionsProvider", {
            get: function () {
              return this.control && this.control.permissionsProvider;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "isPermissionsRequired", {
            get: function () {
              return !1;
            },
            enumerable: !1,
            configurable: !0
          }), t.prototype.lockUIUpdating = function () {
            return !1;
          }, t.prototype.lockInputPositionUpdating = function () {
            return !1;
          }, t;
        }();
        e.CommandBase = n;
      },
      4385: (t, e) => {
        var n, o;
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ConnectorProperties = e.DEFAULT_CONNECTOR_ENDLINEENDING = e.DEFAULT_CONNECTOR_STARTLINEENDING = e.DEFAULT_CONNECTOR_LINEOPTION = e.ConnectorLineEnding = e.ConnectorLineOption = void 0, function (t) {
          t[t.Straight = 0] = "Straight", t[t.Orthogonal = 1] = "Orthogonal";
        }(n = e.ConnectorLineOption || (e.ConnectorLineOption = {})), function (t) {
          t[t.None = 0] = "None", t[t.Arrow = 1] = "Arrow", t[t.OutlinedTriangle = 2] = "OutlinedTriangle", t[t.FilledTriangle = 3] = "FilledTriangle";
        }(o = e.ConnectorLineEnding || (e.ConnectorLineEnding = {})), e.DEFAULT_CONNECTOR_LINEOPTION = n.Orthogonal, e.DEFAULT_CONNECTOR_STARTLINEENDING = o.None, e.DEFAULT_CONNECTOR_ENDLINEENDING = o.Arrow;
        var i = function () {
          function t() {
            this.lineOption = e.DEFAULT_CONNECTOR_LINEOPTION, this.startLineEnding = e.DEFAULT_CONNECTOR_STARTLINEENDING, this.endLineEnding = e.DEFAULT_CONNECTOR_ENDLINEENDING;
          }
          return t.prototype.clone = function () {
            var e = new t();
            return e.lineOption = this.lineOption, e.startLineEnding = this.startLineEnding, e.endLineEnding = this.endLineEnding, e;
          }, t.prototype.forEach = function (t) {
            for (var e in this) Object.prototype.hasOwnProperty.call(this, e) && t(e);
          }, t.prototype.toObject = function () {
            var t = {},
              n = !1;
            return this.lineOption !== e.DEFAULT_CONNECTOR_LINEOPTION && (t.lineOption = this.lineOption, n = !0), this.startLineEnding !== e.DEFAULT_CONNECTOR_STARTLINEENDING && (t.startLineEnding = this.startLineEnding, n = !0), this.endLineEnding !== e.DEFAULT_CONNECTOR_ENDLINEENDING && (t.endLineEnding = this.endLineEnding, n = !0), n ? t : null;
          }, t.prototype.fromObject = function (t) {
            "number" == typeof t.lineOption && (this.lineOption = t.lineOption), "number" == typeof t.startLineEnding && (this.startLineEnding = t.startLineEnding), "number" == typeof t.endLineEnding && (this.endLineEnding = t.endLineEnding);
          }, t;
        }();
        e.ConnectorProperties = i;
      },
      4412: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.RectangleDeviation = e.HitTestDeviation = e.Rectangle = void 0;
        var o,
          i = n(3393),
          r = n(2095),
          s = n(2871),
          a = n(5327),
          c = n(3844),
          u = function () {
            function t(t, e, n, o) {
              this.x = t, this.y = e, this.width = n, this.height = o;
            }
            return Object.defineProperty(t.prototype, "right", {
              get: function () {
                return this.x + this.width;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(t.prototype, "bottom", {
              get: function () {
                return this.y + this.height;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(t.prototype, "center", {
              get: function () {
                return t.center(this);
              },
              enumerable: !1,
              configurable: !0
            }), t.prototype.createRectangle = function () {
              return new t(this.x, this.y, this.width, this.height);
            }, t.prototype.createSize = function () {
              return new c.Size(this.width, this.height);
            }, t.prototype.createPosition = function () {
              return new a.Point(this.x, this.y);
            }, t.prototype.createVerticalInterval = function () {
              return new s.FixedInterval(this.y, this.height);
            }, t.prototype.createHorizontalInterval = function () {
              return new s.FixedInterval(this.x, this.width);
            }, t.fromGeometry = function (e, n) {
              return new t(e.x, e.y, n.width, n.height);
            }, t.fromPoints = function (e, n) {
              return new t(Math.min(e.x, n.x), Math.min(e.y, n.y), Math.abs(e.x - n.x), Math.abs(e.y - n.y));
            }, t.fromPositions = function (e, n, o, i) {
              return new t(Math.min(e, o), Math.min(n, i), Math.abs(o - e), Math.abs(i - n));
            }, t.fromCenter = function (e, n) {
              return new t(e.x - n, e.y - n, 2 * n, 2 * n);
            }, t.prototype.isCollapsed = function () {
              return 0 === this.width || 0 === this.height;
            }, t.prototype.isEmpty = function () {
              return 0 === this.x && 0 === this.y && 0 === this.width && 0 === this.height;
            }, t.prototype.toString = function () {
              return JSON.stringify(this);
            }, t.prototype.setPosition = function (t) {
              return this.x = t.x, this.y = t.y, this;
            }, t.prototype.setSize = function (t) {
              return this.width = t.width, this.height = t.height, this;
            }, t.prototype.setGeomerty = function (t) {
              return this.x = t.x, this.y = t.y, this.width = t.width, this.height = t.height, this;
            }, t.prototype.moveRectangle = function (t, e) {
              return this.x += t, this.y += e, this;
            }, t.prototype.moveRectangleByPoint = function (t) {
              return this.x += t.x, this.y += t.y, this;
            }, t.prototype.resize = function (t, e) {
              return this.width += t, this.height += e, this;
            }, t.prototype.nonNegativeSize = function () {
              return this.width < 0 && (this.width = 0), this.height < 0 && (this.height = 0), this;
            }, t.prototype.multiply = function (t, e) {
              return this.x *= t, this.y *= e, this.width *= t, this.height *= e, this;
            }, t.prototype.equals = function (e) {
              return t.equals(this, e);
            }, t.prototype.clone = function () {
              var e = new t(0, 0, 0, 0);
              return e.copyFrom(this), e;
            }, t.prototype.copyFrom = function (t) {
              this.x = t.x, this.y = t.y, this.width = t.width, this.height = t.height;
            }, t.prototype.containsPoint = function (e) {
              return t.containsPoint(this, e);
            }, t.prototype.containsRectangle = function (t) {
              return this.x <= t.x && this.right >= t.right && this.y <= t.y && this.bottom >= t.bottom;
            }, t.prototype.inflate = function (t, e) {
              return void 0 === e && (e = t), this.x -= t, this.y -= e, this.width += 2 * t, this.height += 2 * e, this;
            }, t.prototype.applyOffsetsInside = function (t) {
              return this.x += t.left, this.y += t.top, this.width -= t.left + t.right, this.height -= t.top + t.bottom, this;
            }, t.prototype.applyNormalizedOffsetsInside = function (t) {
              var e = Math.max(0, t.left),
                n = e + Math.max(0, t.right);
              0 !== n && (n <= this.width ? (this.x += e, this.width -= n) : (this.x += this.width * (e / n), this.width = 0));
              var o = Math.max(0, t.top),
                i = o + Math.max(0, t.bottom);
              return 0 !== i && (i <= this.height ? (this.y += o, this.height -= i) : (this.y += this.height * (o / i), this.height = 0)), this;
            }, t.prototype.applyOffsetsOutside = function (t) {
              return this.x -= t.left, this.y -= t.top, this.width += t.left + t.right, this.height += t.top + t.bottom, this;
            }, t.prototype.applyConverter = function (t) {
              return this.x = t(this.x), this.y = t(this.y), this.width = t(this.width), this.height = t(this.height), this;
            }, t.getHorizIntersection = function (t, e) {
              return r.IntervalAlgorithms.getIntersection(new s.FixedInterval(t.x, t.width), new s.FixedInterval(e.x, e.width));
            }, t.getVertIntersection = function (t, e) {
              return r.IntervalAlgorithms.getIntersection(new s.FixedInterval(t.y, t.height), new s.FixedInterval(e.y, e.height));
            }, t.getIntersection = function (e, n) {
              var o = r.IntervalAlgorithms.getIntersection(new s.FixedInterval(e.x, e.width), new s.FixedInterval(n.x, n.width));
              if (!o) return null;
              var i = r.IntervalAlgorithms.getIntersection(new s.FixedInterval(e.y, e.height), new s.FixedInterval(n.y, n.height));
              return i ? new t(o.start, i.start, o.length, i.length) : null;
            }, t.getHorNonCollapsedIntersection = function (e, n) {
              var o = t.getHorizIntersection(e, n);
              return o && !o.isCollapsed() ? o : null;
            }, t.getVertNonCollapsedIntersection = function (e, n) {
              var o = t.getVertIntersection(e, n);
              return o && !o.isCollapsed() ? o : null;
            }, t.getNonCollapsedIntersection = function (e, n) {
              var o = t.getIntersection(e, n);
              return o && !o.isCollapsed() ? o : null;
            }, t.areIntersected = function (t, e) {
              return !(t.x > e.x + e.width || e.x > t.x + t.width || t.y > e.y + e.height || e.y > t.y + t.height);
            }, t.union = function (e, n) {
              var o = Math.max(e.x + e.width, n.x + n.width),
                i = Math.max(e.y + e.height, n.y + n.height),
                r = Math.min(e.x, n.x),
                s = Math.min(e.y, n.y);
              return new t(r, s, o - r, i - s);
            }, t.equals = function (t, e) {
              return t.x === e.x && t.y === e.y && t.width === e.width && t.height === e.height;
            }, t.center = function (t) {
              return new a.Point(t.x + t.width / 2, t.y + t.height / 2);
            }, t.containsPoint = function (t, e) {
              var n = t.x + t.width,
                o = t.y + t.height;
              return e.y >= t.y && o >= e.y && e.x >= t.x && n >= e.x;
            }, t;
          }();
        e.Rectangle = u, function (t) {
          t[t.None = 0] = "None", t[t.Top = 1] = "Top", t[t.Bottom = 2] = "Bottom", t[t.Left = 4] = "Left", t[t.Right = 8] = "Right";
        }(o = e.HitTestDeviation || (e.HitTestDeviation = {}));
        var p = function () {
          function t(t, e) {
            this.initRectangle = t, this.initPoint = e, this.deviation = new i.Flag(o.None);
          }
          return t.prototype.calcDeviation = function () {
            return this.initPoint.x < this.initRectangle.x ? this.deviation.set(o.Left, !0) : this.initPoint.x > this.initRectangle.right && this.deviation.set(o.Right, !0), this.initPoint.y < this.initRectangle.y ? this.deviation.set(o.Top, !0) : this.initPoint.y > this.initRectangle.bottom && this.deviation.set(o.Bottom, !0), this;
          }, t.prototype.calcAdditionalParams = function () {
            return this.insidePoint = this.initPoint.clone(), this.offsetToInside = new a.Point(0, 0), this.deviation.get(o.Left) ? (this.insidePoint.x = this.initRectangle.x, this.offsetToInside.x = this.insidePoint.x - this.initPoint.x) : this.deviation.get(o.Right) && (this.insidePoint.x = this.initRectangle.right, this.offsetToInside.x = this.initPoint.x - this.insidePoint.x), this.deviation.get(o.Top) ? (this.insidePoint.y = this.initRectangle.y, this.offsetToInside.y = this.insidePoint.y - this.initPoint.y) : this.deviation.get(o.Bottom) && (this.insidePoint.y = this.initRectangle.bottom, this.offsetToInside.y = this.initPoint.y - this.insidePoint.y), this;
          }, t;
        }();
        e.RectangleDeviation = p;
      },
      4424: (t, e) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SimpleCommandState = void 0;
        var n = function (t, e, n, o, i) {
          this.visible = !0, this.denyUpdateValue = !1, this.enabled = t, this.value = e, this.items = o, this.visible = i, this.defaultValue = n;
        };
        e.SimpleCommandState = n;
      },
      4448: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.RedoCommand = void 0;
        var r = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(e, t), e.prototype.executeCore = function (t) {
            return this.control.beginUpdateCanvas(), this.permissionsProvider.lockPermissions(), this.control.history.redo(), this.permissionsProvider.unlockPermissions(), this.control.endUpdateCanvas(), !0;
          }, e.prototype.isEnabled = function () {
            return t.prototype.isEnabled.call(this) && this.control.history.canRedo();
          }, e;
        }(n(3913).SimpleCommandBase);
        e.RedoCommand = r;
      },
      4496: (t, e) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Metrics = void 0;
        var n = function () {
          function t() {}
          return t.euclideanDistance = function (t, e) {
            var n = t.x - e.x,
              o = t.y - e.y;
            return Math.sqrt(n * n + o * o);
          }, t.manhattanDistance = function (t, e) {
            return Math.abs(t.x - e.x) + Math.abs(t.y - e.y);
          }, t;
        }();
        e.Metrics = n;
      },
      4636: (t, e) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ShapeParameters = e.ShapeParameter = void 0;
        var n = function (t, e) {
          this.key = t, this.value = e;
        };
        e.ShapeParameter = n;
        var o = function () {
          function t() {
            this.items = {};
          }
          return t.prototype.addIfNotExists = function (t) {
            t.key in this.items || this.set(t);
          }, t.prototype.set = function (t) {
            this.items[t.key] = t;
          }, t.prototype.addRangeIfNotExists = function (t) {
            for (var e = 0; e < t.length; e++) this.addIfNotExists(t[e]);
          }, t.prototype.get = function (t) {
            return this.items[t];
          }, t.prototype.forEach = function (t) {
            for (var e in this.items) Object.prototype.hasOwnProperty.call(this.items, e) && t(this.items[e]);
          }, t.prototype.clone = function () {
            var e = new t();
            return this.forEach(function (t) {
              e.addIfNotExists(new n(t.key, t.value));
            }), e;
          }, t.prototype.toObject = function () {
            var t = {},
              e = !1;
            return this.forEach(function (n) {
              t[n.key] = {
                value: n.value
              }, e = !0;
            }), e ? t : null;
          }, t.prototype.fromObject = function (t) {
            this.forEach(function (e) {
              var n = t[e.key];
              n && "number" == typeof n.value && (e.value = n.value);
            });
          }, t;
        }();
        e.ShapeParameters = o;
      },
      4713: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ChangeShowGridCommand = void 0;
        var r = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(e, t), e.prototype.isEnabledInReadOnlyMode = function () {
            return !0;
          }, e.prototype.executeCore = function (t, e) {
            var n = void 0 === e ? !this.control.settings.showGrid : !!e;
            return this.control.settings.showGrid !== n && (this.control.settings.showGrid = n, !0);
          }, e.prototype.getValue = function () {
            return this.control.settings.showGrid;
          }, e;
        }(n(3913).SimpleCommandBase);
        e.ChangeShowGridCommand = r;
      },
      4715: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.UpdatePositionsOnPageResizeHistoryItem = void 0;
        var r = n(6320),
          s = n(8408),
          a = function (t) {
            function e(e) {
              var n = t.call(this) || this;
              return n.offset = e, n;
            }
            return i(e, t), e.prototype.redo = function (t) {
              var e = this;
              t.model.iterateItems(function (n) {
                n instanceof s.Shape && t.moveShape(n, e.applyOffset(n.position, e.offset.x, e.offset.y)), n instanceof r.Connector && t.changeConnectorPoints(n, function (t) {
                  return t.updatePointsOnPageResize(e.offset.x, e.offset.y);
                });
              });
            }, e.prototype.undo = function (t) {
              var e = this;
              t.model.iterateItems(function (n) {
                n instanceof s.Shape && t.moveShape(n, e.applyOffset(n.position, -e.offset.x, -e.offset.y)), n instanceof r.Connector && t.changeConnectorPoints(n, function (t) {
                  return t.updatePointsOnPageResize(-e.offset.x, -e.offset.y);
                });
              });
            }, e.prototype.applyOffset = function (t, e, n) {
              return t.clone().offset(e, n);
            }, e;
          }(n(2616).HistoryItem);
        e.UpdatePositionsOnPageResizeHistoryItem = a;
      },
      4717: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.PolygonShapeDescription = void 0;
        var r = n(1280),
          s = function (t) {
            function e(e) {
              var n = t.call(this, void 0, e) || this;
              return n.defaultSize.height = n.calculateHeight(r.ShapeDefaultDimension), n;
            }
            return i(e, t), Object.defineProperty(e.prototype, "keepRatioOnAutoSize", {
              get: function () {
                return !0;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "angle", {
              get: function () {
                return Math.PI * (this.angleCount - 2) / this.angleCount;
              },
              enumerable: !1,
              configurable: !0
            }), e;
          }(r.ShapeDescription);
        e.PolygonShapeDescription = s;
      },
      4762: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.PrimitiveObject = void 0;
        var o = n(9500),
          i = function () {
            function t(t) {
              this.style = t;
            }
            return Object.defineProperty(t.prototype, "strokeWidthPx", {
              get: function () {
                return this.style ? this.style.strokeWidthPx : 0;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(t.prototype, "strokeOffset", {
              get: function () {
                return this.style ? this.style.strokeOffset : 0;
              },
              enumerable: !1,
              configurable: !0
            }), t.prototype.getUnitVaue = function (t) {
              return "number" == typeof t ? o.UnitConverter.twipsToPixels(t).toString() : t;
            }, t.prototype.setUnitAttribute = function (t, e, n) {
              null != n && t.setAttribute(e, this.getUnitVaue(n));
            }, t.prototype.setPositionCorrectionAttribute = function (t) {
              var e = this.strokeWidthPx % 2 == 1 ? "translate(" + this.strokeOffset + ", " + this.strokeOffset + ")" : "";
              t.setAttribute("transform", e);
            }, t;
          }();
        e.PrimitiveObject = i;
      },
      4824: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.DiagramItem = e.DEFAULT_ZINDEX = e.ConnectionPointSide = void 0;
        var o,
          i = n(4412),
          r = n(4496),
          s = n(41),
          a = n(5059);
        !function (t) {
          t[t.Undefined = -1] = "Undefined", t[t.North = 0] = "North", t[t.East = 1] = "East", t[t.South = 2] = "South", t[t.West = 3] = "West";
        }(o = e.ConnectionPointSide || (e.ConnectionPointSide = {})), e.DEFAULT_ZINDEX = 0;
        var c = function () {
          function t() {
            this.key = void 0, this.dataKey = void 0, this.customData = void 0, this.attachedConnectors = [], this.zIndex = e.DEFAULT_ZINDEX, this.locked = !1, this.container = void 0, this.style = new a.Style(), this.styleText = new a.TextStyle();
          }
          return t.prototype.assign = function (t) {
            t.key = this.key, t.dataKey = this.dataKey, t.customData = s.ObjectUtils.cloneObject(this.customData), t.locked = this.locked, t.attachedConnectors = this.attachedConnectors.slice(), t.style = this.style.clone(), t.styleText = this.styleText.clone(), t.zIndex = this.zIndex, t.container = this.container;
          }, t.prototype.getConnectionPointPosition = function (t, e) {
            return this.getConnectionPoint(t, e).toPoint();
          }, t.prototype.getConnectionPoint = function (t, e) {
            t < 0 && e && (t = this.getNearestConnectionPoint(e));
            var n = this.getConnectionPoints();
            return n[t] || n[0];
          }, t.prototype.getNearestConnectionPoint = function (t) {
            var e,
              n = Number.MAX_VALUE;
            return this.getConnectionPoints().forEach(function (o, i) {
              var s = r.Metrics.euclideanDistance(o, t);
              s < n && (n = s, e = i);
            }), e;
          }, t.prototype.getConnectionPointIndex = function (t) {
            var e = this.getConnectionPoints();
            return e.reduce(function (n, i, r) {
              return t === o.North && i.y < e[n].y || t === o.South && i.y > e[n].y || t === o.West && i.x < e[n].x || t === o.East && i.x > e[n].x ? r : n;
            }, 0);
          }, t.prototype.getConnectionPointSideByIndex = function (t, e) {
            var n = this.getConnectionPoint(t, e);
            return this.getConnectionPointSide(n, e);
          }, t.prototype.getConnectionPointIndexForSide = function (t) {
            return t;
          }, Object.defineProperty(t.prototype, "enableText", {
            get: function () {
              return !0;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "allowEditText", {
            get: function () {
              return !0;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "hasTemplate", {
            get: function () {
              return !1;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "enableChildren", {
            get: function () {
              return !1;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "isLocked", {
            get: function () {
              return this.locked || this.container && this.container.isLocked;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "allowResizeHorizontally", {
            get: function () {
              return !1;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "allowResizeVertically", {
            get: function () {
              return !1;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "strokeWidth", {
            get: function () {
              return this.style.strokeWidth;
            },
            enumerable: !1,
            configurable: !0
          }), t.prototype.intersectedByRect = function (t) {
            return i.Rectangle.areIntersected(this.rectangle, t);
          }, t;
        }();
        e.DiagramItem = c;
      },
      4854: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.PasteSelectionCommand = void 0;
        var r = n(5327),
          s = n(5451),
          a = n(8408),
          c = n(6320),
          u = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), e.prototype.getEventPositionOffset = function (t, e) {
              var n = t.reduce(function (t, e) {
                var n = e instanceof a.Shape ? e.position.x : e instanceof c.Connector ? e.getMinX() : Number.MAX_VALUE,
                  o = e instanceof a.Shape ? e.position.y : e instanceof c.Connector ? e.getMinY() : Number.MAX_VALUE;
                return (o < t.y || o === t.y && n < t.x) && (t.topLeftItem = e, t.x = n, t.y = o), t;
              }, {
                topLeftItem: t[0],
                x: Number.MAX_VALUE,
                y: Number.MAX_VALUE
              }).topLeftItem;
              if (n instanceof a.Shape) {
                var o = this.getShapeCorrectedPosition(this.control.model, n);
                return new r.Point(o.x - n.position.x, o.y - n.position.y);
              }
              if (n instanceof c.Connector) {
                var i = this.getConnectorCorrectedPoints(this.control.model, n);
                return new r.Point(n.points[0].x - i[0].x, n.points[0].y - i[0].y);
              }
            }, e.prototype.getShapeCorrectedPosition = function (t, e) {
              for (var n = e.position.clone(); t.findShapeAtPosition(n);) n.offset(s.PasteSelectionCommandBase.positionOffset, s.PasteSelectionCommandBase.positionOffset);
              return n;
            }, e.prototype.getConnectorCorrectedPoints = function (t, e) {
              for (var n = e.points.map(function (t) {
                return t.clone();
              }); t.findConnectorAtPoints(n);) n.forEach(function (t) {
                t.x += s.PasteSelectionCommandBase.positionOffset, t.y += s.PasteSelectionCommandBase.positionOffset;
              });
              return n;
            }, e;
          }(s.PasteSelectionCommandBase);
        e.PasteSelectionCommand = u;
      },
      4856: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ConnectionPoint = void 0;
        var r = n(5327),
          s = n(4824),
          a = function (t) {
            function e(e, n, o) {
              void 0 === o && (o = s.ConnectionPointSide.Undefined);
              var i = t.call(this, e, n) || this;
              return i.side = o, i;
            }
            return i(e, t), e.prototype.offset = function (e, n) {
              return t.prototype.offset.call(this, e, n), this.side = s.ConnectionPointSide.Undefined, this;
            }, e.prototype.multiply = function (e, n) {
              return t.prototype.multiply.call(this, e, n), this.side = s.ConnectionPointSide.Undefined, this;
            }, e.prototype.clone = function () {
              return new e(this.x, this.y, this.side);
            }, e.prototype.toPoint = function () {
              return new r.Point(this.x, this.y);
            }, e;
          }(r.Point);
        e.ConnectionPoint = a;
      },
      4863: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.RightAngleConnectorRoutingContext = e.IntersectingItemsByPointsContext = e.CuttingItemsContext = void 0;
        var o = n(5327),
          i = n(476),
          r = n(4166),
          s = n(4824),
          a = n(618),
          c = n(6824),
          u = n(7804),
          p = n(1922),
          h = n(8671),
          l = n(4045),
          d = n(1188),
          f = n(41),
          y = n(3858),
          g = function () {
            function t() {
              this.cuttingItemKeys = [];
            }
            return Object.defineProperty(t.prototype, "isEmpty", {
              get: function () {
                return 0 === this.cuttingItemKeys.length;
              },
              enumerable: !1,
              configurable: !0
            }), t.prototype.registerShape = function (t, e, n) {
              return !!f.GeometryUtils.areSegmentsCutRectangle(n, e) && (this.cuttingItemKeys.push(t), !0);
            }, t;
          }();
        e.CuttingItemsContext = g;
        var m = function () {
          function t(t) {
            this.routingModel = t, this.trees = {};
          }
          return t.prototype.getItems = function (t, e) {
            return this.getOrCreateTree(e).search(t);
          }, t.prototype.getOrCreateTree = function (t) {
            if (!this.trees[t]) {
              this.trees[t] = new y.RTree();
              for (var e = this.routingModel.getItems(), n = 0, o = void 0; o = e[n]; n++) this.trees[t].insert(t ? o.rectangle.inflate(t, t) : o.rectangle, o);
            }
            return this.trees[t];
          }, t;
        }();
        e.IntersectingItemsByPointsContext = m;
        var v = function () {
          function t(t, e, n, o, i, r, s) {
            this.routingModel = t, this.points = e, this.supportRenderPoints = n, this.beginConnectionShape = o, this.endConnectionShape = i, this.beginConnectionSide = this.getConnectionSide(this.beginConnectionShape, r, this.beginPoint), this.endConnectionSide = this.getConnectionSide(this.endConnectionShape, s, this.endPoint), this.ignorableItemKeys = {}, this.cuttingShapesContext = new g(), this.intersectedItemsByPointsContext = new m(this.routingModel), this.isInvalidRenderSegments = !0;
          }
          return Object.defineProperty(t.prototype, "shapeMargins", {
            get: function () {
              return this.routingModel.shapeMargins;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "beginPoint", {
            get: function () {
              return this.points[0];
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "endPoint", {
            get: function () {
              return this.points[this.points.length - 1];
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "hasIntersecting", {
            get: function () {
              return !this.cuttingShapesContext.isEmpty;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "shouldCreateRenderPoints", {
            get: function () {
              return this.isInvalidRenderSegments || !this.isSmallPath && (this.hasIntersecting || this.isReversedStartConnection || this.isReversedEndConnection);
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "beginPathPoint", {
            get: function () {
              return this.beginConnectionSegment instanceof i.Segment ? this.beginConnectionSegment.startPoint : this.beginConnectionSegment;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "endPathPoint", {
            get: function () {
              return this.endConnectionSegment instanceof i.Segment ? this.endConnectionSegment.endPoint : this.endConnectionSegment;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "isReversedStartConnection", {
            get: function () {
              if (!this.beginConnectionShape || this.beginConnectionSide === s.ConnectionPointSide.Undefined) return !1;
              var t = this.beginConnectionSegment;
              return !(t instanceof o.Point) && this.isReversedConnectionSegment(this.supportSegments[0], t);
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "isReversedEndConnection", {
            get: function () {
              if (!this.endConnectionShape || this.endConnectionSide === s.ConnectionPointSide.Undefined) return !1;
              var t = this.endConnectionSegment;
              return !(t instanceof o.Point) && this.isReversedConnectionSegment(this.supportSegments[this.supportSegments.length - 1], t);
            },
            enumerable: !1,
            configurable: !0
          }), t.prototype.isReversedConnectionSegment = function (t, e) {
            return r.Vector.scalarProduct(r.Vector.fromSegment(t), r.Vector.fromPoints(e.startPoint, e.endPoint)) <= 0;
          }, Object.defineProperty(t.prototype, "isSmallPath", {
            get: function () {
              var t = 2 * this.routingModel.shapeMargins;
              return Math.abs(this.beginPathPoint.x - this.endPathPoint.x) < t && Math.abs(this.beginPathPoint.y - this.endPathPoint.y) < t;
            },
            enumerable: !1,
            configurable: !0
          }), t.prototype.initialize = function (t) {
            this.processContainers(t), this.processSupportSegments(), this.processIntersection(), this.processConnections(), this.processRenderSegments();
          }, t.prototype.setup = function () {
            this.processRoutingGrid(), this.processRoutingMetrics();
          }, t.prototype.createRoutedPoints = function (t, e, n) {
            var i = t instanceof o.Point ? t : t.endPoint,
              r = e instanceof o.Point ? e : e.startPoint,
              s = this.createAStarContext(i, r, n);
            d.AStarCalculator.calculate(s);
            var c = s.path;
            return this.addConnectionRoutedPoints(c, t, e), a.RightAngleConnectorRoutingMathOperations.unionPoints(c), c;
          }, t.prototype.getIntersectedItems = function (t, e) {
            var n = this;
            return this.intersectedItemsByPointsContext.getItems(t, e).filter(function (t) {
              return !n.isIgnorableItem(t);
            });
          }, t.prototype.validateRenderPoints = function (t) {
            this.isInvalidRenderSegments && (a.RightAngleConnectorRoutingMathOperations.unionPoints(t), p.ModelUtils.validateRenderPointIndexes(this.points, t, 0)), p.ModelUtils.skipUnnecessaryRightAngleRenderPoints(t);
          }, t.prototype.processContainers = function (t) {
            if (t && this.registerIgnorableShape(t), this.beginConnectionShape) {
              var e = this.beginConnectionShape.container;
              e && this.registerIgnorableShape(e);
            }
            if (this.endConnectionShape) {
              var n = this.endConnectionShape.container;
              n && this.registerIgnorableShape(n);
            }
          }, t.prototype.processSupportSegments = function () {
            this.supportSegments = this.createSupportSegments();
          }, t.prototype.processIntersection = function () {
            var t = this,
              e = this.routingModel.getItems();
            e && e.forEach(function (e) {
              var n = e.key,
                o = e.rectangle;
              t.cuttingShapesContext.registerShape(n, o, t.supportSegments) ? void 0 !== t.ignorableItemKeys[n] && delete t.ignorableItemKeys[n] : (!t.isConnectedByStart(e) && o.containsPoint(t.beginPoint) || !t.isConnectedByEnd(e) && o.containsPoint(t.endPoint)) && t.registerIgnorableShape(e);
            });
          }, t.prototype.processConnections = function () {
            var t = !1,
              e = !1;
            this.beginConnectionShape !== this.endConnectionShape && (t = this.shapeContainsOtherConnection(this.beginConnectionShape, this.endConnectionShape, this.endPoint), e = this.shapeContainsOtherConnection(this.endConnectionShape, this.beginConnectionShape, this.beginPoint), t && this.registerIgnorableShape(this.beginConnectionShape), e && this.registerIgnorableShape(this.endConnectionShape));
            var n = this.routingModel.shapeMargins;
            this.beginConnectionSegment = this.createBeginConnectionSegment(n, t), this.endConnectionSegment = this.createEndConnectionSegment(n, e);
          }, t.prototype.processRenderSegments = function () {
            this.isInvalidRenderSegments = !1, this.renderSegments = this.createRenderSegments();
            for (var t = 0; t < this.renderSegments.length - 1; t++) {
              var e = this.renderSegments[t],
                n = this.renderSegments[t + 1];
              if (e.endPoint.equals(n.startPoint)) return void (this.isInvalidRenderSegments = !0);
            }
          }, t.prototype.createGridPoints = function () {
            var t = [];
            return this.renderSegments.forEach(function (e) {
              return e.createGridPoints().forEach(function (e) {
                return t.push(e);
              });
            }), t;
          }, t.prototype.processRoutingGrid = function () {
            this.routingGrid = this.createGrid();
          }, t.prototype.processRoutingMetrics = function () {
            this.metrics = this.createAStarMetrics();
          }, t.prototype.createAStarMetrics = function () {
            return new h.AStarMetrics(new h.TurnDirectionMetrics(this.routingModel.penaltyDescription), new h.IntersectedShapesMetrics(new h.IntersectedShapeMetrics(this.routingModel.penaltyDescription, this.routingModel.shapeMargins)));
          }, t.prototype.createAStarContext = function (t, e, n) {
            return new l.AStarContext(this, t, e, n, this.routingGrid, this.metrics);
          }, t.prototype.addConnectionRoutedPoints = function (t, e, n) {
            e instanceof i.Segment && t.splice(0, 0, e.startPoint), n instanceof i.Segment && t.push(n.endPoint);
          }, t.prototype.createSupportSegments = function () {
            var t = this;
            return this.supportRenderPoints.length <= 1 ? [] : f.GeometryUtils.createSegments(this.supportRenderPoints).filter(function (e) {
              return !t.isCustomSegment(e, t.supportRenderPoints[0], t.supportRenderPoints[t.supportRenderPoints.length - 1]);
            });
          }, t.prototype.isCustomSegment = function (t, e, n) {
            var o = t.startPoint;
            if (o.equals(e)) return !1;
            var i = t.endPoint;
            return !i.equals(n) && i.pointIndex - o.pointIndex === 1;
          }, t.prototype.createRenderSegments = function () {
            var t = this,
              e = a.RightAngleConnectorRoutingMathOperations.createUnionSegments(this.supportSegments, function (e, n) {
                return t.shouldCreateSegment(e, n);
              }),
              n = e.length - 1;
            return e.map(function (e, i) {
              return new c.ConnectorRenderSegment(i > 0 ? new o.Point(e.startPoint.x, e.startPoint.y) : t.beginConnectionSegment, i < n ? new o.Point(e.endPoint.x, e.endPoint.y) : t.endConnectionSegment, e.startPoint.pointIndex, t.createPreviousCustomSegment(e.startPoint));
            });
          }, t.prototype.createPreviousCustomSegment = function (t) {
            var e = t.pointIndex - 1;
            return e >= 0 ? new i.Segment(this.points[e].clone(), new o.Point(t.x, t.y)) : void 0;
          }, t.prototype.shouldCreateSegment = function (t, e) {
            return !t.equals(e) || e.pointIndex > 0;
          }, t.prototype.isPathNormal = function (t) {
            return t === s.ConnectionPointSide.Undefined || a.RightAngleConnectorRoutingMathOperations.isSegmentNormal(new i.Segment(this.beginPoint, this.endPoint), t === s.ConnectionPointSide.East || t === s.ConnectionPointSide.West);
          }, t.prototype.registerIgnorableShape = function (t) {
            this.ignorableItemKeys[t.key] = !0;
          }, t.prototype.isConnectedByStart = function (t) {
            return this.beginConnectionShape && this.beginConnectionShape.key === t.key && this.beginConnectionSide !== s.ConnectionPointSide.Undefined;
          }, t.prototype.isConnectedByEnd = function (t) {
            return this.endConnectionShape && this.endConnectionShape.key === t.key && this.endConnectionSide !== s.ConnectionPointSide.Undefined;
          }, t.prototype.getConnectionSide = function (t, e, n) {
            return t ? t.getConnectionPointSideByIndex(e, n) : s.ConnectionPointSide.Undefined;
          }, t.prototype.shapeContainsOtherConnection = function (t, e, n) {
            if (!t) return !1;
            var o = t.rectangle;
            return o.containsPoint(n) && (!e || !e.rectangle.equals(o));
          }, t.prototype.createBeginConnectionSegment = function (t, e) {
            if (this.beginConnectionSide === s.ConnectionPointSide.Undefined) return this.createBeginConnectionSegmentCore(t);
            if (!e || !this.routingModel.shouldReverseConnections) {
              var n = this.createBeginConnectionSegmentCore(t);
              if (n instanceof o.Point || !this.routingModel.shouldResizeConnections) return n;
              for (var i = n.startPoint, r = n.endPoint, a = t; this.hasIntersectedItemsByPoint(r, i, this.beginConnectionShape);) a /= 2, r = (n = this.createBeginConnectionSegmentCore(a)).endPoint;
              return n;
            }
            if (!this.endConnectionShape) return this.createBeginConnectionSegmentCore(-t);
            if (this.isPathNormal(this.endConnectionSide)) return this.createBeginConnectionSegmentCore(-t);
            var c = this.createBeginConnectionSegmentCore(-2 * t);
            return this.isEndConnectionRectanleLineIntersected(c, !1, !0) ? this.createBeginConnectionSegmentCore(t) : this.createBeginConnectionSegmentCore(-t);
          }, t.prototype.hasIntersectedItemsByPoint = function (t, e, n) {
            return this.getIntersectedItems(t, 0).some(function (t) {
              return t.key !== n.key && !t.rectangle.containsPoint(e);
            });
          }, t.prototype.createEndConnectionSegment = function (t, e) {
            if (this.endConnectionSide === s.ConnectionPointSide.Undefined) return this.createEndConnectionSegmentCore(t);
            if (!e || !this.routingModel.shouldReverseConnections) {
              var n = this.createEndConnectionSegmentCore(t);
              if (n instanceof o.Point || !this.routingModel.shouldResizeConnections) return n;
              for (var i = n.endPoint, r = n.startPoint, a = t; this.hasIntersectedItemsByPoint(r, i, this.endConnectionShape);) a /= 2, r = (n = this.createEndConnectionSegmentCore(a)).startPoint;
              return n;
            }
            if (!this.beginConnectionShape) return this.createEndConnectionSegmentCore(-t);
            if (this.isPathNormal(this.beginConnectionSide)) return this.createEndConnectionSegmentCore(-t);
            var c = this.createEndConnectionSegmentCore(-2 * t);
            return this.isBeginConnectionRectanleLineIntersected(c, !0, !1) ? this.createEndConnectionSegmentCore(t) : this.createEndConnectionSegmentCore(-t);
          }, t.prototype.createBeginConnectionSegmentCore = function (t) {
            return a.RightAngleConnectorRoutingMathOperations.createBeginConnectionSegment(this.beginConnectionSide, this.beginPoint, t, function (t, e) {
              return new o.Point(t, e);
            });
          }, t.prototype.createEndConnectionSegmentCore = function (t) {
            return a.RightAngleConnectorRoutingMathOperations.createEndConnectionSegment(this.endConnectionSide, this.endPoint, t, function (t, e) {
              return new o.Point(t, e);
            });
          }, t.prototype.isBeginConnectionRectanleLineIntersected = function (t, e, n) {
            return a.RightAngleConnectorRoutingMathOperations.isConnectionRectanleLineIntersected(this.beginConnectionShape.rectangle, t, this.beginConnectionSide, e, n, function (t, e) {
              return new o.Point(t, e);
            });
          }, t.prototype.isEndConnectionRectanleLineIntersected = function (t, e, n) {
            return a.RightAngleConnectorRoutingMathOperations.isConnectionRectanleLineIntersected(this.endConnectionShape.rectangle, t, this.endConnectionSide, e, n, function (t, e) {
              return new o.Point(t, e);
            });
          }, t.prototype.isIgnorableItem = function (t) {
            return t.key in this.ignorableItemKeys;
          }, t.prototype.createExtendedShapesBounds = function () {
            var t = this;
            return this.routingModel.getItems().map(function (e) {
              return e.rectangle.clone().inflate(t.routingModel.shapeMargins);
            });
          }, t.prototype.createGrid = function () {
            return u.RoutingGrid.create(this.createGridPoints(), this.createExtendedShapesBounds(), function (t, e) {
              return new o.Point(t, e);
            });
          }, t;
        }();
        e.RightAngleConnectorRoutingContext = v;
      },
      4989: (t, e) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.StringUtils = void 0;
        var n = function () {
          function t() {}
          return t.isAlpha = function (t) {
            return t >= "a" && t <= "z" || t >= "A" && t <= "Z";
          }, t.isDigit = function (t) {
            return t >= "0" && t <= "9";
          }, t.stringHashCode = function (t) {
            var e = 0;
            if (0 === t.length) return e;
            for (var n = t.length, o = 0; o < n; o++) e = (e << 5) - e + t.charCodeAt(o), e |= 0;
            return e;
          }, t.endsAt = function (t, e) {
            var n = t.length - 1,
              o = e.length - 1,
              i = n - o;
            if (i < 0) return !1;
            for (; n >= i; n--, o--) if (t[n] !== e[o]) return !1;
            return !0;
          }, t.startsAt = function (t, e) {
            return t.substr(0, e.length) === e;
          }, t.stringInLowerCase = function (t) {
            return t.toLowerCase() === t;
          }, t.stringInUpperCase = function (t) {
            return t.toUpperCase() === t;
          }, t.atLeastOneSymbolInUpperCase = function (e) {
            for (var n = 0, o = void 0; o = e[n]; n++) if (t.stringInUpperCase(o) && !t.stringInLowerCase(o)) return !0;
            return !1;
          }, t.getSymbolFromEnd = function (t, e) {
            return t[t.length - e];
          }, t.trim = function (e, n) {
            if (void 0 === n) return t.trimInternal(e, !0, !0);
            var o = n.join("");
            return e.replace(new RegExp("(^[" + o + "]*)|([" + o + "]*$)", "g"), "");
          }, t.trimStart = function (e, n) {
            if (void 0 === n) return t.trimInternal(e, !0, !1);
            var o = n.join("");
            return e.replace(new RegExp("^[" + o + "]*", "g"), "");
          }, t.trimEnd = function (e, n) {
            if (void 0 === n) return t.trimInternal(e, !1, !0);
            var o = n.join("");
            return e.replace(new RegExp("[" + o + "]*$", "g"), "");
          }, t.getDecimalSeparator = function () {
            return 1.1.toLocaleString().substr(1, 1);
          }, t.repeat = function (t, e) {
            return new Array(e <= 0 ? 0 : e + 1).join(t);
          }, t.isNullOrEmpty = function (t) {
            return !t || !t.length;
          }, t.padLeft = function (e, n, o) {
            return t.repeat(o, Math.max(0, n - e.length)) + e;
          }, t.trimInternal = function (t, e, n) {
            var o = t.length;
            if (!o) return t;
            if (o < 764833) {
              var i = t;
              return e && (i = i.replace(/^\s+/, "")), n && (i = i.replace(/\s+$/, "")), i;
            }
            var r = 0;
            if (n) for (; o > 0 && /\s/.test(t[o - 1]);) o--;
            if (e && o > 0) for (; r < o && /\s/.test(t[r]);) r++;
            return t.substring(r, o);
          }, t;
        }();
        e.StringUtils = n;
      },
      5005: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ManualInputShapeDescription = void 0;
        var r = n(3190),
          s = n(3255),
          a = n(6208),
          c = n(4824),
          u = n(1280),
          p = function (t) {
            function e() {
              return t.call(this, void 0, !0) || this;
            }
            return i(e, t), Object.defineProperty(e.prototype, "key", {
              get: function () {
                return s.ShapeTypes.ManualInput;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "keepRatioOnAutoSize", {
              get: function () {
                return !1;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.createShapePrimitives = function (t) {
              var n = t.rectangle,
                o = n.x,
                i = n.y,
                r = n.right,
                s = n.bottom,
                c = i + n.height * e.slopeHeightRatio;
              return [new a.PathPrimitive([new a.PathPrimitiveMoveToCommand(o, c), new a.PathPrimitiveLineToCommand(r, i), new a.PathPrimitiveLineToCommand(r, s), new a.PathPrimitiveLineToCommand(o, s), new a.PathPrimitiveClosePathCommand()], t.style)];
            }, e.prototype.processConnectionPoint = function (t, n) {
              t.getConnectionPointSide(n) === c.ConnectionPointSide.North && (n.y += e.slopeHeightRatio / 2 * t.size.height);
            }, e.prototype.getTextRectangle = function (t) {
              var n = t.size.height * e.slopeHeightRatio;
              return t.rectangle.clone().moveRectangle(u.ShapeTextPadding, n).resize(2 * -u.ShapeTextPadding, -n - u.ShapeTextPadding).nonNegativeSize();
            }, e.slopeHeightRatio = .1, e;
          }(r.RectangleShapeDescription);
        e.ManualInputShapeDescription = p;
      },
      5031: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CommandManager = e.DiagramCommand = void 0;
        var o,
          i = n(2993),
          r = n(9198),
          s = n(4448),
          a = n(8022),
          c = n(195),
          u = n(1851),
          p = n(2638),
          h = n(7534),
          l = n(5351),
          d = n(9713),
          f = n(531),
          y = n(9675),
          g = n(8162),
          m = n(3188),
          v = n(1550),
          P = n(4276),
          C = n(9185),
          S = n(6537),
          x = n(1893),
          b = n(1917),
          w = n(7201),
          I = n(2198),
          T = n(8536),
          O = n(132),
          _ = n(2383),
          E = n(9784),
          M = n(7562),
          D = n(5162),
          A = n(4854),
          R = n(6389),
          j = n(2408),
          L = n(2748),
          N = n(4214),
          z = n(1998),
          U = n(871),
          k = n(3054),
          B = n(3591),
          H = n(7283),
          K = n(8827),
          V = n(3577),
          F = n(6800),
          W = n(8495),
          G = n(459),
          Z = n(1548),
          q = n(4713),
          X = n(4009),
          Y = n(9923),
          J = n(8192),
          Q = n(5496),
          $ = n(3039),
          tt = n(5441),
          et = n(7615),
          nt = n(5065),
          ot = n(1932),
          it = n(6435),
          rt = n(720),
          st = n(2899),
          at = n(3974),
          ct = n(3589),
          ut = n(728);
        !function (t) {
          t[t.Undo = 0] = "Undo", t[t.Redo = 1] = "Redo", t[t.Cut = 2] = "Cut", t[t.Copy = 3] = "Copy", t[t.Paste = 4] = "Paste", t[t.PasteInPosition = 5] = "PasteInPosition", t[t.SelectAll = 6] = "SelectAll", t[t.Delete = 7] = "Delete", t[t.Import = 8] = "Import", t[t.ImportBPMN = 9] = "ImportBPMN", t[t.Export = 10] = "Export", t[t.ExportSvg = 11] = "ExportSvg", t[t.ExportPng = 12] = "ExportPng", t[t.ExportJpg = 13] = "ExportJpg", t[t.BindDocument = 14] = "BindDocument", t[t.UnbindDocument = 15] = "UnbindDocument", t[t.Bold = 16] = "Bold", t[t.Italic = 17] = "Italic", t[t.Underline = 18] = "Underline", t[t.FontName = 19] = "FontName", t[t.FontSize = 20] = "FontSize", t[t.FontColor = 21] = "FontColor", t[t.FillColor = 22] = "FillColor", t[t.StrokeColor = 23] = "StrokeColor", t[t.TextLeftAlign = 24] = "TextLeftAlign", t[t.TextCenterAlign = 25] = "TextCenterAlign", t[t.TextRightAlign = 26] = "TextRightAlign", t[t.ConnectorLineOption = 27] = "ConnectorLineOption", t[t.ConnectorStartLineEnding = 28] = "ConnectorStartLineEnding", t[t.ConnectorEndLineEnding = 29] = "ConnectorEndLineEnding", t[t.BringToFront = 30] = "BringToFront", t[t.SendToBack = 31] = "SendToBack", t[t.MoveLeft = 32] = "MoveLeft", t[t.MoveStepLeft = 33] = "MoveStepLeft", t[t.MoveRight = 34] = "MoveRight", t[t.MoveStepRight = 35] = "MoveStepRight", t[t.MoveUp = 36] = "MoveUp", t[t.MoveStepUp = 37] = "MoveStepUp", t[t.MoveDown = 38] = "MoveDown", t[t.MoveStepDown = 39] = "MoveStepDown", t[t.CloneLeft = 40] = "CloneLeft", t[t.CloneRight = 41] = "CloneRight", t[t.CloneUp = 42] = "CloneUp", t[t.CloneDown = 43] = "CloneDown", t[t.AutoLayoutTree = 44] = "AutoLayoutTree", t[t.AutoLayoutFlow = 45] = "AutoLayoutFlow", t[t.AutoLayoutTreeVertical = 46] = "AutoLayoutTreeVertical", t[t.AutoLayoutTreeHorizontal = 47] = "AutoLayoutTreeHorizontal", t[t.AutoLayoutLayeredVertical = 48] = "AutoLayoutLayeredVertical", t[t.AutoLayoutLayeredHorizontal = 49] = "AutoLayoutLayeredHorizontal", t[t.Lock = 50] = "Lock", t[t.Unlock = 51] = "Unlock", t[t.Units = 52] = "Units", t[t.ViewUnits = 53] = "ViewUnits", t[t.PageSize = 54] = "PageSize", t[t.PageLandscape = 55] = "PageLandscape", t[t.PageColor = 56] = "PageColor", t[t.GridSize = 57] = "GridSize", t[t.ShowGrid = 58] = "ShowGrid", t[t.SnapToGrid = 59] = "SnapToGrid", t[t.ZoomLevel = 60] = "ZoomLevel", t[t.Fullscreen = 61] = "Fullscreen", t[t.ToggleSimpleView = 62] = "ToggleSimpleView", t[t.ToggleReadOnly = 63] = "ToggleReadOnly", t[t.EditShapeImage = 64] = "EditShapeImage", t[t.FitToScreen = 65] = "FitToScreen", t[t.SwitchAutoZoom = 66] = "SwitchAutoZoom", t[t.ToggleAutoZoom = 67] = "ToggleAutoZoom", t[t.FitToWidth = 68] = "FitToWidth", t[t.ZoomLevelItems = 69] = "ZoomLevelItems", t[t.GridSizeItems = 70] = "GridSizeItems", t[t.PageSizeItems = 71] = "PageSizeItems", t[t.ImportXML = 72] = "ImportXML", t[t.InsertShapeImage = 73] = "InsertShapeImage", t[t.DeleteShapeImage = 74] = "DeleteShapeImage", t[t.StrokeStyle = 75] = "StrokeStyle", t[t.StrokeWidth = 76] = "StrokeWidth", t[t.AutoLayoutTreeVerticalBottomToTop = 77] = "AutoLayoutTreeVerticalBottomToTop", t[t.AutoLayoutTreeHorizontalRightToLeft = 78] = "AutoLayoutTreeHorizontalRightToLeft", t[t.AutoLayoutLayeredVerticalBottomToTop = 79] = "AutoLayoutLayeredVerticalBottomToTop", t[t.AutoLayoutLayeredHorizontalRightToLeft = 80] = "AutoLayoutLayeredHorizontalRightToLeft", t[t.Zoom25 = 81] = "Zoom25", t[t.Zoom50 = 82] = "Zoom50", t[t.Zoom75 = 83] = "Zoom75", t[t.Zoom100 = 84] = "Zoom100", t[t.Zoom125 = 85] = "Zoom125", t[t.Zoom150 = 86] = "Zoom150", t[t.Zoom200 = 87] = "Zoom200", t[t.AutoZoomToContent = 88] = "AutoZoomToContent", t[t.AutoZoomToWidth = 89] = "AutoZoomToWidth", t[t.ZoomLevelInPercentage = 90] = "ZoomLevelInPercentage", t[t.ConnectorRoutingMode = 91] = "ConnectorRoutingMode";
        }(o = e.DiagramCommand || (e.DiagramCommand = {}));
        var pt = function () {
          function t(t) {
            this.commands = {}, this.shortcutsToCommand = {}, this.lastCommandsChain = [], this.executingCommandsChain = [], this.executingCommandCounter = 0, this.isPublicApiCall = !1, this.createCommand(t, o.Undo, r.UndoCommand, S.ModifierKey.Ctrl | S.KeyCode.Key_z, S.ModifierKey.Meta | S.KeyCode.Key_z), this.createCommand(t, o.Redo, s.RedoCommand, S.ModifierKey.Ctrl | S.KeyCode.Key_y, S.ModifierKey.Ctrl | S.ModifierKey.Shift | S.KeyCode.Key_z, S.ModifierKey.Meta | S.ModifierKey.Shift | S.KeyCode.Key_z), this.createCommand(t, o.Cut, D.CutSelectionCommand, S.KeyCode.Key_x | S.ModifierKey.Ctrl, S.KeyCode.Key_x | S.ModifierKey.Meta, S.KeyCode.Delete | S.ModifierKey.Shift), this.createCommand(t, o.Copy, M.CopySelectionCommand, S.KeyCode.Key_c | S.ModifierKey.Ctrl, S.KeyCode.Key_c | S.ModifierKey.Meta, S.KeyCode.Insert | S.ModifierKey.Ctrl), this.createCommand(t, o.Paste, A.PasteSelectionCommand), this.createCommand(t, o.PasteInPosition, $.PasteSelectionInPositionCommand), this.createCommand(t, o.SelectAll, C.SelectAllCommand, S.KeyCode.Key_a | S.ModifierKey.Ctrl, S.KeyCode.Key_a | S.ModifierKey.Meta), this.createCommand(t, o.Delete, i.DeleteCommand, S.KeyCode.Delete, S.KeyCode.Backspace), this.createCommand(t, o.Import, a.ImportCommand), this.createCommand(t, o.ImportBPMN, R.ImportBPMNCommand), this.createCommand(t, o.ImportXML, tt.ImportXMLCommand), this.createCommand(t, o.Export, c.ExportCommand), this.createCommand(t, o.ExportSvg, _.ExportSvgCommand), this.createCommand(t, o.ExportPng, O.ExportPngCommand), this.createCommand(t, o.ExportJpg, E.ExportJpgCommand), this.createCommand(t, o.BindDocument, k.BindDocumentCommand), this.createCommand(t, o.UnbindDocument, B.UnbindDocumentCommand), this.createCommand(t, o.Bold, u.ToggleFontBoldCommand, S.ModifierKey.Ctrl | S.KeyCode.Key_b, S.ModifierKey.Meta | S.KeyCode.Key_b), this.createCommand(t, o.Italic, p.ToggleFontItalicCommand, S.ModifierKey.Ctrl | S.KeyCode.Key_i, S.ModifierKey.Meta | S.KeyCode.Key_i), this.createCommand(t, o.Underline, h.ToggleFontUnderlineCommand, S.ModifierKey.Ctrl | S.KeyCode.Key_u, S.ModifierKey.Meta | S.KeyCode.Key_u), this.createCommand(t, o.FontName, l.ChangeFontNameCommand), this.createCommand(t, o.FontSize, d.ChangeFontSizeCommand), this.createCommand(t, o.FontColor, f.ChangeFontColorCommand), this.createCommand(t, o.FillColor, y.ChangeFillColorCommand), this.createCommand(t, o.StrokeColor, g.ChangeStrokeColorCommand), this.createCommand(t, o.StrokeStyle, ot.ChangeStrokeStyleCommand), this.createCommand(t, o.StrokeWidth, it.ChangeStrokeWidthCommand), this.createCommand(t, o.TextLeftAlign, m.TextLeftAlignCommand), this.createCommand(t, o.TextCenterAlign, m.TextCenterAlignCommand), this.createCommand(t, o.TextRightAlign, m.TextRightAlignCommand), this.createCommand(t, o.ConnectorLineOption, P.ChangeConnectorLineOptionCommand), this.createCommand(t, o.ConnectorStartLineEnding, v.ChangeConnectorStartLineEndingCommand), this.createCommand(t, o.ConnectorEndLineEnding, v.ChangeConnectorEndLineEndingCommand), this.createCommand(t, o.BringToFront, L.BringToFrontCommand), this.createCommand(t, o.SendToBack, j.SendToBackCommand), this.createCommand(t, o.MoveLeft, z.MoveLeftCommand, S.ModifierKey.Ctrl | S.KeyCode.Left, S.ModifierKey.Ctrl | S.ModifierKey.Shift | S.KeyCode.Left), this.createCommand(t, o.MoveRight, z.MoveRightCommand, S.ModifierKey.Ctrl | S.KeyCode.Right, S.ModifierKey.Ctrl | S.ModifierKey.Shift | S.KeyCode.Right), this.createCommand(t, o.MoveUp, z.MoveUpCommand, S.ModifierKey.Ctrl | S.KeyCode.Up, S.ModifierKey.Ctrl | S.ModifierKey.Shift | S.KeyCode.Up), this.createCommand(t, o.MoveDown, z.MoveDownCommand, S.ModifierKey.Ctrl | S.KeyCode.Down, S.ModifierKey.Ctrl | S.ModifierKey.Shift | S.KeyCode.Down), this.createCommand(t, o.MoveStepLeft, z.MoveStepLeftCommand, S.KeyCode.Left, S.ModifierKey.Shift | S.KeyCode.Left), this.createCommand(t, o.MoveStepRight, z.MoveStepRightCommand, S.KeyCode.Right, S.ModifierKey.Shift | S.KeyCode.Right), this.createCommand(t, o.MoveStepUp, z.MoveStepUpCommand, S.KeyCode.Up, S.ModifierKey.Shift | S.KeyCode.Up), this.createCommand(t, o.MoveStepDown, z.MoveStepDownCommand, S.KeyCode.Down, S.ModifierKey.Shift | S.KeyCode.Down), this.createCommand(t, o.CloneLeft, W.CloneLeftCommand, S.ModifierKey.Alt | S.KeyCode.Left, S.ModifierKey.Alt | S.ModifierKey.Shift | S.KeyCode.Left), this.createCommand(t, o.CloneRight, W.CloneRightCommand, S.ModifierKey.Alt | S.KeyCode.Right, S.ModifierKey.Alt | S.ModifierKey.Shift | S.KeyCode.Right), this.createCommand(t, o.CloneUp, W.CloneUpCommand, S.ModifierKey.Alt | S.KeyCode.Up, S.ModifierKey.Alt | S.ModifierKey.Shift | S.KeyCode.Up), this.createCommand(t, o.CloneDown, W.CloneDownCommand, S.ModifierKey.Alt | S.KeyCode.Down, S.ModifierKey.Alt | S.ModifierKey.Shift | S.KeyCode.Down), this.createCommand(t, o.Lock, V.LockCommand), this.createCommand(t, o.Unlock, F.UnLockCommand), this.createCommand(t, o.AutoLayoutTree, x.AutoLayoutTreeVerticalCommand), this.createCommand(t, o.AutoLayoutFlow, N.AutoLayoutLayeredHorizontalCommand), this.createCommand(t, o.Units, G.ChangeUnitsCommand), this.createCommand(t, o.ViewUnits, G.ChangeViewUnitsCommand), this.createCommand(t, o.PageSize, T.ChangePageSizeCommand), this.createCommand(t, o.PageLandscape, I.ChangePageLandscapeCommand), this.createCommand(t, o.PageColor, Z.ChangePageColorCommand), this.createCommand(t, o.GridSize, w.ChangeGridSizeCommand), this.createCommand(t, o.ShowGrid, q.ChangeShowGridCommand), this.createCommand(t, o.SnapToGrid, b.ChangeSnapToGridCommand), this.createCommand(t, o.ZoomLevel, U.ChangeZoomLevelCommand), this.createCommand(t, o.ZoomLevelInPercentage, U.ChangeZoomLevelInPercentageCommand), this.createCommand(t, o.AutoLayoutTreeVertical, x.AutoLayoutTreeVerticalCommand), this.createCommand(t, o.AutoLayoutTreeVerticalBottomToTop, rt.AutoLayoutTreeVerticalBottomToTopCommand), this.createCommand(t, o.AutoLayoutTreeHorizontal, H.AutoLayoutTreeHorizontalCommand), this.createCommand(t, o.AutoLayoutTreeHorizontalRightToLeft, st.AutoLayoutTreeHorizontalRightToLeftCommand), this.createCommand(t, o.AutoLayoutLayeredVertical, K.AutoLayoutLayeredVerticalCommand), this.createCommand(t, o.AutoLayoutLayeredVerticalBottomToTop, at.AutoLayoutLayeredVerticalBottomToTopCommand), this.createCommand(t, o.AutoLayoutLayeredHorizontal, N.AutoLayoutLayeredHorizontalCommand), this.createCommand(t, o.AutoLayoutLayeredHorizontalRightToLeft, ct.AutoLayoutLayeredHorizontalRightToLeftCommand), this.createCommand(t, o.Fullscreen, X.ToggleFullscreenCommand, S.KeyCode.F11), this.createCommand(t, o.ToggleSimpleView, Y.ToggleSimpleViewCommand), this.createCommand(t, o.ToggleReadOnly, J.ToggleReadOnlyCommand), this.createCommand(t, o.InsertShapeImage, et.InsertShapeImageCommand), this.createCommand(t, o.EditShapeImage, Q.EditShapeImageCommand), this.createCommand(t, o.DeleteShapeImage, nt.DeleteShapeImageCommand), this.createCommand(t, o.FitToScreen, U.FitToScreenCommand), this.createCommand(t, o.FitToWidth, U.FitToWidthCommand), this.createCommand(t, o.SwitchAutoZoom, U.SwitchAutoZoomCommand), this.createCommand(t, o.ToggleAutoZoom, U.ToggleAutoZoomCommand), this.createCommand(t, o.ZoomLevelItems, U.ChangeZoomLevelItemsCommand), this.createCommand(t, o.GridSizeItems, w.ChangeGridSizeItemsCommand), this.createCommand(t, o.PageSizeItems, T.ChangePageSizeItemsCommand), this.createCommand(t, o.Zoom25, U.ChangeZoomLevelTo25Command), this.createCommand(t, o.Zoom50, U.ChangeZoomLevelTo50Command), this.createCommand(t, o.Zoom75, U.ChangeZoomLevelTo75Command), this.createCommand(t, o.Zoom100, U.ChangeZoomLevelTo100Command), this.createCommand(t, o.Zoom125, U.ChangeZoomLevelTo125Command), this.createCommand(t, o.Zoom150, U.ChangeZoomLevelTo150Command), this.createCommand(t, o.Zoom200, U.ChangeZoomLevelTo200Command), this.createCommand(t, o.AutoZoomToContent, U.ToggleAutoZoomToContentCommand), this.createCommand(t, o.AutoZoomToWidth, U.ToggleAutoZoomToWidthCommand), this.createCommand(t, o.ConnectorRoutingMode, ut.ChangeConnectorRoutingModeCommand);
          }
          return t.prototype.getCommand = function (t) {
            return this.commands[t];
          }, t.prototype.beforeExecuting = function (t) {
            this.executingCommandsChain.push(t), this.executingCommandCounter++;
          }, t.prototype.afterExecuting = function () {
            this.executingCommandCounter--, 0 === this.executingCommandCounter && (this.lastCommandsChain = this.executingCommandsChain, this.executingCommandsChain = []);
          }, t.prototype.processShortcut = function (t) {
            var e = this.shortcutsToCommand[t];
            return !!e && e.execute();
          }, t.prototype.processPaste = function (t) {
            var e = this.getCommand(o.Paste);
            return e && e.isEnabled() && e.execute(t), !0;
          }, t.prototype.notifySelectionChanged = function (t) {
            this.lastCommandsChain = [];
          }, t.prototype.notifyScrollPositionChanged = function () {}, t.prototype.createCommand = function (t, e, n) {
            for (var o = [], i = 3; i < arguments.length; i++) o[i - 3] = arguments[i];
            this.commands[e] = new n(t);
            for (var r = 0; r < o.length; r++) {
              var s = o[r];
              "number" == typeof s && (this.shortcutsToCommand[s] = this.commands[e]);
            }
          }, t;
        }();
        e.CommandManager = pt;
      },
      5037: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.DiagramDraggingEvent = e.ToolboxDraggingObject = e.Toolbox = void 0;
        var o,
          i = n(41),
          r = n(5327),
          s = n(8451),
          a = n(2620),
          c = n(750),
          u = n(8424),
          p = n(8509),
          h = n(9922),
          l = "dxdi-toolbox",
          d = "dxdi-tb-start-drag-flag",
          f = function () {
            function t(t, e, n, r, s, a) {
              this.readOnly = e, this.allowDragging = n, this.shapeDescriptionManager = r, this.shapeTypes = s, this.getAllowedShapeTypes = a, this.dragPrepareTimeout = -1, this.dragState = o.None, this.emulateDragEvents = u.Browser.WebKitTouchUI, this.onDragOperation = new i.EventDispatcher(), this.onClickOperation = new i.EventDispatcher(), t && (this.mainElement = this.createMainElement(t), this.attachHandlers(this.mainElement));
            }
            return t.prototype.clean = function (t) {
              this.detachHandlers(this.mainElement), t && t(this.mainElement);
            }, t.prototype.createMainElement = function (t) {
              var e = document.createElement("div");
              return e.classList.add(l), u.Browser.AndroidMobilePlatform && e.classList.add("dxdi-nodrag"), e.draggable = !0, this.emulateDragEvents && (e.tabIndex = 0), t.appendChild(e), e;
            }, t.prototype.attachHandlers = function (t) {
              this.onElementMouseDownHandler = this.onElementMouseDown.bind(this), this.onElementMouseUpHandler = this.onElementMouseUp.bind(this), this.onMouseDownHandler = this.onMouseDown.bind(this), this.onMouseMoveHandler = this.onMouseMove.bind(this), this.onMouseUpHandler = this.onMouseUp.bind(this), this.onDragStartHandler = this.onDragStart.bind(this), this.onTouchMoveHandler = this.onTouchMove.bind(this), this.emulateDragEvents || p.RenderHelper.addEventListener(t, "dragstart", this.onDragStartHandler), i.EventUtils.isPointerEvents() ? (this.mouseDownEventName = "pointerdown", this.mouseMoveEventName = "pointermove", this.mouseUpEventName = "pointerup") : (this.mouseDownEventName = u.Browser.TouchUI ? "touchstart" : "mousedown", this.mouseMoveEventName = u.Browser.TouchUI ? "touchmove" : "mousemove", this.mouseUpEventName = u.Browser.TouchUI ? "touchend" : "mouseup"), p.RenderHelper.addEventListener(t, "touchmove", this.onTouchMoveHandler), p.RenderHelper.addEventListener(t, this.mouseDownEventName, this.onElementMouseDownHandler), p.RenderHelper.addEventListener(t, this.mouseUpEventName, this.onElementMouseUpHandler), p.RenderHelper.addEventListener(t, this.mouseDownEventName, this.onMouseDownHandler), p.RenderHelper.addEventListener(document, this.mouseMoveEventName, this.onMouseMoveHandler), p.RenderHelper.addEventListener(document, this.mouseUpEventName, this.onMouseUpHandler);
            }, t.prototype.detachHandlers = function (t) {
              this.emulateDragEvents || p.RenderHelper.removeEventListener(t, "dragstart", this.onDragStartHandler), p.RenderHelper.removeEventListener(t, "touchmove", this.onTouchMoveHandler), p.RenderHelper.removeEventListener(t, this.mouseDownEventName, this.onElementMouseDownHandler), p.RenderHelper.removeEventListener(t, this.mouseUpEventName, this.onElementMouseUpHandler), p.RenderHelper.removeEventListener(t, this.mouseDownEventName, this.onMouseDownHandler), p.RenderHelper.removeEventListener(document, this.mouseMoveEventName, this.onMouseMoveHandler), p.RenderHelper.removeEventListener(document, this.mouseUpEventName, this.onMouseUpHandler);
            }, t.prototype.render = function (t) {
              this.mainElement.childNodes && (this.mainElement.innerHTML = "");
              var e = this.shapeTypes;
              return e = this.getAllowedShapeTypes ? this.getAllowedShapeTypes(e) : e, (e = t ? e.filter(t) : e).length && this.createElements(this.mainElement, e), !!e.length;
            }, t.prototype.createDraggingObject = function (t) {
              var e = new g();
              return e.data = t, e.onFinishDragging = this.resetDragState.bind(this), e.onCaptured = this.capture.bind(this), new y(e);
            }, t.prototype.getDragShapeType = function (t) {
              for (; t && !c.DomUtils.hasClassName(t, l);) {
                if (t.getAttribute && t.getAttribute("data-tb-type")) return t.getAttribute("data-tb-type");
                t = t.parentNode;
              }
            }, t.prototype.getTouchPointFromEvent = function (t) {
              var e,
                n = t.touches;
              return n && n.length > 0 ? e = new r.Point(n[0].clientX, n[0].clientY) : t.clientX && t.clientY && (e = new r.Point(t.clientX, t.clientY)), e;
            }, t.prototype.onElementMouseDown = function (t) {
              this.mouseDownShapeType = this.getDragShapeType(s.EvtUtils.getEventSource(t)), this.touchDownPoint = this.getTouchPointFromEvent(t);
            }, t.prototype.onElementMouseUp = function (t) {
              var e = this.getDragShapeType(s.EvtUtils.getEventSource(t));
              e && e === this.mouseDownShapeType && this.onClickOperation.raise("notifyToolboxClick", e), this.mouseDownShapeType = void 0, this.touchDownPoint = void 0;
            }, t.prototype.onMouseDown = function (t) {
              this.setDragState(o.Prepare, t), u.Browser.TouchUI && i.EventUtils.isMousePointer(t) && this.setDragState(o.Start, t);
            }, t.prototype.onDragStart = function (t) {
              this.setDragState(o.Start, t), t.preventDefault();
            }, t.prototype.onTouchMove = function (t) {
              this.draggingObject && t.preventDefault();
            }, t.prototype.isLeftButtonPressed = function (t) {
              return s.EvtUtils.isLeftButtonPressed(t) || "pointermove" === t.type && u.Browser.TouchUI && u.Browser.MacOSMobilePlatform && i.EventUtils.isMousePointer(t);
            }, t.prototype.onMouseMove = function (t) {
              if (u.Browser.TouchUI && u.Browser.MacOSMobilePlatform) {
                var e = this.getTouchPointFromEvent(t);
                if (this.touchDownPoint && e && this.touchDownPoint.x === e.x && this.touchDownPoint.y === e.y) return;
              }
              this.setDragState(this.isLeftButtonPressed(t) ? o.Dragging : o.None, t), i.EventUtils.isPointerEvents() && this.raiseDraggingMouseMove(t);
            }, t.prototype.onMouseUp = function (t) {
              this.setDragState(o.None, t);
            }, t.prototype.updateDraggingElementPosition = function (t, e) {
              var n = this.draggingObject.element,
                o = t - n.offsetWidth / 2,
                i = e - n.offsetHeight / 2;
              (0, a.SetAbsoluteX)(n, o), (0, a.SetAbsoluteY)(n, i);
            }, t.prototype.setDragState = function (t, e) {
              if (!this.readOnly && this.allowDragging && !(t === o.None && t === this.dragState || (this.dragPrepareTimeout > -1 && (clearTimeout(this.dragPrepareTimeout), this.dragPrepareTimeout = -1, this.dragPrepareEvent = void 0), t - this.dragState > 1 || t !== o.None && t < this.dragState))) switch (this.dragState = t, t) {
                case o.Prepare:
                  this.prepareDragging(e) || this.setDragState(o.None, e), !this.emulateDragEvents && i.EventUtils.isMousePointer(e) || (this.dragPrepareTimeout = setTimeout(this.onDragPrepareTimeout.bind(this), 300), this.dragPrepareEvent = e);
                  break;
                case o.Start:
                  c.DomUtils.addClassName(document.body, "dxdi-dragging"), this.startDragging(e);
                  break;
                case o.Dragging:
                  this.doDragging(e);
                  break;
                case o.None:
                  this.finishDragging(e);
              }
            }, t.prototype.resetDragState = function () {
              this.setDragState(o.None, void 0);
            }, t.prototype.onDragPrepareTimeout = function () {
              this.dragPrepareTimeout = -1, this.dragState === o.Prepare && this.setDragState(o.Start, this.dragPrepareEvent), this.dragPrepareEvent = void 0;
            }, t.prototype.prepareDragging = function (t) {
              return this.dragStartPoint = new r.Point(s.EvtUtils.getEventX(t), s.EvtUtils.getEventY(t)), this.dragStartShapeType = this.getDragShapeType(s.EvtUtils.getEventSource(t)), i.EventUtils.isMousePointer(t) && c.DomUtils.addClassName(this.mainElement, d), !this.emulateDragEvents && i.EventUtils.isMousePointer(t) || i.HtmlFocusUtils.focusWithPreventScroll(this.mainElement), !!this.dragStartShapeType;
            }, t.prototype.startDragging = function (t) {
              this.draggingObject = this.createDraggingObject(this.dragStartShapeType), this.dragStartShapeType ? (this.raiseDragStart(t), this.draggingObject.element = this.createDraggingElement(this.draggingObject), void 0 !== this.draggingObject.captured && this.capture(this.draggingObject.captured, !0), this.updateDraggingElementPosition(this.dragStartPoint.x, this.dragStartPoint.y)) : c.DomUtils.addClassName(document.body, h.NOT_VALID_CSSCLASS);
            }, t.prototype.doDragging = function (t) {
              this.draggingObject.element && this.updateDraggingElementPosition(s.EvtUtils.getEventX(t), s.EvtUtils.getEventY(t));
            }, t.prototype.finishDragging = function (t) {
              if (this.draggingObject) {
                this.raiseDragEnd(t);
                var e = this.draggingObject.element;
                e && e.parentNode.removeChild(e), delete this.draggingObject;
              }
              this.dragStartPoint = void 0, this.dragStartShapeType = void 0, c.DomUtils.removeClassName(this.mainElement, d), c.DomUtils.removeClassName(document.body, h.NOT_VALID_CSSCLASS), setTimeout(function () {
                return c.DomUtils.removeClassName(document.body, "dxdi-dragging");
              }, 500);
            }, t.prototype.capture = function (t, e) {
              this.draggingObject && (this.draggingObject.captured !== t || e) && (this.draggingObject.captured = t, this.draggingObject.element && c.DomUtils.toggleClassName(this.draggingObject.element, "dxdi-tb-drag-captured", t));
            }, t.prototype.raiseDragStart = function (t) {
              this.onDragOperation.raise("notifyToolboxDragStart", t);
            }, t.prototype.raiseDragEnd = function (t) {
              this.onDragOperation.raise("notifyToolboxDragEnd", t);
            }, t.prototype.raiseDraggingMouseMove = function (t) {
              this.onDragOperation.raise("notifyToolboxDraggingMouseMove", t);
            }, t.prototype.notifyReadOnlyChanged = function (t) {
              this.readOnly = t;
            }, t;
          }();
        e.Toolbox = f, function (t) {
          t[t.None = -1] = "None", t[t.Prepare = 0] = "Prepare", t[t.Start = 1] = "Start", t[t.Dragging = 2] = "Dragging";
        }(o || (o = {}));
        var y = function (t) {
          this.evt = t;
        };
        e.ToolboxDraggingObject = y;
        var g = function () {};
        e.DiagramDraggingEvent = g;
      },
      5059: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.EmptyStyle = e.StrokeStyle = e.TextAlignment = e.TextStyle = e.Style = e.DEFAULT_STROKE_DASHARRAY = e.DEFAULT_STROKE_WIDTH = e.StyleBase = void 0;
        var r = n(9553),
          s = n(7768),
          a = n(9500),
          c = function () {
            function t() {
              this.createDefaultProperties();
            }
            return t.prototype.clone = function () {
              var t = this,
                e = this.createInstance();
              return this.forEach(function (n) {
                e[n] = t[n];
              }), e;
            }, t.prototype.forEach = function (t) {
              for (var e in this) Object.prototype.hasOwnProperty.call(this, e) && t(e);
            }, Object.defineProperty(t.prototype, "strokeWidthPx", {
              get: function () {
                return 0;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(t.prototype, "strokeWidth", {
              get: function () {
                return a.UnitConverter.pixelsToTwips(this.strokeWidthPx);
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(t.prototype, "strokeOffset", {
              get: function () {
                return .5;
              },
              enumerable: !1,
              configurable: !0
            }), t.prototype.toHash = function () {
              var t = this.toObject();
              return t ? Object.keys(t).map(function (e) {
                return e + "|" + t[e];
              }).join("") : "";
            }, t.prototype.toObject = function () {
              var t = this,
                e = {},
                n = !1,
                o = this.getDefaultInstance();
              return this.forEach(function (i) {
                t[i] !== o[i] && (e[i] = t[i], n = !0);
              }), n ? e : null;
            }, t.prototype.fromObject = function (t) {
              for (var e in t) if (Object.prototype.hasOwnProperty.call(t, e)) {
                var n = (0, s.isColorProperty)(e) ? r.ColorUtils.stringToHash(t[e]) : t[e];
                this[e] = n;
              }
            }, t;
          }();
        e.StyleBase = c, e.DEFAULT_STROKE_WIDTH = 2, e.DEFAULT_STROKE_DASHARRAY = "";
        var u = function (t) {
          function n() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(n, t), n.prototype.createInstance = function () {
            return new n();
          }, n.prototype.createDefaultProperties = function () {
            this.fill = "#ffffff", this.stroke = "#000000", this["stroke-width"] = e.DEFAULT_STROKE_WIDTH.toString(), this["stroke-dasharray"] = e.DEFAULT_STROKE_DASHARRAY;
          }, n.prototype.getDefaultInstance = function () {
            return n.defaultInstance;
          }, n.prototype.isDefaultStrokeDashArray = function () {
            return this["stroke-dasharray"] === e.DEFAULT_STROKE_DASHARRAY;
          }, n.prototype.resetStrokeDashArray = function () {
            this["stroke-dasharray"] = e.DEFAULT_STROKE_DASHARRAY;
          }, Object.defineProperty(n.prototype, "strokeWidthPx", {
            get: function () {
              return parseInt(this["stroke-width"]);
            },
            enumerable: !1,
            configurable: !0
          }), n.defaultInstance = new n(), n;
        }(c);
        e.Style = u;
        var p,
          h = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), e.prototype.createInstance = function () {
              return new e();
            }, e.prototype.createDefaultProperties = function () {
              this.fill = "#000000", this["font-family"] = "Arial", this["font-size"] = "10pt", this["font-weight"] = "", this["font-style"] = "", this["text-decoration"] = "", this["text-anchor"] = "middle";
            }, e.prototype.getDefaultInstance = function () {
              return e.defaultInstance;
            }, e.prototype.getAlignment = function () {
              switch (this["text-anchor"]) {
                case "left":
                  return p.Left;
                case "right":
                  return p.Right;
                default:
                  return p.Center;
              }
            }, e.defaultInstance = new e(), e;
          }(c);
        e.TextStyle = h, function (t) {
          t[t.Left = 0] = "Left", t[t.Right = 1] = "Right", t[t.Center = 2] = "Center";
        }(p = e.TextAlignment || (e.TextAlignment = {}));
        var l = function (t) {
          function e(e, n) {
            var o = t.call(this) || this;
            return o._strokeWidthPx = e, o._strokeOffset = n, o;
          }
          return i(e, t), e.prototype.createInstance = function () {
            return new e();
          }, e.prototype.createDefaultProperties = function () {}, e.prototype.getDefaultInstance = function () {
            return h.defaultInstance;
          }, Object.defineProperty(e.prototype, "strokeWidthPx", {
            get: function () {
              return this._strokeWidthPx || 0;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "strokeOffset", {
            get: function () {
              return this._strokeOffset || 0;
            },
            enumerable: !1,
            configurable: !0
          }), e.default1pxInstance = new e(1, .5), e.default1pxNegativeOffsetInstance = new e(1, -.5), e.default2pxInstance = new e(2), e;
        }(u);
        e.StrokeStyle = l;
        var d = function (t) {
          function e(e) {
            var n = t.call(this) || this;
            return e && Object.keys(e).forEach(function (t) {
              return n[t] = e[t];
            }), n;
          }
          return i(e, t), e.prototype.createInstance = function () {
            return new e();
          }, e.prototype.createDefaultProperties = function () {}, e.prototype.getDefaultInstance = function () {
            return h.defaultInstance;
          }, e.defaultInstance = new e(), e;
        }(u);
        e.EmptyStyle = d;
      },
      5065: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.DeleteShapeImageCommand = void 0;
        var r = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(e, t), e.prototype.isEnabled = function () {
            var e = this.getSelectedShape();
            return t.prototype.isEnabled.call(this) && !e.image.isEmpty;
          }, e.prototype.executeCore = function (e, n) {
            return t.prototype.executeCore.call(this, e, void 0);
          }, e;
        }(n(877).EditShapeImageCommandBase);
        e.DeleteShapeImageCommand = r;
      },
      5075: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.InputPositionProperties = void 0;
        var o = n(4385),
          i = n(5059),
          r = function () {
            function t(t, e, n) {
              this.selection = t, this.baseProperties = e, this.disableMergingStyles = n, this.selection = t;
            }
            return t.prototype.reset = function () {
              this.connectorProperties = null, this.style = null, this.textStyle = null;
            }, t.prototype.getConnectorProperties = function () {
              return this.connectorProperties || (this.connectorProperties = this.baseProperties ? this.baseProperties.getConnectorProperties().clone() : new o.ConnectorProperties(), this.updateConnectorProperties(this.connectorProperties)), this.connectorProperties;
            }, t.prototype.getConnectorPropertyValue = function (t) {
              return this.getConnectorProperties()[t];
            }, t.prototype.setConnectorPropertyValue = function (t, e) {
              this.getConnectorProperties()[t] = e;
            }, t.prototype.getStyle = function () {
              return this.style || (this.style = this.baseProperties ? this.baseProperties.getStyle().clone() : new i.Style(), this.disableMergingStyles || this.updateStyle(this.style, "style")), this.style;
            }, t.prototype.getStylePropertyValue = function (t) {
              return this.getStyle()[t];
            }, t.prototype.setStylePropertyValue = function (t, e) {
              this.getStyle()[t] = e;
            }, t.prototype.getTextStyle = function () {
              return this.textStyle || (this.textStyle = this.baseProperties ? this.baseProperties.getTextStyle().clone() : new i.TextStyle(), this.disableMergingStyles || this.updateStyle(this.textStyle, "styleText")), this.textStyle;
            }, t.prototype.getTextStylePropertyValue = function (t) {
              return this.getTextStyle()[t];
            }, t.prototype.setTextStylePropertyValue = function (t, e) {
              this.getTextStyle()[t] = e;
            }, t.prototype.updateConnectorProperties = function (t) {
              var e = this,
                n = this.selection.getSelectedConnectors(!0);
              t.forEach(function (o) {
                e.updatePropertyValue(t, n, function (t) {
                  return t.properties;
                }, o);
              });
            }, t.prototype.updateStyle = function (t, e) {
              var n = this,
                o = this.selection.getSelectedItems(!0);
              t.forEach(function (i) {
                n.updatePropertyValue(t, o, function (t) {
                  return t[e];
                }, i);
              });
            }, t.prototype.updatePropertyValue = function (t, e, n, o) {
              var i,
                r = !1;
              e.forEach(function (t) {
                var e = n(t)[o];
                if (void 0 === i && void 0 !== e) i = e, r = !0;else if (r && i !== e) return void (i = void 0);
              }), r && (t[o] = i);
            }, t;
          }();
        e.InputPositionProperties = r;
      },
      5094: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MouseHandlerSelectionState = void 0;
        var r = n(5428),
          s = n(4412),
          a = function (t) {
            function e(e, n, o) {
              var i = t.call(this, e) || this;
              return i.selection = n, i.visualizerManager = o, i;
            }
            return i(e, t), e.prototype.finish = function () {
              this.handler.raiseDragEnd([]), this.visualizerManager.resetSelectionRectangle(), t.prototype.finish.call(this);
            }, e.prototype.cancelChanges = function () {}, e.prototype.onMouseDown = function (t) {
              this.startPoint = t.modelPoint, this.handler.raiseDragStart([]);
            }, e.prototype.onMouseMove = function (t) {
              t.button !== r.MouseButton.Left ? this.handler.switchToDefaultState() : (this.rectangle = s.Rectangle.fromPoints(this.startPoint, t.modelPoint), this.visualizerManager.setSelectionRectangle(this.rectangle));
            }, e.prototype.onMouseUp = function (t) {
              void 0 !== this.rectangle ? this.selection.selectRect(this.rectangle) : this.selection.set([]), this.rectangle = void 0, this.handler.switchToDefaultState();
            }, e;
          }(n(9589).MouseHandlerCancellableState);
        e.MouseHandlerSelectionState = a;
      },
      5102: (t, e) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.PermissionRequestEventArgs = e.RequestedEntity = void 0;
        var n = function () {
          function t(t) {
            this.apiController = t;
          }
          return Object.defineProperty(t.prototype, "allowed", {
            get: function () {
              return this.eventArgs.allowed;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "updateUI", {
            get: function () {
              return this.eventArgs.updateUI;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "eventArgs", {
            get: function () {
              return this._eventArgs || (this._eventArgs = this.createEventArgs()), this._eventArgs;
            },
            enumerable: !1,
            configurable: !0
          }), t;
        }();
        e.RequestedEntity = n;
        var o = function () {
          this.allowed = !0, this.updateUI = !1;
        };
        e.PermissionRequestEventArgs = o;
      },
      5130: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ConnectorRoutingModel = e.ConnectorRoutingPenaltyDescription = void 0;
        var o = n(9307),
          i = n(8408),
          r = n(6320),
          s = n(4385),
          a = n(7003),
          c = function () {
            this.shape = 20, this.margin = 2, this.turnBack = 20, this.turnLeft = 3.1, this.turnRight = 3;
          };
        e.ConnectorRoutingPenaltyDescription = c;
        var u = function () {
          function t() {
            this.connectorRoutingMode = o.ConnectorRoutingMode.AllShapesOnly, this.shapeMargins = r.Connector.minOffset, this.shouldReverseConnections = !0, this.shouldResizeConnections = !0, this.penaltyDescription = new c();
          }
          return t.prototype.initialize = function (t) {
            this.model = t;
          }, t.prototype.createStrategy = function (t) {
            if (void 0 !== this.model && this.connectorRoutingMode !== o.ConnectorRoutingMode.None && t === s.ConnectorLineOption.Orthogonal) return new a.RightAngleConnectorRoutingStrategy(this);
          }, t.prototype.getItems = function () {
            return this.getShapes();
          }, t.prototype.notifyConnectorRoutingModeChanged = function (t) {
            this.connectorRoutingMode = t;
          }, t.prototype.getShapes = function () {
            return void 0 === this.model || void 0 === this.connectorRoutingMode || this.connectorRoutingMode === o.ConnectorRoutingMode.None ? [] : this.model.items.filter(function (t) {
              return t instanceof i.Shape;
            });
          }, t;
        }();
        e.ConnectorRoutingModel = u;
      },
      5148: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ContainerTargetVisualizer = e.ContainerTargetInfo = void 0;
        var r = n(2016),
          s = function (t, e) {
            this.rect = t, this.strokeWidth = e;
          };
        e.ContainerTargetInfo = s;
        var a = function (t) {
          function e(e) {
            return t.call(this, e) || this;
          }
          return i(e, t), e.prototype.raiseShow = function () {
            var t = this,
              e = new s(this.targetRect, this.targetStrokeWidth);
            this.dispatcher.raise1(function (n) {
              return n.notifyContainerTargetShow(t.key, e);
            });
          }, e.prototype.raiseHide = function () {
            this.dispatcher.raise1(function (t) {
              return t.notifyContainerTargetHide();
            });
          }, e;
        }(r.TargetVisualizerBase);
        e.ContainerTargetVisualizer = a;
      },
      5162: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CutSelectionCommand = void 0;
        var r = n(8762),
          s = n(1922),
          a = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), e.prototype.isEnabled = function () {
              var e = this.control.selection.getSelectedItems();
              return t.prototype.isEnabled.call(this) && e.length && (e.length > 1 || this.permissionsProvider.canDeleteItems(e));
            }, e.prototype.executeCore = function (t) {
              var e = new r.Exporter(),
                n = this.control.selection.getSelectedItems(!0, !0),
                o = e.exportItems(n);
              return this.permissionsProvider.beginDeleteItems(n), this.setClipboardData(o), s.ModelUtils.deleteSelection(this.control.history, this.control.model, this.control.selection), this.permissionsProvider.endDeleteItems(), !0;
            }, Object.defineProperty(e.prototype, "isPermissionsRequired", {
              get: function () {
                return !0;
              },
              enumerable: !1,
              configurable: !0
            }), e;
          }(n(1311).ClipboardCommand);
        e.CutSelectionCommand = a;
      },
      5206: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.DataSourceEdgeItem = e.DataSourceNodeItem = e.DataSourceItem = void 0;
        var r = n(6320),
          s = function (t, e, n) {
            this.sourceKey = t, this.key = e, this.dataObj = n;
          };
        e.DataSourceItem = s;
        var a = function (t) {
          function e(e, n, o, i, r, s, a, c) {
            var u = t.call(this, e, n, o) || this;
            return u.type = i, u.text = r, u.parentDataObj = s, u.containerKey = a, u.containerDataObj = c, u;
          }
          return i(e, t), e;
        }(s);
        e.DataSourceNodeItem = a;
        var c = function (t) {
          function e(e, n, o, i, r) {
            var s = t.call(this, e, n, o) || this;
            return s.sourceKey = e, s.from = i, s.to = r, s;
          }
          return i(e, t), Object.defineProperty(e.prototype, "text", {
            get: function () {
              return this.texts && this.texts[r.CONNECTOR_DEFAULT_TEXT_POSITION];
            },
            enumerable: !1,
            configurable: !0
          }), e;
        }(s);
        e.DataSourceEdgeItem = c;
      },
      5215: (t, e, n) => {
        n.r(e), n.d(e, {
          __assign: () => r,
          __asyncDelegator: () => S,
          __asyncGenerator: () => C,
          __asyncValues: () => x,
          __await: () => P,
          __awaiter: () => p,
          __classPrivateFieldGet: () => O,
          __classPrivateFieldSet: () => _,
          __createBinding: () => l,
          __decorate: () => a,
          __exportStar: () => d,
          __extends: () => i,
          __generator: () => h,
          __importDefault: () => T,
          __importStar: () => I,
          __makeTemplateObject: () => b,
          __metadata: () => u,
          __param: () => c,
          __read: () => y,
          __rest: () => s,
          __spread: () => g,
          __spreadArray: () => v,
          __spreadArrays: () => m,
          __values: () => f
        });
        var o = function (t, e) {
          return o = Object.setPrototypeOf || {
            __proto__: []
          } instanceof Array && function (t, e) {
            t.__proto__ = e;
          } || function (t, e) {
            for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
          }, o(t, e);
        };
        function i(t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
          function n() {
            this.constructor = t;
          }
          o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
        }
        var r = function () {
          return r = Object.assign || function (t) {
            for (var e, n = 1, o = arguments.length; n < o; n++) for (var i in e = arguments[n]) Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
            return t;
          }, r.apply(this, arguments);
        };
        function s(t, e) {
          var n = {};
          for (var o in t) Object.prototype.hasOwnProperty.call(t, o) && e.indexOf(o) < 0 && (n[o] = t[o]);
          if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
            var i = 0;
            for (o = Object.getOwnPropertySymbols(t); i < o.length; i++) e.indexOf(o[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, o[i]) && (n[o[i]] = t[o[i]]);
          }
          return n;
        }
        function a(t, e, n, o) {
          var i,
            r = arguments.length,
            s = r < 3 ? e : null === o ? o = Object.getOwnPropertyDescriptor(e, n) : o;
          if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) s = Reflect.decorate(t, e, n, o);else for (var a = t.length - 1; a >= 0; a--) (i = t[a]) && (s = (r < 3 ? i(s) : r > 3 ? i(e, n, s) : i(e, n)) || s);
          return r > 3 && s && Object.defineProperty(e, n, s), s;
        }
        function c(t, e) {
          return function (n, o) {
            e(n, o, t);
          };
        }
        function u(t, e) {
          if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(t, e);
        }
        function p(t, e, n, o) {
          return new (n || (n = Promise))(function (i, r) {
            function s(t) {
              try {
                c(o.next(t));
              } catch (t) {
                r(t);
              }
            }
            function a(t) {
              try {
                c(o.throw(t));
              } catch (t) {
                r(t);
              }
            }
            function c(t) {
              var e;
              t.done ? i(t.value) : (e = t.value, e instanceof n ? e : new n(function (t) {
                t(e);
              })).then(s, a);
            }
            c((o = o.apply(t, e || [])).next());
          });
        }
        function h(t, e) {
          var n,
            o,
            i,
            r,
            s = {
              label: 0,
              sent: function () {
                if (1 & i[0]) throw i[1];
                return i[1];
              },
              trys: [],
              ops: []
            };
          return r = {
            next: a(0),
            throw: a(1),
            return: a(2)
          }, "function" == typeof Symbol && (r[Symbol.iterator] = function () {
            return this;
          }), r;
          function a(r) {
            return function (a) {
              return function (r) {
                if (n) throw new TypeError("Generator is already executing.");
                for (; s;) try {
                  if (n = 1, o && (i = 2 & r[0] ? o.return : r[0] ? o.throw || ((i = o.return) && i.call(o), 0) : o.next) && !(i = i.call(o, r[1])).done) return i;
                  switch (o = 0, i && (r = [2 & r[0], i.value]), r[0]) {
                    case 0:
                    case 1:
                      i = r;
                      break;
                    case 4:
                      return s.label++, {
                        value: r[1],
                        done: !1
                      };
                    case 5:
                      s.label++, o = r[1], r = [0];
                      continue;
                    case 7:
                      r = s.ops.pop(), s.trys.pop();
                      continue;
                    default:
                      if (!(i = s.trys, (i = i.length > 0 && i[i.length - 1]) || 6 !== r[0] && 2 !== r[0])) {
                        s = 0;
                        continue;
                      }
                      if (3 === r[0] && (!i || r[1] > i[0] && r[1] < i[3])) {
                        s.label = r[1];
                        break;
                      }
                      if (6 === r[0] && s.label < i[1]) {
                        s.label = i[1], i = r;
                        break;
                      }
                      if (i && s.label < i[2]) {
                        s.label = i[2], s.ops.push(r);
                        break;
                      }
                      i[2] && s.ops.pop(), s.trys.pop();
                      continue;
                  }
                  r = e.call(t, s);
                } catch (t) {
                  r = [6, t], o = 0;
                } finally {
                  n = i = 0;
                }
                if (5 & r[0]) throw r[1];
                return {
                  value: r[0] ? r[1] : void 0,
                  done: !0
                };
              }([r, a]);
            };
          }
        }
        var l = Object.create ? function (t, e, n, o) {
          void 0 === o && (o = n), Object.defineProperty(t, o, {
            enumerable: !0,
            get: function () {
              return e[n];
            }
          });
        } : function (t, e, n, o) {
          void 0 === o && (o = n), t[o] = e[n];
        };
        function d(t, e) {
          for (var n in t) "default" === n || Object.prototype.hasOwnProperty.call(e, n) || l(e, t, n);
        }
        function f(t) {
          var e = "function" == typeof Symbol && Symbol.iterator,
            n = e && t[e],
            o = 0;
          if (n) return n.call(t);
          if (t && "number" == typeof t.length) return {
            next: function () {
              return t && o >= t.length && (t = void 0), {
                value: t && t[o++],
                done: !t
              };
            }
          };
          throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
        }
        function y(t, e) {
          var n = "function" == typeof Symbol && t[Symbol.iterator];
          if (!n) return t;
          var o,
            i,
            r = n.call(t),
            s = [];
          try {
            for (; (void 0 === e || e-- > 0) && !(o = r.next()).done;) s.push(o.value);
          } catch (t) {
            i = {
              error: t
            };
          } finally {
            try {
              o && !o.done && (n = r.return) && n.call(r);
            } finally {
              if (i) throw i.error;
            }
          }
          return s;
        }
        function g() {
          for (var t = [], e = 0; e < arguments.length; e++) t = t.concat(y(arguments[e]));
          return t;
        }
        function m() {
          for (var t = 0, e = 0, n = arguments.length; e < n; e++) t += arguments[e].length;
          var o = Array(t),
            i = 0;
          for (e = 0; e < n; e++) for (var r = arguments[e], s = 0, a = r.length; s < a; s++, i++) o[i] = r[s];
          return o;
        }
        function v(t, e, n) {
          if (n || 2 === arguments.length) for (var o, i = 0, r = e.length; i < r; i++) !o && i in e || (o || (o = Array.prototype.slice.call(e, 0, i)), o[i] = e[i]);
          return t.concat(o || Array.prototype.slice.call(e));
        }
        function P(t) {
          return this instanceof P ? (this.v = t, this) : new P(t);
        }
        function C(t, e, n) {
          if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
          var o,
            i = n.apply(t, e || []),
            r = [];
          return o = {}, s("next"), s("throw"), s("return"), o[Symbol.asyncIterator] = function () {
            return this;
          }, o;
          function s(t) {
            i[t] && (o[t] = function (e) {
              return new Promise(function (n, o) {
                r.push([t, e, n, o]) > 1 || a(t, e);
              });
            });
          }
          function a(t, e) {
            try {
              (n = i[t](e)).value instanceof P ? Promise.resolve(n.value.v).then(c, u) : p(r[0][2], n);
            } catch (t) {
              p(r[0][3], t);
            }
            var n;
          }
          function c(t) {
            a("next", t);
          }
          function u(t) {
            a("throw", t);
          }
          function p(t, e) {
            t(e), r.shift(), r.length && a(r[0][0], r[0][1]);
          }
        }
        function S(t) {
          var e, n;
          return e = {}, o("next"), o("throw", function (t) {
            throw t;
          }), o("return"), e[Symbol.iterator] = function () {
            return this;
          }, e;
          function o(o, i) {
            e[o] = t[o] ? function (e) {
              return (n = !n) ? {
                value: P(t[o](e)),
                done: "return" === o
              } : i ? i(e) : e;
            } : i;
          }
        }
        function x(t) {
          if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
          var e,
            n = t[Symbol.asyncIterator];
          return n ? n.call(t) : (t = f(t), e = {}, o("next"), o("throw"), o("return"), e[Symbol.asyncIterator] = function () {
            return this;
          }, e);
          function o(n) {
            e[n] = t[n] && function (e) {
              return new Promise(function (o, i) {
                (function (t, e, n, o) {
                  Promise.resolve(o).then(function (e) {
                    t({
                      value: e,
                      done: n
                    });
                  }, e);
                })(o, i, (e = t[n](e)).done, e.value);
              });
            };
          }
        }
        function b(t, e) {
          return Object.defineProperty ? Object.defineProperty(t, "raw", {
            value: e
          }) : t.raw = e, t;
        }
        var w = Object.create ? function (t, e) {
          Object.defineProperty(t, "default", {
            enumerable: !0,
            value: e
          });
        } : function (t, e) {
          t.default = e;
        };
        function I(t) {
          if (t && t.__esModule) return t;
          var e = {};
          if (null != t) for (var n in t) "default" !== n && Object.prototype.hasOwnProperty.call(t, n) && l(e, t, n);
          return w(e, t), e;
        }
        function T(t) {
          return t && t.__esModule ? t : {
            default: t
          };
        }
        function O(t, e, n, o) {
          if ("a" === n && !o) throw new TypeError("Private accessor was defined without a getter");
          if ("function" == typeof e ? t !== e || !o : !e.has(t)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
          return "m" === n ? o : "a" === n ? o.call(t) : o ? o.value : e.get(t);
        }
        function _(t, e, n, o, i) {
          if ("m" === o) throw new TypeError("Private method is not writable");
          if ("a" === o && !i) throw new TypeError("Private accessor was defined without a setter");
          if ("function" == typeof e ? t !== e || !i : !e.has(t)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
          return "a" === o ? i.call(t, n) : i ? i.value = n : e.set(t, n), n;
        }
      },
      5225: (t, e) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.DiagramModelOperation = e.ModelOperationSettings = void 0;
        var n = function () {
          function t() {
            this._addShape = !0, this._addShapeFromToolbox = !0, this._deleteShape = !0, this._deleteConnector = !0, this._changeConnection = !0, this._changeConnectorPoints = !0, this._changeShapeText = !0, this._changeConnectorText = !0, this._resizeShape = !0, this._moveShape = !0;
          }
          return Object.defineProperty(t.prototype, "addShape", {
            get: function () {
              return this._addShape;
            },
            set: function (t) {
              t !== this._addShape && (this._addShape = t);
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "addShapeFromToolbox", {
            get: function () {
              return this._addShapeFromToolbox;
            },
            set: function (t) {
              t !== this._addShapeFromToolbox && (this._addShapeFromToolbox = t);
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "deleteShape", {
            get: function () {
              return this._deleteShape;
            },
            set: function (t) {
              t !== this._deleteShape && (this._deleteShape = t);
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "deleteConnector", {
            get: function () {
              return this._deleteConnector;
            },
            set: function (t) {
              t !== this._deleteConnector && (this._deleteConnector = t);
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "changeConnection", {
            get: function () {
              return this._changeConnection;
            },
            set: function (t) {
              t !== this._changeConnection && (this._changeConnection = t);
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "changeConnectorPoints", {
            get: function () {
              return this._changeConnectorPoints;
            },
            set: function (t) {
              t !== this._changeConnectorPoints && (this._changeConnectorPoints = t);
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "changeShapeText", {
            get: function () {
              return this._changeShapeText;
            },
            set: function (t) {
              t !== this._changeShapeText && (this._changeShapeText = t);
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "changeConnectorText", {
            get: function () {
              return this._changeConnectorText;
            },
            set: function (t) {
              t !== this._changeConnectorText && (this._changeConnectorText = t);
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "resizeShape", {
            get: function () {
              return this._resizeShape;
            },
            set: function (t) {
              t !== this._resizeShape && (this._resizeShape = t);
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "moveShape", {
            get: function () {
              return this._moveShape;
            },
            set: function (t) {
              t !== this._moveShape && (this._moveShape = t);
            },
            enumerable: !1,
            configurable: !0
          }), t.prototype.applySettings = function (t) {
            t && ("boolean" == typeof t.addShape && (this.addShape = t.addShape), "boolean" == typeof t.addShapeFromToolbox && (this.addShapeFromToolbox = t.addShapeFromToolbox), "boolean" == typeof t.deleteShape && (this.deleteShape = t.deleteShape), "boolean" == typeof t.deleteConnector && (this.deleteConnector = t.deleteConnector), "boolean" == typeof t.changeConnection && (this.changeConnection = t.changeConnection), "boolean" == typeof t.changeConnectorPoints && (this.changeConnectorPoints = t.changeConnectorPoints), "boolean" == typeof t.changeShapeText && (this.changeShapeText = t.changeShapeText), "boolean" == typeof t.changeConnectorText && (this.changeConnectorText = t.changeConnectorText), "boolean" == typeof t.resizeShape && (this.resizeShape = t.resizeShape), "boolean" == typeof t.moveShape && (this.moveShape = t.moveShape));
          }, t;
        }();
        e.ModelOperationSettings = n, function (t) {
          t[t.AddShape = 0] = "AddShape", t[t.AddShapeFromToolbox = 1] = "AddShapeFromToolbox", t[t.DeleteShape = 2] = "DeleteShape", t[t.DeleteConnector = 3] = "DeleteConnector", t[t.ChangeConnection = 4] = "ChangeConnection", t[t.ChangeConnectorPoints = 5] = "ChangeConnectorPoints", t[t.BeforeChangeShapeText = 6] = "BeforeChangeShapeText", t[t.ChangeShapeText = 7] = "ChangeShapeText", t[t.BeforeChangeConnectorText = 8] = "BeforeChangeConnectorText", t[t.ChangeConnectorText = 9] = "ChangeConnectorText", t[t.ResizeShape = 10] = "ResizeShape", t[t.MoveShape = 11] = "MoveShape";
        }(e.DiagramModelOperation || (e.DiagramModelOperation = {}));
      },
      5261: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ChangeConnectorPointsEventArgs = e.ChangeConnectorPointsRequestedEntity = void 0;
        var r = n(5225),
          s = n(5102),
          a = n(41),
          c = function (t) {
            function e(e, n, o, i) {
              var r = t.call(this, e) || this;
              return r.connector = n, r.oldPoints = o, r.points = i, r;
            }
            return i(e, t), Object.defineProperty(e.prototype, "operation", {
              get: function () {
                return r.DiagramModelOperation.ChangeConnectorPoints;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.createEventArgs = function () {
              var t = this;
              return new u(this.apiController.createNativeConnector(this.connector), this.oldPoints.map(function (e) {
                return t.apiController.convertPoint(e);
              }), this.points.map(function (e) {
                return t.apiController.convertPoint(e);
              }));
            }, Object.defineProperty(e.prototype, "settingsKey", {
              get: function () {
                return "changeConnectorPoints";
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "storageKey", {
              get: function () {
                return this.settingsKey + "_" + (this.connector && this.connector.key);
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.equals = function (t) {
              return t instanceof e && this.connector === t.connector && a.GeometryUtils.arePointsEqual(this.oldPoints, t.oldPoints) && a.GeometryUtils.arePointsEqual(this.points, t.points);
            }, e;
          }(s.RequestedEntity);
        e.ChangeConnectorPointsRequestedEntity = c;
        var u = function (t) {
          function e(e, n, o) {
            var i = t.call(this) || this;
            return i.connector = e, i.oldPoints = n, i.points = o, i;
          }
          return i(e, t), e;
        }(s.PermissionRequestEventArgs);
        e.ChangeConnectorPointsEventArgs = u;
      },
      5290: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ProcessShapeDescription = void 0;
        var r = n(3190),
          s = n(3255),
          a = function (t) {
            function e() {
              return t.call(this, void 0, !0) || this;
            }
            return i(e, t), Object.defineProperty(e.prototype, "key", {
              get: function () {
                return s.ShapeTypes.Process;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "keepRatioOnAutoSize", {
              get: function () {
                return !1;
              },
              enumerable: !1,
              configurable: !0
            }), e;
          }(r.RectangleShapeDescription);
        e.ProcessShapeDescription = a;
      },
      5311: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CardBaseDescription = void 0;
        var r = n(1280),
          s = n(4412),
          a = n(3844),
          c = n(7185),
          u = n(3763),
          p = n(6208),
          h = n(6709),
          l = n(6018),
          d = n(3255),
          f = n(820),
          y = n(9500),
          g = n(5327),
          m = function (t) {
            function e(e) {
              return void 0 === e && (e = new a.Size(r.ShapeDefaultDimension, 26 / 46 * r.ShapeDefaultDimension)), t.call(this, e, !0) || this;
            }
            return i(e, t), Object.defineProperty(e.prototype, "keepRatioOnAutoSize", {
              get: function () {
                return !1;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.getDefaultText = function () {
              return f.DiagramLocalizationService.shapeTexts[d.ShapeTypes.Card];
            }, e.prototype.createShapePrimitives = function (t, e) {
              var n = t.rectangle,
                o = n.x,
                i = n.y,
                r = n.width,
                s = n.height;
              return [new u.RoundedRectanglePrimitive(o, i, r, s, e ? 30 : 60, e ? 30 : 60, t.style)];
            }, e.prototype.createImagePlaceholder = function (t) {
              return [new u.RoundedRectanglePrimitive(t.x, t.y, t.width, t.height, y.UnitConverter.pixelsToTwips(2), y.UnitConverter.pixelsToTwips(2), void 0, c.SHAPE_IMAGE_CLASSNAMES.IMAGE_PLACEHOLDER)];
            }, e.prototype.createEmptyImagePrimitive = function (t) {
              return l.ShapeImageIndicator.createUserIconPrimitives(t.x, t.y, this.defaultIconSize, y.UnitConverter.pixelsToTwips(1), c.SHAPE_IMAGE_CLASSNAMES.USER_PIC);
            }, e.prototype.createWarningPrimitive = function (t) {
              return l.ShapeImageIndicator.createWarningIconPrimitives(t.x + this.defaultIconSize / 2, t.y + this.defaultIconSize / 2, this.defaultIconSize / 2, c.SHAPE_IMAGE_CLASSNAMES.WARNING_MARK);
            }, e.prototype.getTextRectangle = function (t) {
              var e = t.rectangle,
                n = e.clone().inflate(-r.ShapeTextPadding, -r.ShapeTextPadding),
                o = this.getImageSize(e.createSize(), !0);
              return this.isTextAfterImage && n.moveRectangle(this.isHorizontal ? o.width : 0, this.isHorizontal ? 0 : o.height), n.resize(this.isHorizontal ? -o.width : 0, this.isHorizontal ? 0 : -o.height), n.nonNegativeSize();
            }, e.prototype.getSizeByText = function (t, e) {
              var n = t.clone().offset(2 * r.ShapeTextPadding, 2 * r.ShapeTextPadding),
                o = this.getImageSizeByTextBlockSize(n);
              return this.isHorizontal ? n.width += o.width : n.height += o.height, n;
            }, e.prototype.createTextPrimitives = function (e, n) {
              return n ? this.createGraphicalTextRepresentation(e.rectangle) : t.prototype.createTextPrimitives.call(this, e, n);
            }, e.prototype.createGraphicalTextRepresentation = function (t) {
              var e = new s.Rectangle(0, 0, 0, 0),
                n = this.getImageSize(t.createSize(), !0, !0);
              if (this.isHorizontal) {
                var o = this.isTextAfterImage ? t.width / 2 - y.UnitConverter.pixelsToTwips(2) : 0;
                e.x = t.x + o + y.UnitConverter.pixelsToTwips(4), e.y = t.y + y.UnitConverter.pixelsToTwips(5), e.width = n.width - y.UnitConverter.pixelsToTwips(4), e.height = t.height - y.UnitConverter.pixelsToTwips(6);
              } else {
                var i = this.isTextAfterImage ? t.height / 2 - y.UnitConverter.pixelsToTwips(2) : 0;
                e.x = t.x + t.width / 4, e.y = t.y + i + y.UnitConverter.pixelsToTwips(4), e.width = t.width / 2, e.height = n.height - y.UnitConverter.pixelsToTwips(2);
              }
              return this.createTextRepresentationPrimitives(e);
            }, e.prototype.getImagePlacementRectangle = function (t, e) {
              var n = this.getImageSize(t.createSize(), !1, e),
                o = s.Rectangle.fromGeometry(new g.Point(t.x, t.y), n),
                i = this.getImageSize(t.createSize(), !0, e);
              return this.isHorizontal && this.isTextAfterImage ? o.x += this.getImageMargin(e) : this.isHorizontal && (o.x = t.right - i.width - this.getImageMargin(e)), this.isHorizontal || this.isTextAfterImage ? o.y += this.getImageMargin(e) : o.y = t.bottom - i.height - this.getImageMargin(e), this.isHorizontal || (o.x += (t.width - o.width) / 2), o;
            }, e.prototype.createTextRepresentationPrimitives = function (t) {
              var e = y.UnitConverter.pixelsToTwips(y.UnitConverter.twipsToPixels(t.height / 3));
              return [new h.GroupPrimitive([new p.PathPrimitive([new p.PathPrimitiveMoveToCommand(t.x, t.y), new p.PathPrimitiveLineToCommand(t.x + t.width, t.y)]), new p.PathPrimitive([new p.PathPrimitiveMoveToCommand(t.x, t.y + e), new p.PathPrimitiveLineToCommand(t.x + t.width, t.y + e)]), new p.PathPrimitive([new p.PathPrimitiveMoveToCommand(t.x, t.y + 2 * e), new p.PathPrimitiveLineToCommand(t.x + .66 * t.width, t.y + 2 * e)])], "dxdi-shape-text")];
            }, e;
          }(c.ShapeWithImageDescription);
        e.CardBaseDescription = m;
      },
      5318: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CanvasManager = void 0;
        var r = n(3427),
          s = function (t) {
            function e() {
              var e = null !== t && t.apply(this, arguments) || this;
              return e.pendingChanges = {}, e.pendingRemoveChanges = {}, e.updatesLock = 0, e;
            }
            return i(e, t), e.prototype.beginUpdate = function () {
              this.updatesLock++;
            }, e.prototype.endUpdate = function () {
              this.updatesLock--, 0 === this.updatesLock && this.applyPendingChanges();
            }, e.prototype.getPendingChanges = function () {
              var t = this;
              return Object.keys(this.pendingChanges).map(function (e) {
                return t.pendingChanges[e];
              });
            }, e.prototype.getPendingRemoveChanges = function () {
              var t = this;
              return Object.keys(this.pendingRemoveChanges).map(function (e) {
                return t.pendingRemoveChanges[e];
              });
            }, e.prototype.applyPendingChanges = function () {
              var t = this.getPendingRemoveChanges();
              t.length && (this.applyChangesCore(t), this.pendingRemoveChanges = {});
              var e = this.getPendingChanges();
              e.length && (this.applyChangesCore(e), this.pendingChanges = {});
            }, e.prototype.applyChangesCore = function (t) {
              var e = this,
                n = [];
              t.forEach(function (t) {
                e.applyChange(t) || n.push(t);
              }), n.length && n.length !== t.length && this.applyChangesCore(n);
            }, e.prototype.postponeChanges = function (t) {
              var e = this;
              t.forEach(function (t) {
                if (t.type === r.ItemChangeType.Remove) e.pendingRemoveChanges[t.key] = t, delete e.pendingChanges[t.key];else if (e.pendingChanges[t.key]) t.type === r.ItemChangeType.Create ? e.pendingChanges[t.key] = t : t.type === r.ItemChangeType.UpdateStructure ? e.pendingChanges[t.key].type === r.ItemChangeType.UpdateProperties && (e.pendingChanges[t.key] = t) : t.type === r.ItemChangeType.UpdateProperties ? e.pendingChanges[t.key].type === r.ItemChangeType.Update && (e.pendingChanges[t.key] = t) : t.type === r.ItemChangeType.UpdateClassName && e.pendingChanges[t.key].type === r.ItemChangeType.UpdateClassName && (e.pendingChanges[t.key] = t);else {
                  if (e.pendingRemoveChanges[t.key] && t.type !== r.ItemChangeType.Create) throw new Error("Incorrect model changes sequence.");
                  e.pendingChanges[t.key] = t;
                }
              });
            }, e.prototype.applyOrPostponeChanges = function (t) {
              0 === this.updatesLock ? this.applyChangesCore(t) : this.postponeChanges(t);
            }, e.prototype.notifyModelChanged = function (t) {
              this.applyOrPostponeChanges(t);
            }, e.prototype.notifyPageColorChanged = function (t) {}, e.prototype.notifyPageSizeChanged = function (t, e) {}, e;
          }(n(5707).CanvasManagerBase);
        e.CanvasManager = s;
      },
      5323: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.InsertToContainerHistoryItem = void 0;
        var r = function (t) {
          function e(e, n) {
            var o = t.call(this) || this;
            return o.containerKey = n.key, o.itemKey = e.key, o;
          }
          return i(e, t), e.prototype.redo = function (t) {
            var e = t.model.findItem(this.itemKey),
              n = t.model.findShape(this.containerKey);
            t.insertToContainer(e, n);
          }, e.prototype.undo = function (t) {
            var e = t.model.findItem(this.itemKey);
            t.removeFromContainer(e);
          }, e;
        }(n(2616).HistoryItem);
        e.InsertToContainerHistoryItem = r;
      },
      5327: (t, e) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Point = void 0;
        var n = function () {
          function t(t, e) {
            this.x = t, this.y = e;
          }
          return t.zero = function () {
            return new t(0, 0);
          }, t.fromNumber = function (e) {
            return new t(e, e);
          }, t.prototype.isZero = function () {
            return 0 === this.x && 0 === this.y;
          }, t.prototype.toString = function () {
            return JSON.stringify(this);
          }, t.prototype.copyFrom = function (t) {
            this.x = t.x, this.y = t.y;
          }, t.prototype.clone = function () {
            return new t(this.x, this.y);
          }, t.prototype.equals = function (t) {
            return this.x === t.x && this.y === t.y;
          }, t.prototype.offset = function (t, e) {
            return this.x += t, this.y += e, this;
          }, t.prototype.offsetByPoint = function (t) {
            return this.x += t.x, this.y += t.y, this;
          }, t.prototype.multiply = function (t, e) {
            return this.x *= t, this.y *= e, this;
          }, t.prototype.negative = function () {
            return this.x *= -1, this.y *= -1, this;
          }, t.prototype.applyConverter = function (t) {
            return this.x = t(this.x), this.y = t(this.y), this;
          }, t.plus = function (e, n) {
            return new t(e.x + n.x, e.y + n.y);
          }, t.minus = function (e, n) {
            return new t(e.x - n.x, e.y - n.y);
          }, t.xComparer = function (t, e) {
            return t.x - e.x;
          }, t.yComparer = function (t, e) {
            return t.y - e.y;
          }, t.equals = function (t, e) {
            return t.x === e.x && t.y === e.y;
          }, t;
        }();
        e.Point = n;
      },
      5351: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ChangeFontNameCommand = void 0;
        var r = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(e, t), e.prototype.getStyleProperty = function () {
            return "font-family";
          }, e;
        }(n(6994).ChangeStyleTextPropertyCommand);
        e.ChangeFontNameCommand = r;
      },
      5355: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MouseHandlerResizeShapeState = void 0;
        var r = n(3844),
          s = n(5327),
          a = n(5428),
          c = n(2815),
          u = n(1922),
          p = n(1280),
          h = n(5225),
          l = function (t) {
            function e(e, n, o, i, r, s) {
              var a = t.call(this, e, n) || this;
              return a.model = o, a.selection = i, a.visualizerManager = r, a.settings = s, a.startScrollLeft = 0, a.startScrollTop = 0, a.rotation = 0, a;
            }
            return i(e, t), e.prototype.finish = function () {
              this.visualizerManager.resetResizeInfo(), this.visualizerManager.resetExtensionLines(), t.prototype.finish.call(this);
            }, e.prototype.onMouseDown = function (e) {
              var n = this,
                o = parseInt(e.source.value);
              this.resizeEventSource = o, this.startPoint = e.modelPoint, this.lockH = o === a.ResizeEventSource.ResizeBox_S || o === a.ResizeEventSource.ResizeBox_N, this.lockV = o === a.ResizeEventSource.ResizeBox_E || o === a.ResizeEventSource.ResizeBox_W, this.sideH = o === a.ResizeEventSource.ResizeBox_E || o === a.ResizeEventSource.ResizeBox_NE || o === a.ResizeEventSource.ResizeBox_SE, this.sideV = o === a.ResizeEventSource.ResizeBox_SE || o === a.ResizeEventSource.ResizeBox_S || o === a.ResizeEventSource.ResizeBox_SW, this.shapes = this.selection.getSelectedShapes(), 0 !== this.shapes.length ? (this.shapes.forEach(function (t) {
                n.handler.addInteractingItem(t, h.DiagramModelOperation.ResizeShape), n.handler.addInteractingItem(t, h.DiagramModelOperation.MoveShape);
              }), this.connectors = this.selection.getSelectedConnectors(), this.startRectangle = u.ModelUtils.createRectangle(this.shapes), this.startShapeSizes = this.shapes.map(function (t) {
                return t.size.clone();
              }), this.startShapePositions = this.shapes.map(function (t) {
                return t.position.clone();
              }), this.startConnectorPoints = this.connectors.map(function (t) {
                return t.points.map(function (t) {
                  return t.clone();
                });
              }), t.prototype.onMouseDown.call(this, e)) : this.handler.switchToDefaultState();
            }, e.prototype.onMouseMove = function (e) {
              t.prototype.onMouseMove.call(this, e);
              var n = this.selection.getSelectedShapes();
              this.visualizerManager.setExtensionLines(n);
            }, e.prototype.onApplyChanges = function (t) {
              var e = this,
                n = u.ModelUtils.createRectangle(this.shapes),
                o = 1 === this.shapes.length ? this.shapes[0].getMinWidth(this.settings.shapeMinWidth) : p.ShapeMinDimension,
                i = 1 === this.shapes.length ? this.shapes[0].getMinHeight(this.settings.shapeMinHeight) : p.ShapeMinDimension,
                a = 1 === this.shapes.length ? this.shapes[0].getMaxWidth(this.settings.shapeMaxWidth) : void 0,
                c = 1 === this.shapes.length ? this.shapes[0].getMaxHeight(this.settings.shapeMaxHeight) : void 0,
                h = this.getSize(t, n.createPosition(), this.startRectangle.createSize(), o, i, a, c, this.handler.lockAspectRatioOnShapeResize(t)),
                l = this.getPosition(t, h, this.startRectangle.createSize(), this.startRectangle.createPosition()),
                d = h.width / this.startRectangle.width,
                f = h.height / this.startRectangle.height;
              this.shapes.forEach(function (t, n) {
                var o = e.startShapeSizes[n].width * (t.allowResizeHorizontally ? d : 1);
                o = e.getNormalizedSize(o, t.getMinWidth(e.settings.shapeMinWidth), t.getMaxWidth(e.settings.shapeMaxWidth));
                var i = e.startShapeSizes[n].height * (t.allowResizeVertically ? f : 1);
                i = e.getNormalizedSize(i, t.getMinHeight(e.settings.shapeMinHeight), t.getMaxHeight(e.settings.shapeMaxHeight));
                var a = t.allowResizeHorizontally ? l.x + (e.startShapePositions[n].x - e.startRectangle.x) * d : e.startShapePositions[n].x,
                  c = t.allowResizeVertically ? l.y + (e.startShapePositions[n].y - e.startRectangle.y) * f : e.startShapePositions[n].y;
                u.ModelUtils.setShapeSize(e.history, e.model, t, new s.Point(a, c), new r.Size(o, i));
              }), this.connectors.forEach(function (t, n) {
                for (var o = t.beginItem ? 1 : 0, i = t.endItem ? t.points.length - 2 : t.points.length - 1, r = o; r <= i; r++) {
                  var a = new s.Point(l.x + (e.startConnectorPoints[n][r].x - e.startRectangle.x) * d, l.y + (e.startConnectorPoints[n][r].y - e.startRectangle.y) * f);
                  u.ModelUtils.moveConnectorPoint(e.history, t, r, a);
                }
              }), this.selection.getSelectedShapes(!1, !0).forEach(function (t) {
                u.ModelUtils.updateShapeAttachedConnectors(e.history, e.model, t);
              }), this.tryUpdateModelSize(), this.visualizerManager.setResizeInfo(this.shapes);
            }, e.prototype.tryUpdateModelSize = function () {
              var t = this;
              this.handler.tryUpdateModelSize(function (e, n) {
                t.startShapePositions.forEach(function (t) {
                  t.x += e, t.y += n;
                }), t.startConnectorPoints.forEach(function (t) {
                  t.forEach(function (t) {
                    t.x += e, t.y += n;
                  });
                }), t.startRectangle.x += e, t.startRectangle.y += n, t.startPoint.x += e, t.startPoint.y += n;
              });
            }, e.prototype.getDraggingElementKeys = function () {
              return this.shapes.map(function (t) {
                return t.key;
              });
            }, e.prototype.getNormalizedSize = function (t, e, n) {
              return void 0 !== e && (t = Math.max(t, e)), void 0 !== n && (t = Math.min(t, n)), t;
            }, e.prototype.getSize = function (t, e, n, o, i, s, a, c) {
              var u,
                p,
                h = t.modelPoint.x - (this.startScrollLeft - t.scrollX) - this.startPoint.x,
                l = t.modelPoint.y - (this.startScrollTop - t.scrollY) - this.startPoint.y,
                d = h * Math.cos(this.rotation) - -l * Math.sin(this.rotation),
                f = -(h * Math.sin(this.rotation) + -l * Math.cos(this.rotation));
              return f = !this.sideV && f > 0 ? Math.min(n.height + 1, f) : f, d = !this.sideH && d > 0 ? Math.min(n.width + 1, d) : d, this.lockH || this.lockV || !c ? (d = this.lockH ? 0 : d, f = this.lockV ? 0 : f, u = this.getNormalizedSize(this.sideH ? n.width + d : n.width - d, o, s), p = this.getNormalizedSize(this.sideV ? n.height + f : n.height - f, i, a)) : Math.abs(d) > Math.abs(f) ? (u = this.getNormalizedSize(this.sideH ? n.width + d : n.width - d, o, s), p = n.height * (u / n.width)) : (p = this.getNormalizedSize(this.sideV ? n.height + f : n.height - f, i, a), u = n.width * (p / n.height)), this.lockH || (u = this.getSnappedPosition(t, e.x + u, !0) - e.x), this.lockV || (p = this.getSnappedPosition(t, e.y + p, !1) - e.y), new r.Size(u, p);
            }, e.prototype.getPosition = function (t, e, n, o) {
              var i = o.x,
                r = o.y;
              if (this.resizeEventSource === a.ResizeEventSource.ResizeBox_N || this.resizeEventSource === a.ResizeEventSource.ResizeBox_NE || this.resizeEventSource === a.ResizeEventSource.ResizeBox_NW) {
                r += n.height - e.height;
                var c = this.getSnappedPosition(t, r, !1);
                e.height += r - c, r = c;
              }
              if (this.resizeEventSource === a.ResizeEventSource.ResizeBox_W || this.resizeEventSource === a.ResizeEventSource.ResizeBox_NW || this.resizeEventSource === a.ResizeEventSource.ResizeBox_SW) {
                i += n.width - e.width;
                var u = this.getSnappedPosition(t, i, !0);
                e.width += i - u, i = u;
              }
              return new s.Point(i, r);
            }, e.prototype.getSnappedPosition = function (t, e, n) {
              return this.handler.getSnappedPositionOnResizeShape(t, e, n);
            }, e;
          }(c.MouseHandlerDraggingState);
        e.MouseHandlerResizeShapeState = l;
      },
      5359: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ConnectorRenderPointsContext = void 0;
        var o = n(9956),
          i = function () {
            function t(t, e, n) {
              this.renderPoints = t, this.lockCreateRenderPoints = e, this.actualRoutingMode = n;
            }
            return t.prototype.toObject = function () {
              return {
                actualRoutingMode: this.actualRoutingMode,
                lockCreateRenderPoints: this.lockCreateRenderPoints,
                renderPoints: this.renderPoints.map(function (t) {
                  return t.toObject();
                })
              };
            }, t.fromObject = function (e) {
              return new t(e.renderPoints.map(function (t) {
                return o.ConnectorRenderPoint.fromObject(t);
              }), e.lockCreateRenderPoints, e.actualRoutingMode);
            }, t;
          }();
        e.ConnectorRenderPointsContext = i;
      },
      5428: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.DiagramClipboardEvent = e.DiagramKeyboardEvent = e.DiagramContextMenuEvent = e.DiagramWheelEvent = e.DiagramMouseEvent = e.DiagramMouseEventBase = e.DiagramMouseEventTouch = e.DiagramFocusEvent = e.DiagramEvent = e.ResizeEventSource = e.MouseEventSource = e.MouseEventElementType = e.MouseButton = void 0;
        var r,
          s = n(6537);
        !function (t) {
          t[t.None = 0] = "None", t[t.Left = 1] = "Left", t[t.Right = 2] = "Right", t[t.Middle = 4] = "Middle";
        }(e.MouseButton || (e.MouseButton = {})), function (t) {
          t[t.Undefined = 0] = "Undefined", t[t.Background = 1] = "Background", t[t.Document = 2] = "Document", t[t.Connector = 3] = "Connector", t[t.ConnectorPoint = 4] = "ConnectorPoint", t[t.ConnectorSide = 5] = "ConnectorSide", t[t.ConnectorOrthogonalSide = 6] = "ConnectorOrthogonalSide", t[t.ConnectorText = 7] = "ConnectorText", t[t.Shape = 8] = "Shape", t[t.ShapeResizeBox = 9] = "ShapeResizeBox", t[t.ShapeParameterBox = 10] = "ShapeParameterBox", t[t.SelectionRect = 11] = "SelectionRect", t[t.ShapeConnectionPoint = 12] = "ShapeConnectionPoint", t[t.ShapeExpandButton = 13] = "ShapeExpandButton";
        }(r = e.MouseEventElementType || (e.MouseEventElementType = {}));
        var a = function () {
          function t(t, e, n) {
            this.type = t, this.key = e, this.value = n;
          }
          return Object.defineProperty(t.prototype, "isConnector", {
            get: function () {
              return this.type === r.Connector || this.type === r.ConnectorText;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "isShape", {
            get: function () {
              return this.type === r.Shape || this.type === r.ShapeConnectionPoint;
            },
            enumerable: !1,
            configurable: !0
          }), t;
        }();
        e.MouseEventSource = a, function (t) {
          t[t.Undefined = 0] = "Undefined", t[t.ResizeBox_NW = 1] = "ResizeBox_NW", t[t.ResizeBox_NE = 2] = "ResizeBox_NE", t[t.ResizeBox_SE = 3] = "ResizeBox_SE", t[t.ResizeBox_SW = 4] = "ResizeBox_SW", t[t.ResizeBox_N = 5] = "ResizeBox_N", t[t.ResizeBox_E = 6] = "ResizeBox_E", t[t.ResizeBox_S = 7] = "ResizeBox_S", t[t.ResizeBox_W = 8] = "ResizeBox_W";
        }(e.ResizeEventSource || (e.ResizeEventSource = {}));
        var c = function (t) {
          this.modifiers = t;
        };
        e.DiagramEvent = c;
        var u = function (t) {
          function e(e) {
            var n = t.call(this, s.ModifierKey.None) || this;
            return n.inputText = e, n;
          }
          return i(e, t), e;
        }(c);
        e.DiagramFocusEvent = u;
        var p = function (t, e) {
          this.offsetPoint = t, this.modelPoint = e;
        };
        e.DiagramMouseEventTouch = p;
        var h = function (t) {
          function e(e, n, o, i) {
            var r = t.call(this, e) || this;
            return r.offsetPoint = n, r.modelPoint = o, r.source = i, r;
          }
          return i(e, t), e;
        }(c);
        e.DiagramMouseEventBase = h;
        var l = function (t) {
          function e(e, n, o, i, r, s, a) {
            void 0 === s && (s = []);
            var c = t.call(this, e, o, i, r) || this;
            return c.button = n, c.touches = s, c.isTouchMode = a, c.scrollX = 0, c.scrollY = 0, c;
          }
          return i(e, t), e;
        }(h);
        e.DiagramMouseEvent = l;
        var d = function (t) {
          function e(e, n, o, i, r, s) {
            var a = t.call(this, e, i, r, s) || this;
            return a.deltaX = n, a.deltaY = o, a;
          }
          return i(e, t), e;
        }(h);
        e.DiagramWheelEvent = d;
        var f = function (t) {
          function e(e, n, o) {
            var i = t.call(this, e) || this;
            return i.eventPoint = n, i.modelPoint = o, i;
          }
          return i(e, t), e;
        }(c);
        e.DiagramContextMenuEvent = f;
        var y = function (t) {
          function e(e, n, o) {
            var i = t.call(this, e) || this;
            return i.keyCode = n, i.inputText = o, i;
          }
          return i(e, t), e.prototype.getShortcutCode = function () {
            return this.modifiers | this.keyCode;
          }, e;
        }(c);
        e.DiagramKeyboardEvent = y;
        var g = function (t) {
          function e(e) {
            var n = t.call(this, s.ModifierKey.None) || this;
            return n.clipboardData = e, n;
          }
          return i(e, t), e;
        }(c);
        e.DiagramClipboardEvent = g;
      },
      5441: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ImportXMLCommand = void 0;
        var r = n(7892),
          s = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), e.prototype.executeCore = function (t, e) {
              var n = new r.XmlImporter(this.control.shapeDescriptionManager, e).import();
              return this.control.importModel(n), !0;
            }, e;
          }(n(6089).ExportImportCommandBase);
        e.ImportXMLCommand = s;
      },
      5442: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ConnectorPointsOrthogonalSouthSideCalculator = void 0;
        var r = n(4824),
          s = n(3976),
          a = n(9956),
          c = function (t) {
            function e(e) {
              return t.call(this, e) || this;
            }
            return i(e, t), e.prototype.getCorrectOriginPoint = function (t, e) {
              return t.y < e.bottom && (t = t.clone().offset(0, e.bottom - t.y)), t;
            }, e.prototype.getSameShapeOffsetPoints = function (t, e, n, o) {
              switch (t) {
                case r.ConnectionPointSide.East:
                case r.ConnectionPointSide.West:
                case r.ConnectionPointSide.South:
                  return [e.clone().offset(0, this.getMinOffset())];
                case r.ConnectionPointSide.North:
                  return this.getAsideOffsetPoints(e, n, o, this.getMinOffset(), this.getMinOffset());
              }
            }, e.prototype.getOverlappedPointsOffsetPoints = function (t, e, n, o) {
              switch (t) {
                case r.ConnectionPointSide.South:
                  return [e.clone().offset(0, this.getMinOffset())];
                case r.ConnectionPointSide.North:
                  return [e.clone().offset(0, -this.getMinOffset())];
              }
              return [];
            }, e.prototype.getBeginOverlappedShapeOffsetPoints = function (t, e, n, o) {
              switch (t) {
                case r.ConnectionPointSide.East:
                  return e.y < n.y ? e.x > n.x ? [] : [e.clone().offset(0, this.getMinOffset())] : e.y > this.endRect.bottom ? this.getAsideOffsetPoints(e, n, o, this.getMinOffset(), this.getMinOffset(), !1) : [e.clone().offset(0, this.getMinOffset())];
                case r.ConnectionPointSide.West:
                  return e.y < n.y ? e.x < n.x ? [] : [e.clone().offset(0, this.getMinOffset())] : e.y > this.endRect.bottom ? this.getAsideOffsetPoints(e, n, o, this.getMinOffset(), this.getMinOffset(), !0) : [e.clone().offset(0, this.getMinOffset())];
                case r.ConnectionPointSide.South:
                  return [e.clone().offset(0, this.getMinOffset())];
                case r.ConnectionPointSide.North:
                  return this.getAsideOffsetPoints(e, n, o, this.getMinOffset(), this.getMinOffset(), e.x < n.x);
              }
            }, e.prototype.getEndOverlappedShapeOffsetPoints = function (t, e, n, o) {
              switch (t) {
                case r.ConnectionPointSide.East:
                  return n.y < e.y ? this.getAsideOffsetPoints(e, n, o, this.getMinOffset(), this.getMinOffset(), !1) : e.x < n.x ? [e.clone().offset(0, this.getMinOffset())] : [];
                case r.ConnectionPointSide.West:
                  return n.y < e.y ? this.getAsideOffsetPoints(e, n, o, this.getMinOffset(), this.getMinOffset(), !0) : e.x > n.x ? [e.clone().offset(0, this.getMinOffset())] : [];
                case r.ConnectionPointSide.South:
                  return [e.clone().offset(0, this.getMinOffset())];
                case r.ConnectionPointSide.North:
                  var i = this.getMinOffset();
                  return this.beginRect.bottom > e.y && (i += this.beginRect.bottom - e.y), [e.clone().offset(0, i)];
              }
            }, e.prototype.getBeginOnSideOffsetPoints = function (t, e, n, o) {
              return [e.clone().offset(0, this.getScaleableOffsetY(e, n, !1))];
            }, e.prototype.getEndOnSideOffsetPoints = function (t, e, n, o) {
              return [e.clone().offset(0, this.getScaleableOffsetY(e, n, !0))];
            }, e.prototype.getBeginOffSideOffsetPoints = function (t, e, n, o) {
              switch (t) {
                case r.ConnectionPointSide.East:
                  if (this.isBeginEndOverlappedX()) return this.getScaleableAsideOffsetPoints(e, n, o, !1, !1);
                  break;
                case r.ConnectionPointSide.West:
                  if (this.isBeginEndOverlappedX()) return this.getScaleableAsideOffsetPoints(e, n, o, !1, !0);
                  break;
                case r.ConnectionPointSide.South:
                  if (this.isBeginEndOverlappedX()) return this.getScaleableAsideOffsetPoints(e, n, o, !1);
                  break;
                case r.ConnectionPointSide.Undefined:
                case r.ConnectionPointSide.North:
                  return this.getScaleableAsideOffsetPoints(e, n, o, !1);
              }
              return [e.clone().offset(0, this.getScaleableOffsetY(e, n, !1))];
            }, e.prototype.getEndOffSideOffsetPoints = function (t, e, n, o) {
              if (t === r.ConnectionPointSide.Undefined) return this.getScaleableAsideOffsetPoints(e, n, o, !0);
              if (this.isBeginEndOverlappedX()) {
                var i = this.beginRect.center.x > this.endRect.center.x;
                return this.getScaleableAsideOffsetPoints(e, n, o, !0, i);
              }
              return [e.clone().offset(0, this.getScaleableOffsetY(e, n, !0))];
            }, e.prototype.getAsideOffsetPoints = function (t, e, n, o, i, r) {
              var s = [];
              return void 0 !== n && (void 0 === r && (r = e.x < t.x), r ? s.push(t.clone().offset(-(t.x - n.x + i), o)) : s.push(t.clone().offset(n.right - t.x + i, o))), s.push(t.clone().offset(0, o)), s;
            }, e.prototype.getScaleableAsideOffsetPoints = function (t, e, n, o, i) {
              var r = this.getScaleableOffsetY(t, e, o),
                s = this.getScaleableOffsetX(t, e, o);
              return this.getAsideOffsetPoints(t, e, n, r, s, i);
            }, e.prototype.getScaleableOffsetX = function (t, e, n) {
              if (this.beginRect && this.endRect && !n && !this.isBeginEndOverlappedX()) {
                var o = void 0;
                if ((o = e.x < t.x ? this.beginRect.x - this.endRect.right : this.endRect.x - this.beginRect.right) < 2 * this.getMinOffset()) return o / 2;
              }
              return this.getMinOffset();
            }, e.prototype.getScaleableOffsetY = function (t, e, n) {
              if (this.beginRect && this.endRect) {
                var o = n ? this.beginRect.y - t.y : this.endRect.y - t.y;
                if (o > 0 && o < 2 * this.getMinOffset()) return o / 2;
              }
              return this.getMinOffset();
            }, e.prototype.isOnSidePoint = function (t, e) {
              return e.y > t.y;
            }, e.prototype.isDirectConnectionAllowed = function (t, e, n) {
              return t === r.ConnectionPointSide.North || t === r.ConnectionPointSide.Undefined;
            }, e.prototype.getDirectConnectionPoints = function (t, e) {
              var n = t.y + (e.y - t.y) / 2;
              return [new a.ConnectorRenderPoint(t.x, n), new a.ConnectorRenderPoint(e.x, n)];
            }, e;
          }(s.ConnectorPointsOrthogonalSideCalculatorBase);
        e.ConnectorPointsOrthogonalSouthSideCalculator = c;
      },
      5451: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.PasteSelectionCommandBase = void 0;
        var r = n(1311),
          s = n(7857),
          a = n(8408),
          c = n(7672),
          u = n(6320),
          p = n(506),
          h = n(1922),
          l = n(6512),
          d = n(9500),
          f = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), e.prototype.isEnabled = function () {
              return t.prototype.isEnabled.call(this) && (this.isPasteSupportedByBrowser() || void 0 !== r.ClipboardCommand.clipboardData);
            }, e.prototype.isVisible = function () {
              return this.isPasteSupportedByBrowser() || void 0 !== r.ClipboardCommand.clipboardData;
            }, e.prototype.parseClipboardData = function (t) {
              var e;
              e = new s.Importer(this.control.shapeDescriptionManager, t).importItems(this.control.model);
              for (var n = this.getEventPositionOffset(e, this.control.contextMenuPosition), o = 0; o < e.length; o++) {
                var i = e[o];
                i instanceof a.Shape ? i.position.offsetByPoint(n) : i instanceof u.Connector && (i.points.forEach(function (t) {
                  return t.offsetByPoint(n);
                }), i.clearRenderPoints());
              }
              return e;
            }, e.prototype.executeCore = function (t, e) {
              var n = this,
                o = !0;
              return void 0 === e ? this.getClipboardData(function (t) {
                o = n.execute(t);
              }) : this.performPaste(e), o;
            }, e.prototype.addItemForSortingRecursive = function (t, e) {
              if (t[e.key]) return t[e.key];
              if (e instanceof u.Connector) return e.endItem ? t[e.key] = this.addItemForSortingRecursive(t, e.endItem) - .5 : e.beginItem ? t[e.key] = this.addItemForSortingRecursive(t, e.beginItem) + .5 : t[e.key] = -1, t[e.key];
              if (0 === e.attachedConnectors.length) return t[e.key] = 0;
              for (var n = 0; n < e.attachedConnectors.length; n++) {
                var o = e.attachedConnectors[n].beginItem;
                return e.attachedConnectors[n].endItem === e && o && o !== e.attachedConnectors[n].endItem ? t[e.key] = this.addItemForSortingRecursive(t, o) + 1 : t[e.key] = 0;
              }
            }, e.prototype.getSortedPasteItems = function (t) {
              for (var e = [], n = [], o = {}, i = 0; i < t.length; i++) {
                var r = t[i];
                r instanceof a.Shape ? e.push(r) : r instanceof u.Connector && (n.push(r), this.addItemForSortingRecursive(o, r));
              }
              return n.sort(function (t, e) {
                return o[e.key] - o[t.key];
              }), e.concat(n);
            }, e.prototype.performPaste = function (t) {
              this.control.beginUpdateCanvas(), this.control.history.beginTransaction();
              var e = {},
                n = this.parseClipboardData(t);
              n = this.getSortedPasteItems(n);
              for (var o = 0; o < n.length; o++) {
                var i = n[o];
                i instanceof a.Shape ? this.control.history.addAndRedo(new c.ImportShapeHistoryItem(i)) : i instanceof u.Connector && this.control.history.addAndRedo(new p.ImportConnectorHistoryItem(i));
                var r = i.container && i.container.key;
                r && void 0 !== e[r] ? r && void 0 !== e[r] && (e[i.key] = !1) : e[i.key] = !0;
              }
              h.ModelUtils.tryUpdateModelRectangle(this.control.history), this.control.history.addAndRedo(new l.SetSelectionHistoryItem(this.control.selection, Object.keys(e).filter(function (t) {
                return e[t];
              }))), this.control.history.endTransaction(), this.control.endUpdateCanvas(), this.control.barManager.updateItemsState();
            }, Object.defineProperty(e.prototype, "isPermissionsRequired", {
              get: function () {
                return !0;
              },
              enumerable: !1,
              configurable: !0
            }), e.positionOffset = d.UnitConverter.pixelsToTwips(10), e;
          }(r.ClipboardCommand);
        e.PasteSelectionCommandBase = f;
      },
      5455: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ArrowLeftShapeDescription = void 0;
        var r = n(6208),
          s = n(9090),
          a = n(9763),
          c = n(5327),
          u = n(3255),
          p = n(4824),
          h = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), Object.defineProperty(e.prototype, "key", {
              get: function () {
                return u.ShapeTypes.ArrowLeft;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.createShapePrimitives = function (t) {
              var e = t.rectangle,
                n = e.x,
                o = e.y,
                i = e.right,
                a = e.bottom,
                c = e.height,
                u = e.center.y,
                p = t.parameters.get(s.ArrowVerticalTriangleWidthParameterName).value,
                h = (c - t.parameters.get(s.ArrowVerticalLineHeightParameterName).value) / 2,
                l = t.normalizeX(n + p),
                d = t.normalizeY(o + h),
                f = t.normalizeY(a - h);
              return [new r.PathPrimitive([new r.PathPrimitiveMoveToCommand(n, u), new r.PathPrimitiveLineToCommand(l, o), new r.PathPrimitiveLineToCommand(l, d), new r.PathPrimitiveLineToCommand(i, d), new r.PathPrimitiveLineToCommand(i, f), new r.PathPrimitiveLineToCommand(l, f), new r.PathPrimitiveLineToCommand(l, a), new r.PathPrimitiveClosePathCommand()], t.style)];
            }, e.prototype.modifyParameters = function (t, e, n, o) {
              this.changeParameterValue(e, s.ArrowVerticalTriangleWidthParameterName, function (t) {
                return t.value + n;
              }), this.changeParameterValue(e, s.ArrowVerticalLineHeightParameterName, function (t) {
                return t.value - 2 * o;
              }), this.normalizeParameters(t, e);
            }, e.prototype.getParameterPoints = function (t) {
              return [new a.ShapeParameterPoint("c", new c.Point(t.normalizeX(t.position.x + t.parameters.get(s.ArrowVerticalTriangleWidthParameterName).value), t.normalizeY(t.position.y + (t.size.height - t.parameters.get(s.ArrowVerticalLineHeightParameterName).value) / 2)))];
            }, e.prototype.processConnectionPoint = function (e, n) {
              var o = e.parameters.get(s.ArrowVerticalTriangleWidthParameterName).value;
              if (n.x < e.position.x + o) {
                var i = e.size.height / 2 / o,
                  r = (e.position.x + o - n.x) * i,
                  a = e.getConnectionPointSide(n);
                a === p.ConnectionPointSide.North ? n.y += r : a === p.ConnectionPointSide.South && (n.y -= r);
              } else t.prototype.processConnectionPoint.call(this, e, n);
            }, e;
          }(s.ArrowHorizontalShapeDescription);
        e.ArrowLeftShapeDescription = h;
      },
      5483: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Tree = void 0;
        var o = n(8573),
          i = function () {
            function t(t, e) {
              var n = this;
              this.childToParent = {}, this.root = t, this.parentToChildren = e;
              var o = function (t) {
                if (!Object.prototype.hasOwnProperty.call(e, t)) return "continue";
                e[t].forEach(function (e) {
                  return n.childToParent[e.key] = t;
                });
              };
              for (var i in e) o(i);
            }
            return t.prototype.getChildren = function (t) {
              return t && this.parentToChildren[t.key] ? this.parentToChildren[t.key] : [];
            }, t.prototype.hasChildren = function (t) {
              return this.parentToChildren[t.key] && this.parentToChildren[t.key].length > 0;
            }, t.prototype.iterate = function (t) {
              this.iterateCore(this.root, 0, t);
            }, t.createSpanningTree = function (e) {
              var n = t.findRoot(e),
                i = e.createIterator(o.ConnectionMode.Outgoing),
                r = {};
              return i.skipEdge = function (t) {
                return void 0 === t.to || i.isNodeVisited(t.to);
              }, i.onNode = function (t) {
                return r[t.key] = [];
              }, i.onEdge = function (t) {
                var n = e.getNode(t.to);
                n && r[t.from].push(n);
              }, i.iterate(n), new t(e.getNode(n), r);
            }, t.prototype.iterateCore = function (t, e, n) {
              var o = this;
              n(t, e), this.getChildren(t).forEach(function (t) {
                return o.iterateCore(t, e + 1, n);
              });
            }, t.findRoot = function (t) {
              return t.nodes.reduce(function (e, n) {
                var o = t.getAdjacentEdges(n),
                  i = o.filter(function (t) {
                    return t.to === n;
                  }).length,
                  r = o.filter(function (t) {
                    return t.from === n;
                  }).length;
                return (void 0 === e.candidate || 0 === i && e.inc > 0 || 0 !== e.inc && e.out - e.inc < r - i) && (e.candidate = n, e.inc = i, e.out = r), e;
              }, {
                inc: -1,
                out: -1,
                candidate: void 0
              }).candidate;
            }, t;
          }();
        e.Tree = i;
      },
      5496: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.EditShapeImageCommand = void 0;
        var r = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(e, t), e.prototype.isEnabled = function () {
            var e = this.getSelectedShape();
            return t.prototype.isEnabled.call(this) && !e.image.isEmpty;
          }, e;
        }(n(877).EditShapeImageCommandBase);
        e.EditShapeImageCommand = r;
      },
      5596: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ImporterBase = void 0;
        var o = n(455),
          i = n(8408),
          r = function () {
            function t(t) {
              this.shapeDescriptionManager = t;
            }
            return t.prototype.import = function () {
              var t = new o.DiagramModel(),
                e = this.getObject();
              this.importPageSettings(t, this.getPageObject(e));
              for (var n = this.importShapes(this.getShapeObjects(e)), i = 0; i < n.length; i++) {
                var r = n[i];
                if (t.findItem(r.key)) throw Error("Item key is duplicated");
                t.pushItem(r);
              }
              var s = this.importConnectors(this.getConnectorObjects(e));
              for (i = 0; i < s.length; i++) {
                var a = s[i];
                if (a.endItem = t.findItem(a.endItemKey) || void 0, delete a.endItemKey, a.beginItem = t.findItem(a.beginItemKey) || void 0, delete a.beginItemKey, t.findItem(a.key)) throw Error("Item key is duplicated");
                t.pushItem(a), this.updateConnections(a);
              }
              return this.updateChildren(t.items, function (e) {
                return t.findItem(e);
              }), t;
            }, t.prototype.importItems = function (t) {
              for (var e, n = [], o = this.getObject(), i = {}, r = this.importShapes(this.getShapeObjects(o)), s = 0; s < r.length; s++) {
                var a = r[s],
                  c = a.key;
                e = t.getNextKey(), a.key = e, i[c] = a, void 0 !== a.dataKey && (a.dataKey = void 0), n.push(a);
              }
              var u = this.importConnectors(this.getConnectorObjects(o));
              for (s = 0; s < u.length; s++) {
                var p = u[s];
                c = p.key;
                e = t.getNextKey(), p.key = e, i[c] = p, void 0 !== p.dataKey && (p.dataKey = void 0);
                var h = p.endItemKey;
                p.endItem = i[h], delete p.endItemKey;
                var l = p.beginItemKey;
                p.beginItem = i[l], delete p.beginItemKey, n.push(p), this.updateConnections(p);
              }
              return this.updateChildren(n, function (t) {
                return i[t];
              }), n;
            }, t.prototype.importItemsData = function (t) {
              for (var e = this.getObject(), n = this.importShapes(this.getShapeObjects(e)), o = {}, i = 0; i < n.length; i++) {
                var r = n[i],
                  s = void 0;
                void 0 !== r.dataKey && (s = t.findShapeByDataKey(r.dataKey)), s && (s.dataKey = r.dataKey, o[r.key] = r.dataKey, s.locked = r.locked, s.position = r.position.clone(), s.expanded = r.expanded, r.expandedSize && (s.expandedSize = r.expandedSize.clone()), s.size = r.size.clone(), s.parameters = r.parameters.clone(), s.style = r.style.clone(), s.styleText = r.styleText.clone(), s.zIndex = r.zIndex, s.text = r.text, s.description = r.description, s.image = r.image.clone());
              }
              var a = this.importConnectors(this.getConnectorObjects(e));
              for (i = 0; i < a.length; i++) {
                var c = a[i],
                  u = void 0;
                void 0 !== c.dataKey && (u = t.findConnectorByDataKey(c.dataKey)), u || (u = t.findConnectorByBeginEndDataKeys(o[c.beginItemKey], o[c.endItemKey])), u && (u.dataKey = c.dataKey, u.locked = c.locked, u.points = c.points.slice(), u.properties = c.properties.clone(), u.style = c.style.clone(), u.endConnectionPointIndex = c.endConnectionPointIndex, u.beginConnectionPointIndex = c.beginConnectionPointIndex, u.texts = c.texts.clone(), u.styleText = c.styleText.clone(), u.zIndex = c.zIndex);
              }
            }, t.prototype.importShapes = function (t) {
              var e = [];
              if (!t) return e;
              if (!Array.isArray(t)) throw Error("Invalid Format");
              for (var n = 0; n < t.length; n++) {
                var o = t[n],
                  i = this.importShape(o);
                e.push(i), e = e.concat(this.importShapeChildren(o, i));
              }
              return e;
            }, t.prototype.importConnectors = function (t) {
              var e = [];
              if (!t) return e;
              if (!Array.isArray(t)) throw Error("Invalid Format");
              for (var n = 0; n < t.length; n++) {
                var o = t[n];
                e.push(this.importConnector(o));
              }
              return e;
            }, t.prototype.updateChildren = function (t, e) {
              t.forEach(function (t) {
                t instanceof i.Shape && t.childKeys && (t.childKeys.forEach(function (n) {
                  var o = e(n);
                  o && (-1 === t.children.indexOf(o) && t.children.push(o), o.container = t);
                }), delete t.childKeys);
              });
            }, t.prototype.updateConnections = function (t) {
              t.endItem && (t.endItem instanceof i.Shape ? (t.endItem.attachedConnectors.push(t), t.points[t.points.length - 1] = t.endItem.getConnectionPointPosition(t.endConnectionPointIndex, t.points[t.points.length - 2])) : (t.endItem = void 0, t.endConnectionPointIndex = -1)), t.beginItem && (t.beginItem instanceof i.Shape ? (t.beginItem.attachedConnectors.push(t), t.points[0] = t.beginItem.getConnectionPointPosition(t.beginConnectionPointIndex, t.points[1])) : (t.beginItem = void 0, t.beginConnectionPointIndex = -1));
            }, t.prototype.assert = function (t, e) {
              if (void 0 === t) throw Error("Invalid Format");
              if (void 0 !== e && typeof t !== e) throw Error("Invalid Format");
            }, t;
          }();
        e.ImporterBase = r;
      },
      5650: (t, e) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.TextOwner = void 0, function (t) {
          t[t.Shape = 0] = "Shape", t[t.Connector = 1] = "Connector", t[t.ExtensionLine = 2] = "ExtensionLine", t[t.Resize = 3] = "Resize";
        }(e.TextOwner || (e.TextOwner = {}));
      },
      5654: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ClipPathPrimitive = void 0;
        var r = n(8509),
          s = function (t) {
            function e(e, n) {
              var o = t.call(this) || this;
              return o.id = e, o.children = n, o;
            }
            return i(e, t), e.prototype.createMainElement = function () {
              var t = document.createElementNS(r.svgNS, "clipPath");
              return t.setAttribute("id", this.id), t;
            }, e.prototype.applyElementProperties = function (e, n) {
              this.id && e.setAttribute("id", this.id), t.prototype.applyElementProperties.call(this, e, n);
            }, e;
          }(n(8309).SvgPrimitive);
        e.ClipPathPrimitive = s;
      },
      5656: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ConnectorShapeDescription = void 0;
        var r = n(3255),
          s = n(3844),
          a = n(1280),
          c = function (t) {
            function e() {
              var e = t.call(this, !1) || this;
              return e.defaultSize = new s.Size(.5 * a.ShapeDefaultDimension, .5 * a.ShapeDefaultDimension), e;
            }
            return i(e, t), Object.defineProperty(e.prototype, "key", {
              get: function () {
                return r.ShapeTypes.Connector;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "keepRatioOnAutoSize", {
              get: function () {
                return !0;
              },
              enumerable: !1,
              configurable: !0
            }), e;
          }(n(9829).EllipseShapeDescription);
        e.ConnectorShapeDescription = c;
      },
      5678: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AddShapeFromToolboxEventArgs = e.AddShapeFromToolboxRequestedEntity = void 0;
        var r = n(5225),
          s = n(5102),
          a = function (t) {
            function e(e, n) {
              var o = t.call(this, e) || this;
              return o.shapeType = n, o;
            }
            return i(e, t), Object.defineProperty(e.prototype, "operation", {
              get: function () {
                return r.DiagramModelOperation.AddShapeFromToolbox;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.createEventArgs = function () {
              return new c(this.shapeType);
            }, Object.defineProperty(e.prototype, "settingsKey", {
              get: function () {
                return "addShapeFromToolbox";
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "storageKey", {
              get: function () {
                return this.settingsKey + "_" + this.shapeType;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.equals = function (t) {
              return t instanceof e && this.shapeType === t.shapeType;
            }, e;
          }(s.RequestedEntity);
        e.AddShapeFromToolboxRequestedEntity = a;
        var c = function (t) {
          function e(e) {
            var n = t.call(this) || this;
            return n.shapeType = e, n;
          }
          return i(e, t), e;
        }(s.PermissionRequestEventArgs);
        e.AddShapeFromToolboxEventArgs = c;
      },
      5685: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ResizeShapeHistoryItem = void 0;
        var r = function (t) {
          function e(e, n, o) {
            var i = t.call(this) || this;
            return i.shapeKey = e, i.position = n, i.size = o, i;
          }
          return i(e, t), e.prototype.redo = function (t) {
            var e = t.model.findShape(this.shapeKey);
            this.oldPosition = e.position.clone(), this.oldSize = e.size.clone(), t.resizeShape(e, this.position, this.size);
          }, e.prototype.undo = function (t) {
            var e = t.model.findShape(this.shapeKey);
            t.resizeShape(e, this.oldPosition, this.oldSize);
          }, e;
        }(n(2616).HistoryItem);
        e.ResizeShapeHistoryItem = r;
      },
      5707: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CanvasManagerBase = e.PAGE_BG_TEXTFLOOR_FILTER_IDPREFIX = void 0;
        var o = n(1118),
          i = n(9500);
        e.PAGE_BG_TEXTFLOOR_FILTER_IDPREFIX = "page-text-flood";
        var r = function () {
          function t(t, e, n) {
            this.elements = {}, this.instanceId = n, this.actualZoom = t, this.dom = e;
          }
          return t.prototype.createAndChangePrimitivesElements = function (t, e) {
            var n = this;
            t.forEach(function (t) {
              n.createAndChangePrimitiveElement(t, e);
            });
          }, t.prototype.createPrimitiveElement = function (t, e, n) {
            return this.dom.createElement(t, e, n);
          }, t.prototype.createAndChangePrimitiveElement = function (t, e, n) {
            var o = this.createPrimitiveElement(t, e, n);
            return this.dom.changeByPrimitive(o, t), o;
          }, t.prototype.changePrimitiveElement = function (t, e) {
            this.dom.changeByPrimitive(e, t);
          }, t.prototype.getOrCreateElement = function (t, e, n, o) {
            var i = t && this.elements[t] || (this.elements[t] = this.createPrimitiveElement(e, n, o));
            return this.changePrimitiveElement(e, i), i;
          }, t.prototype.createTextFloodFilter = function (t, n, i, r) {
            this.getOrCreateElement(n, new o.TextFloodFilterPrimitive(e.PAGE_BG_TEXTFLOOR_FILTER_IDPREFIX + t, r), i);
          }, t.prototype.getAbsoluteSize = function (t) {
            return t.clone().applyConverter(i.UnitConverter.twipsToPixelsF).clone().multiply(this.actualZoom, this.actualZoom);
          }, t;
        }();
        e.CanvasManagerBase = r;
      },
      5715: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MouseHandlerZoomOnWheelState = void 0;
        var r = n(9589),
          s = n(5428),
          a = n(9307),
          c = function (t) {
            function e(e, n, o) {
              var i = t.call(this, e) || this;
              return i.settings = n, i.view = o, i;
            }
            return i(e, t), e.prototype.onMouseWheel = function (t) {
              return this.trySwitchToDefault(t) ? this.handler.state.onMouseWheel(t) : (this.settings.zoomLevel = this.view.getNextStepZoom(t.deltaY < 0), t.source.type === s.MouseEventElementType.Background ? this.view.resetScroll() : (this.view.scrollTo(t.modelPoint, t.offsetPoint), this.view.normalize()), t.preventDefault = !0, !0);
            }, e.prototype.onMouseUp = function (t) {
              this.handler.switchToDefaultState(), this.handler.state.onMouseUp(t);
            }, e.prototype.onMouseDown = function (t) {
              this.handler.switchToDefaultState(), this.handler.state.onMouseDown(t);
            }, e.prototype.onMouseMove = function (t) {
              this.trySwitchToDefault(t) && this.handler.state.onMouseMove(t);
            }, e.prototype.trySwitchToDefault = function (t) {
              return !!this.handler.canFinishZoomOnWheel(t) && (this.handler.switchToDefaultState(), !0);
            }, e.prototype.start = function () {
              t.prototype.start.call(this), this.settings.zoomLevel = this.view.getZoom(), this.settings.autoZoom = a.AutoZoomMode.Disabled;
            }, e;
          }(r.MouseHandlerStateBase);
        e.MouseHandlerZoomOnWheelState = c;
      },
      5718: (t, e) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ReloadContentParameters = void 0;
        var n = function () {
          function t() {
            this.isEmpty = !0;
          }
          return t.prototype.add = function (t, e, n) {
            void 0 !== t && (void 0 === this._dataKeys && (this._dataKeys = []), Array.isArray(t) ? this._dataKeys = this._dataKeys.concat(t) : this._dataKeys.push(t)), this._getData = this._getData || e, this._layoutParameters = this._layoutParameters || n, this.isEmpty = !1;
          }, t.prototype.clear = function () {
            this.isEmpty = !0, this._dataKeys = void 0, this._getData = void 0, this._layoutParameters = void 0;
          }, Object.defineProperty(t.prototype, "empty", {
            get: function () {
              return this.isEmpty;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "dataKeys", {
            get: function () {
              return this._dataKeys;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "getData", {
            get: function () {
              return this._getData;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "layoutParameters", {
            get: function () {
              return this._layoutParameters;
            },
            enumerable: !1,
            configurable: !0
          }), t;
        }();
        e.ReloadContentParameters = n;
      },
      5719: (t, e) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ConnectionPointsVisualizer = e.ConnectionPointInfo = void 0;
        var n = function (t, e) {
          this.point = t, this.side = e, this.allowed = !0;
        };
        e.ConnectionPointInfo = n;
        var o = function () {
          function t(t) {
            this.dispatcher = t;
          }
          return t.prototype.getKey = function () {
            return this.key;
          }, t.prototype.setPoints = function (t, e, n, o) {
            this.key === t && this.pointIndex === n || (this.key = t, this.points = e, this.pointIndex = n, this.outsideRectangle = o, this.raiseShow());
          }, t.prototype.setPointIndex = function (t) {
            0 <= t && t < this.points.length && this.pointIndex !== t && (this.pointIndex = t, this.raiseShow());
          }, t.prototype.update = function () {
            this.raiseShow();
          }, t.prototype.reset = function () {
            "-1" !== this.key && (this.key = "-1", this.points = [], this.pointIndex = -1, this.outsideRectangle = void 0, this.raiseHide());
          }, t.prototype.raiseShow = function () {
            var t = this;
            this.dispatcher.raise1(function (e) {
              return e.notifyConnectionPointsShow(t.key, t.points, t.pointIndex, t.outsideRectangle);
            });
          }, t.prototype.raiseHide = function () {
            this.dispatcher.raise1(function (t) {
              return t.notifyConnectionPointsHide();
            });
          }, t;
        }();
        e.ConnectionPointsVisualizer = o;
      },
      5725: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SparseIntervalsCollector = void 0;
        var o = n(2428),
          i = function () {
            function t(t) {
              this.intervals = [], this.template = t;
            }
            return t.prototype.add = function (t) {
              this.curr && this.curr.end === t ? this.curr.length++ : (this.curr = this.template.makeByStartLength(t, 1), this.intervals.push(this.curr));
            }, t.prototype.getIntervals = function () {
              return new o.SparseIntervals(this.intervals);
            }, t;
          }();
        e.SparseIntervalsCollector = i;
      },
      5755: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ChangeStyleTextHistoryItem = void 0;
        var r = function (t) {
          function e(e, n, o) {
            return t.call(this, e, n, o) || this;
          }
          return i(e, t), e.prototype.redo = function (t) {
            var e = t.model.findItem(this.itemKey);
            this.oldStyleValue = e.styleText[this.styleProperty], t.changeStyleText(e, this.styleProperty, this.styleValue);
          }, e.prototype.undo = function (t) {
            var e = t.model.findItem(this.itemKey);
            t.changeStyleText(e, this.styleProperty, this.oldStyleValue);
          }, e;
        }(n(8371).ChangeStyleHistoryItemBase);
        e.ChangeStyleTextHistoryItem = r;
      },
      5803: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MergeShapeDescription = void 0;
        var r = n(3255),
          s = n(4412),
          a = n(1833),
          c = n(6208),
          u = n(1280),
          p = n(3844),
          h = function (t) {
            function e() {
              return t.call(this, !0) || this;
            }
            return i(e, t), Object.defineProperty(e.prototype, "key", {
              get: function () {
                return r.ShapeTypes.Merge;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.createShapePrimitives = function (t) {
              var e = t.rectangle,
                n = e.x,
                o = e.y,
                i = e.right,
                r = e.bottom;
              return [new c.PathPrimitive([new c.PathPrimitiveMoveToCommand(n, o), new c.PathPrimitiveLineToCommand(i, o), new c.PathPrimitiveLineToCommand(e.center.x, r), new c.PathPrimitiveClosePathCommand()], t.style)];
            }, e.prototype.calculateHeight = function (t) {
              return .75 * t;
            }, e.prototype.getTextRectangle = function (t) {
              return s.Rectangle.fromGeometry(t.position.clone().offset(t.size.width / 4, u.ShapeTextPadding), new p.Size(t.size.width / 2, t.size.height / 2 - u.ShapeTextPadding));
            }, e.prototype.getSizeByText = function (t, e) {
              return new p.Size(2 * t.width, 2 * (t.height + u.ShapeTextPadding));
            }, e;
          }(a.TriangleShapeDescription);
        e.MergeShapeDescription = h;
      },
      5963: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ChangeStylePropertyCommand = void 0;
        var r = n(6649),
          s = n(3550),
          a = n(5059),
          c = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), e.prototype.getValue = function () {
              return this.control.selection.inputPosition.getCurrentStylePropertyValue(this.getStyleProperty());
            }, e.prototype.getStyleObj = function (t) {
              return t.style;
            }, e.prototype.getDefaultStyleObj = function () {
              return new a.Style();
            }, e.prototype.createHistoryItem = function (t, e, n) {
              return new s.ChangeStyleHistoryItem(t.key, e, n);
            }, e.prototype.updateInputPosition = function (t) {
              this.control.selection.inputPosition.setStylePropertyValue(this.getStyleProperty(), t);
            }, e;
          }(r.ChangeStylePropertyCommandBase);
        e.ChangeStylePropertyCommand = c;
      },
      5978: (t, e) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SelectionRectVisualizer = void 0;
        var n = function () {
          function t(t) {
            this.dispatcher = t;
          }
          return t.prototype.setRectangle = function (t) {
            this.rect = t, this.raiseShow();
          }, t.prototype.reset = function () {
            this.rect = void 0, this.raiseHide();
          }, t.prototype.raiseShow = function () {
            var t = this;
            this.dispatcher.raise1(function (e) {
              return e.notifySelectionRectShow(t.rect);
            });
          }, t.prototype.raiseHide = function () {
            this.dispatcher.raise1(function (t) {
              return t.notifySelectionRectHide();
            });
          }, t;
        }();
        e.SelectionRectVisualizer = n;
      },
      6018: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ShapeImageIndicator = void 0;
        var o = n(7345),
          i = n(6208),
          r = n(6709),
          s = n(8424),
          a = n(94),
          c = n(9500),
          u = function () {
            function t(t, e, n, o, i) {
              this.x = t, this.y = e, this.size = n, this.borderThickness = o, this.className = i, this.animationStarted = !1;
            }
            return t.createLoadingIndicatorPrimitives = function (e, n, o, i, r) {
              return new t(e, n, o, i, r).createLoadingIndicatorPrimitive();
            }, t.createUserIconPrimitives = function (e, n, o, i, r) {
              return new t(e, n, o, i, r).createUserIconPrimitive();
            }, t.createWarningIconPrimitives = function (e, n, o, i) {
              return new t(e, n, o, void 0, i).createWarningIconPrimitive();
            }, t.prototype.rotate = function (t, e, n, o) {
              if (this.animationStarted) {
                var i = "rotate(" + Math.round(o) % 1080 / 3 + " " + e + " " + n + ")";
                t.setAttribute("transform", i), this.animationRequestId = requestAnimationFrame(function (o) {
                  this.rotate(t, e, n, o);
                }.bind(this));
              }
            }, t.prototype.onApplyLoadingIndicatorElementProperties = function (t) {
              var e = [c.UnitConverter.twipsToPixelsF(this.x + this.size / 2), c.UnitConverter.twipsToPixelsF(this.y + this.size / 2)],
                n = e[0],
                o = e[1];
              s.Browser.IE ? (this.animationRequestId = requestAnimationFrame(function (e) {
                this.rotate(t, n, o, e);
              }.bind(this)), this.animationStarted = !0) : t.style.setProperty("transform-origin", n + "px " + o + "px");
            }, t.prototype.center = function () {
              return [c.UnitConverter.twipsToPixelsF(this.x + this.size / 2), c.UnitConverter.twipsToPixelsF(this.y + this.size / 2)];
            }, t.prototype.createLoadingIndicatorPrimitive = function () {
              var t = this.center(),
                e = t[0],
                n = t[1],
                s = c.UnitConverter.twipsToPixelsF(this.size / 2 - this.borderThickness / 2);
              return new r.GroupPrimitive([new o.EllipsePrimitive(e + "", n + "", s + "", s + ""), new i.PathPrimitive([new i.PathPrimitiveMoveToCommand(e + s + "", n + ""), new i.PathPrimitiveArcToCommand(s + "", s + "", 0, !1, !1, e + "", n - s + "")])], this.className, void 0, void 0, this.onApplyLoadingIndicatorElementProperties.bind(this), this.onBeforeDispose.bind(this));
            }, t.prototype.createUserIconPrimitive = function () {
              var t = this.center(),
                e = t[0],
                n = t[1],
                s = c.UnitConverter.twipsToPixelsF(this.size / 2 - this.borderThickness / 2),
                a = c.UnitConverter.twipsToPixelsF(this.size);
              return new r.GroupPrimitive([new o.EllipsePrimitive(e + "", n + "", s + "", s + "", void 0, "dxdi-background"), new o.EllipsePrimitive(e + "", n - a / 8 + "", a / 8 + "", a / 8 + ""), new i.PathPrimitive([new i.PathPrimitiveMoveToCommand(e + "", n + a / 16 + ""), new i.PathPrimitiveCubicCurveToCommand(e + .1375 * a + "", n + a / 16 + "", e + a / 4 + "", n + .11875 * a + "", e + a / 4 + "", n + .1875 * a + ""), new i.PathPrimitiveLineToCommand(e + a / 4 + "", n + a / 4 + ""), new i.PathPrimitiveLineToCommand(e - a / 4 + "", n + a / 4 + ""), new i.PathPrimitiveLineToCommand(e - a / 4 + "", n + .1875 * a + ""), new i.PathPrimitiveCubicCurveToCommand(e - a / 4 + "", n + .11875 * a + "", e - .1375 * a + "", n + a / 16 + "", e + "", n + a / 16 + ""), new i.PathPrimitiveClosePathCommand()])], this.className);
            }, t.prototype.createWarningIconPrimitive = function () {
              var t = this.center(),
                e = t[0],
                n = t[1],
                i = c.UnitConverter.twipsToPixelsF(this.size / 2) - 1,
                s = c.UnitConverter.twipsToPixelsF(this.size / 8);
              return new r.GroupPrimitive([new o.EllipsePrimitive(e + "", n + "", i + "", i + ""), new a.RectanglePrimitive(e - s / 2 + .5 + "", n + i - c.UnitConverter.twipsToPixelsF(this.size / 4) + "", s + "", s + ""), new a.RectanglePrimitive(e - s / 2 + .5 + "", n - i + c.UnitConverter.twipsToPixelsF(this.size / 4) - s + "", s + "", i + "")], this.className);
            }, t.prototype.onBeforeDispose = function () {
              this.animationRequestId && cancelAnimationFrame(this.animationRequestId), this.animationStarted = !1;
            }, t;
          }();
        e.ShapeImageIndicator = u;
      },
      6035: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ModelResizeHistoryItem = void 0;
        var r = n(2616),
          s = n(8601),
          a = n(3844),
          c = function (t) {
            function e(e) {
              var n = t.call(this) || this;
              return n.offset = e, n;
            }
            return i(e, t), e.prototype.redo = function (t) {
              this.oldSize = t.model.size.clone(), this.backOffset = new s.Offsets(-this.offset.left, -this.offset.right, -this.offset.top, -this.offset.bottom);
              var e = Math.max(this.oldSize.width + this.offset.left + this.offset.right, t.model.pageWidth),
                n = Math.max(this.oldSize.height + this.offset.top + this.offset.bottom, t.model.pageHeight);
              t.changeModelSize(new a.Size(e, n), this.offset);
            }, e.prototype.undo = function (t) {
              t.changeModelSize(this.oldSize, this.backOffset);
            }, e;
          }(r.HistoryItem);
        e.ModelResizeHistoryItem = c;
      },
      6056: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.BPMNNode = e.BPMNImporter = void 0;
        var r = n(9071),
          s = n(3255),
          a = n(8573),
          c = n(9933),
          u = function () {
            function t(t) {
              this.doc = c.ImportUtils.createDocument(t), this.graph = new r.Graph([], []);
            }
            return t.prototype.import = function () {
              for (var t = void 0, e = 0; t = this.doc.children[e]; e++) "DEFINITIONS" === t.nodeName.toUpperCase() && this.onDefinitionsElement(t);
              return this.validate(), this.graph;
            }, t.prototype.validate = function () {
              var t = {};
              this.graph.nodes.forEach(function (e) {
                return t[e] = !0;
              });
              for (var e = 0, n = void 0; n = this.graph.edges[e]; e++) t[n.from] && t[n.to] || (this.graph.edges.splice(e, 1), e--);
            }, t.prototype.onDefinitionsElement = function (t) {
              this.dataSourceKey = t.getAttribute("id");
              for (var e = void 0, n = 0; e = t.children[n]; n++) "PROCESS" === e.nodeName.toUpperCase() && this.onProcessElement(e);
            }, t.prototype.onProcessElement = function (t) {
              for (var e = void 0, n = 0; e = t.children[n]; n++) switch (e.nodeName.toUpperCase()) {
                case "STARTEVENT":
                  this.onStartEventElement(e);
                  break;
                case "SEQUENCEFLOW":
                  this.onSequenceFlowElement(e);
                  break;
                case "SCRIPTTASK":
                  this.onScriptTaskElement(e);
                  break;
                case "USERTASK":
                  this.onUserTaskElement(e);
                  break;
                case "SERVICETASK":
                  this.onServiceTaskElement(e);
                  break;
                case "SENDTASK":
                  this.onSendTaskElement(e);
                  break;
                case "EXCLUSIVEGATEWAY":
                  this.onExclusiveGateway(e);
                  break;
                case "ENDEVENT":
                  this.onEndEventGateway(e);
              }
            }, t.prototype.onStartEventElement = function (t) {
              var e = this.createNode(t);
              e.type = s.ShapeTypes.Ellipse, e.text = t.getAttribute("name"), this.graph.addNode(e);
            }, t.prototype.onSequenceFlowElement = function (t) {
              var e = t.getAttribute("sourceRef"),
                n = t.getAttribute("targetRef"),
                o = this.createEdge(t, e, n);
              t.hasAttribute("name") && (o.text = t.getAttribute("name")), this.graph.addEdge(o);
            }, t.prototype.onScriptTaskElement = function (t) {
              var e = this.createNode(t);
              e.text = t.getAttribute("name"), this.graph.addNode(e);
            }, t.prototype.onUserTaskElement = function (t) {
              var e = this.createNode(t);
              e.text = t.getAttribute("name"), this.graph.addNode(e);
            }, t.prototype.onServiceTaskElement = function (t) {
              var e = this.createNode(t);
              e.text = t.getAttribute("name"), this.graph.addNode(e);
            }, t.prototype.onSendTaskElement = function (t) {
              var e = this.createNode(t);
              e.text = t.getAttribute("name"), this.graph.addNode(e);
            }, t.prototype.onExclusiveGateway = function (t) {
              var e = this.createNode(t);
              e.text = t.getAttribute("name"), e.type = s.ShapeTypes.Decision, this.graph.addNode(e);
            }, t.prototype.onEndEventGateway = function (t) {
              var e = this.createNode(t);
              e.text = t.getAttribute("name"), e.type = s.ShapeTypes.Ellipse, this.graph.addNode(e);
            }, t.prototype.createNode = function (t) {
              return new p(this.dataSourceKey, t.getAttribute("id"));
            }, t.prototype.createEdge = function (t, e, n) {
              return new h(this.dataSourceKey, t.getAttribute("id"), e, n);
            }, t;
          }();
        e.BPMNImporter = u;
        var p = function (t, e) {
          this.sourceKey = t, this.key = e, this.type = s.ShapeTypes.Rectangle;
        };
        e.BPMNNode = p;
        var h = function (t) {
          function e(e, n, o, i) {
            var r = t.call(this, n, o, i) || this;
            return r.sourceKey = e, r;
          }
          return i(e, t), e;
        }(a.Edge);
      },
      6089: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ExportImportCommandBase = void 0;
        var r = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(e, t), e.prototype.isEnabledInReadOnlyMode = function () {
            return !0;
          }, e;
        }(n(3913).SimpleCommandBase);
        e.ExportImportCommandBase = r;
      },
      6155: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.DeleteConnectionHistoryItem = void 0;
        var r = n(2616),
          s = n(6320),
          a = function (t) {
            function e(e, n) {
              var o = t.call(this) || this;
              return o.connectorKey = e.key, o.position = n, o.itemKey = e.getExtremeItem(o.position).key, o;
            }
            return i(e, t), e.prototype.redo = function (t) {
              var e = t.model.findConnector(this.connectorKey);
              this.oldConnectionPointIndex = this.position === s.ConnectorPosition.Begin ? e.beginConnectionPointIndex : e.endConnectionPointIndex, t.deleteConnection(e, this.position);
            }, e.prototype.undo = function (t) {
              var e = t.model.findConnector(this.connectorKey),
                n = t.model.findItem(this.itemKey);
              t.addConnection(e, n, this.oldConnectionPointIndex, this.position);
            }, e;
          }(r.HistoryItem);
        e.DeleteConnectionHistoryItem = a;
      },
      6208: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.PathPrimitiveClosePathCommand = e.PathPrimitiveArcToCommand = e.PathPrimitiveQuadraticCurveToCommand = e.PathPrimitiveCubicCurveToCommand = e.PathPrimitiveLineToCommand = e.PathPrimitiveMoveToCommand = e.PathPrimitiveCommand = e.PathPrimitive = void 0;
        var r = n(8509),
          s = n(8309),
          a = n(4762),
          c = function (t) {
            function e(e, n, o, i, r) {
              var s = t.call(this, n, o, i, r) || this;
              return s.commands = e.map(function (t) {
                return t.style = n, t;
              }), s;
            }
            return i(e, t), e.prototype.createMainElement = function () {
              return document.createElementNS(r.svgNS, "path");
            }, e.prototype.applyElementProperties = function (e, n) {
              e.setAttribute("d", this.commands.map(function (t) {
                return t.toString();
              }).join(" ")), this.setPositionCorrectionAttribute(e), t.prototype.applyElementProperties.call(this, e, n);
            }, e;
          }(s.SvgPrimitive);
        e.PathPrimitive = c;
        var u = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(e, t), e;
        }(a.PrimitiveObject);
        e.PathPrimitiveCommand = u;
        var p = function (t) {
          function e(e, n) {
            var o = t.call(this) || this;
            return o.x = e, o.y = n, o;
          }
          return i(e, t), e.prototype.toString = function () {
            return "M " + this.getUnitVaue(this.x) + " " + this.getUnitVaue(this.y);
          }, e.fromPoint = function (t) {
            return new e(t.x, t.y);
          }, e;
        }(u);
        e.PathPrimitiveMoveToCommand = p;
        var h = function (t) {
          function e(e, n) {
            var o = t.call(this) || this;
            return o.x = e, o.y = n, o;
          }
          return i(e, t), e.prototype.toString = function () {
            return "L " + this.getUnitVaue(this.x) + " " + this.getUnitVaue(this.y);
          }, e.fromPoint = function (t) {
            return new e(t.x, t.y);
          }, e;
        }(u);
        e.PathPrimitiveLineToCommand = h;
        var l = function (t) {
          function e(e, n, o, i, r, s) {
            var a = t.call(this) || this;
            return a.x1 = e, a.y1 = n, a.x2 = o, a.y2 = i, a.x3 = r, a.y3 = s, a;
          }
          return i(e, t), e.prototype.toString = function () {
            return "C " + this.getUnitVaue(this.x1) + " " + this.getUnitVaue(this.y1) + "," + this.getUnitVaue(this.x2) + " " + this.getUnitVaue(this.y2) + "," + this.getUnitVaue(this.x3) + " " + this.getUnitVaue(this.y3);
          }, e;
        }(u);
        e.PathPrimitiveCubicCurveToCommand = l;
        var d = function (t) {
          function e(e, n, o, i) {
            var r = t.call(this) || this;
            return r.x1 = e, r.y1 = n, r.x2 = o, r.y2 = i, r;
          }
          return i(e, t), e.prototype.toString = function () {
            return "Q " + this.getUnitVaue(this.x1) + " " + this.getUnitVaue(this.y1) + "," + this.getUnitVaue(this.x2) + " " + this.getUnitVaue(this.y2);
          }, e;
        }(u);
        e.PathPrimitiveQuadraticCurveToCommand = d;
        var f = function (t) {
          function e(e, n, o, i, r, s, a) {
            var c = t.call(this) || this;
            return c.rx = e, c.ry = n, c.xAxisRotation = o, c.largeArcFlag = i, c.sweepFag = r, c.x = s, c.y = a, c;
          }
          return i(e, t), e.prototype.toString = function () {
            return "A " + this.getUnitVaue(this.rx) + " " + this.getUnitVaue(this.ry) + " " + this.getUnitVaue(this.xAxisRotation) + " " + (this.largeArcFlag ? "1" : "0") + " " + (this.sweepFag ? "1" : "0") + this.getUnitVaue(this.x) + "," + this.getUnitVaue(this.y);
          }, e;
        }(u);
        e.PathPrimitiveArcToCommand = f;
        var y = function (t) {
          function e() {
            return t.call(this) || this;
          }
          return i(e, t), e.prototype.toString = function () {
            return "z";
          }, e;
        }(u);
        e.PathPrimitiveClosePathCommand = y;
      },
      6210: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SortedQueues = void 0;
        var o = n(124),
          i = function () {
            function t(t) {
              this.getKey = t, this._itemsArrays = {}, this._sortedKeys = [];
            }
            return Object.defineProperty(t.prototype, "sortedKeys", {
              get: function () {
                return this._sortedKeys;
              },
              enumerable: !1,
              configurable: !0
            }), t.prototype.getQueue = function (t) {
              return this._itemsArrays[t];
            }, t.prototype.enqueue = function (t) {
              var e = this.getKey(t);
              void 0 === this._itemsArrays[e] ? (this._itemsArrays[e] = [t], this.addSortedKey(e)) : this._itemsArrays[e].push(t);
            }, t.prototype.remove = function (t) {
              var e = this.getKey(t),
                n = this._itemsArrays[e];
              void 0 !== n && (n.length ? n[0] === t ? (n.shift(), n.length || this.removeCore(e)) : this._itemsArrays[e] = n.filter(function (e) {
                return e !== t;
              }) : this.removeCore(e));
            }, t.prototype.dequeueMin = function () {
              if (this._sortedKeys.length) {
                var t = this._sortedKeys[0],
                  e = this._itemsArrays[t],
                  n = e.shift();
                return e.length || this.removeCore(t), n;
              }
            }, t.prototype.removeCore = function (t) {
              delete this._itemsArrays[t], this.removeSortedKey(t);
            }, t.prototype.removeSortedKey = function (t) {
              var e = o.SearchUtils.binaryIndexOf(this._sortedKeys, function (e) {
                return e - t;
              });
              e >= 0 && this.sortedKeys.splice(e, 1);
            }, t.prototype.addSortedKey = function (t) {
              var e = o.SearchUtils.binaryIndexOf(this._sortedKeys, function (e) {
                return e - t;
              });
              e < 0 && this._sortedKeys.splice(-(e + 1), 0, t);
            }, t;
          }();
        e.SortedQueues = i;
      },
      6283: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.HorizontalContainerDescription = void 0;
        var r = n(1280),
          s = n(4412),
          a = n(3844),
          c = n(5327),
          u = n(3255),
          p = n(6687),
          h = n(94),
          l = n(128),
          d = function (t) {
            function e() {
              return t.call(this, new a.Size(2 * r.ShapeDefaultDimension, 1.5 * r.ShapeDefaultDimension)) || this;
            }
            return i(e, t), Object.defineProperty(e.prototype, "key", {
              get: function () {
                return u.ShapeTypes.HorizontalContainer;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.getExpandedSize = function (t) {
              return new a.Size(t.expandedSize.width, t.size.height);
            }, e.prototype.getCollapsedSize = function (t) {
              return new a.Size(p.CONTAINER_HEADER_SIZE + 2 * t.strokeWidth, t.size.height);
            }, e.prototype.allowResizeHorizontally = function (t) {
              return t.expanded;
            }, e.prototype.createHeaderPrimitives = function (t, e) {
              var n = t.rectangle,
                o = n.x,
                i = n.y,
                r = n.height,
                a = this.getHeaderSize(t, e),
                c = [];
              return c = c.concat([new h.RectanglePrimitive(o, i, a, r, t.style)]), e || (c = c.concat(this.createExpandButtonPrimitives(t, new s.Rectangle(o, i, a, a)))), c;
            }, e.prototype.getClientRectangle = function (t) {
              var e = t.rectangle,
                n = this.getHeaderSize(t);
              return s.Rectangle.fromGeometry(new c.Point(e.x + n, e.y), new a.Size(e.width - n, e.height));
            }, e.prototype.getTextRectangle = function (t) {
              var e = t.rectangle,
                n = this.getHeaderSize(t);
              return s.Rectangle.fromGeometry(new c.Point(e.x, e.y + n), new a.Size(n, e.height - n)).nonNegativeSize();
            }, e.prototype.getSizeByText = function (t, e) {
              var n = this.getHeaderSize(e);
              return new a.Size(e.size.width, Math.max(e.size.height, Math.max(t.width + n, e.size.height)));
            }, e.prototype.getTextEditRectangle = function (t) {
              var e = this.getTextRectangle(t);
              return s.Rectangle.fromGeometry(new c.Point(e.x, e.y + e.height), new a.Size(e.height, e.width));
            }, e.prototype.getTextAngle = function () {
              return l.TextAngle.Angle270deg;
            }, e.prototype.getHeaderSize = function (t, e) {
              var n = t.rectangle;
              return e ? n.height * p.CONTAINER_HEADER_TOOLBOX_SIZE_RATIO : p.CONTAINER_HEADER_SIZE + 2 * t.strokeWidth;
            }, e;
          }(p.ContainerDescription);
        e.HorizontalContainerDescription = d;
      },
      6309: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.EventManager = void 0;
        var o = n(779),
          i = n(41),
          r = n(113),
          s = n(2803),
          a = n(2394),
          c = n(9860),
          u = n(3377),
          p = n(7942),
          h = n(8424),
          l = n(6537),
          d = function () {
            function t(t) {
              this.onMouseOperation = new i.EventDispatcher(), this.onTextInputOperation = new i.EventDispatcher(), this.toolboxes = [], this.control = t, this.visualizersManager = i.EventUtils.isTouchMode() ? new u.VisualizerTouchManager(t.selection, t.model, this, t.settings) : new c.VisualizerManager(t.selection, t.model, this, t.settings), this.onMouseOperation.add(this.visualizersManager), this.contextMenuHandler = h.Browser.TouchUI ? new a.ContextMenuTouchHandler(t.selection) : new s.ContextMenuHandler(), this.contextMenuHandler.onVisibilityChanged.add(t), this.onMouseOperation.add(this.contextMenuHandler), this.onTextInputOperation.add(this.contextMenuHandler), this.contextToolboxHandler = new p.ContextToolboxHandler(), this.contextToolboxHandler.onVisibilityChanged.add(t), this.contextToolboxHandler.onVisibilityChanged.add(this.contextMenuHandler), this.mouseHandler = new o.MouseHandler(t.history, t.selection, t.model, this, t.settings.readOnly, t.view, this.visualizersManager, this.contextToolboxHandler, t.shapeDescriptionManager, t.settings, t.permissionsProvider), this.textInputHandler = new r.TextInputHandler(t), this.visualizersManager.onVisualizersUpdate.add(this.mouseHandler);
            }
            return Object.defineProperty(t.prototype, "onVisualizersUpdate", {
              get: function () {
                return this.visualizersManager.onVisualizersUpdate;
              },
              enumerable: !1,
              configurable: !0
            }), t.prototype.registerToolbox = function (t) {
              this.toolboxes.push(t);
            }, t.prototype.cleanToolboxes = function (t) {
              this.toolboxes.forEach(function (e) {
                t.remove(e);
              }), this.toolboxes = [];
            }, t.prototype.initialize = function () {
              this.visualizersManager.initialize(this.control.model), this.mouseHandler.initialize(this.control.model), this.textInputHandler.reset();
            }, t.prototype.beginUpdate = function (t) {
              this.contextMenuHandler.beginUpdate(), this.visualizersManager.beginUpdate();
            }, t.prototype.endUpdate = function () {
              this.contextMenuHandler.endUpdate(), this.visualizersManager.endUpdate();
            }, t.prototype.onMouseDown = function (t) {
              this.mouseHandler.onMouseDown(t), this.contextMenuHandler.onMouseDown(t), this.visualizersManager.onMouseDown(t), this.contextToolboxHandler.onMouseDown(t);
            }, t.prototype.onMouseMove = function (t) {
              this.processDragging(t), this.mouseHandler.onMouseMove(t);
            }, t.prototype.onMouseUp = function (t) {
              this.contextToolboxHandler.onMouseUp(t), this.mouseHandler.onMouseUp(t), this.contextMenuHandler.onMouseUp(t), this.visualizersManager.onMouseUp(t), this.processDragging(t);
            }, t.prototype.onMouseEnter = function (t) {
              this.visualizersManager.onMouseEnter(t);
            }, t.prototype.onMouseLeave = function (t) {
              this.visualizersManager.onMouseLeave(t);
            }, t.prototype.onDblClick = function (t) {
              this.mouseHandler.onMouseDblClick(t), this.textInputHandler.onDblClick(t), this.control.apiController.notifyDblClick(t);
            }, t.prototype.onClick = function (t) {
              this.mouseHandler.onMouseClick(t), this.control.apiController.notifyClick(t);
            }, t.prototype.onContextMenu = function (t) {
              this.contextMenuHandler.onContextMenu(t);
            }, t.prototype.onLongTouch = function (t) {
              this.mouseHandler.onLongTouch(t), this.contextMenuHandler.onLongTouch(t);
            }, t.prototype.onBlur = function (t) {
              this.contextMenuHandler.onBlur(t), this.contextToolboxHandler.onBlur(t), this.visualizersManager.onBlur(t);
            }, t.prototype.onFocus = function (t) {
              this.contextMenuHandler.onFocus(t), this.contextToolboxHandler.onFocus(t), this.visualizersManager.onFocus(t);
            }, t.prototype.onKeyDown = function (t) {
              var e = t.getShortcutCode();
              this.onShortcut(e) ? (this.visualizersManager.updateConnectionPoints(), this.contextMenuHandler.onShortcut(t), this.contextToolboxHandler.onShortcut(t), t.preventDefault = !0) : this.isShortcutForFocusInput(e) && (t.preventDefault = !0), this.contextMenuHandler.onKeyDown(t), this.contextToolboxHandler.onKeyDown(t), this.mouseHandler.onKeyDown(t);
            }, t.prototype.onKeyUp = function (t) {
              this.mouseHandler.onKeyUp(t);
            }, t.prototype.onTextInputBlur = function (t) {
              this.textInputHandler.onBlur(t), this.contextMenuHandler.onTextInputBlur(t);
            }, t.prototype.onTextInputFocus = function (t) {
              this.textInputHandler.onFocus(t), this.contextMenuHandler.onTextInputFocus(t);
            }, t.prototype.onTextInputKeyDown = function (t) {
              this.textInputHandler.onKeyDown(t);
            }, t.prototype.onShortcut = function (t) {
              return !!this.control.commandManager.processShortcut(t) || !!this.mouseHandler.onShortcut(t) || void 0;
            }, t.prototype.isShortcutForFocusInput = function (t) {
              return t === l.KeyCode.Delete || t === (l.KeyCode.Delete | l.ModifierKey.Ctrl) || t === (l.KeyCode.Delete | l.ModifierKey.Meta) || t === l.KeyCode.Backspace || t === (l.KeyCode.Backspace | l.ModifierKey.Ctrl) || t === (l.KeyCode.Backspace | l.ModifierKey.Shift) || t === (l.KeyCode.Backspace | l.ModifierKey.Meta) || t === l.KeyCode.Home || t === l.KeyCode.End || t === l.KeyCode.Up || t === (l.KeyCode.Up | l.ModifierKey.Ctrl) || t === (l.KeyCode.Up | l.ModifierKey.Meta) || t === l.KeyCode.Down || t === (l.KeyCode.Down | l.ModifierKey.Ctrl) || t === (l.KeyCode.Down | l.ModifierKey.Meta) || t === l.KeyCode.Left || t === (l.KeyCode.Left | l.ModifierKey.Ctrl) || t === (l.KeyCode.Left | l.ModifierKey.Meta) || t === l.KeyCode.Right || t === (l.KeyCode.Right | l.ModifierKey.Ctrl) || t === (l.KeyCode.Right | l.ModifierKey.Meta);
            }, t.prototype.onPaste = function (t) {
              !this.textInputHandler.isTextInputActive() && this.control.commandManager.processPaste(t.clipboardData) && (this.visualizersManager.updateConnectionPoints(), t.preventDefault = !0);
            }, t.prototype.onMouseWheel = function (t) {
              this.mouseHandler.onWheel(t) && (t.preventDefault = !0);
            }, t.prototype.isFocused = function () {
              return this.control.isFocused();
            }, t.prototype.processDragging = function (t) {
              var e = this.getDraggingEvent();
              e && this.draggingEvent !== e ? (this.draggingEvent = e, this.mouseHandler.onDragStart(this.draggingEvent), this.control.captureFocus()) : !e && this.draggingEvent && (delete this.draggingEvent, this.mouseHandler.onDragEnd(t));
            }, t.prototype.getDraggingEvent = function () {
              return this.toolboxes.filter(function (t) {
                return t.draggingObject;
              }).map(function (t) {
                return t.draggingObject.evt;
              })[0];
            }, t.prototype.onDocumentDragStart = function (t) {
              this.control.beginUpdate(), this.control.captureFocus(), this.onMouseOperation.raise("notifyDragStart", t);
            }, t.prototype.onDocumentDragEnd = function (t) {
              this.onMouseOperation.raise("notifyDragEnd", t), this.control.endUpdate(), this.control.barManager.updateItemsState();
            }, t.prototype.onDocumentDragScrollStart = function () {
              this.onMouseOperation.raise1(function (t) {
                return t.notifyDragScrollStart();
              });
            }, t.prototype.onDocumentDragScrollEnd = function () {
              this.onMouseOperation.raise1(function (t) {
                return t.notifyDragScrollEnd();
              });
            }, t.prototype.onDocumentClick = function (t) {
              this.control.beginUpdate(), this.control.endUpdate(), this.control.barManager.updateItemsState();
            }, t.prototype.raiseTextInputStart = function (t, e, n, o) {
              this.onTextInputOperation.raise("notifyTextInputStart", t, e, n, o);
            }, t.prototype.raiseTextInputEnd = function (t, e) {
              this.onTextInputOperation.raise("notifyTextInputEnd", t, e);
            }, t.prototype.raiseTextInputPermissionsCheck = function (t, e) {
              this.onTextInputOperation.raise("notifyTextInputPermissionsCheck", t, e);
            }, t.prototype.canFinishTextEditing = function () {
              return this.textInputHandler.canFinishTextEditing();
            }, t;
          }();
        e.EventManager = d;
      },
      6320: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Connector = e.CONNECTOR_DEFAULT_TEXT_POSITION = e.ConnectorPosition = void 0;
        var r,
          s = n(9500),
          a = n(4412),
          c = n(476),
          u = n(3844),
          p = n(5707),
          h = n(4235),
          l = n(5428),
          d = n(5650),
          f = n(6208),
          y = n(128),
          g = n(2136),
          m = n(9307),
          v = n(41),
          P = n(4824),
          C = n(1922),
          S = n(3105),
          x = n(3918),
          b = n(1960),
          w = n(4385),
          I = n(8514),
          T = n(5359);
        !function (t) {
          t[t.Begin = 0] = "Begin", t[t.End = 1] = "End";
        }(r = e.ConnectorPosition || (e.ConnectorPosition = {})), e.CONNECTOR_DEFAULT_TEXT_POSITION = .5;
        var O = function (t) {
          function n(e) {
            var n = t.call(this) || this;
            if (n.beginConnectionPointIndex = -1, n.endConnectionPointIndex = -1, n.properties = new w.ConnectorProperties(), n.points = e.map(function (t) {
              return t.clone();
            }), e.length < 2) throw Error("Points count should be greater than 1");
            return n.texts = new I.ConnectorTexts(), n;
          }
          return i(n, t), Object.defineProperty(n.prototype, "rectangle", {
            get: function () {
              return v.GeometryUtils.createRectagle(this.getRenderPoints(!0));
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(n.prototype, "skippedRenderPoints", {
            get: function () {
              return this.renderPoints ? this.renderPoints.filter(function (t) {
                return t.skipped;
              }) : void 0;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(n.prototype, "shouldChangeRenderPoints", {
            get: function () {
              return void 0 !== this.renderPoints && void 0 !== this.routingStrategy;
            },
            enumerable: !1,
            configurable: !0
          }), n.prototype.assign = function (e) {
            t.prototype.assign.call(this, e), e.beginItem = this.beginItem, e.beginConnectionPointIndex = this.beginConnectionPointIndex, e.endItem = this.endItem, e.endConnectionPointIndex = this.endConnectionPointIndex, e.properties = this.properties.clone(), e.texts = this.texts.clone(), void 0 !== this.routingStrategy && (e.routingStrategy = this.routingStrategy.clone()), void 0 !== this.renderPoints && (e.renderPoints = this.renderPoints.map(function (t) {
              return t.clone();
            })), void 0 !== this.renderPointsWithoutSkipped && (e.renderPointsWithoutSkipped = this.renderPointsWithoutSkipped.map(function (t) {
              return t.clone();
            })), void 0 !== this.actualRoutingMode && (e.actualRoutingMode = this.actualRoutingMode), void 0 !== this.lockCreateRenderPoints && (e.lockCreateRenderPoints = this.lockCreateRenderPoints), void 0 !== this.shouldInvalidateRenderPoints && (e.shouldInvalidateRenderPoints = this.shouldInvalidateRenderPoints);
          }, n.prototype.clone = function () {
            var t = new n(this.points);
            return this.assign(t), t;
          }, n.prototype.getTextCount = function () {
            return this.texts.count();
          }, n.prototype.getText = function (t) {
            void 0 === t && (t = e.CONNECTOR_DEFAULT_TEXT_POSITION);
            var n = this.texts.get(t);
            return n ? n.value : "";
          }, n.prototype.setText = function (t, n) {
            void 0 === n && (n = e.CONNECTOR_DEFAULT_TEXT_POSITION), t && "" !== t ? this.texts.set(n, new I.ConnectorText(n, t)) : this.texts.remove(n);
          }, n.prototype.getTextPoint = function (t) {
            var e = this.getRenderPoints();
            return v.GeometryUtils.getPathPointByPosition(e, t)[0];
          }, n.prototype.getTextPositionByPoint = function (t) {
            var e = this.getRenderPoints(),
              n = v.GeometryUtils.getPathLength(e),
              o = v.GeometryUtils.getPathPositionByPoint(e, t),
              i = s.UnitConverter.pointsToTwips(parseInt(this.styleText["font-size"]));
            return i > o * n ? i / n : i > n - o * n ? (n - i) / n : o;
          }, n.prototype.getTextRectangle = function (t) {
            return a.Rectangle.fromGeometry(this.getTextPoint(t), new u.Size(0, 0));
          }, n.prototype.changeRoutingStrategy = function (t) {
            this.routingStrategy = t, this.invalidateRenderPoints();
          }, n.prototype.clearRoutingStrategy = function () {
            delete this.routingStrategy, delete this.renderPoints, delete this.renderPointsWithoutSkipped, delete this.lockCreateRenderPoints, delete this.actualRoutingMode, delete this.shouldInvalidateRenderPoints, this.invalidateRenderPoints();
          }, n.prototype.getCustomRenderPoints = function (t) {
            void 0 === t && (t = !1);
            var e = this.getRenderPoints(t),
              n = [];
            return e.forEach(function (t, o) {
              o > 0 && o < e.length - 1 && n.push(t);
            }), n;
          }, n.prototype.getRenderPoints = function (t) {
            if (void 0 === t && (t = !1), (void 0 === this.shouldInvalidateRenderPoints || this.shouldInvalidateRenderPoints) && (this.shouldInvalidateRenderPoints = !1, this.routingStrategy && this.lockCreateRenderPoints || this.changeRenderPoints(this.getCalculator().getPoints()), this.routingStrategy && !this.lockCreateRenderPoints && this.actualRoutingMode !== m.ConnectorRoutingMode.None && this.points && this.renderPoints)) {
              var e = this.points[0],
                n = this.points[this.points.length - 1];
              if (!e.equals(n)) {
                var o = this.routingStrategy.createRenderPoints(this.points, this.renderPoints, this.beginItem, this.endItem, this.beginConnectionPointIndex, this.endConnectionPointIndex, C.ModelUtils.getConnectorContainer(this));
                o ? (this.changeRenderPoints(o), this.actualRoutingMode = m.ConnectorRoutingMode.AllShapesOnly) : this.actualRoutingMode = m.ConnectorRoutingMode.None;
              }
            }
            return t ? this.renderPoints : this.renderPointsWithoutSkipped;
          }, n.prototype.tryCreateRenderPointsContext = function (t) {
            return t || this.shouldChangeRenderPoints ? new T.ConnectorRenderPointsContext(this.renderPoints.map(function (t) {
              return t.clone();
            }), this.lockCreateRenderPoints, this.actualRoutingMode) : void 0;
          }, n.prototype.updatePointsOnPageResize = function (t, e) {
            this.points = this.points.map(function (n) {
              return n.clone().offset(t, e);
            }), this.renderPoints && this.changeRenderPoints(this.renderPoints.map(function (n) {
              var o = n.clone().offset(t, e);
              return o.pointIndex = n.pointIndex, o.skipped = n.skipped, o;
            }));
          }, n.prototype.addPoint = function (t, e) {
            this.points.splice(t, 0, e);
          }, n.prototype.deletePoint = function (t) {
            this.points.splice(t, 1);
          }, n.prototype.movePoint = function (t, e) {
            this.points[t] = e;
          }, n.prototype.onAddPoint = function (t, e) {
            this.shouldChangeRenderPoints ? this.replaceRenderPointsCore(this.routingStrategy.onAddPoint(this.points, t, e, this.renderPoints), !0, m.ConnectorRoutingMode.AllShapesOnly) : this.invalidateRenderPoints();
          }, n.prototype.onDeletePoint = function (t) {
            this.shouldChangeRenderPoints ? this.replaceRenderPointsCore(this.routingStrategy.onDeletePoint(this.points, t, this.renderPoints), this.points.length > 2, m.ConnectorRoutingMode.AllShapesOnly) : this.invalidateRenderPoints();
          }, n.prototype.onMovePoint = function (t, e) {
            this.shouldChangeRenderPoints ? (0 !== t && t !== this.points.length - 1 || (this.lockCreateRenderPoints = !1), this.replaceRenderPointsCore(this.routingStrategy.onMovePoint(this.points, t, e, this.renderPoints), this.lockCreateRenderPoints, m.ConnectorRoutingMode.AllShapesOnly)) : this.invalidateRenderPoints();
          }, n.prototype.onMovePoints = function (t, e, n) {
            this.shouldChangeRenderPoints ? (0 !== t && e !== this.points.length - 1 || (this.lockCreateRenderPoints = !1), this.replaceRenderPointsCore(this.routingStrategy.onMovePoints(this.points, t, e, n, this.renderPoints), this.lockCreateRenderPoints, m.ConnectorRoutingMode.AllShapesOnly)) : this.invalidateRenderPoints();
          }, n.prototype.replaceRenderPoints = function (t, e) {
            void 0 !== t ? (this.replaceRenderPointsCore(t.renderPoints, t.lockCreateRenderPoints, t.actualRoutingMode), void 0 !== e && (this.shouldInvalidateRenderPoints = e)) : this.invalidateRenderPoints();
          }, n.prototype.clearRenderPoints = function () {
            this.changeRenderPoints(void 0), this.lockCreateRenderPoints = !1, this.actualRoutingMode = void 0, this.invalidateRenderPoints();
          }, n.prototype.unlockCreateRenderPoints = function () {
            this.lockCreateRenderPoints = !1;
          }, n.prototype.replaceRenderPointsCore = function (t, e, n) {
            this.changeRenderPoints(t), this.lockCreateRenderPoints = e, this.actualRoutingMode = n, this.invalidateRenderPoints();
          }, n.prototype.changeRenderPoints = function (t) {
            this.renderPoints = t, this.renderPointsWithoutSkipped = t ? this.renderPoints.filter(function (t) {
              return !t.skipped;
            }) : void 0;
          }, n.prototype.getCalculator = function () {
            return this.properties.lineOption === w.ConnectorLineOption.Straight ? new S.ConnectorPointsCalculator(this) : new x.ConnectorPointsOrthogonalCalculator(this);
          }, n.prototype.invalidateRenderPoints = function () {
            this.shouldInvalidateRenderPoints = !0;
          }, n.prototype.createPrimitives = function (t) {
            var e = [],
              n = this.getRenderPoints(),
              o = new f.PathPrimitive(n.map(function (t, e) {
                return 0 === e ? new f.PathPrimitiveMoveToCommand(t.x, t.y) : new f.PathPrimitiveLineToCommand(t.x, t.y);
              }), this.style);
            return e.push(o), e = (e = e.concat(this.createLineEndingPrimitives(n, o))).concat(this.createTextPrimitives(t));
          }, n.prototype.createLineEndingPrimitives = function (t, e) {
            var n = [];
            t.length > 1 && [{
              strategy: this.createLineEndingStrategy(this.properties.startLineEnding),
              point1: t[0],
              point2: t[1]
            }, {
              strategy: this.createLineEndingStrategy(this.properties.endLineEnding),
              point1: t[t.length - 1],
              point2: t[t.length - 2]
            }].forEach(function (t) {
              var o = t.strategy;
              if (o.hasCommands()) {
                var i = e;
                o.needCreateSeparatePrimitive() && n.push(i = o.createPrimitive()), i.commands = i.commands.concat(o.createCommands(t.point1, t.point2));
              }
            });
            return n;
          }, n.prototype.createLineEndingStrategy = function (t) {
            switch (t) {
              case w.ConnectorLineEnding.None:
                return new b.ConnectorLineEndingNoneStrategy(this.style);
              case w.ConnectorLineEnding.Arrow:
                return new b.ConnectorLineEndingArrowStrategy(this.style);
              case w.ConnectorLineEnding.OutlinedTriangle:
                return new b.ConnectorLineEndingOutlinedTriangleStrategy(this.style);
              case w.ConnectorLineEnding.FilledTriangle:
                return new b.ConnectorLineEndingFilledTriangleStrategy(this.style);
              default:
                return new b.ConnectorLineEndingStrategy(this.style);
            }
          }, n.prototype.createSelectorPrimitives = function () {
            var t = [],
              e = this.getRenderPoints();
            return t.push(new f.PathPrimitive(e.map(function (t, e) {
              return 0 === e ? new f.PathPrimitiveMoveToCommand(t.x, t.y) : new f.PathPrimitiveLineToCommand(t.x, t.y);
            }), null, "selector")), t;
          }, n.prototype.createTextPrimitives = function (t) {
            var e = this;
            if (!this.enableText) return [];
            var n = [];
            return this.texts.forEach(function (o) {
              var i = e.getText(o.position);
              if (i && "" !== i) {
                var r = e.getTextPoint(o.position);
                n = n.concat([new y.TextPrimitive(r.x, r.y, i, d.TextOwner.Connector, void 0, void 0, void 0, e.styleText, !0, null, p.PAGE_BG_TEXTFLOOR_FILTER_IDPREFIX + t, void 0, function (t) {
                  g.RenderUtils.setElementEventData(t, l.MouseEventElementType.ConnectorText, e.key, o.position);
                })]);
              }
            }), n;
          }, n.prototype.getExtremeItem = function (t) {
            return t === r.Begin ? this.beginItem : t === r.End ? this.endItem : null;
          }, n.prototype.getExtremeConnectionPointIndex = function (t) {
            return t === r.Begin ? this.beginConnectionPointIndex : t === r.End ? this.endConnectionPointIndex : -1;
          }, n.prototype.getMinX = function () {
            return this.getRenderPoints().map(function (t) {
              return t.x;
            }).reduce(function (t, e) {
              return Math.min(t, e);
            }, Number.MAX_VALUE);
          }, n.prototype.getMinY = function () {
            return this.getRenderPoints().map(function (t) {
              return t.y;
            }).reduce(function (t, e) {
              return Math.min(t, e);
            }, Number.MAX_VALUE);
          }, n.prototype.getConnectionPoints = function () {
            return [];
          }, n.prototype.getConnectionPointSide = function (t, e) {
            return P.ConnectionPointSide.Undefined;
          }, n.prototype.getSegments = function () {
            var t = [],
              e = this.getRenderPoints();
            return e.forEach(function (n, o) {
              o > 0 && t.push(new c.Segment(e[o - 1], n));
            }), t;
          }, n.prototype.intersectedByRect = function (t) {
            return this.getSegments().some(function (e) {
              return e.isIntersectedByRect(t);
            });
          }, n.prototype.toNative = function (t) {
            var e = new h.NativeConnector(this.key, this.dataKey);
            return e.fromKey = this.beginItem && this.beginItem.dataKey, e.toKey = this.endItem && this.endItem.dataKey, e.texts = this.texts.map(function (t) {
              return t;
            }).sort(function (t, e) {
              return t.position - e.position;
            }).map(function (t) {
              return t.value;
            }), e.fromId = this.beginItem && this.beginItem.key, e.fromPointIndex = this.beginConnectionPointIndex, e.toId = this.endItem && this.endItem.key, e.toPointIndex = this.endConnectionPointIndex, e.points = this.points.map(function (t) {
              return t.clone();
            }), e.applyUnits(t), e;
          }, n.minOffset = s.UnitConverter.pixelsToTwips(24), n.minTextHeight = s.UnitConverter.pixelsToTwips(12), n;
        }(P.DiagramItem);
        e.Connector = O;
      },
      6389: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ImportBPMNCommand = void 0;
        var r = n(6056),
          s = n(1922),
          a = n(8214),
          c = n(5327),
          u = n(6320),
          p = n(4048),
          h = n(4139),
          l = n(2626),
          d = n(9212),
          f = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), e.prototype.executeCore = function (t, e) {
              var n = new r.BPMNImporter(e).import();
              return this.updateModel(n), !0;
            }, e.prototype.updateModel = function (t) {
              var e = this,
                n = {},
                o = [],
                i = [];
              this.control.history.beginTransaction(), t.items.forEach(function (t) {
                var i = new a.AddShapeHistoryItem(e.getShapeDescription(t.type), new c.Point(0, 0), t.text, t.key);
                e.control.history.addAndRedo(i), n[t.key] = i.shapeKey;
                var r = e.control.model.findShape(i.shapeKey);
                o.push(r);
              }), t.edges.forEach(function (t) {
                var o = e.control.model.findShape(n[t.from]),
                  r = e.control.model.findShape(n[t.to]),
                  s = new p.AddConnectorHistoryItem([o.getConnectionPointPosition(0), r.getConnectionPointPosition(0)]);
                e.control.history.addAndRedo(s);
                var a = e.control.model.findConnector(s.connectorKey);
                e.control.history.addAndRedo(new h.AddConnectionHistoryItem(a, o, 0, u.ConnectorPosition.Begin)), e.control.history.addAndRedo(new h.AddConnectionHistoryItem(a, r, 0, u.ConnectorPosition.End)), i.push(a);
              });
              var r = new d.LayoutSettings();
              s.ModelUtils.getGraphInfoByItems(this.control.model, o, i).forEach(function (t) {
                var n = new l.SugiyamaLayoutBuilder(r, t.graph).build(),
                  a = s.ModelUtils.getNonGraphItems(e.control.model, t.container, n.nodeToLayout, o, i);
                s.ModelUtils.applyLayout(e.control.history, e.control.model, void 0, t.graph, n, a, r, e.control.settings.snapToGrid, e.control.settings.gridSize, !1);
              }), s.ModelUtils.tryUpdateModelRectangle(this.control.history), this.control.history.endTransaction();
            }, e.prototype.getShapeDescription = function (t) {
              return this.control.shapeDescriptionManager.get(t);
            }, e;
          }(n(6089).ExportImportCommandBase);
        e.ImportBPMNCommand = f;
      },
      6435: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ChangeStrokeWidthCommand = void 0;
        var r = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(e, t), e.prototype.getStyleProperty = function () {
            return "stroke-width";
          }, e;
        }(n(5963).ChangeStylePropertyCommand);
        e.ChangeStrokeWidthCommand = r;
      },
      6476: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ChangeShapeTextHistoryItem = void 0;
        var r = function (t) {
          function e(e, n) {
            var o = t.call(this) || this;
            return o.shapeKey = e.key, o.text = n, o;
          }
          return i(e, t), e.prototype.redo = function (t) {
            var e = t.model.findShape(this.shapeKey);
            this.oldText = e.text, t.changeShapeText(e, this.text);
          }, e.prototype.undo = function (t) {
            var e = t.model.findShape(this.shapeKey);
            t.changeShapeText(e, this.oldText);
          }, e;
        }(n(2616).HistoryItem);
        e.ChangeShapeTextHistoryItem = r;
      },
      6512: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SetSelectionHistoryItem = void 0;
        var r = function (t) {
          function e(e, n, o) {
            var i = t.call(this) || this;
            return i.selectedKeys = n, i.selection = e, i.forceChange = o, i;
          }
          return i(e, t), e.prototype.redo = function () {
            this.oldSelection = this.selection.getKeys().slice(0), this.selection.set(this.selectedKeys, this.forceChange);
          }, e.prototype.undo = function () {
            this.selection.set(this.oldSelection, this.forceChange);
          }, e;
        }(n(2616).HistoryItem);
        e.SetSelectionHistoryItem = r;
      },
      6537: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.KeyCode = e.ModifierKey = e.KeyUtils = void 0;
        var o,
          i,
          r = n(8424),
          s = n(9030),
          a = n(4989),
          c = function () {
            function t() {}
            return t.getKeyModifiers = function (t) {
              var e = 0;
              return t.altKey && (e |= o.Alt), t.ctrlKey && (e |= o.Ctrl), t.shiftKey && (e |= o.Shift), t.metaKey && (e |= o.Meta), e;
            }, t.getShortcutCode = function (t, e, n, i, r) {
              var s = t;
              return s |= e ? o.Ctrl : 0, s |= n ? o.Shift : 0, s |= i ? o.Alt : 0, s |= r ? o.Meta : 0;
            }, t.getShortcutCodeByEvent = function (e) {
              return t.getShortcutCode(t.getEventKeyCode(e), e.ctrlKey, e.shiftKey, e.altKey, !!r.Browser.MacOSPlatform && e.metaKey);
            }, t.getEventKeyCode = function (t) {
              return r.Browser.NetscapeFamily || r.Browser.Opera ? t.which : t.keyCode;
            }, t.parseShortcutString = function (e) {
              if (!e) return 0;
              var n = !1,
                o = !1,
                r = !1,
                c = !1,
                u = null,
                p = e.toString().split("+");
              if (p.length > 0) for (var h = 0; h < p.length; h++) {
                var l = a.StringUtils.trim(p[h].toUpperCase());
                switch (l) {
                  case "CONTROL":
                  case "CONTROLKEY":
                  case "CTRL":
                    n = !0;
                    break;
                  case "SHIFT":
                  case "SHIFTKEY":
                    o = !0;
                    break;
                  case "ALT":
                    r = !0;
                    break;
                  case "CMD":
                    c = !0;
                    break;
                  case "F1":
                    u = i.F1;
                    break;
                  case "F2":
                    u = i.F2;
                    break;
                  case "F3":
                    u = i.F3;
                    break;
                  case "F4":
                    u = i.F4;
                    break;
                  case "F5":
                    u = i.F5;
                    break;
                  case "F6":
                    u = i.F6;
                    break;
                  case "F7":
                    u = i.F7;
                    break;
                  case "F8":
                    u = i.F8;
                    break;
                  case "F9":
                    u = i.F9;
                    break;
                  case "F10":
                    u = i.F10;
                    break;
                  case "F11":
                    u = i.F11;
                    break;
                  case "F12":
                    u = i.F12;
                    break;
                  case "RETURN":
                  case "ENTER":
                    u = i.Enter;
                    break;
                  case "HOME":
                    u = i.Home;
                    break;
                  case "END":
                    u = i.End;
                    break;
                  case "LEFT":
                    u = i.Left;
                    break;
                  case "RIGHT":
                    u = i.Right;
                    break;
                  case "UP":
                    u = i.Up;
                    break;
                  case "DOWN":
                    u = i.Down;
                    break;
                  case "PAGEUP":
                    u = i.PageUp;
                    break;
                  case "PAGEDOWN":
                    u = i.PageDown;
                    break;
                  case "SPACE":
                    u = i.Space;
                    break;
                  case "TAB":
                    u = i.Tab;
                    break;
                  case "BACKSPACE":
                  case "BACK":
                    u = i.Backspace;
                    break;
                  case "CONTEXT":
                    u = i.ContextMenu;
                    break;
                  case "ESCAPE":
                  case "ESC":
                    u = i.Esc;
                    break;
                  case "DELETE":
                  case "DEL":
                    u = i.Delete;
                    break;
                  case "INSERT":
                  case "INS":
                    u = i.Insert;
                    break;
                  case "PLUS":
                    u = "+".charCodeAt(0);
                    break;
                  default:
                    u = l.charCodeAt(0);
                }
              } else alert(s.EncodeUtils.decodeViaTextArea("Invalid shortcut"));
              return t.getShortcutCode(u, n, o, r, c);
            }, t;
          }();
        e.KeyUtils = c, function (t) {
          t[t.None = 0] = "None", t[t.Ctrl = 65536] = "Ctrl", t[t.Shift = 262144] = "Shift", t[t.Alt = 1048576] = "Alt", t[t.Meta = 16777216] = "Meta";
        }(o = e.ModifierKey || (e.ModifierKey = {})), function (t) {
          t[t.Backspace = 8] = "Backspace", t[t.Tab = 9] = "Tab", t[t.Enter = 13] = "Enter", t[t.Pause = 19] = "Pause", t[t.CapsLock = 20] = "CapsLock", t[t.Esc = 27] = "Esc", t[t.Space = 32] = "Space", t[t.PageUp = 33] = "PageUp", t[t.PageDown = 34] = "PageDown", t[t.End = 35] = "End", t[t.Home = 36] = "Home", t[t.Left = 37] = "Left", t[t.Up = 38] = "Up", t[t.Right = 39] = "Right", t[t.Down = 40] = "Down", t[t.Insert = 45] = "Insert", t[t.Delete = 46] = "Delete", t[t.Key_0 = 48] = "Key_0", t[t.Key_1 = 49] = "Key_1", t[t.Key_2 = 50] = "Key_2", t[t.Key_3 = 51] = "Key_3", t[t.Key_4 = 52] = "Key_4", t[t.Key_5 = 53] = "Key_5", t[t.Key_6 = 54] = "Key_6", t[t.Key_7 = 55] = "Key_7", t[t.Key_8 = 56] = "Key_8", t[t.Key_9 = 57] = "Key_9", t[t.Key_a = 65] = "Key_a", t[t.Key_b = 66] = "Key_b", t[t.Key_c = 67] = "Key_c", t[t.Key_d = 68] = "Key_d", t[t.Key_e = 69] = "Key_e", t[t.Key_f = 70] = "Key_f", t[t.Key_g = 71] = "Key_g", t[t.Key_h = 72] = "Key_h", t[t.Key_i = 73] = "Key_i", t[t.Key_j = 74] = "Key_j", t[t.Key_k = 75] = "Key_k", t[t.Key_l = 76] = "Key_l", t[t.Key_m = 77] = "Key_m", t[t.Key_n = 78] = "Key_n", t[t.Key_o = 79] = "Key_o", t[t.Key_p = 80] = "Key_p", t[t.Key_q = 81] = "Key_q", t[t.Key_r = 82] = "Key_r", t[t.Key_s = 83] = "Key_s", t[t.Key_t = 84] = "Key_t", t[t.Key_u = 85] = "Key_u", t[t.Key_v = 86] = "Key_v", t[t.Key_w = 87] = "Key_w", t[t.Key_x = 88] = "Key_x", t[t.Key_y = 89] = "Key_y", t[t.Key_z = 90] = "Key_z", t[t.Windows = 91] = "Windows", t[t.ContextMenu = 93] = "ContextMenu", t[t.Numpad_0 = 96] = "Numpad_0", t[t.Numpad_1 = 97] = "Numpad_1", t[t.Numpad_2 = 98] = "Numpad_2", t[t.Numpad_3 = 99] = "Numpad_3", t[t.Numpad_4 = 100] = "Numpad_4", t[t.Numpad_5 = 101] = "Numpad_5", t[t.Numpad_6 = 102] = "Numpad_6", t[t.Numpad_7 = 103] = "Numpad_7", t[t.Numpad_8 = 104] = "Numpad_8", t[t.Numpad_9 = 105] = "Numpad_9", t[t.Multiply = 106] = "Multiply", t[t.Add = 107] = "Add", t[t.Subtract = 109] = "Subtract", t[t.Decimal = 110] = "Decimal", t[t.Divide = 111] = "Divide", t[t.F1 = 112] = "F1", t[t.F2 = 113] = "F2", t[t.F3 = 114] = "F3", t[t.F4 = 115] = "F4", t[t.F5 = 116] = "F5", t[t.F6 = 117] = "F6", t[t.F7 = 118] = "F7", t[t.F8 = 119] = "F8", t[t.F9 = 120] = "F9", t[t.F10 = 121] = "F10", t[t.F11 = 122] = "F11", t[t.F12 = 123] = "F12", t[t.NumLock = 144] = "NumLock", t[t.ScrollLock = 145] = "ScrollLock", t[t.Semicolon = 186] = "Semicolon", t[t.Equals = 187] = "Equals", t[t.Comma = 188] = "Comma", t[t.Dash = 189] = "Dash", t[t.Period = 190] = "Period", t[t.ForwardSlash = 191] = "ForwardSlash", t[t.GraveAccent = 192] = "GraveAccent", t[t.OpenBracket = 219] = "OpenBracket", t[t.BackSlash = 220] = "BackSlash", t[t.CloseBracket = 221] = "CloseBracket", t[t.SingleQuote = 222] = "SingleQuote";
        }(i = e.KeyCode || (e.KeyCode = {}));
      },
      6547: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ChangeConnectorTextEventArgs = e.ChangeConnectorTextRequestedEntity = void 0;
        var r = n(5225),
          s = n(5102),
          a = function (t) {
            function e(e, n, o, i) {
              var r = t.call(this, e) || this;
              return r.connector = n, r.position = o, r.text = i, r;
            }
            return i(e, t), Object.defineProperty(e.prototype, "operation", {
              get: function () {
                return r.DiagramModelOperation.ChangeConnectorText;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.createEventArgs = function () {
              return new c(this.apiController.createNativeConnector(this.connector), this.position, this.connector.texts.map(function (t) {
                return t;
              }).sort(function (t, e) {
                return t.position - e.position;
              }).indexOf(this.connector.texts.get(this.position)), this.text);
            }, Object.defineProperty(e.prototype, "settingsKey", {
              get: function () {
                return "changeConnectorText";
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "storageKey", {
              get: function () {
                return this.settingsKey + "_" + (this.connector && this.connector.key);
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.equals = function (t) {
              return t instanceof e && this.connector === t.connector && this.position === t.position && this.text === t.text;
            }, e;
          }(s.RequestedEntity);
        e.ChangeConnectorTextRequestedEntity = a;
        var c = function (t) {
          function e(e, n, o, i) {
            var r = t.call(this) || this;
            return r.connector = e, r.position = n, r.index = o, r.text = i, r;
          }
          return i(e, t), e;
        }(s.PermissionRequestEventArgs);
        e.ChangeConnectorTextEventArgs = c;
      },
      6568: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ConnectorPointsOrthogonalEastSideCalculator = void 0;
        var r = n(4824),
          s = n(3976),
          a = n(9956),
          c = function (t) {
            function e(e) {
              return t.call(this, e) || this;
            }
            return i(e, t), e.prototype.getCorrectOriginPoint = function (t, e) {
              return t.x < e.right && (t = t.clone().offset(e.right - t.x, 0)), t;
            }, e.prototype.getSameShapeOffsetPoints = function (t, e, n, o) {
              switch (t) {
                case r.ConnectionPointSide.North:
                case r.ConnectionPointSide.South:
                case r.ConnectionPointSide.East:
                  return [e.clone().offset(this.getMinOffset(), 0)];
                case r.ConnectionPointSide.West:
                  return this.getAsideOffsetPoints(e, n, o, this.getMinOffset(), this.getMinOffset());
              }
            }, e.prototype.getOverlappedPointsOffsetPoints = function (t, e, n, o) {
              switch (t) {
                case r.ConnectionPointSide.East:
                  return [e.clone().offset(this.getMinOffset(), 0)];
                case r.ConnectionPointSide.West:
                  return [e.clone().offset(-this.getMinOffset(), 0)];
              }
              return [];
            }, e.prototype.getBeginOverlappedShapeOffsetPoints = function (t, e, n, o) {
              switch (t) {
                case r.ConnectionPointSide.North:
                  return e.x < n.x ? e.y < n.y ? [] : [e.clone().offset(this.getMinOffset(), 0)] : e.x > this.endRect.right ? this.getAsideOffsetPoints(e, n, o, this.getMinOffset(), this.getMinOffset(), !0) : [e.clone().offset(this.getMinOffset(), 0)];
                case r.ConnectionPointSide.South:
                  return e.x < n.x ? e.y > n.y ? [] : [e.clone().offset(this.getMinOffset(), 0)] : e.x > this.endRect.right ? this.getAsideOffsetPoints(e, n, o, this.getMinOffset(), this.getMinOffset(), !1) : [e.clone().offset(this.getMinOffset(), 0)];
                case r.ConnectionPointSide.East:
                  return [e.clone().offset(this.getMinOffset(), 0)];
                case r.ConnectionPointSide.West:
                  return this.getAsideOffsetPoints(e, n, o, this.getMinOffset(), this.getMinOffset(), e.y < n.y);
              }
            }, e.prototype.getEndOverlappedShapeOffsetPoints = function (t, e, n, o) {
              switch (t) {
                case r.ConnectionPointSide.East:
                  return [e.clone().offset(this.getMinOffset(), 0)];
                case r.ConnectionPointSide.West:
                  var i = this.getMinOffset();
                  return this.beginRect.right > e.x && (i += this.beginRect.right - e.x), [e.clone().offset(i, 0)];
                case r.ConnectionPointSide.North:
                  return n.x < e.x ? this.getAsideOffsetPoints(e, n, o, this.getMinOffset(), this.getMinOffset(), !0) : e.y > n.y ? [e.clone().offset(this.getMinOffset(), 0)] : [];
                case r.ConnectionPointSide.South:
                  return n.x < e.x ? this.getAsideOffsetPoints(e, n, o, this.getMinOffset(), this.getMinOffset(), !1) : e.y < n.y ? [e.clone().offset(this.getMinOffset(), 0)] : [];
              }
            }, e.prototype.getBeginOnSideOffsetPoints = function (t, e, n, o) {
              return [e.clone().offset(this.getScaleableOffsetX(e, n, !1), 0)];
            }, e.prototype.getEndOnSideOffsetPoints = function (t, e, n, o) {
              return [e.clone().offset(this.getScaleableOffsetX(e, n, !0), 0)];
            }, e.prototype.getBeginOffSideOffsetPoints = function (t, e, n, o) {
              switch (t) {
                case r.ConnectionPointSide.South:
                  if (this.isBeginEndOverlappedY()) return this.getScaleableAsideOffsetPoints(e, n, o, !1, !1);
                  break;
                case r.ConnectionPointSide.North:
                  if (this.isBeginEndOverlappedY()) return this.getScaleableAsideOffsetPoints(e, n, o, !1, !0);
                  break;
                case r.ConnectionPointSide.East:
                  if (this.isBeginEndOverlappedY()) return this.getScaleableAsideOffsetPoints(e, n, o, !1);
                  break;
                case r.ConnectionPointSide.Undefined:
                case r.ConnectionPointSide.West:
                  return this.getScaleableAsideOffsetPoints(e, n, o, !1);
              }
              return [e.clone().offset(this.getScaleableOffsetX(e, n, !1), 0)];
            }, e.prototype.getEndOffSideOffsetPoints = function (t, e, n, o) {
              if (t === r.ConnectionPointSide.Undefined) return this.getScaleableAsideOffsetPoints(e, n, o, !0);
              if (this.isBeginEndOverlappedY()) {
                var i = this.beginRect.center.y > this.endRect.center.y;
                return this.getScaleableAsideOffsetPoints(e, n, o, !0, i);
              }
              return [e.clone().offset(this.getScaleableOffsetX(e, n, !0), 0)];
            }, e.prototype.getAsideOffsetPoints = function (t, e, n, o, i, r) {
              var s = [];
              return void 0 !== n && (void 0 === r && (r = e.y < t.y), r ? s.push(t.clone().offset(o, -(t.y - n.y + i))) : s.push(t.clone().offset(o, n.bottom - t.y + i))), s.push(t.clone().offset(o, 0)), s;
            }, e.prototype.getScaleableAsideOffsetPoints = function (t, e, n, o, i) {
              var r = this.getScaleableOffsetX(t, e, o),
                s = this.getScaleableOffsetY(t, e, o);
              return this.getAsideOffsetPoints(t, e, n, r, s, i);
            }, e.prototype.getScaleableOffsetX = function (t, e, n) {
              if (this.beginRect && this.endRect) {
                var o = n ? this.beginRect.x - t.x : this.endRect.x - t.x;
                if (o > 0 && o < 2 * this.getMinOffset()) return o / 2;
              }
              return this.getMinOffset();
            }, e.prototype.getScaleableOffsetY = function (t, e, n) {
              if (this.beginRect && this.endRect && !n && !this.isBeginEndOverlappedY()) {
                var o = void 0;
                if ((o = e.y < t.y ? this.beginRect.y - this.endRect.bottom : this.endRect.y - this.beginRect.bottom) < 2 * this.getMinOffset()) return o / 2;
              }
              return this.getMinOffset();
            }, e.prototype.isOnSidePoint = function (t, e) {
              return e.x > t.x;
            }, e.prototype.isDirectConnectionAllowed = function (t, e, n) {
              return t === r.ConnectionPointSide.West || t === r.ConnectionPointSide.Undefined;
            }, e.prototype.getDirectConnectionPoints = function (t, e) {
              var n = t.x + (e.x - t.x) / 2;
              return [new a.ConnectorRenderPoint(n, t.y), new a.ConnectorRenderPoint(n, e.y)];
            }, e;
          }(s.ConnectorPointsOrthogonalSideCalculatorBase);
        e.ConnectorPointsOrthogonalEastSideCalculator = c;
      },
      6621: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.VerticalContainerDescription = void 0;
        var r = n(5327),
          s = n(3844),
          a = n(94),
          c = n(4412),
          u = n(3255),
          p = n(1280),
          h = n(6687),
          l = function (t) {
            function e() {
              return t.call(this, new s.Size(2 * p.ShapeDefaultDimension, 1.5 * p.ShapeDefaultDimension)) || this;
            }
            return i(e, t), Object.defineProperty(e.prototype, "key", {
              get: function () {
                return u.ShapeTypes.VerticalContainer;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.getExpandedSize = function (t) {
              return new s.Size(t.size.width, t.expandedSize.height);
            }, e.prototype.getCollapsedSize = function (t) {
              return new s.Size(t.size.width, h.CONTAINER_HEADER_SIZE + 2 * t.strokeWidth);
            }, e.prototype.allowResizeVertically = function (t) {
              return t.expanded;
            }, e.prototype.createHeaderPrimitives = function (t, e) {
              var n = t.rectangle,
                o = n.x,
                i = n.y,
                r = n.width,
                s = this.getHeaderSize(t, e),
                u = [];
              return u = u.concat([new a.RectanglePrimitive(o, i, r, s, t.style)]), e || (u = u.concat(this.createExpandButtonPrimitives(t, new c.Rectangle(o, i, s, s)))), u;
            }, e.prototype.getClientRectangle = function (t) {
              var e = t.rectangle,
                n = this.getHeaderSize(t);
              return c.Rectangle.fromGeometry(new r.Point(e.x, e.y + n), new s.Size(e.width, e.height - n));
            }, e.prototype.getTextRectangle = function (t) {
              var e = t.rectangle,
                n = this.getHeaderSize(t);
              return c.Rectangle.fromGeometry(new r.Point(e.x + n, e.y), new s.Size(e.width - n, n));
            }, e.prototype.getSizeByText = function (t, e) {
              var n = this.getHeaderSize(e);
              return new s.Size(Math.max(e.size.width, t.width + n), e.size.height);
            }, e.prototype.getHeaderSize = function (t, e) {
              var n = t.rectangle;
              return e ? n.height * h.CONTAINER_HEADER_TOOLBOX_SIZE_RATIO : h.CONTAINER_HEADER_SIZE + 2 * t.strokeWidth;
            }, e;
          }(h.ContainerDescription);
        e.VerticalContainerDescription = l;
      },
      6634: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ExportImageCommand = void 0;
        var r = n(9922),
          s = n(8236),
          a = n(6089),
          c = n(8762),
          u = n(8509),
          p = n(6727),
          h = n(6873),
          l = n(4062),
          d = function (t) {
            function e(e) {
              var n = t.call(this, e) || this;
              return n.exporter = new c.Exporter(), n;
            }
            return i(e, t), e.prototype.isEnabled = function () {
              return !l.ImageCache.instance.hasNonLoadedImages();
            }, e.prototype.executeCore = function (t, e) {
              var n = this;
              try {
                var o = this.getExportManager();
                this.getExportFunc()(this.control.model.size.clone(), this.control.model.pageColor, o, function (t) {
                  e(t, n.getExtension()), n.tryDispose();
                }, this.control.settings.useCanvgForExportToImage);
              } catch (t) {
                throw this.tryDispose(), t;
              }
              return !0;
            }, e.prototype.getExportManager = function () {
              var t = this.getOrCreateMeasurer(),
                e = this.control.render && this.control.render.items || this.createItemsManager(t);
              return this.exportManager || (this.exportManager = new s.CanvasExportManager(e.itemsContainer, t, this.control.instanceId));
            }, e.prototype.createItemsManager = function (t) {
              this.svgElement = u.RenderHelper.createSvgElement(document.body, !0);
              var e = new r.CanvasItemsManager(this.svgElement, 1, new h.ExportDOMManipulator(t), this.control.instanceId);
              return this.control.modelManipulator.onModelChanged.add(e), this.control.modelManipulator.commitItemsCreateChanges(), e;
            }, e.prototype.tryDispose = function () {
              this.svgElement && (document.body.removeChild(this.svgElement), delete this.svgElement), this.tempMeasurer && (this.tempMeasurer.clean(), this.tempMeasurer = void 0), this.exportManager = void 0;
            }, e.prototype.getOrCreateMeasurer = function () {
              return this.control.measurer || (this.tempMeasurer = new p.TextMeasurer(document.body));
            }, e;
          }(a.ExportImportCommandBase);
        e.ExportImageCommand = d;
      },
      6649: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ChangeStylePropertyCommandBase = void 0;
        var r = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(e, t), e.prototype.executeCore = function (t, e) {
            var n = this;
            this.control.history.beginTransaction();
            var o = this.control.selection.getSelectedItems();
            return e = this.processParameter(e), o.forEach(function (t) {
              var o = n.getStyleProperty();
              n.control.history.addAndRedo(n.createHistoryItem(t, o, e));
            }), this.updateInputPosition(e), this.control.history.endTransaction(), !0;
          }, e.prototype.getDefaultValue = function () {
            return this.getDefaultStyleObj()[this.getStyleProperty()];
          }, e.prototype.processParameter = function (t) {
            return t;
          }, e;
        }(n(7418).StylePropertyCommandBase);
        e.ChangeStylePropertyCommandBase = r;
      },
      6687: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ContainerDescription = e.CONTAINER_EXPAND_BUTTON_SIGN_RATIO = e.CONTAINER_EXPAND_BUTTON_RECT_RATIO = e.CONTAINER_HEADER_TOOLBOX_SIZE_RATIO = e.CONTAINER_HEADER_SIZE = void 0;
        var r = n(1280),
          s = n(3844),
          a = n(3255),
          c = n(94),
          u = n(6208),
          p = n(2136),
          h = n(5428),
          l = n(6709),
          d = n(4856),
          f = n(4824),
          y = n(820);
        e.CONTAINER_HEADER_SIZE = 360, e.CONTAINER_HEADER_TOOLBOX_SIZE_RATIO = .2, e.CONTAINER_EXPAND_BUTTON_RECT_RATIO = .5, e.CONTAINER_EXPAND_BUTTON_SIGN_RATIO = .3;
        var g = function (t) {
          function n(e) {
            return void 0 === e && (e = new s.Size(2 * r.ShapeDefaultDimension, 1.5 * r.ShapeDefaultDimension)), t.call(this, e, !0) || this;
          }
          return i(n, t), Object.defineProperty(n.prototype, "enableChildren", {
            get: function () {
              return !0;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(n.prototype, "keepRatioOnAutoSize", {
            get: function () {
              return !1;
            },
            enumerable: !1,
            configurable: !0
          }), n.prototype.getDefaultText = function () {
            return y.DiagramLocalizationService.shapeTexts[a.ShapeTypes.Container];
          }, n.prototype.createConnectionPoints = function () {
            return [new d.ConnectionPoint(.25, 0, f.ConnectionPointSide.North), new d.ConnectionPoint(.5, 0, f.ConnectionPointSide.North), new d.ConnectionPoint(.75, 0, f.ConnectionPointSide.North), new d.ConnectionPoint(1, .25, f.ConnectionPointSide.East), new d.ConnectionPoint(1, .5, f.ConnectionPointSide.East), new d.ConnectionPoint(1, .75, f.ConnectionPointSide.East), new d.ConnectionPoint(.75, 1, f.ConnectionPointSide.South), new d.ConnectionPoint(.5, 1, f.ConnectionPointSide.South), new d.ConnectionPoint(.25, 1, f.ConnectionPointSide.South), new d.ConnectionPoint(0, .75, f.ConnectionPointSide.West), new d.ConnectionPoint(0, .5, f.ConnectionPointSide.West), new d.ConnectionPoint(0, .25, f.ConnectionPointSide.West)];
          }, n.prototype.getConnectionPointIndexForItem = function (t, e) {
            return 4 === (t && t.getConnectionPoints()).length ? 3 * e + 1 : e;
          }, n.prototype.getConnectionPointIndexForSide = function (t) {
            return 3 * t + 1;
          }, n.prototype.createShapePrimitives = function (t, e) {
            var n = t.rectangle,
              o = n.x,
              i = n.y,
              r = n.width,
              s = n.height,
              a = [];
            return t.expanded && (a = a.concat([new c.RectanglePrimitive(o, i, r, s, t.style)])), a.concat(this.createHeaderPrimitives(t, e));
          }, n.prototype.createExpandButtonPrimitives = function (t, n) {
            var o = [new u.PathPrimitiveMoveToCommand(n.x + n.width * ((1 - e.CONTAINER_EXPAND_BUTTON_SIGN_RATIO) / 2), n.center.y), new u.PathPrimitiveLineToCommand(n.x + n.width * ((1 - e.CONTAINER_EXPAND_BUTTON_SIGN_RATIO) / 2 + e.CONTAINER_EXPAND_BUTTON_SIGN_RATIO), n.center.y)];
            t.expanded || (o = o.concat([new u.PathPrimitiveMoveToCommand(n.center.x, n.y + n.height * ((1 - e.CONTAINER_EXPAND_BUTTON_SIGN_RATIO) / 2)), new u.PathPrimitiveLineToCommand(n.center.x, n.y + n.height * ((1 - e.CONTAINER_EXPAND_BUTTON_SIGN_RATIO) / 2 + e.CONTAINER_EXPAND_BUTTON_SIGN_RATIO))]));
            var i = n.clone().inflate(-n.width * (1 - e.CONTAINER_EXPAND_BUTTON_RECT_RATIO) / 2, -n.height * (1 - e.CONTAINER_EXPAND_BUTTON_RECT_RATIO) / 2);
            return [new l.GroupPrimitive([new c.RectanglePrimitive(i.x, i.y, i.width, i.height, t.style), new u.PathPrimitive(o, t.style)], "shape-expand-btn", null, null, function (e) {
              p.RenderUtils.setElementEventData(e, h.MouseEventElementType.ShapeExpandButton, t.key);
            })];
          }, n;
        }(r.ShapeDescription);
        e.ContainerDescription = g;
      },
      6695: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.BarManager = void 0;
        var r = function (t) {
          function e(e) {
            var n = t.call(this) || this;
            return n.bars = [], n.control = e, n;
          }
          return i(e, t), e.prototype.clean = function () {
            var t = this;
            this.bars.forEach(function (e) {
              return e.onChanged.remove(t);
            }), this.bars = [];
          }, e.prototype.registerBar = function (t) {
            this.bars.push(t), t.onChanged.add(this), this.updateBarItemsState(t);
          }, e.prototype.updateItemsState = function (t) {
            if (!this.isUpdateLocked()) for (var e = 0, n = void 0; n = this.bars[e]; e++) this.updateBarItemsState(n, t);
          }, e.prototype.updateBarItemsState = function (t, e) {
            if (!this.isUpdateLocked()) {
              if (this.control.permissionsProvider.beginUpdateUI(), t.isVisible()) {
                var n = void 0;
                if (e) {
                  var o = t.getCommandKeys().reduce(function (t, e) {
                    return t[e] = !0, t;
                  }, {});
                  n = e.filter(function (t) {
                    return o[t];
                  });
                } else n = t.getCommandKeys();
                for (var i = n.length, r = 0; r < i; r++) this.updateBarItem(t, n[r]);
              }
              this.control.permissionsProvider.endUpdateUI();
            }
          }, e.prototype.updateBarItem = function (t, e) {
            var n = this.control.commandManager.getCommand(e);
            if (n) {
              var o = n.getState();
              if (t.setItemVisible(e, o.visible), o.visible && (t.setItemEnabled(e, o.enabled), !o.denyUpdateValue)) {
                var i = this.getItemValue(o.value);
                o.items && t.setItemSubItems(e, o.items), t.setItemValue(e, i, this.getDefaultItemValue(o.defaultValue));
              }
            }
          }, e.prototype.setEnabled = function (t) {
            for (var e = 0, n = void 0; n = this.bars[e]; e++) n.setEnabled(t);
          }, e.prototype.notifyBarCommandExecuted = function (t, e) {
            this.control.commandManager.getCommand(t).execute(e) || this.updateItemsState([t]);
          }, e.prototype.notifyBarUpdateRequested = function () {
            this.updateItemsState();
          }, e.prototype.notifySelectionChanged = function (t) {
            this.updateItemsState();
          }, e.prototype.onUpdateUnlocked = function (t) {}, e.prototype.getItemValue = function (t) {
            return t;
          }, e.prototype.getDefaultItemValue = function (t) {
            return t;
          }, e;
        }(n(815).BatchUpdatableObject);
        e.BarManager = r;
      },
      6696: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MouseHandlerDefaultTouchState = void 0;
        var r = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(e, t), e.prototype.updateConnectionsOnMouseMove = function (t) {}, e.prototype.canDragObjectOnMouseDown = function (t) {
            return this.inSelection(t);
          }, e.prototype.canExpandContainerOnMouseDown = function (t) {
            return !0;
          }, e.prototype.canClearSelectionOnMouseDown = function () {
            return !0;
          }, e.prototype.canSelectOnMouseUp = function (t) {
            return !this.inSelection(t);
          }, e.prototype.canClearSelectionOnMouseUp = function () {
            return !1;
          }, e;
        }(n(7011).MouseHandlerDefaultState);
        e.MouseHandlerDefaultTouchState = r;
      },
      6709: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.GroupPrimitive = void 0;
        var r = n(8509),
          s = function (t) {
            function e(e, n, o, i, r, s) {
              var a = t.call(this, null, n, i, r) || this;
              return a.zIndex = o, a.onBeforeDispose = s, a.children = e, a;
            }
            return i(e, t), e.prototype.createMainElement = function () {
              return document.createElementNS(r.svgNS, "g");
            }, e.prototype.applyElementProperties = function (e, n) {
              (this.zIndex || 0 === this.zIndex) && e.style.setProperty("z-index", this.zIndex.toString()), t.prototype.applyElementProperties.call(this, e, n);
            }, e.prototype.dispose = function () {
              this.onBeforeDispose && this.onBeforeDispose(), t.prototype.dispose.call(this);
            }, e;
          }(n(8309).SvgPrimitive);
        e.GroupPrimitive = s;
      },
      6727: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.TextMeasurer = void 0;
        var o = n(3844),
          i = n(2136),
          r = n(8408),
          s = n(6320),
          a = n(5650),
          c = n(8509),
          u = n(1842),
          p = function () {
            function t(t) {
              this.cache = {}, this.fontSizeCache = {}, this.containers = {}, this.parent = t, this.createNodes();
            }
            return t.prototype.measureWords = function (t, e, n) {
              var o = this,
                i = {
                  words: {},
                  fontSize: -1
                },
                r = "string" == typeof t ? this.splitToWords(t, !1) : t.reduce(function (t, e) {
                  return t.concat(o.splitToWords(e, !1));
                }, []);
              r.push(" ");
              var s = this.getStyleHash(e, n),
                a = this.tryLoadWordsToMeasurer(r, e, s, n, void 0, void 0, void 0, void 0, i);
              if (a) {
                var c = this.containers[n];
                this.putElementsInDOM(c, a), this.beforeMeasureInDOM(), this.measureElementsInDOM(a, i), this.afterMeasureInDOM();
              }
              return i;
            }, t.prototype.measureTextLine = function (t, e, n) {
              var o = this.measureWords(t, e, n);
              return (0, u.getTextLineSize)(t, o);
            }, t.prototype.onNewModel = function (t, e) {
              var n = this;
              e.changeByFunc(null, function () {
                return n.onNewModelCore(t);
              });
            }, t.prototype.onNewModelCore = function (t) {
              var e = t.filter(function (t) {
                  return t instanceof r.Shape;
                }),
                n = t.filter(function (t) {
                  return t instanceof s.Connector;
                }),
                o = this.tryLoadShapeTexts(e),
                i = this.tryLoadConnectorTexts(n);
              (o || i) && (o && this.putElementsInDOM(this.containers[a.TextOwner.Shape], o), i && this.putElementsInDOM(this.containers[a.TextOwner.Connector], i), this.beforeMeasureInDOM(), o && this.measureElementsInDOM(o), i && this.measureElementsInDOM(i), this.afterMeasureInDOM());
            }, t.prototype.replaceParent = function (t) {
              this.parent !== t && (this.mainElement.parentNode && t.appendChild(this.mainElement), this.parent = t);
            }, t.prototype.clean = function () {
              i.RenderUtils.removeElement(this.mainElement);
            }, t.prototype.tryLoadShapeTexts = function (t) {
              var e = this,
                n = {},
                o = [],
                i = [],
                r = [];
              return t.forEach(function (t) {
                var s = e.getStyleHash(t.styleText, a.TextOwner.Shape);
                e.tryLoadWordsToMeasurer(e.splitToWords(t.text, !0), t.styleText, s, a.TextOwner.Shape, n, o, i, r);
              }), o.length ? {
                elements: o,
                hashes: i,
                styleHashes: r
              } : null;
            }, t.prototype.tryLoadConnectorTexts = function (t) {
              var e = this,
                n = {},
                o = [],
                i = [],
                r = [];
              return t.forEach(function (t) {
                var s = t.texts.map(function (t) {
                  return t.value;
                }).reduce(function (t, n) {
                  return t.concat(e.splitToWords(n, !1));
                }, []);
                if (s.length) {
                  s.push(" ");
                  var c = e.getStyleHash(t.styleText, a.TextOwner.Connector);
                  e.tryLoadWordsToMeasurer(s, t.styleText, c, a.TextOwner.Connector, n, o, i, r);
                }
              }), o.length ? {
                elements: o,
                hashes: i,
                styleHashes: r
              } : null;
            }, t.prototype.tryLoadWordsToMeasurer = function (t, e, n, o, i, r, s, a, c) {
              var u = this,
                p = [];
              return r = r || [], s = s || [], a = a || [], i = i || {}, t.forEach(function (t) {
                return u.tryLoadWordToMeasurer(t, e, n, o, i, r, s, a, p, c);
              }), r.length ? {
                elements: r,
                hashes: s,
                styleHashes: a,
                newWords: p
              } : null;
            }, t.prototype.putElementsInDOM = function (t, e) {
              for (t.parentNode && t.parentNode.removeChild(t); t.firstChild;) t.removeChild(t.firstChild);
              e.elements.forEach(function (e) {
                return t.appendChild(e);
              }), this.svgElement.appendChild(t);
            }, t.prototype.measureElementsInDOM = function (t, e) {
              for (var n = t.hashes, o = t.elements, i = t.newWords, r = n.length, s = 0; s < r; s++) {
                var a = this.getDomElementSize(o[s]);
                a && (a.isEmpty() || (this.cache[n[s]] = a), e && (e.words[i[s]] = a));
                var c = t.styleHashes[s];
                void 0 === this.fontSizeCache[c] && (this.fontSizeCache[c] = this.getDomFontSize(o[s])), e && e.fontSize < 0 && (e.fontSize = this.fontSizeCache[c]);
              }
            }, t.prototype.beforeMeasureInDOM = function () {
              this.parent.appendChild(this.mainElement);
            }, t.prototype.afterMeasureInDOM = function () {
              this.mainElement.parentNode && this.mainElement.parentNode.removeChild(this.mainElement);
            }, t.prototype.tryLoadWordToMeasurer = function (t, e, n, o, i, r, s, a, c, u) {
              var p = this.getHash(t, e, o),
                h = this.cache[p];
              h || i[p] ? h && u && (u.words[t] = h, u.fontSize = this.fontSizeCache[n]) : (i[p] = !0, s.push(p), r.push(this.createElement(t, e)), a.push(n), c.push(t));
            }, t.prototype.getHash = function (t, e, n) {
              return n + "|" + (e && e.toHash()) + "|" + t;
            }, t.prototype.getStyleHash = function (t, e) {
              return this.getHash(" ", t, e);
            }, t.prototype.createElement = function (t, e) {
              var n = document.createElementNS(c.svgNS, "text");
              return " " === t && n.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve"), n.textContent = t, e && i.RenderUtils.applyStyleToElement(e, n), n;
            }, t.prototype.splitToWords = function (t, e) {
              var n = (0, u.textToWords)(t);
              return e && n.push(" "), n;
            }, t.prototype.getDomFontSize = function (t) {
              return parseFloat(window.getComputedStyle(t).fontSize);
            }, t.prototype.getDomElementSize = function (t) {
              var e;
              try {
                e = t.getBBox();
              } catch (t) {}
              return e ? new o.Size(e.width, e.height) : new o.Size(0, 0);
            }, t.prototype.createNodes = function () {
              this.mainElement = c.RenderHelper.createMainElement(void 0, !0), this.svgElement = c.RenderHelper.createSvgElement(this.mainElement, !1), this.createContainer(a.TextOwner.Shape, "shape"), this.createContainer(a.TextOwner.Connector, "connector"), this.createContainer(a.TextOwner.ExtensionLine, "extension-line"), this.createContainer(a.TextOwner.Resize, "resize-info");
            }, t.prototype.createContainer = function (t, e) {
              var n = document.createElementNS(c.svgNS, "g");
              n.setAttribute("class", e), this.containers[t] = n;
            }, t;
          }();
        e.TextMeasurer = p;
      },
      6800: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.UnLockCommand = void 0;
        var r = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(e, t), e.prototype.getLockState = function () {
            return !1;
          }, e;
        }(n(9314).ChangeLockedCommand);
        e.UnLockCommand = r;
      },
      6824: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ConnectorRenderSegment = void 0;
        var o = n(476),
          i = n(9049),
          r = function () {
            function t(t, e, n, o) {
              this.startInfo = t, this.endInfo = e, this.startPointIndex = n, this.previousCustomSegment = o;
            }
            return Object.defineProperty(t.prototype, "startPathPoint", {
              get: function () {
                return this.startInfo instanceof o.Segment ? this.startInfo.endPoint : this.startInfo;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(t.prototype, "endPathPoint", {
              get: function () {
                return this.endInfo instanceof o.Segment ? this.endInfo.startPoint : this.endInfo;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(t.prototype, "startPoint", {
              get: function () {
                return this.startInfo instanceof o.Segment ? this.startInfo.startPoint : this.startInfo;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(t.prototype, "endPoint", {
              get: function () {
                return this.endInfo instanceof o.Segment ? this.endInfo.endPoint : this.endInfo;
              },
              enumerable: !1,
              configurable: !0
            }), t.prototype.createGridPoints = function () {
              var t = [];
              return this.endInfo instanceof o.Segment ? (t.push(this.endInfo.startPoint), t.push(this.endInfo.endPoint)) : t.push(this.endInfo), t;
            }, t.prototype.createProhibitedSegments = function () {
              if (this.startInfo instanceof o.Segment) {
                var t = this.createProhibitedSegmentsCore(this.startInfo);
                return this.endInfo instanceof o.Segment && (t.addSegment(this.endInfo), t.addExludedPoint(this.endInfo.startPoint)), this.previousCustomSegment && t.addSegment(this.previousCustomSegment), t;
              }
              return this.endInfo instanceof o.Segment ? ((t = this.createProhibitedSegmentsCore(this.endInfo)).addExludedPoint(this.endInfo.startPoint), this.previousCustomSegment && t.addSegment(this.previousCustomSegment), t) : this.previousCustomSegment ? this.createProhibitedSegmentsCore(this.previousCustomSegment) : void 0;
            }, t.prototype.createProhibitedSegmentsCore = function (t) {
              var e = new i.ConnectorProhibitedSegments();
              return e.addSegment(t), e;
            }, t;
          }();
        e.ConnectorRenderSegment = r;
      },
      6855: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ArrowUpShapeDescription = void 0;
        var r = n(6208),
          s = n(9763),
          a = n(5327),
          c = n(7436),
          u = n(3255),
          p = n(4824),
          h = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), Object.defineProperty(e.prototype, "key", {
              get: function () {
                return u.ShapeTypes.ArrowUp;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.createShapePrimitives = function (t) {
              var e = t.rectangle,
                n = e.x,
                o = e.y,
                i = e.right,
                s = e.bottom,
                a = e.width,
                u = e.center.x,
                p = (a - t.parameters.get(c.ArrowVerticalLineWidthParameterName).value) / 2,
                h = t.parameters.get(c.ArrowVerticalTriangleHeightParameterName).value,
                l = t.normalizeX(n + p),
                d = t.normalizeY(o + h),
                f = t.normalizeX(i - p);
              return [new r.PathPrimitive([new r.PathPrimitiveMoveToCommand(u, o), new r.PathPrimitiveLineToCommand(i, d), new r.PathPrimitiveLineToCommand(f, d), new r.PathPrimitiveLineToCommand(f, s), new r.PathPrimitiveLineToCommand(l, s), new r.PathPrimitiveLineToCommand(l, d), new r.PathPrimitiveLineToCommand(n, d), new r.PathPrimitiveClosePathCommand()], t.style)];
            }, e.prototype.modifyParameters = function (t, e, n, o) {
              this.changeParameterValue(e, c.ArrowVerticalTriangleHeightParameterName, function (t) {
                return t.value + o;
              }), this.changeParameterValue(e, c.ArrowVerticalLineWidthParameterName, function (t) {
                return t.value - 2 * n;
              }), this.normalizeParameters(t, e);
            }, e.prototype.getParameterPoints = function (t) {
              return [new s.ShapeParameterPoint("c", new a.Point(t.normalizeX(t.position.x + (t.size.width - t.parameters.get(c.ArrowVerticalLineWidthParameterName).value) / 2), t.normalizeY(t.position.y + t.parameters.get(c.ArrowVerticalTriangleHeightParameterName).value)))];
            }, e.prototype.processConnectionPoint = function (e, n) {
              var o = e.parameters.get(c.ArrowVerticalTriangleHeightParameterName).value;
              if (n.y < e.position.y + o) {
                var i = e.size.width / 2 / o,
                  r = (e.position.y + o - n.y) * i,
                  s = e.getConnectionPointSide(n);
                s === p.ConnectionPointSide.East ? n.x -= r : s === p.ConnectionPointSide.West && (n.x += r);
              } else t.prototype.processConnectionPoint.call(this, e, n);
            }, e;
          }(c.ArrowVerticalShapeDescription);
        e.ArrowUpShapeDescription = h;
      },
      6873: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ExportDOMManipulator = e.DOMManipulator = void 0;
        var r = n(9196),
          s = function () {
            function t(t) {
              this.measurer = t, this.queue = [];
            }
            return t.prototype.createElement = function (t, e, n) {
              return t.createElement(function (t) {
                null != e && (void 0 !== n ? e.insertBefore(t, n) : e.appendChild(t));
              });
            }, t.prototype.changeChildrenByPrimitives = function (t, e) {
              var n = this;
              t.forEach(function (t, o) {
                var i = e.childNodes[o];
                n.changeByPrimitive(i, t);
              });
            }, t.prototype.changeByFunc = function (t, e) {
              this.doChange(t, e);
            }, t.prototype.changeByPrimitive = function (t, e) {
              this.doChange(t, e);
            }, t.prototype.cancelAnimation = function () {
              void 0 !== this.rafId && (cancelAnimationFrame(this.rafId), this.queue = []);
            }, t.prototype.doChange = function (t, e) {
              r.Diagnostics.optimizeUsingRAF ? (this.queue.push([t, e]), this.requestAnimation()) : this.doChangeSync(t, e);
            }, t.prototype.doChangeSync = function (t, e) {
              "function" == typeof e ? e(t) : e.applyElementProperties(t, this.measurer);
            }, t.prototype.requestAnimation = function () {
              var t = this;
              if (!this.rafRequested) {
                this.rafRequested = !0;
                var e = function () {
                  t.queue.splice(0, 2e3).forEach(function (e) {
                    return t.doChangeSync(e[0], e[1]);
                  }), t.queue.length ? t.rafId = requestAnimationFrame(e) : (t.rafRequested = !1, t.rafId = void 0);
                };
                this.rafId = requestAnimationFrame(e);
              }
            }, t;
          }();
        e.DOMManipulator = s;
        var a = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(e, t), e.prototype.doChange = function (t, e) {
            this.doChangeSync(t, e);
          }, e;
        }(s);
        e.ExportDOMManipulator = a;
      },
      6904: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MoveConnectorRightAnglePointsHistoryItem = e.MoveConnectorPointHistoryItem = void 0;
        var r = n(5327),
          s = n(2616),
          a = function (t) {
            function e(e, n, o) {
              var i = t.call(this) || this;
              return i.connectorKey = e, i.pointIndex = n, i.newPoint = o, i;
            }
            return i(e, t), e.prototype.redo = function (t) {
              var e = this,
                n = t.model.findConnector(this.connectorKey);
              this.oldPoint = n.points[this.pointIndex].clone(), this.renderContext = n.tryCreateRenderPointsContext(), t.moveConnectorPoint(n, this.pointIndex, function (t) {
                t.movePoint(e.pointIndex, e.newPoint), t.onMovePoint(e.pointIndex, e.newPoint);
              });
            }, e.prototype.undo = function (t) {
              var e = this,
                n = t.model.findConnector(this.connectorKey);
              t.moveConnectorPoint(n, this.pointIndex, function (t) {
                t.movePoint(e.pointIndex, e.oldPoint), t.replaceRenderPoints(e.renderContext);
              });
            }, e;
          }(s.HistoryItem);
        e.MoveConnectorPointHistoryItem = a;
        var c = function (t) {
          function e(e, n, o, i, r) {
            var s = t.call(this) || this;
            return s.connectorKey = e, s.beginPointIndex = n, s.lastPointIndex = o, s.newX = i, s.newY = r, s.oldPoints = [], s;
          }
          return i(e, t), e.prototype.redo = function (t) {
            var e = this,
              n = t.model.findConnector(this.connectorKey);
            this.renderContext = n.tryCreateRenderPointsContext(), this.oldPoints = n.points.slice(this.beginPointIndex, this.lastPointIndex + 1).map(function (t) {
              return t.clone();
            });
            var o = [];
            t.changeConnectorPoints(n, function (t) {
              for (var n = e.beginPointIndex; n <= e.lastPointIndex; n++) {
                var i = new r.Point(void 0 === e.newX ? t.points[n].x : e.newX, void 0 === e.newY ? t.points[n].y : e.newY);
                o.push(i), t.movePoint(n, i);
              }
              t.onMovePoints(e.beginPointIndex, e.lastPointIndex, o);
            });
          }, e.prototype.undo = function (t) {
            var e = this,
              n = t.model.findConnector(this.connectorKey);
            t.changeConnectorPoints(n, function (t) {
              for (var n = e.beginPointIndex; n <= e.lastPointIndex; n++) t.movePoint(n, e.oldPoints[n - e.beginPointIndex]);
              t.replaceRenderPoints(e.renderContext);
            });
          }, e;
        }(s.HistoryItem);
        e.MoveConnectorRightAnglePointsHistoryItem = c;
      },
      6961: (t, e) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.HashSet = void 0;
        var n = function () {
          function t(t, e) {
            void 0 === t && (t = []), void 0 === e && (e = function (t) {
              return t.toString();
            });
            var n = this;
            this.items = [], this.map = {}, this.getHashCode = e, t.forEach(function (t) {
              return n.tryPush(t);
            });
          }
          return t.prototype.tryPush = function (t) {
            var e = this.getHashCode(t);
            return void 0 === this.map[e] && (this.map[e] = this.items.push(t) - 1, !0);
          }, t.prototype.contains = function (t) {
            return void 0 !== this.map[this.getHashCode(t)];
          }, t.prototype.forEach = function (t) {
            this.items.forEach(t);
          }, t.prototype.filter = function (t) {
            return this.items.filter(t);
          }, t.prototype.list = function () {
            return this.items.slice(0);
          }, t.prototype.item = function (t) {
            return this.items[t];
          }, t.prototype.first = function () {
            return this.items[0];
          }, t.prototype.remove = function (t) {
            var e = this.getHashCode(t),
              n = this.map[e];
            if ("number" != typeof n) throw "Item not found";
            delete this.map[e], this.items.splice(n, 1);
            for (var o = n; o < this.items.length; o++) this.map[this.getHashCode(this.items[o])]--;
          }, Object.defineProperty(t.prototype, "length", {
            get: function () {
              return this.items.length;
            },
            enumerable: !1,
            configurable: !0
          }), t;
        }();
        e.HashSet = n;
      },
      6994: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ChangeStyleTextPropertyCommand = void 0;
        var r = n(6649),
          s = n(5755),
          a = n(5059),
          c = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), e.prototype.getValue = function () {
              return this.control.selection.inputPosition.getCurrentTextStylePropertyValue(this.getStyleProperty());
            }, e.prototype.getStyleObj = function (t) {
              return t.styleText;
            }, e.prototype.getDefaultStyleObj = function () {
              return new a.TextStyle();
            }, e.prototype.createHistoryItem = function (t, e, n) {
              return new s.ChangeStyleTextHistoryItem(t.key, e, n);
            }, e.prototype.updateInputPosition = function (t) {
              this.control.selection.inputPosition.setTextStylePropertyValue(this.getStyleProperty(), t);
            }, e;
          }(r.ChangeStylePropertyCommandBase);
        e.ChangeStyleTextPropertyCommand = c;
      },
      7003: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.RightAngleConnectorRoutingStrategy = void 0;
        var o = n(476),
          i = n(9956),
          r = n(4863),
          s = n(1922),
          a = function () {
            function t(t) {
              this.model = t;
            }
            return t.prototype.createRenderPoints = function (t, e, n, o, i, s, a) {
              if (e.length > 1) {
                var c = new r.RightAngleConnectorRoutingContext(this.model, t, e, n, o, i, s);
                if (c.initialize(a), c.shouldCreateRenderPoints) return this.createRenderPointsCore(c);
              }
            }, t.prototype.clone = function () {
              return new t(this.model);
            }, t.prototype.onAddPoint = function (t, e, n, r) {
              var a = r.map(function (t) {
                  return new i.ConnectorRenderPoint(t.x, t.y, t.pointIndex);
                }),
                c = s.ModelUtils.findFirstPointIndex(a, function (t) {
                  return t.equals(n);
                });
              if (0 === c) return a.splice(1, 0, new i.ConnectorRenderPoint(n.x, n.y, e)), s.ModelUtils.validateRenderPointIndexes(t, a, 2);
              var u = a.length - 1;
              if (c === u) return a.splice(u, 0, new i.ConnectorRenderPoint(n.x, n.y, e)), a[u + 1].pointIndex = e + 1, a;
              if (c > 0) {
                var p = a[c];
                return a[c] = new i.ConnectorRenderPoint(p.x, p.y, e, p.skipped), s.ModelUtils.validateRenderPointIndexes(t, a, c + 1);
              }
              var h = new o.Segment(a[0], a[1]),
                l = new i.ConnectorRenderPoint(n.x, n.y);
              return h.containsPoint(l) ? (a.splice(1, 0, new i.ConnectorRenderPoint(l.x, l.y, -1)), a.splice(2, 0, new i.ConnectorRenderPoint(l.x, l.y, e)), s.ModelUtils.validateRenderPointIndexes(t, a, 3)) : new o.Segment(a[u - 1], a[u]).containsPoint(l) ? (a.splice(u, 0, new i.ConnectorRenderPoint(l.x, l.y, e)), a.splice(u + 1, 0, new i.ConnectorRenderPoint(l.x, l.y, -1)), a[u + 2].pointIndex = e + 1, a) : r;
            }, t.prototype.onDeletePoint = function (t, e, n) {
              var o = n.map(function (t) {
                  return new i.ConnectorRenderPoint(t.x, t.y, t.pointIndex);
                }),
                r = this.getRenderPointIndexByPointIndex(o, e);
              if (1 === r) {
                var a = o[0],
                  c = o[1];
                return a.equals(c) ? (o.splice(1, 1), s.ModelUtils.validateRenderPointIndexes(t, o, 1)) : (o[1] = new i.ConnectorRenderPoint(c.x, c.y, -1, c.skipped), s.ModelUtils.validateRenderPointIndexes(t, o, 2));
              }
              if (2 === r) {
                a = o[1];
                var u = o[2];
                return a.equals(u) ? (o.splice(1, 2), s.ModelUtils.validateRenderPointIndexes(t, o, 1)) : (o[2] = new i.ConnectorRenderPoint(u.x, u.y, -1, u.skipped), s.ModelUtils.validateRenderPointIndexes(t, o, 3));
              }
              var p = o.length - 1;
              if (r === p - 1) {
                var h = o[p - 1],
                  l = o[p];
                return h.equals(l) ? (o.splice(p - 1, 1), s.ModelUtils.validateRenderPointIndexes(t, o, p - 1)) : (o[p - 1] = new i.ConnectorRenderPoint(h.x, h.y, -1, h.skipped), s.ModelUtils.validateRenderPointIndexes(t, o, p));
              }
              if (r === p - 2) {
                var d = o[p - 2];
                l = o[p - 1];
                return d.equals(l) ? (o.splice(p - 2, 2), s.ModelUtils.validateRenderPointIndexes(t, o, p - 2)) : (o[p - 2] = new i.ConnectorRenderPoint(d.x, d.y, -1, d.skipped), s.ModelUtils.validateRenderPointIndexes(t, o, p - 1));
              }
              var f = o[r];
              return o[r] = new i.ConnectorRenderPoint(f.x, f.y, -1, f.skipped), s.ModelUtils.validateRenderPointIndexes(t, o, r + 1);
            }, t.prototype.onMovePoint = function (t, e, n, o) {
              if (0 === e || e === t.length - 1) return o;
              var r = o.map(function (t) {
                return new i.ConnectorRenderPoint(t.x, t.y, t.pointIndex);
              });
              return this.onMovePointCore(r, e, n), s.ModelUtils.skipUnnecessaryRightAngleRenderPoints(r), r;
            }, t.prototype.onMovePoints = function (t, e, n, o, r) {
              if (0 === e || n === t.length - 1) return r;
              for (var a = r.map(function (t) {
                  return new i.ConnectorRenderPoint(t.x, t.y, t.pointIndex);
                }), c = e; c <= n; c++) this.onMovePointCore(a, c, o[c - e]);
              return s.ModelUtils.skipUnnecessaryRightAngleRenderPoints(a), a;
            }, t.prototype.onMovePointCore = function (t, e, n) {
              var o = this.getRenderPointIndexByPointIndex(t, e);
              if (o >= 0) {
                var r = t[o];
                t[o] = new i.ConnectorRenderPoint(n.x, n.y, e, r.skipped);
              }
            }, t.prototype.createRenderPointsCore = function (t) {
              var e,
                n = [],
                o = -1,
                i = -1;
              t.setup();
              var r = t.renderSegments,
                s = r[r.length - 1].endPoint,
                a = t.points;
              do {
                this.registerCustomPoints(n, a, i + 2, r[o + 1].startPointIndex - 1), i = (e = r[++o]).startPointIndex, this.registerRenderPoints(n, t.createRoutedPoints(e.startInfo, e.endInfo, e.createProhibitedSegments()), i);
              } while (!e.endPoint.equals(s));
              return t.validateRenderPoints(n), n;
            }, t.prototype.getRenderPointIndexByPointIndex = function (t, e) {
              return s.ModelUtils.findFirstPointIndex(t, function (t) {
                return t.pointIndex === e;
              });
            }, t.prototype.registerRenderPoints = function (t, e, n) {
              var o = this;
              e.forEach(function (i, r) {
                var s = 0 === r ? n : r === e.length - 1 ? n + 1 : -1;
                o.registerPoint(t, i, s);
              });
            }, t.prototype.registerCustomPoints = function (t, e, n, o) {
              for (var i = n; i <= o; i++) this.registerPoint(t, e[i], i);
            }, t.prototype.registerPoint = function (t, e, n) {
              t.push(new i.ConnectorRenderPoint(e.x, e.y, n));
            }, t;
          }();
        e.RightAngleConnectorRoutingStrategy = a;
      },
      7011: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MouseHandlerDefaultState = void 0;
        var r = n(5428),
          s = n(3894),
          a = n(5355),
          c = n(401),
          u = n(8503),
          p = n(4237),
          h = n(1988),
          l = n(18),
          d = n(2037),
          f = n(9550),
          y = n(78),
          g = n(6320),
          m = n(1616),
          v = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), e.prototype.finish = function () {
              this.visualizerManager.resetConnectionPoints(), t.prototype.finish.call(this);
            }, e.prototype.onMouseDownCore = function (e) {
              this.handler.canScrollPage(e) ? this.startScrolling(e) : e.button === r.MouseButton.Left && e.source.type === r.MouseEventElementType.ConnectorText ? (this.handler.changeSingleSelection(e.source.key), this.handler.switchState(new d.MouseHandlerMoveConnectorTextState(this.handler, this.history, this.model))) : e.button === r.MouseButton.Left && e.source.type === r.MouseEventElementType.ShapeResizeBox ? this.handler.switchState(new a.MouseHandlerResizeShapeState(this.handler, this.history, this.model, this.selection, this.visualizerManager, this.settings)) : e.button === r.MouseButton.Left && e.source.type === r.MouseEventElementType.ShapeParameterBox ? this.handler.switchState(new u.MouseHandlerDragParameterPointState(this.handler, this.history, this.model)) : e.button === r.MouseButton.Left && e.source.type === r.MouseEventElementType.ConnectorPoint ? this.handler.switchState(new s.MouseHandlerMoveConnectorPointState(this.handler, this.history, this.model, this.visualizerManager)) : e.button === r.MouseButton.Left && e.source.type === r.MouseEventElementType.ConnectorSide ? this.handler.switchState(new c.MouseHandlerMoveConnectorSideState(this.handler, this.history, this.model)) : e.button === r.MouseButton.Left && e.source.type === r.MouseEventElementType.ConnectorOrthogonalSide ? this.handler.switchState(new h.MouseHandlerMoveConnectorOrthogonalSideState(this.handler, this.history, this.model)) : e.button === r.MouseButton.Left && e.source.type === r.MouseEventElementType.ShapeConnectionPoint ? this.handler.switchState(new p.MouseHandlerCreateConnectorState(this.handler, this.history, this.model, this.visualizerManager, this.shapeDescriptionManager, this.selection)) : t.prototype.onMouseDownCore.call(this, e);
            }, e.prototype.onDragDiagramItemOnMouseDown = function (e) {
              this.handler.canAddDiagramItemToSelection(e) ? e.source.isShape ? this.handler.switchState(new y.MouseHandlerMoveShapeState(this.handler, this.history, this.model, this.selection, this.visualizerManager)) : e.source.isConnector && this.handler.switchState(new m.MouseHandlerMoveConnectorState(this.handler, this.history, this.model, this.selection, this.visualizerManager)) : t.prototype.onDragDiagramItemOnMouseDown.call(this, e);
            }, e.prototype.onDragStart = function (t) {
              this.handler.switchState(new l.MouseHandlerBeforeToolboxDraggingState(this.handler, this.history, this.model, this.selection, this.visualizerManager, this.shapeDescriptionManager)), this.handler.state.onDragStart(t);
            }, e.prototype.onMouseMoveCore = function (e) {
              this.updateConnectionsOnMouseMove(e), t.prototype.onMouseMoveCore.call(this, e);
            }, e.prototype.onMouseUp = function (e) {
              this.handler.canRemoveDiagramItemToSelection(e) ? this.handler.removeDiagramItemFromSelection(e.button, e.source.key) : t.prototype.onMouseUp.call(this, e);
            }, e.prototype.updateConnectionsOnMouseMove = function (t) {
              var e = this.model.findItem(t.source.key);
              this.visualizerManager.updateConnections(e, t.source.type, t.source.value);
            }, e.prototype.canDragObjectOnMouseDown = function (t) {
              return !0;
            }, e.prototype.canExpandContainerOnMouseDown = function (t) {
              return !0;
            }, e.prototype.canClearSelectionOnMouseDown = function () {
              return !1;
            }, e.prototype.canSelectOnMouseUp = function (t) {
              return !1;
            }, e.prototype.canClearSelectionOnMouseUp = function () {
              return !0;
            }, e.prototype.onConnectionPointsShow = function (t, e) {
              var n = this,
                o = this.model.findShape(t);
              o && e.forEach(function (t, e) {
                t.allowed = n.handler.canPerformChangeConnectionOnUpdateUI(void 0, {
                  item: o,
                  position: g.ConnectorPosition.Begin,
                  connectionPointIndex: e
                });
              });
            }, e;
          }(f.MouseHandlerDefaultStateBase);
        e.MouseHandlerDefaultState = v;
      },
      7059: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.History = void 0;
        var o = n(2616),
          i = n(41),
          r = function () {
            function t(t, e) {
              this.modelManipulator = t, this.diagram = e, this.historyItems = [], this.currentIndex = -1, this.incrementalId = -1, this.transactionLevel = -1, this.unmodifiedIndex = -1, this.currTransactionId = 0, this.onChanged = new i.EventDispatcher();
            }
            return t.prototype.isModified = function () {
              if (this.unmodifiedIndex === this.currentIndex) return !1;
              for (var t = Math.min(this.unmodifiedIndex, this.currentIndex), e = Math.max(this.unmodifiedIndex, this.currentIndex), n = t + 1; n <= e; n++) if (this.historyItems[n].changeModified()) return !0;
              return !1;
            }, t.prototype.undo = function () {
              this.canUndo() && (this.historyItems[this.currentIndex].undo(this.modelManipulator), this.currentIndex--, this.raiseChanged());
            }, t.prototype.redo = function () {
              this.canRedo() && (this.startDataSyncItem && (this.startDataSyncItem.undo(this.modelManipulator), this.startDataSyncItem = void 0), this.currentIndex++, this.historyItems[this.currentIndex].redo(this.modelManipulator), this.raiseChanged());
            }, t.prototype.canUndo = function () {
              return this.currentIndex >= 0;
            }, t.prototype.canRedo = function () {
              return this.currentIndex < this.historyItems.length - 1;
            }, t.prototype.beginTransaction = function () {
              return this.transactionLevel++, 0 === this.transactionLevel && (this.transaction = new o.CompositionHistoryItem()), this.currTransactionId++;
            }, t.prototype.endTransaction = function (t) {
              if (!(--this.transactionLevel >= 0)) {
                var e = this.transaction.historyItems.length;
                if (e > 0) {
                  var n = e > 1 ? this.transaction : this.transaction.historyItems.pop();
                  t ? this.addDataSyncItem(n) : this.addInternal(n);
                }
                e > 0 && !t && this.raiseChanged(), delete this.transaction;
              }
            }, t.prototype.addAndRedo = function (t) {
              this.add(t), t.redo(this.modelManipulator), this.raiseChanged();
            }, t.prototype.add = function (t) {
              this.transactionLevel >= 0 ? this.transaction.add(t) : this.addInternal(t);
            }, t.prototype.addInternal = function (t) {
              this.currentIndex < this.historyItems.length - 1 && (this.historyItems.splice(this.currentIndex + 1), this.unmodifiedIndex = Math.min(this.unmodifiedIndex, this.currentIndex)), this.historyItems.push(t), this.currentIndex++, this.deleteOldItems();
            }, t.prototype.addDataSyncItem = function (t) {
              var e = this.historyItems[this.currentIndex];
              if (e) {
                var n = void 0;
                e instanceof o.CompositionHistoryItem ? n = e : (this.historyItems.splice(this.currentIndex, 1), n = new o.CompositionHistoryItem(), this.historyItems.push(n), n.historyItems.push(e)), n.dataSyncItems.push(t);
              } else this.historyItems.length && (this.startDataSyncItem = t);
            }, t.prototype.deleteOldItems = function () {
              var e = this.historyItems.length - t.MAX_HISTORY_ITEM_COUNT;
              e > 0 && this.currentIndex > e && (this.historyItems.splice(0, e), this.currentIndex -= e);
            }, t.prototype.getNextId = function () {
              return this.incrementalId++, this.incrementalId;
            }, t.prototype.clear = function () {
              this.currentIndex = -1, this.unmodifiedIndex = -1, this.incrementalId = -1, this.historyItems = [], delete this.transaction, this.transactionLevel = -1;
            }, t.prototype.resetModified = function () {
              this.unmodifiedIndex = this.currentIndex;
            }, t.prototype.getCurrentItemId = function () {
              if (-1 === this.currentIndex) return -1;
              var t = this.historyItems[this.currentIndex];
              return -1 === t.uniqueId && (t.uniqueId = this.getNextId()), t.uniqueId;
            }, t.prototype.undoTransaction = function () {
              this.diagram.beginUpdateCanvas();
              for (var t = this.transaction.historyItems; t.length;) t.pop().undo(this.modelManipulator);
              this.diagram.endUpdateCanvas();
            }, t.prototype.undoTransactionTo = function (t) {
              this.diagram.beginUpdateCanvas();
              for (var e = this.transaction.historyItems; e.length;) {
                var n = e.pop();
                if (n.undo(this.modelManipulator), n === t) break;
              }
              this.diagram.endUpdateCanvas();
            }, t.prototype.raiseChanged = function () {
              -1 === this.transactionLevel && this.onChanged.raise("notifyHistoryChanged");
            }, t.MAX_HISTORY_ITEM_COUNT = 100, t;
          }();
        e.History = r;
      },
      7169: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.InputManager = void 0;
        var o = n(6537),
          i = n(750),
          r = n(2136),
          s = n(5428),
          a = n(8408),
          c = n(6320),
          u = n(8451),
          p = n(5650),
          h = n(8424),
          l = n(9500),
          d = n(8509),
          f = n(1842),
          y = n(41),
          g = "dxdi-text-input",
          m = function () {
            function t(t, e, n, o, i, r) {
              this.mainElement = t, this.layoutPointResolver = e, this.eventManager = n, this.textMeasurer = o, this.actualZoom = i, this.focusElementsParent = r, this.focused = !1, this.focusLocked = !1, this.createInputElements(this.mainElement, this.focusElementsParent);
            }
            return t.prototype.detachEvents = function () {
              this.detachInputElementEvents(), this.detachTextInputElementEvents();
            }, t.prototype.isFocused = function () {
              return this.focused;
            }, t.prototype.captureFocus = function (t) {
              t && document.activeElement === this.textInputElement ? y.HtmlFocusUtils.focusWithPreventScroll(this.textInputElement || this.inputElement) : y.HtmlFocusUtils.focusWithPreventScroll(this.inputElement);
            }, t.prototype.clear = function () {
              this.setInputElementFocusHandlerMode(!1);
            }, t.prototype.setClipboardData = function (t) {
              this.clipboardInputElement.value = t, y.HtmlFocusUtils.focusWithPreventScroll(this.clipboardInputElement), this.clipboardInputElement.select(), document.execCommand("copy"), this.captureFocus();
            }, t.prototype.getClipboardData = function (t) {
              var e = this;
              navigator && navigator.clipboard ? navigator.clipboard.readText().then(function (n) {
                t(n), e.captureFocus();
              }).catch(function () {
                t(""), e.captureFocus();
              }) : h.Browser.IE && (this.clipboardInputElement.value = "", y.HtmlFocusUtils.focusWithPreventScroll(this.clipboardInputElement), this.clipboardInputElement.select(), document.execCommand("Paste"), t(this.clipboardInputElement.value), this.captureFocus());
            }, t.prototype.isPasteSupportedByBrowser = function () {
              return h.Browser.IE || h.Browser.WebKitFamily && navigator && void 0 !== navigator.clipboard;
            }, t.prototype.createInputElements = function (t, e) {
              this.createFocusInputElement(e || t), this.createTextInputElement(t), this.createClipboardInputElement(e || t), this.attachInputElementEvents();
            }, t.prototype.setInputElementFocusHandlerMode = function (t) {
              this.textInputElementContainer.setAttribute("class", "dxdi-text-input-container"), t && this.captureFocus();
            }, t.prototype.setInputElementTextInputMode = function (t, e, n, o, i, r) {
              this.textInputElementContainer.setAttribute("class", "dxdi-text-input-container " + i), this.textInputElement.value = t, this.setTextInputElementBounds(e, n, r), this.setTextInputElementStyle(o), this.updateTextInputPadding();
              var s = this.textInputElement || this.inputElement;
              y.HtmlFocusUtils.focusWithPreventScroll(s), s.select && s.select();
            }, t.prototype.setTextInputElementBounds = function (t, e, n) {
              this.savedTextInputPosition = t, this.savedTextInputSize = e, this.savedTextInputAngle = n;
              var o = this.layoutPointResolver.getAbsolutePoint(t, !0);
              this.textInputElementContainer.style.left = o.x + "px", this.textInputElementContainer.style.top = o.y + "px", this.textInputElementContainer.style.width = e && e.width + "px" || "0px", this.textInputElementContainer.style.height = e && e.height + "px" || "0px";
              var i = [];
              this.textInputElementContainer.style.transform = "", 1 !== this.actualZoom && i.push("scale(" + this.actualZoom + ")"), n && i.push("rotate(" + n + "deg)"), this.textInputElementContainer.style.transform = i.join(" "), this.textInputElement.style.width = e && e.width + "px" || "", this.textInputElement.style.height = e && e.height + "px" || "auto";
            }, t.prototype.setTextInputElementStyle = function (t) {
              this.savedTextInputStyle = t, r.RenderUtils.applyStyleToElement(t, this.textInputElement);
            }, t.prototype.createFocusInputElement = function (t) {
              this.inputElement = document.createElement("textarea"), this.inputElement.readOnly = h.Browser.TouchUI, this.inputElement.setAttribute("class", "dxdi-focus-input"), t.appendChild(this.inputElement);
            }, t.prototype.attachInputElementEvents = function () {
              this.onInputBlurHandler = this.onInputBlur.bind(this), this.onInputFocusHandler = this.onInputFocus.bind(this), this.onInputKeyDownHandler = this.onInputKeyDown.bind(this), this.onInputKeyPressHandler = this.onInputKeyPress.bind(this), this.onInputKeyUpHandler = this.onInputKeyUp.bind(this), this.onPasteHandler = this.onPaste.bind(this), d.RenderHelper.addEventListener(this.inputElement, "blur", this.onInputBlurHandler), d.RenderHelper.addEventListener(this.inputElement, "focus", this.onInputFocusHandler), d.RenderHelper.addEventListener(this.inputElement, "keydown", this.onInputKeyDownHandler), d.RenderHelper.addEventListener(this.inputElement, "keypress", this.onInputKeyPressHandler), d.RenderHelper.addEventListener(this.inputElement, "keyup", this.onInputKeyUpHandler), d.RenderHelper.addEventListener(this.inputElement, "paste", this.onPasteHandler);
            }, t.prototype.detachInputElementEvents = function () {
              d.RenderHelper.removeEventListener(this.inputElement, "blur", this.onInputBlurHandler), d.RenderHelper.removeEventListener(this.inputElement, "focus", this.onInputFocusHandler), d.RenderHelper.removeEventListener(this.inputElement, "keydown", this.onInputKeyDownHandler), d.RenderHelper.removeEventListener(this.inputElement, "keypress", this.onInputKeyPressHandler), d.RenderHelper.removeEventListener(this.inputElement, "keyup", this.onInputKeyUpHandler), d.RenderHelper.removeEventListener(this.inputElement, "paste", this.onPasteHandler);
            }, t.prototype.createTextInputElement = function (t) {
              this.textInputElementContainer = document.createElement("div"), this.textInputElementContainer.setAttribute("class", "dxdi-text-input-container"), t.appendChild(this.textInputElementContainer), this.textInputElement = document.createElement("textarea"), this.textInputElement.setAttribute("class", g), this.attachTextInputElementEvents(), this.textInputElementContainer.appendChild(this.textInputElement);
            }, t.prototype.attachTextInputElementEvents = function () {
              this.onTextInputBlurHandler = this.onTextInputBlur.bind(this), this.onTextInputFocusHandler = this.onTextInputFocus.bind(this), this.onTextInputKeyDownHandler = this.onTextInputKeyDown.bind(this), this.onTextInputMouseWheelHandler = this.onTextInputMouseWheel.bind(this), this.onTextInputMouseUpHandler = this.onTextInputMouseUp.bind(this), this.onTextInputKeyUpHandler = this.onTextInputKeyUp.bind(this), this.onTextInputChangeHandler = this.onTextInputChange.bind(this), d.RenderHelper.addEventListener(this.textInputElement, "mousewheel", this.onTextInputMouseWheelHandler), d.RenderHelper.addEventListener(this.textInputElement, "mouseup", this.onTextInputMouseUpHandler), d.RenderHelper.addEventListener(this.textInputElement, "blur", this.onTextInputBlurHandler), d.RenderHelper.addEventListener(this.textInputElement, "focus", this.onTextInputFocusHandler), d.RenderHelper.addEventListener(this.textInputElement, "keydown", this.onTextInputKeyDownHandler), d.RenderHelper.addEventListener(this.textInputElement, "keyup", this.onTextInputKeyUpHandler), d.RenderHelper.addEventListener(this.textInputElement, "change", this.onTextInputChangeHandler);
            }, t.prototype.detachTextInputElementEvents = function () {
              d.RenderHelper.removeEventListener(this.textInputElement, "mousewheel", this.onTextInputMouseWheelHandler), d.RenderHelper.removeEventListener(this.textInputElement, "mouseup", this.onTextInputMouseUpHandler), d.RenderHelper.removeEventListener(this.textInputElement, "blur", this.onTextInputBlurHandler), d.RenderHelper.removeEventListener(this.textInputElement, "focus", this.onTextInputFocusHandler), d.RenderHelper.removeEventListener(this.textInputElement, "keydown", this.onTextInputKeyDownHandler), d.RenderHelper.removeEventListener(this.textInputElement, "keyup", this.onTextInputKeyUpHandler), d.RenderHelper.removeEventListener(this.textInputElement, "change", this.onTextInputChangeHandler);
            }, t.prototype.createClipboardInputElement = function (t) {
              this.clipboardInputElement = document.createElement("textarea"), this.clipboardInputElement.setAttribute("class", "dxdi-clipboard-input"), t.appendChild(this.clipboardInputElement);
            }, t.prototype.blurControl = function () {
              this.focusLocked || (this.focused = !1, i.DomUtils.removeClassName(this.mainElement, "focused"));
            }, t.prototype.focusControl = function () {
              this.focused = !0, this.focusLocked = !1, i.DomUtils.addClassName(this.mainElement, "focused");
            }, t.prototype.updateTextInputPadding = function () {
              var t = this.textInputElement.value;
              if (this.savedTextInputSize) {
                n = this.textMeasurer.measureWords(t, this.savedTextInputStyle, p.TextOwner.Shape), o = (0, f.getTextHeight)(t, this.savedTextInputSize.width, n, !0);
                var e = Math.max(0, .5 * (this.savedTextInputSize.height - o));
                this.textInputElement.style.paddingTop = Math.ceil(e) + "px", this.textInputElement.style.height = Math.floor(this.savedTextInputSize.height) + "px";
              } else {
                var n = this.textMeasurer.measureWords(" ", this.savedTextInputStyle, p.TextOwner.Connector),
                  o = (0, f.getLineHeight)(n) * (((0, f.textToParagraphs)(t).length || 1) + 1);
                this.textInputElement.style.height = Math.ceil(o) + "px";
              }
            }, t.prototype.onInputBlur = function (t) {
              var e = this;
              this.blurControl(), (0, r.raiseEvent)(t, this.getDiagramFocusEvent(t), function (t) {
                return e.eventManager.onBlur(t);
              });
            }, t.prototype.onInputFocus = function (t) {
              var e = this;
              this.focusControl(), (0, r.raiseEvent)(t, this.getDiagramFocusEvent(t), function (t) {
                return e.eventManager.onFocus(t);
              });
            }, t.prototype.onInputKeyDown = function (t) {
              var e = this;
              (0, r.raiseEvent)(t, this.getDiagramKeyboardEvent(t), function (t) {
                return e.eventManager.onKeyDown(t);
              });
            }, t.prototype.onInputKeyPress = function (t) {
              !t.preventDefault || h.Browser.Safari && "KeyV" === t.code || t.preventDefault();
            }, t.prototype.onInputKeyUp = function (t) {
              var e = this;
              (0, r.raiseEvent)(t, this.getDiagramKeyboardEvent(t), function (t) {
                return e.eventManager.onKeyUp(t);
              });
            }, t.prototype.onTextInputBlur = function (t) {
              var e = this;
              if (this.eventManager.canFinishTextEditing()) this.blurControl(), (0, r.raiseEvent)(t, this.getDiagramFocusEvent(t), function (t) {
                return e.eventManager.onTextInputBlur(t);
              });else {
                var n = u.EvtUtils.getEventSource(t);
                document.activeElement !== n && n.focus();
              }
            }, t.prototype.onTextInputFocus = function (t) {
              var e = this;
              this.focusControl(), (0, r.raiseEvent)(t, this.getDiagramFocusEvent(t), function (t) {
                return e.eventManager.onTextInputFocus(t);
              });
            }, t.prototype.onTextInputKeyDown = function (t) {
              var e = this;
              (0, r.raiseEvent)(t, this.getDiagramKeyboardEvent(t), function (t) {
                return e.eventManager.onTextInputKeyDown(t);
              });
            }, t.prototype.onTextInputKeyUp = function (t) {
              this.updateTextInputPadding();
            }, t.prototype.onTextInputChange = function (t) {
              this.updateTextInputPadding();
            }, t.prototype.onPaste = function (t) {
              var e = this;
              (0, r.raiseEvent)(t, this.getDiagramClipboardEvent(t), function (t) {
                return e.eventManager.onPaste(t);
              });
            }, t.prototype.onTextInputMouseWheel = function (t) {
              this.mouseWheelHandler && this.mouseWheelHandler(t);
            }, t.prototype.onTextInputMouseUp = function (t) {
              t.stopPropagation && t.stopPropagation(), u.EvtUtils.cancelBubble(t);
            }, t.prototype.getDiagramKeyboardEvent = function (t) {
              return new s.DiagramKeyboardEvent(o.KeyUtils.getKeyModifiers(t), o.KeyUtils.getEventKeyCode(t), this.textInputElement.value);
            }, t.prototype.getTextInputElementValue = function () {
              return this.textInputElement.value;
            }, t.prototype.getDiagramFocusEvent = function (t) {
              return new s.DiagramFocusEvent(t.target.value);
            }, t.prototype.getDiagramClipboardEvent = function (t) {
              var e,
                n = t.clipboardData || t.originalEvent && t.originalEvent.clipboardData;
              return e = void 0 !== n ? n.getData("text/plain") : window.clipboardData.getData("Text"), new s.DiagramClipboardEvent(e);
            }, t.prototype.isTextInputElement = function (t) {
              return "string" == typeof t.className && t.className.indexOf(g) > -1;
            }, t.prototype.lockFocus = function () {
              var t = this;
              this.focusLocked = !0, setTimeout(function () {
                return t.focusLocked = !1;
              }, 10);
            }, t.prototype.notifyViewAdjusted = function (t) {}, t.prototype.notifyActualZoomChanged = function (t) {
              this.actualZoom = t, this.savedTextInputPosition && this.savedTextInputSize && this.setTextInputElementBounds(this.savedTextInputPosition, this.savedTextInputSize, this.savedTextInputAngle);
            }, t.prototype.notifyTextInputStart = function (t, e, n, o) {
              var i,
                r = "";
              t instanceof a.Shape ? (r = "shape-text", i = t.textAngle) : t instanceof c.Connector && (r = "connector-text"), o = o && o.clone().applyConverter(l.UnitConverter.twipsToPixels), this.setInputElementTextInputMode(e, n, o, t.styleText, r, i);
            }, t.prototype.notifyTextInputEnd = function (t, e) {
              this.setInputElementFocusHandlerMode(e);
            }, t.prototype.notifyTextInputPermissionsCheck = function (t, e) {}, t;
          }();
        e.InputManager = m;
      },
      7185: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ShapeWithImageDescription = e.SHAPE_IMAGE_CLASSNAMES = e.ShapeDefaultSize = e.ShapeDefaultDimension = void 0;
        var r = n(1280),
          s = n(4412),
          a = n(3844),
          c = n(5327),
          u = n(9500),
          p = n(4),
          h = n(94),
          l = n(6709),
          d = n(2136),
          f = n(5654),
          y = n(6018);
        e.ShapeDefaultDimension = 1440, e.ShapeDefaultSize = new a.Size(e.ShapeDefaultDimension, e.ShapeDefaultDimension), e.SHAPE_IMAGE_CLASSNAMES = {
          IMAGE: "dxdi-image",
          IMAGE_PLACEHOLDER: "dxdi-image-placeholder",
          LOADING_INDICATOR: "dxdi-spinner",
          USER_PIC: "dxdi-user",
          WARNING_MARK: "dxdi-warning"
        };
        var g = function (t) {
          function n(n, o) {
            void 0 === n && (n = e.ShapeDefaultSize.clone());
            var i = t.call(this, n, o) || this;
            return i.hasDefaultText = o, i.defaultIconSize = 480, i;
          }
          return i(n, t), Object.defineProperty(n.prototype, "enableImage", {
            get: function () {
              return !0;
            },
            enumerable: !1,
            configurable: !0
          }), n.prototype.getImageMargin = function (t) {
            return t ? u.UnitConverter.pixelsToTwips(2) : u.UnitConverter.pixelsToTwips(3);
          }, n.prototype.createImagePrimitives = function (t, n) {
            if (!this.enableImage) return [];
            var o = this.getImagePlacementRectangle(t.rectangle, n);
            if (n) return this.createImagePlaceholder(o);
            var i = [];
            if (i = t.image.isEmpty || t.image.unableToLoad ? i.concat(this.createEmptyImagePrimitives(o, t.image.unableToLoad)) : "" === t.image.renderUrl ? i.concat(this.createLoadingImagePrimitives(o)) : i.concat(this.createLoadedImagePrimitives(o, t.image.renderUrl)), "" === t.image.renderUrl) {
              var r = d.RenderUtils.generateSvgElementId("clipImage");
              return [].concat([new l.GroupPrimitive(i, e.SHAPE_IMAGE_CLASSNAMES.IMAGE, void 0, r), new f.ClipPathPrimitive(r, [new h.RectanglePrimitive(o.x, o.y, o.width, o.height)])]);
            }
            return i;
          }, n.prototype.createImagePlaceholder = function (t) {
            return [];
          }, n.prototype.createLoadedImagePrimitives = function (t, o) {
            return [new p.ImagePrimitive(t.x, t.y, t.width, t.height, o, n.imageScalingRule, void 0, e.SHAPE_IMAGE_CLASSNAMES.IMAGE)];
          }, n.prototype.createLoadingImagePrimitives = function (t) {
            var n = this.getIconPlacementRectangle(t);
            return [y.ShapeImageIndicator.createLoadingIndicatorPrimitives(n.x, n.y, this.defaultIconSize, u.UnitConverter.pixelsToTwips(5), e.SHAPE_IMAGE_CLASSNAMES.LOADING_INDICATOR)];
          }, n.prototype.createEmptyImagePrimitives = function (t, e) {
            var n = this.getIconPlacementRectangle(t),
              o = [];
            return o = o.concat(this.createEmptyImagePrimitive(n)), e && (o = o.concat(this.createWarningPrimitive(n))), o;
          }, n.prototype.createEmptyImagePrimitive = function (t) {
            return new l.GroupPrimitive([]);
          }, n.prototype.createWarningPrimitive = function (t) {
            return new l.GroupPrimitive([]);
          }, n.prototype.getIconPlacementRectangle = function (t) {
            var e = s.Rectangle.fromGeometry(new c.Point(t.x, t.y), new a.Size(this.defaultIconSize, this.defaultIconSize));
            return e.width < t.width && (e.x = t.x + (t.width - e.width) / 2), e.height < t.height && (e.y = t.y + (t.height - e.height) / 2), e;
          }, n.imageScalingRule = "xMidYMid meet", n;
        }(r.ShapeDescription);
        e.ShapeWithImageDescription = g;
      },
      7201: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ChangeGridSizeItemsCommand = e.ChangeGridSizeCommand = void 0;
        var r = n(3913),
          s = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), e.prototype.isEnabledInReadOnlyMode = function () {
              return !0;
            }, e.prototype.getValue = function () {
              return this.getModelUnit(this.control.settings.gridSize);
            }, e.prototype.executeCore = function (t, e) {
              return this.control.settings.gridSize = this.getModelUnitTwipsValue(e), !0;
            }, e.prototype.getItems = function () {
              var t = this;
              return this.control.settings.gridSizeItems.map(function (e) {
                return {
                  value: t.getModelUnit(e),
                  text: t.getViewUnitText(e)
                };
              });
            }, e;
          }(r.SimpleCommandBase);
        e.ChangeGridSizeCommand = s;
        var a = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(e, t), e.prototype.isEnabledInReadOnlyMode = function () {
            return !0;
          }, e.prototype.getValue = function () {
            var t = this;
            return this.control.settings.gridSizeItems.map(function (e) {
              return t.getModelUnit(e);
            });
          }, e.prototype.executeCore = function (t, e) {
            var n = this;
            return this.control.settings.gridSizeItems = e.map(function (t) {
              return n.getModelUnitTwipsValue(t);
            }), !0;
          }, e;
        }(r.SimpleCommandBase);
        e.ChangeGridSizeItemsCommand = a;
      },
      7271: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.RemoveFromContainerHistoryItem = void 0;
        var r = function (t) {
          function e(e) {
            var n = t.call(this) || this;
            return n.itemKey = e.key, n;
          }
          return i(e, t), e.prototype.redo = function (t) {
            var e = t.model.findItem(this.itemKey);
            this.containerKey = e.container && e.container.key, t.removeFromContainer(e);
          }, e.prototype.undo = function (t) {
            var e = t.model.findContainer(this.containerKey),
              n = t.model.findItem(this.itemKey);
            t.insertToContainer(n, e);
          }, e;
        }(n(2616).HistoryItem);
        e.RemoveFromContainerHistoryItem = r;
      },
      7281: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.NativeScrollView = void 0;
        var o = n(41),
          i = n(3844),
          r = n(5327),
          s = n(750),
          a = n(8509),
          c = function () {
            function t(t) {
              this.onScroll = new o.EventDispatcher(), this.scrollBarWidth = s.DomUtils.getVerticalScrollBarWidth(), this.mainElement = t, this.attachEvents();
            }
            return t.prototype.attachEvents = function () {
              var t = this;
              this.onScrollHandler = function () {
                return t.onScroll.raise1(function (e) {
                  return e.notifyScrollChanged(function () {
                    return t.getScroll();
                  });
                });
              }, a.RenderHelper.addEventListener(this.mainElement, "scroll", this.onScrollHandler);
            }, t.prototype.detachEvents = function () {
              a.RenderHelper.removeEventListener(this.mainElement, "scroll", this.onScrollHandler);
            }, t.prototype.getScrollContainer = function () {
              return this.mainElement;
            }, t.prototype.setScroll = function (t, e) {
              var n = this;
              this.mainElement.style.overflow = "scroll", this.mainElement.scrollLeft = t, this.mainElement.scrollTop = e, this.mainElement.style.overflow = "", this.onScroll.raise1(function (t) {
                return t.notifyScrollChanged(function () {
                  return n.getScroll();
                });
              });
            }, t.prototype.offsetScroll = function (t, e) {
              var n = this;
              t && (this.mainElement.scrollLeft += t), e && (this.mainElement.scrollTop += e), this.onScroll.raise1(function (t) {
                return t.notifyScrollChanged(function () {
                  return n.getScroll();
                });
              });
            }, t.prototype.getScroll = function () {
              return new r.Point(this.mainElement.scrollLeft, this.mainElement.scrollTop);
            }, t.prototype.getSize = function () {
              var t = this.mainElement.getBoundingClientRect();
              return new i.Size(Math.floor(t.width), Math.floor(t.height));
            }, t.prototype.getScrollBarWidth = function () {
              return this.scrollBarWidth;
            }, t;
          }();
        e.NativeScrollView = c;
      },
      7283: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AutoLayoutTreeHorizontalCommand = void 0;
        var r = n(8674),
          s = n(8533),
          a = n(9212),
          c = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), e.prototype.createLayoutSettings = function () {
              var t = this.control.settings.snapToGrid ? this.control.settings.gridSize : void 0,
                e = new a.TreeLayoutSettings(t);
              return e.orientation = a.DataLayoutOrientation.Horizontal, e;
            }, e.prototype.createLayout = function (t, e) {
              return new s.TreeLayoutBuilder(t, e).build();
            }, e;
          }(r.AutoLayoutCommandBase);
        e.AutoLayoutTreeHorizontalCommand = c;
      },
      7301: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.PatternPrimitive = void 0;
        var r = n(8509),
          s = function (t) {
            function e(e, n, o, i, r, s, a) {
              var c = t.call(this, a) || this;
              return c.id = e, c.x = o, c.y = i, c.width = r, c.height = s, c.children = n, c;
            }
            return i(e, t), e.prototype.createMainElement = function () {
              var t = document.createElementNS(r.svgNS, "pattern");
              return t.setAttribute("patternUnits", "userSpaceOnUse"), t.setAttribute("id", this.id), t;
            }, e.prototype.applyElementProperties = function (e, n) {
              this.setUnitAttribute(e, "x", this.x), this.setUnitAttribute(e, "y", this.y), this.setUnitAttribute(e, "width", this.width), this.setUnitAttribute(e, "height", this.height), this.setPositionCorrectionAttribute(e), t.prototype.applyElementProperties.call(this, e, n);
            }, e;
          }(n(8309).SvgPrimitive);
        e.PatternPrimitive = s;
      },
      7345: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.EllipsePrimitive = void 0;
        var r = n(8509),
          s = function (t) {
            function e(e, n, o, i, r, s, a) {
              var c = t.call(this, r, s, void 0, a) || this;
              return c.cx = e, c.cy = n, c.rx = o, c.ry = i, c;
            }
            return i(e, t), e.prototype.createMainElement = function () {
              return document.createElementNS(r.svgNS, "ellipse");
            }, e.prototype.applyElementProperties = function (e, n) {
              this.setUnitAttribute(e, "cx", this.cx), this.setUnitAttribute(e, "cy", this.cy), this.setUnitAttribute(e, "rx", this.rx), this.setUnitAttribute(e, "ry", this.ry), this.setPositionCorrectionAttribute(e), t.prototype.applyElementProperties.call(this, e, n);
            }, e;
          }(n(8309).SvgPrimitive);
        e.EllipsePrimitive = s;
      },
      7368: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.TerminatorShapeDescription = void 0;
        var r = n(3190),
          s = n(3255),
          a = n(6208),
          c = n(3844),
          u = n(1280),
          p = n(4412),
          h = n(41),
          l = function (t) {
            function e() {
              return t.call(this, new c.Size(u.ShapeDefaultDimension, .5 * u.ShapeDefaultDimension), !0) || this;
            }
            return i(e, t), Object.defineProperty(e.prototype, "key", {
              get: function () {
                return s.ShapeTypes.Terminator;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "keepRatioOnAutoSize", {
              get: function () {
                return !1;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.createShapePrimitives = function (t) {
              var n = t.rectangle,
                o = n.x,
                i = n.y,
                r = n.right,
                s = n.bottom,
                c = n.width,
                u = n.center.y,
                p = o + c * e.curveWidthRatio,
                h = o + c * (1 - e.curveWidthRatio);
              return [new a.PathPrimitive([new a.PathPrimitiveMoveToCommand(p, i), new a.PathPrimitiveLineToCommand(h, i), new a.PathPrimitiveQuadraticCurveToCommand(r, i, r, u), new a.PathPrimitiveQuadraticCurveToCommand(r, s, h, s), new a.PathPrimitiveLineToCommand(p, s), new a.PathPrimitiveQuadraticCurveToCommand(o, s, o, u), new a.PathPrimitiveQuadraticCurveToCommand(o, i, p, i), new a.PathPrimitiveClosePathCommand()], t.style)];
            }, e.prototype.getTextRectangle = function (t) {
              var e = h.GeometryUtils.getMaxRectangleEnscribedInEllipse(t.size);
              return p.Rectangle.fromGeometry(t.position.clone().offset((t.size.width - e.width) / 2, (t.size.height - e.height) / 2), e);
            }, e.prototype.getSizeByText = function (t, e) {
              return h.GeometryUtils.getEllipseByEnscribedRectangle(t);
            }, e.curveWidthRatio = .3, e;
          }(r.RectangleShapeDescription);
        e.TerminatorShapeDescription = l;
      },
      7392: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.DeleteConnectorHistoryItem = void 0;
        var r = function (t) {
          function e(e) {
            var n = t.call(this) || this;
            return n.connectorKey = e, n;
          }
          return i(e, t), e.prototype.redo = function (t) {
            var e = t.model.findConnector(this.connectorKey);
            this.connector = e.clone(), t.deleteConnector(e);
          }, e.prototype.undo = function (t) {
            t.addConnector(this.connector, this.connector.key);
          }, e;
        }(n(2616).HistoryItem);
        e.DeleteConnectorHistoryItem = r;
      },
      7418: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.StylePropertyCommandBase = void 0;
        var r = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(e, t), e.prototype.lockInputPositionUpdating = function () {
            return !0;
          }, e;
        }(n(3913).SimpleCommandBase);
        e.StylePropertyCommandBase = r;
      },
      7436: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ArrowVerticalShapeDescription = e.ArrowVerticalLineWidthParameterName = e.ArrowVerticalTriangleHeightParameterName = void 0;
        var r = n(1280),
          s = n(3844),
          a = n(4636),
          c = n(4824);
        e.ArrowVerticalTriangleHeightParameterName = "th", e.ArrowVerticalLineWidthParameterName = "lw";
        var u = function (t) {
          function n() {
            return t.call(this, new s.Size(.375 * r.ShapeDefaultDimension, r.ShapeDefaultDimension)) || this;
          }
          return i(n, t), Object.defineProperty(n.prototype, "keepRatioOnAutoSize", {
            get: function () {
              return !1;
            },
            enumerable: !1,
            configurable: !0
          }), n.prototype.createParameters = function (t) {
            t.addRangeIfNotExists([new a.ShapeParameter(e.ArrowVerticalTriangleHeightParameterName, Math.sqrt(Math.pow(this.defaultSize.width, 2) - Math.pow(this.defaultSize.width / 2, 2))), new a.ShapeParameter(e.ArrowVerticalLineWidthParameterName, this.defaultSize.width / 3)]);
          }, n.prototype.normalizeParameters = function (t, n) {
            this.changeParameterValue(n, e.ArrowVerticalTriangleHeightParameterName, function (e) {
              return Math.max(0, Math.min(t.size.height, e.value));
            }), this.changeParameterValue(n, e.ArrowVerticalLineWidthParameterName, function (e) {
              return Math.max(0, Math.min(t.size.width, e.value));
            });
          }, n.prototype.processConnectionPoint = function (t, n) {
            var o = (t.size.width - t.parameters.get(e.ArrowVerticalLineWidthParameterName).value) / 2,
              i = t.getConnectionPointSide(n);
            i === c.ConnectionPointSide.East ? n.x -= o : i === c.ConnectionPointSide.West && (n.x += o);
          }, n.prototype.getTextRectangle = function (t) {
            return t.rectangle.clone().inflate(-r.ShapeTextPadding, -r.ShapeTextPadding);
          }, n.prototype.getSizeByText = function (t, e) {
            return t.clone().offset(2 * r.ShapeTextPadding, 2 * r.ShapeTextPadding);
          }, n;
        }(r.ShapeDescription);
        e.ArrowVerticalShapeDescription = u;
      },
      7443: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ArrowUpDownShapeDescription = void 0;
        var r = n(6208),
          s = n(9763),
          a = n(5327),
          c = n(7436),
          u = n(3255),
          p = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), Object.defineProperty(e.prototype, "key", {
              get: function () {
                return u.ShapeTypes.ArrowUpDown;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.createShapePrimitives = function (t) {
              var e = t.rectangle,
                n = e.x,
                o = e.y,
                i = e.right,
                s = e.bottom,
                a = e.width,
                u = e.center.x,
                p = (a - t.parameters.get(c.ArrowVerticalLineWidthParameterName).value) / 2,
                h = t.parameters.get(c.ArrowVerticalTriangleHeightParameterName).value,
                l = t.normalizeX(n + p),
                d = t.normalizeY(o + h),
                f = t.normalizeX(i - p),
                y = t.normalizeY(s - h);
              return [new r.PathPrimitive([new r.PathPrimitiveMoveToCommand(u, o), new r.PathPrimitiveLineToCommand(i, d), new r.PathPrimitiveLineToCommand(f, d), new r.PathPrimitiveLineToCommand(f, y), new r.PathPrimitiveLineToCommand(i, y), new r.PathPrimitiveLineToCommand(u, s), new r.PathPrimitiveLineToCommand(n, y), new r.PathPrimitiveLineToCommand(l, y), new r.PathPrimitiveLineToCommand(l, d), new r.PathPrimitiveLineToCommand(n, d), new r.PathPrimitiveClosePathCommand()], t.style)];
            }, e.prototype.normalizeParameters = function (t, e) {
              this.changeParameterValue(e, c.ArrowVerticalTriangleHeightParameterName, function (e) {
                return Math.max(0, Math.min(t.size.height / 2 - 2 * t.strokeWidth, e.value));
              }), this.changeParameterValue(e, c.ArrowVerticalLineWidthParameterName, function (e) {
                return Math.max(0, Math.min(t.size.width, e.value));
              });
            }, e.prototype.modifyParameters = function (t, e, n, o) {
              this.changeParameterValue(e, c.ArrowVerticalTriangleHeightParameterName, function (t) {
                return t.value + o;
              }), this.changeParameterValue(e, c.ArrowVerticalLineWidthParameterName, function (t) {
                return t.value - 2 * n;
              }), this.normalizeParameters(t, e);
            }, e.prototype.getParameterPoints = function (t) {
              return [new s.ShapeParameterPoint("c", new a.Point(t.normalizeX(t.position.x + (t.size.width - t.parameters.get(c.ArrowVerticalLineWidthParameterName).value) / 2), t.normalizeY(t.position.y + t.parameters.get(c.ArrowVerticalTriangleHeightParameterName).value)))];
            }, e;
          }(c.ArrowVerticalShapeDescription);
        e.ArrowUpDownShapeDescription = p;
      },
      7446: (t, e) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ConstInterval = void 0;
        var n = function () {
          function t() {}
          return Object.defineProperty(t.prototype, "center", {
            get: function () {
              return this.start + this.length / 2;
            },
            enumerable: !1,
            configurable: !0
          }), t.prototype.isNormalized = function () {
            return this.end >= this.start;
          }, t.prototype.isCollapsed = function () {
            return 0 === this.length;
          }, t.prototype.equals = function (t) {
            return this.start === t.start && this.end === t.end;
          }, t.isCollapsed = function (t) {
            return !t[1] && t[0].isCollapsed();
          }, t.prototype.containsInterval = function (t) {
            return this.start <= t.start && this.end >= t.end;
          }, t.prototype.containsIntervalWithoutEnd = function (t) {
            return this.start <= t.start && this.end > t.end;
          }, t.prototype.contains = function (t) {
            return this.start <= t && t < this.end;
          }, t.prototype.containsWithIntervalEnd = function (t) {
            return this.start <= t && t <= this.end;
          }, t.prototype.containsWithoutIntervalEndAndStart = function (t) {
            return this.start < t && t < this.end;
          }, t;
        }();
        e.ConstInterval = n;
      },
      7450: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.PreparationShapeDescription = void 0;
        var r = n(3255),
          s = n(3844),
          a = n(1280),
          c = function (t) {
            function e() {
              var e = t.call(this, !0) || this;
              return e.defaultSize = new s.Size(a.ShapeDefaultDimension, .75 * a.ShapeDefaultDimension), e;
            }
            return i(e, t), Object.defineProperty(e.prototype, "key", {
              get: function () {
                return r.ShapeTypes.Preparation;
              },
              enumerable: !1,
              configurable: !0
            }), e;
          }(n(9543).HexagonShapeDescription);
        e.PreparationShapeDescription = c;
      },
      7489: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ChangeShapeParametersHistoryItem = void 0;
        var r = function (t) {
          function e(e, n) {
            var o = t.call(this) || this;
            return o.shapeKey = e, o.parameters = n, o;
          }
          return i(e, t), e.prototype.redo = function (t) {
            var e = t.model.findShape(this.shapeKey);
            this.oldParameters = e.parameters.clone(), t.changeShapeParameters(e, this.parameters);
          }, e.prototype.undo = function (t) {
            var e = t.model.findShape(this.shapeKey);
            t.changeShapeParameters(e, this.oldParameters);
          }, e;
        }(n(2616).HistoryItem);
        e.ChangeShapeParametersHistoryItem = r;
      },
      7534: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ToggleFontUnderlineCommand = void 0;
        var r = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(e, t), e.prototype.getStyleProperty = function () {
            return "text-decoration";
          }, e.prototype.getStylePropertyValue = function () {
            return "underline";
          }, e;
        }(n(3210).ToggleStyleTextPropertyCommand);
        e.ToggleFontUnderlineCommand = r;
      },
      7562: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CopySelectionCommand = void 0;
        var r = n(8762),
          s = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), e.prototype.isEnabled = function () {
              return t.prototype.isEnabled.call(this) && !this.control.selection.isEmpty(!0);
            }, e.prototype.isEnabledInReadOnlyMode = function () {
              return !0;
            }, e.prototype.executeCore = function (t) {
              var e = new r.Exporter().exportItems(this.control.selection.getSelectedItems(!0, !0));
              return this.setClipboardData(e), !0;
            }, e;
          }(n(1311).ClipboardCommand);
        e.CopySelectionCommand = s;
      },
      7611: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AutoScrollController = void 0;
        var o = n(8509),
          i = n(750),
          r = n(3844),
          s = n(41),
          a = function () {
            function t(t, e, n, o) {
              this.scroll = t, this.svgElement = e, this.view = n, this.dom = o, this.leftButtonPressed = !1, this.scrollDragging = !1, this.scrollTimer = -1, this.scrollBarWidth = i.DomUtils.getVerticalScrollBarWidth();
            }
            return t.prototype.onMouseMove = function (t, e) {
              this.clearScrollTimer(), s.EventUtils.isLeftButtonPressed(t) || (this.leftButtonPressed = !1), this.canAutoScroll() && this.changeScrollPosition(t, e, !1);
            }, t.prototype.onMouseDown = function (t) {
              this.leftButtonPressed = !!s.EventUtils.isLeftButtonPressed(t);
            }, t.prototype.onMouseUp = function (t) {
              this.clearScrollTimer(), this.leftButtonPressed = !1;
            }, t.prototype.onMouseEnter = function (t) {
              var e = this;
              s.EventUtils.isLeftButtonPressed(t) && setTimeout(function () {
                e.leftButtonPressed = !0;
              }, 500);
            }, t.prototype.onDragScrollStart = function () {
              this.scrollDragging = !0;
            }, t.prototype.onDragScrollEnd = function () {
              this.scrollDragging = !1;
            }, t.prototype.canAutoScroll = function () {
              return this.leftButtonPressed && !this.scrollDragging;
            }, t.prototype.changeScrollPosition = function (t, e, n) {
              var o = this,
                s = !1;
              if (!this.view.isAutoScrollLocked()) {
                var a = this.scroll.getScrollContainer(),
                  c = t.pageX - i.DomUtils.getAbsolutePositionX(a),
                  u = t.pageY - i.DomUtils.getAbsolutePositionY(a),
                  p = this.scroll.getSize(),
                  h = new r.Size(parseFloat(this.svgElement.style.width), parseFloat(this.svgElement.style.height)),
                  l = p.width;
                p.width < h.width && (l -= this.scrollBarWidth);
                var d = p.height;
                p.height < h.height && (d -= this.scrollBarWidth), c <= 40 ? (this.dom.changeByFunc(null, function () {
                  o.view.isAutoScrollLocked() || o.scroll.offsetScroll(-o.getScrollingOffset(c), 0);
                }), s = !0) : l - 40 <= c && (this.dom.changeByFunc(null, function () {
                  o.view.isAutoScrollLocked() || o.scroll.offsetScroll(o.getScrollingOffset(l - c), 0);
                }), s = !0), u <= 40 ? (this.dom.changeByFunc(null, function () {
                  o.view.isAutoScrollLocked() || o.scroll.offsetScroll(0, -o.getScrollingOffset(u));
                }), s = !0) : d - 40 <= u && (this.dom.changeByFunc(null, function () {
                  o.view.isAutoScrollLocked() || o.scroll.offsetScroll(0, o.getScrollingOffset(d - u));
                }), s = !0);
              }
              (s || this.view.isAutoScrollLocked()) && (this.scrollTimer = window.setTimeout(function () {
                return o.changeScrollPosition(t, e, s);
              }, 50)), n && e();
            }, t.prototype.clearScrollTimer = function () {
              this.scrollTimer > -1 && (window.clearTimeout(this.scrollTimer), this.scrollTimer = -1);
            }, t.prototype.getScrollingOffset = function (t) {
              var e = Math.pow((40 - t) / 5, 2);
              return Math.round(Math.min(e, 5));
            }, t.createMainElement = function (t) {
              var e = document.createElement("div");
              return e.setAttribute("class", "dxdi-control"), t.appendChild(e), e;
            }, t.createSvgElement = function (t, e) {
              void 0 === e && (e = !1);
              var n = document.createElementNS(o.svgNS, "svg");
              return n.className.baseVal = "dxdi-canvas" + (e ? " export" : ""), t.appendChild(n), n;
            }, t;
          }();
        e.AutoScrollController = a;
      },
      7615: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.InsertShapeImageCommand = void 0;
        var r = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(e, t), e.prototype.isEnabled = function () {
            var e = this.getSelectedShape();
            return t.prototype.isEnabled.call(this) && e.image.isEmpty;
          }, e;
        }(n(877).EditShapeImageCommandBase);
        e.InsertShapeImageCommand = r;
      },
      7672: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ImportShapeHistoryItem = void 0;
        var r = function (t) {
          function e(e) {
            var n = t.call(this) || this;
            return n.shape = e, n;
          }
          return i(e, t), e.prototype.redo = function (t) {
            this.shapeKey = this.shape.key, t.insertShape(this.shape);
          }, e.prototype.undo = function (t) {
            t.removeShape(t.model.findShape(this.shapeKey), !0);
          }, e;
        }(n(2616).HistoryItem);
        e.ImportShapeHistoryItem = r;
      },
      7727: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.HeartShapeDescription = void 0;
        var r = n(1280),
          s = n(6208),
          a = n(3255),
          c = n(4856),
          u = n(4824),
          p = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), Object.defineProperty(e.prototype, "key", {
              get: function () {
                return a.ShapeTypes.Heart;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "keepRatioOnAutoSize", {
              get: function () {
                return !0;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.createConnectionPoints = function () {
              return [new c.ConnectionPoint(.5, .15, u.ConnectionPointSide.North), new c.ConnectionPoint(1, .25, u.ConnectionPointSide.East), new c.ConnectionPoint(.5, 1, u.ConnectionPointSide.South), new c.ConnectionPoint(0, .25, u.ConnectionPointSide.West)];
            }, e.prototype.createShapePrimitives = function (t) {
              var e = t.rectangle,
                n = e.x,
                o = e.y,
                i = e.right,
                r = e.bottom,
                a = e.width,
                c = e.height;
              return [new s.PathPrimitive([new s.PathPrimitiveMoveToCommand(i - .25 * a, o), new s.PathPrimitiveCubicCurveToCommand(i - .15 * a, o, i, o + .1 * c, i, o + .25 * c), new s.PathPrimitiveCubicCurveToCommand(i, o + .3 * c, i - .02 * a, o + .35 * c, i - .05 * a, o + .4 * c), new s.PathPrimitiveLineToCommand(e.center.x, r), new s.PathPrimitiveLineToCommand(n + .05 * a, o + .4 * c), new s.PathPrimitiveCubicCurveToCommand(n + .02 * a, o + .35 * c, n, o + .3 * c, n, o + .25 * c), new s.PathPrimitiveCubicCurveToCommand(n, o + .1 * c, n + .15 * a, o, n + .25 * a, o), new s.PathPrimitiveCubicCurveToCommand(n + .3 * a, o, n + .45 * a, o + .03 * c, n + .5 * a, o + .15 * c), new s.PathPrimitiveCubicCurveToCommand(i - .45 * a, o + .03 * c, i - .3 * a, o, i - .25 * a, o), new s.PathPrimitiveClosePathCommand()], t.style)];
            }, e.prototype.getTextRectangle = function (t) {
              return t.rectangle.clone().inflate(-r.ShapeTextPadding, -r.ShapeTextPadding);
            }, e.prototype.getSizeByText = function (t, e) {
              return e.size.clone().offset(2 * r.ShapeTextPadding, 2 * r.ShapeTextPadding);
            }, e;
          }(r.ShapeDescription);
        e.HeartShapeDescription = p;
      },
      7763: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.DiamondShapeDescription = void 0;
        var r = n(1280),
          s = n(6208),
          a = n(3255),
          c = function (t) {
            function e(e, n) {
              return void 0 === e && (e = r.ShapeDefaultSize.clone()), t.call(this, e, n) || this;
            }
            return i(e, t), Object.defineProperty(e.prototype, "key", {
              get: function () {
                return a.ShapeTypes.Diamond;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "keepRatioOnAutoSize", {
              get: function () {
                return !1;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.createShapePrimitives = function (t) {
              var e = t.rectangle,
                n = e.x,
                o = e.y,
                i = e.right,
                r = e.bottom,
                a = e.center,
                c = a.x,
                u = a.y;
              return [new s.PathPrimitive([new s.PathPrimitiveMoveToCommand(c, o), new s.PathPrimitiveLineToCommand(i, u), new s.PathPrimitiveLineToCommand(c, r), new s.PathPrimitiveLineToCommand(n, u), new s.PathPrimitiveClosePathCommand()], t.style)];
            }, e.prototype.getTextRectangle = function (t) {
              return t.rectangle.clone().inflate(-t.size.width / 4, -t.size.height / 4);
            }, e.prototype.getSizeByText = function (t, e) {
              return t.clone().multiply(2, 2);
            }, e;
          }(r.ShapeDescription);
        e.DiamondShapeDescription = c;
      },
      7768: (t, e) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.isColorProperty = void 0;
        var n = {
          stroke: !0,
          fill: !0
        };
        e.isColorProperty = function (t) {
          return n[t];
        };
      },
      7804: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.RoutingGrid = void 0;
        var o = n(124),
          i = function () {
            function t(t, e, n) {
              this.verticalGridLines = t, this.horizontalGridLines = e, this.createPoint = n;
            }
            return t.create = function (e, n, o) {
              var i = this,
                r = [],
                s = [],
                a = {},
                c = {};
              return n.forEach(function (t) {
                i.addLine(t.x, r, a), i.addLine(t.right, r, a), i.addLine(t.y, s, c), i.addLine(t.bottom, s, c);
              }), e.forEach(function (t) {
                i.addLine(t.x, r, a), i.addLine(t.y, s, c);
              }), r.sort(function (t, e) {
                return t - e;
              }), s.sort(function (t, e) {
                return t - e;
              }), new t(r, s, o);
            }, t.addLine = function (t, e, n) {
              n[t] || (e.push(t), n[t] = !0);
            }, t.prototype.getNeighborPoints = function (t) {
              var e = [];
              if (!(this.horizontalGridLines && this.horizontalGridLines.length && this.verticalGridLines && this.verticalGridLines.length)) return e;
              var n = o.SearchUtils.binaryIndexOf(this.verticalGridLines, function (e) {
                return e - t.x;
              });
              n < 0 ? (n = ~n, this.isValidArrayIndex(this.verticalGridLines, n) && e.push(this.createPoint(this.verticalGridLines[n], t.y))) : this.isValidArrayIndex(this.verticalGridLines, n + 1) && e.push(this.createPoint(this.verticalGridLines[n + 1], t.y)), this.isValidArrayIndex(this.verticalGridLines, n - 1) && e.push(this.createPoint(this.verticalGridLines[n - 1], t.y));
              var i = o.SearchUtils.binaryIndexOf(this.horizontalGridLines, function (e) {
                return e - t.y;
              });
              return i < 0 ? (i = ~i, this.isValidArrayIndex(this.horizontalGridLines, i) && e.push(this.createPoint(t.x, this.horizontalGridLines[i]))) : this.isValidArrayIndex(this.horizontalGridLines, i + 1) && e.push(this.createPoint(t.x, this.horizontalGridLines[i + 1])), this.isValidArrayIndex(this.horizontalGridLines, i - 1) && e.push(this.createPoint(t.x, this.horizontalGridLines[i - 1])), e;
            }, t.prototype.isValidArrayIndex = function (t, e) {
              return t && e >= 0 && e < t.length;
            }, t;
          }();
        e.RoutingGrid = i;
      },
      7837: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CardWithImageOnTopDescription = void 0;
        var r = n(1280),
          s = n(3844),
          a = n(3255),
          c = n(5311),
          u = n(9500),
          p = function (t) {
            function e() {
              var e = t.call(this, new s.Size(.8 * r.ShapeDefaultDimension, r.ShapeDefaultDimension)) || this;
              return e.isTextAfterImage = !0, e.isHorizontal = !1, e;
            }
            return i(e, t), Object.defineProperty(e.prototype, "key", {
              get: function () {
                return a.ShapeTypes.CardWithImageOnTop;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.getImageSize = function (t, e, n) {
              var o = t.width / 2;
              u.UnitConverter.twipsToPixels(o) % 2 == 1 && (o -= u.UnitConverter.pixelsToTwips(1));
              var i = Math.max(0, t.height - (e ? 0 : 2 * this.getImageMargin(n)));
              return i = Math.min(o, i), new s.Size(i, i);
            }, e.prototype.getImageSizeByTextBlockSize = function (t) {
              return this.getImageSize(new s.Size(t.width, Number.MAX_VALUE), !0);
            }, e;
          }(c.CardBaseDescription);
        e.CardWithImageOnTopDescription = p;
      },
      7841: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ImageLoader = void 0;
        var o = n(4062),
          i = function () {
            function t(t) {
              this.loadedCallback = t;
            }
            return t.prototype.load = function (t) {
              t.isLoaded ? this.loadedCallback(t) : t.isLoading || this.loadInner(t);
            }, t.prototype.loadInner = function (t) {
              var e = this;
              return t.imageUrl ? this.loadPictureByUrl(t, function () {
                return e.finalizeLoading(t, t);
              }) : t.base64 && this.loadPictureByBase64(t, function () {
                return e.finalizeLoading(t, t);
              }), t;
            }, t.prototype.finalizeLoading = function (t, e) {
              e || (e = o.ImageCache.instance.getImageData(t.actualId)), e.isLoaded || o.ImageCache.instance.finalizeLoading(e, t), this.loadedCallback(e);
            }, t.prototype.loadPictureByBase64 = function (t, e) {
              var n = new Image();
              n.onload = function () {
                e(t);
              }, n.src = t.base64;
            }, t.prototype.loadPictureByUrl = function (t, e) {
              var n = this,
                o = new XMLHttpRequest();
              try {
                o.onload = function () {
                  var i = new FileReader();
                  i.onloadend = function () {
                    t.base64 = i.result, n.loadPictureByBase64(t, function (t) {
                      return e(t);
                    });
                  }, i.readAsDataURL(o.response);
                }, o.onerror = function () {
                  return e(t);
                }, o.onloadend = function () {
                  404 === o.status && e(t);
                }, o.open("GET", t.imageUrl, !0), o.responseType = "blob", t.startLoading(), o.send();
              } catch (t) {}
            }, t;
          }();
        e.ImageLoader = i;
      },
      7857: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Importer = void 0;
        var r = n(8408),
          s = n(41),
          a = n(3844),
          c = n(5327),
          u = n(281),
          p = n(6320),
          h = n(9406),
          l = n(5596),
          d = n(9933),
          f = n(9553),
          y = n(5359),
          g = function (t) {
            function e(e, n) {
              var o = t.call(this, e) || this;
              return o.obj = d.ImportUtils.parseJSON(n), o;
            }
            return i(e, t), e.prototype.getObject = function () {
              return this.obj;
            }, e.prototype.getPageObject = function (t) {
              return t.page;
            }, e.prototype.getShapeObjects = function (t) {
              return t.shapes;
            }, e.prototype.getConnectorObjects = function (t) {
              return t.connectors;
            }, e.prototype.importPageSettings = function (t, e) {
              e && (this.assert(e.width, "number"), this.assert(e.height, "number"), "number" == typeof e.width && (t.size.width = e.width), "number" == typeof e.height && (t.size.height = e.height), "number" == typeof e.pageColor ? t.pageColor = e.pageColor : "string" == typeof e.pageColor && (t.pageColor = f.ColorUtils.fromString(e.pageColor)), "number" == typeof e.pageWidth && (t.pageSize.width = e.pageWidth), "number" == typeof e.pageHeight && (t.pageSize.height = e.pageHeight), "boolean" == typeof e.pageLandscape && (t.pageLandscape = e.pageLandscape));
            }, e.prototype.importShape = function (t) {
              this.assert(t.key, "string"), this.assert(t.x, "number"), this.assert(t.y, "number"), this.assert(t.type, "string");
              var e = t.type,
                n = this.shapeDescriptionManager.get(e),
                o = new c.Point(t.x, t.y),
                i = new r.Shape(n || u.ShapeDescriptionManager.default, o);
              return i.key = t.key, "string" != typeof t.dataKey && "number" != typeof t.dataKey || (i.dataKey = t.dataKey), "object" == typeof t.customData && (i.customData = s.ObjectUtils.cloneObject(t.customData)), "boolean" == typeof t.locked && (i.locked = t.locked), "number" == typeof t.width && (i.size.width = t.width), "number" == typeof t.height && (i.size.height = t.height), "string" == typeof t.text && (i.text = t.text), "string" == typeof t.imageUrl && (i.image = new h.ImageInfo(t.imageUrl)), t.parameters && (i.parameters.fromObject(t.parameters), i.description.normalizeParameters(i, i.parameters)), t.style && i.style.fromObject(t.style), t.styleText && i.styleText.fromObject(t.styleText), "number" == typeof t.zIndex && (i.zIndex = t.zIndex), Array.isArray(t.childKeys) && (i.childKeys = t.childKeys.slice()), "boolean" == typeof t.expanded && (i.expanded = t.expanded), "number" == typeof t.expandedWidth && "number" == typeof t.expandedHeight && (i.expandedSize = new a.Size(t.expandedWidth, t.expandedHeight)), i;
            }, e.prototype.importShapeChildren = function (t, e) {
              return [];
            }, e.prototype.importConnector = function (t) {
              var e = this;
              if (this.assert(t.key, "string"), !Array.isArray(t.points)) throw Error("Invalid Format");
              var n = t.points.map(function (t) {
                  return e.assert(t.x, "number"), e.assert(t.y, "number"), new c.Point(t.x, t.y);
                }),
                o = new p.Connector(n);
              return o.key = t.key, "string" != typeof t.dataKey && "number" != typeof t.dataKey || (o.dataKey = t.dataKey), "object" == typeof t.customData && (o.customData = s.ObjectUtils.cloneObject(t.customData)), "boolean" == typeof t.locked && (o.locked = t.locked), o.endConnectionPointIndex = "number" == typeof t.endConnectionPointIndex ? t.endConnectionPointIndex : -1, o.beginConnectionPointIndex = "number" == typeof t.beginConnectionPointIndex ? t.beginConnectionPointIndex : -1, void 0 !== t.endItemKey && this.assert(t.endItemKey, "string"), void 0 !== t.beginItemKey && this.assert(t.beginItemKey, "string"), o.endItemKey = t.endItemKey, o.beginItemKey = t.beginItemKey, t.texts && o.texts.fromObject(t.texts), t.properties && o.properties.fromObject(t.properties), t.style && o.style.fromObject(t.style), t.styleText && o.styleText.fromObject(t.styleText), "number" == typeof t.zIndex && (o.zIndex = t.zIndex), void 0 !== t.context && o.replaceRenderPoints(y.ConnectorRenderPointsContext.fromObject(t.context), !1), o;
            }, e;
          }(l.ImporterBase);
        e.Importer = g;
      },
      7873: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ConnectionTargetVisualizer = e.ConnectionTargetInfo = void 0;
        var r = n(2016),
          s = function (t, e) {
            this.rect = t, this.strokeWidth = e, this.allowed = !0;
          };
        e.ConnectionTargetInfo = s;
        var a = function (t) {
          function e(e) {
            return t.call(this, e) || this;
          }
          return i(e, t), e.prototype.raiseShow = function () {
            var t = this,
              e = new s(this.targetRect, this.targetStrokeWidth);
            this.dispatcher.raise1(function (n) {
              return n.notifyConnectionTargetShow(t.key, e);
            });
          }, e.prototype.raiseHide = function () {
            this.dispatcher.raise1(function (t) {
              return t.notifyConnectionTargetHide();
            });
          }, e;
        }(r.TargetVisualizerBase);
        e.ConnectionTargetVisualizer = a;
      },
      7892: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.XmlImporter = void 0;
        var r = n(6320),
          s = n(8408),
          a = n(5596),
          c = n(3255),
          u = n(281),
          p = n(3844),
          h = n(5327),
          l = n(9933),
          d = n(9553),
          f = n(9500),
          y = function (t) {
            function e(e, n) {
              var o = t.call(this, e) || this;
              return o.doc = l.ImportUtils.createDocument(n), o;
            }
            return i(e, t), e.prototype.getObject = function () {
              return this.doc;
            }, e.prototype.getPageObject = function (t) {
              var e = this.doc.querySelectorAll("[ItemKind='DiagramRoot']");
              return e && e[0];
            }, e.prototype.getShapeObjects = function (t) {
              var e = [];
              return this.doc.querySelectorAll("[ItemKind='DiagramRoot'] > Children > [ItemKind='DiagramShape']").forEach(function (t) {
                e.push(t);
              }), this.doc.querySelectorAll("[ItemKind='DiagramRoot'] > Children > [ItemKind='DiagramContainer']").forEach(function (t) {
                e.push(t);
              }), e;
            }, e.prototype.getConnectorObjects = function (t) {
              var e = [];
              return this.doc.querySelectorAll("[ItemKind='DiagramRoot'] > Children > [ItemKind='DiagramConnector']").forEach(function (t) {
                e.push(t);
              }), e;
            }, e.prototype.importPageSettings = function (t, e) {
              if (e) {
                var n = e.getAttribute("PageSize"),
                  o = this.getSize(n);
                o && (t.size = o.clone(), t.pageSize = o.clone());
              }
            }, e.prototype.importShape = function (t) {
              var e = t.getAttribute("Position"),
                n = this.getPoint(e),
                o = t.getAttribute("Shape"),
                i = this.getShapeType(o),
                r = this.shapeDescriptionManager.get(i),
                a = new s.Shape(r || u.ShapeDescriptionManager.default, n);
              a.key = this.getItemKey(t);
              var c = t.getAttribute("Size"),
                p = this.getSize(c);
              p && (a.size = p);
              var h = t.getAttribute("Content");
              if ("string" == typeof h) a.text = h;else {
                var l = t.getAttribute("Header");
                "string" == typeof l && (a.text = l);
              }
              return this.importStyle(t, a), a;
            }, e.prototype.importShapeChildren = function (t, e) {
              var n = [];
              t.setAttribute("dxDiagram", ""), this.doc.querySelectorAll("[dxDiagram] > Children > [ItemKind='DiagramShape']").forEach(function (t) {
                n.push(t);
              }), this.doc.querySelectorAll("[dxDiagram] > Children > [ItemKind='DiagramContainer']").forEach(function (t) {
                n.push(t);
              }), t.removeAttribute("dxDiagram");
              var o = [];
              if (!n) return o;
              for (var i = 0; i < n.length; i++) {
                var r = n[i],
                  s = this.importShape(r);
                s.key = e.key + "," + s.key;
                var a = e.clientRectangle;
                s.position = s.position.clone().offset(a.x, a.y), e.childKeys || (e.childKeys = []), e.childKeys.push(s.key), o.push(s), o = o.concat(this.importShapeChildren(r, s));
              }
              return o;
            }, e.prototype.importConnector = function (t) {
              var e = this,
                n = [],
                o = t.getAttribute("BeginPoint"),
                i = this.getPoint(o);
              i && n.push(i), t.getAttribute("Points").split(" ").forEach(function (t) {
                var o = e.getPoint(t);
                o && n.push(o);
              });
              var s = t.getAttribute("EndPoint"),
                a = this.getPoint(s);
              a && n.push(a);
              var c = new r.Connector(n);
              c.key = this.getItemKey(t);
              var u = t.getAttribute("EndItemPointIndex"),
                p = parseInt(u);
              c.endConnectionPointIndex = isNaN(p) ? -1 : p;
              var h = t.getAttribute("BeginItemPointIndex"),
                l = parseInt(h);
              c.beginConnectionPointIndex = isNaN(l) ? -1 : l;
              var d = t.getAttribute("EndItem");
              void 0 !== d && this.assert(d, "string");
              var f = t.getAttribute("BeginItem");
              void 0 !== f && this.assert(f, "string"), c.endItemKey = d, c.beginItemKey = f;
              var y = t.getAttribute("Content");
              return "string" == typeof y && c.setText(y), this.importStyle(t, c), c;
            }, e.prototype.importStyle = function (t, e) {
              var n = t.getAttribute("Background");
              "string" == typeof n && (e.style.fill = this.getColor(n));
              var o = t.getAttribute("Stroke");
              "string" == typeof o && (e.style.stroke = this.getColor(o));
              var i = t.getAttribute("Foreground");
              "string" == typeof i && (e.styleText.fill = this.getColor(i));
              var r = t.getAttribute("FontFamily");
              "string" == typeof r && (e.styleText["font-family"] = r);
              var s = t.getAttribute("FontSize");
              "string" == typeof s && (e.styleText["font-size"] = s), "Bold" === t.getAttribute("FontWeight") && (e.styleText["font-weight"] = "bold"), "Italic" === t.getAttribute("FontStyle") && (e.styleText["font-style"] = "italic"), "Underline" === t.getAttribute("TextDecorations") && (e.styleText["text-decoration"] = "underline");
              var a = t.getAttribute("TextAlignment");
              "Left" === a ? e.styleText["text-anchor"] = "start" : "Right" === a ? e.styleText["text-anchor"] = "end" : "Center" === a && (e.styleText["text-anchor"] = "middle");
            }, e.prototype.getShapeType = function (t) {
              return e.shapeTypes[t] ? e.shapeTypes[t] : t && t.toLowerCase().indexOf("container") > -1 ? c.ShapeTypes.VerticalContainer : c.ShapeTypes.Rectangle;
            }, e.prototype.getItemKey = function (t) {
              return (parseInt(t.tagName.replace("Item", "")) - 1).toString();
            }, e.prototype.getNumbers = function (t) {
              var e = t.split(",");
              return e && e.length ? e.map(function (t) {
                return +t;
              }) : [];
            }, e.prototype.getSize = function (t) {
              if (t) {
                var e = this.getNumbers(t);
                if (e.length >= 2) return this.assert(e[0], "number"), this.assert(e[1], "number"), new p.Size(f.UnitConverter.pixelsToTwips(e[0]), f.UnitConverter.pixelsToTwips(e[1]));
              }
            }, e.prototype.getPoint = function (t) {
              if (t) {
                var e = this.getNumbers(t);
                if (e.length >= 2) return this.assert(e[0], "number"), this.assert(e[1], "number"), new h.Point(f.UnitConverter.pixelsToTwips(e[0]), f.UnitConverter.pixelsToTwips(e[1]));
              }
            }, e.prototype.getColor = function (t) {
              t = "#" === t.charAt(0) ? t.substr(1) : t;
              var e = parseInt(t, 16);
              return isNaN(e) ? void 0 : d.ColorUtils.colorToHash(e);
            }, e.shapeTypes = {
              "BasicShapes.Rectangle": c.ShapeTypes.Rectangle,
              "BasicShapes.Ellipse": c.ShapeTypes.Ellipse,
              "BasicShapes.Triangle": c.ShapeTypes.Triangle,
              "BasicShapes.Pentagon": c.ShapeTypes.Pentagon,
              "BasicShapes.Hexagon": c.ShapeTypes.Hexagon,
              "BasicShapes.Octagon": c.ShapeTypes.Octagon,
              "BasicShapes.Diamond": c.ShapeTypes.Diamond,
              "BasicShapes.Cross": c.ShapeTypes.Cross,
              "BasicShapes.Star5": c.ShapeTypes.Star,
              "BasicFlowchartShapes.StartEnd": c.ShapeTypes.Terminator,
              "BasicFlowchartShapes.Data": c.ShapeTypes.Data,
              "BasicFlowchartShapes.Database": c.ShapeTypes.Database,
              "BasicFlowchartShapes.ExternalData": c.ShapeTypes.StoredData,
              "BasicFlowchartShapes.Process": c.ShapeTypes.Process,
              "BasicFlowchartShapes.Decision": c.ShapeTypes.Decision,
              "BasicFlowchartShapes.Subprocess": c.ShapeTypes.PredefinedProcess,
              "BasicFlowchartShapes.Document": c.ShapeTypes.Document,
              "BasicFlowchartShapes.Custom1": c.ShapeTypes.ManualInput,
              "BasicFlowchartShapes.Custom2": c.ShapeTypes.ManualOperation,
              "ArrowShapes.SimpleArrow": c.ShapeTypes.ArrowLeft,
              "ArrowShapes.SimpleDoubleArrow": c.ShapeTypes.ArrowLeftRight
            }, e;
          }(a.ImporterBase);
        e.XmlImporter = y;
      },
      7942: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ContextToolboxHandler = void 0;
        var o = n(5428),
          i = n(41),
          r = n(6537),
          s = n(8424),
          a = function () {
            function t() {
              this.contextToolboxVisible = !1, this.onVisibilityChanged = new i.EventDispatcher();
            }
            return t.prototype.onMouseDown = function (t) {
              t.source.type !== o.MouseEventElementType.Undefined && this.hideContextToolbox();
            }, t.prototype.onMouseUp = function (t) {
              t.source.type === o.MouseEventElementType.Undefined && s.Browser.TouchUI || this.hideContextToolbox();
            }, t.prototype.onFocus = function (t) {}, t.prototype.onBlur = function (t) {}, t.prototype.onKeyDown = function (t) {
              t.keyCode === r.KeyCode.Esc && this.hideContextToolbox();
            }, t.prototype.onShortcut = function (t) {
              this.hideContextToolbox();
            }, t.prototype.showContextToolbox = function (t, e, n, o, i, r) {
              this.onVisibilityChanged.raise1(function (r) {
                return r.notifyShowContextToolbox(t, e, n, o, i);
              }), this.contextToolboxVisible = !0, this.contextToolboxCancelCallback = r;
            }, t.prototype.hideContextToolbox = function (t) {
              this.contextToolboxVisible && (this.onVisibilityChanged.raise1(function (t) {
                return t.notifyHideContextToolbox();
              }), this.contextToolboxCancelCallback && (t || this.contextToolboxCancelCallback(), this.contextToolboxCancelCallback = void 0), this.contextToolboxVisible = !1);
            }, t;
          }();
        e.ContextToolboxHandler = a;
      },
      8005: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.StarShapeDescription = e.StarConvexParameterName = void 0;
        var r = n(6208),
          s = n(3255),
          a = n(3165),
          c = n(4636),
          u = n(9763),
          p = n(5327),
          h = n(4824);
        e.StarConvexParameterName = "sc";
        var l = function (t) {
          function n() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(n, t), Object.defineProperty(n.prototype, "key", {
            get: function () {
              return s.ShapeTypes.Star;
            },
            enumerable: !1,
            configurable: !0
          }), n.prototype.createShapePrimitives = function (t) {
            var n = t.rectangle,
              o = n.x,
              i = n.y,
              s = n.right,
              a = n.width,
              c = n.height,
              u = this.getActualBottom(i, n.bottom, a, c),
              p = n.center.x,
              h = i + (u - i) / 2,
              l = c / a,
              d = Math.PI - this.angle,
              f = a / 2 * Math.tan(d / 2) * l,
              y = i + f,
              g = (c - f) / Math.tan(d) / l,
              m = o + g,
              v = s - g,
              P = t.parameters.get(e.StarConvexParameterName).value,
              C = this.getInnerPointDistance(p, p, s, h, i, y);
            return [new r.PathPrimitive([new r.PathPrimitiveMoveToCommand(p, i), new r.PathPrimitiveLineToCommand(this.getInnerPointPos(p, p, s, P, C), this.getInnerPointPos(h, i, y, P, C)), new r.PathPrimitiveLineToCommand(s, y), new r.PathPrimitiveLineToCommand(this.getInnerPointPos(p, s, v, P, C), this.getInnerPointPos(h, y, u, P, C)), new r.PathPrimitiveLineToCommand(v, u), new r.PathPrimitiveLineToCommand(this.getInnerPointPos(p, v, m, P, C), this.getInnerPointPos(h, u, u, P, C)), new r.PathPrimitiveLineToCommand(m, u), new r.PathPrimitiveLineToCommand(this.getInnerPointPos(p, m, o, P, C), this.getInnerPointPos(h, u, y, P, C)), new r.PathPrimitiveLineToCommand(o, y), new r.PathPrimitiveLineToCommand(this.getInnerPointPos(p, o, p, P, C), this.getInnerPointPos(h, y, i, P, C)), new r.PathPrimitiveClosePathCommand()], t.style)];
          }, n.prototype.createParameters = function (t) {
            t.addRangeIfNotExists([new c.ShapeParameter(e.StarConvexParameterName, 300)]);
          }, n.prototype.normalizeParameters = function (t, n) {
            var o = t.rectangle,
              i = o.y,
              r = o.right,
              s = o.width,
              a = o.height,
              c = this.getActualBottom(i, o.bottom, s, a),
              u = o.center.x,
              p = i + (c - i) / 2,
              h = a / s,
              l = Math.PI - this.angle,
              d = i + s / 2 * Math.tan(l / 2) * h,
              f = this.getInnerPointDistance(u, u, r, p, i, d);
            this.changeParameterValue(n, e.StarConvexParameterName, function (t) {
              return Math.max(0, Math.min(f, t.value));
            });
          }, n.prototype.modifyParameters = function (t, n, o, i) {
            var r = Math.sqrt(Math.pow(o, 2) + Math.pow(i, 2));
            (o < 0 || i > 0) && (r = -r), this.changeParameterValue(n, e.StarConvexParameterName, function (t) {
              return t.value + r;
            }), this.normalizeParameters(t, n);
          }, n.prototype.getParameterPoints = function (t) {
            var n = t.rectangle,
              o = n.y,
              i = n.right,
              r = n.width,
              s = n.height,
              a = this.getActualBottom(o, n.bottom, r, s),
              c = n.center.x,
              h = o + (a - o) / 2,
              l = s / r,
              d = Math.PI - this.angle,
              f = o + r / 2 * Math.tan(d / 2) * l,
              y = t.parameters.get(e.StarConvexParameterName).value,
              g = this.getInnerPointDistance(c, c, i, h, o, f),
              m = this.getInnerPointPos(c, c, i, y, g),
              v = this.getInnerPointPos(h, o, f, y, g);
            return [new u.ShapeParameterPoint("c", new p.Point(m, v))];
          }, n.prototype.processConnectionPoint = function (n, o) {
            if (t.prototype.processConnectionPoint.call(this, n, o), n.getConnectionPointSide(o) === h.ConnectionPointSide.South) {
              var i = n.rectangle,
                r = i.y,
                s = i.right,
                a = i.width,
                c = i.height,
                u = this.getActualBottom(r, i.bottom, a, c),
                p = i.center.x,
                l = r + (u - r) / 2,
                d = c / a,
                f = Math.PI - this.angle,
                y = r + a / 2 * Math.tan(f / 2) * d,
                g = n.parameters.get(e.StarConvexParameterName).value,
                m = this.getInnerPointDistance(p, p, s, l, r, y);
              o.y = this.getInnerPointPos(l, u, u, g, m);
            }
          }, n.prototype.getInnerPointDistanceByAxis = function (t, e, n) {
            return Math.min(e, n) + Math.abs(e - n) / 2 - t;
          }, n.prototype.getInnerPointPos = function (t, e, n, o, i) {
            var r = Math.min(1, o / i);
            return t + this.getInnerPointDistanceByAxis(t, e, n) * r;
          }, n.prototype.getInnerPointDistance = function (t, e, n, o, i, r) {
            var s = this.getInnerPointDistanceByAxis(t, e, n),
              a = this.getInnerPointDistanceByAxis(o, i, r);
            return Math.sqrt(Math.pow(s, 2) + Math.pow(a, 2));
          }, n.prototype.getActualBottom = function (e, n, o, i) {
            var r = e + t.prototype.calculateHeight.call(this, o) * i / o;
            return r < n ? r : n;
          }, n.prototype.calculateHeight = function (t) {
            return t;
          }, n;
        }(a.PentagonShapeDescription);
        e.StarShapeDescription = l;
      },
      8022: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ImportCommand = void 0;
        var r = n(7857),
          s = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), e.prototype.executeCore = function (t, e) {
              this.permissionsProvider.lockPermissions();
              var n = e.data ? e.data : e,
                o = new r.Importer(this.control.shapeDescriptionManager, n);
              if (!0 === e.keepExistingItems) o.importItemsData(this.control.model), this.control.importItemsData();else {
                var i = o.import();
                this.control.importModel(i);
              }
              return this.permissionsProvider.unlockPermissions(), !0;
            }, e;
          }(n(6089).ExportImportCommandBase);
        e.ImportCommand = s;
      },
      8060: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.LayoutUtils = void 0;
        var o = n(8501),
          i = function () {
            function t() {}
            return t.shapeToLayout = function (t) {
              var e = new o.Margin(0),
                n = t.rectangle;
              t.attachedConnectors.filter(function (t) {
                return !t.beginItem || !t.endItem;
              }).forEach(function (t) {
                var o = t.rectangle;
                e.left = Math.max(e.left, n.x - o.x), e.right = Math.max(e.right, o.right - n.right), e.top = Math.max(e.top, n.y - o.y), e.bottom = Math.max(e.bottom, o.bottom - n.bottom);
              });
              var i = new o.NodeInfo(t.key, e, t.size.clone());
              return i.connectionPoints = t.description.getConnectionPoints(), i;
            }, t;
          }();
        e.LayoutUtils = i;
      },
      8128: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ResizeShapeEventArgs = e.ResizeShapeRequestedEntity = void 0;
        var r = n(5225),
          s = n(5102),
          a = function (t) {
            function e(e, n, o, i) {
              var r = t.call(this, e) || this;
              return r.shape = n, r.oldSize = o, r.size = i, r;
            }
            return i(e, t), Object.defineProperty(e.prototype, "operation", {
              get: function () {
                return r.DiagramModelOperation.ResizeShape;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.createEventArgs = function () {
              return new c(this.apiController.createNativeShape(this.shape), this.apiController.convertSize(this.oldSize), this.apiController.convertSize(this.size));
            }, Object.defineProperty(e.prototype, "settingsKey", {
              get: function () {
                return "resizeShape";
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "storageKey", {
              get: function () {
                return this.settingsKey + "_" + (this.shape && this.shape.key);
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.equals = function (t) {
              return t instanceof e && this.shape === t.shape && this.oldSize.equals(t.oldSize) && this.size.equals(t.size);
            }, e;
          }(s.RequestedEntity);
        e.ResizeShapeRequestedEntity = a;
        var c = function (t) {
          function e(e, n, o) {
            var i = t.call(this) || this;
            return i.shape = e, i.oldSize = n, i.size = o, i;
          }
          return i(e, t), e;
        }(s.PermissionRequestEventArgs);
        e.ResizeShapeEventArgs = c;
      },
      8156: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.DiagramModelOperation = e.Diagnostics = e.RenderHelper = e.DiagramLocalizationService = e.NativeConnector = e.NativeShape = e.ShapeType = e.ColorUtils = e.PageOrientation = e.ConnectorPosition = e.ConnectorLineOption = e.ConnectorLineEnding = e.AutoZoomMode = e.Browser = e.UnitConverter = e.EventDispatcher = e.DataLayoutOrientation = e.DataLayoutType = e.ShapeCategories = e.ShapeTypes = e.DiagramUnit = e.default = e.DiagramControl = e.DiagramCommand = e.Point = e.Size = void 0;
        var o = n(5031);
        Object.defineProperty(e, "DiagramCommand", {
          enumerable: !0,
          get: function () {
            return o.DiagramCommand;
          }
        });
        var i = n(701);
        Object.defineProperty(e, "DiagramControl", {
          enumerable: !0,
          get: function () {
            return i.DiagramControl;
          }
        }), Object.defineProperty(e, "default", {
          enumerable: !0,
          get: function () {
            return i.DiagramControl;
          }
        });
        var r = n(3844);
        Object.defineProperty(e, "Size", {
          enumerable: !0,
          get: function () {
            return r.Size;
          }
        });
        var s = n(5327);
        Object.defineProperty(e, "Point", {
          enumerable: !0,
          get: function () {
            return s.Point;
          }
        });
        var a = n(41);
        Object.defineProperty(e, "EventDispatcher", {
          enumerable: !0,
          get: function () {
            return a.EventDispatcher;
          }
        });
        var c = n(3255);
        Object.defineProperty(e, "ShapeTypes", {
          enumerable: !0,
          get: function () {
            return c.ShapeTypes;
          }
        }), Object.defineProperty(e, "ShapeCategories", {
          enumerable: !0,
          get: function () {
            return c.ShapeCategories;
          }
        }), Object.defineProperty(e, "ShapeType", {
          enumerable: !0,
          get: function () {
            return c.ShapeType;
          }
        });
        var u = n(9500);
        Object.defineProperty(e, "UnitConverter", {
          enumerable: !0,
          get: function () {
            return u.UnitConverter;
          }
        });
        var p = n(8424);
        Object.defineProperty(e, "Browser", {
          enumerable: !0,
          get: function () {
            return p.Browser;
          }
        });
        var h = n(9307);
        Object.defineProperty(e, "AutoZoomMode", {
          enumerable: !0,
          get: function () {
            return h.AutoZoomMode;
          }
        });
        var l = n(2175);
        Object.defineProperty(e, "DataLayoutType", {
          enumerable: !0,
          get: function () {
            return l.DataLayoutType;
          }
        });
        var d = n(9212);
        Object.defineProperty(e, "DataLayoutOrientation", {
          enumerable: !0,
          get: function () {
            return d.DataLayoutOrientation;
          }
        }), n(540);
        var f = n(4385);
        Object.defineProperty(e, "ConnectorLineEnding", {
          enumerable: !0,
          get: function () {
            return f.ConnectorLineEnding;
          }
        }), Object.defineProperty(e, "ConnectorLineOption", {
          enumerable: !0,
          get: function () {
            return f.ConnectorLineOption;
          }
        });
        var y = n(9553);
        Object.defineProperty(e, "ColorUtils", {
          enumerable: !0,
          get: function () {
            return y.ColorUtils;
          }
        });
        var g = n(9196);
        Object.defineProperty(e, "Diagnostics", {
          enumerable: !0,
          get: function () {
            return g.Diagnostics;
          }
        });
        var m = n(4235);
        Object.defineProperty(e, "NativeShape", {
          enumerable: !0,
          get: function () {
            return m.NativeShape;
          }
        }), Object.defineProperty(e, "NativeConnector", {
          enumerable: !0,
          get: function () {
            return m.NativeConnector;
          }
        });
        var v = n(820);
        Object.defineProperty(e, "DiagramLocalizationService", {
          enumerable: !0,
          get: function () {
            return v.DiagramLocalizationService;
          }
        });
        var P = n(8509);
        Object.defineProperty(e, "RenderHelper", {
          enumerable: !0,
          get: function () {
            return P.RenderHelper;
          }
        });
        var C = n(9254);
        Object.defineProperty(e, "DiagramUnit", {
          enumerable: !0,
          get: function () {
            return C.DiagramUnit;
          }
        }), Object.defineProperty(e, "PageOrientation", {
          enumerable: !0,
          get: function () {
            return C.PageOrientation;
          }
        });
        var S = n(5225);
        Object.defineProperty(e, "DiagramModelOperation", {
          enumerable: !0,
          get: function () {
            return S.DiagramModelOperation;
          }
        });
        var x = n(6320);
        Object.defineProperty(e, "ConnectorPosition", {
          enumerable: !0,
          get: function () {
            return x.ConnectorPosition;
          }
        });
      },
      8162: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ChangeStrokeColorCommand = void 0;
        var r = n(5963),
          s = n(9553),
          a = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), e.prototype.processParameter = function (t) {
              return s.ColorUtils.stringToHash(t);
            }, e.prototype.getStyleProperty = function () {
              return "stroke";
            }, e;
          }(r.ChangeStylePropertyCommand);
        e.ChangeStrokeColorCommand = a;
      },
      8192: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ToggleReadOnlyCommand = void 0;
        var r = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(e, t), e.prototype.isEnabledInReadOnlyMode = function () {
            return !0;
          }, e.prototype.getValue = function () {
            return this.control.settings.readOnly;
          }, e.prototype.executeCore = function (t, e) {
            return "boolean" == typeof e ? this.control.settings.readOnly = e : void 0 === e && (this.control.settings.readOnly = !t.value), !0;
          }, e;
        }(n(3913).SimpleCommandBase);
        e.ToggleReadOnlyCommand = r;
      },
      8214: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AddShapeHistoryItem = void 0;
        var r = n(2616),
          s = n(8408),
          a = function (t) {
            function e(e, n, o, i) {
              var r = t.call(this) || this;
              return r.shapeDescription = e, r.position = n, r.text = o, r.dataKey = i, r;
            }
            return i(e, t), e.prototype.redo = function (t) {
              var e = new s.Shape(this.shapeDescription, this.position);
              "string" == typeof this.text && (e.text = this.text), void 0 !== this.dataKey && (e.dataKey = this.dataKey), t.addShape(e, this.shapeKey), this.shapeKey = e.key;
            }, e.prototype.undo = function (t) {
              t.deleteShape(t.model.findShape(this.shapeKey), !0);
            }, e;
          }(r.HistoryItem);
        e.AddShapeHistoryItem = a;
      },
      8226: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AddConnectorPointHistoryItem = void 0;
        var r = function (t) {
          function e(e, n, o) {
            var i = t.call(this) || this;
            return i.connectorKey = e, i.pointIndex = n, i.point = o, i;
          }
          return i(e, t), e.prototype.redo = function (t) {
            var e = this,
              n = t.model.findConnector(this.connectorKey);
            this.renderContext = n.tryCreateRenderPointsContext(), t.addDeleteConnectorPoint(n, function (t) {
              t.addPoint(e.pointIndex, e.point), t.onAddPoint(e.pointIndex, e.point);
            });
          }, e.prototype.undo = function (t) {
            var e = this,
              n = t.model.findConnector(this.connectorKey);
            t.addDeleteConnectorPoint(n, function (t) {
              t.deletePoint(e.pointIndex), t.replaceRenderPoints(e.renderContext);
            });
          }, e;
        }(n(2616).HistoryItem);
        e.AddConnectorPointHistoryItem = r;
      },
      8236: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          }),
          r = this && this.__awaiter || function (t, e, n, o) {
            return new (n || (n = Promise))(function (i, r) {
              function s(t) {
                try {
                  c(o.next(t));
                } catch (t) {
                  r(t);
                }
              }
              function a(t) {
                try {
                  c(o.throw(t));
                } catch (t) {
                  r(t);
                }
              }
              function c(t) {
                var e;
                t.done ? i(t.value) : (e = t.value, e instanceof n ? e : new n(function (t) {
                  t(e);
                })).then(s, a);
              }
              c((o = o.apply(t, e || [])).next());
            });
          },
          s = this && this.__generator || function (t, e) {
            var n,
              o,
              i,
              r,
              s = {
                label: 0,
                sent: function () {
                  if (1 & i[0]) throw i[1];
                  return i[1];
                },
                trys: [],
                ops: []
              };
            return r = {
              next: a(0),
              throw: a(1),
              return: a(2)
            }, "function" == typeof Symbol && (r[Symbol.iterator] = function () {
              return this;
            }), r;
            function a(a) {
              return function (c) {
                return function (a) {
                  if (n) throw new TypeError("Generator is already executing.");
                  for (; r && (r = 0, a[0] && (s = 0)), s;) try {
                    if (n = 1, o && (i = 2 & a[0] ? o.return : a[0] ? o.throw || ((i = o.return) && i.call(o), 0) : o.next) && !(i = i.call(o, a[1])).done) return i;
                    switch (o = 0, i && (a = [2 & a[0], i.value]), a[0]) {
                      case 0:
                      case 1:
                        i = a;
                        break;
                      case 4:
                        return s.label++, {
                          value: a[1],
                          done: !1
                        };
                      case 5:
                        s.label++, o = a[1], a = [0];
                        continue;
                      case 7:
                        a = s.ops.pop(), s.trys.pop();
                        continue;
                      default:
                        if (!(i = s.trys, (i = i.length > 0 && i[i.length - 1]) || 6 !== a[0] && 2 !== a[0])) {
                          s = 0;
                          continue;
                        }
                        if (3 === a[0] && (!i || a[1] > i[0] && a[1] < i[3])) {
                          s.label = a[1];
                          break;
                        }
                        if (6 === a[0] && s.label < i[1]) {
                          s.label = i[1], i = a;
                          break;
                        }
                        if (i && s.label < i[2]) {
                          s.label = i[2], s.ops.push(a);
                          break;
                        }
                        i[2] && s.ops.pop(), s.trys.pop();
                        continue;
                    }
                    a = e.call(t, s);
                  } catch (t) {
                    a = [6, t], o = 0;
                  } finally {
                    n = i = 0;
                  }
                  if (5 & a[0]) throw a[1];
                  return {
                    value: a[0] ? a[1] : void 0,
                    done: !0
                  };
                }([a, c]);
              };
            }
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CanvasExportManager = void 0;
        var a = n(9500),
          c = n(8424),
          u = n(2136),
          p = n(5707),
          h = n(8509),
          l = n(6873),
          d = n(9553),
          f = function (t) {
            function e(e, n, o) {
              var i = t.call(this, 1, new l.ExportDOMManipulator(n), o) || this;
              return i.itemsContainer = e, i;
            }
            return i(e, t), e.prototype.getSvgImage = function (t, e, n, o) {
              var i = h.RenderHelper.createSvgElement(void 0, !0),
                r = t.clone().applyConverter(a.UnitConverter.twipsToPixelsF).clone().applyConverter(Math.ceil);
              u.RenderUtils.updateSvgElementSize(i, r.width, r.height, !0), i.style.backgroundColor = d.ColorUtils.colorToHash(e), this.createTextFloodFilter(this.instanceId, void 0, i, e);
              var s = !n && !c.Browser.IE && this.getExportCssRules();
              if (s) {
                var p = document.createElementNS(h.svgNS, "style");
                p.innerHTML = s, i.appendChild(p);
              }
              if (o) {
                var l = document.createElementNS(h.svgNS, "rect");
                l.setAttributeNS(null, "x", "0"), l.setAttributeNS(null, "y", "0"), l.setAttributeNS(null, "height", r.height.toString()), l.setAttributeNS(null, "width", r.width.toString()), l.setAttributeNS(null, "fill", i.style.backgroundColor), i.appendChild(l);
              }
              for (var f = 0; f < this.itemsContainer.childNodes.length; f++) {
                var y = this.itemsContainer.childNodes[f].cloneNode(!0);
                s || this.inlineStyle(y, this.itemsContainer.childNodes[f]), i.appendChild(y);
              }
              return i;
            }, e.prototype.getSvgImageUrl = function (t, e, n) {
              var o = this.getSvgImage(t, e, n, !1);
              return this.getSvgBase64String(o);
            }, e.prototype.getSvgString = function (t) {
              return new XMLSerializer().serializeToString(t);
            }, e.prototype.getSvgBase64String = function (t) {
              var n = this.getSvgString(t);
              return e.base64Start + this.getBase64EncodeUnicode(n);
            }, e.prototype.getBase64EncodeUnicode = function (t) {
              return btoa(encodeURIComponent(t).replace(/%([0-9A-F]{2})/g, function (t, e) {
                return String.fromCharCode(parseInt("0x" + e, 16));
              }));
            }, e.prototype.getExportCssRules = function () {
              for (var t = 0; t < document.styleSheets.length; t++) {
                var e = this.getRules(document.styleSheets[t]);
                if (e) {
                  for (var n = "", o = 0; o < e.length; o++) {
                    var i = e[o],
                      r = this.isCSSStyleRule(i) ? i.selectorText : null;
                    r && this.checkSelector(r) && (n += i.cssText + "\n");
                  }
                  if (n.length > 0) return "\n" + n;
                }
              }
            }, e.prototype.checkSelector = function (t) {
              for (var n = 0; n < e.exportStyleRules.length; n++) if (0 === t.indexOf(e.exportStyleRules[n])) return !0;
              return !1;
            }, e.prototype.getRules = function (t) {
              try {
                return this.isCSSStyleSheet(t) ? t.rules || t.cssRules : null;
              } catch (t) {}
            }, e.prototype.isCSSStyleSheet = function (t) {
              return void 0 !== t.rules;
            }, e.prototype.isCSSStyleRule = function (t) {
              return void 0 !== t.selectorText;
            }, e.prototype.inlineStyle = function (t, n) {
              for (var o = 0; o < t.childNodes.length; o++) {
                var i = t.childNodes[o];
                if (i.tagName) if ("g" === i.tagName) this.inlineStyle(i, n.childNodes[o]);else if (i.style) {
                  var r = window.getComputedStyle(n.childNodes[o]);
                  if (void 0 !== r) for (var s = 0; s < e.exportStyleAttributes.length; s++) {
                    var a = e.exportStyleAttributes[s];
                    i.style.setProperty(a, r.getPropertyValue(a));
                  }
                  this.inlineStyle(i, n.childNodes[o]);
                }
              }
            }, e.prototype.exportSvgImage = function (t, e, n) {
              n(this.getSvgImageUrl(t, e, !0));
            }, e.prototype.exportBinaryImage = function (t, e, n, o, i) {
              var r = this.getAbsoluteSize(t).clone().applyConverter(Math.ceil),
                s = document.createElement("canvas");
              s.width = r.width, s.height = r.height;
              var a = s.getContext("2d");
              if (a.fillStyle = d.ColorUtils.colorToHash(e), a.fillRect(0, 0, r.width, r.height), (i || c.Browser.IE) && "object" == typeof canvg) this.exportBinaryImageCanvgAsync(t, e, s, a, n).then(function (t) {
                return o(t);
              });else if (c.Browser.IE && "function" == typeof canvg) this.exportBinaryImageCanvgOld(t, e, s, a, n, o);else {
                var u = new Image();
                u.width = r.width, u.height = r.height, u.setAttribute("crossOrigin", "anonymous"), u.onload = function () {
                  a.drawImage(u, 0, 0), o(s.toDataURL(n, 1));
                }, u.src = this.getSvgImageUrl(t, e, !0);
              }
            }, e.prototype.exportBinaryImageCanvgOld = function (t, e, n, o, i, r) {
              var s = this.getSvgImage(t, e, !0, !1),
                a = this.getSvgString(s);
              o.drawSvg(a, 0, 0, null, null, {
                renderCallback: function () {
                  r(n.toDataURL(i, 1));
                }
              });
            }, e.prototype.exportBinaryImageCanvgAsync = function (t, e, n, o, i) {
              return r(this, void 0, void 0, function () {
                var r, a;
                return s(this, function (s) {
                  switch (s.label) {
                    case 0:
                      return r = this.getSvgImage(t, e, !0, !0), a = this.getSvgString(r), [4, canvg.Canvg.fromString(o, a).render()];
                    case 1:
                      return s.sent(), [2, n.toDataURL(i, 1)];
                  }
                });
              });
            }, e.prototype.exportPngImage = function (t, e, n, o) {
              this.exportBinaryImage(t, e, "image/png", n, o);
            }, e.prototype.exportJpgImage = function (t, e, n, o) {
              this.exportBinaryImage(t, e, "image/jpeg", n, o);
            }, e.prototype.notifyModelChanged = function (t) {}, e.prototype.notifyPageColorChanged = function (t) {}, e.prototype.notifyPageSizeChanged = function (t, e) {}, e.base64Start = "data:image/svg+xml;base64,", e.exportStyleRules = [".dxdi-canvas .shape ", ".dxdi-canvas .connector ", ".dxdi-canvas text", ".dxdi-canvas.export"], e.exportStyleAttributes = ["fill", "stroke", "stroke-width", "stroke-linejoin", "font-family", "font-size", "font-weight", "font-style", "text-decoration", "text-anchor"], e;
          }(p.CanvasManagerBase);
        e.CanvasExportManager = f;
      },
      8278: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.TextShapeDescription = void 0;
        var r = n(1280),
          s = n(3844),
          a = n(3255),
          c = n(5654),
          u = n(94),
          p = n(2136),
          h = function (t) {
            function e() {
              var e = t.call(this, new s.Size(r.ShapeDefaultDimension, .5 * r.ShapeDefaultDimension), !0) || this;
              return e.textClipPathId = p.RenderUtils.generateSvgElementId("clipRect"), e;
            }
            return i(e, t), Object.defineProperty(e.prototype, "key", {
              get: function () {
                return a.ShapeTypes.Text;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "keepRatioOnAutoSize", {
              get: function () {
                return !1;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.createShapePrimitives = function (t, e) {
              if (e) {
                var n = t.rectangle,
                  o = n.x,
                  i = n.y,
                  r = n.width,
                  s = n.height;
                return [new c.ClipPathPrimitive(this.getTextClipPathId(e), [new u.RectanglePrimitive(o, i, r, s)])];
              }
              return [];
            }, e.prototype.getTextClipPathId = function (t) {
              return t ? this.textClipPathId : void 0;
            }, e.prototype.getSizeByTextRectangle = function (t) {
              return t;
            }, e.prototype.getSizeByText = function (t, e) {
              return t.clone();
            }, e.prototype.getTextRectangle = function (t) {
              return t.rectangle;
            }, e;
          }(r.ShapeDescription);
        e.TextShapeDescription = h;
      },
      8309: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SvgPrimitive = void 0;
        var r = n(2136),
          s = function (t) {
            function e(e, n, o, i) {
              var r = t.call(this, e) || this;
              return r.className = n, r.clipPathId = o, r.onApplyProperties = i, r.children = [], r;
            }
            return i(e, t), e.prototype.createElement = function (t) {
              var e = this.createMainElement();
              return this.createChildElements(e), t(e), this.createCustomContent(e), e;
            }, e.prototype.createChildElements = function (t) {
              for (var e = 0; e < this.children.length; e++) this.children[e].createElement(function (e) {
                return t.appendChild(e);
              });
            }, e.prototype.applyElementProperties = function (t, e) {
              this.applyElementStyleProperties(t), this.className && t.setAttribute("class", this.className), "string" == typeof this.clipPathId && (this.clipPathId ? t.setAttribute("clip-path", r.RenderUtils.getUrlPathById(this.clipPathId)) : t.removeAttribute("clip-path")), this.onApplyProperties && this.onApplyProperties(t), this.applyChildrenProperties(t, e);
            }, e.prototype.applyChildrenProperties = function (t, e) {
              for (var n = 0; n < this.children.length; n++) this.children[n].applyElementProperties(t.childNodes[n], e);
            }, e.prototype.applyElementStyleProperties = function (t) {
              this.applyElementStylePropertiesCore(t);
            }, e.prototype.applyElementStylePropertiesCore = function (t, e) {
              void 0 === e && (e = !1), this.style && r.RenderUtils.applyStyleToElement(this.style, t, e);
            }, e.prototype.createCustomContent = function (t) {}, e.prototype.destroyCustomContent = function (t) {}, e.prototype.dispose = function () {
              this.children && this.children.forEach(function (t) {
                return t.dispose();
              });
            }, e;
          }(n(4762).PrimitiveObject);
        e.SvgPrimitive = s;
      },
      8315: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ApiController = void 0;
        var r,
          s = n(815),
          a = n(5428),
          c = n(1922),
          u = n(8156),
          p = function (t) {
            function e(e, n, o) {
              var i = t.call(this) || this;
              return i.events = e, i.model = o, i.selection = n, i;
            }
            return i(e, t), e.prototype.notifySelectionChanged = function (t) {
              this.isUpdateLocked() ? this.registerOccurredEvent(r.SelectionChanged) : this.raiseSelectionChanged();
            }, e.prototype.notifyToolboxDragStart = function () {
              this.events.raise("notifyToolboxItemDragStart");
            }, e.prototype.notifyToolboxDragEnd = function () {
              this.events.raise("notifyToolboxItemDragEnd");
            }, e.prototype.notifyToolboxDraggingMouseMove = function () {}, e.prototype.notifyClick = function (t) {
              var e = this;
              this.tryRaiseUserAction(t, function (t) {
                return e.events.raise("notifyItemClick", t);
              });
            }, e.prototype.notifyDblClick = function (t) {
              var e = this;
              this.tryRaiseUserAction(t, function (t) {
                return e.events.raise("notifyItemDblClick", t);
              });
            }, e.prototype.createNativeItem = function (t) {
              return t && this.cleanupNativeItem(t.toNative(this.model.units));
            }, e.prototype.createNativeShape = function (t) {
              return this.createNativeItem(t);
            }, e.prototype.createNativeConnector = function (t) {
              return this.createNativeItem(t);
            }, e.prototype.convertUnit = function (t) {
              return c.ModelUtils.getlUnitValue(this.model.units, t);
            }, e.prototype.convertPoint = function (t) {
              return new u.Point(this.convertUnit(t.x), this.convertUnit(t.y));
            }, e.prototype.convertSize = function (t) {
              return new u.Size(this.convertUnit(t.width), this.convertUnit(t.height));
            }, e.prototype.cleanupNativeItem = function (t) {
              var e = this.dataSource;
              return e && (e.isAutoGeneratedKey(t.fromKey) && (t.fromKey = void 0), e.isAutoGeneratedKey(t.key) && (t.key = void 0), e.isAutoGeneratedKey(t.toKey) && (t.toKey = void 0)), t;
            }, e.prototype.setDataSource = function (t) {
              this.dataSource = t;
            }, e.prototype.tryRaiseUserAction = function (t, e) {
              var n = this;
              if (this.isUserAction(t)) {
                var o = this.model.findItem(t.source.key);
                o && this.events.raise1(function (t) {
                  return e(n.createNativeItem(o));
                });
              }
            }, e.prototype.isUserAction = function (t) {
              return t.source && (t.source.type === a.MouseEventElementType.Shape || t.source.type === a.MouseEventElementType.ShapeExpandButton || t.source.type === a.MouseEventElementType.ShapeParameterBox || t.source.type === a.MouseEventElementType.ShapeResizeBox || t.source.type === a.MouseEventElementType.ShapeConnectionPoint || t.source.type === a.MouseEventElementType.Connector || t.source.type === a.MouseEventElementType.ConnectorPoint || t.source.type === a.MouseEventElementType.ConnectorSide || t.source.type === a.MouseEventElementType.ConnectorOrthogonalSide || t.source.type === a.MouseEventElementType.ConnectorText);
            }, e.prototype.onUpdateUnlocked = function (t) {
              t & r.SelectionChanged && this.raiseSelectionChanged();
            }, e.prototype.raiseSelectionChanged = function () {
              var t = this,
                e = this.selection.getKeys().map(function (e) {
                  return t.createNativeItem(t.model.findItem(e));
                });
              this.events.raise1(function (t) {
                return t.notifySelectionChanged(e);
              });
            }, e;
          }(s.BatchUpdatableObject);
        e.ApiController = p, function (t) {
          t[t.SelectionChanged = 1] = "SelectionChanged";
        }(r || (r = {}));
      },
      8321: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.DisplayShapeDescription = void 0;
        var r = n(3190),
          s = n(3255),
          a = n(6208),
          c = n(1280),
          u = function (t) {
            function e() {
              return t.call(this, void 0, !0) || this;
            }
            return i(e, t), Object.defineProperty(e.prototype, "key", {
              get: function () {
                return s.ShapeTypes.Display;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "keepRatioOnAutoSize", {
              get: function () {
                return !1;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.createShapePrimitives = function (t) {
              var n = t.rectangle,
                o = n.x,
                i = n.y,
                r = n.right,
                s = n.bottom,
                c = n.width,
                u = n.center.y,
                p = c * e.arcWidthRatio;
              return [new a.PathPrimitive([new a.PathPrimitiveMoveToCommand(r - p / 2, i), new a.PathPrimitiveLineToCommand(o + p / 2, i), new a.PathPrimitiveLineToCommand(o, u), new a.PathPrimitiveLineToCommand(o + p / 2, s), new a.PathPrimitiveLineToCommand(r - p / 2, s), new a.PathPrimitiveArcToCommand(p / 2, (s - i) / 2, 0, !1, !1, r - p / 2, i)], t.style)];
            }, e.prototype.getTextRectangle = function (t) {
              var n = t.size.width * e.arcWidthRatio;
              return t.rectangle.clone().moveRectangle(n / 2, c.ShapeTextPadding).resize(-n, 2 * -c.ShapeTextPadding).nonNegativeSize();
            }, e.arcWidthRatio = .2, e;
          }(r.RectangleShapeDescription);
        e.DisplayShapeDescription = u;
      },
      8371: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ChangeStyleHistoryItemBase = void 0;
        var r = function (t) {
          function e(e, n, o) {
            var i = t.call(this) || this;
            return i.itemKey = e, i.styleProperty = n, i.styleValue = o, i;
          }
          return i(e, t), e.prototype.redo = function (t) {
            var e = t.model.findItem(this.itemKey);
            this.oldStyleValue = e.style[this.styleProperty], t.changeStyle(e, this.styleProperty, this.styleValue);
          }, e.prototype.undo = function (t) {
            var e = t.model.findItem(this.itemKey);
            t.changeStyle(e, this.styleProperty, this.oldStyleValue);
          }, e;
        }(n(2616).HistoryItem);
        e.ChangeStyleHistoryItemBase = r;
      },
      8408: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Shape = void 0;
        var r = n(4412),
          s = n(1280),
          a = n(4636),
          c = n(4824),
          u = n(4856),
          p = n(9406),
          h = n(4235),
          l = function (t) {
            function e(e, n, o) {
              var i = t.call(this) || this;
              if (i.description = e, i.children = [], i.expanded = !0, i.expandedSize = void 0, !e) throw Error("Shape type is incorrect");
              i.position = n.clone();
              var r = o ? e.toolboxSize : e.defaultSize;
              return i.size = r.clone(), i.text = e.getDefaultText(), i.image = new p.ImageInfo(e.getDefaultImageUrl()), i.parameters = new a.ShapeParameters(), e.createParameters(i.parameters), i;
            }
            return i(e, t), e.prototype.assign = function (e) {
              t.prototype.assign.call(this, e), e.size = this.size.clone(), e.text = this.text, e.image = this.image.clone(), e.parameters = this.parameters.clone(), e.children = this.children.slice(), e.expanded = this.expanded, this.expandedSize && (e.expandedSize = this.expandedSize.clone());
            }, e.prototype.clone = function () {
              var t = new e(this.description, this.position.clone());
              return this.assign(t), t;
            }, Object.defineProperty(e.prototype, "enableText", {
              get: function () {
                return this.description.enableText;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "allowEditText", {
              get: function () {
                return this.description.allowEditText;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "hasTemplate", {
              get: function () {
                return this.description.hasTemplate;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "enableChildren", {
              get: function () {
                return this.description.enableChildren;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "enableImage", {
              get: function () {
                return this.description.enableImage;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "allowEditImage", {
              get: function () {
                return this.description.allowEditImage;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.getMinWidth = function (t) {
              return "number" == typeof this.description.minWidth ? this.description.minWidth : "number" == typeof t ? t : s.ShapeMinDimension;
            }, e.prototype.getMinHeight = function (t) {
              return "number" == typeof this.description.minHeight ? this.description.minHeight : "number" == typeof t ? t : s.ShapeMinDimension;
            }, e.prototype.getMaxWidth = function (t) {
              return "number" == typeof this.description.maxWidth ? this.description.maxWidth : "number" == typeof t ? t : void 0;
            }, e.prototype.getMaxHeight = function (t) {
              return "number" == typeof this.description.maxHeight ? this.description.maxHeight : "number" == typeof t ? t : void 0;
            }, e.prototype.createPrimitives = function (t) {
              return this.description.createPrimitives(this, t);
            }, e.prototype.createSelectorPrimitives = function () {
              return this.description.createSelectorPrimitives(this);
            }, e.prototype.normalizeX = function (t) {
              return Math.max(this.position.x, Math.min(t, this.position.x + this.size.width));
            }, e.prototype.normalizeY = function (t) {
              return Math.max(this.position.y, Math.min(t, this.position.y + this.size.height));
            }, e.prototype.getConnectionPoints = function () {
              var t = this;
              return this.description.getConnectionPoints().map(function (e) {
                var n = new u.ConnectionPoint(t.position.x + e.x * t.size.width, t.position.y + e.y * t.size.height, e.side);
                return t.description.processConnectionPoint(t, n), n;
              });
            }, e.prototype.getConnectionPointSide = function (t, e) {
              return t.side !== c.ConnectionPointSide.Undefined ? t.side : this.getConnectionPointSideByGeometry(t);
            }, e.prototype.getConnectionPointSideByGeometry = function (t) {
              var e = t.clone().offset(-this.position.x, -this.position.y).multiply(1 / this.size.width, 1 / this.size.height);
              return s.ShapeDescription.getConnectionPointSideByGeometry(e);
            }, e.prototype.getConnectionPointIndexForItem = function (t, e) {
              return this.description.getConnectionPointIndexForItem(t, e);
            }, e.prototype.getConnectionPointIndexForSide = function (t) {
              return this.description.getConnectionPointIndexForSide(t);
            }, e.prototype.toggleExpandedSize = function () {
              this.expanded ? (this.size = this.getExpandedSize(), this.expandedSize = void 0) : (this.expandedSize = this.size.clone(), this.size = this.getCollapsedSize());
            }, e.prototype.getExpandedSize = function () {
              return this.description.getExpandedSize(this);
            }, e.prototype.getCollapsedSize = function () {
              return this.description.getCollapsedSize(this);
            }, e.prototype.getToolboxHeightToWidthRatio = function () {
              return this.description.getToolboxHeightToWidthRatio(this.size.width, this.size.height);
            }, Object.defineProperty(e.prototype, "allowResizeHorizontally", {
              get: function () {
                return this.description.allowResizeHorizontally(this);
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "allowResizeVertically", {
              get: function () {
                return this.description.allowResizeVertically(this);
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "rectangle", {
              get: function () {
                return r.Rectangle.fromGeometry(this.position, this.size);
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "clientRectangle", {
              get: function () {
                return this.description.getClientRectangle(this);
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "textRectangle", {
              get: function () {
                return this.description.getTextRectangle(this);
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "textEditRectangle", {
              get: function () {
                return this.description.getTextEditRectangle(this);
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "textAngle", {
              get: function () {
                return this.description.getTextAngle();
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.toNative = function (t) {
              var e = new h.NativeShape(this.key, this.dataKey);
              return e.type = this.description.key, e.text = this.text, e.position = this.position.clone(), e.size = this.size.clone(), e.attachedConnectorIds = this.attachedConnectors.map(function (t) {
                return t.key;
              }), e.applyUnits(t), e.containerId = this.container ? this.container.key : null, e.containerChildItemIds = this.children.map(function (t) {
                return t.key;
              }), e.containerExpanded = this.expanded, e;
            }, e;
          }(c.DiagramItem);
        e.Shape = l;
      },
      8424: (t, e) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Browser = void 0;
        var n = function () {
          function t() {}
          return t.IdentUserAgent = function (e, n) {
            void 0 === n && (n = !1);
            var o = ["Mozilla", "IE", "Firefox", "Netscape", "Safari", "Chrome", "Opera", "Opera10", "Edge"],
              i = "IE",
              r = "Win",
              s = {
                Safari: 2,
                Chrome: .1,
                Mozilla: 1.9,
                Netscape: 8,
                Firefox: 2,
                Opera: 9,
                IE: 6,
                Edge: 12
              };
            if (e && 0 !== e.length) {
              e = e.toLowerCase(), t.indentPlatformMajorVersion(e);
              try {
                for (var a = {
                    Windows: "Win",
                    Macintosh: "Mac",
                    "Mac OS": "Mac",
                    Mac_PowerPC: "Mac",
                    "cpu os": "MacMobile",
                    "cpu iphone os": "MacMobile",
                    Android: "Android",
                    "!Windows Phone": "WinPhone",
                    "!WPDesktop": "WinPhone",
                    "!ZuneWP": "WinPhone"
                  }, c = "(?:/|\\s*)?", u = "(\\d+)(?:\\.((?:\\d+?[1-9])|\\d)0*?)?", p = "(?:" + u + ")?", h = {
                    Safari: "applewebkit(?:.*?(?:version/" + u + "[\\.\\w\\d]*?(?:\\s+mobile/\\S*)?\\s+safari))?",
                    Chrome: "(?:chrome|crios)(?!frame)" + c + p,
                    Mozilla: "mozilla(?:.*rv:" + p + ".*Gecko)?",
                    Netscape: "(?:netscape|navigator)\\d*/?\\s*" + p,
                    Firefox: "firefox" + c + p,
                    Opera: "(?:opera|\\sopr)" + c + p,
                    Opera10: "opera.*\\s*version" + c + p,
                    IE: "msie\\s*" + p,
                    Edge: "edge" + c + p
                  }, l = null, d = -1, f = 0; f < o.length; f++) {
                  var y = o[f],
                    g = new RegExp(h[y], "i").exec(e);
                  if (g && g.index >= 0) {
                    if ("IE" === l && d >= 11 && "Safari" === y) continue;
                    "Opera10" === (l = y) && (l = "Opera");
                    var m = "trident" + c + p;
                    d = t.GetBrowserVersion(e, g, m, t.getIECompatibleVersionString()), "Mozilla" === l && d >= 11 && (l = "IE");
                  }
                }
                l || (l = i);
                var v = -1 !== d;
                v || (d = s[l]);
                var P = null,
                  C = Number.MAX_VALUE;
                for (var S in a) if (Object.prototype.hasOwnProperty.call(a, S)) {
                  var x = "!" === S.substr(0, 1),
                    b = e.indexOf((x ? S.substr(1) : S).toLowerCase());
                  b >= 0 && (b < C || x) && (C = x ? 0 : b, P = a[S]);
                }
                var w = e.toUpperCase().match("SM-[A-Z]"),
                  I = w && w.length > 0;
                "WinPhone" === P && d < 9 && (d = Math.floor(t.getVersionFromTrident(e, "trident" + c + p))), !n && "IE" === l && d > 7 && document.documentMode < d && (d = document.documentMode), "WinPhone" === P && (d = Math.max(9, d)), P || (P = r), P !== a["cpu os"] || v || (d = 4), t.fillUserAgentInfo(o, l, d, P, I);
              } catch (e) {
                t.fillUserAgentInfo(o, i, s[i], r);
              }
            } else t.fillUserAgentInfo(o, i, s[i], r);
          }, t.GetBrowserVersion = function (e, n, o, i) {
            var r = t.getVersionFromMatches(n);
            if (i) {
              var s = t.getVersionFromTrident(e, o);
              if ("edge" === i || parseInt(i) === s) return s;
            }
            return r;
          }, t.getIECompatibleVersionString = function () {
            if (document.compatible) for (var t = 0; t < document.compatible.length; t++) if ("IE" === document.compatible[t].userAgent && document.compatible[t].version) return document.compatible[t].version.toLowerCase();
            return "";
          }, t.isTouchEnabled = function () {
            return t.hasTouchStart() || t.hasMaxTouchPoints() || t.hasMsMaxTouchPoints();
          }, t.hasTouchStart = function () {
            return "ontouchstart" in window;
          }, t.hasMaxTouchPoints = function () {
            return navigator.maxTouchPoints > 0;
          }, t.hasMsMaxTouchPoints = function () {
            return navigator.msMaxTouchPoints > 0;
          }, t.hasNavigator = function () {
            return "undefined" != typeof navigator;
          }, t.fillUserAgentInfo = function (e, n, o, i, r) {
            void 0 === r && (r = !1);
            for (var s = 0; s < e.length; s++) {
              var a = e[s];
              t[a] = a === n;
            }
            t.Version = Math.floor(10 * o) / 10, t.MajorVersion = Math.floor(t.Version), t.WindowsPlatform = "Win" === i || "WinPhone" === i, t.MacOSMobilePlatform = "MacMobile" === i || "Mac" === i && t.isTouchEnabled(), t.MacOSPlatform = "Mac" === i && !t.MacOSMobilePlatform, t.AndroidMobilePlatform = "Android" === i, t.WindowsPhonePlatform = "WinPhone" === i, t.WebKitFamily = t.Safari || t.Chrome || t.Opera && t.MajorVersion >= 15, t.NetscapeFamily = t.Netscape || t.Mozilla || t.Firefox, t.WebKitTouchUI = t.MacOSMobilePlatform || t.AndroidMobilePlatform;
            var c = t.IE && t.MajorVersion > 9 && t.WindowsPlatform && t.UserAgent.toLowerCase().indexOf("touch") >= 0;
            if (t.MSTouchUI = c || t.Edge && !!window.navigator.maxTouchPoints, t.TouchUI = t.WebKitTouchUI || t.MSTouchUI, t.MobileUI = t.WebKitTouchUI || t.WindowsPhonePlatform, t.AndroidDefaultBrowser = t.AndroidMobilePlatform && !t.Chrome, t.AndroidChromeBrowser = t.AndroidMobilePlatform && t.Chrome, r && (t.SamsungAndroidDevice = r), t.MSTouchUI) {
              var u = t.UserAgent.toLowerCase().indexOf("arm;") > -1;
              t.VirtualKeyboardSupported = u || t.WindowsPhonePlatform;
            } else t.VirtualKeyboardSupported = t.WebKitTouchUI;
            t.fillDocumentElementBrowserTypeClassNames(e);
          }, t.indentPlatformMajorVersion = function (e) {
            var n = /(?:(?:windows nt|macintosh|mac os|cpu os|cpu iphone os|android|windows phone|linux) )(\d+)(?:[-0-9_.])*/.exec(e);
            n && (t.PlaformMajorVersion = n[1]);
          }, t.getVersionFromMatches = function (t) {
            var e = -1,
              n = "";
            return t && (t[1] && (n += t[1], t[2] && (n += "." + t[2])), "" !== n && (e = parseFloat(n), isNaN(e) && (e = -1))), e;
          }, t.getVersionFromTrident = function (e, n) {
            var o = new RegExp(n, "i").exec(e);
            return t.getVersionFromMatches(o) + 4;
          }, t.fillDocumentElementBrowserTypeClassNames = function (e) {
            for (var n = "", o = e.concat(["WindowsPlatform", "MacOSPlatform", "MacOSMobilePlatform", "AndroidMobilePlatform", "WindowsPhonePlatform", "WebKitFamily", "WebKitTouchUI", "MSTouchUI", "TouchUI", "AndroidDefaultBrowser"]), i = 0; i < o.length; i++) {
              var r = o[i];
              t[r] && (n += "dx" + r + " ");
            }
            n += "dxBrowserVersion-" + t.MajorVersion, "undefined" != typeof document && document && document.documentElement && ("" !== document.documentElement.className && (n = " " + n), document.documentElement.className += n, t.Info = n);
          }, t.getUserAgent = function () {
            return t.hasNavigator() && navigator.userAgent ? navigator.userAgent.toLowerCase() : "";
          }, t.UserAgent = t.getUserAgent(), t._foo = t.IdentUserAgent(t.UserAgent), t;
        }();
        e.Browser = n;
      },
      8426: (t, e) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ResizeInfoVisualizer = void 0;
        var n = function () {
          function t(t) {
            this.dispatcher = t;
          }
          return t.prototype.set = function (t, e) {
            this.point = t, this.text = e, this.raiseShow();
          }, t.prototype.reset = function () {
            void 0 !== this.point && (this.point = void 0, this.text = void 0, this.raiseHide());
          }, t.prototype.raiseShow = function () {
            var t = this;
            this.dispatcher.raise1(function (e) {
              return e.notifyResizeInfoShow(t.point, t.text);
            });
          }, t.prototype.raiseHide = function () {
            this.dispatcher.raise1(function (t) {
              return t.notifyResizeInfoHide();
            });
          }, t;
        }();
        e.ResizeInfoVisualizer = n;
      },
      8437: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ChangeUnitsHistoryItem = void 0;
        var r = function (t) {
          function e(e) {
            var n = t.call(this) || this;
            return n.units = e, n;
          }
          return i(e, t), e.prototype.redo = function (t) {
            this.oldUnits = t.model.units, t.model.units = this.units;
          }, e.prototype.undo = function (t) {
            t.model.units = this.oldUnits;
          }, e;
        }(n(2616).HistoryItem);
        e.ChangeUnitsHistoryItem = r;
      },
      8451: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.EvtUtils = void 0;
        var o = n(8424),
          i = n(961),
          r = n(750),
          s = n(1065),
          a = function () {
            function t() {}
            return t.preventEvent = function (t) {
              t.cancelable && (t.preventDefault ? t.preventDefault() : t.returnValue = !1);
            }, t.getEventSource = function (e) {
              return i.isDefined(e) ? t.getEventSourceCore(e) : null;
            }, t.getEventSourceByPosition = function (e) {
              if (!i.isDefined(e)) return null;
              if (!document.elementFromPoint) return t.getEventSourceCore(e);
              var n = t.getEventX(e) - (t.clientEventRequiresDocScrollCorrection() ? r.DomUtils.getDocumentScrollLeft() : 0),
                o = t.getEventY(e) - (t.clientEventRequiresDocScrollCorrection() ? r.DomUtils.getDocumentScrollTop() : 0);
              return void 0 === n || void 0 === o ? t.getEventSourceCore(e) : document.elementFromPoint(n, o);
            }, t.getEventSourceCore = function (t) {
              return t.srcElement ? t.srcElement : t.target;
            }, t.getMouseWheelEventName = function () {
              return o.Browser.Safari ? "mousewheel" : o.Browser.NetscapeFamily && o.Browser.MajorVersion < 17 ? "DOMMouseScroll" : "wheel";
            }, t.isLeftButtonPressed = function (e) {
              return !!s.TouchUtils.isTouchEvent(e) || !!(e = o.Browser.IE && i.isDefined(event) ? event : e) && (o.Browser.IE && o.Browser.Version < 11 ? !!o.Browser.MSTouchUI || e.button % 2 == 1 : o.Browser.WebKitFamily ? "pointermove" === e.type || "pointerenter" === e.type || "pointerleave" === e.type ? 1 === e.buttons : 1 === e.which : o.Browser.NetscapeFamily || o.Browser.Edge || o.Browser.IE && o.Browser.Version >= 11 ? t.isMoveEventName(e.type) ? 1 === e.buttons : 1 === e.which : !o.Browser.Opera || 0 === e.button);
            }, t.isMoveEventName = function (e) {
              return e === s.TouchUtils.touchMouseMoveEventName || e === t.getMoveEventName();
            }, t.getMoveEventName = function () {
              return window.PointerEvent ? "pointermove" : o.Browser.TouchUI ? "touchmove" : "mousemove";
            }, t.preventEventAndBubble = function (e) {
              t.preventEvent(e), e.stopPropagation && e.stopPropagation(), e.cancelBubble = !0;
            }, t.clientEventRequiresDocScrollCorrection = function () {
              var t = o.Browser.Safari && o.Browser.Version < 3,
                e = o.Browser.MacOSMobilePlatform && o.Browser.Version < 5.1;
              return o.Browser.AndroidDefaultBrowser || o.Browser.AndroidChromeBrowser || !(t || e);
            }, t.getEventX = function (e) {
              return s.TouchUtils.isTouchEvent(e) ? s.TouchUtils.getEventX(e) : e.clientX + (t.clientEventRequiresDocScrollCorrection() ? r.DomUtils.getDocumentScrollLeft() : 0);
            }, t.getEventY = function (e) {
              return s.TouchUtils.isTouchEvent(e) ? s.TouchUtils.getEventY(e) : e.clientY + (t.clientEventRequiresDocScrollCorrection() ? r.DomUtils.getDocumentScrollTop() : 0);
            }, t.cancelBubble = function (t) {
              t.cancelBubble = !0;
            }, t.getWheelDelta = function (t) {
              var e;
              return e = o.Browser.NetscapeFamily && o.Browser.MajorVersion < 17 ? -t.detail : o.Browser.Safari ? t.wheelDelta : -t.deltaY, o.Browser.Opera && o.Browser.Version < 9 && (e = -e), e;
            }, t;
          }();
        e.EvtUtils = a;
      },
      8464: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.LayoutBuilder = void 0;
        var o = n(9212),
          i = function () {
            function t(t, e) {
              this.settings = t, this.graph = e;
            }
            return t.prototype.getBreadthNodeSizeCore = function (t, e) {
              var n = this.settings.orientation === o.DataLayoutOrientation.Vertical ? t.size.width : t.size.height;
              return e || (n += this.settings.orientation === o.DataLayoutOrientation.Vertical ? t.margin.left + t.margin.right : t.margin.top + t.margin.bottom), n;
            }, t.prototype.getDepthNodeSizeCore = function (t) {
              return this.settings.orientation === o.DataLayoutOrientation.Horizontal ? t.size.width + t.margin.left + t.margin.right : t.size.height + t.margin.top + t.margin.bottom;
            }, t.prototype.chooseDirectionValue = function (t, e) {
              return this.settings.direction === o.LogicalDirectionKind.Forward ? t : e;
            }, t.prototype.getDirectionValue = function (t) {
              return this.settings.direction === o.LogicalDirectionKind.Forward ? t : -t;
            }, t.prototype.getComponentOffset = function (t) {
              var e = t.getRectangle(!0);
              return (this.settings.orientation === o.DataLayoutOrientation.Vertical ? e.width : e.height) + this.settings.componentSpacing;
            }, t.prototype.setComponentOffset = function (t, e) {
              return this.settings.orientation === o.DataLayoutOrientation.Vertical ? t.offsetNodes(e) : t.offsetNodes(0, e);
            }, t;
          }();
        e.LayoutBuilder = i;
      },
      8495: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CloneDownCommand = e.CloneUpCommand = e.CloneRightCommand = e.CloneLeftCommand = e.CloneCommand = void 0;
        var r = n(1922),
          s = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), e.prototype.isEnabled = function () {
              var e = this.control.selection.getSelectedItems();
              return t.prototype.isEnabled.call(this) && e.length && e.length > 0 && this.permissionsProvider.canAddItems(e);
            }, e.prototype.executeCore = function (t, e) {
              var n = r.ModelUtils.createRectangle(this.control.selection.getSelectedItems());
              return r.ModelUtils.cloneSelectionToOffset(this.control.history, this.control.model, void 0, this.control.selection, this.getOffsetX(n), this.getOffsetY(n)), !0;
            }, Object.defineProperty(e.prototype, "isPermissionsRequired", {
              get: function () {
                return !0;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.getOffsetX = function (t) {
              return 0;
            }, e.prototype.getOffsetY = function (t) {
              return 0;
            }, e;
          }(n(3913).SimpleCommandBase);
        e.CloneCommand = s;
        var a = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(e, t), e.prototype.getOffsetX = function (t) {
            return -t.width;
          }, e;
        }(s);
        e.CloneLeftCommand = a;
        var c = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(e, t), e.prototype.getOffsetX = function (t) {
            return t.width;
          }, e;
        }(s);
        e.CloneRightCommand = c;
        var u = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(e, t), e.prototype.getOffsetY = function (t) {
            return -t.height;
          }, e;
        }(s);
        e.CloneUpCommand = u;
        var p = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(e, t), e.prototype.getOffsetY = function (t) {
            return t.height;
          }, e;
        }(s);
        e.CloneDownCommand = p;
      },
      8501: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Margin = e.EdgeLayout = e.NodeLayout = e.NodeInfo = void 0;
        var o = n(4412),
          i = function (t, e, n, o) {
            void 0 === o && (o = []), this.key = t, this.margin = e, this.size = n, this.connectionPoints = o;
          };
        e.NodeInfo = i;
        var r = function () {
          function t(t, e) {
            this.info = t, this.position = e;
          }
          return Object.defineProperty(t.prototype, "key", {
            get: function () {
              return this.info.key;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "rectangle", {
            get: function () {
              return o.Rectangle.fromGeometry(this.position, this.info.size);
            },
            enumerable: !1,
            configurable: !0
          }), t;
        }();
        e.NodeLayout = r;
        var s = function (t, e, n) {
          this.key = t, this.beginIndex = e, this.endIndex = n;
        };
        e.EdgeLayout = s;
        var a = function () {
          function t(t, e, n, o) {
            void 0 === e && (e = t), void 0 === n && (n = t), void 0 === o && (o = t), this.top = t, this.right = e, this.bottom = n, this.left = o;
          }
          return t.empty = function () {
            return new t(0);
          }, t;
        }();
        e.Margin = a;
      },
      8503: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MouseHandlerDragParameterPointState = void 0;
        var r = n(2815),
          s = n(7489),
          a = function (t) {
            function e(e, n, o) {
              var i = t.call(this, e, n) || this;
              return i.model = o, i.startScrollLeft = 0, i.startScrollTop = 0, i;
            }
            return i(e, t), e.prototype.onMouseDown = function (e) {
              this.startPoint = e.modelPoint, this.shape = this.model.findShape(e.source.key), this.parameterPointKey = e.source.value, this.startParameters = this.shape.parameters.clone(), t.prototype.onMouseDown.call(this, e);
            }, e.prototype.onApplyChanges = function (t) {
              var e = this.handler.getSnappedOffsetOnDragPoint(t, this.startPoint),
                n = this.startParameters.clone();
              this.shape.description.modifyParameters(this.shape, n, e.x, e.y), this.history.addAndRedo(new s.ChangeShapeParametersHistoryItem(this.shape.key, n));
            }, e.prototype.getDraggingElementKeys = function () {
              return [this.shape.key];
            }, e;
          }(r.MouseHandlerDraggingState);
        e.MouseHandlerDragParameterPointState = a;
      },
      8509: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.RenderHelper = e.svgNS = void 0;
        var o = n(9196);
        e.svgNS = "http://www.w3.org/2000/svg";
        var i = function () {
          function t() {}
          return t.createSvgElement = function (t, n) {
            void 0 === n && (n = !1);
            var o = document.createElementNS(e.svgNS, "svg");
            return o.className.baseVal = "dxdi-canvas" + (n ? " export" : ""), t && t.appendChild(o), o;
          }, t.createMainElement = function (t, e) {
            void 0 === e && (e = !1);
            var n = document.createElement("div");
            return n.setAttribute("class", "dxdi-control" + (e ? " measurer" : "")), o.Diagnostics.optimizeLayers && (n.style.transform = "translateZ(0)"), t && t.appendChild(n), n;
          }, t.addEventListener = function (t, e, n) {
            t.addEventListener(e, n);
          }, t.removeEventListener = function (t, e, n) {
            t.removeEventListener(e, n);
          }, t;
        }();
        e.RenderHelper = i;
      },
      8514: (t, e) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ConnectorTexts = e.ConnectorText = void 0;
        var n = function (t, e) {
          this.position = t, this.value = e;
        };
        e.ConnectorText = n;
        var o = function () {
          function t() {
            this.items = {};
          }
          return t.prototype.get = function (t) {
            return this.items[t];
          }, t.prototype.set = function (t, e) {
            this.items[t] = e;
          }, t.prototype.remove = function (t) {
            delete this.items[t];
          }, t.prototype.map = function (t) {
            var e = [];
            return this.forEach(function (n) {
              return e.push(t(n));
            }), e;
          }, t.prototype.forEach = function (t) {
            for (var e in this.items) Object.prototype.hasOwnProperty.call(this.items, e) && t(this.items[e]);
          }, t.prototype.count = function () {
            return Object.keys(this.items).length;
          }, t.prototype.clone = function () {
            var e = new t();
            return this.forEach(function (t) {
              e.set(t.position, new n(t.position, t.value));
            }), e;
          }, t.prototype.toObject = function () {
            var t = {},
              e = !1;
            return this.forEach(function (n) {
              t[n.position] = n.value, e = !0;
            }), e ? t : null;
          }, t.prototype.fromObject = function (t) {
            for (var e in t) if (Object.prototype.hasOwnProperty.call(t, e)) {
              var o = parseFloat(e);
              isNaN(o) || "string" != typeof t[e] || this.set(o, new n(o, t[e]));
            }
          }, t;
        }();
        e.ConnectorTexts = o;
      },
      8533: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.TreeLayoutBuilder = void 0;
        var r = n(1441),
          s = n(5483),
          a = n(8501),
          c = n(41),
          u = n(5327),
          p = n(8464),
          h = n(8573),
          l = n(4824),
          d = n(9212),
          f = n(9071),
          y = function (t) {
            function e() {
              var e = null !== t && t.apply(this, arguments) || this;
              return e.nodeToLevel = {}, e.levelDepthSize = {}, e;
            }
            return i(e, t), e.prototype.build = function () {
              var t = this,
                e = new r.GraphLayout(),
                n = 0;
              return this.graph.getConnectedComponents().forEach(function (o) {
                for (var i = s.Tree.createSpanningTree(o), r = t.processTree(i), a = t.getComponentOffset(r); r.nodeKeys.length < o.nodes.length;) {
                  var c = new f.Graph(o.nodes.filter(function (t) {
                      return !r.nodeToLayout[t];
                    }).map(function (t) {
                      return o.getNode(t);
                    }), o.edges.filter(function (t) {
                      return !r.edgeToPosition[t.key];
                    })),
                    u = s.Tree.createSpanningTree(c),
                    p = t.processTree(u);
                  r.extend(t.setComponentOffset(p, a)), a += t.getComponentOffset(p);
                }
                e.extend(t.setComponentOffset(r, n)), n += t.getComponentOffset(r);
              }), e;
            }, e.prototype.preProcessTree = function (t, e, n) {
              var o = this;
              if ((e = e.filter(function (t) {
                return (void 0 === o.nodeToLevel[t.key] ? o.nodeToLevel[t.key] = n : -1) >= 0;
              })).length) {
                var i = this.getMaxDepthSize(e);
                this.levelDepthSize[n] = i, this.preProcessTree(t, [].concat.apply([], e.map(function (e) {
                  return t.getChildren(e);
                })), n + 1);
              }
            }, e.prototype.loadNodes = function (t, e, n) {
              return n ? t.getChildren(n.info).map(function (t) {
                return e.hasNode(t.key) ? void 0 : e.addNode(new a.NodeLayout(t, u.Point.zero()));
              }).filter(function (t) {
                return t;
              }) : [e.addNode(new a.NodeLayout(t.root, u.Point.zero()))];
            }, e.prototype.processTree = function (t) {
              var e = this,
                n = new r.GraphLayout();
              if (this.preProcessTree(t, [t.root], 0), this.processLevel(t, n, 0, new c.Range(0), 0), this.settings.direction === d.LogicalDirectionKind.Backward) {
                var o = Object.keys(this.levelDepthSize).map(function (t) {
                    return e.levelDepthSize[t];
                  }),
                  i = o.reduce(function (t, e) {
                    return t + e;
                  }, 0) + (o.length - 1) * this.settings.layerSpacing;
                n.forEachNode(function (t) {
                  return e.setDepthPos(t, e.getDepthPos(t) + i);
                });
              }
              return n;
            }, e.prototype.processLevel = function (t, e, n, o, i, r) {
              var s,
                a = this,
                u = this.addNodes(t, e, i, r),
                p = r ? this.graph.getAdjacentEdges(r.key, h.ConnectionMode.Outgoing) : [],
                l = this.getDirectionValue(this.levelDepthSize[i]),
                d = this.getDirectionValue(this.settings.layerSpacing);
              if (u.forEach(function (r) {
                var u = c.Range.fromLength(s ? s.to + a.settings.columnSpacing : o.from, a.getBreadthNodeSizeCore(r.info));
                r.position = a.getNodePosition(u.from, n, l).clone().offset(r.info.margin.left, r.info.margin.top), a.processLevel(t, e, n + l + d, u, i + 1, r), a.updateEdgeConnections(e, p, r), o.extend(u), s = u;
              }), r && u.length) {
                var f = u[u.length - 1],
                  y = new c.Range(this.getBreadthPos(u[0]), this.getBreadthPos(f) + this.getBreadthNodeSizeCore(f.info, !0));
                this.alignParent(r, y, o);
              }
            }, e.prototype.addNodes = function (t, e, n, o) {
              var i = this;
              return 0 === n ? [e.addNode(new a.NodeLayout(t.root, u.Point.zero()))] : t.getChildren(o.info).reduce(function (t, o) {
                return i.nodeToLevel[o.key] !== n || e.hasNode(o.key) || t.push(e.addNode(new a.NodeLayout(o, u.Point.zero()))), t;
              }, []);
            }, e.prototype.getMaxDepthSize = function (t) {
              var e = this;
              return t.reduce(function (t, n) {
                return Math.max(t, e.getDepthNodeSizeCore(n));
              }, 0);
            }, e.prototype.getNodePosition = function (t, e, n) {
              return this.settings.direction === d.LogicalDirectionKind.Forward ? this.settings.orientation === d.DataLayoutOrientation.Vertical ? new u.Point(t, e) : new u.Point(e, t) : this.settings.orientation === d.DataLayoutOrientation.Vertical ? new u.Point(t, e + n) : new u.Point(e + n, t);
            }, e.prototype.updateEdgeConnections = function (t, e, n) {
              var o = this;
              e.filter(function (t) {
                return t.to === n.key;
              }).forEach(function (e) {
                var n = o.getBeginEdgeIndex(),
                  i = o.getEndEdgeIndex();
                t.addEdge(new a.EdgeLayout(e.key, n, i));
              });
            }, e.prototype.getBeginEdgeIndex = function () {
              return this.settings.direction === d.LogicalDirectionKind.Forward ? this.isVertical() ? l.ConnectionPointSide.South : l.ConnectionPointSide.East : this.isVertical() ? l.ConnectionPointSide.North : l.ConnectionPointSide.West;
            }, e.prototype.getEndEdgeIndex = function () {
              return this.settings.direction === d.LogicalDirectionKind.Forward ? this.isVertical() ? l.ConnectionPointSide.North : l.ConnectionPointSide.West : this.isVertical() ? l.ConnectionPointSide.South : l.ConnectionPointSide.East;
            }, e.prototype.alignParent = function (t, e, n) {
              if (this.settings.alignment === d.Alignment.Center) {
                var o = e.from + e.length / 2 - this.getBreadthNodeSizeCore(t.info, !0) / 2;
                this.settings.orientation === d.DataLayoutOrientation.Vertical ? (t.position.x = Math.max(n.from + t.info.margin.left, o), t.position.x = Math.min(n.to - t.info.size.width - t.info.margin.right, t.position.x)) : (t.position.y = Math.max(n.from + t.info.margin.top, o), t.position.y = Math.min(n.to - t.info.size.height - t.info.margin.bottom, t.position.y));
              }
            }, e.prototype.getDepthPos = function (t) {
              return this.settings.orientation === d.DataLayoutOrientation.Vertical ? t.position.y : t.position.x;
            }, e.prototype.getBreadthPos = function (t) {
              return this.settings.orientation === d.DataLayoutOrientation.Vertical ? t.position.x : t.position.y;
            }, e.prototype.setDepthPos = function (t, e) {
              this.settings.orientation === d.DataLayoutOrientation.Vertical ? t.position.y = e : t.position.x = e;
            }, e.prototype.isVertical = function () {
              return this.settings.orientation === d.DataLayoutOrientation.Vertical;
            }, e;
          }(p.LayoutBuilder);
        e.TreeLayoutBuilder = y;
      },
      8535: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ConnectorPointsOrthogonalUndefinedSideCalculator = void 0;
        var r = n(3976),
          s = n(9956),
          a = function (t) {
            function e(e) {
              return t.call(this, e) || this;
            }
            return i(e, t), e.prototype.getCorrectOriginPoint = function (t, e) {
              return t;
            }, e.prototype.getSameShapeOffsetPoints = function (t, e, n, o) {
              return [];
            }, e.prototype.getOverlappedPointsOffsetPoints = function (t, e, n, o) {
              return [];
            }, e.prototype.getBeginOverlappedShapeOffsetPoints = function (t, e, n, o) {
              return [];
            }, e.prototype.getEndOverlappedShapeOffsetPoints = function (t, e, n, o) {
              return [];
            }, e.prototype.getBeginOnSideOffsetPoints = function (t, e, n, o) {
              return [];
            }, e.prototype.getEndOnSideOffsetPoints = function (t, e, n, o) {
              return [];
            }, e.prototype.getBeginOffSideOffsetPoints = function (t, e, n, o) {
              return [];
            }, e.prototype.getEndOffSideOffsetPoints = function (t, e, n, o) {
              return [];
            }, e.prototype.isOnSidePoint = function (t, e) {
              return !0;
            }, e.prototype.isDirectConnectionAllowed = function (t, e, n) {
              var o = this.getSideCalculator(e, n);
              return void 0 === o || o.isDirectConnectionAllowed(t, e, n);
            }, e.prototype.getDirectConnectionPoints = function (t, e) {
              var n = Math.abs(e.x - t.x),
                o = Math.abs(e.y - t.y);
              if (n > o) {
                var i = Math.min(t.x, e.x) + n / 2;
                return [new s.ConnectorRenderPoint(i, t.y), new s.ConnectorRenderPoint(i, e.y)];
              }
              var r = Math.min(t.y, e.y) + o / 2;
              return [new s.ConnectorRenderPoint(t.x, r), new s.ConnectorRenderPoint(e.x, r)];
            }, e;
          }(r.ConnectorPointsOrthogonalSideCalculatorBase);
        e.ConnectorPointsOrthogonalUndefinedSideCalculator = a;
      },
      8536: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ChangePageSizeItemsCommand = e.ChangePageSizeCommand = void 0;
        var r = n(1540),
          s = n(3844),
          a = n(9066),
          c = n(3913),
          u = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), e.prototype.getValue = function () {
              return this.getModelUnitSize(this.control.model.pageSize);
            }, e.prototype.createHistoryItems = function (t) {
              return [new a.ChangePageSizeHistoryItem(new s.Size(this.getModelUnitTwipsValue(t.width), this.getModelUnitTwipsValue(t.height)))];
            }, e.prototype.getItems = function () {
              var t = this;
              return this.control.settings.pageSizeItems.map(function (e) {
                return {
                  value: t.getModelUnitSize(e.size),
                  text: e.text.replace("{width}", t.getViewUnitText(e.size.width)).replace("{height}", t.getViewUnitText(e.size.height))
                };
              });
            }, e.prototype.getModelUnitSize = function (t) {
              return new s.Size(this.getModelUnit(t.width), this.getModelUnit(t.height));
            }, e;
          }(r.ChangePagePropertyCommand);
        e.ChangePageSizeCommand = u;
        var p = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(e, t), e.prototype.isEnabled = function () {
            return !0;
          }, e.prototype.getValue = function () {
            var t = this;
            return this.control.settings.pageSizeItems.map(function (e) {
              return {
                size: new s.Size(t.getModelUnit(e.width), t.getModelUnit(e.height)),
                text: e.text
              };
            });
          }, e.prototype.executeCore = function (t, e) {
            var n = this;
            return this.control.settings.pageSizeItems = e.map(function (t) {
              return {
                size: new s.Size(n.getModelUnitTwipsValue(t.width), n.getModelUnitTwipsValue(t.height)),
                text: t.text
              };
            }), !0;
          }, e;
        }(c.SimpleCommandBase);
        e.ChangePageSizeItemsCommand = p;
      },
      8573: (t, e) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ConnectionMode = e.Edge = void 0;
        var n = function () {
          function t(t, e, n, o) {
            void 0 === o && (o = 1), this.weight = o, this.key = t, this.from = e, this.to = n;
          }
          return t.prototype.getHashKey = function () {
            return this.from + "_" + this.to;
          }, t.prototype.reverse = function () {
            return new t(this.key, this.to, this.from, this.weight);
          }, t;
        }();
        e.Edge = n, function (t) {
          t[t.Outgoing = 1] = "Outgoing", t[t.Incoming = 2] = "Incoming", t[t.OutgoingAndIncoming = 3] = "OutgoingAndIncoming";
        }(e.ConnectionMode || (e.ConnectionMode = {}));
      },
      8601: (t, e) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Offsets = void 0;
        var n = function () {
          function t(t, e, n, o) {
            this.left = t, this.right = e, this.top = n, this.bottom = o;
          }
          return t.empty = function () {
            return new t(0, 0, 0, 0);
          }, Object.defineProperty(t.prototype, "horizontal", {
            get: function () {
              return this.left + this.right;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "vertical", {
            get: function () {
              return this.top + this.bottom;
            },
            enumerable: !1,
            configurable: !0
          }), t.fromNumber = function (e) {
            return new t(e, e, e, e);
          }, t.fromOffsets = function (e) {
            return new t(e.left, e.right, e.top, e.bottom);
          }, t.fromSide = function (e, n) {
            return new t(e, e, n, n);
          }, t.prototype.normalize = function () {
            return this.left = Math.max(0, this.left), this.right = Math.max(0, this.right), this.top = Math.max(0, this.top), this.bottom = Math.max(0, this.bottom), this;
          }, t.prototype.toString = function () {
            return JSON.stringify(this);
          }, t.prototype.isEmpty = function () {
            return 0 === this.left && 0 === this.right && 0 === this.top && 0 === this.bottom;
          }, t.prototype.offset = function (t) {
            return this.left += t.left, this.right += t.right, this.top += t.top, this.bottom += t.bottom, this;
          }, t.prototype.multiply = function (t, e, n, o) {
            switch (arguments.length) {
              case 1:
                return this.left *= t, this.right *= t, this.top *= t, this.bottom *= t, this;
              case 2:
                return this.left *= t, this.right *= t, this.top *= e, this.bottom *= e, this;
              case 4:
                return this.left *= t, this.right *= e, this.top *= n, this.bottom *= o, this;
            }
            return this;
          }, t.prototype.clone = function () {
            return new t(this.left, this.right, this.top, this.bottom);
          }, t.prototype.copyFrom = function (t) {
            this.left = t.left, this.right = t.right, this.top = t.top, this.bottom = t.bottom;
          }, t.prototype.equals = function (t) {
            return this.top === t.top && this.bottom === t.bottom && this.right === t.right && this.left === t.left;
          }, t.prototype.applyConverter = function (t) {
            return this.left = t(this.left), this.right = t(this.right), this.top = t(this.top), this.bottom = t(this.bottom), this;
          }, t;
        }();
        e.Offsets = n;
      },
      8619: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MouseHandlerMoveConnectorPointStateBase = void 0;
        var r = n(6320),
          s = n(5428),
          a = n(2815),
          c = n(6155),
          u = n(4139),
          p = n(1922),
          h = function (t) {
            function e(e, n, o, i) {
              var r = t.call(this, e, n) || this;
              return r.model = o, r.visualizerManager = i, r;
            }
            return i(e, t), e.prototype.finish = function () {
              this.visualizerManager.resetConnectionTarget(), this.visualizerManager.resetConnectionPoints(), t.prototype.finish.call(this);
            }, e.prototype.onMouseDown = function (e) {
              t.prototype.onMouseDown.call(this, e), this.connector && this.handler.addInteractingItem(this.connector);
            }, e.prototype.onMouseMove = function (e) {
              if (t.prototype.onMouseMove.call(this, e), this.allowAttachToObjects(e, !1, !1)) {
                if (this.connector) {
                  var n = this.connector.getExtremeItem(this.pointPosition);
                  this.visualizerManager.setConnectionTarget(n, e.source.type);
                  var o = this.connector.getExtremeConnectionPointIndex(this.pointPosition);
                  (n || -1 === this.oppositeConnectionPointIndex) && this.allowAttachToObjects(e, !0, !1) || (n = this.model.findItem(e.source.key)), this.visualizerManager.setConnectionPoints(n, e.source.type, o, !0);
                }
              } else this.visualizerManager.resetConnectionTarget(), this.visualizerManager.resetConnectionPoints();
            }, e.prototype.onApplyChanges = function (t) {
              var e = this.getSnappedPoint(t, t.modelPoint);
              if (void 0 !== this.pointPosition) {
                void 0 === this.oppositePointPosition && (this.oppositePointPosition = this.getOppositePointPosition(), this.oppositeItem = this.connector.getExtremeItem(this.oppositePointPosition), this.oppositeConnectionPointIndex = this.connector.getExtremeConnectionPointIndex(this.oppositePointPosition)), this.targetItem = this.model.findItem(t.source.key);
                var n = this.allowAttachToObjects(t, !0, !0) ? this.targetItem : void 0,
                  o = -1;
                t.source.type === s.MouseEventElementType.ShapeConnectionPoint && (o = parseInt(t.source.value)), !n || t.source.type !== s.MouseEventElementType.Shape && t.source.type !== s.MouseEventElementType.ShapeConnectionPoint || this.connector.getExtremeItem(this.oppositePointPosition) === n && (-1 === o || -1 === this.oppositeConnectionPointIndex || o === this.oppositeConnectionPointIndex) ? this.connector.getExtremeItem(this.pointPosition) && (this.history.addAndRedo(new c.DeleteConnectionHistoryItem(this.connector, this.pointPosition)), this.oppositeItem && this.updateOppositeItemConnectionPointIndex(this.oppositeConnectionPointIndex)) : (this.connector.getExtremeItem(this.pointPosition) === n && this.connector.getExtremeConnectionPointIndex(this.pointPosition) === o || (this.connector.getExtremeItem(this.pointPosition) && this.history.addAndRedo(new c.DeleteConnectionHistoryItem(this.connector, this.pointPosition)), this.history.addAndRedo(new u.AddConnectionHistoryItem(this.connector, n, o, this.pointPosition)), this.oppositeItem && this.updateOppositeItemConnectionPointIndex(o)), e = n.getConnectionPointPosition(o, this.connector.points[this.pointIndex + (this.pointPosition === r.ConnectorPosition.End ? -1 : 1)]), this.visualizerManager.setConnectionPointIndex(o));
              }
              p.ModelUtils.moveConnectorPoint(this.history, this.connector, this.pointIndex, e), p.ModelUtils.updateConnectorAttachedPoints(this.history, this.model, this.connector), this.handler.tryUpdateModelSize();
            }, e.prototype.updateOppositeItemConnectionPointIndex = function (t) {
              var e = -1 === t ? -1 : this.oppositeConnectionPointIndex;
              e !== this.connector.getExtremeConnectionPointIndex(this.oppositePointPosition) && (this.history.addAndRedo(new c.DeleteConnectionHistoryItem(this.connector, this.oppositePointPosition)), this.history.addAndRedo(new u.AddConnectionHistoryItem(this.connector, this.oppositeItem, e, this.oppositePointPosition)));
            }, e.prototype.onFinishWithChanges = function () {
              p.ModelUtils.updateConnectorContainer(this.history, this.model, this.connector), p.ModelUtils.deleteConnectorUnnecessaryPoints(this.history, this.connector), this.handler.tryUpdateModelSize();
            }, e.prototype.getDraggingElementKeys = function () {
              return this.connector ? [this.connector.key] : [];
            }, e.prototype.getOppositePointPosition = function () {
              return this.pointPosition === r.ConnectorPosition.Begin ? r.ConnectorPosition.End : r.ConnectorPosition.Begin;
            }, e.prototype.allowAttachToObjects = function (t, e, n) {
              if (this.handler.canMultipleSelection(t)) return !1;
              var o = this.connector;
              if (o && t.source.type === s.MouseEventElementType.Shape) {
                var i = this.model.findItem(t.source.key);
                if (e && this.model.findItemContainerCore(o, function (t) {
                  return t === i;
                })) return !1;
                if (e && this.oppositeItem && this.model.findItemContainerCore(this.oppositeItem, function (t) {
                  return t === i;
                })) return !1;
                if (n && this.oppositeItem === i && -1 === this.oppositeConnectionPointIndex) return !1;
              }
              return !0;
            }, e.prototype.onConnectionPointsShow = function (t, e) {
              var n = this;
              if (this.connector && void 0 !== this.pointPosition && (this.connector.endItem && this.connector.endItem.key === t || this.connector.beginItem && this.connector.beginItem.key === t)) {
                var o = this.connector.beginItem && this.connector.beginItem.key === t ? r.ConnectorPosition.Begin : r.ConnectorPosition.End;
                e.forEach(function (t, e) {
                  t.allowed = n.handler.canPerformChangeConnectionOnUpdateUI(n.connector, {
                    item: n.connector.getExtremeItem(o),
                    position: o,
                    connectionPointIndex: e
                  });
                });
              }
            }, e.prototype.onConnectionTargetShow = function (t, e) {
              if (this.connector && void 0 !== this.pointPosition && (this.connector.endItem && this.connector.endItem.key === t || this.connector.beginItem && this.connector.beginItem.key === t)) {
                var n = this.connector.beginItem && this.connector.beginItem.key === t ? r.ConnectorPosition.Begin : r.ConnectorPosition.End;
                e.allowed = this.handler.canPerformChangeConnectionOnUpdateUI(this.connector, {
                  item: this.connector.getExtremeItem(n),
                  position: n,
                  connectionPointIndex: -1
                });
              }
            }, e;
          }(a.MouseHandlerDraggingState);
        e.MouseHandlerMoveConnectorPointStateBase = h;
      },
      8671: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.IntersectedShapeZone = e.AStarMetrics = e.IntersectedShapesMetrics = e.TurnDirectionMetrics = e.IntersectedShapeMetrics = e.RightAngleTurnDirection = void 0;
        var o,
          i = n(5327),
          r = n(4496);
        !function (t) {
          t[t.Straight = 0] = "Straight", t[t.Left = 1] = "Left", t[t.Right = 2] = "Right", t[t.Backwards = 3] = "Backwards";
        }(o = e.RightAngleTurnDirection || (e.RightAngleTurnDirection = {}));
        var s = function () {
          function t(t, e) {
            this.description = t, this.shapeMargin = e;
          }
          return t.prototype.penalty = function (t, e, n, o) {
            var i = o.rectangle;
            if (i.containsPoint(n)) return t + this.description.shape * e;
            var r = this.createRelativeMarginPenalty(n, i, this.shapeMargin);
            return r > 0 ? t + this.description.margin * r * e : t;
          }, t.prototype.createRelativeMarginPenalty = function (t, e, n) {
            var o = this.isTopPosition(t, e, n),
              s = this.isLeftPosition(t, e, n),
              a = this.isBottomPosition(t, e, n),
              c = this.isRightPosition(t, e, n);
            if (o) {
              if (s) {
                var u = (l = e.clone().inflate(n)).createPosition(),
                  p = e.createPosition(),
                  h = r.Metrics.euclideanDistance(p, u);
                return 1 - r.Metrics.euclideanDistance(p, t) / h;
              }
              if (c) {
                var l = e.clone().inflate(n),
                  d = new i.Point(l.right, l.y),
                  f = new i.Point(e.right, e.y),
                  y = r.Metrics.euclideanDistance(f, d);
                return 1 - r.Metrics.euclideanDistance(f, t) / y;
              }
              return 1 - (e.y - t.y) / n;
            }
            if (a) {
              if (s) {
                l = e.clone().inflate(n);
                var g = new i.Point(l.x, l.bottom),
                  m = new i.Point(e.x, e.bottom),
                  v = r.Metrics.euclideanDistance(m, g);
                return 1 - r.Metrics.euclideanDistance(m, t) / v;
              }
              if (c) {
                l = e.clone().inflate(n);
                var P = new i.Point(l.right, l.bottom),
                  C = new i.Point(e.right, e.bottom),
                  S = r.Metrics.euclideanDistance(C, P);
                return 1 - r.Metrics.euclideanDistance(C, t) / S;
              }
              return 1 - (t.y - e.bottom) / n;
            }
            return s ? 1 - (e.x - t.x) / n : c ? 1 - (t.x - e.right) / n : 0;
          }, t.prototype.isTopPosition = function (t, e, n) {
            return t.x > e.x - n && t.x < e.right + n && t.y > e.y - n && t.y < e.y;
          }, t.prototype.isBottomPosition = function (t, e, n) {
            return t.x > e.x - n && t.x < e.right + n && t.y > e.bottom && t.y < e.bottom + n;
          }, t.prototype.isLeftPosition = function (t, e, n) {
            return t.x > e.x - n && t.x < e.x && t.y > e.y - n && t.y < e.bottom + n;
          }, t.prototype.isRightPosition = function (t, e, n) {
            return t.x > e.right && t.x < e.right + n && t.y > e.y - n && t.y < e.bottom + n;
          }, t;
        }();
        e.IntersectedShapeMetrics = s;
        var a = function () {
          function t(t) {
            this.description = t;
          }
          return t.prototype.penalty = function (t, e) {
            switch (e) {
              case o.Backwards:
                return t * this.description.turnBack;
              case o.Left:
                return t * this.description.turnLeft;
              case o.Right:
                return t * this.description.turnRight;
            }
            return t;
          }, t;
        }();
        e.TurnDirectionMetrics = a;
        var c = function () {
          function t(t) {
            this.shapeMetrics = t;
          }
          return t.prototype.penalty = function (t, e, n, o) {
            var i = this;
            if (!o || !o.length) return t;
            var r = t;
            return o.forEach(function (t) {
              return r = i.shapeMetrics.penalty(r, e, n, t);
            }), r;
          }, t;
        }();
        e.IntersectedShapesMetrics = c;
        var u = function () {
          function t(t, e) {
            this.turnDirectionMetrics = t, this.shapesMetrics = e;
          }
          return t.prototype.distance = function (t, e) {
            return r.Metrics.manhattanDistance(t, e);
          }, t.prototype.penalty = function (t, e, n, o) {
            var i = t;
            return i = this.shapesMetrics.penalty(i, t, e, o), i = this.turnDirectionMetrics.penalty(i, n);
          }, t;
        }();
        e.AStarMetrics = u, function (t) {
          t[t.None = 0] = "None", t[t.Shape = 1] = "Shape", t[t.Margin = 2] = "Margin";
        }(e.IntersectedShapeZone || (e.IntersectedShapeZone = {}));
      },
      8674: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AutoLayoutCommandBase = void 0;
        var r = n(1922),
          s = n(3913),
          a = n(8408),
          c = n(6320),
          u = n(41),
          p = n(4412),
          h = n(4044),
          l = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), e.prototype.executeCore = function (t, e) {
              var n = this;
              this.control.history.beginTransaction();
              var o = this.getAffectedShapes(),
                i = this.getAffectedConnectors(),
                s = this.createLayoutSettings(),
                a = r.ModelUtils.getGraphInfoByItems(this.control.model, o, i, !1);
              if (a.length) {
                var c,
                  l = this.control.model,
                  d = u.GeometryUtils.getCommonRectangle(u.Utils.flatten(a.map(function (t) {
                    return t.graph.items.map(function (t) {
                      return l.findItem(t.key);
                    });
                  })).concat(a.map(function (t) {
                    return t.container;
                  })).filter(function (t) {
                    return t;
                  }).map(function (t) {
                    return t.rectangle;
                  }));
                this.control.history.addAndRedo(new h.ScrollIntoViewOnUndoHistoryItem(this.control.view, d)), a.forEach(function (t) {
                  var e = n.createLayout(s, t.graph),
                    a = r.ModelUtils.getNonGraphItems(n.control.model, t.container, e.nodeToLayout, o, i),
                    u = r.ModelUtils.applyLayout(n.control.history, n.control.model, t.container, t.graph, e, a, s, n.control.settings.snapToGrid, n.control.settings.gridSize, !1);
                  c = c && p.Rectangle.union(c, u) || u;
                }), r.ModelUtils.tryUpdateModelRectangle(this.control.history), this.control.history.addAndRedo(new h.ScrollIntoViewOnRedoHistoryItem(this.control.view, c));
              }
              return this.control.history.endTransaction(), !0;
            }, e.prototype.getAffectedShapes = function () {
              return this.control.selection.isEmpty() ? this.control.model.items.filter(function (t) {
                return t instanceof a.Shape && !t.locked;
              }) : this.control.selection.getSelectedShapes(!1, !0);
            }, e.prototype.getAffectedConnectors = function () {
              return this.control.selection.isEmpty() ? this.control.model.items.filter(function (t) {
                return t instanceof c.Connector && !t.locked;
              }) : this.control.selection.getSelectedConnectors(!1, !0);
            }, e;
          }(s.SimpleCommandBase);
        e.AutoLayoutCommandBase = l;
      },
      8716: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.DataSource = void 0;
        var o = n(9500),
          i = n(5327),
          r = n(3844),
          s = n(4139),
          a = n(4048),
          c = n(8214),
          u = n(6155),
          p = n(5685),
          h = n(2448),
          l = n(1914),
          d = n(9735),
          f = n(1684),
          y = n(472),
          g = n(6476),
          m = n(672),
          v = n(3550),
          P = n(5755),
          C = n(6320),
          S = n(1922),
          x = n(3255),
          b = n(5650),
          w = n(41),
          I = n(9553),
          T = n(2620),
          O = n(7768),
          _ = n(1842),
          E = n(3831),
          M = n(5206),
          D = n(8818),
          A = function () {
            function t(t, e, n, o, i, r) {
              if (this.key = t, this.nodes = [], this.edges = [], this.autoGeneratedDataKeys = {}, this.addInternalKeyOnInsert = !1, this.useNodeParentId = !1, this.useNodeContainerId = !1, this.useNodeChildren = !1, this.useNodeItems = !1, this.canUseAutoSize = !1, this.canUpdateEdgeDataSource = !1, this.containers = null, null == t) throw new Error("DataSource key must be specified");
              this.key = t.toString(), this.loadParameters(o || {}), this.nodeDataImporter = this.createNodeDataImporter(i), this.edgeDataImporter = this.createEdgeDataImporter(r), this.nodeDataSource = e || [], this.edgeDataSource = n || [], this.canUpdateEdgeDataSource = !!n, this.fetchData();
            }
            return t.prototype.loadParameters = function (t) {
              this.addInternalKeyOnInsert = !!t.addInternalKeyOnInsert;
            }, t.prototype.isAutoGeneratedKey = function (t) {
              return t && !!this.autoGeneratedDataKeys[t];
            }, t.prototype.createNodeDataImporter = function (t) {
              var e = new E.DataSourceNodeDataImporter();
              return t && this.assignNodeDataImporterProperties(t, e), e;
            }, t.prototype.createEdgeDataImporter = function (t) {
              var e = new E.DataSourceEdgeDataImporter();
              return t && this.assignEdgeDataImporterProperties(t, e), e;
            }, t.prototype.assignItemDataImporterProperties = function (t, e) {
              t.getKey && (e.getKey = t.getKey), t.setKey && (e.setKey = t.setKey), t.getCustomData && (e.getCustomData = t.getCustomData), t.setCustomData && (e.setCustomData = t.setCustomData), t.getLocked && (e.getLocked = t.getLocked), t.setLocked && (e.setLocked = t.setLocked), t.getStyle && (e.getStyle = t.getStyle), t.setStyle && (e.setStyle = t.setStyle), t.getStyleText && (e.getStyleText = t.getStyleText), t.setStyleText && (e.setStyleText = t.setStyleText), t.getZIndex && (e.getZIndex = t.getZIndex), t.setZIndex && (e.setZIndex = t.setZIndex);
            }, t.prototype.assignNodeDataImporterProperties = function (t, e) {
              this.assignItemDataImporterProperties(t, e), t.getType && (e.getType = t.getType), t.setType && (e.setType = t.setType), t.getImage && (e.getImage = t.getImage), t.setImage && (e.setImage = t.setImage), t.getText && (e.getText = t.getText), t.setText && (e.setText = t.setText), t.getLeft && (e.getLeft = t.getLeft), t.setLeft && (e.setLeft = t.setLeft), t.getTop && (e.getTop = t.getTop), t.setTop && (e.setTop = t.setTop), t.getWidth && (e.getWidth = t.getWidth), t.setWidth && (e.setWidth = t.setWidth), t.getHeight && (e.getHeight = t.getHeight), t.setHeight && (e.setHeight = t.setHeight), t.getChildren && (e.getChildren = t.getChildren), t.setChildren && (e.setChildren = t.setChildren), t.getParentKey && (e.getParentKey = t.getParentKey), t.setParentKey && (e.setParentKey = t.setParentKey), t.getItems && (e.getItems = t.getItems), t.setItems && (e.setItems = t.setItems), t.getContainerKey && (e.getContainerKey = t.getContainerKey), t.setContainerKey && (e.setContainerKey = t.setContainerKey);
            }, t.prototype.assignEdgeDataImporterProperties = function (t, e) {
              this.assignItemDataImporterProperties(t, e), t.getFrom && (e.getFrom = t.getFrom), t.setFrom && (e.setFrom = t.setFrom), t.getFromPointIndex && (e.getFromPointIndex = t.getFromPointIndex), t.setFromPointIndex && (e.setFromPointIndex = t.setFromPointIndex), t.getTo && (e.getTo = t.getTo), t.setTo && (e.setTo = t.setTo), t.getToPointIndex && (e.getToPointIndex = t.getToPointIndex), t.setToPointIndex && (e.setToPointIndex = t.setToPointIndex), t.getPoints && (e.getPoints = t.getPoints), t.setPoints && (e.setPoints = t.setPoints), t.getText && (e.getText = t.getText), t.setText && (e.setText = t.setText), t.getLineOption && (e.getLineOption = t.getLineOption), t.setLineOption && (e.setLineOption = t.setLineOption), t.getStartLineEnding && (e.getStartLineEnding = t.getStartLineEnding), t.setStartLineEnding && (e.setStartLineEnding = t.setStartLineEnding), t.getEndLineEnding && (e.getEndLineEnding = t.getEndLineEnding), t.setEndLineEnding && (e.setEndLineEnding = t.setEndLineEnding);
            }, t.prototype.fetchData = function () {
              var t = this;
              if (this.nodes = [], this.edges = [], this.autoGeneratedDataKeys = {}, this.useNodeParentId = void 0 !== this.nodeDataImporter.getParentKey, this.useNodeContainerId = void 0 !== this.nodeDataImporter.getContainerKey, this.useNodeItems = void 0 !== this.nodeDataImporter.getItems, this.useNodeChildren = void 0 !== this.nodeDataImporter.getChildren, this.canUseAutoSize = void 0 === this.nodeDataImporter.getWidth && void 0 !== this.nodeDataImporter.getText, this.useEdgesArray() && this.useNodeParentId) throw new Error("You cannot use edges array and parentKey simultaneously.");
              if (this.useEdgesArray() && this.useNodeItems) throw new Error("You cannot use edges array and items array simultaneously.");
              if (this.useNodeParentId && this.useNodeItems) throw new Error("You cannot use parentKey and items array simultaneously.");
              if (this.useNodeContainerId && this.useNodeChildren) throw new Error("You cannot use containerKey and children array simultaneously.");
              this.nodeDataSource.forEach(function (e) {
                t.addNode(e);
              }), this.useEdgesArray() ? this.edgeDataSource.forEach(function (e) {
                t.addEdge(e);
              }) : this.nodes.forEach(function (e) {
                t.addNodeEdgesByParentId(e);
              });
            }, t.prototype.isContainer = function (t) {
              var e = this;
              return !this.containers && this.useNodeContainerId && (this.containers = this.nodeDataSource.map(function (t) {
                return e.nodeDataImporter.getContainerKey(t);
              }).filter(function (t) {
                return null != t;
              }).reduce(function (t, e) {
                return t[e] = !0, t;
              }, {})), this.containers && this.containers[t];
            }, t.prototype.refetchData = function (t, e) {
              var n = this;
              this.nodeDataSource = t || this.nodeDataSource, this.edgeDataSource = e || this.edgeDataSource;
              var o = this.nodes.slice(),
                i = this.edges.slice();
              return this.fetchData(), {
                nodes: this.getItemChanges(o, this.nodes, function (t, e) {
                  return t.key === e.key || t.dataObj === e.dataObj;
                }),
                edges: this.getItemChanges(i, this.edges, function (t, e) {
                  return n.useNodeParentId || n.useNodeItems ? t.key === e.key || t.from === e.from && t.to === e.to : t.key === e.key || t.dataObj === e.dataObj;
                })
              };
            }, t.prototype.getItemChanges = function (t, e, n) {
              var o = this,
                i = t.filter(function (t) {
                  return o.containsItem(e, t, n);
                }),
                r = t.filter(function (t) {
                  return !o.containsItem(e, t, n);
                }),
                s = e.filter(function (e) {
                  return !o.containsItem(t, e, n);
                });
              return {
                remained: i.map(function (t) {
                  return t.key;
                }),
                remainedNewKeys: i.map(function (t) {
                  var o;
                  return null === (o = e.find(function (e) {
                    return n(t, e);
                  })) || void 0 === o ? void 0 : o.key;
                }),
                removed: r.map(function (t) {
                  return t.key;
                }),
                added: s.map(function (t) {
                  return t.key;
                })
              };
            }, t.prototype.containsItem = function (t, e, n) {
              var o = !1;
              return t.forEach(function (t) {
                !o && n(t, e) && (o = !0);
              }), o;
            }, t.prototype.useEdgesArray = function () {
              return Array.isArray(this.edgeDataSource) && (this.edgeDataSource.length || !(this.useNodeParentId || this.useNodeItems));
            }, t.prototype.addNode = function (t, e, n, o) {
              var i = this,
                r = this.nodeDataImporter.getChildren && this.nodeDataImporter.getChildren(t),
                s = r && Array.isArray(r) && r.length,
                a = s || this.isContainer(this.nodeDataImporter.getKey(t)),
                c = this.nodeDataImporter.getType && this.nodeDataImporter.getType(t) || a && x.ShapeTypes.VerticalContainer || x.ShapeTypes.Rectangle,
                u = this.nodeDataImporter.getText && (this.nodeDataImporter.getText(t) || ""),
                p = this.addNodeInternal(t, c, u, e, n, o);
              if (this.assignNodeProperties(p, t), s && r.forEach(function (e) {
                i.addNode(e, void 0, p.key, t);
              }), this.useNodeItems) {
                var h = this.nodeDataImporter.getItems(t);
                Array.isArray(h) && h.length && h.forEach(function (e) {
                  var r = i.addNode(e, t, n, o);
                  i.addEdgeInternal(void 0, p.key, r.key);
                });
              }
              return p;
            }, t.prototype.addNodeEdgesByParentId = function (t) {
              if (this.useNodeParentId) {
                var e = this.nodeDataImporter.getParentKey(t.dataObj);
                if (null != e) this.findNode(e) && this.addEdgeInternal(void 0, this.getNodeKey(t.dataObj, this.nodeDataImporter.getParentKey), this.getNodeKey(t.dataObj, this.nodeDataImporter.getKey));
              }
            }, t.prototype.addNodeInternal = function (t, e, n, o, i, r) {
              var s = this.nodeDataImporter.getKey(t),
                a = null != s ? s : S.ModelUtils.getGuidItemKey(),
                c = new M.DataSourceNodeItem(this.key, a, t, e, n, o, i, r);
              return this.nodes.push(c), null == s && (s = a, this.autoGeneratedDataKeys[a] = !0), c;
            }, t.prototype.addEdge = function (t) {
              var e = this.addEdgeInternal(t, this.getNodeKey(t, this.edgeDataImporter.getFrom), this.getNodeKey(t, this.edgeDataImporter.getTo));
              return this.assignEdgeProperties(e, t), e;
            }, t.prototype.addEdgeInternal = function (t, e, n) {
              var o = t && this.edgeDataImporter.getKey(t),
                i = null != o ? o : S.ModelUtils.getGuidItemKey(),
                r = new M.DataSourceEdgeItem(this.key, i, t, e, n);
              return this.edges.push(r), null == o && (o = i, this.autoGeneratedDataKeys[i] = !0), r;
            }, t.prototype.assignItemProperties = function (t, e, n) {
              if (n.getCustomData && (t.customData = w.ObjectUtils.cloneObject(n.getCustomData(e))), n.getLocked && (t.locked = n.getLocked(e)), n.getStyle) {
                var o = n.getStyle(e);
                t.style = "string" == typeof o ? T.Data.cssTextToObject(o) : o;
              }
              if (n.getStyleText) {
                o = n.getStyleText(e);
                t.styleText = "string" == typeof o ? T.Data.cssTextToObject(o) : o;
              }
              n.getZIndex && (t.zIndex = n.getZIndex(e));
            }, t.prototype.assignNodeProperties = function (t, e) {
              this.assignItemProperties(t, e, this.nodeDataImporter), this.nodeDataImporter.getImage && (t.image = this.nodeDataImporter.getImage(e)), this.nodeDataImporter.getLeft && (t.left = this.nodeDataImporter.getLeft(e)), this.nodeDataImporter.getTop && (t.top = this.nodeDataImporter.getTop(e)), this.nodeDataImporter.getWidth && (t.width = this.nodeDataImporter.getWidth(e)), this.nodeDataImporter.getHeight && (t.height = this.nodeDataImporter.getHeight(e)), this.nodeDataImporter.getContainerKey && (t.containerKey = this.nodeDataImporter.getContainerKey(e));
            }, t.prototype.assignEdgeProperties = function (t, e) {
              if (this.assignItemProperties(t, e, this.edgeDataImporter), this.edgeDataImporter.getFromPointIndex && (t.fromPointIndex = this.edgeDataImporter.getFromPointIndex(e)), this.edgeDataImporter.getToPointIndex && (t.toPointIndex = this.edgeDataImporter.getToPointIndex(e)), this.edgeDataImporter.getPoints && (t.points = this.edgeDataImporter.getPoints(e)), this.edgeDataImporter.getText) {
                var n = this.edgeDataImporter.getText(e);
                if (t.texts = {}, "object" == typeof n) {
                  for (var o in n) if (Object.prototype.hasOwnProperty.call(n, o)) {
                    var i = parseFloat(o),
                      r = n[o];
                    isNaN(i) || "string" != typeof r || "" === r || (i = Math.min(1, Math.max(0, i)), t.texts[i] = r);
                  }
                } else "string" == typeof n && "" !== n && (t.texts[C.CONNECTOR_DEFAULT_TEXT_POSITION] = n);
              }
              this.edgeDataImporter.getLineOption && (t.lineOption = this.edgeDataImporter.getLineOption(e)), this.edgeDataImporter.getStartLineEnding && (t.startLineEnding = this.edgeDataImporter.getStartLineEnding(e)), this.edgeDataImporter.getEndLineEnding && (t.endLineEnding = this.edgeDataImporter.getEndLineEnding(e));
            }, t.prototype.findNode = function (t) {
              return this.nodes.filter(function (e) {
                return void 0 !== t && e.key === t;
              })[0];
            }, t.prototype.findEdge = function (t) {
              return this.edges.filter(function (e) {
                return void 0 !== t && e.key === t;
              })[0];
            }, t.prototype.getNodeKey = function (t, e) {
              return e(t);
            }, t.prototype.createModelItems = function (t, e, n, o, r, s, a, c) {
              var u = this;
              this.beginChangesNotification(), t.clear(), t.beginTransaction(), S.ModelUtils.deleteAllItems(t, e, o), e.initializeKeyCounter();
              var p = s ? Math.max(1, Math.floor(2e3 / a)) * a : 2e3,
                h = 0,
                l = 0,
                d = {},
                f = [],
                y = [];
              this.nodes.forEach(function (y) {
                var g = new i.Point(l++ * p, h * p),
                  m = u.createShapeByNode(t, e, o, n, y, g, r, s, a, c);
                void 0 !== y.key && (d[y.key] = m.key), l > 4 && (l = 0, h++), f.push(m);
              }), this.nodes.forEach(function (n) {
                if (void 0 !== n.containerKey && null !== n.containerKey) {
                  var o = d[n.key],
                    i = e.findShape(o),
                    r = d[n.containerKey],
                    s = e.findShape(r);
                  s && S.ModelUtils.insertToContainer(t, e, i, s);
                }
              }), this.edges.forEach(function (n) {
                var i = e.findShape(d[n.to]),
                  r = e.findShape(d[n.from]),
                  s = u.createConnectorByEdge(t, e, o, n, r, i);
                s && (y.push(s), S.ModelUtils.updateConnectorContainer(t, e, s));
              }), r.needAutoLayout && this.applyLayout(t, e, f, y, r, s, a), S.ModelUtils.tryUpdateModelRectangle(t), t.endTransaction(!0), this.endChangesNotification(!0);
            }, t.prototype.updateModelItems = function (t, e, n, o, r, s, a, c, u, p, h, l) {
              var d = this;
              this.beginChangesNotification(), t.beginTransaction();
              var f = [],
                y = [],
                g = [],
                m = u.nodes.removed.map(function (t) {
                  return e.findShapeByDataKey(t);
                }).filter(function (t) {
                  return t;
                });
              m.forEach(function (t) {
                t.attachedConnectors.forEach(function (e) {
                  e.beginItem && e.beginItem !== t && y.push(e.beginItem), e.endItem && e.endItem !== t && y.push(e.endItem);
                });
              }), S.ModelUtils.deleteItems(t, e, o, m, !0);
              var v = u.edges.removed.map(function (t) {
                return e.findConnectorByDataKey(t);
              }).filter(function (t) {
                return t;
              });
              v.forEach(function (t) {
                t.beginItem && y.push(t.beginItem), t.endItem && y.push(t.endItem);
              }), S.ModelUtils.deleteItems(t, e, o, v, !0), y = this.purgeLayoutShapes(y, m), (a || []).forEach(function (s) {
                if (-1 !== u.nodes.remained.indexOf(s)) {
                  var a = d.findNode(s);
                  if (a) {
                    var c = e.findShapeByDataKey(s);
                    if (c) {
                      var g = c.position.clone();
                      d.changeShapeByDataItem(t, e, c, a, g), d.changeItemByDataItem(t, c, a);
                    } else c = d.createShapeByNode(t, e, o, n, a, new i.Point(0, 0), r, p, h, l);
                    d.updateShapeContainer(t, e, c, a), y.push(c), f.push(c);
                  }
                }
              }), u.nodes.remained.forEach(function (t, n) {
                var o = e.findShapeByDataKey(t);
                o && (o.dataKey = u.nodes.remainedNewKeys[n]);
              }), u.nodes.added.forEach(function (s) {
                var a = d.findNode(s),
                  c = d.createShapeByNode(t, e, o, n, a, new i.Point(0, 0), r, p, h, l);
                d.updateShapeContainer(t, e, c, a), y.push(c);
              }), u.edges.added.forEach(function (n) {
                var i = d.findEdge(n),
                  r = e.findShapeByDataKey(i.from),
                  s = e.findShapeByDataKey(i.to),
                  a = d.createConnectorByEdge(t, e, o, i, r, s);
                a && (S.ModelUtils.updateConnectorContainer(t, e, a), g.push(a));
              });
              var P = a || [];
              u.edges.remained.forEach(function (t) {
                var e = d.findEdge(t);
                !e || -1 === u.nodes.added.indexOf(e.from) && -1 === u.nodes.added.indexOf(e.to) || P.push(t);
              }), P.forEach(function (n) {
                if (-1 !== u.edges.remained.indexOf(n)) {
                  var i = d.findEdge(n);
                  if (i) {
                    var r = e.findShapeByDataKey(i.from),
                      s = e.findShapeByDataKey(i.to),
                      a = e.findConnectorByDataKey(n);
                    a ? (d.changeConnectorPointsByDataItem(t, a, d.getConnectorPointsByEdge(e, i, r, s, !1)), d.changeConnectorByDataItem(t, e, a, r, s, i), d.changeItemByDataItem(t, a, i)) : a = d.createConnectorByEdge(t, e, o, i, r, s), a && (S.ModelUtils.updateConnectorContainer(t, e, a), g.push(a), f.push(a));
                  }
                }
              }), u.edges.remained.forEach(function (t, n) {
                var o = e.findConnectorByDataKey(t);
                o && (o.dataKey = u.edges.remainedNewKeys[n]);
              }), f.length && c && f.forEach(function (t) {
                t.hasTemplate && c(t);
              }), r.needAutoLayout && (y.length || g.length) && this.applyLayout(t, e, y, g, r, p, h), S.ModelUtils.tryUpdateModelRectangle(t), t.endTransaction(!s), this.endChangesNotification(!1);
            }, t.prototype.purgeLayoutShapes = function (t, e) {
              var n = e.reduce(function (t, e) {
                return (t[e.key] = !0) && t;
              }, {});
              return t.reduce(function (t, e) {
                return void 0 === t.keySet[e.key] && void 0 === n[e.key] && (t.uniqueShapes.push(e), t.keySet[e.key] = !0), t;
              }, {
                uniqueShapes: [],
                keySet: {}
              }).uniqueShapes;
            }, t.prototype.applyShapeAutoSize = function (t, e, n, i, s, a) {
              if (i.description.enableText) {
                var c = i.textRectangle.createSize(),
                  u = i.size,
                  h = c.width - u.width,
                  l = c.height - u.height,
                  d = i.getMaxWidth(n.shapeMaxWidth),
                  f = i.getMaxHeight(n.shapeMaxHeight),
                  y = function (t, e) {
                    return "number" == typeof t ? o.UnitConverter.twipsToPixelsF(t + (e ? h : l)) : void 0;
                  },
                  g = (0, _.getOptimalTextRectangle)(i.text, i.styleText, b.TextOwner.Shape, e, c.clone().applyConverter(o.UnitConverter.twipsToPixelsF), i.description.keepRatioOnAutoSize, y(i.getMinWidth(n.shapeMinWidth), !0), y(d, !0), y(i.getMinHeight(n.shapeMinHeight), !1), y(f, !1)).clone().applyConverter(o.UnitConverter.pixelsToTwips);
                if (!g.equals(c)) {
                  var m = i.description.getSizeByText(g, i);
                  s && a && (m = new r.Size(Math.min(a * Math.ceil(m.width / a), d || Number.MAX_VALUE), Math.min(a * Math.ceil(m.height / a), f || Number.MAX_VALUE))), t.addAndRedo(new p.ResizeShapeHistoryItem(i.key, i.position, m));
                }
              }
            }, t.prototype.applyLayout = function (t, e, n, o, i, r, s) {
              S.ModelUtils.getGraphInfoByItems(e, n, o).forEach(function (a) {
                var c = i.getLayoutBuilder(a.graph).build(),
                  u = S.ModelUtils.getNonGraphItems(e, a.container, c.nodeToLayout, n, o);
                S.ModelUtils.applyLayout(t, e, a.container, a.graph, c, u, i.layoutSettings, r, s, i.skipPointIndices);
              });
            }, t.prototype.changeItemByDataItem = function (t, e, n) {
              if (void 0 === n.customData || w.ObjectUtils.compareObjects(n.customData, e.customData) || t.addAndRedo(new d.ChangeCustomDataHistoryItem(e.key, n.customData)), void 0 !== n.zIndex && n.zIndex !== e.zIndex && t.addAndRedo(new m.ChangeZindexHistoryItem(e, n.zIndex)), void 0 !== n.style) for (var o in n.style) {
                if (Object.prototype.hasOwnProperty.call(n.style, o)) (r = this.getPreparedStyleValue(n.style[o], (0, O.isColorProperty)(o))) !== e.style[o] && t.addAndRedo(new v.ChangeStyleHistoryItem(e.key, o, r));
              }
              var i = e.style.getDefaultInstance();
              if (e.style.forEach(function (o) {
                n.style && void 0 === n.style[o] && e.style[o] !== i[o] && t.addAndRedo(new v.ChangeStyleHistoryItem(e.key, o, i[o]));
              }), void 0 !== n.styleText) for (var o in n.styleText) {
                var r;
                if (Object.prototype.hasOwnProperty.call(n.styleText, o)) (r = this.getPreparedStyleValue(n.styleText[o], (0, O.isColorProperty)(o))) !== e.styleText[o] && t.addAndRedo(new P.ChangeStyleTextHistoryItem(e.key, o, r));
              }
              var s = e.styleText.getDefaultInstance();
              e.styleText.forEach(function (o) {
                n.styleText && void 0 === n.styleText[o] && e.styleText[o] !== s[o] && t.addAndRedo(new P.ChangeStyleTextHistoryItem(e.key, o, s[o]));
              }), void 0 !== n.locked && n.locked !== e.locked && t.addAndRedo(new f.ChangeLockedHistoryItem(e, n.locked));
            }, t.prototype.getPreparedStyleValue = function (t, e) {
              if (e) {
                var n = I.ColorUtils.stringToHash(t);
                null !== n && (t = n);
              }
              return t;
            }, t.prototype.createShapeByNode = function (t, e, n, o, i, r, s, a, u, p) {
              var h = new c.AddShapeHistoryItem(o.get(i.type), r, "", i.key);
              t.addAndRedo(h);
              var l = e.findShape(h.shapeKey);
              return S.ModelUtils.updateNewShapeProperties(t, n, h.shapeKey), this.changeShapeByDataItem(t, e, l, i, r), this.changeItemByDataItem(t, l, i), p && this.canUseAutoSize && s.autoSizeEnabled && this.applyShapeAutoSize(t, p, s.sizeSettings, l, a, u), l;
            }, t.prototype.changeShapeByDataItem = function (t, e, n, o, i) {
              var r = !1;
              void 0 !== o.left && (i.x = S.ModelUtils.getTwipsValue(e.units, o.left)), void 0 !== o.top && (i.y = S.ModelUtils.getTwipsValue(e.units, o.top)), r = S.ModelUtils.setShapePosition(t, e, n, i, !1) || r, void 0 !== o.type && (r = S.ModelUtils.changeShapeType(t, e, n, o.type) || r);
              var s = n.size.clone();
              void 0 !== o.width && (s.width = S.ModelUtils.getTwipsValue(e.units, o.width)), void 0 !== o.height && (s.height = S.ModelUtils.getTwipsValue(e.units, o.height)), (r = S.ModelUtils.setShapeSize(t, e, n, i, s) || r) && S.ModelUtils.updateShapeAttachedConnectors(t, e, n), void 0 !== o.text && o.text !== n.text && t.addAndRedo(new g.ChangeShapeTextHistoryItem(n, o.text)), void 0 !== o.image && o.image !== n.image.actualUrl && t.addAndRedo(new y.ChangeShapeImageHistoryItem(n, o.image));
            }, t.prototype.updateShapeContainer = function (t, e, n, o) {
              var i = void 0 !== o.containerKey ? e.findShapeByDataKey(o.containerKey) : void 0;
              i !== n.container && (i ? S.ModelUtils.insertToContainer(t, e, n, i) : S.ModelUtils.removeFromContainer(t, e, n));
            }, t.prototype.getConnectorPointsByEdge = function (t, e, n, o, i) {
              var r = [],
                s = this.createModelPointFromDataSourceEdgeItemPoints(t.units, e);
              if (s && s.length > 1) for (var a = s.length - 1, c = 0; c <= a; c++) {
                var u = s[c];
                if (null !== u) r.push(u);else {
                  if (!n && !o) return;
                  0 === c && n ? r.push(n.position.clone()) : c === a && o && r.push(o.position.clone());
                }
              } else i && (n && r.push(n.position.clone()), o && r.push(o.position.clone()));
              return r;
            }, t.prototype.createModelPointFromDataSourceEdgeItemPoints = function (t, e) {
              var n = this,
                o = [];
              if (Array.isArray(e.points)) return e.points.forEach(function (e) {
                return o.push(n.isValidDataSourceEdgeItemPoint(e) ? n.createModelPoint(t, e) : null);
              }), o;
            }, t.prototype.createModelPoint = function (t, e) {
              return new i.Point(S.ModelUtils.getTwipsValue(t, e.x), S.ModelUtils.getTwipsValue(t, e.y));
            }, t.prototype.isValidDataSourceEdgeItemPoint = function (t) {
              return null != t && void 0 !== t.x && void 0 !== t.y && null !== t.x && null !== t.y;
            }, t.prototype.createConnectorByEdge = function (t, e, n, o, i, r) {
              var s,
                c = o.key,
                u = this.getConnectorPointsByEdge(e, o, i, r, !0);
              if (u && u.length > 1) {
                var p = new a.AddConnectorHistoryItem(u, c);
                t.addAndRedo(p), s = e.findConnector(p.connectorKey), S.ModelUtils.updateNewConnectorProperties(t, n, p.connectorKey), this.changeConnectorByDataItem(t, e, s, i, r, o), this.changeItemByDataItem(t, s, o);
              }
              return s;
            }, t.prototype.changeConnectorByDataItem = function (t, e, n, o, i, r) {
              var a = void 0 !== r.fromPointIndex ? r.fromPointIndex : n.beginConnectionPointIndex;
              n.beginItem === o && n.beginConnectionPointIndex === a || (n.beginItem && t.addAndRedo(new u.DeleteConnectionHistoryItem(n, C.ConnectorPosition.Begin)), o && t.addAndRedo(new s.AddConnectionHistoryItem(n, o, a, C.ConnectorPosition.Begin)));
              var c = void 0 !== r.toPointIndex ? r.toPointIndex : n.endConnectionPointIndex;
              if (n.endItem === i && n.endConnectionPointIndex === c || (n.endItem && t.addAndRedo(new u.DeleteConnectionHistoryItem(n, C.ConnectorPosition.End)), i && t.addAndRedo(new s.AddConnectionHistoryItem(n, i, c, C.ConnectorPosition.End))), S.ModelUtils.updateConnectorAttachedPoints(t, e, n), void 0 !== r.texts && !this.compareTexts(r, n)) for (var p in n.texts.forEach(function (e) {
                t.addAndRedo(new l.ChangeConnectorTextHistoryItem(n, e.position, void 0));
              }), r.texts) if (Object.prototype.hasOwnProperty.call(r.texts, p)) {
                var d = parseFloat(p);
                t.addAndRedo(new l.ChangeConnectorTextHistoryItem(n, d, r.texts[p]));
              }
              void 0 !== r.lineOption && r.lineOption !== n.properties.lineOption && t.addAndRedo(new h.ChangeConnectorPropertyHistoryItem(n.key, "lineOption", r.lineOption)), void 0 !== r.startLineEnding && r.startLineEnding !== n.properties.startLineEnding && t.addAndRedo(new h.ChangeConnectorPropertyHistoryItem(n.key, "startLineEnding", r.startLineEnding)), void 0 !== r.endLineEnding && r.endLineEnding !== n.properties.endLineEnding && t.addAndRedo(new h.ChangeConnectorPropertyHistoryItem(n.key, "endLineEnding", r.endLineEnding));
            }, t.prototype.changeConnectorPointsByDataItem = function (t, e, n) {
              n && n.length > 1 && n.join(",") !== e.points.join(",") && t.addAndRedo(new D.ReplaceConnectorPointsHistoryItem(e.key, n));
            }, t.prototype.compareTexts = function (t, e) {
              var n = t.texts || {},
                o = Object.keys(n).length === e.getTextCount();
              if (o) for (var i in n) if (Object.prototype.hasOwnProperty.call(n, i)) {
                var r = parseFloat(i);
                this.compareStrings(e.getText(r), n[i]) || (o = !1);
              }
              return o;
            }, t.prototype.compareStrings = function (t, e) {
              return "string" == typeof t && "string" == typeof e ? t === e : this.isEmptyString(t) && this.isEmptyString(e);
            }, t.prototype.isEmptyString = function (t) {
              return "" === t || null == t;
            }, t;
          }();
        e.DataSource = A;
      },
      8762: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Exporter = void 0;
        var o = n(8408),
          i = n(6320),
          r = n(41),
          s = function () {
            function t() {}
            return t.prototype.export = function (t) {
              var e = {
                page: {},
                connectors: [],
                shapes: []
              };
              return e.page = {
                width: t.size.width,
                height: t.size.height,
                pageColor: t.pageColor,
                pageWidth: t.pageSize.width,
                pageHeight: t.pageSize.height,
                pageLandscape: t.pageLandscape
              }, this.exportItemsCore(t.items, e), JSON.stringify(e);
            }, t.prototype.exportItems = function (t) {
              var e = {
                connectors: [],
                shapes: []
              };
              return this.exportItemsCore(t, e), JSON.stringify(e);
            }, t.prototype.exportItemsCore = function (t, e) {
              var n = this;
              t.forEach(function (t) {
                if (t instanceof o.Shape) e.shapes.push(n.exportShape(t));else if (t instanceof i.Connector) {
                  var r = n.exportConnector(t);
                  t.beginItem && (r.beginItemKey = t.beginItem.key, r.beginConnectionPointIndex = t.beginConnectionPointIndex), t.endItem && (r.endItemKey = t.endItem.key, r.endConnectionPointIndex = t.endConnectionPointIndex), e.connectors.push(r);
                }
              });
            }, t.prototype.exportItem = function (t) {
              return {
                key: t.key,
                dataKey: t.dataKey,
                customData: r.ObjectUtils.cloneObject(t.customData),
                locked: t.locked,
                zIndex: t.zIndex
              };
            }, t.prototype.exportShape = function (t) {
              var e = this.exportItem(t);
              e.type = t.description.key, e.text = t.text, t.image.isEmpty || (e.imageUrl = t.image.exportUrl), e.x = t.position.x, e.y = t.position.y, e.width = t.size.width, e.height = t.size.height;
              var n = t.parameters.toObject();
              n && (e.parameters = n);
              var o = t.style.toObject();
              o && (e.style = o);
              var i = t.styleText.toObject();
              return i && (e.styleText = i), t.children.length && (e.childKeys = t.children.map(function (t) {
                return t.key;
              })), t.expanded || (e.expanded = !1), t.expandedSize && (e.expandedWidth = t.expandedSize.width, e.expandedHeight = t.expandedSize.height), e;
            }, t.prototype.exportConnector = function (t) {
              var e = this.exportItem(t);
              e.points = t.points.map(function (t) {
                return {
                  x: t.x,
                  y: t.y
                };
              });
              var n = t.texts.toObject();
              n && (e.texts = n);
              var o = t.properties.toObject();
              o && (e.properties = o);
              var i = t.style.toObject();
              i && (e.style = i);
              var r = t.styleText.toObject();
              r && (e.styleText = r);
              var s = t.tryCreateRenderPointsContext();
              return s && (e.context = s.toObject()), e;
            }, t.prototype.exportSvg = function (t, e, n, o) {
              n.exportSvgImage(t, e, o);
            }, t.prototype.exportPng = function (t, e, n, o, i) {
              n.exportPngImage(t, e, o, i);
            }, t.prototype.exportJpg = function (t, e, n, o, i) {
              n.exportJpgImage(t, e, o, i);
            }, t;
          }();
        e.Exporter = s;
      },
      8818: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ReplaceConnectorPointsHistoryItem = e.ChangeConnectorPointsHistoryItem = e.UpdateConnectorPointsHistoryItem = void 0;
        var r = function (t) {
          function e(e, n) {
            var o = t.call(this) || this;
            return o.connectorKey = e, o.newPoints = n, o;
          }
          return i(e, t), e.prototype.redo = function (t) {
            var e = this,
              n = t.model.findConnector(this.connectorKey);
            this.oldRenderContext = n.tryCreateRenderPointsContext(), this.oldPoints = n.points.map(function (t) {
              return t.clone();
            }), t.changeConnectorPoints(n, function (t) {
              t.points = e.newPoints, e.updateRenderPoints(t);
            });
          }, e.prototype.undo = function (t) {
            var e = this,
              n = t.model.findConnector(this.connectorKey);
            t.changeConnectorPoints(n, function (t) {
              t.points = e.oldPoints, t.replaceRenderPoints(e.oldRenderContext);
            });
          }, e;
        }(n(2616).HistoryItem);
        e.UpdateConnectorPointsHistoryItem = r;
        var s = function (t) {
          function e(e, n, o) {
            var i = t.call(this, e, n) || this;
            return i.connectorKey = e, i.newPoints = n, i.newRenderContext = o, i;
          }
          return i(e, t), e.prototype.updateRenderPoints = function (t) {
            t.replaceRenderPoints(this.newRenderContext);
          }, e;
        }(r);
        e.ChangeConnectorPointsHistoryItem = s;
        var a = function (t) {
          function e(e, n) {
            var o = t.call(this, e, n) || this;
            return o.connectorKey = e, o.newPoints = n, o;
          }
          return i(e, t), e.prototype.updateRenderPoints = function (t) {
            t.clearRenderPoints();
          }, e;
        }(r);
        e.ReplaceConnectorPointsHistoryItem = a;
      },
      8827: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AutoLayoutLayeredVerticalCommand = void 0;
        var r = n(8674),
          s = n(2626),
          a = n(9212),
          c = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), e.prototype.createLayoutSettings = function () {
              var t = new a.LayoutSettings();
              return t.orientation = a.DataLayoutOrientation.Vertical, t;
            }, e.prototype.createLayout = function (t, e) {
              return new s.SugiyamaLayoutBuilder(t, e).build();
            }, e;
          }(r.AutoLayoutCommandBase);
        e.AutoLayoutLayeredVerticalCommand = c;
      },
      8912: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ChangePageLandscapeHistoryItem = void 0;
        var r = function (t) {
          function e(e) {
            var n = t.call(this) || this;
            return n.value = e, n;
          }
          return i(e, t), e.prototype.redo = function (t) {
            this.oldValue = t.model.pageLandscape, t.changePageLandscape(this.value);
          }, e.prototype.undo = function (t) {
            t.changePageLandscape(this.oldValue);
          }, e;
        }(n(2616).HistoryItem);
        e.ChangePageLandscapeHistoryItem = r;
      },
      9030: (t, e) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.EncodeUtils = void 0;
        var n = function () {
          function t() {}
          return t.encodeHtml = function (t) {
            return t.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
          }, t.decodeHtml = function (t) {
            return t.replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&amp;/g, "&");
          }, t.prepareTextForRequest = function (t) {
            return t.replace(/%/g, "%25").replace(/&/g, "%26amp;").replace(/\+/g, "%2B").replace(/</g, "%26lt;").replace(/>/g, "%26gt;").replace(/"/g, "%26quot;");
          }, t.prepareTextForCallBackRequest = function (t) {
            return t.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
          }, t.decodeViaTextArea = function (t) {
            var e = document.createElement("TEXTAREA");
            return e.innerHTML = t, e.value;
          }, t;
        }();
        e.EncodeUtils = n;
      },
      9049: (t, e) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ConnectorProhibitedSegments = void 0;
        var n = function () {
          function t() {
            this.segments = [], this.exludedPoints = {};
          }
          return t.prototype.addSegment = function (t) {
            this.segments.push(t);
          }, t.prototype.addExludedPoint = function (t) {
            this.exludedPoints[t.x + "_" + t.y] = !0;
          }, t.prototype.allowPoint = function (t) {
            if (!(t.x + "_" + t.y in this.exludedPoints)) for (var e = 0; e < this.segments.length; e++) if (this.segments[e].containsPoint(t)) return !1;
            return !0;
          }, t;
        }();
        e.ConnectorProhibitedSegments = n;
      },
      9066: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ChangePageSizeHistoryItem = void 0;
        var r = function (t) {
          function e(e) {
            var n = t.call(this) || this;
            return n.size = e, n;
          }
          return i(e, t), e.prototype.redo = function (t) {
            this.oldSize = t.model.pageSize, t.changePageSize(this.size);
          }, e.prototype.undo = function (t) {
            t.changePageSize(this.oldSize);
          }, e;
        }(n(2616).HistoryItem);
        e.ChangePageSizeHistoryItem = r;
      },
      9071: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.GraphIterator = e.FastGraph = e.Graph = void 0;
        var r = n(8573),
          s = n(8408),
          a = n(124),
          c = n(6961),
          u = function () {
            function t(t, e) {
              this.nodeMap = {}, this.edgeMap = {}, this.nodes = [], this.edges = [], this.onInit(), t.forEach(this.addNode.bind(this)), e.forEach(this.addEdge.bind(this));
            }
            return Object.defineProperty(t.prototype, "items", {
              get: function () {
                return this.nodes.map(this.getNode.bind(this));
              },
              enumerable: !1,
              configurable: !0
            }), t.prototype.onInit = function () {}, t.prototype.addEdge = function (t) {
              this.edgeMap[t.key] = t, this.edges.push(t);
            }, t.prototype.addNode = function (t) {
              this.nodeMap[t.key] = t, this.nodes.push(t.key);
            }, t.prototype.getNode = function (t) {
              return this.nodeMap[t];
            }, t.prototype.getEdge = function (t) {
              return this.edgeMap[t];
            }, t.prototype.isEmpty = function () {
              return !this.nodes.length && !this.edges.length;
            }, t.prototype.getAdjacentEdges = function (t, e) {
              return void 0 === e && (e = r.ConnectionMode.OutgoingAndIncoming), this.edges.filter(function (n) {
                return e & r.ConnectionMode.Incoming && n.to === t || e & r.ConnectionMode.Outgoing && n.from === t;
              });
            }, t;
          }(),
          p = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), e.prototype.cast = function (t, n) {
              var o = this;
              return new e(this.nodes.map(function (e) {
                return t(o.getNode(e));
              }), this.edges.map(function (t) {
                return n ? n(t) : t;
              }));
            }, e.prototype.getConnectedComponents = function () {
              var t = this.createIterator(r.ConnectionMode.OutgoingAndIncoming);
              t.visitEachEdgeOnce = !0;
              for (var n = [], o = function (o) {
                  var r = [],
                    s = [];
                  t.onNode = function (t) {
                    return r.push(t);
                  }, t.onEdge = function (t) {
                    return s.push(t);
                  }, t.iterate(i.nodes[o]), r.length && n.push(new e(r, s));
                }, i = this, s = 0; s < this.nodes.length; s++) o(s);
              return n;
            }, e.prototype.createIterator = function (t) {
              var e = new l(this, t);
              return e.comparer = function (t, e) {
                return t.weight - e.weight;
              }, e;
            }, e.prototype.getSpanningGraph = function (t, n, o) {
              var i = this;
              if (void 0 === o && (o = void 0), !this.nodes.length) return new e([], []);
              o || (o = function (t) {
                return t.weight;
              });
              var r = [],
                s = new c.HashSet(),
                a = new c.HashSet([], function (t) {
                  return t.getHashKey();
                });
              for (this.addNodeToSpanningGraph(t, n, r, s, a, o); r.length && s.length !== this.nodes.length;) {
                var u = r.shift();
                a.tryPush(u);
                var p = s.contains(u.from) ? u.to : u.from;
                this.addNodeToSpanningGraph(p, n, r, s, a, o), r = r.filter(function (t) {
                  return !s.contains(t.from) || !s.contains(t.to);
                });
              }
              return new e(s.list().map(function (t) {
                return i.getNode(t);
              }), a.list());
            }, e.prototype.addNodeToSpanningGraph = function (t, e, n, o, i, s) {
              o.tryPush(t), this.getAdjacentEdges(t, e).filter(function (t) {
                return !i.contains(t);
              }).forEach(function (t) {
                var e = s(t),
                  o = a.SearchUtils.binaryIndexOf(n, function (t) {
                    return t.weight - e;
                  });
                for (o = o < 0 ? ~o : o; o < n.length && s(n[o]) === e;) o++;
                n.splice(o, 0, new r.Edge(t.key, t.from, t.to, e));
              });
            }, e.create = function (t, n) {
              return new e(t, n.filter(function (t) {
                return t.beginItem && t.endItem instanceof s.Shape && t.endItem && t.endItem instanceof s.Shape && t.beginItem !== t.endItem;
              }).map(function (t) {
                return new r.Edge(t.key, t.beginItem && t.beginItem.key, t.endItem && t.endItem.key);
              }));
            }, e;
          }(u);
        e.Graph = p;
        var h = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(e, t), e.prototype.onInit = function () {
            this.parentToChildren = {}, this.childToParents = {};
          }, e.prototype.addEdge = function (e) {
            t.prototype.addEdge.call(this, e), (this.parentToChildren[e.from] || (this.parentToChildren[e.from] = [])).push(e.to), (this.childToParents[e.to] || (this.childToParents[e.to] = [])).push(e.from);
          }, e.prototype.getChildren = function (t) {
            return this.parentToChildren[t] || [];
          }, e.prototype.getParents = function (t) {
            return this.childToParents[t] || [];
          }, e.prototype.createIterator = function (t) {
            return new l(this, t);
          }, e;
        }(u);
        e.FastGraph = h;
        var l = function () {
          function t(t, e) {
            void 0 === e && (e = r.ConnectionMode.OutgoingAndIncoming), this.graph = t, this.connectionMode = e, this.visitEachEdgeOnce = !0, this.visitEachNodeOnce = !0, this.visitedNodes = {}, this.visitedEdges = {};
          }
          return t.prototype.iterate = function (t) {
            if (!this.visitEachNodeOnce && !this.visitEachEdgeOnce && !this.skipNode) throw "skipNode or visitEachNodeOnce or visitEachEdgeOnce must be set to avoid SOF";
            this.iterateCore(t);
          }, t.prototype.iterateCore = function (t) {
            var e = this,
              n = this.graph.getNode(t);
            if (!(!n || this.skipNode && this.skipNode(n) || this.visitEachNodeOnce && this.isNodeVisited(t))) {
              this.visitedNodes[t] = !0, this.onNode && this.onNode(n);
              var o = this.graph.getAdjacentEdges(t, this.connectionMode);
              if (this.skipEdge && (o = o.filter(function (t) {
                return !e.skipEdge(t);
              })), this.connectionMode & r.ConnectionMode.Outgoing) {
                var i = o.filter(function (e) {
                  return e.from === t;
                });
                this.comparer && i.sort(this.comparer), i.forEach(function (t) {
                  e.visitEachEdgeOnce && e.visitedEdges[t.key] || (e.visitedEdges[t.key] = !0, e.onEdge && e.onEdge(t, !0), e.iterateCore(t.to), e.onAfterEdge && e.onAfterEdge(t, !0));
                });
              }
              if (this.onAllEdges && this.onAllEdges(n, !0), this.connectionMode & r.ConnectionMode.Incoming) {
                var s = o.filter(function (e) {
                  return e.to === t;
                });
                this.comparer && s.sort(this.comparer), s.forEach(function (t) {
                  e.visitEachEdgeOnce && e.visitedEdges[t.key] || (e.visitedEdges[t.key] = !0, e.onEdge && e.onEdge(t, !1), e.iterateCore(t.from), e.onAfterEdge && e.onAfterEdge(t, !1));
                });
              }
              this.onAllEdges && this.onAllEdges(n, !1);
            }
          }, t.prototype.isNodeVisited = function (t) {
            return !!this.visitedNodes[t];
          }, t.prototype.isEdgeVisited = function (t) {
            return !!this.visitedEdges[t];
          }, t;
        }();
        e.GraphIterator = l;
      },
      9090: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ArrowHorizontalShapeDescription = e.ArrowVerticalLineHeightParameterName = e.ArrowVerticalTriangleWidthParameterName = void 0;
        var r = n(1280),
          s = n(3844),
          a = n(4636),
          c = n(4824);
        e.ArrowVerticalTriangleWidthParameterName = "tw", e.ArrowVerticalLineHeightParameterName = "lh";
        var u = function (t) {
          function n() {
            return t.call(this, new s.Size(r.ShapeDefaultDimension, .375 * r.ShapeDefaultDimension)) || this;
          }
          return i(n, t), Object.defineProperty(n.prototype, "keepRatioOnAutoSize", {
            get: function () {
              return !1;
            },
            enumerable: !1,
            configurable: !0
          }), n.prototype.createParameters = function (t) {
            t.addRangeIfNotExists([new a.ShapeParameter(e.ArrowVerticalTriangleWidthParameterName, Math.sqrt(Math.pow(this.defaultSize.height, 2) - Math.pow(this.defaultSize.height / 2, 2))), new a.ShapeParameter(e.ArrowVerticalLineHeightParameterName, this.defaultSize.height / 3)]);
          }, n.prototype.normalizeParameters = function (t, n) {
            this.changeParameterValue(n, e.ArrowVerticalTriangleWidthParameterName, function (e) {
              return Math.max(0, Math.min(t.size.width, e.value));
            }), this.changeParameterValue(n, e.ArrowVerticalLineHeightParameterName, function (e) {
              return Math.max(0, Math.min(t.size.height, e.value));
            });
          }, n.prototype.processConnectionPoint = function (t, n) {
            var o = (t.size.height - t.parameters.get(e.ArrowVerticalLineHeightParameterName).value) / 2,
              i = t.getConnectionPointSide(n);
            i === c.ConnectionPointSide.North ? n.y += o : i === c.ConnectionPointSide.South && (n.y -= o);
          }, n.prototype.getTextRectangle = function (t) {
            return t.rectangle.clone().inflate(-r.ShapeTextPadding, -r.ShapeTextPadding);
          }, n.prototype.getSizeByText = function (t, e) {
            return t.clone().offset(2 * r.ShapeTextPadding, 2 * r.ShapeTextPadding);
          }, n;
        }(r.ShapeDescription);
        e.ArrowHorizontalShapeDescription = u;
      },
      9157: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MouseHandlerDefaultReadOnlyState = void 0;
        var r = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(e, t), e.prototype.canDragObjectOnMouseDown = function (t) {
            return !1;
          }, e.prototype.canExpandContainerOnMouseDown = function (t) {
            return !1;
          }, e.prototype.canClearSelectionOnMouseDown = function () {
            return !1;
          }, e.prototype.canSelectOnMouseUp = function (t) {
            return !0;
          }, e.prototype.canClearSelectionOnMouseUp = function () {
            return !0;
          }, e.prototype.updateConnectionsOnMouseMove = function (t) {}, e;
        }(n(9550).MouseHandlerDefaultStateBase);
        e.MouseHandlerDefaultReadOnlyState = r;
      },
      9185: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SelectAllCommand = void 0;
        var r = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(e, t), e.prototype.isEnabledInReadOnlyMode = function () {
            return !0;
          }, e.prototype.executeCore = function (t, e) {
            var n = [];
            return this.control.model.iterateItems(function (t) {
              return n.push(t.key);
            }), this.control.selection.set(n), !0;
          }, e;
        }(n(3913).SimpleCommandBase);
        e.SelectAllCommand = r;
      },
      9196: (t, e) => {
        var n;
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Diagnostics = void 0, function (t) {
          t[t.Disabled = 0] = "Disabled", t[t.Console = 1] = "Console", t[t.Document = 2] = "Document";
        }(n || (n = {}));
        var o = function () {
          function t() {}
          return t.beginAverage = function (t) {
            this.enableLogsAndTimers && (this.lastAverageGroupName = t);
          }, t.endAverage = function () {
            this.enableLogsAndTimers && (this.lastAverageGroupName = null);
          }, t.tryLogAverage = function (t) {
            var e = this;
            if (this.lastAverageGroupName !== t) {
              var n = Object.keys(this.timers).map(function (t) {
                return e.timers[t];
              }).filter(function (e) {
                return e.groupName === t;
              });
              if (!n.filter(function (t) {
                return !t.endTime;
              }).length) {
                var o = n.reduce(function (t, e) {
                  return t + (e.endTime - e.startTime);
                }, 0) / n.length;
                this.log("average: ".concat(o));
              }
            }
          }, t.timer = function (t) {
            this.enableLogsAndTimers && (this.lastCreatedTimer = {
              message: t,
              startTime: performance.now(),
              groupName: this.lastAverageGroupName
            });
          }, t.endTimer = function () {
            var t = this;
            if (this.enableLogsAndTimers) {
              var e = this.lastCreatedTimer,
                n = setTimeout(function () {
                  e.endTime = performance.now(), t.showMessage('timer "'.concat(e.message, '": ').concat(e.endTime - e.startTime)), e.groupName && t.tryLogAverage(e.groupName);
                }, 0);
              this.timers[n] = e, this.lastCreatedTimer = null;
            }
          }, t.logPerfInfo = function () {
            var t = document.querySelector(".dxdi-control > svg").querySelectorAll("*").length,
              e = performance.memory;
            this.log("nodes: ".concat(t.toLocaleString()).concat(e ? " memory: " : "").concat(e ? e.usedJSHeapSize.toLocaleString() : ""));
          }, t.log = function (t) {
            this.showMessage(t);
          }, t.showMessage = function (e) {
            switch (t.mode) {
              case n.Console:
                console.log(e);
                break;
              case n.Document:
                var o = this.getElement().value;
                if (this.lastMessage === e) {
                  var i = o.indexOf("\r\n");
                  i < 0 && (i = o.indexOf("\n"));
                  var r = o.substr(0, i);
                  /( \()([0-9]+)(\))$/.test(r) ? r = r.replace(/( \()([0-9]+)(\))$/, function (t, e, n, o) {
                    return e + ++n + o;
                  }) : r += " (1)", this.getElement().value = r + o.substr(i);
                } else this.getElement().value = e + "\r\n" + o, this.lastMessage = e;
            }
          }, t.getElement = function () {
            var t = this;
            if (!this.el) {
              this.el = document.createElement("textarea"), this.el.style.top = "0px", this.el.style.right = "0px", this.el.style.position = "fixed", this.el.style.background = "transparent", this.el.style.fontSize = "11px", this.el.style.fontFamily = "monospace", this.el.style.overflow = "auto", this.el.style.width = "400px", document.body.appendChild(this.el);
              var e = document.createElement("button");
              e.innerHTML = "x", e.addEventListener("click", function () {
                t.el.value = "", t.lastMessage = "";
              }), e.style.top = "0px", e.style.right = "400px", e.style.position = "fixed", e.style.opacity = "0.1", document.body.appendChild(e);
            }
            return this.el;
          }, t.mode = n.Document, t.optimizeUsingRAF = !0, t.optimizeLayers = !0, t.timers = {}, t.enableLogsAndTimers = !1, t;
        }();
        e.Diagnostics = o;
      },
      9198: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.UndoCommand = void 0;
        var r = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(e, t), e.prototype.executeCore = function (t) {
            return this.control.beginUpdateCanvas(), this.permissionsProvider.lockPermissions(), this.control.history.undo(), this.permissionsProvider.unlockPermissions(), this.control.endUpdateCanvas(), !0;
          }, e.prototype.isEnabled = function () {
            return t.prototype.isEnabled.call(this) && this.control.history.canUndo();
          }, e;
        }(n(3913).SimpleCommandBase);
        e.UndoCommand = r;
      },
      9212: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Alignment = e.DataLayoutOrientation = e.LogicalDirectionKind = e.TreeLayoutSettings = e.LayoutSettings = void 0;
        var r = n(6320),
          s = function (t) {
            this.orientation = c.Vertical, this.direction = a.Forward;
            var e = t && 2 * t > r.Connector.minOffset ? 2 * t : r.Connector.minOffset;
            this.columnSpacing = e, this.layerSpacing = 2 * e, this.containerPadding = 2 * e, this.componentSpacing = 2 * e;
          };
        e.LayoutSettings = s;
        var a,
          c,
          u,
          p = function (t) {
            function e(e) {
              var n = t.call(this, e) || this;
              return n.alignment = u.Center, n.subTreeColumnSpacing = n.componentSpacing / 2, n;
            }
            return i(e, t), e;
          }(s);
        e.TreeLayoutSettings = p, function (t) {
          t[t.Backward = 0] = "Backward", t[t.Forward = 1] = "Forward";
        }(a = e.LogicalDirectionKind || (e.LogicalDirectionKind = {})), function (t) {
          t[t.Horizontal = 0] = "Horizontal", t[t.Vertical = 1] = "Vertical";
        }(c = e.DataLayoutOrientation || (e.DataLayoutOrientation = {})), function (t) {
          t[t.Left = 0] = "Left", t[t.Center = 1] = "Center";
        }(u = e.Alignment || (e.Alignment = {}));
      },
      9254: (t, e) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.PageOrientation = e.DiagramUnit = void 0, function (t) {
          t[t.In = 0] = "In", t[t.Cm = 1] = "Cm", t[t.Px = 2] = "Px";
        }(e.DiagramUnit || (e.DiagramUnit = {})), function (t) {
          t[t.Portrait = 0] = "Portrait", t[t.Landscape = 1] = "Landscape";
        }(e.PageOrientation || (e.PageOrientation = {}));
      },
      9299: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ShadowFilterPrimitive = void 0;
        var r = n(9707),
          s = n(8509),
          a = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), e.prototype.createChildElements = function (t) {
              var e = document.createElementNS(s.svgNS, "feGaussianBlur");
              e.setAttribute("in", "SourceGraphic"), e.setAttribute("stdDeviation", "4.6"), t.appendChild(e);
              var n = document.createElementNS(s.svgNS, "feOffset");
              n.setAttribute("dx", "0"), n.setAttribute("dy", "0"), t.appendChild(n);
              var o = document.createElementNS(s.svgNS, "feMerge");
              t.appendChild(o);
              var i = document.createElementNS(s.svgNS, "feMergeNode");
              o.appendChild(i);
              var r = document.createElementNS(s.svgNS, "feMergeNode");
              r.setAttribute("in", "SourceGraphic"), o.appendChild(r);
            }, e;
          }(r.FilterPrimitive);
        e.ShadowFilterPrimitive = a;
      },
      9307: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ConnectorRoutingMode = e.AutoZoomMode = e.DiagramSettings = void 0;
        var o,
          i,
          r = n(41),
          s = n(3844),
          a = n(9254),
          c = n(1922),
          u = function () {
            function t() {
              this.onZoomChanged = new r.EventDispatcher(), this.onViewChanged = new r.EventDispatcher(), this.onReadOnlyChanged = new r.EventDispatcher(), this.onConnectorRoutingModeChanged = new r.EventDispatcher(), this._zoomLevel = 1, this._zoomLevelWasChanged = !1, this._zoomLevelItems = [.5, .75, 1, 1.25, 1.5, 2, 3], this._simpleView = !1, this._fullscreen = !1, this._readOnly = !1, this._autoZoom = o.Disabled, this._snapToGrid = !0, this._showGrid = !0, this._contextMenuEnabled = !0, this._gridSize = 180, this._gridSizeItems = [90, 180, 360, 720], this._pageSizeItems = [{
                size: new s.Size(12240, 15840),
                text: "US-Letter ({width} x {height})"
              }, {
                size: new s.Size(12240, 20160),
                text: "US-Legal ({width} x {height})"
              }, {
                size: new s.Size(15817, 24491),
                text: "US-Tabloid ({width} x {height})"
              }, {
                size: new s.Size(47685, 67410),
                text: "A0 ({width} x {height})"
              }, {
                size: new s.Size(33675, 47685),
                text: "A1 ({width} x {height})"
              }, {
                size: new s.Size(23805, 33675),
                text: "A2 ({width} x {height})"
              }, {
                size: new s.Size(16830, 23805),
                text: "A3 ({width} x {height})"
              }, {
                size: new s.Size(11910, 16830),
                text: "A4 ({width} x {height})"
              }, {
                size: new s.Size(8400, 11910),
                text: "A5 ({width} x {height})"
              }, {
                size: new s.Size(5955, 8400),
                text: "A6 ({width} x {height})"
              }, {
                size: new s.Size(4200, 5955),
                text: "A7 ({width} x {height})"
              }], this._viewUnits = a.DiagramUnit.In, this._connectorRoutingMode = i.AllShapesOnly, this._reloadInsertedItemRequired = !1, this._useCanvgForExportToImage = !0;
            }
            return Object.defineProperty(t.prototype, "zoomLevel", {
              get: function () {
                return this._zoomLevel;
              },
              set: function (e) {
                var n = this;
                (e = t.correctZoomLevel(e)) !== this._zoomLevel && (this._zoomLevel = e, this._zoomLevelWasChanged = !0, this.onZoomChanged.raise1(function (t) {
                  return t.notifyZoomChanged(e, n._autoZoom);
                }));
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(t.prototype, "zoomLevelWasChanged", {
              get: function () {
                return this._zoomLevelWasChanged;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(t.prototype, "zoomLevelItems", {
              get: function () {
                return this._zoomLevelItems;
              },
              set: function (e) {
                (e = e.map(function (e) {
                  return t.correctZoomLevel(e);
                })) !== this._zoomLevelItems && (this._zoomLevelItems = e);
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(t.prototype, "autoZoom", {
              get: function () {
                return this._autoZoom;
              },
              set: function (t) {
                var e = this;
                t !== this._autoZoom && (this._autoZoom = t, this.onZoomChanged.raise1(function (n) {
                  return n.notifyZoomChanged(e._zoomLevel, t);
                }));
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(t.prototype, "simpleView", {
              get: function () {
                return this._simpleView;
              },
              set: function (t) {
                t !== this._simpleView && (this._simpleView = t, this.notifyViewChanged());
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(t.prototype, "readOnly", {
              get: function () {
                return this._readOnly;
              },
              set: function (t) {
                t !== this._readOnly && (this._readOnly = t, this.onReadOnlyChanged.raise1(function (e) {
                  return e.notifyReadOnlyChanged(t);
                }));
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(t.prototype, "fullscreen", {
              get: function () {
                return this._fullscreen;
              },
              set: function (t) {
                this._fullscreen = t;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(t.prototype, "snapToGrid", {
              get: function () {
                return this._snapToGrid;
              },
              set: function (t) {
                this._snapToGrid = t;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(t.prototype, "showGrid", {
              get: function () {
                return this._showGrid;
              },
              set: function (t) {
                var e = this;
                t !== this._showGrid && (this._showGrid = t, this.onViewChanged.raise1(function (t) {
                  return t.notifyGridChanged(e.showGrid, e.gridSize);
                }));
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(t.prototype, "contextMenuEnabled", {
              get: function () {
                return this._contextMenuEnabled;
              },
              set: function (t) {
                this._contextMenuEnabled = t;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(t.prototype, "gridSize", {
              get: function () {
                return this._gridSize;
              },
              set: function (t) {
                var e = this;
                t !== this._gridSize && (this._gridSize = t, this.onViewChanged.raise1(function (t) {
                  return t.notifyGridChanged(e.showGrid, e.gridSize);
                }));
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(t.prototype, "gridSizeItems", {
              get: function () {
                return this._gridSizeItems;
              },
              set: function (t) {
                t !== this._gridSizeItems && (this._gridSizeItems = t);
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(t.prototype, "pageSizeItems", {
              get: function () {
                return this._pageSizeItems;
              },
              set: function (t) {
                t !== this._pageSizeItems && (this._pageSizeItems = t);
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(t.prototype, "viewUnits", {
              get: function () {
                return this._viewUnits;
              },
              set: function (t) {
                this._viewUnits = t;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(t.prototype, "connectorRoutingMode", {
              get: function () {
                return this._connectorRoutingMode;
              },
              set: function (t) {
                t !== this._connectorRoutingMode && (this._connectorRoutingMode = t, this.onConnectorRoutingModeChanged.raise1(function (e) {
                  return e.notifyConnectorRoutingModeChanged(t);
                }));
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(t.prototype, "reloadInsertedItemRequired", {
              get: function () {
                return this._reloadInsertedItemRequired;
              },
              set: function (t) {
                this._reloadInsertedItemRequired = t;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(t.prototype, "useCanvgForExportToImage", {
              get: function () {
                return this._useCanvgForExportToImage;
              },
              set: function (t) {
                this._useCanvgForExportToImage = t;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(t.prototype, "shapeMinWidth", {
              get: function () {
                return this._shapeMinWidth;
              },
              set: function (t) {
                this._shapeMinWidth = t;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(t.prototype, "shapeMinHeight", {
              get: function () {
                return this._shapeMinHeight;
              },
              set: function (t) {
                this._shapeMinHeight = t;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(t.prototype, "shapeMaxWidth", {
              get: function () {
                return this._shapeMaxWidth;
              },
              set: function (t) {
                this._shapeMaxWidth = t;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(t.prototype, "shapeMaxHeight", {
              get: function () {
                return this._shapeMaxHeight;
              },
              set: function (t) {
                this._shapeMaxHeight = t;
              },
              enumerable: !1,
              configurable: !0
            }), t.prototype.applyShapeSizeSettings = function (t, e) {
              t && ("number" == typeof t.shapeMaxHeight && (this.shapeMaxHeight = c.ModelUtils.getTwipsValue(e, t.shapeMaxHeight)), "number" == typeof t.shapeMinHeight && (this.shapeMinHeight = c.ModelUtils.getTwipsValue(e, t.shapeMinHeight)), "number" == typeof t.shapeMaxWidth && (this.shapeMaxWidth = c.ModelUtils.getTwipsValue(e, t.shapeMaxWidth)), "number" == typeof t.shapeMinWidth && (this.shapeMinWidth = c.ModelUtils.getTwipsValue(e, t.shapeMinWidth)));
            }, t.prototype.notifyViewChanged = function () {
              var t = this;
              this.onViewChanged.raise1(function (e) {
                return e.notifyViewChanged(t._simpleView);
              });
            }, t.correctZoomLevel = function (t) {
              return Math.min(10, Math.max(t, .01));
            }, t;
          }();
        e.DiagramSettings = u, function (t) {
          t[t.Disabled = 0] = "Disabled", t[t.FitContent = 1] = "FitContent", t[t.FitToWidth = 2] = "FitToWidth";
        }(o = e.AutoZoomMode || (e.AutoZoomMode = {})), function (t) {
          t[t.None = 0] = "None", t[t.AllShapesOnly = 2] = "AllShapesOnly";
        }(i = e.ConnectorRoutingMode || (e.ConnectorRoutingMode = {}));
      },
      9314: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ChangeLockedCommand = void 0;
        var r = n(1922),
          s = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), e.prototype.isEnabled = function () {
              var e = this,
                n = this.control.selection.getSelectedItems(!0),
                o = !1;
              return n.forEach(function (t) {
                t.locked !== e.getLockState() && (o = !0);
              }), t.prototype.isEnabled.call(this) && o;
            }, e.prototype.executeCore = function (t, e) {
              return r.ModelUtils.changeSelectionLocked(this.control.history, this.control.model, this.control.selection, this.getLockState()), !0;
            }, e;
          }(n(3913).SimpleCommandBase);
        e.ChangeLockedCommand = s;
      },
      9406: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ImageInfo = void 0;
        var o = n(807),
          i = function () {
            function t(t) {
              this.url = void 0, this.base64 = void 0, t && (o.Base64Utils.checkPrependDataUrl(t) ? this.base64 = t : this.url = t), this.loadFailed = !1;
            }
            return t.prototype.clone = function () {
              var e = new t();
              return e.url = this.url, e.base64 = this.base64, e;
            }, Object.defineProperty(t.prototype, "isEmpty", {
              get: function () {
                return void 0 === this.url && void 0 === this.base64;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(t.prototype, "unableToLoad", {
              get: function () {
                return this.loadFailed;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(t.prototype, "renderUrl", {
              get: function () {
                return this.base64 || "";
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(t.prototype, "exportUrl", {
              get: function () {
                return this.base64 ? this.base64 : this.url;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(t.prototype, "actualUrl", {
              get: function () {
                return this.url ? this.url : this.base64;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(t, "transparentOnePixelImage", {
              get: function () {
                return this.transparentWhiteImage1_1;
              },
              enumerable: !1,
              configurable: !0
            }), t.prototype.loadBase64Content = function (t) {
              this.base64 = o.Base64Utils.normalizeToDataUrl(t, "image/png");
            }, t.prototype.setUnableToLoadFlag = function () {
              this.loadFailed = !0;
            }, t.transparentWhiteImage1_1 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAANSURBVBhXY/j///9/AAn7A/0FQ0XKAAAAAElFTkSuQmCC", t;
          }();
        e.ImageInfo = i;
      },
      9415: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.DecisionShapeDescription = void 0;
        var r = n(7763),
          s = n(3255),
          a = n(3844),
          c = n(1280),
          u = function (t) {
            function e() {
              return t.call(this, new a.Size(c.ShapeDefaultDimension, .75 * c.ShapeDefaultDimension), !0) || this;
            }
            return i(e, t), Object.defineProperty(e.prototype, "key", {
              get: function () {
                return s.ShapeTypes.Decision;
              },
              enumerable: !1,
              configurable: !0
            }), e;
          }(r.DiamondShapeDescription);
        e.DecisionShapeDescription = u;
      },
      9491: t => {
        function e(t, e) {
          if (null == t) throw new TypeError("Cannot convert first argument to object");
          for (var n = Object(t), o = 1; o < arguments.length; o++) {
            var i = arguments[o];
            if (null != i) for (var r = Object.keys(Object(i)), s = 0, a = r.length; s < a; s++) {
              var c = r[s],
                u = Object.getOwnPropertyDescriptor(i, c);
              void 0 !== u && u.enumerable && (n[c] = i[c]);
            }
          }
          return n;
        }
        t.exports = {
          assign: e,
          polyfill: function () {
            Object.assign || Object.defineProperty(Object, "assign", {
              enumerable: !1,
              configurable: !0,
              writable: !0,
              value: e
            });
          }
        };
      },
      9496: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.OctagonShapeDescription = void 0;
        var r = n(6208),
          s = n(3255),
          a = n(4717),
          c = n(41),
          u = n(4412),
          p = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), Object.defineProperty(e.prototype, "key", {
              get: function () {
                return s.ShapeTypes.Octagon;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "angleCount", {
              get: function () {
                return 8;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.createShapePrimitives = function (t) {
              var e = t.rectangle,
                n = e.x,
                o = e.y,
                i = e.right,
                s = e.bottom,
                a = e.width,
                c = e.height,
                u = Math.PI - this.angle,
                p = a / (1 + 2 * Math.cos(u)),
                h = c / (1 + 2 * Math.cos(u)),
                l = n + (a - p) / 2,
                d = l + p,
                f = o + (c - h) / 2,
                y = f + h;
              return [new r.PathPrimitive([new r.PathPrimitiveMoveToCommand(l, o), new r.PathPrimitiveLineToCommand(d, o), new r.PathPrimitiveLineToCommand(i, f), new r.PathPrimitiveLineToCommand(i, y), new r.PathPrimitiveLineToCommand(d, s), new r.PathPrimitiveLineToCommand(l, s), new r.PathPrimitiveLineToCommand(n, y), new r.PathPrimitiveLineToCommand(n, f), new r.PathPrimitiveClosePathCommand()], t.style)];
            }, e.prototype.calculateHeight = function (t) {
              return t;
            }, e.prototype.getTextRectangle = function (t) {
              var e = c.GeometryUtils.getMaxRectangleEnscribedInEllipse(t.size);
              return u.Rectangle.fromGeometry(t.position.clone().offset((t.size.width - e.width) / 2, (t.size.height - e.height) / 2), e);
            }, e.prototype.getSizeByText = function (t, e) {
              return c.GeometryUtils.getEllipseByEnscribedRectangle(t);
            }, e;
          }(a.PolygonShapeDescription);
        e.OctagonShapeDescription = p;
      },
      9500: (t, e) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.UnitConverter = void 0;
        var n = function () {
          function t() {}
          return t.hundredthsOfMillimeterToTwipsRound = function (t) {
            return Math.round(1440 * t / 2540);
          }, t.documentsToTwips = function (t) {
            return 24 * t / 5;
          }, t.pixelsToTwips = function (e) {
            return Math.round(t.pixelsToTwipsF(e));
          }, t.pixelsToTwipsCustomDpi = function (e, n) {
            return Math.round(t.pixelsToTwipsFCustomDpi(e, n));
          }, t.inchesToTwips = function (e) {
            return Math.round(t.inchesToTwipsF(e));
          }, t.pointsToTwips = function (e) {
            return Math.round(t.pointsToTwipsF(e));
          }, t.picasToTwips = function (e) {
            return Math.round(1440 * e / t.PICAS_PER_INCH);
          }, t.centimetersToTwips = function (e) {
            return Math.round(t.centimetersToTwipsF(e));
          }, t.pixelsToTwipsF = function (e) {
            return 1440 * e / t.DPI;
          }, t.pixelsToTwipsFCustomDpi = function (t, e) {
            return 1440 * t / e;
          }, t.inchesToTwipsF = function (t) {
            return 1440 * t;
          }, t.pointsToTwipsF = function (t) {
            return 20 * t;
          }, t.centimetersToTwipsF = function (e) {
            return 1440 * e / t.CENTIMETERS_PER_INCH;
          }, t.twipsToDegrees = function (t) {
            return t / 6e4;
          }, t.twipsToRadians = function (t) {
            return t / 6e4 * Math.PI / 180;
          }, t.degreesToTwips = function (t) {
            return 6e4 * t;
          }, t.radiansToTwips = function (t) {
            return 6e4 * t / Math.PI * 180;
          }, t.radiansToDegrees = function (t) {
            return t / Math.PI * 180;
          }, t.twipsToFD = function (t) {
            return Math.round(2048 * t / 1875);
          }, t.fdToTwips = function (t) {
            return Math.round(1875 * t / 2048);
          }, t.emuToTwips = function (t) {
            return t / 635;
          }, t.twipsToPixels = function (e) {
            return Math.round(t.twipsToPixelsF(e));
          }, t.inchesToPixels = function (e) {
            return Math.round(t.DPI * e);
          }, t.centimeterToPixel = function (t) {
            return Math.round(this.centimeterToPixelF(t));
          }, t.centimeterToPixelF = function (e) {
            return e * t.DPI / t.CENTIMETERS_PER_INCH;
          }, t.millimetersToPixel = function (e) {
            return Math.round(e / (t.CENTIMETERS_PER_INCH / t.DPI) / 10);
          }, t.pointsToPixels = function (e) {
            return Math.round(e * t.DPI / 72);
          }, t.pointsToPixelsF = function (e) {
            return e * t.DPI / 72;
          }, t.twipsToPixelsF = function (e) {
            return e * t.DPI / 1440;
          }, t.pixelsToPoints = function (e) {
            return Math.round(72 * e / t.DPI);
          }, t.pixelsToPointsF = function (e) {
            return 72 * e / t.DPI;
          }, t.twipsToPoints = function (t) {
            return Math.round(this.twipsToPointsF(t));
          }, t.twipsToPointsF = function (t) {
            return t / 20;
          }, t.twipsToInches = function (t) {
            return t / 1440;
          }, t.pixelsToInches = function (e) {
            return e / t.DPI;
          }, t.twipsToCentimeters = function (e) {
            return e * t.CENTIMETERS_PER_INCH / 1440;
          }, t.pixelToCentimeters = function (e) {
            return e * t.CENTIMETERS_PER_INCH / t.DPI;
          }, t.twipsToHundredthsOfMillimeter = function (t) {
            return Math.round(127 * t / 72);
          }, t.pixelsToHundredthsOfMillimeter = function (e) {
            return Math.round(2540 * e / t.DPI);
          }, t.hundredthsOfMillimeterToTwips = function (t) {
            return 15 * t / 127;
          }, t.twipsToEmu = function (t) {
            return 635 * t;
          }, t.twipsToDegree = function (t) {
            return t / 6e4;
          }, t.DPI = 96, t.CENTIMETERS_PER_INCH = 2.54, t.PICAS_PER_INCH = 6, t;
        }();
        e.UnitConverter = n;
      },
      9543: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.HexagonShapeDescription = void 0;
        var r = n(6208),
          s = n(3255),
          a = n(4717),
          c = n(41),
          u = n(4412),
          p = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), Object.defineProperty(e.prototype, "key", {
              get: function () {
                return s.ShapeTypes.Hexagon;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "angleCount", {
              get: function () {
                return 6;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.createShapePrimitives = function (t) {
              var e = t.rectangle,
                n = e.x,
                o = e.y,
                i = e.right,
                s = e.bottom,
                a = e.width,
                c = e.center.y,
                u = Math.PI - this.angle,
                p = a / (1 + 2 * Math.cos(u)),
                h = n + (a - p) / 2,
                l = h + p;
              return [new r.PathPrimitive([new r.PathPrimitiveMoveToCommand(h, o), new r.PathPrimitiveLineToCommand(l, o), new r.PathPrimitiveLineToCommand(i, c), new r.PathPrimitiveLineToCommand(l, s), new r.PathPrimitiveLineToCommand(h, s), new r.PathPrimitiveLineToCommand(n, c), new r.PathPrimitiveClosePathCommand()], t.style)];
            }, e.prototype.calculateHeight = function (t) {
              var e = Math.PI - this.angle;
              return 2 * (t / (1 + 2 * Math.cos(e))) * Math.sin(e);
            }, e.prototype.getTextRectangle = function (t) {
              var e = c.GeometryUtils.getMaxRectangleEnscribedInEllipse(t.size);
              return u.Rectangle.fromGeometry(t.position.clone().offset((t.size.width - e.width) / 2, (t.size.height - e.height) / 2), e);
            }, e.prototype.getSizeByText = function (t, e) {
              return c.GeometryUtils.getEllipseByEnscribedRectangle(t);
            }, e;
          }(a.PolygonShapeDescription);
        e.HexagonShapeDescription = p;
      },
      9550: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MouseHandlerDefaultStateBase = void 0;
        var r = n(9589),
          s = n(5428),
          a = n(868),
          c = n(5094),
          u = n(5715),
          p = n(2325),
          h = n(9500),
          l = n(2270),
          d = function (t) {
            function e(e, n, o, i, r, s, a, c) {
              var u = t.call(this, e) || this;
              return u.history = n, u.selection = o, u.model = i, u.view = r, u.visualizerManager = s, u.shapeDescriptionManager = a, u.settings = c, u;
            }
            return i(e, t), e.prototype.onKeyDown = function (t) {
              this.handler.onStartScrollPageByKeyboard(t);
            }, e.prototype.onKeyUp = function (t) {
              this.handler.onFinishScrollPageByKeyboard(t);
            }, e.prototype.onMouseDown = function (t) {
              this.handler.canFinishTextEditing() && (this.onMouseDownCore(t), this.handler.state !== this && this.handler.state.onMouseDown(t));
            }, e.prototype.onMouseDownCore = function (t) {
              this.handler.canScrollPage(t) ? this.startScrolling(t) : this.hasDiagramItem(t) && this.canDragObjectOnMouseDown(t.source.key) ? this.onDragDiagramItemOnMouseDown(t) : t.button === s.MouseButton.Left && t.source.type === s.MouseEventElementType.ShapeExpandButton && this.canExpandContainerOnMouseDown(t.source.key) ? this.onShapeExpandBtnMouseDown(t) : (!this.hasDiagramItem(t) && this.canClearSelectionOnMouseDown() && this.clearSelection(), this.startPoint = t.modelPoint);
            }, e.prototype.onDragDiagramItemOnMouseDown = function (t) {
              this.replaceSelection(t);
            }, e.prototype.onMouseMove = function (t) {
              this.onMouseMoveCore(t), this.handler.state !== this && (this.handler.state.onMouseDown(this.handler.mouseDownEvent), this.handler.state.onMouseMove(t));
            }, e.prototype.onMouseMoveCore = function (t) {
              this.startPoint && (Math.abs(this.startPoint.x - t.modelPoint.x) > e.startLimit || Math.abs(this.startPoint.y - t.modelPoint.y) > e.startLimit) && (this.processOnMouseMoveAfterLimit(t), this.startPoint = void 0);
            }, e.prototype.processOnMouseMoveAfterLimit = function (t) {
              t.isTouchMode ? t.touches.length > 1 ? this.startZooming(t) : this.startScrolling(t) : this.startSelection(t);
            }, e.prototype.onMouseUp = function (t) {
              this.onMouseUpCore(t), this.handler.state !== this && this.handler.state.onMouseUp(t);
            }, e.prototype.onMouseUpCore = function (t) {
              t.source.type === s.MouseEventElementType.Shape && this.canSelectOnMouseUp(t.source.key) || t.source.type === s.MouseEventElementType.Connector && this.canSelectOnMouseUp(t.source.key) || t.source.type === s.MouseEventElementType.ShapeExpandButton && this.canSelectOnMouseUp(t.source.key) ? this.replaceSelection(t) : this.startPoint && this.canClearSelectionOnMouseUp() && this.clearSelection(), this.startPoint = void 0;
            }, e.prototype.onMouseWheel = function (t) {
              return !!this.handler.canStartZoomOnWheel(t) && (this.handler.switchState(new u.MouseHandlerZoomOnWheelState(this.handler, this.settings, this.view)), this.handler.state.onMouseWheel(t), !0);
            }, e.prototype.onLongTouch = function (t) {
              this.replaceMultipleSelection(t.source.key);
            }, e.prototype.finish = function () {
              this.startPoint = void 0;
            }, e.prototype.startSelection = function (t) {
              t.button === s.MouseButton.Left && this.handler.switchState(new c.MouseHandlerSelectionState(this.handler, this.selection, this.visualizerManager));
            }, e.prototype.startScrolling = function (t) {
              t.button === s.MouseButton.Left && (this.handler.raiseDragScrollStart(), this.handler.switchState(new p.MouseHandlerScrollingState(this.handler, this.view, this.selection)));
            }, e.prototype.startZooming = function (t) {
              this.handler.switchState(new l.MouseHandlerZoomOnPinchState(this.handler, this.selection, this.settings, this.view));
            }, e.prototype.inSelection = function (t) {
              return this.selection.hasKey(t);
            }, e.prototype.hasDiagramItem = function (t) {
              return t.source.isShape || t.source.isConnector;
            }, e.prototype.onShapeExpandBtnMouseDown = function (t) {
              this.handler.addDiagramItemToSelection(t), this.handler.switchState(new a.MouseHandlerToggleShapeExpandedState(this.handler, this.history, this.model, this.selection));
            }, e.prototype.replaceSelection = function (t) {
              this.handler.canMultipleSelection(t) ? this.replaceMultipleSelection(t.source.key) : this.handler.changeSingleSelection(t.source.key);
            }, e.prototype.replaceMultipleSelection = function (t) {
              this.selection.hasKey(t) ? this.selection.remove(t) : this.selection.add(t);
            }, e.prototype.clearSelection = function () {
              this.selection.set([]);
            }, e.startLimit = h.UnitConverter.pixelsToTwips(1), e;
          }(r.MouseHandlerStateBase);
        e.MouseHandlerDefaultStateBase = d;
      },
      9551: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SvgElementPrimitive = void 0;
        var r = n(8509),
          s = function (t) {
            function e(e, n, o, i, r, s, a, c, u) {
              var p = t.call(this, null, c, void 0, u) || this;
              return p.x = e, p.y = n, p.width = o, p.height = i, p.createContent = r, p.destroyContent = s, p.data = a, p;
            }
            return i(e, t), e.prototype.createMainElement = function () {
              return document.createElementNS(r.svgNS, "svg");
            }, e.prototype.applyElementProperties = function (e, n) {
              this.setUnitAttribute(e, "x", this.x), this.setUnitAttribute(e, "y", this.y), this.setUnitAttribute(e, "width", this.width), this.setUnitAttribute(e, "height", this.height), this.setPositionCorrectionAttribute(e), t.prototype.applyElementProperties.call(this, e, n);
            }, e.prototype.createCustomContent = function (t) {
              this.createContent && this.createContent(t, this.data);
            }, e.prototype.destroyCustomContent = function (t) {
              this.destroyContent && this.destroyContent(t);
            }, e;
          }(n(8309).SvgPrimitive);
        e.SvgElementPrimitive = s;
      },
      9553: (t, e, n) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ColorUtils = void 0;
        var o = n(4989),
          i = function () {
            function t() {}
            return t.getAlpha = function (t) {
              return t >> 24 & 255;
            }, t.getRed = function (t) {
              return t >> 16 & 255;
            }, t.getGreen = function (t) {
              return t >> 8 & 255;
            }, t.getBlue = function (t) {
              return 255 & t;
            }, t.redPartToString = function (e) {
              var n = t.getRed(e).toString(16);
              return n.length > 1 ? n : "0" + n;
            }, t.greenPartToString = function (e) {
              var n = t.getGreen(e).toString(16);
              return n.length > 1 ? n : "0" + n;
            }, t.bluePartToString = function (e) {
              var n = t.getBlue(e).toString(16);
              return n.length > 1 ? n : "0" + n;
            }, t.fromArgbNumber = function (t, e, n, o) {
              return t << 24 | e << 16 | n << 8 | o;
            }, t.fromRgbaString = function (t, e) {
              void 0 === e && (e = 255);
              var n = t.replace(/ +/g, "").match(/(rgba?)|(\d+(\.\d+)?%?)|(\.\d+)/g);
              if (n && n.length > 3) {
                for (var o = [], i = 1, r = void 0; r = n[i]; i++) {
                  var s = -1 !== r.indexOf("%") ? Math.round(2.55 * parseFloat(r)) : parseInt(r);
                  if (s < 0 || s > 255) return null;
                  o.push(s);
                }
                if (0 === t.indexOf("rgba")) {
                  if (isNaN(o[3]) || o[3] < 0 || o[3] > 1) return null;
                  o[3] <= 1 && (o[3] = Math.round(255 * o[3]));
                } else if (o[3]) return null;
                return (255 & o[0]) << 16 | (255 & o[1]) << 8 | 255 & o[2] | (255 & (o.length > 3 ? o[3] : e)) << 24;
              }
              return null;
            }, t.fromHashString = function (e, n) {
              return void 0 === n && (n = 255), t.isHashColorString(e) ? ("#" === e.charAt(0) && (e = e.substr(1)), 3 === e.length && (e = o.StringUtils.repeat(e.charAt(0), 2) + o.StringUtils.repeat(e.charAt(1), 2) + o.StringUtils.repeat(e.charAt(2), 2)), parseInt(e, 16) | n << 24) : null;
            }, t.fromColorName = function (e, n) {
              void 0 === n && (n = 255);
              var o = t.colorNames[e.toLowerCase()];
              return o ? t.fromHashString(o, n) : null;
            }, t.fromString = function (e, n) {
              void 0 === n && (n = 255);
              var o = t.fromRgbaString(e, n);
              if (null !== o) return o;
              var i = t.fromHashString(e, n);
              return null !== i ? i : t.fromColorName(e, n);
            }, t.colorToHash = function (e) {
              return "#" + t.redPartToString(e) + t.greenPartToString(e) + t.bluePartToString(e);
            }, t.stringToHash = function (t) {
              var e = this.fromString(t);
              return null !== e ? this.colorToHash(e) : null;
            }, t.isHashColorString = function (t) {
              return /^#?([0-9a-f]{6})$/i.test(t) || /^#?([0-9a-f]{3})$/i.test(t);
            }, t.isKnownColorName = function (e) {
              return !!t.colorNames[e.toLowerCase()];
            }, t.isGray = function (e) {
              var n = t.getRed(e);
              return n === t.getGreen(e) && n === t.getBlue(e);
            }, t.DARK_COLOR = -16777216, t.LIGHT_COLOR = -1, t.colorNames = {
              aliceblue: "#f0f8ff",
              antiquewhite: "#faebd7",
              aqua: "#00ffff",
              aquamarine: "#7fffd4",
              azure: "#f0ffff",
              beige: "#f5f5dc",
              bisque: "#ffe4c4",
              black: "#000000",
              blanchedalmond: "#ffebcd",
              blue: "#0000ff",
              blueviolet: "#8a2be2",
              brown: "#a52a2a",
              burlywood: "#deb887",
              cadetblue: "#5f9ea0",
              chartreuse: "#7fff00",
              chocolate: "#d2691e",
              coral: "#ff7f50",
              cornflowerblue: "#6495ed",
              cornsilk: "#fff8dc",
              crimson: "#dc143c",
              cyan: "#00ffff",
              darkblue: "#00008b",
              darkcyan: "#008b8b",
              darkgoldenrod: "#b8860b",
              darkgray: "#a9a9a9",
              darkgreen: "#006400",
              darkkhaki: "#bdb76b",
              darkmagenta: "#8b008b",
              darkolivegreen: "#556b2f",
              darkorange: "#ff8c00",
              darkorchid: "#9932cc",
              darkred: "#8b0000",
              darksalmon: "#e9967a",
              darkseagreen: "#8fbc8f",
              darkslateblue: "#483d8b",
              darkslategray: "#2f4f4f",
              darkturquoise: "#00ced1",
              darkviolet: "#9400d3",
              deeppink: "#ff1493",
              deepskyblue: "#00bfff",
              dimgray: "#696969",
              dodgerblue: "#1e90ff",
              feldspar: "#d19275",
              firebrick: "#b22222",
              floralwhite: "#fffaf0",
              forestgreen: "#228b22",
              fuchsia: "#ff00ff",
              gainsboro: "#dcdcdc",
              ghostwhite: "#f8f8ff",
              gold: "#ffd700",
              goldenrod: "#daa520",
              gray: "#808080",
              green: "#00ff00",
              greenyellow: "#adff2f",
              honeydew: "#f0fff0",
              hotpink: "#ff69b4",
              indianred: "#cd5c5c",
              indigo: "#4b0082",
              ivory: "#fffff0",
              khaki: "#f0e68c",
              lavender: "#e6e6fa",
              lavenderblush: "#fff0f5",
              lawngreen: "#7cfc00",
              lemonchiffon: "#fffacd",
              lightblue: "#add8e6",
              lightcoral: "#f08080",
              lightcyan: "#e0ffff",
              lightgoldenrodyellow: "#fafad2",
              lightgray: "#d3d3d3",
              lightgreen: "#90ee90",
              lightpink: "#ffb6c1",
              lightsalmon: "#ffa07a",
              lightseagreen: "#20b2aa",
              lightskyblue: "#87cefa",
              lightslateblue: "#8470ff",
              lightslategray: "#778899",
              lightsteelblue: "#b0c4de",
              lightyellow: "#ffffe0",
              lime: "#00ff00",
              limegreen: "#32cd32",
              linen: "#faf0e6",
              magenta: "#ff00ff",
              maroon: "#800000",
              mediumaquamarine: "#66cdaa",
              mediumblue: "#0000cd",
              mediumorchid: "#ba55d3",
              mediumpurple: "#9370d8",
              mediumseagreen: "#3cb371",
              mediumslateblue: "#7b68ee",
              mediumspringgreen: "#00fa9a",
              mediumturquoise: "#48d1cc",
              mediumvioletred: "#c71585",
              midnightblue: "#191970",
              mintcream: "#f5fffa",
              mistyrose: "#ffe4e1",
              moccasin: "#ffe4b5",
              navajowhite: "#ffdead",
              navy: "#000080",
              oldlace: "#fdf5e6",
              olive: "#808000",
              olivedrab: "#6b8e23",
              orange: "#ffa500",
              orangered: "#ff4500",
              orchid: "#da70d6",
              palegoldenrod: "#eee8aa",
              palegreen: "#98fb98",
              paleturquoise: "#afeeee",
              palevioletred: "#d87093",
              papayawhip: "#ffefd5",
              peachpuff: "#ffdab9",
              peru: "#cd853f",
              pink: "#ffc0cb",
              plum: "#dda0dd",
              powderblue: "#b0e0e6",
              purple: "#800080",
              red: "#ff0000",
              rosybrown: "#bc8f8f",
              royalblue: "#4169e1",
              saddlebrown: "#8b4513",
              salmon: "#fa8072",
              sandybrown: "#f4a460",
              seagreen: "#2e8b57",
              seashell: "#fff5ee",
              sienna: "#a0522d",
              silver: "#c0c0c0",
              skyblue: "#87ceeb",
              slateblue: "#6a5acd",
              slategray: "#708090",
              snow: "#fffafa",
              springgreen: "#00ff7f",
              steelblue: "#4682b4",
              tan: "#d2b48c",
              teal: "#008080",
              thistle: "#d8bfd8",
              tomato: "#ff6347",
              turquoise: "#40e0d0",
              violet: "#ee82ee",
              violetred: "#d02090",
              wheat: "#f5deb3",
              white: "#ffffff",
              whitesmoke: "#f5f5f5",
              yellow: "#ffff00",
              yellowgreen: "#9acd32",
              windowtext: "#000000"
            }, t;
          }();
        e.ColorUtils = i;
      },
      9589: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MouseHandlerCancellableState = e.MouseHandlerStateBase = void 0;
        var r = n(6537),
          s = function () {
            function t(t) {
              this.handler = t;
            }
            return t.prototype.start = function () {}, t.prototype.finish = function () {}, t.prototype.onMouseClick = function (t) {}, t.prototype.onMouseDblClick = function (t) {
              this.handler.switchToDefaultState();
            }, t.prototype.onMouseDown = function (t) {}, t.prototype.onMouseUp = function (t) {}, t.prototype.onMouseMove = function (t) {}, t.prototype.onMouseWheel = function (t) {
              return !1;
            }, t.prototype.onDragStart = function (t) {}, t.prototype.onDragEnd = function (t) {}, t.prototype.onShortcut = function (t) {
              return !1;
            }, t.prototype.onKeyDown = function (t) {}, t.prototype.onKeyUp = function (t) {}, t.prototype.onConnectionPointsShow = function (t, e) {}, t.prototype.onConnectionTargetShow = function (t, e) {}, t;
          }();
        e.MouseHandlerStateBase = s;
        var a = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(e, t), e.prototype.onShortcut = function (t) {
            return t === r.KeyCode.Esc && (this.cancelChanges(), this.handler.switchToDefaultState(), !0);
          }, e;
        }(s);
        e.MouseHandlerCancellableState = a;
      },
      9613: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.InternalStorageShapeDescription = e.InternalStorageVerticalEdgeParameterName = e.InternalStorageHorizontalEdgeParameterName = void 0;
        var r = n(3190),
          s = n(3255),
          a = n(4636),
          c = n(9763),
          u = n(5327),
          p = n(6208);
        e.InternalStorageHorizontalEdgeParameterName = "he", e.InternalStorageVerticalEdgeParameterName = "ve";
        var h = function (t) {
          function n() {
            return t.call(this, void 0, !0) || this;
          }
          return i(n, t), Object.defineProperty(n.prototype, "key", {
            get: function () {
              return s.ShapeTypes.InternalStorage;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(n.prototype, "keepRatioOnAutoSize", {
            get: function () {
              return !1;
            },
            enumerable: !1,
            configurable: !0
          }), n.prototype.createShapePrimitives = function (n) {
            var o = n.rectangle,
              i = o.x,
              r = o.y,
              s = o.right,
              a = o.bottom,
              c = i + n.parameters.get(e.InternalStorageHorizontalEdgeParameterName).value,
              u = r + n.parameters.get(e.InternalStorageVerticalEdgeParameterName).value;
            return t.prototype.createShapePrimitives.call(this, n).concat([new p.PathPrimitive([new p.PathPrimitiveMoveToCommand(c, r), new p.PathPrimitiveLineToCommand(c, a), new p.PathPrimitiveMoveToCommand(i, u), new p.PathPrimitiveLineToCommand(s, u)], n.style)]);
          }, n.prototype.createParameters = function (t) {
            t.addRangeIfNotExists([new a.ShapeParameter(e.InternalStorageHorizontalEdgeParameterName, .1 * this.defaultSize.width), new a.ShapeParameter(e.InternalStorageVerticalEdgeParameterName, .1 * this.defaultSize.width)]);
          }, n.prototype.normalizeParameters = function (t, o) {
            this.changeParameterValue(o, e.InternalStorageHorizontalEdgeParameterName, function (e) {
              return Math.max(n.minEdge, Math.min(.3 * t.size.width, e.value));
            }), this.changeParameterValue(o, e.InternalStorageVerticalEdgeParameterName, function (e) {
              return Math.max(n.minEdge, Math.min(.3 * t.size.height, e.value));
            });
          }, n.prototype.modifyParameters = function (t, n, o, i) {
            this.changeParameterValue(n, e.InternalStorageHorizontalEdgeParameterName, function (t) {
              return t.value + o;
            }), this.changeParameterValue(n, e.InternalStorageVerticalEdgeParameterName, function (t) {
              return t.value + i;
            }), this.normalizeParameters(t, n);
          }, n.prototype.getParameterPoints = function (t) {
            return [new c.ShapeParameterPoint("c", new u.Point(t.normalizeX(t.position.x + t.parameters.get(e.InternalStorageHorizontalEdgeParameterName).value), t.normalizeY(t.position.y + t.parameters.get(e.InternalStorageVerticalEdgeParameterName).value)))];
          }, n.prototype.getTextRectangle = function (t) {
            var n = t.rectangle,
              o = t.parameters.get(e.InternalStorageHorizontalEdgeParameterName).value;
            return n.clone().resize(-o, 0).clone().moveRectangle(o, 0);
          }, n.minEdge = 72, n;
        }(r.RectangleShapeDescription);
        e.InternalStorageShapeDescription = h;
      },
      9675: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ChangeFillColorCommand = void 0;
        var r = n(5963),
          s = n(9553),
          a = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), e.prototype.processParameter = function (t) {
              return s.ColorUtils.stringToHash(t);
            }, e.prototype.getStyleProperty = function () {
              return "fill";
            }, e;
          }(r.ChangeStylePropertyCommand);
        e.ChangeFillColorCommand = a;
      },
      9700: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CanvasSelectionManager = e.ACTIVE_SELECTION_CSSCLASS = e.SELECTION_ELEMENT_CLASSNAMES = void 0;
        var r = n(5707),
          s = n(6709),
          a = n(2136),
          c = n(5428),
          u = n(4824),
          p = n(41),
          h = n(5327),
          l = n(3788),
          d = n(8408),
          f = n(6320),
          y = n(4385),
          g = n(94),
          m = n(6208),
          v = n(128),
          P = n(7345),
          C = n(5059),
          S = n(9500),
          x = n(5650),
          b = n(8424),
          w = n(750),
          I = n(9922),
          T = n(5318),
          O = n(4496),
          _ = n(594),
          E = n(1922),
          M = "-1";
        e.SELECTION_ELEMENT_CLASSNAMES = {
          SELECTION_RECTANGLE: "selection-rect",
          CONNECTION_POINT: "connection-point",
          ACTIVE: "active",
          CONTAINER_TARGET: "container-target",
          CONNECTION_TARGET: "connection-target",
          EXTENSION_LINE: "extension-line",
          CONNECTION_MARK: "connection-mark",
          SELECTION_MARK: "selection-mark",
          LOCKED_SELECTION_MARK: "locked-selection-mark",
          ITEMS_SELECTION_RECT: "items-selection-rect",
          CONNECTOR_MULTI_SELECTION: "connector-multi-selection",
          CONNECTOR_SELECTION: "connector-selection",
          CONNECTOR_POINT_MARK: "connector-point-mark",
          CONNECTOR_SELECTION_MASK: "connector-selection-mask",
          CONNECTOR_SIDE_MARK: "connector-side-mark",
          ITEM_SELECTION_RECT: "item-selection-rect",
          ITEM_MULTI_SELECTION: "item-multi-selection-rect"
        }, e.ACTIVE_SELECTION_CSSCLASS = "dxdi-active-selection";
        var D = function (t) {
          function n(e, n, o, i, r) {
            var s = t.call(this, n, i, r) || this;
            return s.readOnly = o, s.connectionPointElements = [], s.extensionLineElements = [], s.selectionMap = {}, s.parentContainer = e, s.initializeContainerElements(e), s;
          }
          return i(n, t), n.prototype.initializeContainerElements = function (t) {
            this.itemSelectionContainer = this.createAndChangePrimitiveElement(new s.GroupPrimitive([], null), t), this.visualizersContainer = this.createAndChangePrimitiveElement(new s.GroupPrimitive([], null), t), this.selectionMarksContainer = this.createAndChangePrimitiveElement(new s.GroupPrimitive([], null), t);
          }, n.prototype.clear = function () {
            a.RenderUtils.removeContent(this.itemSelectionContainer), a.RenderUtils.removeContent(this.selectionMarksContainer), a.RenderUtils.removeContent(this.visualizersContainer), this.selectionRectElement = void 0, this.resizeInfoElement = void 0, this.connectionPointElements = [], this.connectionTargetElement = void 0, this.containerTargetElement = void 0, this.extensionLineElements = [], this.selectionMap = {};
          }, n.prototype.showSelectionRect = function (t) {
            w.DomUtils.addClassName(this.parentContainer, e.ACTIVE_SELECTION_CSSCLASS);
            var n = new g.RectanglePrimitive(t.x, t.y, t.width, t.height, C.StrokeStyle.default1pxInstance, e.SELECTION_ELEMENT_CLASSNAMES.SELECTION_RECTANGLE),
              o = this.getSelectionRectElement(n);
            this.changePrimitiveElement(n, o);
          }, n.prototype.hideSelectionRect = function () {
            w.DomUtils.removeClassName(this.parentContainer, e.ACTIVE_SELECTION_CSSCLASS), void 0 !== this.selectionRectElement && this.dom.changeByFunc(this.selectionRectElement, function (t) {
              return t.style.display = "none";
            });
          }, n.prototype.getSelectionRectElement = function (t) {
            return void 0 !== this.selectionRectElement ? this.dom.changeByFunc(this.selectionRectElement, function (t) {
              return t.style.display = "";
            }) : this.selectionRectElement = this.createPrimitiveElement(t, this.visualizersContainer), this.selectionRectElement;
          }, n.prototype.showResizeInfo = function (t, e) {
            var o = new g.RectanglePrimitive(t.x, t.y, 0, 0, C.StrokeStyle.default1pxInstance),
              i = new s.GroupPrimitive([o, new v.TextPrimitive(t.x, t.y, e, x.TextOwner.Resize)], "resize-info"),
              r = this.getResizeInfoElement(i);
            this.changePrimitiveElement(i, r);
            var a = this.dom.measurer.measureTextLine(e, null, x.TextOwner.Resize).applyConverter(S.UnitConverter.pixelsToTwips);
            o.width = a.width + 2 * n.resizeInfoTextOffset, o.height = a.height + 2 * n.resizeInfoTextOffset, o.x = t.x - a.width / 2 - n.resizeInfoTextOffset, o.y = t.y - a.height / 2 - n.resizeInfoTextOffset, this.changePrimitiveElement(i, r);
          }, n.prototype.hideResizeInfo = function () {
            void 0 !== this.resizeInfoElement && this.dom.changeByFunc(this.resizeInfoElement, function (t) {
              return t.style.display = "none";
            });
          }, n.prototype.getResizeInfoElement = function (t) {
            return void 0 !== this.resizeInfoElement ? this.dom.changeByFunc(this.resizeInfoElement, function (t) {
              return t.style.display = "";
            }) : this.resizeInfoElement = this.createPrimitiveElement(t, this.visualizersContainer), this.resizeInfoElement;
          }, n.prototype.getConnectionPointClassName = function (t, n) {
            var o = e.SELECTION_ELEMENT_CLASSNAMES.CONNECTION_POINT;
            return t && (o += " " + e.SELECTION_ELEMENT_CLASSNAMES.ACTIVE), n || (o += " " + I.NOT_VALID_CSSCLASS), o;
          }, n.prototype.showConnectionPoint = function (t, o, i, r, s, a) {
            this.showConnectionPointCore(2 * t, o.x, o.y, n.connectionPointLargeSize, n.connectionPointLargeSize, c.MouseEventElementType.ShapeConnectionPoint, i, r, e.SELECTION_ELEMENT_CLASSNAMES.CONNECTION_POINT + " selector" + (a ? "" : " " + I.NOT_VALID_CSSCLASS)), this.showConnectionPointCore(2 * t + 1, o.x, o.y, n.connectionPointSmallSize, n.connectionPointSmallSize, c.MouseEventElementType.ShapeConnectionPoint, i, r, this.getConnectionPointClassName(s, a));
          }, n.prototype.showConnectionPointCore = function (t, e, n, o, i, r, s, c, u) {
            var p = new P.EllipsePrimitive(e, n, o, i, null, u, function (t) {
                return a.RenderUtils.setElementEventData(t, r, s, c);
              }),
              h = this.getConnectionPointElement(p, t);
            this.changePrimitiveElement(p, h);
          }, n.prototype.hideConnectionPoints = function () {
            for (var t = 0; t < this.connectionPointElements.length; t++) this.dom.changeByFunc(this.connectionPointElements[t], function (t) {
              return t.style.display = "none";
            });
          }, n.prototype.getConnectionPointElement = function (t, e) {
            var n = this.connectionPointElements[e];
            return void 0 !== n ? this.dom.changeByFunc(n, function (t) {
              return t.style.display = "";
            }) : (n = this.createPrimitiveElement(t, this.visualizersContainer), this.connectionPointElements[e] = n), n;
          }, n.prototype.showContainerTarget = function (t, n) {
            var o = new g.RectanglePrimitive(n.x, n.y, n.width, n.height, null, e.SELECTION_ELEMENT_CLASSNAMES.CONTAINER_TARGET),
              i = this.getContainerTargetElement(o);
            this.changePrimitiveElement(o, i);
          }, n.prototype.hideContainerTarget = function () {
            this.containerTargetElement && this.dom.changeByFunc(this.containerTargetElement, function (t) {
              return t.style.display = "none";
            });
          }, n.prototype.getContainerTargetElement = function (t) {
            return void 0 !== this.containerTargetElement ? this.dom.changeByFunc(this.containerTargetElement, function (t) {
              return t.style.display = "";
            }) : this.containerTargetElement = this.createPrimitiveElement(t, this.itemSelectionContainer), this.containerTargetElement;
          }, n.prototype.showConnectionTarget = function (t, n) {
            var o = new g.RectanglePrimitive(n.x, n.y, n.width, n.height, null, e.SELECTION_ELEMENT_CLASSNAMES.CONNECTION_TARGET),
              i = this.getConnectionTargetElement(o);
            this.changePrimitiveElement(o, i);
          }, n.prototype.hideConnectionTarget = function () {
            this.connectionTargetElement && this.dom.changeByFunc(this.connectionTargetElement, function (t) {
              return t.style.display = "none";
            });
          }, n.prototype.getConnectionTargetElement = function (t) {
            return void 0 !== this.connectionTargetElement ? this.dom.changeByFunc(this.connectionTargetElement, function (t) {
              return t.style.display = "";
            }) : this.connectionTargetElement = this.createPrimitiveElement(t, this.itemSelectionContainer), this.connectionTargetElement;
          }, n.prototype.showExtensionLine = function (t, o, i, a, c) {
            var u = e.SELECTION_ELEMENT_CLASSNAMES.EXTENSION_LINE;
            o !== l.ExtensionLineType.VerticalCenterAfter && o !== l.ExtensionLineType.VerticalCenterBefore && o !== l.ExtensionLineType.HorizontalCenterAbove && o !== l.ExtensionLineType.HorizontalCenterBelow || (u += " center"), o !== l.ExtensionLineType.VerticalCenterToPageCenter && o !== l.ExtensionLineType.HorizontalCenterToPageCenter && o !== l.ExtensionLineType.LeftToPageCenter && o !== l.ExtensionLineType.RightToPageCenter && o !== l.ExtensionLineType.TopToPageCenter && o !== l.ExtensionLineType.BottomToPageCenter || (u += " page");
            var p = 0,
              h = 0,
              d = 0,
              f = 0,
              y = 0,
              g = 0,
              P = 0,
              S = 0;
            i.y === a.y ? (p = i.x - n.extensionLineWidth, h = i.y - n.extensionLineEndingSize, d = i.x - n.extensionLineWidth, f = i.y + n.extensionLineEndingSize, y = a.x - n.extensionLineWidth, g = i.y - n.extensionLineEndingSize, P = a.x - n.extensionLineWidth, S = i.y + n.extensionLineEndingSize) : i.x === a.x && (p = i.x - n.extensionLineEndingSize, h = i.y - n.extensionLineWidth, d = i.x + n.extensionLineEndingSize, f = i.y - n.extensionLineWidth, y = i.x - n.extensionLineEndingSize, g = a.y - n.extensionLineWidth, P = i.x + n.extensionLineEndingSize, S = a.y - n.extensionLineWidth);
            var b = 0,
              w = 0;
            o !== l.ExtensionLineType.RightToRightAbove && o !== l.ExtensionLineType.RightToRightBelow || (b -= n.extensionLineWidth), o !== l.ExtensionLineType.BottomToBottomAfter && o !== l.ExtensionLineType.BottomToBottomBefore || (w -= n.extensionLineWidth);
            var I = [new m.PathPrimitive([m.PathPrimitiveMoveToCommand.fromPoint(i.clone().offset(b, w)), m.PathPrimitiveLineToCommand.fromPoint(a.clone().offset(b, w))], C.StrokeStyle.default1pxInstance, "size-line"), new m.PathPrimitive([new m.PathPrimitiveMoveToCommand(p, h), new m.PathPrimitiveLineToCommand(d, f), new m.PathPrimitiveMoveToCommand(y, g), new m.PathPrimitiveLineToCommand(P, S)], C.StrokeStyle.default1pxInstance), new v.TextPrimitive((a.x + i.x) / 2, (a.y + i.y) / 2, c, x.TextOwner.ExtensionLine, void 0, void 0, void 0, null, void 0, null, r.PAGE_BG_TEXTFLOOR_FILTER_IDPREFIX + this.instanceId)],
              T = new s.GroupPrimitive(I, u),
              O = this.getExtensionLineElement(T, t);
            this.changePrimitiveElement(T, O);
          }, n.prototype.hideExtensionLines = function () {
            for (var t = 0; t < this.extensionLineElements.length; t++) this.extensionLineElements[t] && this.dom.changeByFunc(this.extensionLineElements[t], function (t) {
              return t.style.display = "none";
            });
          }, n.prototype.getExtensionLineElement = function (t, e) {
            var n = this.extensionLineElements[e];
            return void 0 !== n ? this.dom.changeByFunc(n, function (t) {
              return t.style.display = "";
            }) : (n = this.createPrimitiveElement(t, this.visualizersContainer), this.extensionLineElements[e] = n), n;
          }, n.prototype.getOrCreateShapeSelection = function (t, e) {
            var n = this.selectionMap[t.key];
            return n || (n = new L(this.itemSelectionContainer, this.selectionMarksContainer, this.actualZoom, this.readOnly, this.dom, t.key, t.isLocked, t.rectangle, t.style, t.allowResizeHorizontally, t.allowResizeVertically, t.description.getParameterPoints(t)), this.selectionMap[t.key] = n), e && (e[t.key] = !0), n;
          }, n.prototype.getOrCreateConnectorSelection = function (t, e) {
            var n = this.selectionMap[t.key],
              o = t.getRenderPoints(!0),
              i = t.getRenderPoints(!1);
            return n || (n = new N(this.itemSelectionContainer, this.selectionMarksContainer, this.actualZoom, this.readOnly, this.dom, t.key, t.isLocked, t.rectangle, o, t.style, t.styleText, t.enableText, t.texts.map(function (e) {
              var n = p.GeometryUtils.getPathPointByPosition(i, e.position);
              return {
                text: t.getText(e.position),
                point: n[0],
                pointIndex: n[1],
                pos: e.position
              };
            }).sort(function (t, e) {
              return t.pos - e.pos;
            }), t.points, t.properties.lineOption), this.selectionMap[t.key] = n), e && (e[t.key] = !0), n;
          }, n.prototype.getOrCreateMultipleSelection = function (t) {
            var e = this.selectionMap[M];
            return e || (e = new j(this.itemSelectionContainer, this.selectionMarksContainer, this.actualZoom, this.readOnly, this.dom), this.selectionMap[M] = e), t[M] = !0, e;
          }, n.prototype.getMultipleSelection = function () {
            return this.selectionMap[M];
          }, n.prototype.updateShapeSelection = function (t, e) {
            t.key in this.selectionMap && (this.getOrCreateShapeSelection(t).onModelChanged(t.isLocked, t.rectangle, t.style, t.allowResizeHorizontally, t.allowResizeVertically, t.description.getParameterPoints(t)), e && e.onModelItemChanged(t.key, t.rectangle));
          }, n.prototype.updateConnectorSelection = function (t, e) {
            if (t.key in this.selectionMap) {
              var n = t.getRenderPoints(!0),
                o = t.getRenderPoints(!1);
              this.getOrCreateConnectorSelection(t).onModelChanged(t.isLocked, t.rectangle, n, t.style, t.styleText, t.enableText, t.texts.map(function (e) {
                var n = p.GeometryUtils.getPathPointByPosition(o, e.position);
                return {
                  text: t.getText(e.position),
                  pointIndex: n[1],
                  pos: e.position,
                  point: n[0]
                };
              }).sort(function (t, e) {
                return t.pos - e.pos;
              }), t.points, t.properties.lineOption), e && e.onModelItemChanged(t.key, t.rectangle);
            }
          }, n.prototype.hideOutdatedSelection = function (t) {
            var e = this;
            Object.keys(this.selectionMap).filter(function (e) {
              return !t[e];
            }).forEach(function (t) {
              e.selectionMap[t].destroy(), delete e.selectionMap[t];
            });
          }, n.prototype.selectionCanBeDrawn = function (t) {
            return !t.container || t.container.expanded && this.selectionCanBeDrawn(t.container);
          }, n.prototype.notifySelectionChanged = function (t) {
            var e = this,
              n = t.getSelectedItems(!0).filter(function (t) {
                return e.selectionCanBeDrawn(t);
              }),
              o = {},
              i = n.length > 1,
              r = t.getSelectedShapes(!0).filter(function (t) {
                return e.selectionCanBeDrawn(t);
              }),
              s = t.getSelectedConnectors(!0).filter(function (t) {
                return e.selectionCanBeDrawn(t);
              });
            if (r.forEach(function (t) {
              return e.getOrCreateShapeSelection(t, o).onSelectionChanged(i);
            }), s.forEach(function (t) {
              return e.getOrCreateConnectorSelection(t, o).onSelectionChanged(i);
            }), i) {
              var a = n.length > 0 ? n[0].strokeWidth : 0,
                c = {};
              n.filter(function (t) {
                return !t.isLocked;
              }).forEach(function (t) {
                return c[t.key] = t.rectangle;
              }), this.getOrCreateMultipleSelection(o).onSelectionChanged(!!r.filter(function (t) {
                return !t.isLocked;
              }).length, a, c);
            }
            this.hideOutdatedSelection(o);
          }, n.prototype.applyChangesCore = function (e) {
            t.prototype.applyChangesCore.call(this, e);
            var n = this.getMultipleSelection();
            n && n.onModelChanged();
          }, n.prototype.applyChange = function (t) {
            var e = this.getMultipleSelection();
            t.item instanceof d.Shape ? this.updateShapeSelection(t.item, e) : t.item instanceof f.Connector && this.updateConnectorSelection(t.item, e);
          }, n.prototype.notifyPageColorChanged = function (t) {}, n.prototype.notifyPageSizeChanged = function (t, e) {}, n.prototype.notifyActualZoomChanged = function (t) {
            var e = this;
            Object.keys(this.selectionMap).forEach(function (n) {
              return e.selectionMap[n].notifyZoomChanged(t);
            }), this.actualZoom = t;
          }, n.prototype.notifyViewAdjusted = function (t) {}, n.prototype.notifyReadOnlyChanged = function (t) {
            var e = this;
            this.readOnly = t, Object.keys(this.selectionMap).forEach(function (n) {
              return e.selectionMap[n].notifyReadOnlyChanged(t);
            });
          }, n.prototype.notifySelectionRectShow = function (t) {
            this.showSelectionRect(t.clone().multiply(this.actualZoom, this.actualZoom));
          }, n.prototype.notifySelectionRectHide = function () {
            this.hideSelectionRect();
          }, n.prototype.notifyResizeInfoShow = function (t, e) {
            this.showResizeInfo(t.clone().multiply(this.actualZoom, this.actualZoom), e);
          }, n.prototype.notifyResizeInfoHide = function () {
            this.hideResizeInfo();
          }, n.prototype.notifyConnectionPointsShow = function (t, e, o, i) {
            var r = this;
            this.hideConnectionPoints(), e.forEach(function (e, s) {
              var a = e.point.clone().multiply(r.actualZoom, r.actualZoom);
              if (i) switch (e.side) {
                case u.ConnectionPointSide.North:
                  a.y = i.y * r.actualZoom - n.connectionPointShift;
                  break;
                case u.ConnectionPointSide.South:
                  a.y = i.bottom * r.actualZoom + n.connectionPointShift;
                  break;
                case u.ConnectionPointSide.West:
                  a.x = i.x * r.actualZoom - n.connectionPointShift;
                  break;
                case u.ConnectionPointSide.East:
                  a.x = i.right * r.actualZoom + n.connectionPointShift;
              }
              r.showConnectionPoint(s, a, t, s, s === o, e.allowed);
            });
          }, n.prototype.notifyConnectionPointsHide = function () {
            this.hideConnectionPoints();
          }, n.prototype.notifyConnectionTargetShow = function (t, e) {
            if (e.allowed) {
              var o = n.correctSelectionRect(e.rect.clone().multiply(this.actualZoom, this.actualZoom), e.strokeWidth, n.connectionTargetBorderWidth, this.actualZoom, 0);
              this.showConnectionTarget(0, o);
            }
          }, n.prototype.notifyConnectionTargetHide = function () {
            this.hideConnectionTarget();
          }, n.prototype.notifyContainerTargetShow = function (t, e) {
            var o = n.correctSelectionRect(e.rect.clone().multiply(this.actualZoom, this.actualZoom), e.strokeWidth, n.connectionTargetBorderWidth, this.actualZoom, 0);
            this.showContainerTarget(0, o);
          }, n.prototype.notifyContainerTargetHide = function () {
            this.hideContainerTarget();
          }, n.prototype.notifyExtensionLinesShow = function (t) {
            var e = this;
            this.hideExtensionLines(), t.forEach(function (t, n) {
              e.showExtensionLine(n, t.type, t.segment.startPoint.clone().multiply(e.actualZoom, e.actualZoom), t.segment.endPoint.clone().multiply(e.actualZoom, e.actualZoom), t.text);
            });
          }, n.prototype.notifyExtensionLinesHide = function () {
            this.hideExtensionLines();
          }, n.prototype.notifyDragStart = function (t) {
            this.dom.changeByFunc(this.selectionMarksContainer, function (t) {
              return t.style.display = "none";
            });
          }, n.prototype.notifyDragEnd = function (t) {
            this.dom.changeByFunc(this.selectionMarksContainer, function (t) {
              return t.style.display = "";
            });
          }, n.prototype.notifyDragScrollStart = function () {}, n.prototype.notifyDragScrollEnd = function () {}, n.prototype.notifyTextInputStart = function (t, e, n, o) {
            this.dom.changeByFunc(this.visualizersContainer, function (t) {
              return t.style.display = "none";
            });
          }, n.prototype.notifyTextInputEnd = function (t, e) {
            this.dom.changeByFunc(this.visualizersContainer, function (t) {
              return t.style.display = "";
            });
          }, n.prototype.notifyTextInputPermissionsCheck = function (t, e) {}, n.correctSelectionRect = function (t, e, o, i, r) {
            void 0 === r && (r = n.selectionOffset);
            var s = S.UnitConverter.twipsToPixels(e) % 2 != S.UnitConverter.twipsToPixels(o) % 2,
              a = Math.ceil(e / 2 * i);
            t = t.clone().inflate(a, a);
            var c = Math.floor(o / 2);
            if (t.x -= c, t.y -= c, t.width += o, t.height += o, s) {
              var u = n.evenOddSelectionCorrection * (S.UnitConverter.twipsToPixels(o) % 2 == 1 ? -1 : 1);
              t = t.clone().moveRectangle(u, u);
            }
            return t.clone().inflate(r, r);
          }, n.selectionMarkSize = S.UnitConverter.pixelsToTwips(10), n.lockedSelectionMarkSize = S.UnitConverter.pixelsToTwips(8), n.selectionOffset = S.UnitConverter.pixelsToTwips(2), n.selectionRectLineWidth = S.UnitConverter.pixelsToTwips(1), n.multiSelectionRectLineWidth = S.UnitConverter.pixelsToTwips(1), n.connectionPointSmallSize = S.UnitConverter.pixelsToTwips(5), n.connectionPointLargeSize = S.UnitConverter.pixelsToTwips(12), n.connectionPointShift = S.UnitConverter.pixelsToTwips(16), n.connectionTargetBorderWidth = S.UnitConverter.pixelsToTwips(2), n.geomertyMarkSize = S.UnitConverter.pixelsToTwips(8), n.connectorPointMarkSize = S.UnitConverter.pixelsToTwips(6), n.connectorSideMarkSize = S.UnitConverter.pixelsToTwips(6), n.extensionLineWidth = S.UnitConverter.pixelsToTwips(1), n.extensionLineOffset = S.UnitConverter.pixelsToTwips(1), n.extensionLineEndingSize = S.UnitConverter.pixelsToTwips(6), n.resizeInfoOffset = S.UnitConverter.pixelsToTwips(16), n.resizeInfoTextOffset = S.UnitConverter.pixelsToTwips(2), n.resizeInfoLineWidth = S.UnitConverter.pixelsToTwips(1), n.evenOddSelectionCorrection = S.UnitConverter.pixelsToTwips(1), n;
        }(T.CanvasManager);
        e.CanvasSelectionManager = D;
        var A = function () {
            function t(t, e, n, o, i, r) {
              this.rectsContainer = t, this.marksContainer = e, this.key = n, this.zoomLevel = o, this.readOnly = i, this.dom = r, this.elements = {}, this.updatedElements = {};
            }
            return t.prototype.notifyZoomChanged = function (t) {
              this.zoomLevel !== t && (this.zoomLevel = t, this.redraw());
            }, t.prototype.notifyReadOnlyChanged = function (t) {
              this.readOnly = t, this.redraw();
            }, t.prototype.destroy = function () {
              var t = this;
              Object.keys(this.elements).forEach(function (e) {
                t.elements[e].parentNode.removeChild(t.elements[e]), delete t.elements[e];
              });
            }, t.prototype.redraw = function () {
              var t = this;
              this.updatedElements = {}, this.redrawCore(), Object.keys(this.elements).filter(function (e) {
                return !t.updatedElements[e];
              }).forEach(function (e) {
                t.elements[e].parentNode.removeChild(t.elements[e]), delete t.elements[e];
              }), this.updatedElements = {};
            }, t.prototype.drawSelectionMarks = function (t, n, o) {
              if (!this.readOnly) {
                var i = n && t.height > 3 * D.selectionMarkSize,
                  r = o && t.width > 3 * D.selectionMarkSize,
                  s = n || o;
                s && this.drawSelectionMark(0, new h.Point(t.x, t.y), D.selectionMarkSize, c.MouseEventElementType.ShapeResizeBox, c.ResizeEventSource.ResizeBox_NW, e.SELECTION_ELEMENT_CLASSNAMES.SELECTION_MARK), r && !b.Browser.TouchUI && this.drawSelectionMark(1, new h.Point(t.x + t.width / 2, t.y), D.selectionMarkSize, c.MouseEventElementType.ShapeResizeBox, c.ResizeEventSource.ResizeBox_N, e.SELECTION_ELEMENT_CLASSNAMES.SELECTION_MARK), s && this.drawSelectionMark(2, new h.Point(t.right, t.y), D.selectionMarkSize, c.MouseEventElementType.ShapeResizeBox, c.ResizeEventSource.ResizeBox_NE, e.SELECTION_ELEMENT_CLASSNAMES.SELECTION_MARK), i && !b.Browser.TouchUI && this.drawSelectionMark(3, new h.Point(t.right, t.y + t.height / 2), D.selectionMarkSize, c.MouseEventElementType.ShapeResizeBox, c.ResizeEventSource.ResizeBox_E, e.SELECTION_ELEMENT_CLASSNAMES.SELECTION_MARK), s && this.drawSelectionMark(4, new h.Point(t.right, t.bottom), D.selectionMarkSize, c.MouseEventElementType.ShapeResizeBox, c.ResizeEventSource.ResizeBox_SE, e.SELECTION_ELEMENT_CLASSNAMES.SELECTION_MARK), r && !b.Browser.TouchUI && this.drawSelectionMark(5, new h.Point(t.x + t.width / 2, t.bottom), D.selectionMarkSize, c.MouseEventElementType.ShapeResizeBox, c.ResizeEventSource.ResizeBox_S, e.SELECTION_ELEMENT_CLASSNAMES.SELECTION_MARK), s && this.drawSelectionMark(6, new h.Point(t.x, t.bottom), D.selectionMarkSize, c.MouseEventElementType.ShapeResizeBox, c.ResizeEventSource.ResizeBox_SW, e.SELECTION_ELEMENT_CLASSNAMES.SELECTION_MARK), i && !b.Browser.TouchUI && this.drawSelectionMark(7, new h.Point(t.x, t.y + t.height / 2), D.selectionMarkSize, c.MouseEventElementType.ShapeResizeBox, c.ResizeEventSource.ResizeBox_W, e.SELECTION_ELEMENT_CLASSNAMES.SELECTION_MARK);
              }
            }, t.prototype.drawSelectionMark = function (t, e, n, o, i, r) {
              var s = this;
              this.getOrCreateElement("SM" + t, new g.RectanglePrimitive(e.x - n / 2, e.y - n / 2, n, n, null, r, void 0, function (t) {
                a.RenderUtils.setElementEventData(t, o, s.key, i);
              }), this.marksContainer);
            }, t.prototype.drawSelectionRect = function (t, e, n) {
              var o = new g.RectanglePrimitive(t.x, t.y, t.width, t.height, C.StrokeStyle.default1pxInstance, n, void 0, function (t) {
                a.RenderUtils.setElementEventData(t, e, "-1", -1);
              });
              this.getOrCreateElement("shapeSelection", o, this.rectsContainer);
            }, t.prototype.getOrCreateElement = function (t, e, n) {
              var o = this.elements[t];
              return o || (o = e.createElement(function (t) {
                return n.appendChild(t);
              }), this.elements[t] = o), this.updatedElements[t] = !0, this.dom.changeByPrimitive(o, e), o;
            }, t;
          }(),
          R = function (t) {
            function e(e, n, o, i, r, s, a, c) {
              var u = t.call(this, e, n, o, i, r, s) || this;
              return u.isLocked = a, u.rectangle = c, u;
            }
            return i(e, t), e.prototype.onSelectionChanged = function (t) {
              this.isMultipleSelection !== t && (this.isMultipleSelection = t, this.redraw());
            }, e.prototype.isLockedRender = function () {
              return this.isLocked && !this.readOnly;
            }, e.prototype.drawLockedSelectionMark = function (t, e, n, o) {
              var i = new m.PathPrimitive([new m.PathPrimitiveMoveToCommand(e.x - n / 2, e.y - n / 2), new m.PathPrimitiveLineToCommand(e.x + n / 2, e.y + n / 2), new m.PathPrimitiveMoveToCommand(e.x + n / 2, e.y - n / 2), new m.PathPrimitiveLineToCommand(e.x - n / 2, e.y + n / 2)], null, o);
              this.getOrCreateElement("LSM" + t, i, this.marksContainer);
            }, e;
          }(A),
          j = function (t) {
            function n(e, n, o, i, r) {
              var s = t.call(this, e, n, "-1", o, i, r) || this;
              return s.rectangles = {}, s;
            }
            return i(n, t), n.prototype.onModelItemChanged = function (t, e) {
              t in this.rectangles && (this.rectangles[t] = e);
            }, n.prototype.onModelChanged = function () {
              this.redraw();
            }, n.prototype.onSelectionChanged = function (t, e, n) {
              this.needDrawSelectionMarks = t, this.strokeWidth = e, this.rectangles = n, this.redraw();
            }, n.prototype.redrawCore = function () {
              var t = this,
                n = Object.keys(this.rectangles);
              if (n.length) {
                var o = p.GeometryUtils.getCommonRectangle(n.map(function (e) {
                    return t.rectangles[e];
                  })).clone().multiply(this.zoomLevel, this.zoomLevel),
                  i = D.correctSelectionRect(o, this.strokeWidth, D.selectionRectLineWidth, this.zoomLevel);
                this.drawSelectionRect(i, c.MouseEventElementType.SelectionRect, e.SELECTION_ELEMENT_CLASSNAMES.ITEMS_SELECTION_RECT), this.needDrawSelectionMarks && this.drawSelectionMarks(o, !0, !0);
              }
            }, n;
          }(A),
          L = function (t) {
            function n(e, n, o, i, r, s, a, c, u, p, h, l) {
              var d = t.call(this, e, n, s, o, i, r, a, c) || this;
              return d.style = u, d.allowResizeHorizontally = p, d.allowResizeVertically = h, d.shapeParameterPoints = l, d;
            }
            return i(n, t), n.prototype.onModelChanged = function (t, e, n, o, i, r) {
              this.isLocked = t, this.rectangle = e, this.style = n, this.allowResizeHorizontally = o, this.allowResizeVertically = i, this.shapeParameterPoints = r, this.redraw();
            }, n.prototype.redrawCore = function () {
              var t = this.rectangle.clone().multiply(this.zoomLevel, this.zoomLevel);
              this.isLockedRender() ? this.drawLockedSelection(t) : this.drawUnlockedSelection(t);
            }, n.prototype.drawLockedSelection = function (t) {
              this.drawLockedSelectionMark(0, new h.Point(t.x, t.y), D.lockedSelectionMarkSize, e.SELECTION_ELEMENT_CLASSNAMES.LOCKED_SELECTION_MARK), this.drawLockedSelectionMark(1, new h.Point(t.right, t.y), D.lockedSelectionMarkSize, e.SELECTION_ELEMENT_CLASSNAMES.LOCKED_SELECTION_MARK), this.drawLockedSelectionMark(2, new h.Point(t.right, t.bottom), D.lockedSelectionMarkSize, e.SELECTION_ELEMENT_CLASSNAMES.LOCKED_SELECTION_MARK), this.drawLockedSelectionMark(3, new h.Point(t.x, t.bottom), D.lockedSelectionMarkSize, e.SELECTION_ELEMENT_CLASSNAMES.LOCKED_SELECTION_MARK);
            }, n.prototype.drawUnlockedSelection = function (t) {
              var n = D.correctSelectionRect(t, this.style.strokeWidth, D.selectionRectLineWidth, this.zoomLevel);
              this.drawSelectionRect(n, c.MouseEventElementType.SelectionRect, this.isMultipleSelection ? e.SELECTION_ELEMENT_CLASSNAMES.ITEM_MULTI_SELECTION : e.SELECTION_ELEMENT_CLASSNAMES.ITEM_SELECTION_RECT), this.isMultipleSelection || this.drawSelectionMarks(t, this.allowResizeHorizontally, this.allowResizeVertically), this.drawShapeParameterPoints();
            }, n.prototype.drawShapeParameterPoints = function () {
              var t = this;
              this.readOnly || this.shapeParameterPoints.forEach(function (e, n) {
                var o = e.point.clone().multiply(t.zoomLevel, t.zoomLevel);
                t.drawShapeParameterPoint(o, n, e.key);
              });
            }, n.prototype.drawShapeParameterPoint = function (t, e, n) {
              var o = this,
                i = D.geomertyMarkSize,
                r = new g.RectanglePrimitive(t.x - i / 2, t.y - i / 2, i, i, null, "geometry-mark", void 0, function (t) {
                  a.RenderUtils.setElementEventData(t, c.MouseEventElementType.ShapeParameterBox, o.key, n);
                });
              this.getOrCreateElement("pp" + e.toString(), r, this.marksContainer);
            }, n;
          }(R),
          N = function (t) {
            function n(e, n, o, i, r, s, a, c, u, p, h, l, d, f, y) {
              var g = t.call(this, e, n, s, o, i, r, a, c) || this;
              return g.renderPoints = u, g.style = p, g.styleText = h, g.enableText = l, g.texts = d, g.points = f, g.lineType = y, g;
            }
            return i(n, t), n.prototype.onModelChanged = function (t, e, n, o, i, r, s, a, c) {
              this.isLocked = t, this.rectangle = e, this.renderPoints = n, this.style = o, this.styleText = i, this.enableText = r, this.texts = s, this.points = a, this.lineType = c, this.redraw();
            }, n.prototype.redrawCore = function () {
              this.isLockedRender() ? this.drawLockedSelection() : this.drawUnlockedSelection();
            }, n.prototype.drawLockedSelection = function () {
              var t = this;
              this.renderPoints.forEach(function (n, o) {
                t.drawLockedSelectionMark(o, n, D.lockedSelectionMarkSize, e.SELECTION_ELEMENT_CLASSNAMES.LOCKED_SELECTION_MARK);
              });
            }, n.prototype.drawUnlockedSelection = function () {
              this.drawConnectorSelection(), this.isMultipleSelection || this.readOnly || this.drawConnectorSelectionMarks();
            }, n.prototype.drawConnectorSelection = function () {
              var t = [],
                n = [],
                o = this.isMultipleSelection ? e.SELECTION_ELEMENT_CLASSNAMES.CONNECTOR_MULTI_SELECTION : e.SELECTION_ELEMENT_CLASSNAMES.CONNECTOR_SELECTION;
              this.populateSelectionPrimitiveCommands(t, n);
              var i = new m.PathPrimitive(t.concat(n.reverse()), C.StrokeStyle.default1pxInstance, o);
              this.getOrCreateElement("CS", i, this.rectsContainer);
            }, n.prototype.populateSelectionPrimitiveCommands = function (t, e) {
              for (var n, o, i, r, s = this.texts, a = this.styleText.getAlignment(), c = this.createNotSkippedRenderPoints(), u = this.zoomLevel, h = this.style.strokeWidthPx, l = this.getSelectionOffset(h), d = h % 2 == 0, f = c[0], y = 0, g = 1, v = void 0; v = c[g]; g++) {
                var P = c[g + 1];
                if (void 0 === n) {
                  if (o = O.Metrics.euclideanDistance(f, v), _.MathUtils.numberCloseTo(o, 0)) continue;
                  n = p.GeometryUtils.getSelectionOffsetPoint(f, v, o).multiply(l, l);
                }
                if (P) {
                  if (r = O.Metrics.euclideanDistance(v, P), _.MathUtils.numberCloseTo(r, 0)) continue;
                  i = p.GeometryUtils.getSelectionOffsetPoint(v, P, r).multiply(l, l);
                }
                var C = n.x,
                  S = n.y,
                  x = -C,
                  b = -S,
                  w = i && i.x,
                  I = i && i.y,
                  T = i && -i.x,
                  E = i && -i.y;
                for (d && (x > 0 ? x -= D.evenOddSelectionCorrection : C > 0 && (C -= D.evenOddSelectionCorrection), b > 0 ? b -= D.evenOddSelectionCorrection : S > 0 && (S -= D.evenOddSelectionCorrection), T > 0 ? T -= D.evenOddSelectionCorrection : w > 0 && (w -= D.evenOddSelectionCorrection), E > 0 ? E -= D.evenOddSelectionCorrection : I > 0 && (I -= D.evenOddSelectionCorrection)); s[y] && s[y].pointIndex <= g;) {
                  var M = s[y],
                    A = this.getConnectorSelectionTextSize(M.text, l),
                    R = p.GeometryUtils.getSelectionTextStartEndPoints(f, v, o, M.point, A, a);
                  s[y].pointIndex < g ? (f = R[1], t.push(m.PathPrimitiveMoveToCommand.fromPoint(f.clone().offset(C, S).multiply(u, u))), e.push(m.PathPrimitiveLineToCommand.fromPoint(f.clone().offset(x, b).multiply(u, u)))) : (t.length || (t.push(m.PathPrimitiveMoveToCommand.fromPoint(f.clone().offset(C, S).multiply(u, u))), e.push(m.PathPrimitiveLineToCommand.fromPoint(f.clone().offset(x, b).multiply(u, u)))), t.push(m.PathPrimitiveLineToCommand.fromPoint(R[0].clone().offset(C, S).multiply(u, u))), t.push(m.PathPrimitiveMoveToCommand.fromPoint(R[1].clone().offset(C, S).multiply(u, u))), e.push(m.PathPrimitiveMoveToCommand.fromPoint(R[0].clone().offset(x, b).multiply(u, u))), e.push(m.PathPrimitiveLineToCommand.fromPoint(R[1].clone().offset(x, b).multiply(u, u))), f = R[1]), y++;
                }
                t.length || (t.push(m.PathPrimitiveMoveToCommand.fromPoint(f.clone().offset(C, S).multiply(u, u))), e.push(m.PathPrimitiveLineToCommand.fromPoint(f.clone().offset(x, b).multiply(u, u)))), P ? (p.GeometryUtils.addSelectedLinesTo(f, v, P, C, S, x, b, w, I, T, E, function (e, n) {
                  return t.push(new m.PathPrimitiveLineToCommand(e * u, n * u));
                }, function (t, n) {
                  return e.push(new m.PathPrimitiveLineToCommand(t * u, n * u));
                }), n = i, o = r) : (t.push(m.PathPrimitiveLineToCommand.fromPoint(v.clone().offset(C, S).multiply(u, u))), e.push(m.PathPrimitiveMoveToCommand.fromPoint(v.clone().offset(x, b).multiply(u, u)))), f = v;
              }
            }, n.prototype.createNotSkippedRenderPoints = function () {
              var t = this.renderPoints.map(function (t) {
                return t.clone();
              });
              return this.lineType === y.ConnectorLineOption.Straight ? E.ModelUtils.skipUnnecessaryRenderPoints(t) : E.ModelUtils.skipUnnecessaryRightAngleRenderPoints(t), t.filter(function (t) {
                return !t.skipped;
              });
            }, n.prototype.getSelectionOffset = function (t) {
              return D.selectionOffset + S.UnitConverter.pixelsToTwips(Math.round(t / 2) + (t + 1) % 2);
            }, n.prototype.getConnectorSelectionTextSize = function (t, e) {
              return this.dom.measurer.measureTextLine(t, this.styleText, x.TextOwner.Connector).applyConverter(S.UnitConverter.pixelsToTwips).clone().offset(e, e).nonNegativeSize();
            }, n.prototype.drawConnectorSelectionMarks = function () {
              var t = this,
                n = this.points.length - 1;
              this.points.forEach(function (o, i) {
                var r = 0 === i || i === n,
                  s = r ? e.SELECTION_ELEMENT_CLASSNAMES.SELECTION_MARK : e.SELECTION_ELEMENT_CLASSNAMES.CONNECTOR_POINT_MARK,
                  a = r ? D.selectionMarkSize : D.connectorPointMarkSize;
                r || t.lineType === y.ConnectorLineOption.Straight ? t.drawSelectionMark(i, o.clone().multiply(t.zoomLevel, t.zoomLevel), a, c.MouseEventElementType.ConnectorPoint, i, s) : t.drawSelectionMark(i, o.clone().multiply(t.zoomLevel, t.zoomLevel), a, c.MouseEventElementType.Undefined, -1, s + " disabled");
              }), this.drawConnectorSideMarks();
            }, n.prototype.drawConnectorSideMarks = function () {
              var t,
                n,
                o = this,
                i = this.lineType === y.ConnectorLineOption.Straight ? c.MouseEventElementType.ConnectorSide : c.MouseEventElementType.ConnectorOrthogonalSide;
              this.renderPoints.forEach(function (r, s) {
                if (!r.skipped) {
                  if (void 0 !== t && o.canDrawConnectorSideMark(r, t)) {
                    var a = o.lineType === y.ConnectorLineOption.Orthogonal ? r.x - t.x === 0 ? "vertical" : "horizontal" : "";
                    o.drawSelectionMark(o.points.length + s - 1, new h.Point(t.x + (r.x - t.x) / 2, t.y + (r.y - t.y) / 2).clone().multiply(o.zoomLevel, o.zoomLevel), D.connectorSideMarkSize, i, n + "_" + s, e.SELECTION_ELEMENT_CLASSNAMES.CONNECTOR_SIDE_MARK + " " + a);
                  }
                  t = r, n = s;
                }
              });
            }, n.prototype.canDrawConnectorSideMark = function (t, e) {
              if (this.lineType === y.ConnectorLineOption.Straight) {
                var n = D.selectionMarkSize + D.connectorSideMarkSize;
                return O.Metrics.euclideanDistance(t, e) > n;
              }
              if (this.lineType === y.ConnectorLineOption.Orthogonal) {
                var o = 0 === e.pointIndex,
                  i = p.GeometryUtils.areDuplicatedPoints(this.points[this.points.length - 1], t);
                if (o && i) return O.Metrics.euclideanDistance(t, e) > 2 * f.Connector.minOffset;
                if (!o && i || o && !i) return O.Metrics.euclideanDistance(t, e) > f.Connector.minOffset;
                n = D.selectionMarkSize + D.connectorSideMarkSize;
                return O.Metrics.euclideanDistance(t, e) > n;
              }
              return !1;
            }, n;
          }(R);
      },
      9707: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.FilterPrimitive = void 0;
        var r = n(8509),
          s = function (t) {
            function e(e, n, o, i, r) {
              var s = t.call(this) || this;
              return s.id = e, s.x = n, s.y = o, s.width = i, s.height = r, s;
            }
            return i(e, t), e.prototype.createMainElement = function () {
              var t = document.createElementNS(r.svgNS, "filter");
              return t.setAttribute("id", this.id), t;
            }, e.prototype.applyElementProperties = function (e, n) {
              this.id && e.setAttribute("id", this.id), this.setUnitAttribute(e, "x", this.x), this.setUnitAttribute(e, "y", this.y), this.setUnitAttribute(e, "width", this.width), this.setUnitAttribute(e, "height", this.height), this.setPositionCorrectionAttribute(e), t.prototype.applyElementProperties.call(this, e, n);
            }, e;
          }(n(8309).SvgPrimitive);
        e.FilterPrimitive = s;
      },
      9713: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ChangeFontSizeCommand = void 0;
        var r = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(e, t), e.prototype.getStyleProperty = function () {
            return "font-size";
          }, e;
        }(n(6994).ChangeStyleTextPropertyCommand);
        e.ChangeFontSizeCommand = r;
      },
      9735: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ChangeCustomDataHistoryItem = void 0;
        var r = n(2616),
          s = n(41),
          a = function (t) {
            function e(e, n) {
              var o = t.call(this) || this;
              return o.itemKey = e, o.customData = s.ObjectUtils.cloneObject(n), o;
            }
            return i(e, t), e.prototype.redo = function (t) {
              var e = t.model.findItem(this.itemKey);
              this.oldCustomData = s.ObjectUtils.cloneObject(e.customData), t.changeCustomData(e, this.customData);
            }, e.prototype.undo = function (t) {
              var e = t.model.findItem(this.itemKey);
              t.changeCustomData(e, this.oldCustomData);
            }, e;
          }(r.HistoryItem);
        e.ChangeCustomDataHistoryItem = a;
      },
      9758: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.StoredDataShapeDescription = void 0;
        var r = n(3190),
          s = n(3255),
          a = n(6208),
          c = n(1280),
          u = n(3844),
          p = function (t) {
            function e() {
              return t.call(this, void 0, !0) || this;
            }
            return i(e, t), Object.defineProperty(e.prototype, "key", {
              get: function () {
                return s.ShapeTypes.StoredData;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "keepRatioOnAutoSize", {
              get: function () {
                return !1;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.createShapePrimitives = function (t) {
              var n = t.rectangle,
                o = n.x,
                i = n.y,
                r = n.right,
                s = n.bottom,
                c = n.width * e.arcWidthRatio;
              return [new a.PathPrimitive([new a.PathPrimitiveMoveToCommand(r, i), new a.PathPrimitiveLineToCommand(o + c / 2, i), new a.PathPrimitiveArcToCommand(c / 2, (s - i) / 2, 0, !1, !1, o + c / 2, s), new a.PathPrimitiveLineToCommand(r, s), new a.PathPrimitiveArcToCommand(c / 2, (s - i) / 2, 0, !1, !0, r, i)], t.style)];
            }, e.prototype.getTextRectangle = function (t) {
              var n = t.rectangle,
                o = n.width * e.arcWidthRatio / 2;
              return n.clone().resize(-o - 2 * c.ShapeTextPadding, -2 * c.ShapeTextPadding).moveRectangle(c.ShapeTextPadding, c.ShapeTextPadding).nonNegativeSize();
            }, e.prototype.getSizeByText = function (t, n) {
              return new u.Size((t.width + 2 * c.ShapeTextPadding) / (1 - e.arcWidthRatio / 2), t.height + 2 * c.ShapeTextPadding);
            }, e.arcWidthRatio = .2, e;
          }(r.RectangleShapeDescription);
        e.StoredDataShapeDescription = p;
      },
      9763: (t, e) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ShapeParameterPoint = void 0;
        var n = function (t, e) {
          this.key = t, this.point = e;
        };
        e.ShapeParameterPoint = n;
      },
      9782: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MouseHandlerDefaultReadOnlyTouchState = void 0;
        var r = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(e, t), e.prototype.canDragObjectOnMouseDown = function (t) {
            return !1;
          }, e.prototype.canExpandContainerOnMouseDown = function (t) {
            return !1;
          }, e.prototype.canClearSelectionOnMouseDown = function () {
            return !0;
          }, e.prototype.canSelectOnMouseUp = function (t) {
            return !this.inSelection(t);
          }, e.prototype.canClearSelectionOnMouseUp = function () {
            return !1;
          }, e;
        }(n(9157).MouseHandlerDefaultReadOnlyState);
        e.MouseHandlerDefaultReadOnlyTouchState = r;
      },
      9784: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ExportJpgCommand = void 0;
        var r = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(e, t), e.prototype.getExtension = function () {
            return "jpg";
          }, e.prototype.getExportFunc = function () {
            return this.exporter.exportJpg;
          }, e;
        }(n(6634).ExportImageCommand);
        e.ExportJpgCommand = r;
      },
      9829: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.EllipseShapeDescription = void 0;
        var r = n(1280),
          s = n(3844),
          a = n(7345),
          c = n(3255),
          u = n(41),
          p = n(4412),
          h = function (t) {
            function e(e) {
              return t.call(this, new s.Size(r.ShapeDefaultDimension, .75 * r.ShapeDefaultDimension), e) || this;
            }
            return i(e, t), Object.defineProperty(e.prototype, "key", {
              get: function () {
                return c.ShapeTypes.Ellipse;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "keepRatioOnAutoSize", {
              get: function () {
                return !1;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.getTextRectangle = function (t) {
              var e = u.GeometryUtils.getMaxRectangleEnscribedInEllipse(t.size);
              return p.Rectangle.fromGeometry(t.position.clone().offset((t.size.width - e.width) / 2, (t.size.height - e.height) / 2), e);
            }, e.prototype.getSizeByText = function (t, e) {
              return u.GeometryUtils.getEllipseByEnscribedRectangle(t);
            }, e.prototype.createShapePrimitives = function (t) {
              var e = t.rectangle,
                n = e.width,
                o = e.height,
                i = e.center,
                r = i.x,
                s = i.y;
              return [new a.EllipsePrimitive(r, s, n / 2, o / 2, t.style)];
            }, e;
          }(r.ShapeDescription);
        e.EllipseShapeDescription = h;
      },
      9860: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.VisualizerManager = void 0;
        var r = n(7873),
          s = n(5148),
          a = n(3788),
          c = n(5428),
          u = n(5719),
          p = n(8408),
          h = n(41),
          l = n(476),
          d = n(5327),
          f = n(9700),
          y = n(1922),
          g = n(8426),
          m = n(5978),
          v = n(815),
          P = n(820),
          C = function (t) {
            function e(e, n, o, i, c) {
              void 0 === c && (c = i.readOnly);
              var p = t.call(this) || this;
              return p.selection = e, p.model = n, p.eventManager = o, p.settings = i, p.readOnly = c, p.onVisualizersUpdate = new h.EventDispatcher(), p.connectionPointsVisualizer = new u.ConnectionPointsVisualizer(p.onVisualizersUpdate), p.connectionPointsVisualizer = new u.ConnectionPointsVisualizer(p.onVisualizersUpdate), p.connectionTargetVisualizer = new r.ConnectionTargetVisualizer(p.onVisualizersUpdate), p.containerTargetVisualizer = new s.ContainerTargetVisualizer(p.onVisualizersUpdate), p.extensionLinesVisualizer = new a.ExtensionLinesVisualizer(p.onVisualizersUpdate), p.resizeInfoVisualizer = new g.ResizeInfoVisualizer(p.onVisualizersUpdate), p.selectionRectangleVisualizer = new m.SelectionRectVisualizer(p.onVisualizersUpdate), p;
            }
            return i(e, t), e.prototype.initialize = function (t) {
              this.model = t;
            }, e.prototype.onMouseDown = function (t) {}, e.prototype.onMouseUp = function (t) {}, e.prototype.onMouseEnter = function (t) {}, e.prototype.onMouseLeave = function (t) {
              this.resetConnectionPoints(), this.resetConnectionTarget(), this.resetExtensionLines(), this.resetContainerTarget(), this.resetResizeInfo(), this.resetSelectionRectangle();
            }, e.prototype.onBlur = function (t) {}, e.prototype.onFocus = function (t) {}, e.prototype.updateConnections = function (t, e, n) {
              var o = -1;
              n && e === c.MouseEventElementType.ShapeConnectionPoint && (o = parseInt(n));
              var i = t && (!t.allowResizeHorizontally && !t.allowResizeVertically || t.isLocked);
              this.setConnectionPoints(t, e, o, i);
            }, e.prototype.setConnectionPoints = function (t, e, n, o) {
              if (this.eventManager.isFocused()) if (!t || e !== c.MouseEventElementType.Shape && e !== c.MouseEventElementType.ShapeResizeBox && e !== c.MouseEventElementType.ShapeConnectionPoint || void 0 === t) this.connectionPointsVisualizer.reset();else {
                var i = t.key,
                  r = this.selection.hasKey(i),
                  s = t.getConnectionPoints();
                this.connectionPointsVisualizer.setPoints(i, s.map(function (e) {
                  return new u.ConnectionPointInfo(e, t.getConnectionPointSide(e));
                }), n, r && !o && t.rectangle);
              }
            }, e.prototype.setConnectionPointIndex = function (t) {
              this.connectionPointsVisualizer.setPointIndex(t);
            }, e.prototype.updateConnectionPoints = function () {
              void 0 !== this.model.findItem(this.connectionPointsVisualizer.getKey()) ? this.connectionPointsVisualizer.update() : this.connectionPointsVisualizer.reset();
            }, e.prototype.resetConnectionPoints = function () {
              this.connectionPointsVisualizer.reset();
            }, e.prototype.setConnectionTarget = function (t, e) {
              !t || e !== c.MouseEventElementType.Shape && e !== c.MouseEventElementType.ShapeConnectionPoint ? this.connectionTargetVisualizer.reset() : this.connectionTargetVisualizer.setTargetRect(t.key, t.rectangle, t.strokeWidth);
            }, e.prototype.resetConnectionTarget = function () {
              this.connectionTargetVisualizer.reset();
            }, e.prototype.setContainerTarget = function (t, e) {
              t && !t.isLocked && e === c.MouseEventElementType.Shape && t.enableChildren ? this.containerTargetVisualizer.setTargetRect(t.key, t.rectangle, t.strokeWidth) : this.containerTargetVisualizer.reset();
            }, e.prototype.resetContainerTarget = function () {
              this.containerTargetVisualizer.reset();
            }, e.prototype.setExtensionLines = function (t) {
              var e = this;
              if (this.eventManager.isFocused()) {
                this.extensionLinesVisualizer.reset();
                var n = y.ModelUtils.createRectangle(t.filter(function (t) {
                  return t;
                }));
                this.addPageExtensionLines(n), this.model.items.forEach(function (o) {
                  t.indexOf(o) > -1 || o instanceof p.Shape && e.addShapeExtensionLines(o, n);
                });
              }
            }, e.prototype.addPageExtensionLines = function (t) {
              for (var e = Math.round(this.model.size.width / this.model.pageWidth), n = Math.round(this.model.size.height / this.model.pageHeight), o = 0; o < e; o++) for (var i = 0; i < n; i++) {
                var r = new d.Point(o * this.model.pageWidth + this.model.pageWidth / 2, i * this.model.pageHeight + this.model.pageHeight / 2);
                if (Math.abs(t.center.x - r.x) < this.settings.gridSize / 2) {
                  var s = new l.Segment(new d.Point(t.center.x, 0), new d.Point(t.center.x, this.model.size.height));
                  this.extensionLinesVisualizer.addSegment(a.ExtensionLineType.HorizontalCenterToPageCenter, s, "");
                }
                if (Math.abs(t.center.y - r.y) < this.settings.gridSize / 2) {
                  s = new l.Segment(new d.Point(0, t.center.y), new d.Point(this.model.size.width, t.center.y));
                  this.extensionLinesVisualizer.addSegment(a.ExtensionLineType.VerticalCenterToPageCenter, s, "");
                }
                if (Math.abs(t.x - r.x) < this.settings.gridSize / 2) {
                  s = new l.Segment(new d.Point(t.x, 0), new d.Point(t.x, this.model.size.height));
                  this.extensionLinesVisualizer.addSegment(a.ExtensionLineType.LeftToPageCenter, s, "");
                }
                if (Math.abs(t.y - r.y) < this.settings.gridSize / 2) {
                  s = new l.Segment(new d.Point(0, t.y), new d.Point(this.model.size.width, t.y));
                  this.extensionLinesVisualizer.addSegment(a.ExtensionLineType.TopToPageCenter, s, "");
                }
                if (Math.abs(t.right - r.x) < this.settings.gridSize / 2) {
                  s = new l.Segment(new d.Point(t.right, 0), new d.Point(t.right, this.model.size.height));
                  this.extensionLinesVisualizer.addSegment(a.ExtensionLineType.RightToPageCenter, s, "");
                }
                if (Math.abs(t.bottom - r.y) < this.settings.gridSize / 2) {
                  s = new l.Segment(new d.Point(0, t.bottom), new d.Point(this.model.size.width, t.bottom));
                  this.extensionLinesVisualizer.addSegment(a.ExtensionLineType.BottomToPageCenter, s, "");
                }
              }
            }, e.prototype.addShapeExtensionLines = function (t, e) {
              var n,
                o,
                i,
                r,
                s,
                c,
                u,
                p,
                h = t.rectangle,
                y = t.strokeWidth - f.CanvasSelectionManager.extensionLineWidth,
                g = !0;
              e.right < h.x ? (n = e.right, i = h.x, s = n + y + f.CanvasSelectionManager.extensionLineOffset, u = i - f.CanvasSelectionManager.extensionLineOffset) : e.x > h.right && (n = e.x, i = h.right, s = n - f.CanvasSelectionManager.extensionLineOffset, u = i + y + f.CanvasSelectionManager.extensionLineOffset), e.bottom < h.y ? (o = e.bottom, r = h.y, c = o + y + f.CanvasSelectionManager.extensionLineOffset, p = r - f.CanvasSelectionManager.extensionLineOffset) : e.y > h.bottom && (o = e.y, r = h.bottom, c = o - f.CanvasSelectionManager.extensionLineOffset, p = r + y + f.CanvasSelectionManager.extensionLineOffset);
              var m = this.settings.gridSize / 2;
              if (void 0 !== s && void 0 !== u) {
                var v = this.getViewUnitText(Math.abs(n - i));
                if (Math.abs(e.center.y - h.center.y) < m) {
                  var P = new l.Segment(new d.Point(s, e.center.y), new d.Point(u, e.center.y));
                  this.extensionLinesVisualizer.addSegment(s > u ? a.ExtensionLineType.VerticalCenterAfter : a.ExtensionLineType.VerticalCenterBefore, P, g ? v : ""), g = !1;
                }
                if (e.y === h.y) {
                  P = new l.Segment(new d.Point(s, e.y), new d.Point(u, h.y));
                  this.extensionLinesVisualizer.addSegment(s > u ? a.ExtensionLineType.TopToTopAfter : a.ExtensionLineType.TopToTopBefore, P, g ? v : "");
                }
                if (e.bottom === h.bottom) {
                  P = new l.Segment(new d.Point(s, e.bottom + y), new d.Point(u, h.bottom + y));
                  this.extensionLinesVisualizer.addSegment(s > u ? a.ExtensionLineType.BottomToBottomAfter : a.ExtensionLineType.BottomToBottomBefore, P, g ? v : "");
                }
                if (e.y === h.bottom) {
                  P = new l.Segment(new d.Point(s, e.y), new d.Point(u, h.bottom + y));
                  this.extensionLinesVisualizer.addSegment(s > u ? a.ExtensionLineType.TopToBottomAfter : a.ExtensionLineType.TopToBottomBefore, P, g ? v : "");
                }
                if (e.bottom === h.y) {
                  P = new l.Segment(new d.Point(s, e.bottom + y), new d.Point(u, h.y));
                  this.extensionLinesVisualizer.addSegment(s > u ? a.ExtensionLineType.BottomToTopAfter : a.ExtensionLineType.BottomToTopBefore, P, g ? v : "");
                }
              }
              if (void 0 !== c && void 0 !== p) {
                v = this.getViewUnitText(Math.abs(o - r));
                if (Math.abs(e.center.x - h.center.x) < m) {
                  P = new l.Segment(new d.Point(e.center.x, c), new d.Point(e.center.x, p));
                  this.extensionLinesVisualizer.addSegment(c > p ? a.ExtensionLineType.HorizontalCenterBelow : a.ExtensionLineType.HorizontalCenterAbove, P, g ? v : ""), g = !1;
                }
                if (e.x === h.x) {
                  P = new l.Segment(new d.Point(e.x, c), new d.Point(h.x, p));
                  this.extensionLinesVisualizer.addSegment(c > p ? a.ExtensionLineType.LeftToLeftBelow : a.ExtensionLineType.LeftToLeftAbove, P, g ? v : "");
                }
                if (e.right === h.right) {
                  P = new l.Segment(new d.Point(e.right + y, c), new d.Point(h.right + y, p));
                  this.extensionLinesVisualizer.addSegment(c > p ? a.ExtensionLineType.RightToRightBelow : a.ExtensionLineType.RightToRightAbove, P, g ? v : "");
                }
                if (e.x === h.right) {
                  P = new l.Segment(new d.Point(e.x, c), new d.Point(h.right + y, p));
                  this.extensionLinesVisualizer.addSegment(c > p ? a.ExtensionLineType.LeftToRightBelow : a.ExtensionLineType.LeftToRightAbove, P, g ? v : "");
                }
                if (e.right === h.x) {
                  P = new l.Segment(new d.Point(e.right + y, c), new d.Point(h.x, p));
                  this.extensionLinesVisualizer.addSegment(c > p ? a.ExtensionLineType.RightToLeftBelow : a.ExtensionLineType.RightToLeftAbove, P, g ? v : "");
                }
              }
            }, e.prototype.resetExtensionLines = function () {
              this.extensionLinesVisualizer.reset();
            }, e.prototype.setResizeInfo = function (t) {
              var e = y.ModelUtils.createRectangle(t),
                n = new d.Point(e.center.x, e.bottom + f.CanvasSelectionManager.resizeInfoOffset),
                o = this.getViewUnitText(e.width) + " x " + this.getViewUnitText(e.height);
              this.resizeInfoVisualizer.set(n, o);
            }, e.prototype.resetResizeInfo = function () {
              this.resizeInfoVisualizer.reset();
            }, e.prototype.setSelectionRectangle = function (t) {
              this.selectionRectangleVisualizer.setRectangle(t);
            }, e.prototype.resetSelectionRectangle = function () {
              this.selectionRectangleVisualizer.reset();
            }, e.prototype.getViewUnitText = function (t) {
              return y.ModelUtils.getUnitText(this.settings.viewUnits, P.DiagramLocalizationService.unitItems, P.DiagramLocalizationService.formatUnit, t);
            }, e.prototype.notifyReadOnlyChanged = function (t) {
              this.readOnly = t, this.readOnly && (this.resetConnectionPoints(), this.resetConnectionTarget(), this.resetExtensionLines(), this.resetContainerTarget(), this.resetResizeInfo(), this.resetSelectionRectangle());
            }, e.prototype.notifyDragStart = function (t) {}, e.prototype.notifyDragEnd = function (t) {}, e.prototype.notifyDragScrollStart = function () {}, e.prototype.notifyDragScrollEnd = function () {}, e.prototype.onUpdateUnlocked = function (t) {}, e;
          }(v.BatchUpdatableObject);
        e.VisualizerManager = C;
      },
      9901: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MultipleDocumentsShapeDescription = void 0;
        var r = n(3255),
          s = n(6208),
          a = n(268),
          c = n(5654),
          u = n(2136),
          p = n(1280),
          h = n(3844),
          l = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), Object.defineProperty(e.prototype, "key", {
              get: function () {
                return r.ShapeTypes.MultipleDocuments;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "keepRatioOnAutoSize", {
              get: function () {
                return !1;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.createShapePrimitives = function (t, n) {
              var o = t.rectangle,
                i = t.rectangle,
                r = i.width,
                s = i.height,
                a = n ? e.documentsOffsetRatioForToolbox : e.documentsOffsetRatio,
                c = Math.ceil(r * a),
                p = Math.ceil(s * a),
                h = (o = o.clone().inflate(-c, -p).clone().moveRectangle(-c, -p)).clone().moveRectangle(c, p),
                l = h.clone().moveRectangle(c, p),
                d = u.RenderUtils.generateSvgElementId("clipRect");
              return [].concat(this.createDocumentPrimitives(o, t.style, d + "1", h)).concat(this.createDocumentPrimitives(h, t.style, d + "2", l)).concat(this.createDocumentPrimitives(l, t.style));
            }, e.prototype.createDocumentPrimitives = function (t, e, n, o) {
              var i = t.x,
                r = t.y,
                u = t.right,
                p = t.bottom,
                h = t.width,
                l = t.height,
                d = t.center.x,
                f = l * a.DocumentShapeDescription.curveOffsetRatio,
                y = [];
              return y = y.concat([new s.PathPrimitive([new s.PathPrimitiveMoveToCommand(i, r), new s.PathPrimitiveLineToCommand(u, r), new s.PathPrimitiveLineToCommand(u, p), new s.PathPrimitiveQuadraticCurveToCommand(u - .25 * h, p - 2 * f, d, p - f), new s.PathPrimitiveQuadraticCurveToCommand(i + .25 * h, p + f, i, p - f), new s.PathPrimitiveClosePathCommand()], e, void 0, o && n)]), o && n && (y = y.concat([new c.ClipPathPrimitive(n, [new s.PathPrimitive([new s.PathPrimitiveMoveToCommand(i - e.strokeWidth, r - e.strokeWidth), new s.PathPrimitiveLineToCommand(u + e.strokeWidth, r - e.strokeWidth), new s.PathPrimitiveLineToCommand(u + e.strokeWidth, o.y), new s.PathPrimitiveLineToCommand(o.x, o.y), new s.PathPrimitiveLineToCommand(o.x, p + e.strokeWidth), new s.PathPrimitiveLineToCommand(i - e.strokeWidth, p + e.strokeWidth), new s.PathPrimitiveClosePathCommand()])])])), y;
            }, e.prototype.getTextRectangle = function (t) {
              var n = t.rectangle,
                o = n.width * e.documentsOffsetRatio,
                i = n.height * e.documentsOffsetRatio;
              return (n = n.clone().inflate(-o, -i).clone().moveRectangle(-o, -i)).clone().moveRectangle(2 * o + p.ShapeTextPadding, 2 * i + p.ShapeTextPadding).clone().resize(-2 * p.ShapeTextPadding, -n.height * a.DocumentShapeDescription.curveOffsetRatio - 2 * p.ShapeTextPadding);
            }, e.prototype.getSizeByText = function (t, n) {
              return new h.Size((t.width + 2 * p.ShapeTextPadding) / (1 - 2 * e.documentsOffsetRatio), (t.height + 2 * p.ShapeTextPadding) / ((1 - a.DocumentShapeDescription.curveOffsetRatio) * (1 - e.documentsOffsetRatio))).nonNegativeSize();
            }, e.documentsOffsetRatio = .1, e.documentsOffsetRatioForToolbox = .16, e;
          }(a.DocumentShapeDescription);
        e.MultipleDocumentsShapeDescription = l;
      },
      9904: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.DelayShapeDescription = void 0;
        var r = n(3190),
          s = n(3255),
          a = n(6208),
          c = n(41),
          u = n(1280),
          p = n(3844),
          h = function (t) {
            function e() {
              var e = t.call(this, void 0, !0) || this;
              return e.defaultSize.width = e.defaultSize.height, e;
            }
            return i(e, t), Object.defineProperty(e.prototype, "key", {
              get: function () {
                return s.ShapeTypes.Delay;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "keepRatioOnAutoSize", {
              get: function () {
                return !1;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.createShapePrimitives = function (t) {
              var e = t.rectangle,
                n = e.x,
                o = e.y,
                i = e.right,
                r = e.bottom,
                s = e.center.x;
              return [new a.PathPrimitive([new a.PathPrimitiveMoveToCommand(n, o), new a.PathPrimitiveLineToCommand(s, o), new a.PathPrimitiveArcToCommand((i - n) / 2, (r - o) / 2, 0, !1, !0, s, r), new a.PathPrimitiveLineToCommand(n, r), new a.PathPrimitiveClosePathCommand()], t.style)];
            }, e.prototype.getTextRectangle = function (t) {
              var e = c.GeometryUtils.getMaxRectangleEnscribedInEllipse(t.size);
              return t.rectangle.clone().moveRectangle(u.ShapeTextPadding, u.ShapeTextPadding).setSize({
                width: e.width / 2 + t.size.width / 2 - u.ShapeTextPadding,
                height: e.height / 2 + t.size.height / 2 - u.ShapeTextPadding
              }).nonNegativeSize();
            }, e.prototype.getSizeByText = function (t, e) {
              var n = c.GeometryUtils.getEllipseByEnscribedRectangle(t);
              return new p.Size(n.width / 2 + t.width / 2 + u.ShapeTextPadding, n.height / 2 + t.height / 2 + u.ShapeTextPadding);
            }, e.arcWidthRatio = .2, e;
          }(r.RectangleShapeDescription);
        e.DelayShapeDescription = h;
      },
      9922: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CanvasItemsManager = e.CONNECTOR_CAN_MOVE = e.NOT_VALID_CSSCLASS = void 0;
        var r = n(3427),
          s = n(5428),
          a = n(6709),
          c = n(2136),
          u = n(8408),
          p = n(6320),
          h = n(750),
          l = n(5318),
          d = n(1922);
        e.NOT_VALID_CSSCLASS = "not-valid", e.CONNECTOR_CAN_MOVE = "can-move";
        var f = function (t) {
          function n(e, n, o, i) {
            var r = t.call(this, n, o, i) || this;
            return r.itemSelectorGroupContainers = {}, r.itemSelectorElements = {}, r.itemGroupContainers = {}, r.itemElements = {}, r.itemChildElements = {}, r.primitives = {}, r.selectorPrimitives = {}, r.selectedItems = {}, r.initializeContainerElements(e), r;
          }
          return i(n, t), n.prototype.initializeContainerElements = function (t) {
            this.itemSelectorsContainer = this.createAndChangePrimitiveElement(new a.GroupPrimitive([], null), t), this.itemsContainer = this.createAndChangePrimitiveElement(new a.GroupPrimitive([], null), t);
          }, n.prototype.clear = function () {
            this.primitives = {}, this.selectorPrimitives = {}, c.RenderUtils.removeContent(this.itemSelectorsContainer), c.RenderUtils.removeContent(this.itemsContainer), this.itemSelectorGroupContainers = {}, this.itemSelectorElements = {}, this.itemGroupContainers = {}, this.itemElements = {}, this.itemChildElements = {}, this.selectedItems = {};
          }, n.prototype.applyChange = function (t) {
            var e = t.item;
            return !!this.getItemParent(e.zIndex, e.container && e.container.key) && (e instanceof u.Shape ? this.applyShapeChange(e, t.type, t.isValid) : e instanceof p.Connector && this.applyConnectorChange(e, t.type, t.isValid), !0);
          }, n.prototype.setPointerEventsNone = function (t, e) {
            var n = t.style;
            void 0 !== n && void 0 !== n.pointerEvents && (n.pointerEvents = e ? "none" : "");
            for (var o = t.childNodes, i = 0; i < o.length; i++) this.setPointerEventsNone(o[i], e);
          }, n.prototype.notifyDragStart = function (t) {
            var e = this;
            t.forEach(function (t) {
              e.itemElements[t] && e.setPointerEventsNone(e.itemElements[t], !0), e.itemChildElements[t] && e.setPointerEventsNone(e.itemChildElements[t], !0), e.itemSelectorElements[t] && e.setPointerEventsNone(e.itemSelectorElements[t], !0);
            });
          }, n.prototype.notifyDragEnd = function (t) {
            var e = this;
            t.forEach(function (t) {
              e.itemElements[t] && e.setPointerEventsNone(e.itemElements[t], !1), e.itemChildElements[t] && e.setPointerEventsNone(e.itemChildElements[t], !1), e.itemSelectorElements[t] && e.setPointerEventsNone(e.itemSelectorElements[t], !1);
            });
          }, n.prototype.notifyDragScrollStart = function () {}, n.prototype.notifyDragScrollEnd = function () {}, n.prototype.notifyTextInputStart = function (t, e, n, o) {
            var i = this.itemElements[t.key];
            h.DomUtils.addClassName(i, "text-input");
          }, n.prototype.notifyTextInputEnd = function (t, e) {
            var n = this.itemElements[t.key];
            h.DomUtils.removeClassName(n, "text-input");
          }, n.prototype.notifyTextInputPermissionsCheck = function (t, n) {
            var o = this.itemElements[t.key];
            n ? h.DomUtils.removeClassName(o, e.NOT_VALID_CSSCLASS) : h.DomUtils.addClassName(o, e.NOT_VALID_CSSCLASS);
          }, n.prototype.notifyActualZoomChanged = function (t) {
            var e = "scale(" + t + ")";
            this.dom.changeByFunc(this.itemsContainer, function (t) {
              return t.setAttribute("transform", e);
            }), this.dom.changeByFunc(this.itemSelectorsContainer, function (t) {
              return t.setAttribute("transform", e);
            }), this.actualZoom = t;
          }, n.prototype.notifyViewAdjusted = function (t) {}, n.prototype.invalidatePrimitives = function (t) {
            this.primitives[t.key] && (this.primitives[t.key].forEach(function (t) {
              t.dispose();
            }), delete this.primitives[t.key]), this.selectorPrimitives[t.key] && (this.selectorPrimitives[t.key].forEach(function (t) {
              t.dispose();
            }), delete this.selectorPrimitives[t.key]);
          }, n.prototype.getPrimitives = function (t, e) {
            return this.primitives[t.key] || (this.primitives[t.key] = t.createPrimitives(e)), this.primitives[t.key];
          }, n.prototype.getSelectorPrimitives = function (t) {
            return this.selectorPrimitives[t.key] || (this.selectorPrimitives[t.key] = t.createSelectorPrimitives()), this.selectorPrimitives[t.key];
          }, n.prototype.getShapeSelectorClassName = function (t) {
            var e = "shape";
            return t.enableChildren && (e += " container"), t.isLocked && (e += " locked"), e;
          }, n.prototype.getShapeClassName = function (t, n) {
            var o = this.getShapeSelectorClassName(t);
            return n ? o : o + " " + e.NOT_VALID_CSSCLASS;
          }, n.prototype.applyShapeChange = function (t, e, n) {
            var o = t.key,
              i = t.container && t.container.key,
              a = this.getItemSelectorGroupContainer(t.zIndex, i),
              c = this.getItemGroupContainer(t.zIndex, i),
              u = this.getShapeClassName(t, n);
            switch (e) {
              case r.ItemChangeType.Create:
                this.itemSelectorElements[o] = this.createItemElements(o, this.getSelectorPrimitives(t), a, this.getShapeSelectorClassName(t), s.MouseEventElementType.Shape), this.itemElements[o] = this.createItemElements(o, this.getPrimitives(t, this.instanceId), c, u, s.MouseEventElementType.Shape), t.enableChildren && (this.itemChildElements[o] = this.createItemElements(o, [], c, "container-children", s.MouseEventElementType.Undefined), this.changeItemChildrenVisibility(this.itemChildElements[o], t.expanded));
                break;
              case r.ItemChangeType.Remove:
                this.removeItemCustomContent(this.itemSelectorElements[o], this.getSelectorPrimitives(t)), this.removeItemCustomContent(this.itemElements[o], this.getPrimitives(t, this.instanceId)), this.invalidatePrimitives(t), this.removeItemElements(this.itemSelectorElements[o]), delete this.itemSelectorElements[o], this.removeItemElements(this.itemElements[o]), delete this.itemElements[o], this.itemChildElements[o] && (this.removeItemElements(this.itemChildElements[o]), delete this.itemChildElements[o], delete this.itemGroupContainers[o], delete this.itemSelectorGroupContainers[o]);
                break;
              case r.ItemChangeType.UpdateStructure:
              case r.ItemChangeType.UpdateProperties:
              case r.ItemChangeType.Update:
                e !== r.ItemChangeType.Update && (e === r.ItemChangeType.UpdateStructure && (this.removeItemCustomContent(this.itemSelectorElements[o], this.getSelectorPrimitives(t)), this.removeItemCustomContent(this.itemElements[o], this.getPrimitives(t, this.instanceId))), this.invalidatePrimitives(t)), this.changeItemElements(this.getSelectorPrimitives(t), this.itemSelectorElements[o], e === r.ItemChangeType.UpdateStructure), this.changeItemElements(this.getPrimitives(t, this.instanceId), this.itemElements[o], e === r.ItemChangeType.UpdateStructure), this.changeItemClassName(this.itemElements[o], u), this.itemChildElements[o] && this.changeItemChildrenVisibility(this.itemChildElements[o], t.expanded), a !== (this.itemSelectorElements[o] && this.itemSelectorElements[o].parentNode) && this.moveItemElements(a, this.itemSelectorElements[o]), c !== (this.itemElements[o] && this.itemElements[o].parentNode) && this.moveItemElements(c, this.itemElements[o]), this.itemChildElements[o] && c !== this.itemChildElements[o].parentNode && this.moveItemElements(c, this.itemChildElements[o]);
                break;
              case r.ItemChangeType.UpdateClassName:
                this.changeItemClassName(this.itemElements[o], u);
            }
          }, n.prototype.getConnectorSelectorClassName = function (t) {
            var n = "connector";
            return d.ModelUtils.canMoveConnector(this.selectedItems, t) ? n + " " + e.CONNECTOR_CAN_MOVE : n;
          }, n.prototype.getConnectorClassName = function (t, n) {
            var o = this.getConnectorSelectorClassName(t);
            return n ? o : o + " " + e.NOT_VALID_CSSCLASS;
          }, n.prototype.applyConnectorChange = function (t, e, n) {
            var o = t.key,
              i = t.container && t.container.key,
              a = this.getItemSelectorGroupContainer(t.zIndex, i),
              c = this.getItemGroupContainer(t.zIndex, i),
              u = this.getConnectorClassName(t, n);
            switch (e) {
              case r.ItemChangeType.Create:
                this.itemSelectorElements[o] = this.createItemElements(o, this.getSelectorPrimitives(t), a, this.getConnectorSelectorClassName(t), s.MouseEventElementType.Connector), this.itemElements[o] = this.createItemElements(o, this.getPrimitives(t, this.instanceId), c, u, s.MouseEventElementType.Connector);
                break;
              case r.ItemChangeType.Remove:
                this.removeItemCustomContent(this.itemSelectorElements[o], this.getSelectorPrimitives(t)), this.removeItemCustomContent(this.itemElements[o], this.getPrimitives(t, this.instanceId)), this.invalidatePrimitives(t), this.removeItemElements(this.itemSelectorElements[o]), delete this.itemSelectorElements[o], this.removeItemElements(this.itemElements[o]), delete this.itemElements[o];
                break;
              case r.ItemChangeType.UpdateStructure:
              case r.ItemChangeType.UpdateProperties:
              case r.ItemChangeType.Update:
                e !== r.ItemChangeType.Update && (e === r.ItemChangeType.UpdateStructure && (this.removeItemCustomContent(this.itemSelectorElements[o], this.getSelectorPrimitives(t)), this.removeItemCustomContent(this.itemElements[o], this.getPrimitives(t, this.instanceId))), this.invalidatePrimitives(t)), this.changeItemElements(this.getSelectorPrimitives(t), this.itemSelectorElements[o], e === r.ItemChangeType.UpdateStructure), this.changeItemClassName(this.itemSelectorElements[o], this.getConnectorSelectorClassName(t)), this.changeItemElements(this.getPrimitives(t, this.instanceId), this.itemElements[o], e === r.ItemChangeType.UpdateStructure), this.changeItemClassName(this.itemElements[o], u), a !== (this.itemSelectorElements[o] && this.itemSelectorElements[o].parentNode) && this.moveItemElements(a, this.itemSelectorElements[o]), c !== (this.itemElements[o] && this.itemElements[o].parentNode) && this.moveItemElements(c, this.itemElements[o]);
                break;
              case r.ItemChangeType.UpdateClassName:
                this.changeItemClassName(this.itemSelectorElements[o], this.getConnectorSelectorClassName(t)), this.changeItemClassName(this.itemElements[o], u);
            }
          }, n.prototype.createItemElements = function (t, e, n, o, i) {
            var r = this.createAndChangePrimitiveElement(new a.GroupPrimitive([], o, void 0, void 0, function (e) {
              return c.RenderUtils.setElementEventData(e, i, t);
            }), n);
            return this.createAndChangePrimitivesElements(e, r), r;
          }, n.prototype.changeItemElements = function (t, e, n) {
            n || t.length !== e.childNodes.length ? (c.RenderUtils.removeContent(e), this.createAndChangePrimitivesElements(t, e)) : this.dom.changeChildrenByPrimitives(t, e);
          }, n.prototype.changeItemClassName = function (t, e) {
            e && t && this.changePrimitiveElement(new a.GroupPrimitive([], e), t);
          }, n.prototype.removeItemElements = function (t) {
            t && t.parentNode && t.parentNode.removeChild(t);
          }, n.prototype.removeItemCustomContent = function (t, e) {
            t && e && e.length === t.childNodes.length && e.forEach(function (e, n) {
              e.destroyCustomContent(t.childNodes[n]);
            });
          }, n.prototype.moveItemElements = function (t, e, n) {
            e && t && (n ? t.insertBefore(e, n) : t.appendChild(e));
          }, n.prototype.changeItemChildrenVisibility = function (t, e) {
            t.style.display = e ? "" : "none";
          }, n.prototype.getItemGroupContainerKey = function (t, e) {
            return void 0 !== e ? t + "_" + e : t.toString();
          }, n.prototype.getItemGroupContainer = function (t, e) {
            var n = void 0 !== e ? this.getItemParent(t, e) : this.itemsContainer,
              o = e || "Main";
            if (void 0 === this.itemGroupContainers[o] || void 0 === this.itemGroupContainers[o][t]) {
              void 0 === this.itemGroupContainers[o] && (this.itemGroupContainers[o] = []);
              var i = Object.keys(this.itemGroupContainers[o]).map(function (t) {
                return +t;
              }).sort(function (t, e) {
                return t - e;
              }).filter(function (e) {
                return e > t;
              })[0];
              this.itemGroupContainers[o][t] = this.createAndChangePrimitiveElement(new a.GroupPrimitive([], null, t), n, this.itemGroupContainers[o][i]);
            }
            return this.itemGroupContainers[o][t];
          }, n.prototype.getItemSelectorGroupContainer = function (t, e) {
            var n = void 0 !== e ? this.getItemSelectorParent(t, e) : this.itemSelectorsContainer,
              o = e || "Main";
            if (void 0 === this.itemSelectorGroupContainers[o] || void 0 === this.itemSelectorGroupContainers[o][t]) {
              void 0 === this.itemSelectorGroupContainers[o] && (this.itemSelectorGroupContainers[o] = []);
              var i = Object.keys(this.itemSelectorGroupContainers[o]).map(function (t) {
                return +t;
              }).sort(function (t, e) {
                return t - e;
              }).filter(function (e) {
                return e > t;
              })[0];
              this.itemSelectorGroupContainers[o][t] = this.createAndChangePrimitiveElement(new a.GroupPrimitive([], null, t), n, this.itemSelectorGroupContainers[o][i]);
            }
            return this.itemSelectorGroupContainers[o][t];
          }, n.prototype.getItemParent = function (t, e) {
            return void 0 !== e ? this.itemChildElements[e] : this.getItemGroupContainer(t);
          }, n.prototype.getItemSelectorParent = function (t, e) {
            return void 0 !== e ? this.itemChildElements[e] : this.getItemSelectorGroupContainer(t);
          }, n.prototype.notifySelectionChanged = function (t) {
            var e = this,
              n = d.ModelUtils.createSelectedItems(t),
              o = [];
            this.populateItems(o, n, this.selectedItems), this.populateItems(o, this.selectedItems, n), this.selectedItems = n, o.forEach(function (t) {
              t instanceof p.Connector && !e.pendingRemoveChanges[t.key] && e.applyOrPostponeChanges([new r.ItemChange(t, r.ItemChangeType.UpdateClassName, !0)]);
            });
          }, n.prototype.populateItems = function (t, e, n) {
            Object.keys(e).forEach(function (o) {
              n[o] || t.push(e[o]);
            });
          }, n;
        }(l.CanvasManager);
        e.CanvasItemsManager = f;
      },
      9923: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ToggleSimpleViewCommand = void 0;
        var r = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(e, t), e.prototype.isEnabledInReadOnlyMode = function () {
            return !0;
          }, e.prototype.getValue = function () {
            return this.control.settings.simpleView;
          }, e.prototype.executeCore = function (t, e) {
            return "boolean" == typeof e ? this.control.settings.simpleView = e : void 0 === e && (this.control.settings.simpleView = !t.value), this.control.updateLayout(!0), !0;
          }, e;
        }(n(3913).SimpleCommandBase);
        e.ToggleSimpleViewCommand = r;
      },
      9933: (t, e) => {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ImportUtils = void 0;
        var n = function () {
          function t() {}
          return t.parseJSON = function (t) {
            if (!t || "" === t) return {};
            try {
              return JSON.parse(t);
            } catch (t) {
              return {};
            }
          }, t.createDocument = function (t) {
            return new DOMParser().parseFromString(t, "application/xml");
          }, t;
        }();
        e.ImportUtils = n;
      },
      9956: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ConnectorRenderPoint = void 0;
        var r = function (t) {
          function e(e, n, o, i) {
            void 0 === o && (o = -1), void 0 === i && (i = !1);
            var r = t.call(this, e, n) || this;
            return r.pointIndex = o, r.skipped = i, r;
          }
          return i(e, t), e.prototype.offset = function (e, n) {
            return t.prototype.offset.call(this, e, n), this.pointIndex = -1, this.skipped = !1, this;
          }, e.prototype.multiply = function (e, n) {
            return t.prototype.multiply.call(this, e, n), this.pointIndex = -1, this.skipped = !1, this;
          }, e.prototype.clone = function () {
            return new e(this.x, this.y, this.pointIndex, this.skipped);
          }, e.equal = function (t, e) {
            return t.equals(e) && t.pointIndex === e.pointIndex && t.skipped === e.skipped;
          }, e.prototype.toObject = function () {
            return {
              x: this.x,
              y: this.y,
              pointIndex: this.pointIndex,
              skipped: this.skipped
            };
          }, e.fromObject = function (t) {
            return new e(t.x, t.y, t.pointIndex, t.skipped);
          }, e;
        }(n(5327).Point);
        e.ConnectorRenderPoint = r;
      },
      9968: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.DatabaseShapeDescription = void 0;
        var r = n(3190),
          s = n(3255),
          a = n(6208),
          c = n(7345),
          u = function (t) {
            function e() {
              var e = t.call(this, void 0, !0) || this;
              return e.defaultSize.width = e.defaultSize.height, e;
            }
            return i(e, t), Object.defineProperty(e.prototype, "key", {
              get: function () {
                return s.ShapeTypes.Database;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "keepRatioOnAutoSize", {
              get: function () {
                return !1;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.createShapePrimitives = function (t) {
              var n = t.rectangle,
                o = n.x,
                i = n.y,
                r = n.right,
                s = n.bottom,
                u = n.height,
                p = n.center.x,
                h = u * e.arcWidthRatio;
              return [new a.PathPrimitive([new a.PathPrimitiveMoveToCommand(r, i + h / 2), new a.PathPrimitiveLineToCommand(r, s - h / 2), new a.PathPrimitiveArcToCommand((r - o) / 2, h / 2, 0, !1, !0, o, s - h / 2), new a.PathPrimitiveLineToCommand(o, i + h / 2)], t.style), new c.EllipsePrimitive(p, i + h / 2, (r - o) / 2, h / 2, t.style)];
            }, e.prototype.getTextRectangle = function (t) {
              var n = t.rectangle,
                o = n.height * e.arcWidthRatio;
              return n.clone().resize(0, -o).clone().moveRectangle(0, o);
            }, e.arcWidthRatio = .2, e;
          }(r.RectangleShapeDescription);
        e.DatabaseShapeDescription = u;
      },
      9993: function (t, e, n) {
        var o,
          i = this && this.__extends || (o = function (t, e) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            }, o(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MouseHandlerDragDiagramItemStateBase = e.DraggingConnector = void 0;
        var r = n(1922),
          s = n(5225),
          a = n(5428),
          c = n(2815),
          u = n(1416),
          p = function (t) {
            this.connector = t, this.startPoints = t.points.map(function (t) {
              return t.clone();
            }), this.startRenderContext = t.tryCreateRenderPointsContext();
          };
        e.DraggingConnector = p;
        var h = function (t) {
          function e(e, n, o, i, r) {
            var s = t.call(this, e, n) || this;
            return s.model = o, s.selection = i, s.visualizerManager = r, s.startScrollLeft = 0, s.startScrollTop = 0, s;
          }
          return i(e, t), e.prototype.finish = function () {
            var e;
            null === (e = this.dragHelper) || void 0 === e || e.finish(), this.visualizerManager.resetExtensionLines(), this.visualizerManager.resetContainerTarget(), this.visualizerManager.resetConnectionTarget(), this.visualizerManager.resetConnectionPoints(), t.prototype.finish.call(this);
          }, e.prototype.onMouseDown = function (e) {
            this.handler.addDiagramItemToSelection(e), this.shouldClone = this.handler.canCopySelectedItems(e), this.startPoint = e.modelPoint, this.initDrag(), this.lockInitDrag = !1, t.prototype.onMouseDown.call(this, e);
          }, e.prototype.onMouseMove = function (t) {
            if (this.mouseMoveEvent = t, t.button !== a.MouseButton.Left) return this.cancelChanges(), void this.handler.switchToDefaultState();
            this.canApplyChangesOnMouseMove(this.startPoint, t.modelPoint) && (this.handler.canCopySelectedItems(t) && (this.lockInitDrag || (this.cancelChanges(), this.shouldClone = !0, this.copySelection(), this.initDrag(), this.lockInitDrag = !0)), this.onApplyChanges(t), this.onAfterApplyChanges(), this.updateContainers(t));
          }, e.prototype.updateContainers = function (t) {
            this.visualizerManager.setExtensionLines(this.selection.getSelectedShapes(!1, !0));
            var e = r.ModelUtils.findContainerByEventKey(this.model, this.selection, t.source.key);
            e && this.allowInsertToContainer(t, e) ? this.visualizerManager.setContainerTarget(e, t.source.type) : this.visualizerManager.resetContainerTarget();
          }, e.prototype.onMouseUp = function (e) {
            t.prototype.onMouseUp.call(this, e), this.handler.canRemoveDiagramItemToSelection(e) && this.handler.canMultipleSelection(e) && this.handler.removeDiagramItemFromSelection(e.button, e.source.key);
          }, e.prototype.onApplyChanges = function (t) {
            var e = this;
            this.calculateFixedPosition(t), this.dragHelper.move(this.shouldClone, function (n) {
              return e.getSnappedPoint(t, n);
            }, function () {
              e.visualizerManager.resetConnectionTarget(), e.visualizerManager.resetConnectionPoints();
            }, function (t, n) {
              e.visualizerManager.setConnectionTarget(t, a.MouseEventElementType.Shape), e.visualizerManager.setConnectionPoints(t, a.MouseEventElementType.Shape, n, !0);
            });
            var n = r.ModelUtils.findContainerByEventKey(this.model, this.selection, t.source.key);
            n && this.allowInsertToContainer(t, n) ? r.ModelUtils.insertSelectionToContainer(this.history, this.model, this.selection, n) : r.ModelUtils.removeSelectionFromContainer(this.history, this.model, this.selection), this.handler.tryUpdateModelSize(function (t, n) {
              return e.dragHelper.onTryUpdateModelSize(t, n);
            });
          }, e.prototype.getDraggingElementKeys = function () {
            return this.dragHelper.draggingShapes.map(function (t) {
              return t.shape.key;
            }).concat(this.dragHelper.draggingConnectors.map(function (t) {
              return t.connector.key;
            }));
          }, e.prototype.getSnappedPoint = function (t, e) {
            return this.handler.getSnappedPointOnDragDiagramItem(t, e, this.fixedX, this.fixedY, this.startPoint);
          }, e.prototype.initDrag = function () {
            this.dragHelper = new u.SelectionDragHelper(this.history, this.model, this.handler.permissionsProvider, this.startPoint, this.selection.getSelectedItems(!0)), this.initDraggingShapes(), this.areValidDraggingShapes ? (this.initDraggingConnectors(), this.areValidDraggingConnectors || this.handler.switchToDefaultState()) : this.handler.switchToDefaultState();
          }, e.prototype.initDraggingShapes = function () {
            this.dragHelper.initDraggingShapes(this.selection.getSelectedShapes(!1, !0), this.shouldClone);
          }, e.prototype.initDraggingConnectors = function () {
            this.dragHelper.initDraggingConnectors(this.selection.getSelectedConnectors(!1, !0), this.shouldClone);
          }, e.prototype.copySelection = function () {
            var t = this;
            r.ModelUtils.cloneSelectionToOffset(this.history, this.model, function (e) {
              var n = t.model.findItem(e);
              n && t.handler.addInteractingItem(n, s.DiagramModelOperation.AddShape);
            }, this.selection, 0, 0);
          }, e.prototype.calculateFixedPosition = function (t) {
            (this.fixedX = !1, this.fixedY = !1, this.handler.canCalculateFixedPosition(t)) && (Math.abs(this.startPoint.x - t.modelPoint.x) < Math.abs(this.startPoint.y - t.modelPoint.y) ? this.fixedX = !0 : this.fixedY = !0);
          }, e.prototype.allowInsertToContainer = function (t, e) {
            return !this.handler.canMultipleSelection(t) && e && e.expanded && r.ModelUtils.canInsertSelectionToContainer(this.model, this.selection, e);
          }, e;
        }(c.MouseHandlerDraggingState);
        e.MouseHandlerDragDiagramItemStateBase = h;
      }
    },
    e = {};
  function n(o) {
    var i = e[o];
    if (void 0 !== i) return i.exports;
    var r = e[o] = {
      exports: {}
    };
    return t[o].call(r.exports, r, r.exports, n), r.exports;
  }
  return n.d = (t, e) => {
    for (var o in e) n.o(e, o) && !n.o(t, o) && Object.defineProperty(t, o, {
      enumerable: !0,
      get: e[o]
    });
  }, n.o = (t, e) => Object.prototype.hasOwnProperty.call(t, e), n.r = t => {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, n(8156);
})());